/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		13: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"route-home","1":"route-ticket","2":"route-orders","3":"route-terms","4":"route-receipt","5":"route-profile","6":"route-privacy","7":"route-payment","8":"route-event","9":"route-deliveryterms","10":"route-contact","11":"route-confirmation","12":"route-checkout"}[chunkId]||chunkId) + ".chunk." + {"0":"9cbb1","1":"8ff26","2":"8442d","3":"5436e","4":"53a9d","5":"e183f","6":"6f803","7":"0a60d","8":"24a48","9":"13ff2","10":"30930","11":"7e2d0","12":"4214e"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "4kBY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_helpers__ = __webpack_require__("UiAd");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'modal-backdrop fade show' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'svg',
	{ 'class': 'icon bg-dark', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M16.2426 6.34311L6.34309 16.2426C5.95257 16.6331 5.95257 17.2663 6.34309 17.6568C6.73362 18.0473 7.36678 18.0473 7.75731 17.6568L17.6568 7.75732C18.0473 7.36679 18.0473 6.73363 17.6568 6.34311C17.2663 5.95258 16.6331 5.95258 16.2426 6.34311Z', fill: '#212529' }),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M17.6568 16.2426L7.75734 6.34309C7.36681 5.95257 6.73365 5.95257 6.34313 6.34309C5.9526 6.73362 5.9526 7.36678 6.34313 7.75731L16.2426 17.6568C16.6331 18.0473 17.2663 18.0473 17.6568 17.6568C18.0474 17.2663 18.0474 16.6331 17.6568 16.2426Z', fill: '#212529' })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h3',
	null,
	'Ostoskori'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'svg',
	{ 'class': 'icon', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M14.4444 8.41358C14.7776 8.2281 15.1875 8.46907 15.1875 8.85048V15.1495C15.1875 15.5309 14.7776 15.7719 14.4444 15.5864L8.78505 12.4369C8.44258 12.2463 8.44258 11.7537 8.78505 11.5631L14.4444 8.41358Z', fill: '#212529' })
);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'svg',
	{ 'class': 'icon', width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'title',
		null,
		'Icon For Heart'
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'g',
		{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('rect', { opacity: '0', x: '0', y: '0', width: '24', height: '24' }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M18.1446364,11.84388 L17.4471627,16.0287218 C17.4463569,16.0335568 17.4455155,16.0383857 17.4446387,16.0432083 C17.345843,16.5865846 16.8252597,16.9469884 16.2818833,16.8481927 L4.91303792,14.7811299 C4.53842737,14.7130189 4.23500006,14.4380834 4.13039941,14.0719812 L2.30560137,7.68518803 C2.28007524,7.59584656 2.26712532,7.50338343 2.26712532,7.4104669 C2.26712532,6.85818215 2.71484057,6.4104669 3.26712532,6.4104669 L16.9929851,6.4104669 L17.606173,3.78251876 C17.7307772,3.24850086 18.2068633,2.87071314 18.7552257,2.87071314 L20.8200821,2.87071314 C21.4717328,2.87071314 22,3.39898039 22,4.05063106 C22,4.70228173 21.4717328,5.23054898 20.8200821,5.23054898 L19.6915238,5.23054898 L18.1446364,11.84388 Z', fill: '#000000', opacity: '0.3' }),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M6.5,21 C5.67157288,21 5,20.3284271 5,19.5 C5,18.6715729 5.67157288,18 6.5,18 C7.32842712,18 8,18.6715729 8,19.5 C8,20.3284271 7.32842712,21 6.5,21 Z M15.5,21 C14.6715729,21 14,20.3284271 14,19.5 C14,18.6715729 14.6715729,18 15.5,18 C16.3284271,18 17,18.6715729 17,19.5 C17,20.3284271 16.3284271,21 15.5,21 Z', fill: '#000000' })
	)
);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'span',
	null,
	'Vahvista'
);

var AddToCart = function (_Component) {
	_inherits(AddToCart, _Component);

	function AddToCart() {
		var _temp, _this, _ret;

		_classCallCheck(this, AddToCart);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			tickets: []
		}, _this.generateOptions = function () {
			var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
			var maxQuantity = arguments[1];

			var fullLength = maxQuantity ? Math.min(Math.max(length, 10), maxQuantity) : Math.max(length, 10);
			return Array.from({ length: fullLength + 1 }).map(function (a, i) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'option',
					{ value: i },
					i
				);
			});
		}, _this.addToCart = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			var items = _this.props.tickets.reduce(function (final, item) {
				item.quantity = parseInt(item.quantity) || 0;

				if (item.quantity) {
					return [].concat(final, [item]);
				} else {
					return final;
				}
			}, []);

			_this.props.onChange(items);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	AddToCart.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		console.log(this.props.tickets);
		this.setState({
			tickets: (this.props.tickets || []).map(function (ticket) {
				ticket.maxQuantity = ticket.maxQuantity || ticket.quantity;
				if (!_this2.props.cart) ticket.quantity = 0;
				return ticket;
			})
		});
		document.body.classList.add('modal-open');
	};

	AddToCart.prototype.componentWillUnmount = function componentWillUnmount() {
		document.body.classList.remove('modal-open');
	};

	AddToCart.prototype.render = function render(props, state) {
		var _this3 = this;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			_ref,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'modal fade show', id: 'contact-box-modal', tabindex: '-1', role: 'dialog', 'aria-modal': 'true', style: 'display: block;' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'modal-dialog modal-dialog-centered', role: 'document' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'modal-content bg-light' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': 'modal-body' },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'button',
								{ type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: props.onClose },
								_ref2
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'm-3' },
								_ref3,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'form',
									{ action: '/', 'data-form-email': '', novalidate: '' },
									state.tickets.map(function (ticket, index, tickets) {
										return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ href: '#', 'class': 'card card-body hover-shadow-sm p-2' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': 'd-flex justify-content-between align-items-center' },
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													null,
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'div',
														{ 'class': 'mb-2' },
														Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
															'span',
															{ 'class': 'badge bg-primary-alt text-primary' },
															ticket.tag
														)
													),
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'h4',
														{ 'class': 'mb-2' },
														ticket.title
													),
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'span',
														null,
														Object(__WEBPACK_IMPORTED_MODULE_1_helpers__["e" /* parseCurrency */])(ticket.price)
													)
												),
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													{ 'class': 'form-group mb-lg-0' },
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'select',
														{ 'class': 'custom-select custom-select-lg bg-white mr-4', value: ticket.quantity || 0, onChange: function onChange(e) {
																ticket.quantity = parseInt(e.target.value);_this3.setState({ tickets: tickets });
															} },
														_this3.generateOptions(ticket.quantity, ticket.maxQuantity)
													),
													_ref4
												)
											)
										);
									}),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'button',
										{ type: 'submit', onClick: this.addToCart, 'class': (state.tickets || []).reduce(function (sum, item) {
												return sum + (item.quantity || 0);
											}, 0) > 0 ? "btn btn-block btn-success" : "btn btn-block", 'data-loading-text': 'Sending' },
										_ref5,
										_ref6
									)
								)
							)
						)
					)
				)
			)
		);
	};

	return AddToCart;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AddToCart);

/***/ }),

/***/ "58xA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__("vCxL");

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function assert(assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function assertionError(message) {
    return new Error('Firebase Database (' + CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function stringToByteArray(str) {
    // TODO(user): Use native implementations if/when available
    var out = [],
        p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) == 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [],
        pos = 0,
        c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        } else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function encodeByteArray(input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function encodeString(input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function decodeString(input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function decodeStringToByteArray(input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function base64Encode(str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function base64Decode(str) {
    try {
        return base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            } else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () {});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                } else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    } else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
function isMobileCordova() {
    return typeof window !== 'undefined' && !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 * Node detection logic from: https://github.com/iliakan/detect-node/
 */
function isNode() {
    try {
        return Object.prototype.toString.call(global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
function isReactNative() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return {boolean} True if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var FirebaseError = /** @class */function (_super) {
    tslib_1.__extends(FirebaseError, _super);
    function FirebaseError(code, message) {
        var _this = _super.call(this, message) || this;
        _this.code = code;
        _this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
        }
        return _this;
    }
    return FirebaseError;
}(Error);
var ErrorFactory = /** @class */function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === void 0) {
            data = {};
        }
        var fullCode = this.service + "/" + code;
        var template = this.errors[code];
        var message = template ? replaceTemplate(template, data) : 'Error';
        // Service Name: Error message (service/code).
        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
        var error = new FirebaseError(fullCode, fullMessage);
        // Keys with an underscore at the end of their name are not included in
        // error.data for some reason.
        // TODO: Replace with Object.entries when lib is updated to es2017.
        for (var _i = 0, _a = Object.keys(data); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key.slice(-1) !== '_') {
                if (key in error) {
                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
                }
                error[key] = data[key];
            }
        }
        return error;
    };
    return ErrorFactory;
}();
function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? value.toString() : "<" + key + "?>";
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function decode(token) {
    var header = {},
        claims = {},
        data = {},
        signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function isValidTimestamp(token) {
    var claims = decode(token).claims,
        now = Math.floor(new Date().getTime() / 1000),
        validSince,
        validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        } else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        } else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return now && validSince && validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function issuedAtTime(token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function isValidFormat(token) {
    var decoded = decode(token),
        claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function isAdmin(token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function forEach(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function extend(objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function clone(obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function isNonNullObject(obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function isEmpty(obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function getCount(obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function map(obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function findKey(obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function findValue(obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function getAnyKey(obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function getValues(obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function every(obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function querystring(querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */
var Sha1 = /** @class */function () {
    function Sha1() {
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] = buf.charCodeAt(opt_offset) << 24 | buf.charCodeAt(opt_offset + 1) << 16 | buf.charCodeAt(opt_offset + 2) << 8 | buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        } else {
            for (var i = 0; i < 16; i++) {
                W[i] = buf[opt_offset] << 24 | buf[opt_offset + 1] << 16 | buf[opt_offset + 2] << 8 | buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else {
                if (i < 60) {
                    f = b & c | d & (b | c);
                    k = 0x8f1bbcdc;
                } else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            } else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        } else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = this.chain_[i] >> j & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}();

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function () {
            executor(_this);
        }).catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        } else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    } else {
                        observer.complete();
                    }
                } catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                } catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true).then(function () {
            fn.apply(void 0, args);
        }).catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {}
// do nothing


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    } else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error(errorPrefix(fnName, argumentNumber, optional) + 'must be a valid context object.');
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function stringToByteArray$1(str) {
    var out = [],
        p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function stringLength(str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        } else if (c < 2048) {
            p += 2;
        } else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.CONSTANTS = CONSTANTS;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.Sha1 = Sha1;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.clone = clone;
exports.contains = contains;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.errorPrefix = errorPrefix;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getUA = getUA;
exports.getValues = getValues;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isEmpty = isEmpty;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isNonNullObject = isNonNullObject;
exports.isReactNative = isReactNative;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.patchProperty = patchProperty;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.cjs.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("h6ac")))

/***/ }),

/***/ "5cZM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Avatar = function (_Component) {
  _inherits(Avatar, _Component);

  function Avatar() {
    var _temp, _this, _ret;

    _classCallCheck(this, Avatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getAvatar = function (name, size) {
      name = name || '';
      size = size || 60;

      var colours = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#ecf0f1", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"],
          nameSplit = String(name).toUpperCase().split(' '),
          initials,
          charIndex,
          colourIndex,
          canvas,
          context,
          dataURI;

      if (nameSplit.length == 1) {
        initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
      } else {
        initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
      }

      if (window.devicePixelRatio) {
        size = size * window.devicePixelRatio;
      }

      charIndex = (initials == '?' ? 72 : initials.charCodeAt(0)) - 64;
      colourIndex = charIndex % 20;
      canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      context = canvas.getContext("2d");

      context.fillStyle = colours[colourIndex - 1];
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.font = Math.round(canvas.width / 2.5) + "px Arial";
      context.textAlign = "center";
      context.fillStyle = "#FFF";
      context.fillText(initials, size / 1.9, size / 1.5);

      dataURI = canvas.toDataURL();
      canvas = null;

      return dataURI;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Avatar.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.src && this.props.name) this.setState({ avatar: this.getAvatar(this.props.name, this.base.getClientWidth || 60) });
  };

  Avatar.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.src && nextProps.name !== this.props.name) {
      this.setState({ avatar: this.getAvatar(this.props.name, this.base.getClientWidth || 60) });
    }
  };

  Avatar.prototype.render = function render(props, state) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { 'class': props.class, src: props.src ? props.src : state.avatar ? state.avatar : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==' });
  };

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Avatar);

/***/ }),

/***/ "7N8r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (req) {
	function Async() {
		var _this = this;

		_preact.Component.call(this);

		var b = void 0,
		    old = void 0;
		this.componentWillMount = function () {
			b = _this.base = _this.nextBase || _this.__b;
			req(function (m) {
				_this.setState({ child: m.default || m });
			});
		};

		this.shouldComponentUpdate = function (_, nxt) {
			nxt = nxt.child === void 0;
			if (nxt && old === void 0 && !!b) {
				old = (0, _preact.h)(b.nodeName, { dangerouslySetInnerHTML: { __html: b.innerHTML } });
			} else {
				old = '';
			}
			return !nxt;
		};

		this.render = function (p, s) {
			return s.child ? (0, _preact.h)(s.child, p) : old;
		};
	}
	(Async.prototype = new _preact.Component()).constructor = Async;
	return Async;
};

var _preact = __webpack_require__("KM04");

/***/ }),

/***/ "9RKk":
/***/ (function(module, exports, __webpack_require__) {

!function (e, t) {
   true ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.AOS = t() : e.AOS = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;var i = n[o] = { exports: {}, id: o, loaded: !1 };return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }var n = {};return t.m = e, t.c = n, t.p = "dist/", t(0);
  }([function (e, t, n) {
    "use strict";
    function o(e) {
      return e && e.__esModule ? e : { default: e };
    }var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }return e;
    },
        r = n(1),
        a = (o(r), n(6)),
        u = o(a),
        c = n(7),
        s = o(c),
        f = n(8),
        d = o(f),
        l = n(9),
        p = o(l),
        m = n(10),
        b = o(m),
        v = n(11),
        y = o(v),
        g = n(14),
        h = o(g),
        w = [],
        k = !1,
        x = { offset: 120, delay: 0, easing: "ease", duration: 400, disable: !1, once: !1, startEvent: "DOMContentLoaded", throttleDelay: 99, debounceDelay: 50, disableMutationObserver: !1 },
        j = function j() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];if (e && (k = !0), k) return w = (0, y.default)(w, x), (0, b.default)(w, x.once), w;
    },
        O = function O() {
      w = (0, h.default)(), j();
    },
        M = function M() {
      w.forEach(function (e, t) {
        e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
      });
    },
        S = function S(e) {
      return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
    },
        _ = function _(e) {
      x = i(x, e), w = (0, h.default)();var t = document.all && !window.atob;return S(x.disable) || t ? M() : (x.disableMutationObserver || d.default.isSupported() || (console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '), x.disableMutationObserver = !0), document.querySelector("body").setAttribute("data-aos-easing", x.easing), document.querySelector("body").setAttribute("data-aos-duration", x.duration), document.querySelector("body").setAttribute("data-aos-delay", x.delay), "DOMContentLoaded" === x.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? j(!0) : "load" === x.startEvent ? window.addEventListener(x.startEvent, function () {
        j(!0);
      }) : document.addEventListener(x.startEvent, function () {
        j(!0);
      }), window.addEventListener("resize", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("orientationchange", (0, s.default)(j, x.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function () {
        (0, b.default)(w, x.once);
      }, x.throttleDelay)), x.disableMutationObserver || d.default.ready("[data-aos]", O), w);
    };e.exports = { init: _, refresh: j, refreshHard: O };
  }, function (e, t) {},,,,, function (e, t) {
    (function (t) {
      "use strict";
      function n(e, t, n) {
        function o(t) {
          var n = b,
              o = v;return b = v = void 0, k = t, g = e.apply(o, n);
        }function r(e) {
          return k = e, h = setTimeout(f, t), M ? o(e) : g;
        }function a(e) {
          var n = e - w,
              o = e - k,
              i = t - n;return S ? j(i, y - o) : i;
        }function c(e) {
          var n = e - w,
              o = e - k;return void 0 === w || n >= t || n < 0 || S && o >= y;
        }function f() {
          var e = O();return c(e) ? d(e) : void (h = setTimeout(f, a(e)));
        }function d(e) {
          return h = void 0, _ && b ? o(e) : (b = v = void 0, g);
        }function l() {
          void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
        }function p() {
          return void 0 === h ? g : d(O());
        }function m() {
          var e = O(),
              n = c(e);if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);if (S) return h = setTimeout(f, t), o(w);
          }return void 0 === h && (h = setTimeout(f, t)), g;
        }var b,
            v,
            y,
            g,
            h,
            w,
            k = 0,
            M = !1,
            S = !1,
            _ = !0;if ("function" != typeof e) throw new TypeError(s);return t = u(t) || 0, i(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
      }function o(e, t, o) {
        var r = !0,
            a = !0;if ("function" != typeof e) throw new TypeError(s);return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, { leading: r, maxWait: t, trailing: a });
      }function i(e) {
        var t = "undefined" == typeof e ? "undefined" : c(e);return !!e && ("object" == t || "function" == t);
      }function r(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
      }function a(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
      }function u(e) {
        if ("number" == typeof e) return e;if (a(e)) return f;if (i(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;e = i(t) ? t + "" : t;
        }if ("string" != typeof e) return 0 === e ? e : +e;e = e.replace(l, "");var n = m.test(e);return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? f : +e;
      }var c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          s = "Expected a function",
          f = NaN,
          d = "[object Symbol]",
          l = /^\s+|\s+$/g,
          p = /^[-+]0x[0-9a-f]+$/i,
          m = /^0b[01]+$/i,
          b = /^0o[0-7]+$/i,
          v = parseInt,
          y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t,
          g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self,
          h = y || g || Function("return this")(),
          w = Object.prototype,
          k = w.toString,
          x = Math.max,
          j = Math.min,
          O = function O() {
        return h.Date.now();
      };e.exports = o;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    (function (t) {
      "use strict";
      function n(e, t, n) {
        function i(t) {
          var n = b,
              o = v;return b = v = void 0, O = t, g = e.apply(o, n);
        }function r(e) {
          return O = e, h = setTimeout(f, t), M ? i(e) : g;
        }function u(e) {
          var n = e - w,
              o = e - O,
              i = t - n;return S ? x(i, y - o) : i;
        }function s(e) {
          var n = e - w,
              o = e - O;return void 0 === w || n >= t || n < 0 || S && o >= y;
        }function f() {
          var e = j();return s(e) ? d(e) : void (h = setTimeout(f, u(e)));
        }function d(e) {
          return h = void 0, _ && b ? i(e) : (b = v = void 0, g);
        }function l() {
          void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
        }function p() {
          return void 0 === h ? g : d(j());
        }function m() {
          var e = j(),
              n = s(e);if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);if (S) return h = setTimeout(f, t), i(w);
          }return void 0 === h && (h = setTimeout(f, t)), g;
        }var b,
            v,
            y,
            g,
            h,
            w,
            O = 0,
            M = !1,
            S = !1,
            _ = !0;if ("function" != typeof e) throw new TypeError(c);return t = a(t) || 0, o(n) && (M = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, _ = "trailing" in n ? !!n.trailing : _), m.cancel = l, m.flush = p, m;
      }function o(e) {
        var t = "undefined" == typeof e ? "undefined" : u(e);return !!e && ("object" == t || "function" == t);
      }function i(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
      }function r(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == f;
      }function a(e) {
        if ("number" == typeof e) return e;if (r(e)) return s;if (o(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;e = o(t) ? t + "" : t;
        }if ("string" != typeof e) return 0 === e ? e : +e;e = e.replace(d, "");var n = p.test(e);return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? s : +e;
      }var u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
          c = "Expected a function",
          s = NaN,
          f = "[object Symbol]",
          d = /^\s+|\s+$/g,
          l = /^[-+]0x[0-9a-f]+$/i,
          p = /^0b[01]+$/i,
          m = /^0o[0-7]+$/i,
          b = parseInt,
          v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t,
          y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self,
          g = v || y || Function("return this")(),
          h = Object.prototype,
          w = h.toString,
          k = Math.max,
          x = Math.min,
          j = function j() {
        return g.Date.now();
      };e.exports = n;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    "use strict";
    function n(e) {
      var t = void 0,
          o = void 0,
          i = void 0;for (t = 0; t < e.length; t += 1) {
        if (o = e[t], o.dataset && o.dataset.aos) return !0;if (i = o.children && n(o.children)) return !0;
      }return !1;
    }function o() {
      return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    }function i() {
      return !!o();
    }function r(e, t) {
      var n = window.document,
          i = o(),
          r = new i(a);u = t, r.observe(n.documentElement, { childList: !0, subtree: !0, removedNodes: !0 });
    }function a(e) {
      e && e.forEach(function (e) {
        var t = Array.prototype.slice.call(e.addedNodes),
            o = Array.prototype.slice.call(e.removedNodes),
            i = t.concat(o);if (n(i)) return u();
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var u = function u() {};t.default = { isSupported: i, ready: r };
  }, function (e, t) {
    "use strict";
    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }function o() {
      return navigator.userAgent || navigator.vendor || window.opera || "";
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
        c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        s = function () {
      function e() {
        n(this, e);
      }return i(e, [{ key: "phone", value: function value() {
          var e = o();return !(!r.test(e) && !a.test(e.substr(0, 4)));
        } }, { key: "mobile", value: function value() {
          var e = o();return !(!u.test(e) && !c.test(e.substr(0, 4)));
        } }, { key: "tablet", value: function value() {
          return this.mobile() && !this.phone();
        } }]), e;
    }();t.default = new s();
  }, function (e, t) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = function n(e, t, _n) {
      var o = e.node.getAttribute("data-aos-once");t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !_n && "true" !== o) && e.node.classList.remove("aos-animate");
    },
        o = function o(e, t) {
      var o = window.pageYOffset,
          i = window.innerHeight;e.forEach(function (e, r) {
        n(e, i + o, t);
      });
    };t.default = o;
  }, function (e, t, n) {
    "use strict";
    function o(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(12),
        r = o(i),
        a = function a(e, t) {
      return e.forEach(function (e, n) {
        e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
      }), e;
    };t.default = a;
  }, function (e, t, n) {
    "use strict";
    function o(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = n(13),
        r = o(i),
        a = function a(e, t) {
      var n = 0,
          o = 0,
          i = window.innerHeight,
          a = { offset: e.getAttribute("data-aos-offset"), anchor: e.getAttribute("data-aos-anchor"), anchorPlacement: e.getAttribute("data-aos-anchor-placement") };switch (a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement) {case "top-bottom":
          break;case "center-bottom":
          n += e.offsetHeight / 2;break;case "bottom-bottom":
          n += e.offsetHeight;break;case "top-center":
          n += i / 2;break;case "bottom-center":
          n += i / 2 + e.offsetHeight;break;case "center-center":
          n += i / 2 + e.offsetHeight / 2;break;case "top-top":
          n += i;break;case "bottom-top":
          n += e.offsetHeight + i;break;case "center-top":
          n += e.offsetHeight / 2 + i;}return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
    };t.default = a;
  }, function (e, t) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = function n(e) {
      for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) {
        t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
      }return { top: n, left: t };
    };t.default = n;
  }, function (e, t) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = function n(e) {
      return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function (e) {
        return { node: e };
      });
    };t.default = n;
  }]);
});

/***/ }),

/***/ "CSCC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function dlv(obj, key, def, p) {
	p = 0;
	key = key.split ? key.split('.') : key;
	while (obj && p < key.length) {
		obj = obj[key[p++]];
	}
	return obj === undefined ? def : obj;
}

/** Create an Event handler function that sets a given state property.
 *	@param {Component} component	The component whose state should be updated
 *	@param {string} key				A dot-notated key path to update in the component's state
 *	@param {string} eventPath		A dot-notated key path to the value that should be retrieved from the Event or component
 *	@returns {function} linkedStateHandler
 */
function linkState(component, key, eventPath) {
	var path = key.split('.'),
	    cache = component.__lsc || (component.__lsc = {});

	return cache[key + eventPath] || (cache[key + eventPath] = function (e) {
		var t = e && e.target || this,
		    state = {},
		    obj = state,
		    v = typeof eventPath === 'string' ? dlv(e, eventPath) : t.nodeName ? t.type.match(/^che|rad/) ? t.checked : t.value : e,
		    i = 0;
		for (; i < path.length - 1; i++) {
			obj = obj[path[i]] || (obj[path[i]] = !i && component.state[path[i]] || {});
		}
		obj[path[i]] = v;
		component.setState(state);
	});
}

/* harmony default export */ __webpack_exports__["a"] = (linkState);
//# sourceMappingURL=linkstate.es.js.map

/***/ }),

/***/ "EkFk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__("dP58");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_app__);
(function () {
  var k,
      aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
  },
      ba = "undefined" != typeof window && window === this ? this : "undefined" != typeof global && null != global ? global : this;function ca(a, b) {
    if (b) {
      var c = ba;a = a.split(".");for (var d = 0; d < a.length - 1; d++) {
        var e = a[d];e in c || (c[e] = {});c = c[e];
      }a = a[a.length - 1];d = c[a];b = b(d);b != d && null != b && aa(c, a, { configurable: !0, writable: !0, value: b });
    }
  }
  function da(a) {
    var b = 0;return function () {
      return b < a.length ? { done: !1, value: a[b++] } : { done: !0 };
    };
  }function ea(a) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];return b ? b.call(a) : { next: da(a) };
  }
  ca("Promise", function (a) {
    function b(g) {
      this.b = 0;this.c = void 0;this.a = [];var h = this.f();try {
        g(h.resolve, h.reject);
      } catch (m) {
        h.reject(m);
      }
    }function c() {
      this.a = null;
    }function d(g) {
      return g instanceof b ? g : new b(function (h) {
        h(g);
      });
    }if (a) return a;c.prototype.b = function (g) {
      if (null == this.a) {
        this.a = [];var h = this;this.c(function () {
          h.g();
        });
      }this.a.push(g);
    };var e = ba.setTimeout;c.prototype.c = function (g) {
      e(g, 0);
    };c.prototype.g = function () {
      for (; this.a && this.a.length;) {
        var g = this.a;this.a = [];for (var h = 0; h < g.length; ++h) {
          var m = g[h];g[h] = null;try {
            m();
          } catch (p) {
            this.f(p);
          }
        }
      }this.a = null;
    };c.prototype.f = function (g) {
      this.c(function () {
        throw g;
      });
    };b.prototype.f = function () {
      function g(p) {
        return function (v) {
          m || (m = !0, p.call(h, v));
        };
      }var h = this,
          m = !1;return { resolve: g(this.o), reject: g(this.g) };
    };b.prototype.o = function (g) {
      if (g === this) this.g(new TypeError("A Promise cannot resolve to itself"));else if (g instanceof b) this.u(g);else {
        a: switch (typeof g) {case "object":
            var h = null != g;break a;case "function":
            h = !0;break a;default:
            h = !1;}h ? this.l(g) : this.h(g);
      }
    };
    b.prototype.l = function (g) {
      var h = void 0;try {
        h = g.then;
      } catch (m) {
        this.g(m);return;
      }"function" == typeof h ? this.v(h, g) : this.h(g);
    };b.prototype.g = function (g) {
      this.i(2, g);
    };b.prototype.h = function (g) {
      this.i(1, g);
    };b.prototype.i = function (g, h) {
      if (0 != this.b) throw Error("Cannot settle(" + g + ", " + h + "): Promise already settled in state" + this.b);this.b = g;this.c = h;this.m();
    };b.prototype.m = function () {
      if (null != this.a) {
        for (var g = 0; g < this.a.length; ++g) {
          f.b(this.a[g]);
        }this.a = null;
      }
    };var f = new c();b.prototype.u = function (g) {
      var h = this.f();
      g.Ja(h.resolve, h.reject);
    };b.prototype.v = function (g, h) {
      var m = this.f();try {
        g.call(h, m.resolve, m.reject);
      } catch (p) {
        m.reject(p);
      }
    };b.prototype.then = function (g, h) {
      function m(H, U) {
        return "function" == typeof H ? function (ta) {
          try {
            p(H(ta));
          } catch (ld) {
            v(ld);
          }
        } : U;
      }var p,
          v,
          z = new b(function (H, U) {
        p = H;v = U;
      });this.Ja(m(g, p), m(h, v));return z;
    };b.prototype.catch = function (g) {
      return this.then(void 0, g);
    };b.prototype.Ja = function (g, h) {
      function m() {
        switch (p.b) {case 1:
            g(p.c);break;case 2:
            h(p.c);break;default:
            throw Error("Unexpected state: " + p.b);}
      }var p = this;null == this.a ? f.b(m) : this.a.push(m);
    };b.resolve = d;b.reject = function (g) {
      return new b(function (h, m) {
        m(g);
      });
    };b.race = function (g) {
      return new b(function (h, m) {
        for (var p = ea(g), v = p.next(); !v.done; v = p.next()) {
          d(v.value).Ja(h, m);
        }
      });
    };b.all = function (g) {
      var h = ea(g),
          m = h.next();return m.done ? d([]) : new b(function (p, v) {
        function z(ta) {
          return function (ld) {
            H[ta] = ld;U--;0 == U && p(H);
          };
        }var H = [],
            U = 0;do {
          H.push(void 0), U++, d(m.value).Ja(z(H.length - 1), v), m = h.next();
        } while (!m.done);
      });
    };return b;
  });var fa = fa || {},
      l = this;
  function n(a) {
    return "string" == typeof a;
  }function ha(a) {
    return "boolean" == typeof a;
  }var ia = /^[\w+/_-]+[=]{0,2}$/,
      ja = null;function ka() {}
  function la(a) {
    var b = typeof a;if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
  }function ma(a) {
    return null === a;
  }function na(a) {
    return "array" == la(a);
  }function oa(a) {
    var b = la(a);return "array" == b || "object" == b && "number" == typeof a.length;
  }function q(a) {
    return "function" == la(a);
  }function r(a) {
    var b = typeof a;return "object" == b && null != a || "function" == b;
  }var pa = "closure_uid_" + (1E9 * Math.random() >>> 0),
      qa = 0;function ra(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }
  function sa(a, b, c) {
    if (!a) throw Error();if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);return function () {
        var e = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e, d);return a.apply(b, e);
      };
    }return function () {
      return a.apply(b, arguments);
    };
  }function t(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? t = ra : t = sa;return t.apply(null, arguments);
  }
  function ua(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);return function () {
      var d = c.slice();d.push.apply(d, arguments);return a.apply(this, d);
    };
  }var va = Date.now || function () {
    return +new Date();
  };function u(a, b) {
    function c() {}c.prototype = b.prototype;a.qb = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.cd = function (d, e, f) {
      for (var g = Array(arguments.length - 2), h = 2; h < arguments.length; h++) {
        g[h - 2] = arguments[h];
      }return b.prototype[e].apply(d, g);
    };
  };function wa(a) {
    if (!a) return !1;try {
      return !!a.$goog_Thenable;
    } catch (b) {
      return !1;
    }
  };function w(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, w);else {
      var b = Error().stack;b && (this.stack = b);
    }a && (this.message = String(a));
  }u(w, Error);w.prototype.name = "CustomError";function xa(a, b) {
    a = a.split("%s");for (var c = "", d = a.length - 1, e = 0; e < d; e++) {
      c += a[e] + (e < b.length ? b[e] : "%s");
    }w.call(this, c + a[d]);
  }u(xa, w);xa.prototype.name = "AssertionError";function ya(a, b) {
    throw new xa("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
  };function za(a, b) {
    this.c = a;this.f = b;this.b = 0;this.a = null;
  }za.prototype.get = function () {
    if (0 < this.b) {
      this.b--;var a = this.a;this.a = a.next;a.next = null;
    } else a = this.c();return a;
  };function Aa(a, b) {
    a.f(b);100 > a.b && (a.b++, b.next = a.a, a.a = b);
  };function Ba() {
    this.b = this.a = null;
  }var Da = new za(function () {
    return new Ca();
  }, function (a) {
    a.reset();
  });Ba.prototype.add = function (a, b) {
    var c = Da.get();c.set(a, b);this.b ? this.b.next = c : this.a = c;this.b = c;
  };function Ea() {
    var a = Fa,
        b = null;a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);return b;
  }function Ca() {
    this.next = this.b = this.a = null;
  }Ca.prototype.set = function (a, b) {
    this.a = a;this.b = b;this.next = null;
  };Ca.prototype.reset = function () {
    this.next = this.b = this.a = null;
  };var Ga = Array.prototype.indexOf ? function (a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
  } : function (a, b) {
    if (n(a)) return n(b) && 1 == b.length ? a.indexOf(b, 0) : -1;for (var c = 0; c < a.length; c++) {
      if (c in a && a[c] === b) return c;
    }return -1;
  },
      x = Array.prototype.forEach ? function (a, b, c) {
    Array.prototype.forEach.call(a, b, c);
  } : function (a, b, c) {
    for (var d = a.length, e = n(a) ? a.split("") : a, f = 0; f < d; f++) {
      f in e && b.call(c, e[f], f, a);
    }
  };function Ha(a, b) {
    for (var c = n(a) ? a.split("") : a, d = a.length - 1; 0 <= d; --d) {
      d in c && b.call(void 0, c[d], d, a);
    }
  }
  var Ia = Array.prototype.map ? function (a, b) {
    return Array.prototype.map.call(a, b, void 0);
  } : function (a, b) {
    for (var c = a.length, d = Array(c), e = n(a) ? a.split("") : a, f = 0; f < c; f++) {
      f in e && (d[f] = b.call(void 0, e[f], f, a));
    }return d;
  },
      Ja = Array.prototype.some ? function (a, b) {
    return Array.prototype.some.call(a, b, void 0);
  } : function (a, b) {
    for (var c = a.length, d = n(a) ? a.split("") : a, e = 0; e < c; e++) {
      if (e in d && b.call(void 0, d[e], e, a)) return !0;
    }return !1;
  };
  function Ka(a) {
    a: {
      var b = La;for (var c = a.length, d = n(a) ? a.split("") : a, e = 0; e < c; e++) {
        if (e in d && b.call(void 0, d[e], e, a)) {
          b = e;break a;
        }
      }b = -1;
    }return 0 > b ? null : n(a) ? a.charAt(b) : a[b];
  }function Ma(a, b) {
    return 0 <= Ga(a, b);
  }function Na(a, b) {
    b = Ga(a, b);var c;(c = 0 <= b) && Array.prototype.splice.call(a, b, 1);return c;
  }function y(a, b) {
    var c = 0;Ha(a, function (d, e) {
      b.call(void 0, d, e, a) && 1 == Array.prototype.splice.call(a, e, 1).length && c++;
    });
  }function Oa(a) {
    return Array.prototype.concat.apply([], arguments);
  }
  function Pa(a) {
    var b = a.length;if (0 < b) {
      for (var c = Array(b), d = 0; d < b; d++) {
        c[d] = a[d];
      }return c;
    }return [];
  };var Qa = String.prototype.trim ? function (a) {
    return a.trim();
  } : function (a) {
    return (/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]
    );
  },
      Ra = /&/g,
      Sa = /</g,
      Ta = />/g,
      Ua = /"/g,
      Va = /'/g,
      Wa = /\x00/g,
      Xa = /[\x00&<>"']/;function A(a, b) {
    return -1 != a.indexOf(b);
  }function Ya(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
  };var Za;a: {
    var $a = l.navigator;if ($a) {
      var ab = $a.userAgent;if (ab) {
        Za = ab;break a;
      }
    }Za = "";
  }function B(a) {
    return A(Za, a);
  };function bb(a, b) {
    for (var c in a) {
      b.call(void 0, a[c], c, a);
    }
  }function cb(a) {
    for (var b in a) {
      return !1;
    }return !0;
  }function db(a) {
    var b = {},
        c;for (c in a) {
      b[c] = a[c];
    }return b;
  }var eb = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function fb(a, b) {
    for (var c, d, e = 1; e < arguments.length; e++) {
      d = arguments[e];for (c in d) {
        a[c] = d[c];
      }for (var f = 0; f < eb.length; f++) {
        c = eb[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
      }
    }
  };function gb(a, b) {
    for (var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;) {
      d += c.shift() + e.shift();
    }return d + c.join("%s");
  }function hb(a) {
    Xa.test(a) && (-1 != a.indexOf("&") && (a = a.replace(Ra, "&amp;")), -1 != a.indexOf("<") && (a = a.replace(Sa, "&lt;")), -1 != a.indexOf(">") && (a = a.replace(Ta, "&gt;")), -1 != a.indexOf('"') && (a = a.replace(Ua, "&quot;")), -1 != a.indexOf("'") && (a = a.replace(Va, "&#39;")), -1 != a.indexOf("\x00") && (a = a.replace(Wa, "&#0;")));return a;
  };function ib(a) {
    l.setTimeout(function () {
      throw a;
    }, 0);
  }var jb;
  function kb() {
    var a = l.MessageChannel;"undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && !B("Presto") && (a = function a() {
      var e = document.createElement("IFRAME");e.style.display = "none";e.src = "";document.documentElement.appendChild(e);var f = e.contentWindow;e = f.document;e.open();e.write("");e.close();var g = "callImmediate" + Math.random(),
          h = "file:" == f.location.protocol ? "*" : f.location.protocol + "//" + f.location.host;e = t(function (m) {
        if (("*" == h || m.origin == h) && m.data == g) this.port1.onmessage();
      }, this);f.addEventListener("message", e, !1);this.port1 = {};this.port2 = { postMessage: function postMessage() {
          f.postMessage(g, h);
        } };
    });if ("undefined" !== typeof a && !B("Trident") && !B("MSIE")) {
      var b = new a(),
          c = {},
          d = c;b.port1.onmessage = function () {
        if (void 0 !== c.next) {
          c = c.next;var e = c.yb;c.yb = null;e();
        }
      };return function (e) {
        d.next = { yb: e };d = d.next;b.port2.postMessage(0);
      };
    }return "undefined" !== typeof document && "onreadystatechange" in document.createElement("SCRIPT") ? function (e) {
      var f = document.createElement("SCRIPT");
      f.onreadystatechange = function () {
        f.onreadystatechange = null;f.parentNode.removeChild(f);f = null;e();e = null;
      };document.documentElement.appendChild(f);
    } : function (e) {
      l.setTimeout(e, 0);
    };
  };function lb(a, b) {
    mb || nb();ob || (mb(), ob = !0);Fa.add(a, b);
  }var mb;function nb() {
    if (l.Promise && l.Promise.resolve) {
      var a = l.Promise.resolve(void 0);mb = function mb() {
        a.then(pb);
      };
    } else mb = function mb() {
      var b = pb;!q(l.setImmediate) || l.Window && l.Window.prototype && !B("Edge") && l.Window.prototype.setImmediate == l.setImmediate ? (jb || (jb = kb()), jb(b)) : l.setImmediate(b);
    };
  }var ob = !1,
      Fa = new Ba();function pb() {
    for (var a; a = Ea();) {
      try {
        a.a.call(a.b);
      } catch (b) {
        ib(b);
      }Aa(Da, a);
    }ob = !1;
  };function C(a, b) {
    this.a = qb;this.i = void 0;this.f = this.b = this.c = null;this.g = this.h = !1;if (a != ka) try {
      var c = this;a.call(b, function (d) {
        rb(c, sb, d);
      }, function (d) {
        if (!(d instanceof tb)) try {
          if (d instanceof Error) throw d;throw Error("Promise rejected.");
        } catch (e) {}rb(c, ub, d);
      });
    } catch (d) {
      rb(this, ub, d);
    }
  }var qb = 0,
      sb = 2,
      ub = 3;function vb() {
    this.next = this.f = this.b = this.g = this.a = null;this.c = !1;
  }vb.prototype.reset = function () {
    this.f = this.b = this.g = this.a = null;this.c = !1;
  };var wb = new za(function () {
    return new vb();
  }, function (a) {
    a.reset();
  });
  function xb(a, b, c) {
    var d = wb.get();d.g = a;d.b = b;d.f = c;return d;
  }function D(a) {
    if (a instanceof C) return a;var b = new C(ka);rb(b, sb, a);return b;
  }function E(a) {
    return new C(function (b, c) {
      c(a);
    });
  }function yb(a, b, c) {
    zb(a, b, c, null) || lb(ua(b, a));
  }function Ab(a) {
    return new C(function (b, c) {
      var d = a.length,
          e = [];if (d) for (var f = function f(p, v) {
        d--;e[p] = v;0 == d && b(e);
      }, g = function g(p) {
        c(p);
      }, h = 0, m; h < a.length; h++) {
        m = a[h], yb(m, ua(f, h), g);
      } else b(e);
    });
  }
  function Bb(a) {
    return new C(function (b) {
      var c = a.length,
          d = [];if (c) for (var e = function e(h, m, p) {
        c--;d[h] = m ? { Eb: !0, value: p } : { Eb: !1, reason: p };0 == c && b(d);
      }, f = 0, g; f < a.length; f++) {
        g = a[f], yb(g, ua(e, f, !0), ua(e, f, !1));
      } else b(d);
    });
  }C.prototype.then = function (a, b, c) {
    return Cb(this, q(a) ? a : null, q(b) ? b : null, c);
  };C.prototype.$goog_Thenable = !0;k = C.prototype;k.ia = function (a, b) {
    a = xb(a, a, b);a.c = !0;Db(this, a);return this;
  };k.s = function (a, b) {
    return Cb(this, null, a, b);
  };
  k.cancel = function (a) {
    this.a == qb && lb(function () {
      var b = new tb(a);Eb(this, b);
    }, this);
  };function Eb(a, b) {
    if (a.a == qb) if (a.c) {
      var c = a.c;if (c.b) {
        for (var d = 0, e = null, f = null, g = c.b; g && (g.c || (d++, g.a == a && (e = g), !(e && 1 < d))); g = g.next) {
          e || (f = g);
        }e && (c.a == qb && 1 == d ? Eb(c, b) : (f ? (d = f, d.next == c.f && (c.f = d), d.next = d.next.next) : Fb(c), Gb(c, e, ub, b)));
      }a.c = null;
    } else rb(a, ub, b);
  }function Db(a, b) {
    a.b || a.a != sb && a.a != ub || Hb(a);a.f ? a.f.next = b : a.b = b;a.f = b;
  }
  function Cb(a, b, c, d) {
    var e = xb(null, null, null);e.a = new C(function (f, g) {
      e.g = b ? function (h) {
        try {
          var m = b.call(d, h);f(m);
        } catch (p) {
          g(p);
        }
      } : f;e.b = c ? function (h) {
        try {
          var m = c.call(d, h);void 0 === m && h instanceof tb ? g(h) : f(m);
        } catch (p) {
          g(p);
        }
      } : g;
    });e.a.c = a;Db(a, e);return e.a;
  }k.Lc = function (a) {
    this.a = qb;rb(this, sb, a);
  };k.Mc = function (a) {
    this.a = qb;rb(this, ub, a);
  };
  function rb(a, b, c) {
    a.a == qb && (a === c && (b = ub, c = new TypeError("Promise cannot resolve to itself")), a.a = 1, zb(c, a.Lc, a.Mc, a) || (a.i = c, a.a = b, a.c = null, Hb(a), b != ub || c instanceof tb || Ib(a, c)));
  }function zb(a, b, c, d) {
    if (a instanceof C) return Db(a, xb(b || ka, c || null, d)), !0;if (wa(a)) return a.then(b, c, d), !0;if (r(a)) try {
      var e = a.then;if (q(e)) return Jb(a, e, b, c, d), !0;
    } catch (f) {
      return c.call(d, f), !0;
    }return !1;
  }
  function Jb(a, b, c, d, e) {
    function f(m) {
      h || (h = !0, d.call(e, m));
    }function g(m) {
      h || (h = !0, c.call(e, m));
    }var h = !1;try {
      b.call(a, g, f);
    } catch (m) {
      f(m);
    }
  }function Hb(a) {
    a.h || (a.h = !0, lb(a.Xb, a));
  }function Fb(a) {
    var b = null;a.b && (b = a.b, a.b = b.next, b.next = null);a.b || (a.f = null);return b;
  }k.Xb = function () {
    for (var a; a = Fb(this);) {
      Gb(this, a, this.a, this.i);
    }this.h = !1;
  };
  function Gb(a, b, c, d) {
    if (c == ub && b.b && !b.c) for (; a && a.g; a = a.c) {
      a.g = !1;
    }if (b.a) b.a.c = null, Kb(b, c, d);else try {
      b.c ? b.g.call(b.f) : Kb(b, c, d);
    } catch (e) {
      Lb.call(null, e);
    }Aa(wb, b);
  }function Kb(a, b, c) {
    b == sb ? a.g.call(a.f, c) : a.b && a.b.call(a.f, c);
  }function Ib(a, b) {
    a.g = !0;lb(function () {
      a.g && Lb.call(null, b);
    });
  }var Lb = ib;function tb(a) {
    w.call(this, a);
  }u(tb, w);tb.prototype.name = "cancel";function Mb() {
    0 != Nb && (Ob[this[pa] || (this[pa] = ++qa)] = this);this.qa = this.qa;this.ja = this.ja;
  }var Nb = 0,
      Ob = {};Mb.prototype.qa = !1;function Pb(a) {
    if (!a.qa && (a.qa = !0, a.va(), 0 != Nb)) {
      var b = a[pa] || (a[pa] = ++qa);if (0 != Nb && a.ja && 0 < a.ja.length) throw Error(a + " did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Ob[b];
    }
  }Mb.prototype.va = function () {
    if (this.ja) for (; this.ja.length;) {
      this.ja.shift()();
    }
  };function Qb(a) {
    Qb[" "](a);return a;
  }Qb[" "] = ka;function Rb(a, b) {
    var c = Sb;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
  };var Tb = B("Opera"),
      Ub = B("Trident") || B("MSIE"),
      Vb = B("Edge"),
      Wb = Vb || Ub,
      Xb = B("Gecko") && !(A(Za.toLowerCase(), "webkit") && !B("Edge")) && !(B("Trident") || B("MSIE")) && !B("Edge"),
      Yb = A(Za.toLowerCase(), "webkit") && !B("Edge");function Zb() {
    var a = l.document;return a ? a.documentMode : void 0;
  }var $b;
  a: {
    var ac = "",
        bc = function () {
      var a = Za;if (Xb) return (/rv:([^\);]+)(\)|;)/.exec(a)
      );if (Vb) return (/Edge\/([\d\.]+)/.exec(a)
      );if (Ub) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
      );if (Yb) return (/WebKit\/(\S+)/.exec(a)
      );if (Tb) return (/(?:Version)[ \/]?(\S+)/.exec(a)
      );
    }();bc && (ac = bc ? bc[1] : "");if (Ub) {
      var cc = Zb();if (null != cc && cc > parseFloat(ac)) {
        $b = String(cc);break a;
      }
    }$b = ac;
  }var Sb = {};
  function dc(a) {
    return Rb(a, function () {
      for (var b = 0, c = Qa(String($b)).split("."), d = Qa(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
        var g = c[f] || "",
            h = d[f] || "";do {
          g = /(\d*)(\D*)(.*)/.exec(g) || ["", "", "", ""];h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];if (0 == g[0].length && 0 == h[0].length) break;b = Ya(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == h[1].length ? 0 : parseInt(h[1], 10)) || Ya(0 == g[2].length, 0 == h[2].length) || Ya(g[2], h[2]);g = g[3];h = h[3];
        } while (0 == b);
      }return 0 <= b;
    });
  }var ec;var fc = l.document;
  ec = fc && Ub ? Zb() || ("CSS1Compat" == fc.compatMode ? parseInt($b, 10) : 5) : void 0;var gc = Object.freeze || function (a) {
    return a;
  };var hc = !Ub || 9 <= Number(ec),
      ic = Ub && !dc("9"),
      jc = function () {
    if (!l.addEventListener || !Object.defineProperty) return !1;var a = !1,
        b = Object.defineProperty({}, "passive", { get: function get() {
        a = !0;
      } });try {
      l.addEventListener("test", ka, b), l.removeEventListener("test", ka, b);
    } catch (c) {}return a;
  }();function kc(a, b) {
    this.type = a;this.b = this.target = b;this.Kb = !0;
  }kc.prototype.preventDefault = function () {
    this.Kb = !1;
  };function lc(a, b) {
    kc.call(this, a ? a.type : "");this.relatedTarget = this.b = this.target = null;this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;this.key = "";this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.pointerId = 0;this.pointerType = "";this.a = null;if (a) {
      var c = this.type = a.type,
          d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.b = b;if (b = a.relatedTarget) {
        if (Xb) {
          a: {
            try {
              Qb(b.nodeName);var e = !0;break a;
            } catch (f) {}e = !1;
          }e || (b = null);
        }
      } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);this.button = a.button;this.key = a.key || "";this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.pointerId = a.pointerId || 0;this.pointerType = n(a.pointerType) ? a.pointerType : mc[a.pointerType] || "";this.a = a;a.defaultPrevented && this.preventDefault();
    }
  }u(lc, kc);var mc = gc({ 2: "touch", 3: "pen", 4: "mouse" });lc.prototype.preventDefault = function () {
    lc.qb.preventDefault.call(this);var a = this.a;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, ic) try {
      if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
    } catch (b) {}
  };lc.prototype.f = function () {
    return this.a;
  };var nc = "closure_listenable_" + (1E6 * Math.random() | 0),
      oc = 0;function pc(a, b, c, d, e) {
    this.listener = a;this.proxy = null;this.src = b;this.type = c;this.capture = !!d;this.Na = e;this.key = ++oc;this.oa = this.Ia = !1;
  }function qc(a) {
    a.oa = !0;a.listener = null;a.proxy = null;a.src = null;a.Na = null;
  };function rc(a) {
    this.src = a;this.a = {};this.b = 0;
  }rc.prototype.add = function (a, b, c, d, e) {
    var f = a.toString();a = this.a[f];a || (a = this.a[f] = [], this.b++);var g = sc(a, b, d, e);-1 < g ? (b = a[g], c || (b.Ia = !1)) : (b = new pc(b, this.src, f, !!d, e), b.Ia = c, a.push(b));return b;
  };function tc(a, b) {
    var c = b.type;c in a.a && Na(a.a[c], b) && (qc(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
  }function sc(a, b, c, d) {
    for (var e = 0; e < a.length; ++e) {
      var f = a[e];if (!f.oa && f.listener == b && f.capture == !!c && f.Na == d) return e;
    }return -1;
  };var uc = "closure_lm_" + (1E6 * Math.random() | 0),
      vc = {},
      wc = 0;function xc(a, b, c, d, e) {
    if (d && d.once) yc(a, b, c, d, e);else if (na(b)) for (var f = 0; f < b.length; f++) {
      xc(a, b[f], c, d, e);
    } else c = zc(c), a && a[nc] ? Ac(a, b, c, r(d) ? !!d.capture : !!d, e) : Bc(a, b, c, !1, d, e);
  }
  function Bc(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");var g = r(e) ? !!e.capture : !!e,
        h = Cc(a);h || (a[uc] = h = new rc(a));c = h.add(b, c, d, g, f);if (!c.proxy) {
      d = Dc();c.proxy = d;d.src = a;d.listener = c;if (a.addEventListener) jc || (e = g), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(Ec(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");wc++;
    }
  }
  function Dc() {
    var a = Fc,
        b = hc ? function (c) {
      return a.call(b.src, b.listener, c);
    } : function (c) {
      c = a.call(b.src, b.listener, c);if (!c) return c;
    };return b;
  }function yc(a, b, c, d, e) {
    if (na(b)) for (var f = 0; f < b.length; f++) {
      yc(a, b[f], c, d, e);
    } else c = zc(c), a && a[nc] ? Gc(a, b, c, r(d) ? !!d.capture : !!d, e) : Bc(a, b, c, !0, d, e);
  }
  function Hc(a, b, c, d, e) {
    if (na(b)) for (var f = 0; f < b.length; f++) {
      Hc(a, b[f], c, d, e);
    } else (d = r(d) ? !!d.capture : !!d, c = zc(c), a && a[nc]) ? (a = a.m, b = String(b).toString(), b in a.a && (f = a.a[b], c = sc(f, c, d, e), -1 < c && (qc(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = Cc(a)) && (b = a.a[b.toString()], a = -1, b && (a = sc(b, c, d, e)), (c = -1 < a ? b[a] : null) && Ic(c));
  }
  function Ic(a) {
    if ("number" != typeof a && a && !a.oa) {
      var b = a.src;if (b && b[nc]) tc(b.m, a);else {
        var c = a.type,
            d = a.proxy;b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Ec(c), d) : b.addListener && b.removeListener && b.removeListener(d);wc--;(c = Cc(b)) ? (tc(c, a), 0 == c.b && (c.src = null, b[uc] = null)) : qc(a);
      }
    }
  }function Ec(a) {
    return a in vc ? vc[a] : vc[a] = "on" + a;
  }
  function Jc(a, b, c, d) {
    var e = !0;if (a = Cc(a)) if (b = a.a[b.toString()]) for (b = b.concat(), a = 0; a < b.length; a++) {
      var f = b[a];f && f.capture == c && !f.oa && (f = Kc(f, d), e = e && !1 !== f);
    }return e;
  }function Kc(a, b) {
    var c = a.listener,
        d = a.Na || a.src;a.Ia && Ic(a);return c.call(d, b);
  }
  function Fc(a, b) {
    if (a.oa) return !0;if (!hc) {
      if (!b) a: {
        b = ["window", "event"];for (var c = l, d = 0; d < b.length; d++) {
          if (c = c[b[d]], null == c) {
            b = null;break a;
          }
        }b = c;
      }d = b;b = new lc(d, this);c = !0;if (!(0 > d.keyCode || void 0 != d.returnValue)) {
        a: {
          var e = !1;if (0 == d.keyCode) try {
            d.keyCode = -1;break a;
          } catch (g) {
            e = !0;
          }if (e || void 0 == d.returnValue) d.returnValue = !0;
        }d = [];for (e = b.b; e; e = e.parentNode) {
          d.push(e);
        }a = a.type;for (e = d.length - 1; 0 <= e; e--) {
          b.b = d[e];var f = Jc(d[e], a, !0, b);c = c && f;
        }for (e = 0; e < d.length; e++) {
          b.b = d[e], f = Jc(d[e], a, !1, b), c = c && f;
        }
      }return c;
    }return Kc(a, new lc(b, this));
  }function Cc(a) {
    a = a[uc];return a instanceof rc ? a : null;
  }var Lc = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);function zc(a) {
    if (q(a)) return a;a[Lc] || (a[Lc] = function (b) {
      return a.handleEvent(b);
    });return a[Lc];
  };function F() {
    Mb.call(this);this.m = new rc(this);this.Qb = this;this.Va = null;
  }u(F, Mb);F.prototype[nc] = !0;F.prototype.addEventListener = function (a, b, c, d) {
    xc(this, a, b, c, d);
  };F.prototype.removeEventListener = function (a, b, c, d) {
    Hc(this, a, b, c, d);
  };
  F.prototype.dispatchEvent = function (a) {
    var b,
        c = this.Va;if (c) for (b = []; c; c = c.Va) {
      b.push(c);
    }c = this.Qb;var d = a.type || a;if (n(a)) a = new kc(a, c);else if (a instanceof kc) a.target = a.target || c;else {
      var e = a;a = new kc(d, c);fb(a, e);
    }e = !0;if (b) for (var f = b.length - 1; 0 <= f; f--) {
      var g = a.b = b[f];e = Mc(g, d, !0, a) && e;
    }g = a.b = c;e = Mc(g, d, !0, a) && e;e = Mc(g, d, !1, a) && e;if (b) for (f = 0; f < b.length; f++) {
      g = a.b = b[f], e = Mc(g, d, !1, a) && e;
    }return e;
  };
  F.prototype.va = function () {
    F.qb.va.call(this);if (this.m) {
      var a = this.m,
          b = 0,
          c;for (c in a.a) {
        for (var d = a.a[c], e = 0; e < d.length; e++) {
          ++b, qc(d[e]);
        }delete a.a[c];a.b--;
      }
    }this.Va = null;
  };function Ac(a, b, c, d, e) {
    a.m.add(String(b), c, !1, d, e);
  }function Gc(a, b, c, d, e) {
    a.m.add(String(b), c, !0, d, e);
  }
  function Mc(a, b, c, d) {
    b = a.m.a[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
      var g = b[f];if (g && !g.oa && g.capture == c) {
        var h = g.listener,
            m = g.Na || g.src;g.Ia && tc(a.m, g);e = !1 !== h.call(m, d) && e;
      }
    }return e && 0 != d.Kb;
  };function Nc(a, b, c) {
    if (q(a)) c && (a = t(a, c));else if (a && "function" == typeof a.handleEvent) a = t(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : l.setTimeout(a, b || 0);
  }function Oc(a) {
    var b = null;return new C(function (c, d) {
      b = Nc(function () {
        c(void 0);
      }, a);-1 == b && d(Error("Failed to schedule timer."));
    }).s(function (c) {
      l.clearTimeout(b);throw c;
    });
  };function Pc(a) {
    if (a.S && "function" == typeof a.S) return a.S();if (n(a)) return a.split("");if (oa(a)) {
      for (var b = [], c = a.length, d = 0; d < c; d++) {
        b.push(a[d]);
      }return b;
    }b = [];c = 0;for (d in a) {
      b[c++] = a[d];
    }return b;
  }function Qc(a) {
    if (a.U && "function" == typeof a.U) return a.U();if (!a.S || "function" != typeof a.S) {
      if (oa(a) || n(a)) {
        var b = [];a = a.length;for (var c = 0; c < a; c++) {
          b.push(c);
        }return b;
      }b = [];c = 0;for (var d in a) {
        b[c++] = d;
      }return b;
    }
  }
  function Rc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (oa(a) || n(a)) x(a, b, void 0);else for (var c = Qc(a), d = Pc(a), e = d.length, f = 0; f < e; f++) {
      b.call(void 0, d[f], c && c[f], a);
    }
  };function Sc(a, b) {
    this.b = {};this.a = [];this.c = 0;var c = arguments.length;if (1 < c) {
      if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
        this.set(arguments[d], arguments[d + 1]);
      }
    } else if (a) if (a instanceof Sc) for (c = a.U(), d = 0; d < c.length; d++) {
      this.set(c[d], a.get(c[d]));
    } else for (d in a) {
      this.set(d, a[d]);
    }
  }k = Sc.prototype;k.S = function () {
    Tc(this);for (var a = [], b = 0; b < this.a.length; b++) {
      a.push(this.b[this.a[b]]);
    }return a;
  };k.U = function () {
    Tc(this);return this.a.concat();
  };
  k.clear = function () {
    this.b = {};this.c = this.a.length = 0;
  };function Tc(a) {
    if (a.c != a.a.length) {
      for (var b = 0, c = 0; b < a.a.length;) {
        var d = a.a[b];Uc(a.b, d) && (a.a[c++] = d);b++;
      }a.a.length = c;
    }if (a.c != a.a.length) {
      var e = {};for (c = b = 0; b < a.a.length;) {
        d = a.a[b], Uc(e, d) || (a.a[c++] = d, e[d] = 1), b++;
      }a.a.length = c;
    }
  }k.get = function (a, b) {
    return Uc(this.b, a) ? this.b[a] : b;
  };k.set = function (a, b) {
    Uc(this.b, a) || (this.c++, this.a.push(a));this.b[a] = b;
  };
  k.forEach = function (a, b) {
    for (var c = this.U(), d = 0; d < c.length; d++) {
      var e = c[d],
          f = this.get(e);a.call(b, f, e, this);
    }
  };function Uc(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  };var Vc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Wc(a, b) {
    if (a) {
      a = a.split("&");for (var c = 0; c < a.length; c++) {
        var d = a[c].indexOf("="),
            e = null;if (0 <= d) {
          var f = a[c].substring(0, d);e = a[c].substring(d + 1);
        } else f = a[c];b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
      }
    }
  };function Xc(a, b) {
    this.b = this.i = this.f = "";this.m = null;this.g = this.c = "";this.h = !1;var c;a instanceof Xc ? (this.h = void 0 !== b ? b : a.h, Yc(this, a.f), this.i = a.i, this.b = a.b, Zc(this, a.m), this.c = a.c, $c(this, ad(a.a)), this.g = a.g) : a && (c = String(a).match(Vc)) ? (this.h = !!b, Yc(this, c[1] || "", !0), this.i = bd(c[2] || ""), this.b = bd(c[3] || "", !0), Zc(this, c[4]), this.c = bd(c[5] || "", !0), $c(this, c[6] || "", !0), this.g = bd(c[7] || "")) : (this.h = !!b, this.a = new cd(null, this.h));
  }
  Xc.prototype.toString = function () {
    var a = [],
        b = this.f;b && a.push(dd(b, ed, !0), ":");var c = this.b;if (c || "file" == b) a.push("//"), (b = this.i) && a.push(dd(b, ed, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));if (c = this.c) this.b && "/" != c.charAt(0) && a.push("/"), a.push(dd(c, "/" == c.charAt(0) ? fd : gd, !0));(c = this.a.toString()) && a.push("?", c);(c = this.g) && a.push("#", dd(c, hd));return a.join("");
  };
  Xc.prototype.resolve = function (a) {
    var b = new Xc(this),
        c = !!a.f;c ? Yc(b, a.f) : c = !!a.i;c ? b.i = a.i : c = !!a.b;c ? b.b = a.b : c = null != a.m;var d = a.c;if (c) Zc(b, a.m);else if (c = !!a.c) {
      if ("/" != d.charAt(0)) if (this.b && !this.c) d = "/" + d;else {
        var e = b.c.lastIndexOf("/");-1 != e && (d = b.c.substr(0, e + 1) + d);
      }e = d;if (".." == e || "." == e) d = "";else if (A(e, "./") || A(e, "/.")) {
        d = 0 == e.lastIndexOf("/", 0);e = e.split("/");for (var f = [], g = 0; g < e.length;) {
          var h = e[g++];"." == h ? d && g == e.length && f.push("") : ".." == h ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && g == e.length && f.push("")) : (f.push(h), d = !0);
        }d = f.join("/");
      } else d = e;
    }c ? b.c = d : c = "" !== a.a.toString();c ? $c(b, ad(a.a)) : c = !!a.g;c && (b.g = a.g);return b;
  };function Yc(a, b, c) {
    a.f = c ? bd(b, !0) : b;a.f && (a.f = a.f.replace(/:$/, ""));
  }function Zc(a, b) {
    if (b) {
      b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.m = b;
    } else a.m = null;
  }function $c(a, b, c) {
    b instanceof cd ? (a.a = b, id(a.a, a.h)) : (c || (b = dd(b, jd)), a.a = new cd(b, a.h));
  }function G(a, b, c) {
    a.a.set(b, c);
  }function kd(a, b) {
    return a.a.get(b);
  }
  function md(a) {
    return a instanceof Xc ? new Xc(a) : new Xc(a, void 0);
  }function nd(a, b) {
    var c = new Xc(null, void 0);Yc(c, "https");a && (c.b = a);b && (c.c = b);return c;
  }function bd(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
  }function dd(a, b, c) {
    return n(a) ? (a = encodeURI(a).replace(b, od), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
  }function od(a) {
    a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
  }
  var ed = /[#\/\?@]/g,
      gd = /[#\?:]/g,
      fd = /[#\?]/g,
      jd = /[#\?@]/g,
      hd = /#/g;function cd(a, b) {
    this.b = this.a = null;this.c = a || null;this.f = !!b;
  }function pd(a) {
    a.a || (a.a = new Sc(), a.b = 0, a.c && Wc(a.c, function (b, c) {
      a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
  }function qd(a) {
    var b = Qc(a);if ("undefined" == typeof b) throw Error("Keys are undefined");var c = new cd(null, void 0);a = Pc(a);for (var d = 0; d < b.length; d++) {
      var e = b[d],
          f = a[d];na(f) ? rd(c, e, f) : c.add(e, f);
    }return c;
  }k = cd.prototype;
  k.add = function (a, b) {
    pd(this);this.c = null;a = sd(this, a);var c = this.a.get(a);c || this.a.set(a, c = []);c.push(b);this.b += 1;return this;
  };function td(a, b) {
    pd(a);b = sd(a, b);Uc(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, Uc(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Tc(a)));
  }k.clear = function () {
    this.a = this.c = null;this.b = 0;
  };function ud(a, b) {
    pd(a);b = sd(a, b);return Uc(a.a.b, b);
  }k.forEach = function (a, b) {
    pd(this);this.a.forEach(function (c, d) {
      x(c, function (e) {
        a.call(b, e, d, this);
      }, this);
    }, this);
  };
  k.U = function () {
    pd(this);for (var a = this.a.S(), b = this.a.U(), c = [], d = 0; d < b.length; d++) {
      for (var e = a[d], f = 0; f < e.length; f++) {
        c.push(b[d]);
      }
    }return c;
  };k.S = function (a) {
    pd(this);var b = [];if (n(a)) ud(this, a) && (b = Oa(b, this.a.get(sd(this, a))));else {
      a = this.a.S();for (var c = 0; c < a.length; c++) {
        b = Oa(b, a[c]);
      }
    }return b;
  };k.set = function (a, b) {
    pd(this);this.c = null;a = sd(this, a);ud(this, a) && (this.b -= this.a.get(a).length);this.a.set(a, [b]);this.b += 1;return this;
  };
  k.get = function (a, b) {
    if (!a) return b;a = this.S(a);return 0 < a.length ? String(a[0]) : b;
  };function rd(a, b, c) {
    td(a, b);0 < c.length && (a.c = null, a.a.set(sd(a, b), Pa(c)), a.b += c.length);
  }k.toString = function () {
    if (this.c) return this.c;if (!this.a) return "";for (var a = [], b = this.a.U(), c = 0; c < b.length; c++) {
      var d = b[c],
          e = encodeURIComponent(String(d));d = this.S(d);for (var f = 0; f < d.length; f++) {
        var g = e;"" !== d[f] && (g += "=" + encodeURIComponent(String(d[f])));a.push(g);
      }
    }return this.c = a.join("&");
  };
  function ad(a) {
    var b = new cd();b.c = a.c;a.a && (b.a = new Sc(a.a), b.b = a.b);return b;
  }function sd(a, b) {
    b = String(b);a.f && (b = b.toLowerCase());return b;
  }function id(a, b) {
    b && !a.f && (pd(a), a.c = null, a.a.forEach(function (c, d) {
      var e = d.toLowerCase();d != e && (td(this, d), rd(this, e, c));
    }, a));a.f = b;
  };var vd = !Ub || 9 <= Number(ec);function wd(a, b) {
    this.a = a === xd && b || "";this.b = yd;
  }wd.prototype.na = !0;wd.prototype.ma = function () {
    return this.a;
  };wd.prototype.toString = function () {
    return "Const{" + this.a + "}";
  };function zd(a) {
    if (a instanceof wd && a.constructor === wd && a.b === yd) return a.a;ya("expected object of type Const, got '" + a + "'");return "type_error:Const";
  }var yd = {},
      xd = {};function Ad() {
    this.a = "";this.b = Bd;
  }Ad.prototype.na = !0;Ad.prototype.ma = function () {
    return this.a.toString();
  };Ad.prototype.toString = function () {
    return "TrustedResourceUrl{" + this.a + "}";
  };function Cd(a) {
    if (a instanceof Ad && a.constructor === Ad && a.b === Bd) return a.a;ya("expected object of type TrustedResourceUrl, got '" + a + "' of type " + la(a));return "type_error:TrustedResourceUrl";
  }
  function Dd(a, b) {
    var c = zd(a);if (!Ed.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);a = c.replace(Fd, function (d, e) {
      if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));d = b[e];return d instanceof wd ? zd(d) : encodeURIComponent(String(d));
    });return Gd(a);
  }var Fd = /%{(\w+)}/g,
      Ed = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,
      Bd = {};
  function Gd(a) {
    var b = new Ad();b.a = a;return b;
  };function Hd() {
    this.a = "";this.b = Id;
  }Hd.prototype.na = !0;Hd.prototype.ma = function () {
    return this.a.toString();
  };Hd.prototype.toString = function () {
    return "SafeUrl{" + this.a + "}";
  };function Jd(a) {
    if (a instanceof Hd && a.constructor === Hd && a.b === Id) return a.a;ya("expected object of type SafeUrl, got '" + a + "' of type " + la(a));return "type_error:SafeUrl";
  }var Kd = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
  function Ld(a) {
    if (a instanceof Hd) return a;a = "object" == typeof a && a.na ? a.ma() : String(a);Kd.test(a) || (a = "about:invalid#zClosurez");return Md(a);
  }var Id = {};function Md(a) {
    var b = new Hd();b.a = a;return b;
  }Md("about:blank");function Nd() {
    this.a = "";this.b = Od;
  }Nd.prototype.na = !0;Nd.prototype.ma = function () {
    return this.a.toString();
  };Nd.prototype.toString = function () {
    return "SafeHtml{" + this.a + "}";
  };function Pd(a) {
    if (a instanceof Nd && a.constructor === Nd && a.b === Od) return a.a;ya("expected object of type SafeHtml, got '" + a + "' of type " + la(a));return "type_error:SafeHtml";
  }var Od = {};function Qd(a) {
    var b = new Nd();b.a = a;return b;
  }Qd("<!DOCTYPE html>");Qd("");Qd("<br>");function Rd(a, b) {
    a.src = Cd(b);if (null === ja) b: {
      b = l.document;if ((b = b.querySelector && b.querySelector("script[nonce]")) && (b = b.nonce || b.getAttribute("nonce")) && ia.test(b)) {
        ja = b;break b;
      }ja = "";
    }b = ja;b && a.setAttribute("nonce", b);
  };function Sd(a) {
    var b = document;return n(a) ? b.getElementById(a) : a;
  }function Td(a, b) {
    bb(b, function (c, d) {
      c && "object" == typeof c && c.na && (c = c.ma());"style" == d ? a.style.cssText = c : "class" == d ? a.className = c : "for" == d ? a.htmlFor = c : Ud.hasOwnProperty(d) ? a.setAttribute(Ud[d], c) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, c) : a[d] = c;
    });
  }
  var Ud = { cellpadding: "cellPadding", cellspacing: "cellSpacing", colspan: "colSpan", frameborder: "frameBorder", height: "height", maxlength: "maxLength", nonce: "nonce", role: "role", rowspan: "rowSpan", type: "type", usemap: "useMap", valign: "vAlign", width: "width" };
  function Vd(a, b, c) {
    var d = arguments,
        e = document,
        f = String(d[0]),
        g = d[1];if (!vd && g && (g.name || g.type)) {
      f = ["<", f];g.name && f.push(' name="', hb(g.name), '"');if (g.type) {
        f.push(' type="', hb(g.type), '"');var h = {};fb(h, g);delete h.type;g = h;
      }f.push(">");f = f.join("");
    }f = e.createElement(f);g && (n(g) ? f.className = g : na(g) ? f.className = g.join(" ") : Td(f, g));2 < d.length && Wd(e, f, d);return f;
  }
  function Wd(a, b, c) {
    function d(g) {
      g && b.appendChild(n(g) ? a.createTextNode(g) : g);
    }for (var e = 2; e < c.length; e++) {
      var f = c[e];!oa(f) || r(f) && 0 < f.nodeType ? d(f) : x(Xd(f) ? Pa(f) : f, d);
    }
  }function Xd(a) {
    if (a && "number" == typeof a.length) {
      if (r(a)) return "function" == typeof a.item || "string" == typeof a.item;if (q(a)) return "function" == typeof a.item;
    }return !1;
  };function Yd(a) {
    var b = [];Zd(new $d(), a, b);return b.join("");
  }function $d() {}
  function Zd(a, b, c) {
    if (null == b) c.push("null");else {
      if ("object" == typeof b) {
        if (na(b)) {
          var d = b;b = d.length;c.push("[");for (var e = "", f = 0; f < b; f++) {
            c.push(e), Zd(a, d[f], c), e = ",";
          }c.push("]");return;
        }if (b instanceof String || b instanceof Number || b instanceof Boolean) b = b.valueOf();else {
          c.push("{");e = "";for (d in b) {
            Object.prototype.hasOwnProperty.call(b, d) && (f = b[d], "function" != typeof f && (c.push(e), ae(d, c), c.push(":"), Zd(a, f, c), e = ","));
          }c.push("}");return;
        }
      }switch (typeof b) {case "string":
          ae(b, c);break;case "number":
          c.push(isFinite(b) && !isNaN(b) ? String(b) : "null");break;case "boolean":
          c.push(String(b));break;case "function":
          c.push("null");break;default:
          throw Error("Unknown type: " + typeof b);}
    }
  }var be = { '"': '\\"', "\\": "\\\\", "/": "\\/", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "\t": "\\t", "\x0B": "\\u000b" },
      ce = /\uffff/.test("\uFFFF") ? /[\\"\x00-\x1f\x7f-\uffff]/g : /[\\"\x00-\x1f\x7f-\xff]/g;
  function ae(a, b) {
    b.push('"', a.replace(ce, function (c) {
      var d = be[c];d || (d = "\\u" + (c.charCodeAt(0) | 65536).toString(16).substr(1), be[c] = d);return d;
    }), '"');
  }; /*
     Copyright 2017 Google Inc.
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     http://www.apache.org/licenses/LICENSE-2.0
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */
  function de() {
    var a = I();return Ub && !!ec && 11 == ec || /Edge\/\d+/.test(a);
  }function ee() {
    return l.window && l.window.location.href || self && self.location && self.location.href || "";
  }function fe(a, b) {
    b = b || l.window;var c = "about:blank";a && (c = Jd(Ld(a)).toString());b.location.href = c;
  }function ge(a, b) {
    var c = [],
        d;for (d in a) {
      d in b ? typeof a[d] != typeof b[d] ? c.push(d) : "object" == typeof a[d] && null != a[d] && null != b[d] ? 0 < ge(a[d], b[d]).length && c.push(d) : a[d] !== b[d] && c.push(d) : c.push(d);
    }for (d in b) {
      d in a || c.push(d);
    }return c;
  }
  function he() {
    var a = I();a = ie(a) != je ? null : (a = a.match(/\sChrome\/(\d+)/i)) && 2 == a.length ? parseInt(a[1], 10) : null;return a && 30 > a ? !1 : !Ub || !ec || 9 < ec;
  }function ke(a) {
    a = (a || I()).toLowerCase();return a.match(/android/) || a.match(/webos/) || a.match(/iphone|ipad|ipod/) || a.match(/blackberry/) || a.match(/windows phone/) || a.match(/iemobile/) ? !0 : !1;
  }function le(a) {
    a = a || l.window;try {
      a.close();
    } catch (b) {}
  }
  function me(a, b, c) {
    var d = Math.floor(1E9 * Math.random()).toString();b = b || 500;c = c || 600;var e = (window.screen.availHeight - c) / 2,
        f = (window.screen.availWidth - b) / 2;b = { width: b, height: c, top: 0 < e ? e : 0, left: 0 < f ? f : 0, location: !0, resizable: !0, statusbar: !0, toolbar: !1 };c = I().toLowerCase();d && (b.target = d, A(c, "crios/") && (b.target = "_blank"));ie(I()) == ne && (a = a || "http://localhost", b.scrollbars = !0);c = a || "";(a = b) || (a = {});d = window;b = c instanceof Hd ? c : Ld("undefined" != typeof c.href ? c.href : String(c));c = a.target || c.target;e = [];
    for (g in a) {
      switch (g) {case "width":case "height":case "top":case "left":
          e.push(g + "=" + a[g]);break;case "target":case "noopener":case "noreferrer":
          break;default:
          e.push(g + "=" + (a[g] ? 1 : 0));}
    }var g = e.join(",");(B("iPhone") && !B("iPod") && !B("iPad") || B("iPad") || B("iPod")) && d.navigator && d.navigator.standalone && c && "_self" != c ? (g = d.document.createElement("A"), b instanceof Hd || b instanceof Hd || (b = "object" == typeof b && b.na ? b.ma() : String(b), Kd.test(b) || (b = "about:invalid#zClosurez"), b = Md(b)), g.href = Jd(b), g.setAttribute("target", c), a.noreferrer && g.setAttribute("rel", "noreferrer"), a = document.createEvent("MouseEvent"), a.initMouseEvent("click", !0, !0, d, 1), g.dispatchEvent(a), g = {}) : a.noreferrer ? (g = d.open("", c, g), a = Jd(b).toString(), g && (Wb && A(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'"), g.opener = null, a = Qd('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url=' + hb(a) + '">'), g.document.write(Pd(a)), g.document.close())) : (g = d.open(Jd(b).toString(), c, g)) && a.noopener && (g.opener = null);if (g) try {
      g.focus();
    } catch (h) {}return g;
  }
  function oe(a) {
    return new C(function (b) {
      function c() {
        Oc(2E3).then(function () {
          if (!a || a.closed) b();else return c();
        });
      }return c();
    });
  }var pe = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
      qe = /^[^@]+@[^@]+$/;function re() {
    var a = null;return new C(function (b) {
      "complete" == l.document.readyState ? b() : (a = function a() {
        b();
      }, yc(window, "load", a));
    }).s(function (b) {
      Hc(window, "load", a);throw b;
    });
  }
  function se() {
    return te(void 0) ? re().then(function () {
      return new C(function (a, b) {
        var c = l.document,
            d = setTimeout(function () {
          b(Error("Cordova framework is not ready."));
        }, 1E3);c.addEventListener("deviceready", function () {
          clearTimeout(d);a();
        }, !1);
      });
    }) : E(Error("Cordova must run in an Android or iOS file scheme."));
  }function te(a) {
    a = a || I();return !("file:" !== ue() || !a.toLowerCase().match(/iphone|ipad|ipod|android/));
  }function ve() {
    var a = l.window;try {
      return !(!a || a == a.top);
    } catch (b) {
      return !1;
    }
  }
  function we() {
    return "undefined" !== typeof l.WorkerGlobalScope && "function" === typeof l.importScripts;
  }function xe() {
    return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("reactNative") ? "ReactNative" : __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.hasOwnProperty("node") ? "Node" : we() ? "Worker" : "Browser";
  }function ye() {
    var a = xe();return "ReactNative" === a || "Node" === a;
  }function ze() {
    for (var a = 50, b = []; 0 < a;) {
      b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
    }return b.join("");
  }
  var ne = "Firefox",
      je = "Chrome";
  function ie(a) {
    var b = a.toLowerCase();if (A(b, "opera/") || A(b, "opr/") || A(b, "opios/")) return "Opera";if (A(b, "iemobile")) return "IEMobile";if (A(b, "msie") || A(b, "trident/")) return "IE";if (A(b, "edge/")) return "Edge";if (A(b, "firefox/")) return ne;if (A(b, "silk/")) return "Silk";if (A(b, "blackberry")) return "Blackberry";if (A(b, "webos")) return "Webos";if (!A(b, "safari/") || A(b, "chrome/") || A(b, "crios/") || A(b, "android")) {
      if (!A(b, "chrome/") && !A(b, "crios/") || A(b, "edge/")) {
        if (A(b, "android")) return "Android";if ((a = a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/)) && 2 == a.length) return a[1];
      } else return je;
    } else return "Safari";return "Other";
  }var Ae = { Sc: "FirebaseCore-web", Uc: "FirebaseUI-web" };function Be(a, b) {
    b = b || [];var c = [],
        d = {},
        e;for (e in Ae) {
      d[Ae[e]] = !0;
    }for (e = 0; e < b.length; e++) {
      "undefined" !== typeof d[b[e]] && (delete d[b[e]], c.push(b[e]));
    }c.sort();b = c;b.length || (b = ["FirebaseCore-web"]);c = xe();"Browser" === c ? (d = I(), c = ie(d)) : "Worker" === c && (d = I(), c = ie(d) + "-" + c);return c + "/JsCore/" + a + "/" + b.join(",");
  }function I() {
    return l.navigator && l.navigator.userAgent || "";
  }
  function J(a, b) {
    a = a.split(".");b = b || l;for (var c = 0; c < a.length && "object" == typeof b && null != b; c++) {
      b = b[a[c]];
    }c != a.length && (b = void 0);return b;
  }function Ce() {
    try {
      var a = l.localStorage,
          b = De();if (a) return a.setItem(b, "1"), a.removeItem(b), de() ? !!l.indexedDB : !0;
    } catch (c) {
      return we() && !!l.indexedDB;
    }return !1;
  }function Ee() {
    return (Fe() || "chrome-extension:" === ue() || te()) && !ye() && Ce() && !we();
  }function Fe() {
    return "http:" === ue() || "https:" === ue();
  }function ue() {
    return l.location && l.location.protocol || null;
  }
  function Ge(a) {
    a = a || I();return ke(a) || ie(a) == ne ? !1 : !0;
  }function He(a) {
    return "undefined" === typeof a ? null : Yd(a);
  }function Ie(a) {
    var b = {},
        c;for (c in a) {
      a.hasOwnProperty(c) && null !== a[c] && void 0 !== a[c] && (b[c] = a[c]);
    }return b;
  }function Je(a) {
    if (null !== a) return JSON.parse(a);
  }function De(a) {
    return a ? a : Math.floor(1E9 * Math.random()).toString();
  }function Ke(a) {
    a = a || I();return "Safari" == ie(a) || a.toLowerCase().match(/iphone|ipad|ipod/) ? !1 : !0;
  }
  function Le() {
    var a = l.___jsl;if (a && a.H) for (var b in a.H) {
      if (a.H[b].r = a.H[b].r || [], a.H[b].L = a.H[b].L || [], a.H[b].r = a.H[b].L.concat(), a.CP) for (var c = 0; c < a.CP.length; c++) {
        a.CP[c] = null;
      }
    }
  }function Me(a, b) {
    if (a > b) throw Error("Short delay should be less than long delay!");this.a = a;this.c = b;a = I();b = xe();this.b = ke(a) || "ReactNative" === b;
  }
  Me.prototype.get = function () {
    var a = l.navigator;return (a && "boolean" === typeof a.onLine && (Fe() || "chrome-extension:" === ue() || "undefined" !== typeof a.connection) ? a.onLine : 1) ? this.b ? this.c : this.a : Math.min(5E3, this.a);
  };function Ne() {
    var a = l.document;return a && "undefined" !== typeof a.visibilityState ? "visible" == a.visibilityState : !0;
  }
  function Oe() {
    var a = l.document,
        _b = null;return Ne() || !a ? D() : new C(function (c) {
      _b = function b() {
        Ne() && (a.removeEventListener("visibilitychange", _b, !1), c());
      };a.addEventListener("visibilitychange", _b, !1);
    }).s(function (c) {
      a.removeEventListener("visibilitychange", _b, !1);throw c;
    });
  }function Pe(a) {
    try {
      var b = new Date(parseInt(a, 10));if (!isNaN(b.getTime()) && !/[^0-9]/.test(a)) return b.toUTCString();
    } catch (c) {}return null;
  }function Qe() {
    return !(!J("fireauth.oauthhelper", l) && !J("fireauth.iframe", l));
  }
  function Re() {
    var a = l.navigator;return a && a.serviceWorker && a.serviceWorker.controller || null;
  }function Se() {
    var a = l.navigator;return a && a.serviceWorker ? D().then(function () {
      return a.serviceWorker.ready;
    }).then(function (b) {
      return b.active || null;
    }).s(function () {
      return null;
    }) : D(null);
  };var Te = {};function Ue(a) {
    Te[a] || (Te[a] = !0, "undefined" !== typeof console && "function" === typeof console.warn && console.warn(a));
  };var Ve;try {
    var We = {};Object.defineProperty(We, "abcd", { configurable: !0, enumerable: !0, value: 1 });Object.defineProperty(We, "abcd", { configurable: !0, enumerable: !0, value: 2 });Ve = 2 == We.abcd;
  } catch (a) {
    Ve = !1;
  }function K(a, b, c) {
    Ve ? Object.defineProperty(a, b, { configurable: !0, enumerable: !0, value: c }) : a[b] = c;
  }function L(a, b) {
    if (b) for (var c in b) {
      b.hasOwnProperty(c) && K(a, c, b[c]);
    }
  }function Xe(a) {
    var b = {};L(b, a);return b;
  }function Ye(a) {
    var b = {},
        c;for (c in a) {
      a.hasOwnProperty(c) && (b[c] = a[c]);
    }return b;
  }
  function Ze(a, b) {
    if (!b || !b.length) return !0;if (!a) return !1;for (var c = 0; c < b.length; c++) {
      var d = a[b[c]];if (void 0 === d || null === d || "" === d) return !1;
    }return !0;
  }function $e(a) {
    var b = a;if ("object" == typeof a && null != a) {
      b = "length" in a ? [] : {};for (var c in a) {
        K(b, c, $e(a[c]));
      }
    }return b;
  };function af(a) {
    var b = {},
        c = a[bf],
        d = a[cf];a = a[df];if (!a || a != ef && !c) throw Error("Invalid provider user info!");b[ff] = d || null;b[gf] = c || null;K(this, hf, a);K(this, jf, $e(b));
  }var ef = "EMAIL_SIGNIN",
      bf = "email",
      cf = "newEmail",
      df = "requestType",
      gf = "email",
      ff = "fromEmail",
      jf = "data",
      hf = "operation";function M(a, b) {
    this.code = kf + a;this.message = b || lf[a] || "";
  }u(M, Error);M.prototype.w = function () {
    return { code: this.code, message: this.message };
  };M.prototype.toJSON = function () {
    return this.w();
  };function mf(a) {
    var b = a && a.code;return b ? new M(b.substring(kf.length), a.message) : null;
  }
  var kf = "auth/",
      lf = { "admin-restricted-operation": "This operation is restricted to administrators only.", "argument-error": "", "app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.", "app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
    "captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.", "code-expired": "The SMS code has expired. Please re-send the verification code to try again.", "cordova-not-ready": "Cordova framework is not ready.", "cors-unsupported": "This browser is not supported.", "credential-already-in-use": "This credential is already associated with a different user account.", "custom-token-mismatch": "The custom token corresponds to a different audience.",
    "requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.", "dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.", "email-already-in-use": "The email address is already in use by another account.", "expired-action-code": "The action code has expired. ", "cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
    "internal-error": "An internal error has occurred.", "invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.", "invalid-app-id": "The mobile app identifier is not registed for the current project.", "invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.", "invalid-auth-event": "An internal error has occurred.",
    "invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.", "invalid-continue-uri": "The continue URL provided in the request is invalid.", "invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
    "invalid-custom-token": "The custom token format is incorrect. Please check the documentation.", "invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.", "invalid-email": "The email address is badly formatted.", "invalid-api-key": "Your API key is invalid, please check you have copied it correctly.", "invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.", "invalid-credential": "The supplied auth credential is malformed or has expired.",
    "invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.", "invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.", "invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.", "unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
    "invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.", "wrong-password": "The password is invalid or the user does not have a password.", "invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.", "invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
    "invalid-provider-id": "The specified provider ID is invalid.", "invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.", "invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.", "invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.", "missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
    "auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.", "missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.", "missing-verification-code": "The phone auth credential was created with an empty SMS verification code.", "missing-continue-uri": "A continue URL must be provided in the request.", "missing-iframe-start": "An internal error has occurred.",
    "missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.", "missing-or-invalid-nonce": "The OIDC ID token requires a valid unhashed nonce.", "missing-phone-number": "To send verification codes, provide a phone number for the recipient.", "missing-verification-id": "The phone auth credential was created with an empty verification ID.", "app-deleted": "This instance of FirebaseApp has been deleted.", "account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
    "network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.", "no-auth-event": "An internal error has occurred.", "no-such-provider": "User was not linked to an account with the given provider.", "null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.", "operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
    "operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.', "popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.", "popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.", "provider-already-linked": "User can only be linked to one identity for the given provider.",
    "quota-exceeded": "The project's quota for this operation has been exceeded.", "redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.", "redirect-operation-pending": "A redirect sign-in operation is already pending.", "rejected-credential": "The request contains malformed or mismatching credentials.", timeout: "The operation has timed out.", "user-token-expired": "The user's credential is no longer valid. The user must sign in again.", "too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
    "unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.", "unsupported-persistence-type": "The current environment does not support the specified persistence type.", "user-cancelled": "User did not grant your application the permissions it requested.", "user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.", "user-disabled": "The user account has been disabled by an administrator.",
    "user-mismatch": "The supplied credentials do not correspond to the previously signed in user.", "user-signed-out": "", "weak-password": "The password must be 6 characters long or more.", "web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled." };function nf(a) {
    var b = a[of];if ("undefined" === typeof b) throw new M("missing-continue-uri");if ("string" !== typeof b || "string" === typeof b && !b.length) throw new M("invalid-continue-uri");this.h = b;this.b = this.a = null;this.g = !1;var c = a[pf];if (c && "object" === typeof c) {
      b = c[qf];var d = c[rf];c = c[sf];if ("string" === typeof b && b.length) {
        this.a = b;if ("undefined" !== typeof d && "boolean" !== typeof d) throw new M("argument-error", rf + " property must be a boolean when specified.");this.g = !!d;if ("undefined" !== typeof c && ("string" !== typeof c || "string" === typeof c && !c.length)) throw new M("argument-error", sf + " property must be a non empty string when specified.");this.b = c || null;
      } else {
        if ("undefined" !== typeof b) throw new M("argument-error", qf + " property must be a non empty string when specified.");if ("undefined" !== typeof d || "undefined" !== typeof c) throw new M("missing-android-pkg-name");
      }
    } else if ("undefined" !== typeof c) throw new M("argument-error", pf + " property must be a non null object when specified.");this.f = null;if ((b = a[tf]) && "object" === typeof b) {
      if (b = b[uf], "string" === typeof b && b.length) this.f = b;else {
        if ("undefined" !== typeof b) throw new M("argument-error", uf + " property must be a non empty string when specified.");
      }
    } else if ("undefined" !== typeof b) throw new M("argument-error", tf + " property must be a non null object when specified.");b = a[vf];if ("undefined" !== typeof b && "boolean" !== typeof b) throw new M("argument-error", vf + " property must be a boolean when specified.");this.c = !!b;a = a[wf];if ("undefined" !== typeof a && ("string" !== typeof a || "string" === typeof a && !a.length)) throw new M("argument-error", wf + " property must be a non empty string when specified.");this.i = a || null;
  }var pf = "android",
      wf = "dynamicLinkDomain",
      vf = "handleCodeInApp",
      tf = "iOS",
      of = "url",
      rf = "installApp",
      sf = "minimumVersion",
      qf = "packageName",
      uf = "bundleId";
  function xf(a) {
    var b = {};b.continueUrl = a.h;b.canHandleCodeInApp = a.c;if (b.androidPackageName = a.a) b.androidMinimumVersion = a.b, b.androidInstallApp = a.g;b.iOSBundleId = a.f;b.dynamicLinkDomain = a.i;for (var c in b) {
      null === b[c] && delete b[c];
    }return b;
  };function yf(a) {
    return Ia(a, function (b) {
      b = b.toString(16);return 1 < b.length ? b : "0" + b;
    }).join("");
  };var zf = null,
      Af = null;function Bf(a) {
    var b = "";Cf(a, function (c) {
      b += String.fromCharCode(c);
    });return b;
  }function Cf(a, b) {
    function c(m) {
      for (; d < a.length;) {
        var p = a.charAt(d++),
            v = Af[p];if (null != v) return v;if (!/^[\s\xa0]*$/.test(p)) throw Error("Unknown base64 encoding at char: " + p);
      }return m;
    }Df();for (var d = 0;;) {
      var e = c(-1),
          f = c(0),
          g = c(64),
          h = c(64);if (64 === h && -1 === e) break;b(e << 2 | f >> 4);64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
    }
  }
  function Df() {
    if (!zf) {
      zf = {};Af = {};for (var a = 0; 65 > a; a++) {
        zf[a] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a), Af[zf[a]] = a, 62 <= a && (Af["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)] = a);
      }
    }
  };function Ef(a) {
    this.c = a.sub;va();this.a = a.provider_id || a.firebase && a.firebase.sign_in_provider || null;this.b = !!a.is_anonymous || "anonymous" == this.a;
  }Ef.prototype.f = function () {
    return this.b;
  };function Ff(a) {
    return (a = Gf(a)) && a.sub && a.iss && a.aud && a.exp ? new Ef(a) : null;
  }function Gf(a) {
    if (!a) return null;a = a.split(".");if (3 != a.length) return null;a = a[1];for (var b = (4 - a.length % 4) % 4, c = 0; c < b; c++) {
      a += ".";
    }try {
      return JSON.parse(Bf(a));
    } catch (d) {}return null;
  };var Hf = { Yc: { ab: "https://www.googleapis.com/identitytoolkit/v3/relyingparty/", ib: "https://securetoken.googleapis.com/v1/token", id: "p" }, $c: { ab: "https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/", ib: "https://staging-securetoken.sandbox.googleapis.com/v1/token", id: "s" }, ad: { ab: "https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/", ib: "https://test-securetoken.sandbox.googleapis.com/v1/token", id: "t" } };
  function If(a) {
    for (var b in Hf) {
      if (Hf[b].id === a) return a = Hf[b], { firebaseEndpoint: a.ab, secureTokenEndpoint: a.ib };
    }return null;
  }var Jf;Jf = If("__EID__") ? "__EID__" : void 0;var Kf = "oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),
      Lf = ["client_id", "response_type", "scope", "redirect_uri", "state"],
      Mf = { Tc: { Oa: "locale", Ba: 500, Aa: 600, Pa: "facebook.com", hb: Lf }, Vc: { Oa: null, Ba: 500, Aa: 620, Pa: "github.com", hb: Lf }, Wc: { Oa: "hl", Ba: 515, Aa: 680, Pa: "google.com", hb: Lf }, bd: { Oa: "lang", Ba: 485, Aa: 705, Pa: "twitter.com", hb: Kf } };function Nf(a) {
    for (var b in Mf) {
      if (Mf[b].Pa == a) return Mf[b];
    }return null;
  };function Of(a) {
    var b = {};b["facebook.com"] = Pf;b["google.com"] = Qf;b["github.com"] = Rf;b["twitter.com"] = Sf;var c = a && a[Tf];try {
      if (c) return b[c] ? new b[c](a) : new Uf(a);if ("undefined" !== typeof a[Vf]) return new Wf(a);
    } catch (d) {}return null;
  }var Vf = "idToken",
      Tf = "providerId";
  function Wf(a) {
    var b = a[Tf];if (!b && a[Vf]) {
      var c = Ff(a[Vf]);c && c.a && (b = c.a);
    }if (!b) throw Error("Invalid additional user info!");if ("anonymous" == b || "custom" == b) b = null;c = !1;"undefined" !== typeof a.isNewUser ? c = !!a.isNewUser : "identitytoolkit#SignupNewUserResponse" === a.kind && (c = !0);K(this, "providerId", b);K(this, "isNewUser", c);
  }function Uf(a) {
    Wf.call(this, a);a = Je(a.rawUserInfo || "{}");K(this, "profile", $e(a || {}));
  }u(Uf, Wf);
  function Pf(a) {
    Uf.call(this, a);if ("facebook.com" != this.providerId) throw Error("Invalid provider ID!");
  }u(Pf, Uf);function Rf(a) {
    Uf.call(this, a);if ("github.com" != this.providerId) throw Error("Invalid provider ID!");K(this, "username", this.profile && this.profile.login || null);
  }u(Rf, Uf);function Qf(a) {
    Uf.call(this, a);if ("google.com" != this.providerId) throw Error("Invalid provider ID!");
  }u(Qf, Uf);
  function Sf(a) {
    Uf.call(this, a);if ("twitter.com" != this.providerId) throw Error("Invalid provider ID!");K(this, "username", a.screenName || null);
  }u(Sf, Uf);function Xf(a) {
    this.a = md(a);
  };function Yf(a) {
    var b = md(a),
        c = kd(b, "link"),
        d = kd(md(c), "link");b = kd(b, "deep_link_id");return kd(md(b), "link") || b || d || c || a;
  };function Zf() {}function $f(a, b) {
    return a.then(function (c) {
      if (c[ag]) {
        var d = Ff(c[ag]);if (!d || b != d.c) throw new M("user-mismatch");return c;
      }throw new M("user-mismatch");
    }).s(function (c) {
      throw c && c.code && c.code == kf + "user-not-found" ? new M("user-mismatch") : c;
    });
  }function bg(a, b) {
    if (b) this.a = b;else throw new M("internal-error", "failed to construct a credential");K(this, "providerId", a);K(this, "signInMethod", a);
  }bg.prototype.la = function (a) {
    return cg(a, dg(this));
  };
  bg.prototype.b = function (a, b) {
    var c = dg(this);c.idToken = b;return eg(a, c);
  };bg.prototype.f = function (a, b) {
    return $f(fg(a, dg(this)), b);
  };function dg(a) {
    return { pendingToken: a.a, requestUri: "http://localhost" };
  }bg.prototype.w = function () {
    return { providerId: this.providerId, signInMethod: this.signInMethod, pendingToken: this.a };
  };function gg(a) {
    if (a && a.providerId && a.signInMethod && 0 == a.providerId.indexOf("saml.") && a.pendingToken) try {
      return new bg(a.providerId, a.pendingToken);
    } catch (b) {}return null;
  }
  function hg(a, b, c) {
    this.a = null;if (b.idToken || b.accessToken) b.idToken && K(this, "idToken", b.idToken), b.accessToken && K(this, "accessToken", b.accessToken), b.nonce && !b.pendingToken && K(this, "nonce", b.nonce), b.pendingToken && (this.a = b.pendingToken);else if (b.oauthToken && b.oauthTokenSecret) K(this, "accessToken", b.oauthToken), K(this, "secret", b.oauthTokenSecret);else throw new M("internal-error", "failed to construct a credential");K(this, "providerId", a);K(this, "signInMethod", c);
  }
  hg.prototype.la = function (a) {
    return cg(a, ig(this));
  };hg.prototype.b = function (a, b) {
    var c = ig(this);c.idToken = b;return eg(a, c);
  };hg.prototype.f = function (a, b) {
    var c = ig(this);return $f(fg(a, c), b);
  };
  function ig(a) {
    var b = {};a.idToken && (b.id_token = a.idToken);a.accessToken && (b.access_token = a.accessToken);a.secret && (b.oauth_token_secret = a.secret);b.providerId = a.providerId;a.nonce && !a.a && (b.nonce = a.nonce);b = { postBody: qd(b).toString(), requestUri: "http://localhost" };a.a && (delete b.postBody, b.pendingToken = a.a);return b;
  }
  hg.prototype.w = function () {
    var a = { providerId: this.providerId, signInMethod: this.signInMethod };this.idToken && (a.oauthIdToken = this.idToken);this.accessToken && (a.oauthAccessToken = this.accessToken);this.secret && (a.oauthTokenSecret = this.secret);this.nonce && (a.nonce = this.nonce);this.a && (a.pendingToken = this.a);return a;
  };
  function jg(a) {
    if (a && a.providerId && a.signInMethod) {
      var b = { idToken: a.oauthIdToken, accessToken: a.oauthTokenSecret ? null : a.oauthAccessToken, oauthTokenSecret: a.oauthTokenSecret, oauthToken: a.oauthTokenSecret && a.oauthAccessToken, nonce: a.nonce, pendingToken: a.pendingToken };try {
        return new hg(a.providerId, b, a.signInMethod);
      } catch (c) {}
    }return null;
  }function kg(a, b) {
    this.Dc = b || [];L(this, { providerId: a, isOAuthProvider: !0 });this.zb = {};this.cb = (Nf(a) || {}).Oa || null;this.$a = null;
  }
  kg.prototype.Da = function (a) {
    this.zb = db(a);return this;
  };function lg(a) {
    if ("string" !== typeof a || 0 != a.indexOf("saml.")) throw new M("argument-error", 'SAML provider IDs must be prefixed with "saml."');kg.call(this, a, []);
  }u(lg, kg);function N(a) {
    kg.call(this, a, Lf);this.a = [];
  }u(N, kg);N.prototype.ua = function (a) {
    Ma(this.a, a) || this.a.push(a);return this;
  };N.prototype.Fb = function () {
    return Pa(this.a);
  };
  N.prototype.credential = function (a, b) {
    var c;r(a) ? c = { idToken: a.idToken || null, accessToken: a.accessToken || null, nonce: a.rawNonce || null } : c = { idToken: a || null, accessToken: b || null };if (!c.idToken && !c.accessToken) throw new M("argument-error", "credential failed: must provide the ID token and/or the access token.");return new hg(this.providerId, c, this.providerId);
  };function mg() {
    N.call(this, "facebook.com");
  }u(mg, N);K(mg, "PROVIDER_ID", "facebook.com");K(mg, "FACEBOOK_SIGN_IN_METHOD", "facebook.com");
  function ng(a) {
    if (!a) throw new M("argument-error", "credential failed: expected 1 argument (the OAuth access token).");var b = a;r(a) && (b = a.accessToken);return new mg().credential({ accessToken: b });
  }function og() {
    N.call(this, "github.com");
  }u(og, N);K(og, "PROVIDER_ID", "github.com");K(og, "GITHUB_SIGN_IN_METHOD", "github.com");
  function pg(a) {
    if (!a) throw new M("argument-error", "credential failed: expected 1 argument (the OAuth access token).");var b = a;r(a) && (b = a.accessToken);return new og().credential({ accessToken: b });
  }function qg() {
    N.call(this, "google.com");this.ua("profile");
  }u(qg, N);K(qg, "PROVIDER_ID", "google.com");K(qg, "GOOGLE_SIGN_IN_METHOD", "google.com");function rg(a, b) {
    var c = a;r(a) && (c = a.idToken, b = a.accessToken);return new qg().credential({ idToken: c, accessToken: b });
  }function sg() {
    kg.call(this, "twitter.com", Kf);
  }u(sg, kg);
  K(sg, "PROVIDER_ID", "twitter.com");K(sg, "TWITTER_SIGN_IN_METHOD", "twitter.com");function tg(a, b) {
    var c = a;r(c) || (c = { oauthToken: a, oauthTokenSecret: b });if (!c.oauthToken || !c.oauthTokenSecret) throw new M("argument-error", "credential failed: expected 2 arguments (the OAuth access token and secret).");return new hg("twitter.com", c, "twitter.com");
  }
  function ug(a, b, c) {
    this.a = a;this.c = b;K(this, "providerId", "password");K(this, "signInMethod", c === vg.EMAIL_LINK_SIGN_IN_METHOD ? vg.EMAIL_LINK_SIGN_IN_METHOD : vg.EMAIL_PASSWORD_SIGN_IN_METHOD);
  }ug.prototype.la = function (a) {
    return this.signInMethod == vg.EMAIL_LINK_SIGN_IN_METHOD ? O(a, wg, { email: this.a, oobCode: this.c }) : O(a, xg, { email: this.a, password: this.c });
  };
  ug.prototype.b = function (a, b) {
    return this.signInMethod == vg.EMAIL_LINK_SIGN_IN_METHOD ? O(a, yg, { idToken: b, email: this.a, oobCode: this.c }) : O(a, zg, { idToken: b, email: this.a, password: this.c });
  };ug.prototype.f = function (a, b) {
    return $f(this.la(a), b);
  };ug.prototype.w = function () {
    return { email: this.a, password: this.c, signInMethod: this.signInMethod };
  };function Ag(a) {
    return a && a.email && a.password ? new ug(a.email, a.password, a.signInMethod) : null;
  }function vg() {
    L(this, { providerId: "password", isOAuthProvider: !1 });
  }
  function Bg(a, b) {
    b = Cg(b);if (!b) throw new M("argument-error", "Invalid email link!");return new ug(a, b, vg.EMAIL_LINK_SIGN_IN_METHOD);
  }function Cg(a) {
    a = Yf(a);a = new Xf(a);var b = kd(a.a, "oobCode") || null;return "signIn" === (kd(a.a, "mode") || null) && b ? b : null;
  }L(vg, { PROVIDER_ID: "password" });L(vg, { EMAIL_LINK_SIGN_IN_METHOD: "emailLink" });L(vg, { EMAIL_PASSWORD_SIGN_IN_METHOD: "password" });
  function Dg(a) {
    if (!(a.Ta && a.Sa || a.Fa && a.$)) throw new M("internal-error");this.a = a;K(this, "providerId", "phone");K(this, "signInMethod", "phone");
  }Dg.prototype.la = function (a) {
    return a.Ua(Eg(this));
  };Dg.prototype.b = function (a, b) {
    var c = Eg(this);c.idToken = b;return O(a, Fg, c);
  };Dg.prototype.f = function (a, b) {
    var c = Eg(this);c.operation = "REAUTH";a = O(a, Gg, c);return $f(a, b);
  };
  Dg.prototype.w = function () {
    var a = { providerId: "phone" };this.a.Ta && (a.verificationId = this.a.Ta);this.a.Sa && (a.verificationCode = this.a.Sa);this.a.Fa && (a.temporaryProof = this.a.Fa);this.a.$ && (a.phoneNumber = this.a.$);return a;
  };function Hg(a) {
    if (a && "phone" === a.providerId && (a.verificationId && a.verificationCode || a.temporaryProof && a.phoneNumber)) {
      var b = {};x(["verificationId", "verificationCode", "temporaryProof", "phoneNumber"], function (c) {
        a[c] && (b[c] = a[c]);
      });return new Dg(b);
    }return null;
  }
  function Eg(a) {
    return a.a.Fa && a.a.$ ? { temporaryProof: a.a.Fa, phoneNumber: a.a.$ } : { sessionInfo: a.a.Ta, code: a.a.Sa };
  }function Ig(a) {
    try {
      this.a = a || __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.auth();
    } catch (b) {
      throw new M("argument-error", "Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");
    }L(this, { providerId: "phone", isOAuthProvider: !1 });
  }
  Ig.prototype.Ua = function (a, b) {
    var c = this.a.c;return D(b.verify()).then(function (d) {
      if (!n(d)) throw new M("argument-error", "An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch (b.type) {case "recaptcha":
          return Jg(c, { phoneNumber: a, recaptchaToken: d }).then(function (e) {
            "function" === typeof b.reset && b.reset();return e;
          }, function (e) {
            "function" === typeof b.reset && b.reset();throw e;
          });default:
          throw new M("argument-error", 'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}
    });
  };function Kg(a, b) {
    if (!a) throw new M("missing-verification-id");if (!b) throw new M("missing-verification-code");return new Dg({ Ta: a, Sa: b });
  }L(Ig, { PROVIDER_ID: "phone" });L(Ig, { PHONE_SIGN_IN_METHOD: "phone" });
  function Lg(a) {
    if (a.temporaryProof && a.phoneNumber) return new Dg({ Fa: a.temporaryProof, $: a.phoneNumber });var b = a && a.providerId;if (!b || "password" === b) return null;var c = a && a.oauthAccessToken,
        d = a && a.oauthTokenSecret,
        e = a && a.nonce,
        f = a && a.oauthIdToken,
        g = a && a.pendingToken;try {
      switch (b) {case "google.com":
          return rg(f, c);case "facebook.com":
          return ng(c);case "github.com":
          return pg(c);case "twitter.com":
          return tg(c, d);default:
          return c || d || f || g ? g ? 0 == b.indexOf("saml.") ? new bg(b, g) : new hg(b, { pendingToken: g, idToken: a.oauthIdToken,
            accessToken: a.oauthAccessToken }, b) : new N(b).credential({ idToken: f, accessToken: c, rawNonce: e }) : null;}
    } catch (h) {
      return null;
    }
  }function Mg(a) {
    if (!a.isOAuthProvider) throw new M("invalid-oauth-provider");
  };function Ng(a, b, c, d, e, f) {
    this.c = a;this.b = b || null;this.g = c || null;this.f = d || null;this.h = f || null;this.a = e || null;if (this.g || this.a) {
      if (this.g && this.a) throw new M("invalid-auth-event");if (this.g && !this.f) throw new M("invalid-auth-event");
    } else throw new M("invalid-auth-event");
  }Ng.prototype.getUid = function () {
    var a = [];a.push(this.c);this.b && a.push(this.b);this.f && a.push(this.f);this.i && a.push(this.i);return a.join("-");
  };
  Ng.prototype.w = function () {
    return { type: this.c, eventId: this.b, urlResponse: this.g, sessionId: this.f, postBody: this.h, error: this.a && this.a.w() };
  };function Og(a) {
    a = a || {};return a.type ? new Ng(a.type, a.eventId, a.urlResponse, a.sessionId, a.error && mf(a.error), a.postBody) : null;
  }; /*
     Copyright 2018 Google Inc.
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     http://www.apache.org/licenses/LICENSE-2.0
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */
  function Pg() {
    this.b = null;this.a = [];
  }var Qg = null;Pg.prototype.subscribe = function (a) {
    var b = this;this.a.push(a);this.b || (this.b = function (c) {
      for (var d = 0; d < b.a.length; d++) {
        b.a[d](c);
      }
    }, a = J("universalLinks.subscribe", l), "function" === typeof a && a(null, this.b));
  };Pg.prototype.unsubscribe = function (a) {
    y(this.a, function (b) {
      return b == a;
    });
  };function Rg(a) {
    var b = "unauthorized-domain",
        c = void 0,
        d = md(a);a = d.b;d = d.f;"chrome-extension" == d ? c = gb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : "http" == d || "https" == d ? c = gb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.", a) : b = "operation-not-supported-in-this-environment";
    M.call(this, b, c);
  }u(Rg, M);function Sg(a, b, c) {
    M.call(this, a, c);a = b || {};a.Ab && K(this, "email", a.Ab);a.$ && K(this, "phoneNumber", a.$);a.credential && K(this, "credential", a.credential);
  }u(Sg, M);Sg.prototype.w = function () {
    var a = { code: this.code, message: this.message };this.email && (a.email = this.email);this.phoneNumber && (a.phoneNumber = this.phoneNumber);var b = this.credential && this.credential.w();b && fb(a, b);return a;
  };Sg.prototype.toJSON = function () {
    return this.w();
  };
  function Tg(a) {
    if (a.code) {
      var b = a.code || "";0 == b.indexOf(kf) && (b = b.substring(kf.length));var c = { credential: Lg(a) };if (a.email) c.Ab = a.email;else if (a.phoneNumber) c.$ = a.phoneNumber;else if (!c.credential) return new M(b, a.message || void 0);return new Sg(b, c, a.message);
    }return null;
  };function Ug() {}Ug.prototype.c = null;function Vg(a) {
    return a.c || (a.c = a.b());
  };var Wg;function Xg() {}u(Xg, Ug);Xg.prototype.a = function () {
    var a = Yg(this);return a ? new ActiveXObject(a) : new XMLHttpRequest();
  };Xg.prototype.b = function () {
    var a = {};Yg(this) && (a[0] = !0, a[1] = !0);return a;
  };
  function Yg(a) {
    if (!a.f && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
      for (var b = ["MSXML2.XMLHTTP.6.0", "MSXML2.XMLHTTP.3.0", "MSXML2.XMLHTTP", "Microsoft.XMLHTTP"], c = 0; c < b.length; c++) {
        var d = b[c];try {
          return new ActiveXObject(d), a.f = d;
        } catch (e) {}
      }throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }return a.f;
  }Wg = new Xg();function Zg() {}u(Zg, Ug);Zg.prototype.a = function () {
    var a = new XMLHttpRequest();if ("withCredentials" in a) return a;if ("undefined" != typeof XDomainRequest) return new $g();throw Error("Unsupported browser");
  };Zg.prototype.b = function () {
    return {};
  };
  function $g() {
    this.a = new XDomainRequest();this.readyState = 0;this.onreadystatechange = null;this.responseType = this.responseText = this.response = "";this.status = -1;this.statusText = "";this.a.onload = t(this.dc, this);this.a.onerror = t(this.Gb, this);this.a.onprogress = t(this.ec, this);this.a.ontimeout = t(this.ic, this);
  }k = $g.prototype;k.open = function (a, b, c) {
    if (null != c && !c) throw Error("Only async requests are supported.");this.a.open(a, b);
  };
  k.send = function (a) {
    if (a) {
      if ("string" == typeof a) this.a.send(a);else throw Error("Only string data is supported");
    } else this.a.send();
  };k.abort = function () {
    this.a.abort();
  };k.setRequestHeader = function () {};k.getResponseHeader = function (a) {
    return "content-type" == a.toLowerCase() ? this.a.contentType : "";
  };k.dc = function () {
    this.status = 200;this.response = this.responseText = this.a.responseText;ah(this, 4);
  };k.Gb = function () {
    this.status = 500;this.response = this.responseText = "";ah(this, 4);
  };k.ic = function () {
    this.Gb();
  };
  k.ec = function () {
    this.status = 200;ah(this, 1);
  };function ah(a, b) {
    a.readyState = b;if (a.onreadystatechange) a.onreadystatechange();
  }k.getAllResponseHeaders = function () {
    return "content-type: " + this.a.contentType;
  };function bh(a, b, c) {
    this.reset(a, b, c, void 0, void 0);
  }bh.prototype.a = null;var ch = 0;bh.prototype.reset = function (a, b, c, d, e) {
    "number" == typeof e || ch++;d || va();delete this.a;
  };function dh(a) {
    this.f = a;this.b = this.c = this.a = null;
  }function eh(a, b) {
    this.name = a;this.value = b;
  }eh.prototype.toString = function () {
    return this.name;
  };var fh = new eh("SEVERE", 1E3),
      gh = new eh("WARNING", 900),
      hh = new eh("CONFIG", 700),
      ih = new eh("FINE", 500);function jh(a) {
    if (a.c) return a.c;if (a.a) return jh(a.a);ya("Root logger has no level set.");return null;
  }dh.prototype.log = function (a, b, c) {
    if (a.value >= jh(this).value) for (q(b) && (b = b()), a = new bh(a, String(b), this.f), c && (a.a = c), c = this; c;) {
      c = c.a;
    }
  };var kh = {},
      lh = null;
  function mh(a) {
    lh || (lh = new dh(""), kh[""] = lh, lh.c = hh);var b;if (!(b = kh[a])) {
      b = new dh(a);var c = a.lastIndexOf("."),
          d = a.substr(c + 1);c = mh(a.substr(0, c));c.b || (c.b = {});c.b[d] = b;b.a = c;kh[a] = b;
    }return b;
  };function nh(a, b) {
    a && a.log(ih, b, void 0);
  };function oh(a) {
    this.f = a;
  }u(oh, Ug);oh.prototype.a = function () {
    return new ph(this.f);
  };oh.prototype.b = function (a) {
    return function () {
      return a;
    };
  }({});function ph(a) {
    F.call(this);this.u = a;this.readyState = qh;this.status = 0;this.responseType = this.responseText = this.response = this.statusText = "";this.onreadystatechange = null;this.i = new Headers();this.b = null;this.o = "GET";this.g = "";this.a = !1;this.h = mh("goog.net.FetchXmlHttp");this.l = this.c = this.f = null;
  }u(ph, F);var qh = 0;k = ph.prototype;
  k.open = function (a, b) {
    if (this.readyState != qh) throw this.abort(), Error("Error reopening a connection");this.o = a;this.g = b;this.readyState = 1;rh(this);
  };k.send = function (a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");this.a = !0;var b = { headers: this.i, method: this.o, credentials: void 0, cache: void 0 };a && (b.body = a);this.u.fetch(new Request(this.g, b)).then(this.hc.bind(this), this.Ma.bind(this));
  };
  k.abort = function () {
    this.response = this.responseText = "";this.i = new Headers();this.status = 0;this.c && this.c.cancel("Request was aborted.");1 <= this.readyState && this.a && 4 != this.readyState && (this.a = !1, sh(this, !1));this.readyState = qh;
  };
  k.hc = function (a) {
    this.a && (this.f = a, this.b || (this.b = a.headers, this.readyState = 2, rh(this)), this.a && (this.readyState = 3, rh(this), this.a && ("arraybuffer" === this.responseType ? a.arrayBuffer().then(this.fc.bind(this), this.Ma.bind(this)) : "undefined" !== typeof l.ReadableStream && "body" in a ? (this.response = this.responseText = "", this.c = a.body.getReader(), this.l = new TextDecoder(), th(this)) : a.text().then(this.gc.bind(this), this.Ma.bind(this)))));
  };function th(a) {
    a.c.read().then(a.cc.bind(a)).catch(a.Ma.bind(a));
  }
  k.cc = function (a) {
    if (this.a) {
      var b = this.l.decode(a.value ? a.value : new Uint8Array(0), { stream: !a.done });b && (this.response = this.responseText += b);a.done ? sh(this, !0) : rh(this);3 == this.readyState && th(this);
    }
  };k.gc = function (a) {
    this.a && (this.response = this.responseText = a, sh(this, !0));
  };k.fc = function (a) {
    this.a && (this.response = a, sh(this, !0));
  };k.Ma = function (a) {
    var b = this.h;b && b.log(gh, "Failed to fetch url " + this.g, a instanceof Error ? a : Error(a));this.a && sh(this, !0);
  };
  function sh(a, b) {
    b && a.f && (a.status = a.f.status, a.statusText = a.f.statusText);a.readyState = 4;a.f = null;a.c = null;a.l = null;rh(a);
  }k.setRequestHeader = function (a, b) {
    this.i.append(a, b);
  };k.getResponseHeader = function (a) {
    return this.b ? this.b.get(a.toLowerCase()) || "" : ((a = this.h) && a.log(gh, "Attempting to get response header but no headers have been received for url: " + this.g, void 0), "");
  };
  k.getAllResponseHeaders = function () {
    if (!this.b) {
      var a = this.h;a && a.log(gh, "Attempting to get all response headers but no headers have been received for url: " + this.g, void 0);return "";
    }a = [];for (var b = this.b.entries(), c = b.next(); !c.done;) {
      c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    }return a.join("\r\n");
  };function rh(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
  };function uh(a) {
    F.call(this);this.headers = new Sc();this.D = a || null;this.c = !1;this.A = this.a = null;this.h = this.N = this.l = "";this.f = this.I = this.i = this.G = !1;this.g = 0;this.u = null;this.o = vh;this.v = this.O = !1;
  }u(uh, F);var vh = "";uh.prototype.b = mh("goog.net.XhrIo");var wh = /^https?$/i,
      xh = ["POST", "PUT"];
  function yh(a, b, c, d, e) {
    if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.l + "; newUri=" + b);c = c ? c.toUpperCase() : "GET";a.l = b;a.h = "";a.N = c;a.G = !1;a.c = !0;a.a = a.D ? a.D.a() : Wg.a();a.A = a.D ? Vg(a.D) : Vg(Wg);a.a.onreadystatechange = t(a.Jb, a);try {
      nh(a.b, zh(a, "Opening Xhr")), a.I = !0, a.a.open(c, String(b), !0), a.I = !1;
    } catch (g) {
      nh(a.b, zh(a, "Error opening Xhr: " + g.message));Ah(a, g);return;
    }b = d || "";var f = new Sc(a.headers);e && Rc(e, function (g, h) {
      f.set(h, g);
    });e = Ka(f.U());d = l.FormData && b instanceof l.FormData;!Ma(xh, c) || e || d || f.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");f.forEach(function (g, h) {
      this.a.setRequestHeader(h, g);
    }, a);a.o && (a.a.responseType = a.o);"withCredentials" in a.a && a.a.withCredentials !== a.O && (a.a.withCredentials = a.O);try {
      Bh(a), 0 < a.g && (a.v = Ch(a.a), nh(a.b, zh(a, "Will abort after " + a.g + "ms if incomplete, xhr2 " + a.v)), a.v ? (a.a.timeout = a.g, a.a.ontimeout = t(a.Ga, a)) : a.u = Nc(a.Ga, a.g, a)), nh(a.b, zh(a, "Sending request")), a.i = !0, a.a.send(b), a.i = !1;
    } catch (g) {
      nh(a.b, zh(a, "Send error: " + g.message)), Ah(a, g);
    }
  }function Ch(a) {
    return Ub && dc(9) && "number" == typeof a.timeout && void 0 !== a.ontimeout;
  }function La(a) {
    return "content-type" == a.toLowerCase();
  }k = uh.prototype;k.Ga = function () {
    "undefined" != typeof fa && this.a && (this.h = "Timed out after " + this.g + "ms, aborting", nh(this.b, zh(this, this.h)), this.dispatchEvent("timeout"), this.abort(8));
  };function Ah(a, b) {
    a.c = !1;a.a && (a.f = !0, a.a.abort(), a.f = !1);a.h = b;Dh(a);Eh(a);
  }
  function Dh(a) {
    a.G || (a.G = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
  }k.abort = function () {
    this.a && this.c && (nh(this.b, zh(this, "Aborting")), this.c = !1, this.f = !0, this.a.abort(), this.f = !1, this.dispatchEvent("complete"), this.dispatchEvent("abort"), Eh(this));
  };k.va = function () {
    this.a && (this.c && (this.c = !1, this.f = !0, this.a.abort(), this.f = !1), Eh(this, !0));uh.qb.va.call(this);
  };k.Jb = function () {
    this.qa || (this.I || this.i || this.f ? Fh(this) : this.wc());
  };k.wc = function () {
    Fh(this);
  };
  function Fh(a) {
    if (a.c && "undefined" != typeof fa) if (a.A[1] && 4 == Gh(a) && 2 == Hh(a)) nh(a.b, zh(a, "Local request error detected and ignored"));else if (a.i && 4 == Gh(a)) Nc(a.Jb, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == Gh(a)) {
      nh(a.b, zh(a, "Request complete"));a.c = !1;try {
        var b = Hh(a);a: switch (b) {case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
            var c = !0;break a;default:
            c = !1;}var d;if (!(d = c)) {
          var e;if (e = 0 === b) {
            var f = String(a.l).match(Vc)[1] || null;if (!f && l.self && l.self.location) {
              var g = l.self.location.protocol;
              f = g.substr(0, g.length - 1);
            }e = !wh.test(f ? f.toLowerCase() : "");
          }d = e;
        }if (d) a.dispatchEvent("complete"), a.dispatchEvent("success");else {
          try {
            var h = 2 < Gh(a) ? a.a.statusText : "";
          } catch (m) {
            nh(a.b, "Can not get status: " + m.message), h = "";
          }a.h = h + " [" + Hh(a) + "]";Dh(a);
        }
      } finally {
        Eh(a);
      }
    }
  }function Eh(a, b) {
    if (a.a) {
      Bh(a);var c = a.a,
          d = a.A[0] ? ka : null;a.a = null;a.A = null;b || a.dispatchEvent("ready");try {
        c.onreadystatechange = d;
      } catch (e) {
        (a = a.b) && a.log(fh, "Problem encountered resetting onreadystatechange: " + e.message, void 0);
      }
    }
  }
  function Bh(a) {
    a.a && a.v && (a.a.ontimeout = null);a.u && (l.clearTimeout(a.u), a.u = null);
  }function Gh(a) {
    return a.a ? a.a.readyState : 0;
  }function Hh(a) {
    try {
      return 2 < Gh(a) ? a.a.status : -1;
    } catch (b) {
      return -1;
    }
  }function Ih(a) {
    try {
      return a.a ? a.a.responseText : "";
    } catch (b) {
      return nh(a.b, "Can not get responseText: " + b.message), "";
    }
  }
  k.getResponse = function () {
    try {
      if (!this.a) return null;if ("response" in this.a) return this.a.response;switch (this.o) {case vh:case "text":
          return this.a.responseText;case "arraybuffer":
          if ("mozResponseArrayBuffer" in this.a) return this.a.mozResponseArrayBuffer;}var a = this.b;a && a.log(fh, "Response type " + this.o + " is not supported on this browser", void 0);return null;
    } catch (b) {
      return nh(this.b, "Can not get response: " + b.message), null;
    }
  };function zh(a, b) {
    return b + " [" + a.N + " " + a.l + " " + Hh(a) + "]";
  }; /*
     Portions of this code are from MochiKit, received by
     The Closure Authors under the MIT license. All other code is Copyright
     2005-2009 The Closure Authors. All Rights Reserved.
     */
  function Jh(a) {
    var b = Kh;this.g = [];this.v = b;this.u = a || null;this.f = this.a = !1;this.c = void 0;this.l = this.A = this.i = !1;this.h = 0;this.b = null;this.m = 0;
  }Jh.prototype.cancel = function (a) {
    if (this.a) this.c instanceof Jh && this.c.cancel();else {
      if (this.b) {
        var b = this.b;delete this.b;a ? b.cancel(a) : (b.m--, 0 >= b.m && b.cancel());
      }this.v ? this.v.call(this.u, this) : this.l = !0;this.a || (a = new Lh(this), Mh(this), Nh(this, !1, a));
    }
  };Jh.prototype.o = function (a, b) {
    this.i = !1;Nh(this, a, b);
  };function Nh(a, b, c) {
    a.a = !0;a.c = c;a.f = !b;Oh(a);
  }
  function Mh(a) {
    if (a.a) {
      if (!a.l) throw new Ph(a);a.l = !1;
    }
  }function Qh(a, b) {
    Rh(a, null, b, void 0);
  }function Rh(a, b, c, d) {
    a.g.push([b, c, d]);a.a && Oh(a);
  }Jh.prototype.then = function (a, b, c) {
    var d,
        e,
        f = new C(function (g, h) {
      d = g;e = h;
    });Rh(this, d, function (g) {
      g instanceof Lh ? f.cancel() : e(g);
    });return f.then(a, b, c);
  };Jh.prototype.$goog_Thenable = !0;function Sh(a) {
    return Ja(a.g, function (b) {
      return q(b[1]);
    });
  }
  function Oh(a) {
    if (a.h && a.a && Sh(a)) {
      var b = a.h,
          c = Th[b];c && (l.clearTimeout(c.a), delete Th[b]);a.h = 0;
    }a.b && (a.b.m--, delete a.b);b = a.c;for (var d = c = !1; a.g.length && !a.i;) {
      var e = a.g.shift(),
          f = e[0],
          g = e[1];e = e[2];if (f = a.f ? g : f) try {
        var h = f.call(e || a.u, b);void 0 !== h && (a.f = a.f && (h == b || h instanceof Error), a.c = b = h);if (wa(b) || "function" === typeof l.Promise && b instanceof l.Promise) d = !0, a.i = !0;
      } catch (m) {
        b = m, a.f = !0, Sh(a) || (c = !0);
      }
    }a.c = b;d && (h = t(a.o, a, !0), d = t(a.o, a, !1), b instanceof Jh ? (Rh(b, h, d), b.A = !0) : b.then(h, d));c && (b = new Uh(b), Th[b.a] = b, a.h = b.a);
  }function Ph() {
    w.call(this);
  }u(Ph, w);Ph.prototype.message = "Deferred has already fired";Ph.prototype.name = "AlreadyCalledError";function Lh() {
    w.call(this);
  }u(Lh, w);Lh.prototype.message = "Deferred was canceled";Lh.prototype.name = "CanceledError";function Uh(a) {
    this.a = l.setTimeout(t(this.c, this), 0);this.b = a;
  }Uh.prototype.c = function () {
    delete Th[this.a];throw this.b;
  };var Th = {};function Vh(a) {
    var b = {},
        c = b.document || document,
        d = Cd(a).toString(),
        e = document.createElement("SCRIPT"),
        f = { Lb: e, Ga: void 0 },
        g = new Jh(f),
        h = null,
        m = null != b.timeout ? b.timeout : 5E3;0 < m && (h = window.setTimeout(function () {
      Wh(e, !0);var p = new Xh(Yh, "Timeout reached for loading script " + d);Mh(g);Nh(g, !1, p);
    }, m), f.Ga = h);e.onload = e.onreadystatechange = function () {
      e.readyState && "loaded" != e.readyState && "complete" != e.readyState || (Wh(e, b.dd || !1, h), Mh(g), Nh(g, !0, null));
    };e.onerror = function () {
      Wh(e, !0, h);var p = new Xh(Zh, "Error while loading script " + d);Mh(g);Nh(g, !1, p);
    };f = b.attributes || {};fb(f, { type: "text/javascript", charset: "UTF-8" });Td(e, f);Rd(e, a);$h(c).appendChild(e);return g;
  }function $h(a) {
    var b;return (b = (a || document).getElementsByTagName("HEAD")) && 0 != b.length ? b[0] : a.documentElement;
  }function Kh() {
    if (this && this.Lb) {
      var a = this.Lb;a && "SCRIPT" == a.tagName && Wh(a, !0, this.Ga);
    }
  }
  function Wh(a, b, c) {
    null != c && l.clearTimeout(c);a.onload = ka;a.onerror = ka;a.onreadystatechange = ka;b && window.setTimeout(function () {
      a && a.parentNode && a.parentNode.removeChild(a);
    }, 0);
  }var Zh = 0,
      Yh = 1;function Xh(a, b) {
    var c = "Jsloader error (code #" + a + ")";b && (c += ": " + b);w.call(this, c);this.code = a;
  }u(Xh, w);function ai(a) {
    this.f = a;
  }u(ai, Ug);ai.prototype.a = function () {
    return new this.f();
  };ai.prototype.b = function () {
    return {};
  };
  function bi(a, b, c) {
    this.b = a;a = b || {};this.i = a.secureTokenEndpoint || "https://securetoken.googleapis.com/v1/token";this.m = a.secureTokenTimeout || ci;this.f = db(a.secureTokenHeaders || di);this.g = a.firebaseEndpoint || "https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h = a.firebaseTimeout || ei;this.a = db(a.firebaseHeaders || fi);c && (this.a["X-Client-Version"] = c, this.f["X-Client-Version"] = c);c = "Node" == xe();c = l.XMLHttpRequest || c && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.XMLHttpRequest;if (!c && !we()) throw new M("internal-error", "The XMLHttpRequest compatibility library was not found.");this.c = void 0;we() ? this.c = new oh(self) : ye() ? this.c = new ai(c) : this.c = new Zg();
  }var gi,
      ag = "idToken",
      ci = new Me(3E4, 6E4),
      di = { "Content-Type": "application/x-www-form-urlencoded" },
      ei = new Me(3E4, 6E4),
      fi = { "Content-Type": "application/json" };function hi(a, b) {
    b ? a.a["X-Firebase-Locale"] = b : delete a.a["X-Firebase-Locale"];
  }
  function ii(a, b) {
    b ? (a.a["X-Client-Version"] = b, a.f["X-Client-Version"] = b) : (delete a.a["X-Client-Version"], delete a.f["X-Client-Version"]);
  }function ji(a, b, c, d, e, f, g) {
    he() || we() ? a = t(a.o, a) : (gi || (gi = new C(function (h, m) {
      ki(h, m);
    })), a = t(a.l, a));a(b, c, d, e, f, g);
  }
  bi.prototype.o = function (a, b, c, d, e, f) {
    if (we() && ("undefined" === typeof l.fetch || "undefined" === typeof l.Headers || "undefined" === typeof l.Request)) throw new M("operation-not-supported-in-this-environment", "fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g = new uh(this.c);if (f) {
      g.g = Math.max(0, f);var h = setTimeout(function () {
        g.dispatchEvent("timeout");
      }, f);
    }Ac(g, "complete", function () {
      h && clearTimeout(h);var m = null;try {
        m = JSON.parse(Ih(this)) || null;
      } catch (p) {
        m = null;
      }b && b(m);
    });Gc(g, "ready", function () {
      h && clearTimeout(h);Pb(this);
    });Gc(g, "timeout", function () {
      h && clearTimeout(h);Pb(this);b && b(null);
    });yh(g, a, c, d, e);
  };var li = new wd(xd, "https://apis.google.com/js/client.js?onload=%{onload}"),
      mi = "__fcb" + Math.floor(1E6 * Math.random()).toString();
  function ki(a, b) {
    if (((window.gapi || {}).client || {}).request) a();else {
      l[mi] = function () {
        ((window.gapi || {}).client || {}).request ? a() : b(Error("CORS_UNSUPPORTED"));
      };var c = Dd(li, { onload: mi });Qh(Vh(c), function () {
        b(Error("CORS_UNSUPPORTED"));
      });
    }
  }
  bi.prototype.l = function (a, b, c, d, e) {
    var f = this;gi.then(function () {
      window.gapi.client.setApiKey(f.b);var g = window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({ path: a, method: c, body: d, headers: e, authType: "none", callback: function callback(h) {
          window.gapi.auth.setToken(g);b && b(h);
        } });
    }).s(function (g) {
      b && b({ error: { message: g && g.message || "CORS_UNSUPPORTED" } });
    });
  };
  function ni(a, b) {
    return new C(function (c, d) {
      "refresh_token" == b.grant_type && b.refresh_token || "authorization_code" == b.grant_type && b.code ? ji(a, a.i + "?key=" + encodeURIComponent(a.b), function (e) {
        e ? e.error ? d(oi(e)) : e.access_token && e.refresh_token ? c(e) : d(new M("internal-error")) : d(new M("network-request-failed"));
      }, "POST", qd(b).toString(), a.f, a.m.get()) : d(new M("internal-error"));
    });
  }
  function pi(a, b, c, d, e, f) {
    var g = md(a.g + b);G(g, "key", a.b);f && G(g, "cb", va().toString());var h = "GET" == c;if (h) for (var m in d) {
      d.hasOwnProperty(m) && G(g, m, d[m]);
    }return new C(function (p, v) {
      ji(a, g.toString(), function (z) {
        z ? z.error ? v(oi(z, e || {})) : p(z) : v(new M("network-request-failed"));
      }, c, h ? void 0 : Yd(Ie(d)), a.a, a.h.get());
    });
  }function qi(a) {
    a = a.email;if (!n(a) || !qe.test(a)) throw new M("invalid-email");
  }function ri(a) {
    "email" in a && qi(a);
  }
  function si(a, b) {
    return O(a, ti, { identifier: b, continueUri: Fe() ? ee() : "http://localhost" }).then(function (c) {
      return c.signinMethods || [];
    });
  }function ui(a) {
    return O(a, vi, {}).then(function (b) {
      return b.authorizedDomains || [];
    });
  }function wi(a) {
    if (!a[ag]) throw new M("internal-error");
  }
  function xi(a) {
    if (a.phoneNumber || a.temporaryProof) {
      if (!a.phoneNumber || !a.temporaryProof) throw new M("internal-error");
    } else {
      if (!a.sessionInfo) throw new M("missing-verification-id");if (!a.code) throw new M("missing-verification-code");
    }
  }bi.prototype.ob = function () {
    return O(this, yi, {});
  };bi.prototype.rb = function (a, b) {
    return O(this, zi, { idToken: a, email: b });
  };bi.prototype.sb = function (a, b) {
    return O(this, zg, { idToken: a, password: b });
  };var Ai = { displayName: "DISPLAY_NAME", photoUrl: "PHOTO_URL" };k = bi.prototype;
  k.tb = function (a, b) {
    var c = { idToken: a },
        d = [];bb(Ai, function (e, f) {
      var g = b[f];null === g ? d.push(e) : f in b && (c[f] = g);
    });d.length && (c.deleteAttribute = d);return O(this, zi, c);
  };k.kb = function (a, b) {
    a = { requestType: "PASSWORD_RESET", email: a };fb(a, b);return O(this, Bi, a);
  };k.lb = function (a, b) {
    a = { requestType: "EMAIL_SIGNIN", email: a };fb(a, b);return O(this, Ci, a);
  };k.jb = function (a, b) {
    a = { requestType: "VERIFY_EMAIL", idToken: a };fb(a, b);return O(this, Di, a);
  };function Jg(a, b) {
    return O(a, Ei, b);
  }k.Ua = function (a) {
    return O(this, Fi, a);
  };
  function Gi(a, b, c) {
    return O(a, Hi, { idToken: b, deleteProvider: c });
  }function Ii(a) {
    if (!a.requestUri || !a.sessionId && !a.postBody && !a.pendingToken) throw new M("internal-error");
  }function Ji(a, b) {
    b.oauthIdToken && b.providerId && 0 == b.providerId.indexOf("oidc.") && !b.pendingToken && (a.sessionId ? b.nonce = a.sessionId : a.postBody && (a = new cd(a.postBody), ud(a, "nonce") && (b.nonce = a.get("nonce"))));return b;
  }
  function Ki(a) {
    var b = null;a.needConfirmation ? (a.code = "account-exists-with-different-credential", b = Tg(a)) : "FEDERATED_USER_ID_ALREADY_LINKED" == a.errorMessage ? (a.code = "credential-already-in-use", b = Tg(a)) : "EMAIL_EXISTS" == a.errorMessage ? (a.code = "email-already-in-use", b = Tg(a)) : a.errorMessage && (b = Li(a.errorMessage));if (b) throw b;if (!a[ag]) throw new M("internal-error");
  }function cg(a, b) {
    b.returnIdpCredential = !0;return O(a, Mi, b);
  }function eg(a, b) {
    b.returnIdpCredential = !0;return O(a, Ni, b);
  }
  function fg(a, b) {
    b.returnIdpCredential = !0;b.autoCreate = !1;return O(a, Oi, b);
  }function Pi(a) {
    if (!a.oobCode) throw new M("invalid-action-code");
  }k.Za = function (a, b) {
    return O(this, Qi, { oobCode: a, newPassword: b });
  };k.Ka = function (a) {
    return O(this, Ri, { oobCode: a });
  };k.Wa = function (a) {
    return O(this, Si, { oobCode: a });
  };
  var Si = { endpoint: "setAccountInfo", C: Pi, da: "email" },
      Ri = { endpoint: "resetPassword", C: Pi, J: function J(a) {
      var b = a.requestType;if (!b || !a.email && "EMAIL_SIGNIN" != b) throw new M("internal-error");
    } },
      Ti = { endpoint: "signupNewUser", C: function C(a) {
      qi(a);if (!a.password) throw new M("weak-password");
    }, J: wi, R: !0 },
      ti = { endpoint: "createAuthUri" },
      Ui = { endpoint: "deleteAccount", T: ["idToken"] },
      Hi = { endpoint: "setAccountInfo", T: ["idToken", "deleteProvider"], C: function C(a) {
      if (!na(a.deleteProvider)) throw new M("internal-error");
    } },
      wg = { endpoint: "emailLinkSignin", T: ["email", "oobCode"], C: qi, J: wi, R: !0 },
      yg = { endpoint: "emailLinkSignin", T: ["idToken", "email", "oobCode"], C: qi, J: wi, R: !0 },
      Vi = { endpoint: "getAccountInfo" },
      Ci = { endpoint: "getOobConfirmationCode", T: ["requestType"], C: function C(a) {
      if ("EMAIL_SIGNIN" != a.requestType) throw new M("internal-error");qi(a);
    }, da: "email" },
      Di = { endpoint: "getOobConfirmationCode", T: ["idToken", "requestType"], C: function C(a) {
      if ("VERIFY_EMAIL" != a.requestType) throw new M("internal-error");
    }, da: "email" },
      Bi = { endpoint: "getOobConfirmationCode",
    T: ["requestType"], C: function C(a) {
      if ("PASSWORD_RESET" != a.requestType) throw new M("internal-error");qi(a);
    }, da: "email" },
      vi = { wb: !0, endpoint: "getProjectConfig", Ib: "GET" },
      Wi = { wb: !0, endpoint: "getRecaptchaParam", Ib: "GET", J: function J(a) {
      if (!a.recaptchaSiteKey) throw new M("internal-error");
    } },
      Qi = { endpoint: "resetPassword", C: Pi, da: "email" },
      Ei = { endpoint: "sendVerificationCode", T: ["phoneNumber", "recaptchaToken"], da: "sessionInfo" },
      zi = { endpoint: "setAccountInfo", T: ["idToken"], C: ri, R: !0 },
      zg = { endpoint: "setAccountInfo",
    T: ["idToken"], C: function C(a) {
      ri(a);if (!a.password) throw new M("weak-password");
    }, J: wi, R: !0 },
      yi = { endpoint: "signupNewUser", J: wi, R: !0 },
      Mi = { endpoint: "verifyAssertion", C: Ii, Qa: Ji, J: Ki, R: !0 },
      Oi = { endpoint: "verifyAssertion", C: Ii, Qa: Ji, J: function J(a) {
      if (a.errorMessage && "USER_NOT_FOUND" == a.errorMessage) throw new M("user-not-found");if (a.errorMessage) throw Li(a.errorMessage);if (!a[ag]) throw new M("internal-error");
    }, R: !0 },
      Ni = { endpoint: "verifyAssertion", C: function C(a) {
      Ii(a);if (!a.idToken) throw new M("internal-error");
    }, Qa: Ji, J: Ki, R: !0 },
      Xi = { endpoint: "verifyCustomToken", C: function C(a) {
      if (!a.token) throw new M("invalid-custom-token");
    }, J: wi, R: !0 },
      xg = { endpoint: "verifyPassword", C: function C(a) {
      qi(a);if (!a.password) throw new M("wrong-password");
    }, J: wi, R: !0 },
      Fi = { endpoint: "verifyPhoneNumber", C: xi, J: wi },
      Fg = { endpoint: "verifyPhoneNumber", C: function C(a) {
      if (!a.idToken) throw new M("internal-error");xi(a);
    }, J: function J(a) {
      if (a.temporaryProof) throw a.code = "credential-already-in-use", Tg(a);wi(a);
    } },
      Gg = { Wb: { USER_NOT_FOUND: "user-not-found" },
    endpoint: "verifyPhoneNumber", C: xi, J: wi };function O(a, b, c) {
    if (!Ze(c, b.T)) return E(new M("internal-error"));var d = b.Ib || "POST",
        e;return D(c).then(b.C).then(function () {
      b.R && (c.returnSecureToken = !0);return pi(a, b.endpoint, d, c, b.Wb, b.wb || !1);
    }).then(function (f) {
      e = f;return b.Qa ? b.Qa(c, e) : e;
    }).then(b.J).then(function () {
      if (!b.da) return e;if (!(b.da in e)) throw new M("internal-error");return e[b.da];
    });
  }function Li(a) {
    return oi({ error: { errors: [{ message: a }], code: 400, message: a } });
  }
  function oi(a, b) {
    var c = (a.error && a.error.errors && a.error.errors[0] || {}).reason || "";var d = { keyInvalid: "invalid-api-key", ipRefererBlocked: "app-not-authorized" };if (c = d[c] ? new M(d[c]) : null) return c;c = a.error && a.error.message || "";d = { INVALID_CUSTOM_TOKEN: "invalid-custom-token", CREDENTIAL_MISMATCH: "custom-token-mismatch", MISSING_CUSTOM_TOKEN: "internal-error", INVALID_IDENTIFIER: "invalid-email", MISSING_CONTINUE_URI: "internal-error", INVALID_EMAIL: "invalid-email", INVALID_PASSWORD: "wrong-password", USER_DISABLED: "user-disabled",
      MISSING_PASSWORD: "internal-error", EMAIL_EXISTS: "email-already-in-use", PASSWORD_LOGIN_DISABLED: "operation-not-allowed", INVALID_IDP_RESPONSE: "invalid-credential", INVALID_PENDING_TOKEN: "invalid-credential", FEDERATED_USER_ID_ALREADY_LINKED: "credential-already-in-use", MISSING_OR_INVALID_NONCE: "missing-or-invalid-nonce", INVALID_MESSAGE_PAYLOAD: "invalid-message-payload", INVALID_RECIPIENT_EMAIL: "invalid-recipient-email", INVALID_SENDER: "invalid-sender", EMAIL_NOT_FOUND: "user-not-found", RESET_PASSWORD_EXCEED_LIMIT: "too-many-requests",
      EXPIRED_OOB_CODE: "expired-action-code", INVALID_OOB_CODE: "invalid-action-code", MISSING_OOB_CODE: "internal-error", INVALID_PROVIDER_ID: "invalid-provider-id", CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "requires-recent-login", INVALID_ID_TOKEN: "invalid-user-token", TOKEN_EXPIRED: "user-token-expired", USER_NOT_FOUND: "user-token-expired", CORS_UNSUPPORTED: "cors-unsupported", DYNAMIC_LINK_NOT_ACTIVATED: "dynamic-link-not-activated", INVALID_APP_ID: "invalid-app-id", TOO_MANY_ATTEMPTS_TRY_LATER: "too-many-requests", WEAK_PASSWORD: "weak-password",
      OPERATION_NOT_ALLOWED: "operation-not-allowed", USER_CANCELLED: "user-cancelled", CAPTCHA_CHECK_FAILED: "captcha-check-failed", INVALID_APP_CREDENTIAL: "invalid-app-credential", INVALID_CODE: "invalid-verification-code", INVALID_PHONE_NUMBER: "invalid-phone-number", INVALID_SESSION_INFO: "invalid-verification-id", INVALID_TEMPORARY_PROOF: "invalid-credential", MISSING_APP_CREDENTIAL: "missing-app-credential", MISSING_CODE: "missing-verification-code", MISSING_PHONE_NUMBER: "missing-phone-number", MISSING_SESSION_INFO: "missing-verification-id",
      QUOTA_EXCEEDED: "quota-exceeded", SESSION_EXPIRED: "code-expired", REJECTED_CREDENTIAL: "rejected-credential", INVALID_CONTINUE_URI: "invalid-continue-uri", MISSING_ANDROID_PACKAGE_NAME: "missing-android-pkg-name", MISSING_IOS_BUNDLE_ID: "missing-ios-bundle-id", UNAUTHORIZED_DOMAIN: "unauthorized-continue-uri", INVALID_DYNAMIC_LINK_DOMAIN: "invalid-dynamic-link-domain", INVALID_OAUTH_CLIENT_ID: "invalid-oauth-client-id", INVALID_CERT_HASH: "invalid-cert-hash", ADMIN_ONLY_OPERATION: "admin-restricted-operation" };fb(d, b || {});b = (b = c.match(/^[^\s]+\s*:\s*(.*)$/)) && 1 < b.length ? b[1] : void 0;for (var e in d) {
      if (0 === c.indexOf(e)) return new M(d[e], b);
    }!b && a && (b = He(a));return new M("internal-error", b);
  };function Yi(a) {
    this.b = a;this.a = null;this.fb = Zi(this);
  }
  function Zi(a) {
    return $i().then(function () {
      return new C(function (b, c) {
        J("gapi.iframes.getContext")().open({ where: document.body, url: a.b, messageHandlersFilter: J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"), attributes: { style: { position: "absolute", top: "-100px", width: "1px", height: "1px" } }, dontclear: !0 }, function (d) {
          function e() {
            clearTimeout(f);b();
          }a.a = d;a.a.restyle({ setHideOnLeave: !1 });var f = setTimeout(function () {
            c(Error("Network Error"));
          }, aj.get());d.ping(e).then(e, function () {
            c(Error("Network Error"));
          });
        });
      });
    });
  }
  function bj(a, b) {
    return a.fb.then(function () {
      return new C(function (c) {
        a.a.send(b.type, b, c, J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
      });
    });
  }function cj(a, b) {
    a.fb.then(function () {
      a.a.register("authEvent", b, J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"));
    });
  }var dj = new wd(xd, "https://apis.google.com/js/api.js?onload=%{onload}"),
      ej = new Me(3E4, 6E4),
      aj = new Me(5E3, 15E3),
      fj = null;
  function $i() {
    return fj ? fj : fj = new C(function (a, b) {
      function c() {
        Le();J("gapi.load")("gapi.iframes", { callback: a, ontimeout: function ontimeout() {
            Le();b(Error("Network Error"));
          }, timeout: ej.get() });
      }if (J("gapi.iframes.Iframe")) a();else if (J("gapi.load")) c();else {
        var d = "__iframefcb" + Math.floor(1E6 * Math.random()).toString();l[d] = function () {
          J("gapi.load") ? c() : b(Error("Network Error"));
        };d = Dd(dj, { onload: d });D(Vh(d)).s(function () {
          b(Error("Network Error"));
        });
      }
    }).s(function (a) {
      fj = null;throw a;
    });
  };function gj(a, b, c) {
    this.i = a;this.g = b;this.h = c;this.f = null;this.a = nd(this.i, "/__/auth/iframe");G(this.a, "apiKey", this.g);G(this.a, "appName", this.h);this.b = null;this.c = [];
  }gj.prototype.toString = function () {
    this.f ? G(this.a, "v", this.f) : td(this.a.a, "v");this.b ? G(this.a, "eid", this.b) : td(this.a.a, "eid");this.c.length ? G(this.a, "fw", this.c.join(",")) : td(this.a.a, "fw");return this.a.toString();
  };function hj(a, b, c, d, e) {
    this.o = a;this.l = b;this.c = c;this.m = d;this.h = this.g = this.i = null;this.a = e;this.f = null;
  }
  hj.prototype.toString = function () {
    var a = nd(this.o, "/__/auth/handler");G(a, "apiKey", this.l);G(a, "appName", this.c);G(a, "authType", this.m);if (this.a.isOAuthProvider) {
      var b = this.a;try {
        var c = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(this.c).auth().ea();
      } catch (h) {
        c = null;
      }b.$a = c;G(a, "providerId", this.a.providerId);b = this.a;c = Ie(b.zb);for (var d in c) {
        c[d] = c[d].toString();
      }d = b.Dc;c = db(c);for (var e = 0; e < d.length; e++) {
        var f = d[e];f in c && delete c[f];
      }b.cb && b.$a && !c[b.cb] && (c[b.cb] = b.$a);cb(c) || G(a, "customParameters", He(c));
    }"function" === typeof this.a.Fb && (b = this.a.Fb(), b.length && G(a, "scopes", b.join(",")));this.i ? G(a, "redirectUrl", this.i) : td(a.a, "redirectUrl");this.g ? G(a, "eventId", this.g) : td(a.a, "eventId");this.h ? G(a, "v", this.h) : td(a.a, "v");if (this.b) for (var g in this.b) {
      this.b.hasOwnProperty(g) && !kd(a, g) && G(a, g, this.b[g]);
    }this.f ? G(a, "eid", this.f) : td(a.a, "eid");g = ij(this.c);g.length && G(a, "fw", g.join(","));return a.toString();
  };function ij(a) {
    try {
      return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a).auth().ya();
    } catch (b) {
      return [];
    }
  }
  function jj(a, b, c, d, e) {
    this.l = a;this.f = b;this.b = c;this.c = d || null;this.h = e || null;this.o = this.u = this.v = null;this.g = [];this.m = this.a = null;
  }
  function kj(a) {
    var b = ee();return ui(a).then(function (c) {
      a: {
        var d = md(b),
            e = d.f;d = d.b;for (var f = 0; f < c.length; f++) {
          var g = c[f];var h = d;var m = e;0 == g.indexOf("chrome-extension://") ? h = md(g).b == h && "chrome-extension" == m : "http" != m && "https" != m ? h = !1 : pe.test(g) ? h = h == g : (g = g.split(".").join("\\."), h = new RegExp("^(.+\\." + g + "|" + g + ")$", "i").test(h));if (h) {
            c = !0;break a;
          }
        }c = !1;
      }if (!c) throw new Rg(ee());
    });
  }
  function lj(a) {
    if (a.m) return a.m;a.m = re().then(function () {
      if (!a.u) {
        var b = a.c,
            c = a.h,
            d = ij(a.b),
            e = new gj(a.l, a.f, a.b);e.f = b;e.b = c;e.c = Pa(d || []);a.u = e.toString();
      }a.i = new Yi(a.u);mj(a);
    });return a.m;
  }k = jj.prototype;k.Ea = function (a, b, c) {
    var d = new M("popup-closed-by-user"),
        e = new M("web-storage-unsupported"),
        f = this,
        g = !1;return this.ga().then(function () {
      nj(f).then(function (h) {
        h || (a && le(a), b(e), g = !0);
      });
    }).s(function () {}).then(function () {
      if (!g) return oe(a);
    }).then(function () {
      if (!g) return Oc(c).then(function () {
        b(d);
      });
    });
  };
  k.Mb = function () {
    var a = I();return !Ge(a) && !Ke(a);
  };k.Hb = function () {
    return !1;
  };
  k.Db = function (a, b, c, d, e, f, g) {
    if (!a) return E(new M("popup-blocked"));if (g && !Ge()) return this.ga().s(function (m) {
      le(a);e(m);
    }), d(), D();this.a || (this.a = kj(oj(this)));var h = this;return this.a.then(function () {
      var m = h.ga().s(function (p) {
        le(a);e(p);throw p;
      });d();return m;
    }).then(function () {
      Mg(c);if (!g) {
        var m = pj(h.l, h.f, h.b, b, c, null, f, h.c, void 0, h.h);fe(m, a);
      }
    }).s(function (m) {
      "auth/network-request-failed" == m.code && (h.a = null);throw m;
    });
  };
  function oj(a) {
    a.o || (a.v = a.c ? Be(a.c, ij(a.b)) : null, a.o = new bi(a.f, If(a.h), a.v));return a.o;
  }k.Ca = function (a, b, c) {
    this.a || (this.a = kj(oj(this)));var d = this;return this.a.then(function () {
      Mg(b);var e = pj(d.l, d.f, d.b, a, b, ee(), c, d.c, void 0, d.h);fe(e);
    }).s(function (e) {
      "auth/network-request-failed" == e.code && (d.a = null);throw e;
    });
  };k.ga = function () {
    var a = this;return lj(this).then(function () {
      return a.i.fb;
    }).s(function () {
      a.a = null;throw new M("network-request-failed");
    });
  };k.Pb = function () {
    return !0;
  };
  function pj(a, b, c, d, e, f, g, h, m, p) {
    a = new hj(a, b, c, d, e);a.i = f;a.g = g;a.h = h;a.b = db(m || null);a.f = p;return a.toString();
  }function mj(a) {
    if (!a.i) throw Error("IfcHandler must be initialized!");cj(a.i, function (b) {
      var c = {};if (b && b.authEvent) {
        var d = !1;b = Og(b.authEvent);for (c = 0; c < a.g.length; c++) {
          d = a.g[c](b) || d;
        }c = {};c.status = d ? "ACK" : "ERROR";return D(c);
      }c.status = "ERROR";return D(c);
    });
  }
  function nj(a) {
    var b = { type: "webStorageSupport" };return lj(a).then(function () {
      return bj(a.i, b);
    }).then(function (c) {
      if (c && c.length && "undefined" !== typeof c[0].webStorageSupport) return c[0].webStorageSupport;throw Error();
    });
  }k.wa = function (a) {
    this.g.push(a);
  };k.La = function (a) {
    y(this.g, function (b) {
      return b == a;
    });
  };function qj(a) {
    this.a = a || __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.reactNative.AsyncStorage;if (!this.a) throw new M("internal-error", "The React Native compatibility library was not found.");this.type = "asyncStorage";
  }k = qj.prototype;k.get = function (a) {
    return D(this.a.getItem(a)).then(function (b) {
      return b && Je(b);
    });
  };k.set = function (a, b) {
    return D(this.a.setItem(a, He(b)));
  };k.P = function (a) {
    return D(this.a.removeItem(a));
  };k.Y = function () {};k.ca = function () {};function rj(a) {
    this.b = a;this.a = {};this.c = t(this.f, this);
  }var sj = [];function tj() {
    var a = we() ? self : null;x(sj, function (c) {
      c.b == a && (b = c);
    });if (!b) {
      var b = new rj(a);sj.push(b);
    }return b;
  }
  rj.prototype.f = function (a) {
    var b = a.data.eventType,
        c = a.data.eventId,
        d = this.a[b];if (d && 0 < d.length) {
      a.ports[0].postMessage({ status: "ack", eventId: c, eventType: b, response: null });var e = [];x(d, function (f) {
        e.push(D().then(function () {
          return f(a.origin, a.data.data);
        }));
      });Bb(e).then(function (f) {
        var g = [];x(f, function (h) {
          g.push({ fulfilled: h.Eb, value: h.value, reason: h.reason ? h.reason.message : void 0 });
        });x(g, function (h) {
          for (var m in h) {
            "undefined" === typeof h[m] && delete h[m];
          }
        });a.ports[0].postMessage({ status: "done", eventId: c,
          eventType: b, response: g });
      });
    }
  };rj.prototype.subscribe = function (a, b) {
    cb(this.a) && this.b.addEventListener("message", this.c);"undefined" === typeof this.a[a] && (this.a[a] = []);this.a[a].push(b);
  };rj.prototype.unsubscribe = function (a, b) {
    "undefined" !== typeof this.a[a] && b ? (y(this.a[a], function (c) {
      return c == b;
    }), 0 == this.a[a].length && delete this.a[a]) : b || delete this.a[a];cb(this.a) && this.b.removeEventListener("message", this.c);
  };function uj(a) {
    this.a = a;
  }uj.prototype.postMessage = function (a, b) {
    this.a.postMessage(a, b);
  };function vj(a) {
    this.c = a;this.b = !1;this.a = [];
  }
  function wj(a, b, c, d) {
    var e,
        f = c || {},
        g,
        h,
        m,
        p = null;if (a.b) return E(Error("connection_unavailable"));var v = d ? 800 : 50,
        z = "undefined" !== typeof MessageChannel ? new MessageChannel() : null;return new C(function (H, U) {
      z ? (e = Math.floor(Math.random() * Math.pow(10, 20)).toString(), z.port1.start(), h = setTimeout(function () {
        U(Error("unsupported_event"));
      }, v), g = function g(ta) {
        ta.data.eventId === e && ("ack" === ta.data.status ? (clearTimeout(h), m = setTimeout(function () {
          U(Error("timeout"));
        }, 3E3)) : "done" === ta.data.status ? (clearTimeout(m), "undefined" !== typeof ta.data.response ? H(ta.data.response) : U(Error("unknown_error"))) : (clearTimeout(h), clearTimeout(m), U(Error("invalid_response"))));
      }, p = { messageChannel: z, onMessage: g }, a.a.push(p), z.port1.addEventListener("message", g), a.c.postMessage({ eventType: b, eventId: e, data: f }, [z.port2])) : U(Error("connection_unavailable"));
    }).then(function (H) {
      xj(a, p);return H;
    }).s(function (H) {
      xj(a, p);throw H;
    });
  }
  function xj(a, b) {
    if (b) {
      var c = b.messageChannel,
          d = b.onMessage;c && (c.port1.removeEventListener("message", d), c.port1.close());y(a.a, function (e) {
        return e == b;
      });
    }
  }vj.prototype.close = function () {
    for (; 0 < this.a.length;) {
      xj(this, this.a[0]);
    }this.b = !0;
  };function yj() {
    if (!zj()) throw new M("web-storage-unsupported");this.c = {};this.a = [];this.b = 0;this.l = l.indexedDB;this.type = "indexedDB";this.g = this.m = this.f = this.i = null;this.u = !1;this.h = null;var a = this;we() && self ? (this.m = tj(), this.m.subscribe("keyChanged", function (b, c) {
      return Aj(a).then(function (d) {
        0 < d.length && x(a.a, function (e) {
          e(d);
        });return { keyProcessed: Ma(d, c.key) };
      });
    }), this.m.subscribe("ping", function () {
      return D(["keyChanged"]);
    })) : Se().then(function (b) {
      if (a.h = b) a.g = new vj(new uj(b)), wj(a.g, "ping", null, !0).then(function (c) {
        c[0].fulfilled && Ma(c[0].value, "keyChanged") && (a.u = !0);
      }).s(function () {});
    });
  }var Bj;function Cj(a) {
    return new C(function (b, c) {
      var d = a.l.deleteDatabase("firebaseLocalStorageDb");d.onsuccess = function () {
        b();
      };d.onerror = function (e) {
        c(Error(e.target.error));
      };
    });
  }
  function Dj(a) {
    return new C(function (b, c) {
      var d = a.l.open("firebaseLocalStorageDb", 1);d.onerror = function (e) {
        try {
          e.preventDefault();
        } catch (f) {}c(Error(e.target.error));
      };d.onupgradeneeded = function (e) {
        e = e.target.result;try {
          e.createObjectStore("firebaseLocalStorage", { keyPath: "fbase_key" });
        } catch (f) {
          c(f);
        }
      };d.onsuccess = function (e) {
        e = e.target.result;e.objectStoreNames.contains("firebaseLocalStorage") ? b(e) : Cj(a).then(function () {
          return Dj(a);
        }).then(function (f) {
          b(f);
        }).s(function (f) {
          c(f);
        });
      };
    });
  }
  function Ej(a) {
    a.o || (a.o = Dj(a));return a.o;
  }function zj() {
    try {
      return !!l.indexedDB;
    } catch (a) {
      return !1;
    }
  }function Fj(a) {
    return a.objectStore("firebaseLocalStorage");
  }function Gj(a, b) {
    return a.transaction(["firebaseLocalStorage"], b ? "readwrite" : "readonly");
  }function Hj(a) {
    return new C(function (b, c) {
      a.onsuccess = function (d) {
        d && d.target ? b(d.target.result) : b();
      };a.onerror = function (d) {
        c(d.target.error);
      };
    });
  }k = yj.prototype;
  k.set = function (a, b) {
    var c = !1,
        d,
        e = this;return Ej(this).then(function (f) {
      d = f;f = Fj(Gj(d, !0));return Hj(f.get(a));
    }).then(function (f) {
      var g = Fj(Gj(d, !0));if (f) return f.value = b, Hj(g.put(f));e.b++;c = !0;f = {};f.fbase_key = a;f.value = b;return Hj(g.add(f));
    }).then(function () {
      e.c[a] = b;return Ij(e, a);
    }).ia(function () {
      c && e.b--;
    });
  };function Ij(a, b) {
    return a.g && a.h && Re() === a.h ? wj(a.g, "keyChanged", { key: b }, a.u).then(function () {}).s(function () {}) : D();
  }
  k.get = function (a) {
    return Ej(this).then(function (b) {
      return Hj(Fj(Gj(b, !1)).get(a));
    }).then(function (b) {
      return b && b.value;
    });
  };k.P = function (a) {
    var b = !1,
        c = this;return Ej(this).then(function (d) {
      b = !0;c.b++;return Hj(Fj(Gj(d, !0))["delete"](a));
    }).then(function () {
      delete c.c[a];return Ij(c, a);
    }).ia(function () {
      b && c.b--;
    });
  };
  function Aj(a) {
    return Ej(a).then(function (b) {
      var c = Fj(Gj(b, !1));return c.getAll ? Hj(c.getAll()) : new C(function (d, e) {
        var f = [],
            g = c.openCursor();g.onsuccess = function (h) {
          (h = h.target.result) ? (f.push(h.value), h["continue"]()) : d(f);
        };g.onerror = function (h) {
          e(h.target.error);
        };
      });
    }).then(function (b) {
      var c = {},
          d = [];if (0 == a.b) {
        for (d = 0; d < b.length; d++) {
          c[b[d].fbase_key] = b[d].value;
        }d = ge(a.c, c);a.c = c;
      }return d;
    });
  }k.Y = function (a) {
    0 == this.a.length && Jj(this);this.a.push(a);
  };
  k.ca = function (a) {
    y(this.a, function (b) {
      return b == a;
    });0 == this.a.length && Kj(this);
  };function Jj(a) {
    function b() {
      a.f = setTimeout(function () {
        a.i = Aj(a).then(function (c) {
          0 < c.length && x(a.a, function (d) {
            d(c);
          });
        }).then(function () {
          b();
        }).s(function (c) {
          "STOP_EVENT" != c.message && b();
        });
      }, 800);
    }Kj(a);b();
  }function Kj(a) {
    a.i && a.i.cancel("STOP_EVENT");a.f && (clearTimeout(a.f), a.f = null);
  };function Lj(a) {
    var b = this,
        c = null;this.a = [];this.type = "indexedDB";this.c = a;this.b = D().then(function () {
      if (zj()) {
        var d = De(),
            e = "__sak" + d;Bj || (Bj = new yj());c = Bj;return c.set(e, d).then(function () {
          return c.get(e);
        }).then(function (f) {
          if (f !== d) throw Error("indexedDB not supported!");return c.P(e);
        }).then(function () {
          return c;
        }).s(function () {
          return b.c;
        });
      }return b.c;
    }).then(function (d) {
      b.type = d.type;d.Y(function (e) {
        x(b.a, function (f) {
          f(e);
        });
      });return d;
    });
  }k = Lj.prototype;k.get = function (a) {
    return this.b.then(function (b) {
      return b.get(a);
    });
  };
  k.set = function (a, b) {
    return this.b.then(function (c) {
      return c.set(a, b);
    });
  };k.P = function (a) {
    return this.b.then(function (b) {
      return b.P(a);
    });
  };k.Y = function (a) {
    this.a.push(a);
  };k.ca = function (a) {
    y(this.a, function (b) {
      return b == a;
    });
  };function Mj() {
    this.a = {};this.type = "inMemory";
  }k = Mj.prototype;k.get = function (a) {
    return D(this.a[a]);
  };k.set = function (a, b) {
    this.a[a] = b;return D();
  };k.P = function (a) {
    delete this.a[a];return D();
  };k.Y = function () {};k.ca = function () {};function Nj() {
    if (!Oj()) {
      if ("Node" == xe()) throw new M("internal-error", "The LocalStorage compatibility library was not found.");throw new M("web-storage-unsupported");
    }this.a = Pj() || __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;this.type = "localStorage";
  }function Pj() {
    try {
      var a = l.localStorage,
          b = De();a && (a.setItem(b, "1"), a.removeItem(b));return a;
    } catch (c) {
      return null;
    }
  }
  function Oj() {
    var a = "Node" == xe();a = Pj() || a && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.localStorage;if (!a) return !1;try {
      return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
    } catch (b) {
      return !1;
    }
  }k = Nj.prototype;k.get = function (a) {
    var b = this;return D().then(function () {
      var c = b.a.getItem(a);return Je(c);
    });
  };k.set = function (a, b) {
    var c = this;return D().then(function () {
      var d = He(b);null === d ? c.P(a) : c.a.setItem(a, d);
    });
  };k.P = function (a) {
    var b = this;return D().then(function () {
      b.a.removeItem(a);
    });
  };
  k.Y = function (a) {
    l.window && xc(l.window, "storage", a);
  };k.ca = function (a) {
    l.window && Hc(l.window, "storage", a);
  };function Qj() {
    this.type = "nullStorage";
  }k = Qj.prototype;k.get = function () {
    return D(null);
  };k.set = function () {
    return D();
  };k.P = function () {
    return D();
  };k.Y = function () {};k.ca = function () {};function Rj() {
    if (!Sj()) {
      if ("Node" == xe()) throw new M("internal-error", "The SessionStorage compatibility library was not found.");throw new M("web-storage-unsupported");
    }this.a = Tj() || __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;this.type = "sessionStorage";
  }function Tj() {
    try {
      var a = l.sessionStorage,
          b = De();a && (a.setItem(b, "1"), a.removeItem(b));return a;
    } catch (c) {
      return null;
    }
  }
  function Sj() {
    var a = "Node" == xe();a = Tj() || a && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.node.sessionStorage;if (!a) return !1;try {
      return a.setItem("__sak", "1"), a.removeItem("__sak"), !0;
    } catch (b) {
      return !1;
    }
  }k = Rj.prototype;k.get = function (a) {
    var b = this;return D().then(function () {
      var c = b.a.getItem(a);return Je(c);
    });
  };k.set = function (a, b) {
    var c = this;return D().then(function () {
      var d = He(b);null === d ? c.P(a) : c.a.setItem(a, d);
    });
  };k.P = function (a) {
    var b = this;return D().then(function () {
      b.a.removeItem(a);
    });
  };k.Y = function () {};
  k.ca = function () {};function Uj() {
    var a = {};a.Browser = Vj;a.Node = Wj;a.ReactNative = Xj;a.Worker = Yj;this.a = a[xe()];
  }var Zj,
      Vj = { B: Nj, Ra: Rj },
      Wj = { B: Nj, Ra: Rj },
      Xj = { B: qj, Ra: Qj },
      Yj = { B: Nj, Ra: Qj };var ak = { Xc: "local", NONE: "none", Zc: "session" };function bk(a) {
    var b = new M("invalid-persistence-type"),
        c = new M("unsupported-persistence-type");a: {
      for (d in ak) {
        if (ak[d] == a) {
          var d = !0;break a;
        }
      }d = !1;
    }if (!d || "string" !== typeof a) throw b;switch (xe()) {case "ReactNative":
        if ("session" === a) throw c;break;case "Node":
        if ("none" !== a) throw c;break;default:
        if (!Ce() && "none" !== a) throw c;}
  }
  function ck() {
    var a = !Ke(I()) && ve() ? !0 : !1,
        b = Ge(),
        c = Ce();this.o = a;this.h = b;this.m = c;this.a = {};Zj || (Zj = new Uj());a = Zj;try {
      this.g = !de() && Qe() || !l.indexedDB ? new a.a.B() : new Lj(we() ? new Mj() : new a.a.B());
    } catch (d) {
      this.g = new Mj(), this.h = !0;
    }try {
      this.i = new a.a.Ra();
    } catch (d) {
      this.i = new Mj();
    }this.l = new Mj();this.f = t(this.Ob, this);this.b = {};
  }var dk;function ek() {
    dk || (dk = new ck());return dk;
  }function fk(a, b) {
    switch (b) {case "session":
        return a.i;case "none":
        return a.l;default:
        return a.g;}
  }
  function gk(a, b) {
    return "firebase:" + a.name + (b ? ":" + b : "");
  }function hk(a, b, c) {
    var d = gk(b, c),
        e = fk(a, b.B);return a.get(b, c).then(function (f) {
      var g = null;try {
        g = Je(l.localStorage.getItem(d));
      } catch (h) {}if (g && !f) return l.localStorage.removeItem(d), a.set(b, g, c);g && f && "localStorage" != e.type && l.localStorage.removeItem(d);
    });
  }k = ck.prototype;k.get = function (a, b) {
    return fk(this, a.B).get(gk(a, b));
  };function ik(a, b, c) {
    c = gk(b, c);"local" == b.B && (a.b[c] = null);return fk(a, b.B).P(c);
  }
  k.set = function (a, b, c) {
    var d = gk(a, c),
        e = this,
        f = fk(this, a.B);return f.set(d, b).then(function () {
      return f.get(d);
    }).then(function (g) {
      "local" == a.B && (e.b[d] = g);
    });
  };k.addListener = function (a, b, c) {
    a = gk(a, b);this.m && (this.b[a] = l.localStorage.getItem(a));cb(this.a) && (fk(this, "local").Y(this.f), this.h || (de() || !Qe()) && l.indexedDB || !this.m || jk(this));this.a[a] || (this.a[a] = []);this.a[a].push(c);
  };
  k.removeListener = function (a, b, c) {
    a = gk(a, b);this.a[a] && (y(this.a[a], function (d) {
      return d == c;
    }), 0 == this.a[a].length && delete this.a[a]);cb(this.a) && (fk(this, "local").ca(this.f), kk(this));
  };function jk(a) {
    kk(a);a.c = setInterval(function () {
      for (var b in a.a) {
        var c = l.localStorage.getItem(b),
            d = a.b[b];c != d && (a.b[b] = c, c = new lc({ type: "storage", key: b, target: window, oldValue: d, newValue: c, a: !0 }), a.Ob(c));
      }
    }, 1E3);
  }function kk(a) {
    a.c && (clearInterval(a.c), a.c = null);
  }
  k.Ob = function (a) {
    if (a && a.f) {
      var b = a.a.key;if (null == b) for (var c in this.a) {
        var d = this.b[c];"undefined" === typeof d && (d = null);var e = l.localStorage.getItem(c);e !== d && (this.b[c] = e, this.Xa(c));
      } else if (0 == b.indexOf("firebase:") && this.a[b]) {
        "undefined" !== typeof a.a.a ? fk(this, "local").ca(this.f) : kk(this);if (this.o) if (c = l.localStorage.getItem(b), d = a.a.newValue, d !== c) null !== d ? l.localStorage.setItem(b, d) : l.localStorage.removeItem(b);else if (this.b[b] === d && "undefined" === typeof a.a.a) return;var f = this;c = function c() {
          if ("undefined" !== typeof a.a.a || f.b[b] !== l.localStorage.getItem(b)) f.b[b] = l.localStorage.getItem(b), f.Xa(b);
        };Ub && ec && 10 == ec && l.localStorage.getItem(b) !== a.a.newValue && a.a.newValue !== a.a.oldValue ? setTimeout(c, 10) : c();
      }
    } else x(a, t(this.Xa, this));
  };k.Xa = function (a) {
    this.a[a] && x(this.a[a], function (b) {
      b();
    });
  };function lk(a) {
    this.a = a;this.b = ek();
  }var mk = { name: "authEvent", B: "local" };function nk(a) {
    return a.b.get(mk, a.a).then(function (b) {
      return Og(b);
    });
  };function ok() {
    this.a = ek();
  };function pk() {
    this.b = -1;
  };function qk(a, b) {
    this.b = rk;this.f = l.Uint8Array ? new Uint8Array(this.b) : Array(this.b);this.g = this.c = 0;this.a = [];this.i = a;this.h = b;this.m = l.Int32Array ? new Int32Array(64) : Array(64);void 0 !== sk || (l.Int32Array ? sk = new Int32Array(tk) : sk = tk);this.reset();
  }var sk;u(qk, pk);for (var rk = 64, uk = rk - 1, vk = [], wk = 0; wk < uk; wk++) {
    vk[wk] = 0;
  }var xk = Oa(128, vk);qk.prototype.reset = function () {
    this.g = this.c = 0;this.a = l.Int32Array ? new Int32Array(this.h) : Pa(this.h);
  };
  function yk(a) {
    for (var b = a.f, c = a.m, d = 0, e = 0; e < b.length;) {
      c[d++] = b[e] << 24 | b[e + 1] << 16 | b[e + 2] << 8 | b[e + 3], e = 4 * d;
    }for (b = 16; 64 > b; b++) {
      e = c[b - 15] | 0;d = c[b - 2] | 0;var f = (c[b - 16] | 0) + ((e >>> 7 | e << 25) ^ (e >>> 18 | e << 14) ^ e >>> 3) | 0,
          g = (c[b - 7] | 0) + ((d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10) | 0;c[b] = f + g | 0;
    }d = a.a[0] | 0;e = a.a[1] | 0;var h = a.a[2] | 0,
        m = a.a[3] | 0,
        p = a.a[4] | 0,
        v = a.a[5] | 0,
        z = a.a[6] | 0;f = a.a[7] | 0;for (b = 0; 64 > b; b++) {
      var H = ((d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10)) + (d & e ^ d & h ^ e & h) | 0;g = p & v ^ ~p & z;f = f + ((p >>> 6 | p << 26) ^ (p >>> 11 | p << 21) ^ (p >>> 25 | p << 7)) | 0;g = g + (sk[b] | 0) | 0;g = f + (g + (c[b] | 0) | 0) | 0;f = z;z = v;v = p;p = m + g | 0;m = h;h = e;e = d;d = g + H | 0;
    }a.a[0] = a.a[0] + d | 0;a.a[1] = a.a[1] + e | 0;a.a[2] = a.a[2] + h | 0;a.a[3] = a.a[3] + m | 0;a.a[4] = a.a[4] + p | 0;a.a[5] = a.a[5] + v | 0;a.a[6] = a.a[6] + z | 0;a.a[7] = a.a[7] + f | 0;
  }
  function zk(a, b, c) {
    void 0 === c && (c = b.length);var d = 0,
        e = a.c;if (n(b)) for (; d < c;) {
      a.f[e++] = b.charCodeAt(d++), e == a.b && (yk(a), e = 0);
    } else if (oa(b)) for (; d < c;) {
      var f = b[d++];if (!("number" == typeof f && 0 <= f && 255 >= f && f == (f | 0))) throw Error("message must be a byte array");a.f[e++] = f;e == a.b && (yk(a), e = 0);
    } else throw Error("message must be string or array");a.c = e;a.g += c;
  }
  var tk = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];function Ak() {
    qk.call(this, 8, Bk);
  }u(Ak, qk);var Bk = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225];function Ck(a, b, c, d, e) {
    this.l = a;this.i = b;this.m = c;this.o = d || null;this.u = e || null;this.h = b + ":" + c;this.v = new ok();this.g = new lk(this.h);this.f = null;this.b = [];this.a = this.c = null;
  }function Dk(a) {
    return new M("invalid-cordova-configuration", a);
  }k = Ck.prototype;
  k.ga = function () {
    return this.za ? this.za : this.za = se().then(function () {
      if ("function" !== typeof J("universalLinks.subscribe", l)) throw Dk("cordova-universal-links-plugin-fix is not installed");if ("undefined" === typeof J("BuildInfo.packageName", l)) throw Dk("cordova-plugin-buildinfo is not installed");if ("function" !== typeof J("cordova.plugins.browsertab.openUrl", l)) throw Dk("cordova-plugin-browsertab is not installed");if ("function" !== typeof J("cordova.InAppBrowser.open", l)) throw Dk("cordova-plugin-inappbrowser is not installed");
    }, function () {
      throw new M("cordova-not-ready");
    });
  };function Ek() {
    for (var a = 20, b = []; 0 < a;) {
      b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62 * Math.random()))), a--;
    }return b.join("");
  }function Fk(a) {
    var b = new Ak();zk(b, a);a = [];var c = 8 * b.g;56 > b.c ? zk(b, xk, 56 - b.c) : zk(b, xk, b.b - (b.c - 56));for (var d = 63; 56 <= d; d--) {
      b.f[d] = c & 255, c /= 256;
    }yk(b);for (d = c = 0; d < b.i; d++) {
      for (var e = 24; 0 <= e; e -= 8) {
        a[c++] = b.a[d] >> e & 255;
      }
    }return yf(a);
  }
  k.Ea = function (a, b) {
    b(new M("operation-not-supported-in-this-environment"));return D();
  };k.Db = function () {
    return E(new M("operation-not-supported-in-this-environment"));
  };k.Pb = function () {
    return !1;
  };k.Mb = function () {
    return !0;
  };k.Hb = function () {
    return !0;
  };
  k.Ca = function (a, b, c) {
    if (this.c) return E(new M("redirect-operation-pending"));var d = this,
        e = l.document,
        f = null,
        g = null,
        h = null,
        m = null;return this.c = D().then(function () {
      Mg(b);return Gk(d);
    }).then(function () {
      return Hk(d, a, b, c);
    }).then(function () {
      return new C(function (p, v) {
        g = function g() {
          var z = J("cordova.plugins.browsertab.close", l);p();"function" === typeof z && z();d.a && "function" === typeof d.a.close && (d.a.close(), d.a = null);return !1;
        };d.wa(g);h = function h() {
          f || (f = Oc(2E3).then(function () {
            v(new M("redirect-cancelled-by-user"));
          }));
        };
        m = function m() {
          Ne() && h();
        };e.addEventListener("resume", h, !1);I().toLowerCase().match(/android/) || e.addEventListener("visibilitychange", m, !1);
      }).s(function (p) {
        return Ik(d).then(function () {
          throw p;
        });
      });
    }).ia(function () {
      h && e.removeEventListener("resume", h, !1);m && e.removeEventListener("visibilitychange", m, !1);f && f.cancel();g && d.La(g);d.c = null;
    });
  };
  function Hk(a, b, c, d) {
    var e = Ek(),
        f = new Ng(b, d, null, e, new M("no-auth-event")),
        g = J("BuildInfo.packageName", l);if ("string" !== typeof g) throw new M("invalid-cordova-configuration");var h = J("BuildInfo.displayName", l),
        m = {};if (I().toLowerCase().match(/iphone|ipad|ipod/)) m.ibi = g;else if (I().toLowerCase().match(/android/)) m.apn = g;else return E(new M("operation-not-supported-in-this-environment"));h && (m.appDisplayName = h);e = Fk(e);m.sessionId = e;var p = pj(a.l, a.i, a.m, b, c, null, d, a.o, m, a.u);return a.ga().then(function () {
      var v = a.h;return a.v.a.set(mk, f.w(), v);
    }).then(function () {
      var v = J("cordova.plugins.browsertab.isAvailable", l);if ("function" !== typeof v) throw new M("invalid-cordova-configuration");var z = null;v(function (H) {
        if (H) {
          z = J("cordova.plugins.browsertab.openUrl", l);if ("function" !== typeof z) throw new M("invalid-cordova-configuration");z(p);
        } else {
          z = J("cordova.InAppBrowser.open", l);if ("function" !== typeof z) throw new M("invalid-cordova-configuration");H = I();a.a = z(p, H.match(/(iPad|iPhone|iPod).*OS 7_\d/i) || H.match(/(iPad|iPhone|iPod).*OS 8_\d/i) ? "_blank" : "_system", "location=yes");
        }
      });
    });
  }function Jk(a, b) {
    for (var c = 0; c < a.b.length; c++) {
      try {
        a.b[c](b);
      } catch (d) {}
    }
  }function Gk(a) {
    a.f || (a.f = a.ga().then(function () {
      return new C(function (b) {
        function c(d) {
          b(d);a.La(c);return !1;
        }a.wa(c);Kk(a);
      });
    }));return a.f;
  }function Ik(a) {
    var b = null;return nk(a.g).then(function (c) {
      b = c;c = a.g;return ik(c.b, mk, c.a);
    }).then(function () {
      return b;
    });
  }
  function Kk(a) {
    function b(g) {
      d = !0;e && e.cancel();Ik(a).then(function (h) {
        var m = c;if (h && g && g.url) {
          var p = null;m = Yf(g.url);-1 != m.indexOf("/__/auth/callback") && (p = md(m), p = Je(kd(p, "firebaseError") || null), p = (p = "object" === typeof p ? mf(p) : null) ? new Ng(h.c, h.b, null, null, p) : new Ng(h.c, h.b, m, h.f));m = p || c;
        }Jk(a, m);
      });
    }var c = new Ng("unknown", null, null, null, new M("no-auth-event")),
        d = !1,
        e = Oc(500).then(function () {
      return Ik(a).then(function () {
        d || Jk(a, c);
      });
    }),
        f = l.handleOpenURL;l.handleOpenURL = function (g) {
      0 == g.toLowerCase().indexOf(J("BuildInfo.packageName", l).toLowerCase() + "://") && b({ url: g });if ("function" === typeof f) try {
        f(g);
      } catch (h) {
        console.error(h);
      }
    };Qg || (Qg = new Pg());Qg.subscribe(b);
  }k.wa = function (a) {
    this.b.push(a);Gk(this).s(function (b) {
      "auth/invalid-cordova-configuration" === b.code && (b = new Ng("unknown", null, null, null, new M("no-auth-event")), a(b));
    });
  };k.La = function (a) {
    y(this.b, function (b) {
      return b == a;
    });
  };function Lk(a) {
    this.a = a;this.b = ek();
  }var Mk = { name: "pendingRedirect", B: "session" };function Nk(a) {
    return a.b.set(Mk, "pending", a.a);
  }function Ok(a) {
    return ik(a.b, Mk, a.a);
  }function Pk(a) {
    return a.b.get(Mk, a.a).then(function (b) {
      return "pending" == b;
    });
  };function Qk(a, b, c) {
    this.i = {};this.u = 0;this.A = a;this.l = b;this.o = c;this.h = [];this.f = !1;this.m = t(this.bb, this);this.b = new Rk();this.v = new Sk();this.g = new Lk(this.l + ":" + this.o);this.c = {};this.c.unknown = this.b;this.c.signInViaRedirect = this.b;this.c.linkViaRedirect = this.b;this.c.reauthViaRedirect = this.b;this.c.signInViaPopup = this.v;this.c.linkViaPopup = this.v;this.c.reauthViaPopup = this.v;this.a = Tk(this.A, this.l, this.o, Jf);
  }
  function Tk(a, b, c, d) {
    var e = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION || null;return te() ? new Ck(a, b, c, e, d) : new jj(a, b, c, e, d);
  }k = Qk.prototype;k.reset = function () {
    this.f = !1;this.a.La(this.m);this.a = Tk(this.A, this.l, this.o);this.i = {};
  };k.Ya = function () {
    this.b.Ya();
  };function Uk(a) {
    a.f || (a.f = !0, a.a.wa(a.m));var b = a.a;return a.a.ga().s(function (c) {
      a.a == b && a.reset();throw c;
    });
  }
  function Vk(a) {
    a.a.Mb() && Uk(a).s(function (b) {
      var c = new Ng("unknown", null, null, null, new M("operation-not-supported-in-this-environment"));Wk(b) && a.bb(c);
    });a.a.Hb() || Xk(a.b);
  }k.subscribe = function (a) {
    Ma(this.h, a) || this.h.push(a);if (!this.f) {
      var b = this;Pk(this.g).then(function (c) {
        c ? Ok(b.g).then(function () {
          Uk(b).s(function (d) {
            var e = new Ng("unknown", null, null, null, new M("operation-not-supported-in-this-environment"));Wk(d) && b.bb(e);
          });
        }) : Vk(b);
      }).s(function () {
        Vk(b);
      });
    }
  };
  k.unsubscribe = function (a) {
    y(this.h, function (b) {
      return b == a;
    });
  };k.bb = function (a) {
    if (!a) throw new M("invalid-auth-event");6E5 <= va() - this.u && (this.i = {}, this.u = 0);if (a && a.getUid() && this.i.hasOwnProperty(a.getUid())) return !1;for (var b = !1, c = 0; c < this.h.length; c++) {
      var d = this.h[c];if (d.xb(a.c, a.b)) {
        if (b = this.c[a.c]) b.h(a, d), a && (a.f || a.b) && (this.i[a.getUid()] = !0, this.u = va());b = !0;break;
      }
    }Xk(this.b);return b;
  };var Yk = new Me(2E3, 1E4),
      Zk = new Me(3E4, 6E4);Qk.prototype.fa = function () {
    return this.b.fa();
  };
  function $k(a, b, c, d, e, f) {
    return a.a.Db(b, c, d, function () {
      a.f || (a.f = !0, a.a.wa(a.m));
    }, function () {
      a.reset();
    }, e, f);
  }function Wk(a) {
    return a && "auth/cordova-not-ready" == a.code ? !0 : !1;
  }Qk.prototype.Ca = function (a, b, c) {
    var d = this,
        e;return Nk(this.g).then(function () {
      return d.a.Ca(a, b, c).s(function (f) {
        if (Wk(f)) throw new M("operation-not-supported-in-this-environment");e = f;return Ok(d.g).then(function () {
          throw e;
        });
      }).then(function () {
        return d.a.Pb() ? new C(function () {}) : Ok(d.g).then(function () {
          return d.fa();
        }).then(function () {}).s(function () {});
      });
    });
  };
  Qk.prototype.Ea = function (a, b, c, d) {
    return this.a.Ea(c, function (e) {
      a.ha(b, null, e, d);
    }, Yk.get());
  };var al = {};function bl(a, b, c) {
    var d = b + ":" + c;al[d] || (al[d] = new Qk(a, b, c));return al[d];
  }function Rk() {
    this.b = null;this.f = [];this.c = [];this.a = null;this.i = this.g = !1;
  }Rk.prototype.reset = function () {
    this.b = null;this.a && (this.a.cancel(), this.a = null);
  };
  Rk.prototype.h = function (a, b) {
    if (a) {
      this.reset();this.g = !0;var c = a.c,
          d = a.b,
          e = a.a && "auth/web-storage-unsupported" == a.a.code,
          f = a.a && "auth/operation-not-supported-in-this-environment" == a.a.code;this.i = !(!e && !f);"unknown" != c || e || f ? a.a ? (cl(this, !0, null, a.a), D()) : b.xa(c, d) ? dl(this, a, b) : E(new M("invalid-auth-event")) : (cl(this, !1, null, null), D());
    } else E(new M("invalid-auth-event"));
  };function Xk(a) {
    a.g || (a.g = !0, cl(a, !1, null, null));
  }Rk.prototype.Ya = function () {
    this.g && !this.i && cl(this, !1, null, null);
  };
  function dl(a, b, c) {
    c = c.xa(b.c, b.b);var d = b.g,
        e = b.f,
        f = b.h,
        g = !!b.c.match(/Redirect$/);c(d, e, f).then(function (h) {
      cl(a, g, h, null);
    }).s(function (h) {
      cl(a, g, null, h);
    });
  }function el(a, b) {
    a.b = function () {
      return E(b);
    };if (a.c.length) for (var c = 0; c < a.c.length; c++) {
      a.c[c](b);
    }
  }function fl(a, b) {
    a.b = function () {
      return D(b);
    };if (a.f.length) for (var c = 0; c < a.f.length; c++) {
      a.f[c](b);
    }
  }function cl(a, b, c, d) {
    b ? d ? el(a, d) : fl(a, c) : fl(a, { user: null });a.f = [];a.c = [];
  }
  Rk.prototype.fa = function () {
    var a = this;return new C(function (b, c) {
      a.b ? a.b().then(b, c) : (a.f.push(b), a.c.push(c), gl(a));
    });
  };function gl(a) {
    var b = new M("timeout");a.a && a.a.cancel();a.a = Oc(Zk.get()).then(function () {
      a.b || (a.g = !0, cl(a, !0, null, b));
    });
  }function Sk() {}Sk.prototype.h = function (a, b) {
    if (a) {
      var c = a.c,
          d = a.b;a.a ? (b.ha(a.c, null, a.a, a.b), D()) : b.xa(c, d) ? hl(a, b) : E(new M("invalid-auth-event"));
    } else E(new M("invalid-auth-event"));
  };
  function hl(a, b) {
    var c = a.b,
        d = a.c;b.xa(d, c)(a.g, a.f, a.h).then(function (e) {
      b.ha(d, e, null, c);
    }).s(function (e) {
      b.ha(d, null, e, c);
    });
  };function il() {
    this.ub = !1;Object.defineProperty(this, "appVerificationDisabled", { get: function get() {
        return this.ub;
      }, set: function set(a) {
        this.ub = a;
      }, enumerable: !1 });
  };function jl(a, b) {
    this.a = b;K(this, "verificationId", a);
  }jl.prototype.confirm = function (a) {
    a = Kg(this.verificationId, a);return this.a(a);
  };function kl(a, b, c, d) {
    return new Ig(a).Ua(b, c).then(function (e) {
      return new jl(e, d);
    });
  };function ll(a) {
    var b = Gf(a);if (!(b && b.exp && b.auth_time && b.iat)) throw new M("internal-error", "An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this, { token: a, expirationTime: Pe(1E3 * b.exp), authTime: Pe(1E3 * b.auth_time), issuedAtTime: Pe(1E3 * b.iat), signInProvider: b.firebase && b.firebase.sign_in_provider ? b.firebase.sign_in_provider : null, claims: b });
  };function ml(a, b, c) {
    this.h = a;this.i = b;this.g = c;this.c = 3E4;this.f = 96E4;this.b = null;this.a = this.c;if (this.f < this.c) throw Error("Proactive refresh lower bound greater than upper bound!");
  }ml.prototype.start = function () {
    this.a = this.c;nl(this, !0);
  };function ol(a, b) {
    if (b) return a.a = a.c, a.g();b = a.a;a.a *= 2;a.a > a.f && (a.a = a.f);return b;
  }function nl(a, b) {
    a.stop();a.b = Oc(ol(a, b)).then(function () {
      return Oe();
    }).then(function () {
      return a.h();
    }).then(function () {
      nl(a, !0);
    }).s(function (c) {
      a.i(c) && nl(a, !1);
    });
  }
  ml.prototype.stop = function () {
    this.b && (this.b.cancel(), this.b = null);
  };function pl(a) {
    this.f = a;this.b = this.a = null;this.c = 0;
  }pl.prototype.w = function () {
    return { apiKey: this.f.b, refreshToken: this.a, accessToken: this.b, expirationTime: this.c };
  };function ql(a, b) {
    var c = b[ag],
        d = b.refreshToken;b = rl(b.expiresIn);a.b = c;a.c = b;a.a = d;
  }function sl(a, b) {
    a.b = b.b;a.a = b.a;a.c = b.c;
  }function rl(a) {
    return va() + 1E3 * parseInt(a, 10);
  }
  function tl(a, b) {
    return ni(a.f, b).then(function (c) {
      a.b = c.access_token;a.c = rl(c.expires_in);a.a = c.refresh_token;return { accessToken: a.b, expirationTime: a.c, refreshToken: a.a };
    }).s(function (c) {
      "auth/user-token-expired" == c.code && (a.a = null);throw c;
    });
  }pl.prototype.getToken = function (a) {
    a = !!a;return this.b && !this.a ? E(new M("user-token-expired")) : a || !this.b || va() > this.c - 3E4 ? this.a ? tl(this, { grant_type: "refresh_token", refresh_token: this.a }) : D(null) : D({ accessToken: this.b, expirationTime: this.c, refreshToken: this.a });
  };function ul(a, b) {
    this.a = a || null;this.b = b || null;L(this, { lastSignInTime: Pe(b || null), creationTime: Pe(a || null) });
  }function vl(a) {
    return new ul(a.a, a.b);
  }ul.prototype.w = function () {
    return { lastLoginAt: this.b, createdAt: this.a };
  };function wl(a, b, c, d, e, f) {
    L(this, { uid: a, displayName: d || null, photoURL: e || null, email: c || null, phoneNumber: f || null, providerId: b });
  }function xl(a, b) {
    kc.call(this, a);for (var c in b) {
      this[c] = b[c];
    }
  }u(xl, kc);
  function P(a, b, c) {
    this.G = [];this.l = a.apiKey;this.o = a.appName;this.u = a.authDomain || null;a = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION ? Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION) : null;this.c = new bi(this.l, If(Jf), a);this.h = new pl(this.c);yl(this, b[ag]);ql(this.h, b);K(this, "refreshToken", this.h.a);zl(this, c || {});F.call(this);this.I = !1;this.u && Ee() && (this.a = bl(this.u, this.l, this.o));this.N = [];this.i = null;this.A = Al(this);this.V = t(this.Ha, this);var d = this;this.ka = null;this.ta = function (e) {
      d.pa(e.g);
    };this.X = null;this.O = [];this.sa = function (e) {
      Bl(d, e.c);
    };this.W = null;
  }u(P, F);P.prototype.pa = function (a) {
    this.ka = a;hi(this.c, a);
  };P.prototype.ea = function () {
    return this.ka;
  };function Cl(a, b) {
    a.X && Hc(a.X, "languageCodeChanged", a.ta);(a.X = b) && xc(b, "languageCodeChanged", a.ta);
  }function Bl(a, b) {
    a.O = b;ii(a.c, __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION ? Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION, a.O) : null);
  }P.prototype.ya = function () {
    return Pa(this.O);
  };function Dl(a, b) {
    a.W && Hc(a.W, "frameworkChanged", a.sa);(a.W = b) && xc(b, "frameworkChanged", a.sa);
  }P.prototype.Ha = function () {
    this.A.b && (this.A.stop(), this.A.start());
  };
  function El(a) {
    try {
      return __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app(a.o).auth();
    } catch (b) {
      throw new M("internal-error", "No firebase.auth.Auth instance is available for the Firebase App '" + a.o + "'!");
    }
  }function Al(a) {
    return new ml(function () {
      return a.F(!0);
    }, function (b) {
      return b && "auth/network-request-failed" == b.code ? !0 : !1;
    }, function () {
      var b = a.h.c - va() - 3E5;return 0 < b ? b : 0;
    });
  }function Fl(a) {
    a.D || a.A.b || (a.A.start(), Hc(a, "tokenChanged", a.V), xc(a, "tokenChanged", a.V));
  }function Gl(a) {
    Hc(a, "tokenChanged", a.V);a.A.stop();
  }
  function yl(a, b) {
    a.ra = b;K(a, "_lat", b);
  }function Hl(a, b) {
    y(a.N, function (c) {
      return c == b;
    });
  }function Il(a) {
    for (var b = [], c = 0; c < a.N.length; c++) {
      b.push(a.N[c](a));
    }return Bb(b).then(function () {
      return a;
    });
  }function Jl(a) {
    a.a && !a.I && (a.I = !0, a.a.subscribe(a));
  }
  function zl(a, b) {
    L(a, { uid: b.uid, displayName: b.displayName || null, photoURL: b.photoURL || null, email: b.email || null, emailVerified: b.emailVerified || !1, phoneNumber: b.phoneNumber || null, isAnonymous: b.isAnonymous || !1, metadata: new ul(b.createdAt, b.lastLoginAt), providerData: [] });
  }K(P.prototype, "providerId", "firebase");function Kl() {}function Ll(a) {
    return D().then(function () {
      if (a.D) throw new M("app-deleted");
    });
  }function Ml(a) {
    return Ia(a.providerData, function (b) {
      return b.providerId;
    });
  }
  function Nl(a, b) {
    b && (Ol(a, b.providerId), a.providerData.push(b));
  }function Ol(a, b) {
    y(a.providerData, function (c) {
      return c.providerId == b;
    });
  }function Pl(a, b, c) {
    ("uid" != b || c) && a.hasOwnProperty(b) && K(a, b, c);
  }
  function Ql(a, b) {
    a != b && (L(a, { uid: b.uid, displayName: b.displayName, photoURL: b.photoURL, email: b.email, emailVerified: b.emailVerified, phoneNumber: b.phoneNumber, isAnonymous: b.isAnonymous, providerData: [] }), b.metadata ? K(a, "metadata", vl(b.metadata)) : K(a, "metadata", new ul()), x(b.providerData, function (c) {
      Nl(a, c);
    }), sl(a.h, b.h), K(a, "refreshToken", a.h.a));
  }k = P.prototype;k.reload = function () {
    var a = this;return Q(this, Ll(this).then(function () {
      return Rl(a).then(function () {
        return Il(a);
      }).then(Kl);
    }));
  };
  function Rl(a) {
    return a.F().then(function (b) {
      var c = a.isAnonymous;return Sl(a, b).then(function () {
        c || Pl(a, "isAnonymous", !1);return b;
      });
    });
  }k.bc = function (a) {
    return this.F(a).then(function (b) {
      return new ll(b);
    });
  };k.F = function (a) {
    var b = this;return Q(this, Ll(this).then(function () {
      return b.h.getToken(a);
    }).then(function (c) {
      if (!c) throw new M("internal-error");c.accessToken != b.ra && (yl(b, c.accessToken), b.dispatchEvent(new xl("tokenChanged")));Pl(b, "refreshToken", c.refreshToken);return c.accessToken;
    }));
  };
  function Tl(a, b) {
    b[ag] && a.ra != b[ag] && (ql(a.h, b), a.dispatchEvent(new xl("tokenChanged")), yl(a, b[ag]), Pl(a, "refreshToken", a.h.a));
  }function Sl(a, b) {
    return O(a.c, Vi, { idToken: b }).then(t(a.xc, a));
  }
  k.xc = function (a) {
    a = a.users;if (!a || !a.length) throw new M("internal-error");a = a[0];zl(this, { uid: a.localId, displayName: a.displayName, photoURL: a.photoUrl, email: a.email, emailVerified: !!a.emailVerified, phoneNumber: a.phoneNumber, lastLoginAt: a.lastLoginAt, createdAt: a.createdAt });for (var b = Ul(a), c = 0; c < b.length; c++) {
      Nl(this, b[c]);
    }Pl(this, "isAnonymous", !(this.email && a.passwordHash) && !(this.providerData && this.providerData.length));
  };
  function Ul(a) {
    return (a = a.providerUserInfo) && a.length ? Ia(a, function (b) {
      return new wl(b.rawId, b.providerId, b.email, b.displayName, b.photoUrl, b.phoneNumber);
    }) : [];
  }k.yc = function (a) {
    Ue("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.gb(a);
  };
  k.gb = function (a) {
    var b = this,
        c = null;return Q(this, a.f(this.c, this.uid).then(function (d) {
      Tl(b, d);c = Vl(b, d, "reauthenticate");b.i = null;return b.reload();
    }).then(function () {
      return c;
    }), !0);
  };function Wl(a, b) {
    return Rl(a).then(function () {
      if (Ma(Ml(a), b)) return Il(a).then(function () {
        throw new M("provider-already-linked");
      });
    });
  }k.pc = function (a) {
    Ue("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.eb(a);
  };
  k.eb = function (a) {
    var b = this,
        c = null;return Q(this, Wl(this, a.providerId).then(function () {
      return b.F();
    }).then(function (d) {
      return a.b(b.c, d);
    }).then(function (d) {
      c = Vl(b, d, "link");return Xl(b, d);
    }).then(function () {
      return c;
    }));
  };k.qc = function (a, b) {
    var c = this;return Q(this, Wl(this, "phone").then(function () {
      return kl(El(c), a, b, t(c.eb, c));
    }));
  };k.zc = function (a, b) {
    var c = this;return Q(this, D().then(function () {
      return kl(El(c), a, b, t(c.gb, c));
    }), !0);
  };
  function Vl(a, b, c) {
    var d = Lg(b);b = Of(b);return Xe({ user: a, credential: d, additionalUserInfo: b, operationType: c });
  }function Xl(a, b) {
    Tl(a, b);return a.reload().then(function () {
      return a;
    });
  }k.rb = function (a) {
    var b = this;return Q(this, this.F().then(function (c) {
      return b.c.rb(c, a);
    }).then(function (c) {
      Tl(b, c);return b.reload();
    }));
  };k.Pc = function (a) {
    var b = this;return Q(this, this.F().then(function (c) {
      return a.b(b.c, c);
    }).then(function (c) {
      Tl(b, c);return b.reload();
    }));
  };
  k.sb = function (a) {
    var b = this;return Q(this, this.F().then(function (c) {
      return b.c.sb(c, a);
    }).then(function (c) {
      Tl(b, c);return b.reload();
    }));
  };
  k.tb = function (a) {
    if (void 0 === a.displayName && void 0 === a.photoURL) return Ll(this);var b = this;return Q(this, this.F().then(function (c) {
      return b.c.tb(c, { displayName: a.displayName, photoUrl: a.photoURL });
    }).then(function (c) {
      Tl(b, c);Pl(b, "displayName", c.displayName || null);Pl(b, "photoURL", c.photoUrl || null);x(b.providerData, function (d) {
        "password" === d.providerId && (K(d, "displayName", b.displayName), K(d, "photoURL", b.photoURL));
      });return Il(b);
    }).then(Kl));
  };
  k.Nc = function (a) {
    var b = this;return Q(this, Rl(this).then(function (c) {
      return Ma(Ml(b), a) ? Gi(b.c, c, [a]).then(function (d) {
        var e = {};x(d.providerUserInfo || [], function (f) {
          e[f.providerId] = !0;
        });x(Ml(b), function (f) {
          e[f] || Ol(b, f);
        });e[Ig.PROVIDER_ID] || K(b, "phoneNumber", null);return Il(b);
      }) : Il(b).then(function () {
        throw new M("no-such-provider");
      });
    }));
  };
  k.delete = function () {
    var a = this;return Q(this, this.F().then(function (b) {
      return O(a.c, Ui, { idToken: b });
    }).then(function () {
      a.dispatchEvent(new xl("userDeleted"));
    })).then(function () {
      for (var b = 0; b < a.G.length; b++) {
        a.G[b].cancel("app-deleted");
      }Cl(a, null);Dl(a, null);a.G = [];a.D = !0;Gl(a);K(a, "refreshToken", null);a.a && a.a.unsubscribe(a);
    });
  };
  k.xb = function (a, b) {
    return "linkViaPopup" == a && (this.g || null) == b && this.f || "reauthViaPopup" == a && (this.g || null) == b && this.f || "linkViaRedirect" == a && (this.aa || null) == b || "reauthViaRedirect" == a && (this.aa || null) == b ? !0 : !1;
  };k.ha = function (a, b, c, d) {
    "linkViaPopup" != a && "reauthViaPopup" != a || d != (this.g || null) || (c && this.v ? this.v(c) : b && !c && this.f && this.f(b), this.b && (this.b.cancel(), this.b = null), delete this.f, delete this.v);
  };
  k.xa = function (a, b) {
    return "linkViaPopup" == a && b == (this.g || null) ? t(this.Bb, this) : "reauthViaPopup" == a && b == (this.g || null) ? t(this.Cb, this) : "linkViaRedirect" == a && (this.aa || null) == b ? t(this.Bb, this) : "reauthViaRedirect" == a && (this.aa || null) == b ? t(this.Cb, this) : null;
  };k.rc = function (a) {
    var b = this;return Yl(this, "linkViaPopup", a, function () {
      return Wl(b, a.providerId).then(function () {
        return Il(b);
      });
    }, !1);
  };k.Ac = function (a) {
    return Yl(this, "reauthViaPopup", a, function () {
      return D();
    }, !0);
  };
  function Yl(a, b, c, d, e) {
    if (!Ee()) return E(new M("operation-not-supported-in-this-environment"));if (a.i && !e) return E(a.i);var f = Nf(c.providerId),
        g = De(a.uid + ":::"),
        h = null;(!Ge() || ve()) && a.u && c.isOAuthProvider && (h = pj(a.u, a.l, a.o, b, c, null, g, __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION || null));var m = me(h, f && f.Ba, f && f.Aa);d = d().then(function () {
      Zl(a);if (!e) return a.F().then(function () {});
    }).then(function () {
      return $k(a.a, m, b, c, g, !!h);
    }).then(function () {
      return new C(function (p, v) {
        a.ha(b, null, new M("cancelled-popup-request"), a.g || null);
        a.f = p;a.v = v;a.g = g;a.b = a.a.Ea(a, b, m, g);
      });
    }).then(function (p) {
      m && le(m);return p ? Xe(p) : null;
    }).s(function (p) {
      m && le(m);throw p;
    });return Q(a, d, e);
  }k.sc = function (a) {
    var b = this;return $l(this, "linkViaRedirect", a, function () {
      return Wl(b, a.providerId);
    }, !1);
  };k.Bc = function (a) {
    return $l(this, "reauthViaRedirect", a, function () {
      return D();
    }, !0);
  };
  function $l(a, b, c, d, e) {
    if (!Ee()) return E(new M("operation-not-supported-in-this-environment"));if (a.i && !e) return E(a.i);var f = null,
        g = De(a.uid + ":::");d = d().then(function () {
      Zl(a);if (!e) return a.F().then(function () {});
    }).then(function () {
      a.aa = g;return Il(a);
    }).then(function (h) {
      a.ba && (h = a.ba, h = h.b.set(am, a.w(), h.a));return h;
    }).then(function () {
      return a.a.Ca(b, c, g);
    }).s(function (h) {
      f = h;if (a.ba) return bm(a.ba);throw f;
    }).then(function () {
      if (f) throw f;
    });return Q(a, d, e);
  }
  function Zl(a) {
    if (!a.a || !a.I) {
      if (a.a && !a.I) throw new M("internal-error");throw new M("auth-domain-config-required");
    }
  }k.Bb = function (a, b, c) {
    var d = this;this.b && (this.b.cancel(), this.b = null);var e = null,
        f = this.F().then(function (g) {
      return eg(d.c, { requestUri: a, postBody: c, sessionId: b, idToken: g });
    }).then(function (g) {
      e = Vl(d, g, "link");return Xl(d, g);
    }).then(function () {
      return e;
    });return Q(this, f);
  };
  k.Cb = function (a, b, c) {
    var d = this;this.b && (this.b.cancel(), this.b = null);var e = null,
        f = D().then(function () {
      return $f(fg(d.c, { requestUri: a, sessionId: b, postBody: c }), d.uid);
    }).then(function (g) {
      e = Vl(d, g, "reauthenticate");Tl(d, g);d.i = null;return d.reload();
    }).then(function () {
      return e;
    });return Q(this, f, !0);
  };k.jb = function (a) {
    var b = this,
        c = null;return Q(this, this.F().then(function (d) {
      c = d;return "undefined" === typeof a || cb(a) ? {} : xf(new nf(a));
    }).then(function (d) {
      return b.c.jb(c, d);
    }).then(function (d) {
      if (b.email != d) return b.reload();
    }).then(function () {}));
  };
  function Q(a, b, c) {
    var d = cm(a, b, c);a.G.push(d);d.ia(function () {
      Na(a.G, d);
    });return d;
  }function cm(a, b, c) {
    return a.i && !c ? (b.cancel(), E(a.i)) : b.s(function (d) {
      !d || "auth/user-disabled" != d.code && "auth/user-token-expired" != d.code || (a.i || a.dispatchEvent(new xl("userInvalidated")), a.i = d);throw d;
    });
  }k.toJSON = function () {
    return this.w();
  };
  k.w = function () {
    var a = { uid: this.uid, displayName: this.displayName, photoURL: this.photoURL, email: this.email, emailVerified: this.emailVerified, phoneNumber: this.phoneNumber, isAnonymous: this.isAnonymous, providerData: [], apiKey: this.l, appName: this.o, authDomain: this.u, stsTokenManager: this.h.w(), redirectEventId: this.aa || null };this.metadata && fb(a, this.metadata.w());x(this.providerData, function (b) {
      a.providerData.push(Ye(b));
    });return a;
  };
  function dm(a) {
    if (!a.apiKey) return null;var b = { apiKey: a.apiKey, authDomain: a.authDomain, appName: a.appName },
        c = {};if (a.stsTokenManager && a.stsTokenManager.accessToken && a.stsTokenManager.expirationTime) c[ag] = a.stsTokenManager.accessToken, c.refreshToken = a.stsTokenManager.refreshToken || null, c.expiresIn = (a.stsTokenManager.expirationTime - va()) / 1E3;else return null;var d = new P(b, c, a);a.providerData && x(a.providerData, function (e) {
      e && Nl(d, Xe(e));
    });a.redirectEventId && (d.aa = a.redirectEventId);return d;
  }
  function em(a, b, c, d) {
    var e = new P(a, b);c && (e.ba = c);d && Bl(e, d);return e.reload().then(function () {
      return e;
    });
  }function fm(a, b, c, d) {
    b = b || { apiKey: a.l, authDomain: a.u, appName: a.o };var e = a.h,
        f = {};f[ag] = e.b;f.refreshToken = e.a;f.expiresIn = (e.c - va()) / 1E3;b = new P(b, f);c && (b.ba = c);d && Bl(b, d);Ql(b, a);return b;
  };function gm(a) {
    this.a = a;this.b = ek();
  }var am = { name: "redirectUser", B: "session" };function bm(a) {
    return ik(a.b, am, a.a);
  }function hm(a, b) {
    return a.b.get(am, a.a).then(function (c) {
      c && b && (c.authDomain = b);return dm(c || {});
    });
  };function im(a) {
    this.a = a;this.b = ek();this.c = null;this.f = jm(this);this.b.addListener(km("local"), this.a, t(this.g, this));
  }im.prototype.g = function () {
    var a = this,
        b = km("local");lm(this, function () {
      return D().then(function () {
        return a.c && "local" != a.c.B ? a.b.get(b, a.a) : null;
      }).then(function (c) {
        if (c) return mm(a, "local").then(function () {
          a.c = b;
        });
      });
    });
  };function mm(a, b) {
    var c = [],
        d;for (d in ak) {
      ak[d] !== b && c.push(ik(a.b, km(ak[d]), a.a));
    }c.push(ik(a.b, nm, a.a));return Ab(c);
  }
  function jm(a) {
    var b = km("local"),
        c = km("session"),
        d = km("none");return hk(a.b, b, a.a).then(function () {
      return a.b.get(c, a.a);
    }).then(function (e) {
      return e ? c : a.b.get(d, a.a).then(function (f) {
        return f ? d : a.b.get(b, a.a).then(function (g) {
          return g ? b : a.b.get(nm, a.a).then(function (h) {
            return h ? km(h) : b;
          });
        });
      });
    }).then(function (e) {
      a.c = e;return mm(a, e.B);
    }).s(function () {
      a.c || (a.c = b);
    });
  }var nm = { name: "persistence", B: "session" };function km(a) {
    return { name: "authUser", B: a };
  }
  im.prototype.mb = function (a) {
    var b = null,
        c = this;bk(a);return lm(this, function () {
      return a != c.c.B ? c.b.get(c.c, c.a).then(function (d) {
        b = d;return mm(c, a);
      }).then(function () {
        c.c = km(a);if (b) return c.b.set(c.c, b, c.a);
      }) : D();
    });
  };function om(a) {
    return lm(a, function () {
      return a.b.set(nm, a.c.B, a.a);
    });
  }function pm(a, b) {
    return lm(a, function () {
      return a.b.set(a.c, b.w(), a.a);
    });
  }function qm(a) {
    return lm(a, function () {
      return ik(a.b, a.c, a.a);
    });
  }
  function rm(a, b) {
    return lm(a, function () {
      return a.b.get(a.c, a.a).then(function (c) {
        c && b && (c.authDomain = b);return dm(c || {});
      });
    });
  }function lm(a, b) {
    a.f = a.f.then(b, b);return a.f;
  };function sm(a) {
    this.l = !1;K(this, "settings", new il());K(this, "app", a);if (R(this).options && R(this).options.apiKey) a = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION ? Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION) : null, this.c = new bi(R(this).options && R(this).options.apiKey, If(Jf), a);else throw new M("invalid-api-key");this.N = [];this.o = [];this.I = [];this.Sb = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.mc, this));this.O = void 0;this.Tb = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.createSubscribe(t(this.nc, this));tm(this, null);this.h = new im(R(this).options.apiKey + ":" + R(this).name);this.A = new gm(R(this).options.apiKey + ":" + R(this).name);this.V = S(this, um(this));this.i = S(this, vm(this));this.X = !1;this.ka = t(this.Kc, this);this.Ha = t(this.Z, this);this.ra = t(this.$b, this);this.sa = t(this.jc, this);this.ta = t(this.kc, this);wm(this);this.INTERNAL = {};this.INTERNAL["delete"] = t(this.delete, this);this.INTERNAL.logFramework = t(this.tc, this);this.u = 0;F.call(this);xm(this);this.G = [];
  }u(sm, F);function ym(a) {
    kc.call(this, "languageCodeChanged");this.g = a;
  }u(ym, kc);
  function zm(a) {
    kc.call(this, "frameworkChanged");this.c = a;
  }u(zm, kc);k = sm.prototype;k.mb = function (a) {
    a = this.h.mb(a);return S(this, a);
  };k.pa = function (a) {
    this.W === a || this.l || (this.W = a, hi(this.c, this.W), this.dispatchEvent(new ym(this.ea())));
  };k.ea = function () {
    return this.W;
  };k.Qc = function () {
    var a = l.navigator;this.pa(a ? a.languages && a.languages[0] || a.language || a.userLanguage || null : null);
  };k.tc = function (a) {
    this.G.push(a);ii(this.c, __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION ? Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION, this.G) : null);this.dispatchEvent(new zm(this.G));
  };
  k.ya = function () {
    return Pa(this.G);
  };function xm(a) {
    Object.defineProperty(a, "lc", { get: function get() {
        return this.ea();
      }, set: function set(b) {
        this.pa(b);
      }, enumerable: !1 });a.W = null;
  }k.toJSON = function () {
    return { apiKey: R(this).options.apiKey, authDomain: R(this).options.authDomain, appName: R(this).name, currentUser: T(this) && T(this).w() };
  };function Am(a) {
    return a.Rb || E(new M("auth-domain-config-required"));
  }
  function wm(a) {
    var b = R(a).options.authDomain,
        c = R(a).options.apiKey;b && Ee() && (a.Rb = a.V.then(function () {
      if (!a.l) {
        a.a = bl(b, c, R(a).name);a.a.subscribe(a);T(a) && Jl(T(a));if (a.D) {
          Jl(a.D);var d = a.D;d.pa(a.ea());Cl(d, a);d = a.D;Bl(d, a.G);Dl(d, a);a.D = null;
        }return a.a;
      }
    }));
  }k.xb = function (a, b) {
    switch (a) {case "unknown":case "signInViaRedirect":
        return !0;case "signInViaPopup":
        return this.g == b && !!this.f;default:
        return !1;}
  };
  k.ha = function (a, b, c, d) {
    "signInViaPopup" == a && this.g == d && (c && this.v ? this.v(c) : b && !c && this.f && this.f(b), this.b && (this.b.cancel(), this.b = null), delete this.f, delete this.v);
  };k.xa = function (a, b) {
    return "signInViaRedirect" == a || "signInViaPopup" == a && this.g == b && this.f ? t(this.Zb, this) : null;
  };
  k.Zb = function (a, b, c) {
    var d = this;a = { requestUri: a, postBody: c, sessionId: b };this.b && (this.b.cancel(), this.b = null);var e = null,
        f = null,
        g = cg(d.c, a).then(function (h) {
      e = Lg(h);f = Of(h);return h;
    });a = d.V.then(function () {
      return g;
    }).then(function (h) {
      return Bm(d, h);
    }).then(function () {
      return Xe({ user: T(d), credential: e, additionalUserInfo: f, operationType: "signIn" });
    });return S(this, a);
  };
  k.Ic = function (a) {
    if (!Ee()) return E(new M("operation-not-supported-in-this-environment"));var b = this,
        c = Nf(a.providerId),
        d = De(),
        e = null;(!Ge() || ve()) && R(this).options.authDomain && a.isOAuthProvider && (e = pj(R(this).options.authDomain, R(this).options.apiKey, R(this).name, "signInViaPopup", a, null, d, __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION || null));var f = me(e, c && c.Ba, c && c.Aa);c = Am(this).then(function (g) {
      return $k(g, f, "signInViaPopup", a, d, !!e);
    }).then(function () {
      return new C(function (g, h) {
        b.ha("signInViaPopup", null, new M("cancelled-popup-request"), b.g);b.f = g;b.v = h;b.g = d;b.b = b.a.Ea(b, "signInViaPopup", f, d);
      });
    }).then(function (g) {
      f && le(f);return g ? Xe(g) : null;
    }).s(function (g) {
      f && le(f);throw g;
    });return S(this, c);
  };k.Jc = function (a) {
    if (!Ee()) return E(new M("operation-not-supported-in-this-environment"));var b = this,
        c = Am(this).then(function () {
      return om(b.h);
    }).then(function () {
      return b.a.Ca("signInViaRedirect", a);
    });return S(this, c);
  };
  k.fa = function () {
    if (!Ee()) return E(new M("operation-not-supported-in-this-environment"));var a = this,
        b = Am(this).then(function () {
      return a.a.fa();
    }).then(function (c) {
      return c ? Xe(c) : null;
    });return S(this, b);
  };
  k.Oc = function (a) {
    if (!a) return E(new M("null-user"));var b = this,
        c = {};c.apiKey = R(this).options.apiKey;c.authDomain = R(this).options.authDomain;c.appName = R(this).name;var d = fm(a, c, b.A, b.ya());return S(this, this.i.then(function () {
      if (R(b).options.apiKey != a.l) return d.reload();
    }).then(function () {
      if (T(b) && a.uid == T(b).uid) return Ql(T(b), a), b.Z(a);tm(b, d);Jl(d);return b.Z(d);
    }).then(function () {
      Cm(b);
    }));
  };
  function Bm(a, b) {
    var c = {};c.apiKey = R(a).options.apiKey;c.authDomain = R(a).options.authDomain;c.appName = R(a).name;return a.V.then(function () {
      return em(c, b, a.A, a.ya());
    }).then(function (d) {
      if (T(a) && d.uid == T(a).uid) return Ql(T(a), d), a.Z(d);tm(a, d);Jl(d);return a.Z(d);
    }).then(function () {
      Cm(a);
    });
  }
  function tm(a, b) {
    T(a) && (Hl(T(a), a.Ha), Hc(T(a), "tokenChanged", a.ra), Hc(T(a), "userDeleted", a.sa), Hc(T(a), "userInvalidated", a.ta), Gl(T(a)));b && (b.N.push(a.Ha), xc(b, "tokenChanged", a.ra), xc(b, "userDeleted", a.sa), xc(b, "userInvalidated", a.ta), 0 < a.u && Fl(b));K(a, "currentUser", b);b && (b.pa(a.ea()), Cl(b, a), Bl(b, a.G), Dl(b, a));
  }k.pb = function () {
    var a = this,
        b = this.i.then(function () {
      if (!T(a)) return D();tm(a, null);return qm(a.h).then(function () {
        Cm(a);
      });
    });return S(this, b);
  };
  function Dm(a) {
    var b = hm(a.A, R(a).options.authDomain).then(function (c) {
      if (a.D = c) c.ba = a.A;return bm(a.A);
    });return S(a, b);
  }function um(a) {
    var b = R(a).options.authDomain,
        c = Dm(a).then(function () {
      return rm(a.h, b);
    }).then(function (d) {
      return d ? (d.ba = a.A, a.D && (a.D.aa || null) == (d.aa || null) ? d : d.reload().then(function () {
        return pm(a.h, d).then(function () {
          return d;
        });
      }).s(function (e) {
        return "auth/network-request-failed" == e.code ? d : qm(a.h);
      })) : null;
    }).then(function (d) {
      tm(a, d || null);
    });return S(a, c);
  }
  function vm(a) {
    return a.V.then(function () {
      return a.fa();
    }).s(function () {}).then(function () {
      if (!a.l) return a.ka();
    }).s(function () {}).then(function () {
      if (!a.l) {
        a.X = !0;var b = a.h;b.b.addListener(km("local"), b.a, a.ka);
      }
    });
  }
  k.Kc = function () {
    var a = this;return rm(this.h, R(this).options.authDomain).then(function (b) {
      if (!a.l) {
        var c;if (c = T(a) && b) {
          c = T(a).uid;var d = b.uid;c = void 0 === c || null === c || "" === c || void 0 === d || null === d || "" === d ? !1 : c == d;
        }if (c) return Ql(T(a), b), T(a).F();if (T(a) || b) tm(a, b), b && (Jl(b), b.ba = a.A), a.a && a.a.subscribe(a), Cm(a);
      }
    });
  };k.Z = function (a) {
    return pm(this.h, a);
  };k.$b = function () {
    Cm(this);this.Z(T(this));
  };k.jc = function () {
    this.pb();
  };k.kc = function () {
    this.pb();
  };
  function Em(a, b) {
    var c = null,
        d = null;return S(a, b.then(function (e) {
      c = Lg(e);d = Of(e);return Bm(a, e);
    }).then(function () {
      return Xe({ user: T(a), credential: c, additionalUserInfo: d, operationType: "signIn" });
    }));
  }k.mc = function (a) {
    var b = this;this.addAuthTokenListener(function () {
      a.next(T(b));
    });
  };k.nc = function (a) {
    var b = this;Fm(this, function () {
      a.next(T(b));
    });
  };k.vc = function (a, b, c) {
    var d = this;this.X && Promise.resolve().then(function () {
      q(a) ? a(T(d)) : q(a.next) && a.next(T(d));
    });return this.Sb(a, b, c);
  };
  k.uc = function (a, b, c) {
    var d = this;this.X && Promise.resolve().then(function () {
      d.O = d.getUid();q(a) ? a(T(d)) : q(a.next) && a.next(T(d));
    });return this.Tb(a, b, c);
  };k.ac = function (a) {
    var b = this,
        c = this.i.then(function () {
      return T(b) ? T(b).F(a).then(function (d) {
        return { accessToken: d };
      }) : null;
    });return S(this, c);
  };k.Ec = function (a) {
    var b = this;return this.i.then(function () {
      return Em(b, O(b.c, Xi, { token: a }));
    }).then(function (c) {
      var d = c.user;Pl(d, "isAnonymous", !1);b.Z(d);return c;
    });
  };
  k.Fc = function (a, b) {
    var c = this;return this.i.then(function () {
      return Em(c, O(c.c, xg, { email: a, password: b }));
    });
  };k.Vb = function (a, b) {
    var c = this;return this.i.then(function () {
      return Em(c, O(c.c, Ti, { email: a, password: b }));
    });
  };k.Nb = function (a) {
    var b = this;return this.i.then(function () {
      return Em(b, a.la(b.c));
    });
  };k.nb = function (a) {
    Ue("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Nb(a);
  };
  k.ob = function () {
    var a = this;return this.i.then(function () {
      var b = T(a);if (b && b.isAnonymous) {
        var c = Xe({ providerId: null, isNewUser: !1 });return Xe({ user: b, credential: null, additionalUserInfo: c, operationType: "signIn" });
      }return Em(a, a.c.ob()).then(function (d) {
        var e = d.user;Pl(e, "isAnonymous", !0);a.Z(e);return d;
      });
    });
  };function R(a) {
    return a.app;
  }function T(a) {
    return a.currentUser;
  }k.getUid = function () {
    return T(this) && T(this).uid || null;
  };function Gm(a) {
    return T(a) && T(a)._lat || null;
  }
  function Cm(a) {
    if (a.X) {
      for (var b = 0; b < a.o.length; b++) {
        if (a.o[b]) a.o[b](Gm(a));
      }if (a.O !== a.getUid() && a.I.length) for (a.O = a.getUid(), b = 0; b < a.I.length; b++) {
        if (a.I[b]) a.I[b](Gm(a));
      }
    }
  }k.Ub = function (a) {
    this.addAuthTokenListener(a);this.u++;0 < this.u && T(this) && Fl(T(this));
  };k.Cc = function (a) {
    var b = this;x(this.o, function (c) {
      c == a && b.u--;
    });0 > this.u && (this.u = 0);0 == this.u && T(this) && Gl(T(this));this.removeAuthTokenListener(a);
  };
  k.addAuthTokenListener = function (a) {
    var b = this;this.o.push(a);S(this, this.i.then(function () {
      b.l || Ma(b.o, a) && a(Gm(b));
    }));
  };k.removeAuthTokenListener = function (a) {
    y(this.o, function (b) {
      return b == a;
    });
  };function Fm(a, b) {
    a.I.push(b);S(a, a.i.then(function () {
      !a.l && Ma(a.I, b) && a.O !== a.getUid() && (a.O = a.getUid(), b(Gm(a)));
    }));
  }
  k.delete = function () {
    this.l = !0;for (var a = 0; a < this.N.length; a++) {
      this.N[a].cancel("app-deleted");
    }this.N = [];this.h && (a = this.h, a.b.removeListener(km("local"), a.a, this.ka));this.a && (this.a.unsubscribe(this), this.a.Ya());return Promise.resolve();
  };function S(a, b) {
    a.N.push(b);b.ia(function () {
      Na(a.N, b);
    });return b;
  }k.Yb = function (a) {
    return S(this, si(this.c, a));
  };k.oc = function (a) {
    return !!Cg(a);
  };
  k.lb = function (a, b) {
    var c = this;return S(this, D().then(function () {
      var d = new nf(b);if (!d.c) throw new M("argument-error", vf + " must be true when sending sign in link to email");return xf(d);
    }).then(function (d) {
      return c.c.lb(a, d);
    }).then(function () {}));
  };k.Rc = function (a) {
    return this.Ka(a).then(function (b) {
      return b.data.email;
    });
  };k.Za = function (a, b) {
    return S(this, this.c.Za(a, b).then(function () {}));
  };k.Ka = function (a) {
    return S(this, this.c.Ka(a).then(function (b) {
      return new af(b);
    }));
  };
  k.Wa = function (a) {
    return S(this, this.c.Wa(a).then(function () {}));
  };k.kb = function (a, b) {
    var c = this;return S(this, D().then(function () {
      return "undefined" === typeof b || cb(b) ? {} : xf(new nf(b));
    }).then(function (d) {
      return c.c.kb(a, d);
    }).then(function () {}));
  };k.Hc = function (a, b) {
    return S(this, kl(this, a, b, t(this.nb, this)));
  };k.Gc = function (a, b) {
    var c = this;return S(this, D().then(function () {
      var d = Bg(a, b || ee());return c.nb(d);
    }));
  };function Hm() {}Hm.prototype.render = function () {};Hm.prototype.reset = function () {};Hm.prototype.getResponse = function () {};Hm.prototype.execute = function () {};function Im() {
    this.a = {};this.b = 1E12;
  }var Jm = null;Im.prototype.render = function (a, b) {
    this.a[this.b.toString()] = new Km(a, b);return this.b++;
  };Im.prototype.reset = function (a) {
    var b = Lm(this, a);a = Mm(a);b && a && (b.delete(), delete this.a[a]);
  };Im.prototype.getResponse = function (a) {
    return (a = Lm(this, a)) ? a.getResponse() : null;
  };Im.prototype.execute = function (a) {
    (a = Lm(this, a)) && a.execute();
  };function Lm(a, b) {
    return (b = Mm(b)) ? a.a[b] || null : null;
  }function Mm(a) {
    return (a = "undefined" === typeof a ? 1E12 : a) ? a.toString() : null;
  }
  function Km(a, b) {
    this.g = !1;this.c = b;this.a = this.b = null;this.h = "invisible" !== this.c.size;this.f = Sd(a);var c = this;this.i = function () {
      c.execute();
    };this.h ? this.execute() : xc(this.f, "click", this.i);
  }Km.prototype.getResponse = function () {
    Nm(this);return this.b;
  };
  Km.prototype.execute = function () {
    Nm(this);var a = this;this.a || (this.a = setTimeout(function () {
      a.b = ze();var b = a.c.callback,
          c = a.c["expired-callback"];if (b) try {
        b(a.b);
      } catch (d) {}a.a = setTimeout(function () {
        a.a = null;a.b = null;if (c) try {
          c();
        } catch (d) {}a.h && a.execute();
      }, 6E4);
    }, 500));
  };Km.prototype.delete = function () {
    Nm(this);this.g = !0;clearTimeout(this.a);this.a = null;Hc(this.f, "click", this.i);
  };function Nm(a) {
    if (a.g) throw Error("reCAPTCHA mock was already deleted!");
  };function Om() {}Om.prototype.g = function () {
    Jm || (Jm = new Im());return D(Jm);
  };Om.prototype.c = function () {};var Pm = null;function Qm() {
    this.b = l.grecaptcha ? Infinity : 0;this.f = null;this.a = "__rcb" + Math.floor(1E6 * Math.random()).toString();
  }var Rm = new wd(xd, "https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),
      Sm = new Me(3E4, 6E4);
  Qm.prototype.g = function (a) {
    var b = this;return new C(function (c, d) {
      var e = setTimeout(function () {
        d(new M("network-request-failed"));
      }, Sm.get());if (!l.grecaptcha || a !== b.f && !b.b) {
        l[b.a] = function () {
          if (l.grecaptcha) {
            b.f = a;var g = l.grecaptcha.render;l.grecaptcha.render = function (h, m) {
              h = g(h, m);b.b++;return h;
            };clearTimeout(e);c(l.grecaptcha);
          } else clearTimeout(e), d(new M("internal-error"));delete l[b.a];
        };var f = Dd(Rm, { onload: b.a, hl: a || "" });D(Vh(f)).s(function () {
          clearTimeout(e);d(new M("internal-error", "Unable to load external reCAPTCHA dependencies!"));
        });
      } else clearTimeout(e), c(l.grecaptcha);
    });
  };Qm.prototype.c = function () {
    this.b--;
  };var Tm = null;function Um(a, b, c, d, e, f, g) {
    K(this, "type", "recaptcha");this.c = this.f = null;this.D = !1;this.l = b;this.g = null;g ? (Pm || (Pm = new Om()), g = Pm) : (Tm || (Tm = new Qm()), g = Tm);this.o = g;this.a = c || { theme: "light", type: "image" };this.h = [];if (this.a[Vm]) throw new M("argument-error", "sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i = "invisible" === this.a[Wm];if (!l.document) throw new M("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
    if (!Sd(b) || !this.i && Sd(b).hasChildNodes()) throw new M("argument-error", "reCAPTCHA container is either not found or already contains inner elements!");this.u = new bi(a, f || null, e || null);this.v = d || function () {
      return null;
    };var h = this;this.m = [];var m = this.a[Xm];this.a[Xm] = function (v) {
      Ym(h, v);if ("function" === typeof m) m(v);else if ("string" === typeof m) {
        var z = J(m, l);"function" === typeof z && z(v);
      }
    };var p = this.a[Zm];this.a[Zm] = function () {
      Ym(h, null);if ("function" === typeof p) p();else if ("string" === typeof p) {
        var v = J(p, l);"function" === typeof v && v();
      }
    };
  }var Xm = "callback",
      Zm = "expired-callback",
      Vm = "sitekey",
      Wm = "size";function Ym(a, b) {
    for (var c = 0; c < a.m.length; c++) {
      try {
        a.m[c](b);
      } catch (d) {}
    }
  }function $m(a, b) {
    y(a.m, function (c) {
      return c == b;
    });
  }function an(a, b) {
    a.h.push(b);b.ia(function () {
      Na(a.h, b);
    });return b;
  }k = Um.prototype;
  k.za = function () {
    var a = this;return this.f ? this.f : this.f = an(this, D().then(function () {
      if (Fe() && !we()) return re();throw new M("operation-not-supported-in-this-environment", "RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");
    }).then(function () {
      return a.o.g(a.v());
    }).then(function (b) {
      a.g = b;return O(a.u, Wi, {});
    }).then(function (b) {
      a.a[Vm] = b.recaptchaSiteKey;
    }).s(function (b) {
      a.f = null;throw b;
    }));
  };
  k.render = function () {
    bn(this);var a = this;return an(this, this.za().then(function () {
      if (null === a.c) {
        var b = a.l;if (!a.i) {
          var c = Sd(b);b = Vd("DIV");c.appendChild(b);
        }a.c = a.g.render(b, a.a);
      }return a.c;
    }));
  };k.verify = function () {
    bn(this);var a = this;return an(this, this.render().then(function (b) {
      return new C(function (c) {
        var d = a.g.getResponse(b);if (d) c(d);else {
          var e = function e(f) {
            f && ($m(a, e), c(f));
          };a.m.push(e);a.i && a.g.execute(a.c);
        }
      });
    }));
  };k.reset = function () {
    bn(this);null !== this.c && this.g.reset(this.c);
  };
  function bn(a) {
    if (a.D) throw new M("internal-error", "RecaptchaVerifier instance has been destroyed.");
  }k.clear = function () {
    bn(this);this.D = !0;this.o.c();for (var a = 0; a < this.h.length; a++) {
      this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");
    }if (!this.i) {
      a = Sd(this.l);for (var b; b = a.firstChild;) {
        a.removeChild(b);
      }
    }
  };
  function cn(a, b, c) {
    var d = !1;try {
      this.b = c || __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app();
    } catch (g) {
      throw new M("argument-error", "No firebase.app.App instance is currently initialized.");
    }if (this.b.options && this.b.options.apiKey) c = this.b.options.apiKey;else throw new M("invalid-api-key");var e = this,
        f = null;try {
      f = this.b.auth().ya();
    } catch (g) {}try {
      d = this.b.auth().settings.appVerificationDisabledForTesting;
    } catch (g) {}f = __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION ? Be(__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.SDK_VERSION, f) : null;Um.call(this, c, a, b, function () {
      try {
        var g = e.b.auth().ea();
      } catch (h) {
        g = null;
      }return g;
    }, f, If(Jf), d);
  }u(cn, Um);function dn(a, b, c, d) {
    a: {
      c = Array.prototype.slice.call(c);var e = 0;for (var f = !1, g = 0; g < b.length; g++) {
        if (b[g].optional) f = !0;else {
          if (f) throw new M("internal-error", "Argument validator encountered a required argument after an optional argument.");e++;
        }
      }f = b.length;if (c.length < e || f < c.length) d = "Expected " + (e == f ? 1 == e ? "1 argument" : e + " arguments" : e + "-" + f + " arguments") + " but got " + c.length + ".";else {
        for (e = 0; e < c.length; e++) {
          if (f = b[e].optional && void 0 === c[e], !b[e].M(c[e]) && !f) {
            b = b[e];if (0 > e || e >= en.length) throw new M("internal-error", "Argument validator received an unsupported number of arguments.");c = en[e];d = (d ? "" : c + " argument ") + (b.name ? '"' + b.name + '" ' : "") + "must be " + b.K + ".";break a;
          }
        }d = null;
      }
    }if (d) throw new M("argument-error", a + " failed: " + d);
  }var en = "First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a, b) {
    return { name: a || "", K: "a valid string", optional: !!b, M: n };
  }function fn(a, b) {
    return { name: a || "", K: "a boolean", optional: !!b, M: ha };
  }
  function W(a, b) {
    return { name: a || "", K: "a valid object", optional: !!b, M: r };
  }function gn(a, b) {
    return { name: a || "", K: "a function", optional: !!b, M: q };
  }function hn(a, b) {
    return { name: a || "", K: "null", optional: !!b, M: ma };
  }function jn() {
    return { name: "", K: "an HTML element", optional: !1, M: function M(a) {
        return !!(a && a instanceof Element);
      } };
  }function kn() {
    return { name: "auth", K: "an instance of Firebase Auth", optional: !0, M: function M(a) {
        return !!(a && a instanceof sm);
      } };
  }
  function ln() {
    return { name: "app", K: "an instance of Firebase App", optional: !0, M: function M(a) {
        return !!(a && a instanceof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.app.App);
      } };
  }function mn(a) {
    return { name: a ? a + "Credential" : "credential", K: a ? "a valid " + a + " credential" : "a valid credential", optional: !1, M: function M(b) {
        if (!b) return !1;var c = !a || b.providerId === a;return !(!b.la || !c);
      } };
  }
  function nn() {
    return { name: "authProvider", K: "a valid Auth provider", optional: !1, M: function M(a) {
        return !!(a && a.providerId && a.hasOwnProperty && a.hasOwnProperty("isOAuthProvider"));
      } };
  }function on() {
    return { name: "applicationVerifier", K: "an implementation of firebase.auth.ApplicationVerifier", optional: !1, M: function M(a) {
        return !!(a && n(a.type) && q(a.verify));
      } };
  }function X(a, b, c, d) {
    return { name: c || "", K: a.K + " or " + b.K, optional: !!d, M: function M(e) {
        return a.M(e) || b.M(e);
      } };
  };function Y(a, b) {
    for (var c in b) {
      var d = b[c].name;a[d] = pn(d, a[c], b[c].j);
    }
  }function qn(a, b) {
    for (var c in b) {
      var d = b[c].name;d !== c && Object.defineProperty(a, d, { get: ua(function (e) {
          return this[e];
        }, c), set: ua(function (e, f, g, h) {
          dn(e, [g], [h], !0);this[f] = h;
        }, d, c, b[c].vb), enumerable: !0 });
    }
  }function Z(a, b, c, d) {
    a[b] = pn(b, c, d);
  }
  function pn(a, b, c) {
    function d() {
      var g = Array.prototype.slice.call(arguments);dn(e, c, g);return b.apply(this, g);
    }if (!c) return b;var e = rn(a),
        f;for (f in b) {
      d[f] = b[f];
    }for (f in b.prototype) {
      d.prototype[f] = b.prototype[f];
    }return d;
  }function rn(a) {
    a = a.split(".");return a[a.length - 1];
  };Y(sm.prototype, { Wa: { name: "applyActionCode", j: [V("code")] }, Ka: { name: "checkActionCode", j: [V("code")] }, Za: { name: "confirmPasswordReset", j: [V("code"), V("newPassword")] }, Vb: { name: "createUserWithEmailAndPassword", j: [V("email"), V("password")] }, Yb: { name: "fetchSignInMethodsForEmail", j: [V("email")] }, fa: { name: "getRedirectResult", j: [] }, oc: { name: "isSignInWithEmailLink", j: [V("emailLink")] }, uc: { name: "onAuthStateChanged", j: [X(W(), gn(), "nextOrObserver"), gn("opt_error", !0), gn("opt_completed", !0)] }, vc: { name: "onIdTokenChanged",
      j: [X(W(), gn(), "nextOrObserver"), gn("opt_error", !0), gn("opt_completed", !0)] }, kb: { name: "sendPasswordResetEmail", j: [V("email"), X(W("opt_actionCodeSettings", !0), hn(null, !0), "opt_actionCodeSettings", !0)] }, lb: { name: "sendSignInLinkToEmail", j: [V("email"), W("actionCodeSettings")] }, mb: { name: "setPersistence", j: [V("persistence")] }, nb: { name: "signInAndRetrieveDataWithCredential", j: [mn()] }, ob: { name: "signInAnonymously", j: [] }, Nb: { name: "signInWithCredential", j: [mn()] }, Ec: { name: "signInWithCustomToken", j: [V("token")] },
    Fc: { name: "signInWithEmailAndPassword", j: [V("email"), V("password")] }, Gc: { name: "signInWithEmailLink", j: [V("email"), V("emailLink", !0)] }, Hc: { name: "signInWithPhoneNumber", j: [V("phoneNumber"), on()] }, Ic: { name: "signInWithPopup", j: [nn()] }, Jc: { name: "signInWithRedirect", j: [nn()] }, Oc: { name: "updateCurrentUser", j: [X(function (a) {
        return { name: "user", K: "an instance of Firebase User", optional: !!a, M: function M(b) {
            return !!(b && b instanceof P);
          } };
      }(), hn(), "user")] }, pb: { name: "signOut", j: [] }, toJSON: { name: "toJSON", j: [V(null, !0)] },
    Qc: { name: "useDeviceLanguage", j: [] }, Rc: { name: "verifyPasswordResetCode", j: [V("code")] } });qn(sm.prototype, { lc: { name: "languageCode", vb: X(V(), hn(), "languageCode") } });sm.Persistence = ak;sm.Persistence.LOCAL = "local";sm.Persistence.SESSION = "session";sm.Persistence.NONE = "none";
  Y(P.prototype, { "delete": { name: "delete", j: [] }, bc: { name: "getIdTokenResult", j: [fn("opt_forceRefresh", !0)] }, F: { name: "getIdToken", j: [fn("opt_forceRefresh", !0)] }, pc: { name: "linkAndRetrieveDataWithCredential", j: [mn()] }, eb: { name: "linkWithCredential", j: [mn()] }, qc: { name: "linkWithPhoneNumber", j: [V("phoneNumber"), on()] }, rc: { name: "linkWithPopup", j: [nn()] }, sc: { name: "linkWithRedirect", j: [nn()] }, yc: { name: "reauthenticateAndRetrieveDataWithCredential", j: [mn()] }, gb: { name: "reauthenticateWithCredential", j: [mn()] }, zc: { name: "reauthenticateWithPhoneNumber",
      j: [V("phoneNumber"), on()] }, Ac: { name: "reauthenticateWithPopup", j: [nn()] }, Bc: { name: "reauthenticateWithRedirect", j: [nn()] }, reload: { name: "reload", j: [] }, jb: { name: "sendEmailVerification", j: [X(W("opt_actionCodeSettings", !0), hn(null, !0), "opt_actionCodeSettings", !0)] }, toJSON: { name: "toJSON", j: [V(null, !0)] }, Nc: { name: "unlink", j: [V("provider")] }, rb: { name: "updateEmail", j: [V("email")] }, sb: { name: "updatePassword", j: [V("password")] }, Pc: { name: "updatePhoneNumber", j: [mn("phone")] }, tb: { name: "updateProfile", j: [W("profile")] } });
  Y(Im.prototype, { execute: { name: "execute" }, render: { name: "render" }, reset: { name: "reset" }, getResponse: { name: "getResponse" } });Y(Hm.prototype, { execute: { name: "execute" }, render: { name: "render" }, reset: { name: "reset" }, getResponse: { name: "getResponse" } });Y(C.prototype, { ia: { name: "finally" }, s: { name: "catch" }, then: { name: "then" } });qn(il.prototype, { appVerificationDisabled: { name: "appVerificationDisabledForTesting", vb: fn("appVerificationDisabledForTesting") } });Y(jl.prototype, { confirm: { name: "confirm", j: [V("verificationCode")] } });
  Z(Zf, "fromJSON", function (a) {
    a = n(a) ? JSON.parse(a) : a;for (var b, c = [jg, Ag, Hg, gg], d = 0; d < c.length; d++) {
      if (b = c[d](a)) return b;
    }return null;
  }, [X(V(), W(), "json")]);Z(vg, "credential", function (a, b) {
    return new ug(a, b);
  }, [V("email"), V("password")]);Y(ug.prototype, { w: { name: "toJSON", j: [V(null, !0)] } });Y(mg.prototype, { ua: { name: "addScope", j: [V("scope")] }, Da: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(mg, "credential", ng, [X(V(), W(), "token")]);Z(vg, "credentialWithLink", Bg, [V("email"), V("emailLink")]);
  Y(og.prototype, { ua: { name: "addScope", j: [V("scope")] }, Da: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(og, "credential", pg, [X(V(), W(), "token")]);Y(qg.prototype, { ua: { name: "addScope", j: [V("scope")] }, Da: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(qg, "credential", rg, [X(V(), X(W(), hn()), "idToken"), X(V(), hn(), "accessToken", !0)]);Y(sg.prototype, { Da: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Z(sg, "credential", tg, [X(V(), W(), "token"), V("secret", !0)]);
  Y(N.prototype, { ua: { name: "addScope", j: [V("scope")] }, credential: { name: "credential", j: [X(V(), X(W(), hn()), "optionsOrIdToken"), X(V(), hn(), "accessToken", !0)] }, Da: { name: "setCustomParameters", j: [W("customOAuthParameters")] } });Y(hg.prototype, { w: { name: "toJSON", j: [V(null, !0)] } });Y(bg.prototype, { w: { name: "toJSON", j: [V(null, !0)] } });Z(Ig, "credential", Kg, [V("verificationId"), V("verificationCode")]);Y(Ig.prototype, { Ua: { name: "verifyPhoneNumber", j: [V("phoneNumber"), on()] } });
  Y(Dg.prototype, { w: { name: "toJSON", j: [V(null, !0)] } });Y(M.prototype, { toJSON: { name: "toJSON", j: [V(null, !0)] } });Y(Sg.prototype, { toJSON: { name: "toJSON", j: [V(null, !0)] } });Y(Rg.prototype, { toJSON: { name: "toJSON", j: [V(null, !0)] } });Y(cn.prototype, { clear: { name: "clear", j: [] }, render: { name: "render", j: [] }, verify: { name: "verify", j: [] } });
  (function () {
    if ("undefined" !== typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL && __WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService) {
      var a = { Auth: sm, AuthCredential: Zf, Error: M };Z(a, "EmailAuthProvider", vg, []);Z(a, "FacebookAuthProvider", mg, []);Z(a, "GithubAuthProvider", og, []);Z(a, "GoogleAuthProvider", qg, []);Z(a, "TwitterAuthProvider", sg, []);Z(a, "OAuthProvider", N, [V("providerId")]);Z(a, "SAMLAuthProvider", lg, [V("providerId")]);Z(a, "PhoneAuthProvider", Ig, [kn()]);Z(a, "RecaptchaVerifier", cn, [X(V(), jn(), "recaptchaContainer"), W("recaptchaParameters", !0), ln()]);__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.registerService("auth", function (b, c) {
        b = new sm(b);c({ INTERNAL: { getUid: t(b.getUid, b), getToken: t(b.ac, b), addAuthTokenListener: t(b.Ub, b), removeAuthTokenListener: t(b.Cc, b) } });return b;
      }, a, function (b, c) {
        if ("create" === b) try {
          c.auth();
        } catch (d) {}
      });__WEBPACK_IMPORTED_MODULE_0__firebase_app___default.a.INTERNAL.extendNamespace({ User: P });
    } else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");
  })();
}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

//# sourceMappingURL=auth.esm.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./style/index.scss
var style = __webpack_require__("yY49");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(match);

// EXTERNAL MODULE: ./components/header/style.css
var header_style = __webpack_require__("u3et");
var header_style_default = /*#__PURE__*/__webpack_require__.n(header_style);

// EXTERNAL MODULE: ./helpers.js
var helpers = __webpack_require__("UiAd");

// EXTERNAL MODULE: ./utils/firebase.js + 2 modules
var firebase = __webpack_require__("ZxPa");

// EXTERNAL MODULE: ./components/avatar/index.js
var avatar = __webpack_require__("5cZM");

// EXTERNAL MODULE: ./components/login/index.js
var login = __webpack_require__("pjHD");

// EXTERNAL MODULE: ./components/register/index.js
var register = __webpack_require__("fbon");

// CONCATENATED MODULE: ./components/header/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var header__ref = Object(preact_min["h"])(
	'a',
	{ 'class': 'navbar-brand fade-page', href: '/', style: 'max-width:50%;' },
	Object(preact_min["h"])('img', { src: '/assets/lippumaatti-logo.png', style: 'max-height:3rem' })
);

var _ref2 = Object(preact_min["h"])(
	'svg',
	{ 'class': 'icon', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	Object(preact_min["h"])('path', { d: 'M3 17C3 17.5523 3.44772 18 4 18H20C20.5523 18 21 17.5523 21 17V17C21 16.4477 20.5523 16 20 16H4C3.44772 16 3 16.4477 3 17V17ZM3 12C3 12.5523 3.44772 13 4 13H20C20.5523 13 21 12.5523 21 12V12C21 11.4477 20.5523 11 20 11H4C3.44772 11 3 11.4477 3 12V12ZM4 6C3.44772 6 3 6.44772 3 7V7C3 7.55228 3.44772 8 4 8H20C20.5523 8 21 7.55228 21 7V7C21 6.44772 20.5523 6 20 6H4Z',
		fill: '#212529' })
);

var _ref3 = Object(preact_min["h"])(
	'div',
	{ 'class': 'py-2 py-lg-0' },
	Object(preact_min["h"])(
		'ul',
		{ 'class': 'navbar-nav' },
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/', 'class': 'nav-link' },
				'Selaa tapahtumia'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/ota-yhteytta', 'class': 'nav-link' },
				'J\xE4rjest\xE4 tapahtuma'
			)
		)
	)
);

var _ref4 = Object(preact_min["h"])(
	'svg',
	{ 'class': 'icon', width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
	Object(preact_min["h"])(
		'title',
		null,
		'Icon For Heart'
	),
	Object(preact_min["h"])(
		'g',
		{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
		Object(preact_min["h"])('rect', { opacity: '0', x: '0', y: '0', width: '24', height: '24' }),
		Object(preact_min["h"])('path', { d: 'M18.1446364,11.84388 L17.4471627,16.0287218 C17.4463569,16.0335568 17.4455155,16.0383857 17.4446387,16.0432083 C17.345843,16.5865846 16.8252597,16.9469884 16.2818833,16.8481927 L4.91303792,14.7811299 C4.53842737,14.7130189 4.23500006,14.4380834 4.13039941,14.0719812 L2.30560137,7.68518803 C2.28007524,7.59584656 2.26712532,7.50338343 2.26712532,7.4104669 C2.26712532,6.85818215 2.71484057,6.4104669 3.26712532,6.4104669 L16.9929851,6.4104669 L17.606173,3.78251876 C17.7307772,3.24850086 18.2068633,2.87071314 18.7552257,2.87071314 L20.8200821,2.87071314 C21.4717328,2.87071314 22,3.39898039 22,4.05063106 C22,4.70228173 21.4717328,5.23054898 20.8200821,5.23054898 L19.6915238,5.23054898 L18.1446364,11.84388 Z', fill: '#000000', opacity: '0.3' }),
		Object(preact_min["h"])('path', { d: 'M6.5,21 C5.67157288,21 5,20.3284271 5,19.5 C5,18.6715729 5.67157288,18 6.5,18 C7.32842712,18 8,18.6715729 8,19.5 C8,20.3284271 7.32842712,21 6.5,21 Z M15.5,21 C14.6715729,21 14,20.3284271 14,19.5 C14,18.6715729 14.6715729,18 15.5,18 C16.3284271,18 17,18.6715729 17,19.5 C17,20.3284271 16.3284271,21 15.5,21 Z', fill: '#000000' })
	)
);

var _ref5 = Object(preact_min["h"])(
	'li',
	{ 'class': 'nav-item' },
	Object(preact_min["h"])(
		'a',
		{ href: '/profiili/liput', 'class': 'nav-link' },
		'Omat liput'
	)
);

var _ref6 = Object(preact_min["h"])(
	'li',
	{ 'class': 'nav-item' },
	Object(preact_min["h"])(
		'a',
		{ href: '/profiili', 'class': 'nav-link' },
		'Omat tiedot'
	)
);

var _ref7 = Object(preact_min["h"])(
	'a',
	{ 'class': 'dropdown-item', href: '/profiili/liput' },
	'Omat liput'
);

var _ref8 = Object(preact_min["h"])(
	'a',
	{ 'class': 'dropdown-item', href: '/profiili' },
	'Omat tiedot'
);

var header_Header = function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		var _temp, _this, _ret;

		_classCallCheck(this, Header);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.open = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			_this.setState({ show: 'account' }, function () {
				document.body.addEventListener('click', _this.close);
			});
		}, _this.close = function () {
			_this.setState({ show: null });
			document.body.removeEventListener('click', _this.close);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Header.prototype.render = function render(props, state, context) {
		var _this2 = this,
		    _h,
		    _h2;

		return Object(preact_min["h"])(
			'div',
			{ 'class': 'navbar-container ' },
			Object(preact_min["h"])(
				'nav',
				{ 'class': state.mobile ? "navbar navbar-expand-lg navbar-light navbar-toggled-show" : "navbar navbar-expand-lg navbar-light" },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'container' },
					header__ref,
					Object(preact_min["h"])(
						'button',
						{ 'class': 'navbar-toggler', type: 'button', 'data-toggle': 'collapse', 'data-target': '.navbar-collapse', 'aria-expanded': state.mobile === true ? "true" : "false", 'aria-label': 'Toggle navigation', onClick: function onClick() {
								return _this2.setState({ mobile: !state.mobile });
							} },
						_ref2
					),
					Object(preact_min["h"])(
						'div',
						{ 'class': state.mobile ? "collapse navbar-collapse justify-content-end show" : "collapse navbar-collapse justify-content-end" },
						_ref3,
						Object(preact_min["h"])(
							'a',
							{ href: '/ostoskori', 'class': 'btn btn-success ml-lg-3' },
							_ref4,
							Object(preact_min["h"])(
								'span',
								null,
								Object(helpers["e" /* parseCurrency */])(context.cart.getTotal())
							)
						),
						context.user ? Object(preact_min["h"])(
							'div',
							null,
							Object(preact_min["h"])(
								'div',
								{ 'class': 'mt-2 bt-1 pt-2 d-block d-lg-none' },
								Object(preact_min["h"])(
									'button',
									{ 'class': 'btn btn-white dropdown-toggle pl-0 pl-md-2', 'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': state.show === 'account' ? "true" : "false", onClick: this.open },
									Object(preact_min["h"])(avatar["a" /* default */], { alt: context.user.displayName, name: context.user.displayName, src: context.user.photoURL, 'class': 'avatar avatar-sm' }),
									Object(preact_min["h"])(
										'span',
										{ 'class': 'ml-2' },
										context.user.displayName || 'Oma tili'
									)
								),
								Object(preact_min["h"])(
									'ul',
									{ 'class': 'navbar-nav' },
									_ref5,
									_ref6,
									Object(preact_min["h"])(
										'li',
										{ 'class': 'nav-item' },
										Object(preact_min["h"])(
											'a',
											(_h = { 'class': 'dropdown-item', href: '/' }, _h['class'] = 'nav-link', _h.onClick = function onClick() {
												return firebase["a" /* default */].auth().signOut();
											}, _h),
											'Kirjaudu ulos'
										)
									)
								)
							),
							Object(preact_min["h"])(
								'div',
								{ 'class': 'd-none d-lg-block' },
								Object(preact_min["h"])(
									'div',
									{ 'class': 'dropdown' },
									Object(preact_min["h"])(
										'button',
										{ 'class': 'btn btn-white dropdown-toggle pl-0 pl-md-2', 'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': state.show === 'account' ? "true" : "false", onClick: this.open },
										Object(preact_min["h"])(avatar["a" /* default */], { alt: context.user.displayName, name: context.user.displayName, src: context.user.photoURL, 'class': 'avatar avatar-sm' }),
										Object(preact_min["h"])(
											'span',
											{ 'class': 'ml-2' },
											context.user.displayName || 'Oma tili'
										)
									),
									Object(preact_min["h"])(
										'div',
										{ 'class': state.show === 'account' ? "dropdown-menu dropdown-menu-right dropdown-content show mt-0" : "dropdown-menu dropdown-menu-right dropdown-content" },
										_ref7,
										_ref8,
										Object(preact_min["h"])(
											'a',
											(_h2 = { 'class': 'dropdown-item', href: '/' }, _h2['class'] = 'dropdown-item', _h2.onClick = function onClick() {
												return firebase["a" /* default */].auth().signOut();
											}, _h2),
											'Kirjaudu ulos'
										)
									)
								)
							)
						) : Object(preact_min["h"])(
							'button',
							{ 'class': 'btn btn-white', onClick: function onClick() {
									return _this2.setState({ show: 'account' });
								} },
							'Oma tili'
						)
					)
				)
			),
			!context.user && state.show === 'account' && !state.register ? Object(preact_min["h"])(login["a" /* default */], { onClose: function onClose() {
					return _this2.setState({ show: null });
				}, onRegister: function onRegister() {
					return _this2.setState({ register: true });
				} }) : !context.user && state.show === 'account' && state.register === true ? Object(preact_min["h"])(register["a" /* default */], { onClose: function onClose() {
					return _this2.setState({ show: null });
				}, onLogin: function onLogin() {
					return _this2.setState({ register: false });
				} }) : null
		);
	};

	return Header;
}(preact_min["Component"]);

/* harmony default export */ var header = (header_Header);
// EXTERNAL MODULE: ./components/footer/style.css
var footer_style = __webpack_require__("ZMjw");
var footer_style_default = /*#__PURE__*/__webpack_require__.n(footer_style);

// CONCATENATED MODULE: ./components/footer/index.js





var footer__ref = Object(preact_min["h"])(
	'h5',
	null,
	'Tapahtumat'
);

var footer__ref2 = Object(preact_min["h"])(
	'li',
	{ 'class': 'nav-item' },
	Object(preact_min["h"])(
		'a',
		{ href: '/#', 'class': 'nav-link' },
		'Kaikki tapahtumat'
	)
);

var footer__ref3 = Object(preact_min["h"])(
	'h5',
	null,
	'J\xE4rjest\xE4 tapahtuma'
);

var footer__ref4 = Object(preact_min["h"])(
	'li',
	{ 'class': 'nav-item' },
	Object(preact_min["h"])(
		'a',
		{ href: '/', 'class': 'nav-link' },
		'J\xE4rjest\xE4 tapahtuma'
	)
);

var footer__ref5 = Object(preact_min["h"])(
	'div',
	{ 'class': 'col-6 col-lg-4 col-xl-3' },
	Object(preact_min["h"])(
		'h5',
		null,
		'Lippumaatti'
	),
	Object(preact_min["h"])(
		'ul',
		{ 'class': 'nav flex-column' },
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/ota-yhteytta', 'class': 'nav-link' },
				'Tietoa meist\xE4'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/kayttoehdot', 'class': 'nav-link' },
				'K\xE4ytt\xF6ehdot'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/tietosuojalauseke', 'class': 'nav-link' },
				'Tietosuojalauseke'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/toimitusehdot', 'class': 'nav-link' },
				'Toimitusehdot'
			)
		)
	)
);

var footer__ref6 = Object(preact_min["h"])(
	'div',
	{ 'class': 'col-6 col-lg-4 col-xl-3' },
	Object(preact_min["h"])(
		'h5',
		null,
		'Tuki'
	),
	Object(preact_min["h"])(
		'ul',
		{ 'class': 'nav flex-column' },
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/ota-yhteytta', 'class': 'nav-link' },
				'Ota yhteytt\xE4'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/', 'class': 'nav-link' },
				'Facebook'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/', 'class': 'nav-link' },
				'Twitter'
			)
		),
		Object(preact_min["h"])(
			'li',
			{ 'class': 'nav-item' },
			Object(preact_min["h"])(
				'a',
				{ href: '/', 'class': 'nav-link' },
				'Instagram'
			)
		)
	)
);

var footer__ref7 = Object(preact_min["h"])(
	'div',
	{ 'class': 'row justify-content-center mb-2' },
	Object(preact_min["h"])(
		'div',
		{ 'class': 'col-auto' },
		Object(preact_min["h"])(
			'ul',
			{ 'class': 'nav' },
			Object(preact_min["h"])(
				'li',
				{ 'class': 'nav-item' },
				Object(preact_min["h"])(
					'a',
					{ href: '#', 'class': 'nav-link' },
					Object(preact_min["h"])(
						'svg',
						{ 'class': 'icon undefined', role: 'img', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' },
						Object(preact_min["h"])(
							'title',
							null,
							'Facebook icon'
						),
						Object(preact_min["h"])('path', { d: 'M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0'
						})
					)
				)
			),
			Object(preact_min["h"])(
				'li',
				{ 'class': 'nav-item' },
				Object(preact_min["h"])(
					'a',
					{ href: '#', 'class': 'nav-link' },
					Object(preact_min["h"])(
						'svg',
						{ 'class': 'icon undefined', role: 'img', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' },
						Object(preact_min["h"])(
							'title',
							null,
							'Twitter icon'
						),
						Object(preact_min["h"])('path', { d: 'M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z'
						})
					)
				)
			),
			Object(preact_min["h"])(
				'li',
				{ 'class': 'nav-item' },
				Object(preact_min["h"])(
					'a',
					{ href: '#', 'class': 'nav-link' },
					Object(preact_min["h"])(
						'svg',
						{ 'class': 'icon undefined', role: 'img', viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' },
						Object(preact_min["h"])(
							'title',
							null,
							'Instagram icon'
						),
						Object(preact_min["h"])('path', { d: 'M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z'
						})
					)
				)
			)
		)
	)
);

var footer__ref8 = Object(preact_min["h"])(
	'div',
	{ 'class': 'row justify-content-center' },
	Object(preact_min["h"])(
		'div',
		{ 'class': 'col col-md-auto text-center' },
		Object(preact_min["h"])(
			'small',
			{ 'class': 'text-muted' },
			'Copyright \xA92019. All rights reserved. Built by ',
			Object(preact_min["h"])(
				'a',
				{ href: 'https://alasti.fi?ref=lippumaatti' },
				'Alasti'
			),
			'. Version 0.9.2'
		)
	)
);

var footer_Footer = function Footer(props, context) {
	return Object(preact_min["h"])(
		'footer',
		{ 'class': 'pb-4 bg-primary-3 text-light', id: 'footer' },
		Object(preact_min["h"])(
			'div',
			{ 'class': 'container' },
			Object(preact_min["h"])(
				'div',
				{ 'class': 'row mb-5' },
				Object(preact_min["h"])(
					'div',
					{ 'class': 'col-6 col-lg-4 col-xl-3' },
					footer__ref,
					Object(preact_min["h"])(
						'ul',
						{ 'class': 'nav flex-column' },
						footer__ref2,
						context.categories.map(function (category) {
							return Object(preact_min["h"])(
								'li',
								{ 'class': 'nav-item' },
								Object(preact_min["h"])(
									'a',
									{ href: '/#' + category.toLowerCase, 'class': 'nav-link' },
									category
								)
							);
						})
					)
				),
				Object(preact_min["h"])(
					'div',
					{ 'class': 'col-6 col-lg-4 col-xl-3' },
					footer__ref3,
					Object(preact_min["h"])(
						'ul',
						{ 'class': 'nav flex-column' },
						footer__ref4,
						context.categories.filter(function (item) {
							return item !== 'Muut';
						}).map(function (category) {
							return Object(preact_min["h"])(
								'li',
								{ 'class': 'nav-item' },
								Object(preact_min["h"])(
									'a',
									{ href: '/', 'class': 'nav-link' },
									'J\xE4rjest\xE4 ',
									category.toLowerCase()
								)
							);
						})
					)
				),
				footer__ref5,
				footer__ref6
			),
			footer__ref7,
			footer__ref8
		)
	);
};

/* harmony default export */ var footer = (footer_Footer);
// EXTERNAL MODULE: ../node_modules/preact-cli/lib/components/async.js
var components_async = __webpack_require__("7N8r");
var async_default = /*#__PURE__*/__webpack_require__.n(components_async);

// CONCATENATED MODULE: ./routes/home/index.js

		

		function load(cb) {
			__webpack_require__.e/* require.ensure */(0).then((function (require) {
				cb( __webpack_require__("iOg+") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var home = (async_default()(load));
	
// CONCATENATED MODULE: ./routes/contact/index.js

		

		function contact_load(cb) {
			__webpack_require__.e/* require.ensure */(10).then((function (require) {
				cb( __webpack_require__("mkNN") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var contact = (async_default()(contact_load));
	
// CONCATENATED MODULE: ./routes/terms/index.js

		

		function terms_load(cb) {
			__webpack_require__.e/* require.ensure */(3).then((function (require) {
				cb( __webpack_require__("+UuA") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var terms = (async_default()(terms_load));
	
// CONCATENATED MODULE: ./routes/privacy/index.js

		

		function privacy_load(cb) {
			__webpack_require__.e/* require.ensure */(6).then((function (require) {
				cb( __webpack_require__("8Vb/") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var privacy = (async_default()(privacy_load));
	
// CONCATENATED MODULE: ./routes/deliveryterms/index.js

		

		function deliveryterms_load(cb) {
			__webpack_require__.e/* require.ensure */(9).then((function (require) {
				cb( __webpack_require__("NW1P") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var deliveryterms = (async_default()(deliveryterms_load));
	
// CONCATENATED MODULE: ./routes/checkout/index.js

		

		function checkout_load(cb) {
			__webpack_require__.e/* require.ensure */(12).then((function (require) {
				cb( __webpack_require__("VqFA") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var checkout = (async_default()(checkout_load));
	
// CONCATENATED MODULE: ./routes/confirmation/index.js

		

		function confirmation_load(cb) {
			__webpack_require__.e/* require.ensure */(11).then((function (require) {
				cb( __webpack_require__("AXev") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var confirmation = (async_default()(confirmation_load));
	
// CONCATENATED MODULE: ./routes/ticket/index.js

		

		function ticket_load(cb) {
			__webpack_require__.e/* require.ensure */(1).then((function (require) {
				cb( __webpack_require__("fYYy") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var ticket = (async_default()(ticket_load));
	
// CONCATENATED MODULE: ./routes/receipt/index.js

		

		function receipt_load(cb) {
			__webpack_require__.e/* require.ensure */(4).then((function (require) {
				cb( __webpack_require__("6BHT") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var receipt = (async_default()(receipt_load));
	
// CONCATENATED MODULE: ./routes/event/index.js

		

		function event_load(cb) {
			__webpack_require__.e/* require.ensure */(8).then((function (require) {
				cb( __webpack_require__("gp3s") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_event = (async_default()(event_load));
	
// CONCATENATED MODULE: ./routes/profile/index.js

		

		function profile_load(cb) {
			__webpack_require__.e/* require.ensure */(5).then((function (require) {
				cb( __webpack_require__("B9hw") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var routes_profile = (async_default()(profile_load));
	
// CONCATENATED MODULE: ./routes/orders/index.js

		

		function orders_load(cb) {
			__webpack_require__.e/* require.ensure */(2).then((function (require) {
				cb( __webpack_require__("ErJU") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var orders = (async_default()(orders_load));
	
// CONCATENATED MODULE: ./routes/payment/index.js

		

		function payment_load(cb) {
			__webpack_require__.e/* require.ensure */(7).then((function (require) {
				cb( __webpack_require__("Qpbk") );
			}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
		}

		/* harmony default export */ var payment = (async_default()(payment_load));
	
// CONCATENATED MODULE: ./components/cart/index.js
function cart__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function cart__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function cart__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var cart_CartProvider = function (_Component) {
	cart__inherits(CartProvider, _Component);

	function CartProvider() {
		var _temp, _this, _ret;

		cart__classCallCheck(this, CartProvider);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = cart__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function () {
			localStorage.setItem('Lippumaatti--Cart', JSON.stringify(_this.state.items));
		}, _this.parseCart = function (items) {
			return items.reduce(function (final, item) {
				var foundItemIndex = final.reduce(function (found, existing, index) {
					return found === null && item.ticket_id === existing.ticket_id ? index : found;
				}, null);
				item.quantity = parseInt(item.quantity);
				if (foundItemIndex !== null) {
					final[foundItemIndex].quantity = final[foundItemIndex].quantity + item.quantity;
				} else if (item.quantity) {
					final.push(item);
				}
				return final;
			}, []);
		}, _this.state = {
			items: (localStorage.getItem('Lippumaatti--Cart') ? _this.parseCart(JSON.parse(localStorage.getItem('Lippumaatti--Cart'))) : []).filter(function (item) {
				return !item.deadline || Object(helpers["a" /* convertToTimestamp */])(item.deadline) > new Date();
			})
		}, _temp), cart__possibleConstructorReturn(_this, _ret);
	}

	CartProvider.prototype.getChildContext = function getChildContext() {
		var _this2 = this;

		return {
			cart: {
				addItems: function addItems(items) {
					_this2.setState({ items: _this2.parseCart([].concat(_this2.state.items, items)) }, _this2.update);return items;
				},
				setItems: function setItems(items) {
					_this2.setState({ items: _this2.parseCart(items) }, _this2.update);return items;
				},
				getTotal: function getTotal(cart) {
					return (cart || _this2.state.items).reduce(function (total, item) {
						return total + item.quantity * item.price;
					}, 0);
				},
				clearCart: function clearCart() {
					_this2.setState({ items: [] }, _this2.update);return [];
				},
				getItems: function getItems() {
					return _this2.state.items;
				}
			}
		};
	};

	CartProvider.prototype.render = function render(_ref) {
		var children = _ref.children;

		return children[0];
	};

	return CartProvider;
}(preact_min["Component"]);
/* harmony default export */ var cart = (cart_CartProvider);
// EXTERNAL MODULE: ./globals.js
var globals = __webpack_require__("zQXs");

// CONCATENATED MODULE: ./components/auth/index.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function auth__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function auth__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function auth__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var auth_AuthProvider = function (_Component) {
	auth__inherits(AuthProvider, _Component);

	function AuthProvider() {
		var _temp, _this, _ret;

		auth__classCallCheck(this, AuthProvider);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = auth__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.fetch = function (url, options) {
			return new Promise(function (resolve, reject) {
				// method: 'POST',
				// body: JSON.stringify(payload);

				var user = firebase["a" /* default */].auth().currentUser;

				if (!user) {
					reject('Ei pääsyä');
				}

				user.getIdToken().then(function (token) {

					fetch('' + globals["a" /* API */] + url, _extends({
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + token
						}
					}, options)).then(function (res) {
						return res.json();
					}).then(resolve).catch(reject);
				}).catch(reject);
			});
		}, _temp), auth__possibleConstructorReturn(_this, _ret);
	}

	AuthProvider.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		firebase["a" /* default */].auth().onAuthStateChanged(function (user) {
			if (!user) {
				_this2.setState({ user: firebase["a" /* default */].auth().currentUser });
			} else {
				var currentUser = firebase["a" /* default */].auth().currentUser;
				var db = firebase["a" /* default */].firestore();
				db.collection("user").doc(currentUser.uid).get().then(function (doc) {
					console.log('admin check', doc.data().admin);
					if (doc.exists && doc.data().admin) {
						_this2.setState({ user: _extends({}, currentUser, { admin: true }) });
					} else {
						console.log('not admin');

						_this2.setState({ user: currentUser });
					}
				}).catch(function (err) {
					console.log('not admin', currentUser.uid, err);
					_this2.setState({ user: currentUser });
				});
			}
		});
	};

	AuthProvider.prototype.getChildContext = function getChildContext() {
		var _this3 = this;

		return {
			user: this.state.user,
			http: this.fetch,
			updateProfile: function updateProfile(profile) {
				var user = firebase["a" /* default */].auth().currentUser;

				user.updateProfile(profile).then(function () {
					return _this3.setState({ user: _extends({}, firebase["a" /* default */].auth().currentUser, { admin: _this3.state.user ? _this3.state.user.admin : false }) });
				});
			}
		};
	};

	AuthProvider.prototype.render = function render(props) {
		return props.children[0];
	};

	return AuthProvider;
}(preact_min["Component"]);

/* harmony default export */ var auth = (auth_AuthProvider);
// CONCATENATED MODULE: ./components/app.js


function app__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function app__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function app__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Code-splitting is automated for routes

















var app__ref2 = Object(preact_min["h"])(header, null);

var app__ref3 = Object(preact_min["h"])(home, { path: '/' });

var app__ref4 = Object(preact_min["h"])(contact, { path: '/ota-yhteytta' });

var app__ref5 = Object(preact_min["h"])(home, { path: '/tapahtumat' });

var app__ref6 = Object(preact_min["h"])(routes_event, { path: '/tapahtumat/:slug/:id' });

var app__ref7 = Object(preact_min["h"])(routes_profile, { path: '/profiili' });

var app__ref8 = Object(preact_min["h"])(orders, { path: '/profiili/liput' });

var _ref9 = Object(preact_min["h"])(checkout, { path: '/ostoskori' });

var _ref10 = Object(preact_min["h"])(payment, { path: '/ostoskori/:cart' });

var _ref11 = Object(preact_min["h"])(confirmation, { path: '/tilaus/:cart' });

var _ref12 = Object(preact_min["h"])(receipt, { path: '/kuitti/:cart' });

var _ref13 = Object(preact_min["h"])(ticket, { path: '/lippu/:ticket' });

var _ref14 = Object(preact_min["h"])(terms, { path: '/kayttoehdot' });

var _ref15 = Object(preact_min["h"])(privacy, { path: '/tietosuojalauseke' });

var _ref16 = Object(preact_min["h"])(deliveryterms, { path: '/toimitusehdot' });

var _ref17 = Object(preact_min["h"])(footer, null);

var app_App = function (_Component) {
	app__inherits(App, _Component);

	function App() {
		var _temp, _this, _ret;

		app__classCallCheck(this, App);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = app__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			url: window.location.pathname
		}, _this.handleRoute = function (e) {
			var url = e.url;

			_this.setState({ url: url });
			window.scrollTo(0, 0);
		}, _temp), app__possibleConstructorReturn(_this, _ret);
	}

	App.prototype.getChildContext = function getChildContext() {
		return {
			cart: [],
			categories: ['Musiikki', 'Urheilu', 'Muut']
		};
	};

	App.prototype.render = function render(props, _ref) {
		var url = _ref.url;

		return Object(preact_min["h"])(
			cart,
			null,
			Object(preact_min["h"])(
				auth,
				null,
				Object(preact_min["h"])(
					'div',
					{ id: 'app' },
					url.indexOf('receipt') === -1 ? app__ref2 : null,
					Object(preact_min["h"])(
						preact_router_es["Router"],
						{ onChange: this.handleRoute },
						app__ref3,
						app__ref4,
						app__ref5,
						app__ref6,
						app__ref7,
						app__ref8,
						_ref9,
						_ref10,
						_ref11,
						_ref12,
						_ref13,
						_ref14,
						_ref15,
						_ref16
					),
					url.indexOf('receipt') === -1 ? _ref17 : null
				)
			)
		);
	};

	return App;
}(preact_min["Component"]);


// EXTERNAL MODULE: ../node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("juYr");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// CONCATENATED MODULE: ./utils/jquery.js

window.$ = jquery_default.a;
// CONCATENATED MODULE: ./index.js




/* harmony default export */ var index = __webpack_exports__["default"] = (app_App);

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e(e, t) {
    var n,
        o,
        r,
        i,
        l = W;for (i = arguments.length; i-- > 2;) {
      P.push(arguments[i]);
    }t && null != t.children && (P.length || P.push(t.children), delete t.children);while (P.length) {
      if ((o = P.pop()) && void 0 !== o.pop) for (i = o.length; i--;) {
        P.push(o[i]);
      } else "boolean" == typeof o && (o = null), (r = "function" != typeof e) && (null == o ? o = "" : "number" == typeof o ? o += "" : "string" != typeof o && (r = !1)), r && n ? l[l.length - 1] += o : l === W ? l = [o] : l.push(o), n = r;
    }var a = new T();return a.nodeName = e, a.children = l, a.attributes = null == t ? void 0 : t, a.key = null == t ? void 0 : t.key, void 0 !== M.vnode && M.vnode(a), a;
  }function t(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function n(e, t) {
    null != e && ("function" == typeof e ? e(t) : e.current = t);
  }function o(n, o) {
    return e(n.nodeName, t(t({}, n.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : n.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == V.push(e) && (M.debounceRendering || D)(i);
  }function i() {
    var e;while (e = V.pop()) {
      e.__d && x(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var n = t({}, e.attributes);n.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === n[r] && (n[r] = o[r]);
    }return n;
  }function c(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function s(e, t, o, r, i) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n(o, null), n(r, e);else if ("class" !== t || i) {
      if ("style" === t) {
        if (r && "string" != typeof r && "string" != typeof o || (e.style.cssText = r || ""), r && "object" == typeof r) {
          if ("string" != typeof o) for (var l in o) {
            l in r || (e.style[l] = "");
          }for (var l in r) {
            e.style[l] = "number" == typeof r[l] && !1 === E.test(l) ? r[l] + "px" : r[l];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) r && (e.innerHTML = r.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var a = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), r ? o || e.addEventListener(t, _, a) : e.removeEventListener(t, _, a), (e.__l || (e.__l = {}))[t] = r;
      } else if ("list" !== t && "type" !== t && !i && t in e) {
        try {
          e[t] = null == r ? "" : r;
        } catch (e) {}null != r && !1 !== r || "spellcheck" == t || e.removeAttribute(t);
      } else {
        var u = i && t !== (t = t.replace(/^xlink:?/, ""));null == r || !1 === r ? u ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof r && (u ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), r) : e.setAttribute(t, r));
      }
    } else e.className = r || "";
  }function _(e) {
    return this.__l[e.type](M.event && M.event(e) || e);
  }function f() {
    var e;while (e = A.shift()) {
      M.afterMount && M.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function d(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, B = null != e && !("__preactattr_" in e));var l = h(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (B = !1, i || f()), l;
  }function h(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return N(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = c(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), v(e, !0);
    }var p = i.firstChild,
        s = i.__preactattr_,
        _ = t.children;if (null == s) {
      s = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        s[f[d].name] = f[d].value;
      }
    }return !B && _ && 1 === _.length && "string" == typeof _[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != _[0] && (p.nodeValue = _[0]) : (_ && _.length || null != p) && m(i, _, n, o, B || null != s.dangerouslySetInnerHTML), y(i, t.attributes, s), R = l, i;
  }function m(e, t, n, o, r) {
    var i,
        a,
        u,
        c,
        s,
        _ = e.childNodes,
        f = [],
        d = {},
        m = 0,
        b = 0,
        y = _.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = _[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (m++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      c = t[C], s = null;var k = c.key;if (null != k) m && void 0 !== d[k] && (s = d[k], d[k] = void 0, m--);else if (b < g) for (i = b; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], c, r)) {
          s = a, f[i] = void 0, i === g - 1 && g--, i === b && b++;break;
        }
      }s = h(s, c, n, o), u = _[C], s && s !== e && s !== u && (null == u ? e.appendChild(s) : s === u.nextSibling ? p(u) : e.insertBefore(s, u));
    }if (m) for (var C in d) {
      void 0 !== d[C] && v(d[C], !1);
    }while (b <= g) {
      void 0 !== (s = f[g--]) && v(s, !1);
    }
  }function v(e, t) {
    var o = e._component;o ? k(o) : (null != e.__preactattr_ && n(e.__preactattr_.ref, null), !1 !== t && null != e.__preactattr_ || p(e), b(e));
  }function b(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;v(e, !0), e = t;
    }
  }function y(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || s(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || s(e, o, n[o], n[o] = t[o], R);
    }
  }function g(e, t, n) {
    var o,
        r = F.length;e.prototype && e.prototype.render ? (o = new e(t, n), U.call(o, t, n)) : (o = new U(t, n), o.constructor = e, o.render = w);while (r--) {
      if (F[r].constructor === e) return o.__b = F[r].__b, F.splice(r, 1), o;
    }return o;
  }function w(e, t, n) {
    return this.constructor(e, n);
  }function C(e, t, o, i, l) {
    e.__x || (e.__x = !0, e.__r = t.ref, e.__k = t.key, delete t.ref, delete t.key, void 0 === e.constructor.getDerivedStateFromProps && (!e.base || l ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, i)), i && i !== e.context && (e.__c || (e.__c = e.context), e.context = i), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== o && (1 !== o && !1 === M.syncComponentUpdates && e.base ? r(e) : x(e, 1, l)), n(e.__r, e));
  }function x(e, n, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          c = e.props,
          p = e.state,
          s = e.context,
          _ = e.__p || c,
          h = e.__s || p,
          m = e.__c || s,
          b = e.base,
          y = e.__b,
          w = b || y,
          N = e._component,
          U = !1,
          S = m;if (e.constructor.getDerivedStateFromProps && (p = t(t({}, p), e.constructor.getDerivedStateFromProps(c, p)), e.state = p), b && (e.props = _, e.state = h, e.context = m, 2 !== n && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(c, p, s) ? U = !0 : e.componentWillUpdate && e.componentWillUpdate(c, p, s), e.props = c, e.state = p, e.context = s), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !U) {
        i = e.render(c, p, s), e.getChildContext && (s = t(t({}, s), e.getChildContext())), b && e.getSnapshotBeforeUpdate && (S = e.getSnapshotBeforeUpdate(_, h));var L,
            T,
            P = i && i.nodeName;if ("function" == typeof P) {
          var W = u(i);l = N, l && l.constructor === P && W.key == l.__k ? C(l, W, 1, s, !1) : (L = l, e._component = l = g(P, W, s), l.__b = l.__b || y, l.__u = e, C(l, W, 0, s, !1), x(l, 1, o, !0)), T = l.base;
        } else a = w, L = N, L && (a = e._component = null), (w || 1 === n) && (a && (a._component = null), T = d(a, i, s, o || !b, w && w.parentNode, !0));if (w && T !== w && l !== N) {
          var D = w.parentNode;D && T !== D && (D.replaceChild(T, w), L || (w._component = null, v(w, !1)));
        }if (L && k(L), e.base = T, T && !r) {
          var E = e,
              V = e;while (V = V.__u) {
            (E = V).base = T;
          }T._component = E, T._componentConstructor = E.constructor;
        }
      }!b || o ? A.push(e) : U || (e.componentDidUpdate && e.componentDidUpdate(_, h, S), M.afterUpdate && M.afterUpdate(e));while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || f();
    }
  }function N(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        c = a,
        p = u(t);while (r && !c && (r = r.__u)) {
      c = r.constructor === t.nodeName;
    }return r && c && (!o || r._component) ? (C(r, p, 3, n, o), e = r.base) : (i && !a && (k(i), e = l = null), r = g(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), C(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, v(l, !1))), e;
  }function k(e) {
    M.beforeUnmount && M.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var o = e._component;o ? k(o) : t && (null != t.__preactattr_ && n(t.__preactattr_.ref, null), e.__b = t, p(t), F.push(e), b(t)), n(e.__r, null);
  }function U(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {}, this.__h = [];
  }function S(e, t, n) {
    return d(n, e, {}, !1, t, !1);
  }function L() {
    return {};
  }var T = function T() {},
      M = {},
      P = [],
      W = [],
      D = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      E = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      V = [],
      A = [],
      H = 0,
      R = !1,
      B = !1,
      F = [];t(U.prototype, { setState: function setState(e, n) {
      this.__s || (this.__s = this.state), this.state = t(t({}, this.state), "function" == typeof e ? e(this.state, this.props) : e), n && this.__h.push(n), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && this.__h.push(e), x(this, 2);
    }, render: function render() {} });var j = { h: e, createElement: e, cloneElement: o, createRef: L, Component: U, render: S, rerender: i, options: M }; true ? module.exports = j : self.preact = j;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "NSiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aos__ = __webpack_require__("9RKk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aos__);

//
//
// aos.js
//
// Initialises the animate on scroll plugin



__WEBPACK_IMPORTED_MODULE_0_aos___default.a.init({ once: true });

/***/ }),

/***/ "Ousc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tickets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utils_firebase__ = __webpack_require__("ZxPa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_helpers__ = __webpack_require__("UiAd");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var months = {
	'1': 'TAMMI',
	'2': 'HELMI',
	'3': 'MAALIS',
	'4': 'HUHTI',
	'5': 'TOUKO',
	'6': 'KESÄ',
	'7': 'HEINÄ',
	'8': 'ELO',
	'9': 'SYYS',
	'10': 'LOKA',
	'11': 'MARRAS',
	'12': 'JOULU'
};

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h6',
	{ 'class': 'mb-1' },
	'Nimi'
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'row' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': 'col-12 col-md-8 p-0' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'embed-responsive embed-responsive-16by9' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'section',
				{ 'class': 'p-0 mb-0 embed-responsive-item' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'carousel-cell bg-dark text-light overlay d-flex flex-column justify-content-end h-100' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'container' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': 'row px-2 py-3 p-lg-6' },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'col' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									null,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('h1', { 'class': 'text-primary', waiting: true }),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { 'class': 'text-muted', waiting: true })
								)
							)
						)
					)
				)
			)
		)
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'div',
		{ 'class': 'col-12 col-md-4 bg-primary-3 text-white' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'p-2 p-md-4' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { waiting: true }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('h6', { 'class': 'text-muted w-100', waiting: true })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'px-2 px-md-4' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('span', { waiting: true }),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('h6', { 'class': 'text-muted w-100', waiting: true })
			)
		)
	)
);

var SingleTicket = function (_Component) {
	_inherits(SingleTicket, _Component);

	function SingleTicket() {
		var _temp, _this, _ret;

		_classCallCheck(this, SingleTicket);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getEvent = function (id) {
			// const db = firebase.firestore();
			// db.collection("events")
			// .doc(id)
			// .get()
			// .then((doc) => {
			// 	if (doc.exists) {
			//         console.log("Document data:", doc.data());
			// 		this.setState({event: doc.data()})
			//     } else {
			//         // doc.data() will be undefined in this case
			//         console.log("No such document!");
			//     }
			// });
			fetch('https://us-central1-lippumaatti.cloudfunctions.net/api/events/' + id).then(function (res) {
				return res.json();
			}).then(function (event) {
				_this.setState(_extends({}, event, { loading: false }));
			});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	SingleTicket.prototype.componentDidMount = function componentDidMount() {
		this.getEvent(this.props.ticket.event_id);
	};

	SingleTicket.prototype.render = function render(_ref, _ref2, _ref3) {
		var ticket = _ref.ticket,
		    background = _ref.background;
		var event = _ref2.event;
		var user = _ref3.user,
		    cart = _ref3.cart;

		return event ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'container card', style: background ? 'background:white;position:absolute;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px ' + 1 / background + 'rem 0px;overflow:hidden; border-radius:0.75rem;transform:translate3d(-4px, -4px, 0) rotateZ(-' + background + 'deg);transform-origin:0 0;width:calc(100% - 4rem);' : "background:white;position:relative;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 1rem 0px;overflow:hidden; border-radius:0.75rem;" },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'row' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'col-12 col-xl-8 p-0' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'embed-responsive embed-responsive-16by9' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'section',
							{ 'class': 'p-0 mb-0 embed-responsive-item' },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'carousel-cell bg-dark text-light overlay d-flex flex-column justify-content-end h-100' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', { src: event.image, alt: 'Image', 'class': 'bg-image opacity-80' }),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'container' },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'row px-2 py-3 p-lg-6' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												null,
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'h1',
													{ 'class': 'mt-3 mb-0 h3' },
													event.title
												),
												Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
													'div',
													{ 'class': 'd-flex mt-2' },
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'div',
														{ 'class': 'd-flex align-items-center' },
														Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
															'div',
															{ 'class': 'mr-4 d-flex flex-column justify-content-center align-items-center' },
															Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
																'span',
																{ 'class': 'block text-small text-muted' },
																months[Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["b" /* formatDate */])(event.start_date).split('.')[1]]
															),
															Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
																'h4',
																{ 'class': 'lead mb-0' },
																Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["b" /* formatDate */])(event.start_date).split('.')[0]
															)
														)
													),
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'div',
														{ 'class': 'mr-4' },
														Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
															'span',
															{ 'class': 'text-white' },
															event.address
														),
														_ref4,
														Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
															'span',
															{ 'class': 'text-muted' },
															event.city
														)
													),
													Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
														'div',
														{ 'class': 'mr-4' },
														Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
															'span',
															{ 'class': 'text-white' },
															this.props.cart.items.length,
															' kpl'
														),
														_ref5,
														Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
															'span',
															{ 'class': 'text-muted' },
															Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["e" /* parseCurrency */])(cart.getTotal(this.props.cart ? this.props.cart.items : []))
														)
													)
												)
											)
										)
									)
								)
							)
						)
					)
				),
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'col-12 col-lg-4' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'd-flex justify-content-center align-items-center' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': 'p-2 py-4 p-xl-4' },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'mb-4' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'h4',
									{ 'class': 'mb-1' },
									event.title
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'h5',
									{ 'class': 'text-primary' },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'strong',
										null,
										Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["b" /* formatDate */])(event.start_date),
										' klo ',
										Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["c" /* formatTime */])(event.start_date)
									)
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'mb-4' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'h5',
									{ 'class': 'mb-1 text-small' },
									event.location
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'p',
									null,
									event.address,
									', ',
									event.city
								)
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'd-flex justify-content-between' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'mb-2' },
									_ref6,
									user ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'p',
										null,
										user.displayName
									) : null
								),
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'mb-2' },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'h6',
										{ 'class': 'mb-1' },
										this.props.cart.items.length,
										' kpl'
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'p',
										null,
										Object(__WEBPACK_IMPORTED_MODULE_2_helpers__["e" /* parseCurrency */])(cart.getTotal(this.props.cart ? this.props.cart.items : []))
									)
								)
							)
						)
					)
				)
			)
		) : _ref7;
	};

	return SingleTicket;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/*

<div class="container card"	style="overflow:hidden">
	<div class="row">
		<div class="col-12 col-md-8 p-0">
				<div class="embed-responsive embed-responsive-16by9 d-none d-md-block d-print-none">
					<section class="p-0 mb-0 embed-responsive-item">
						{event.image ?
						<div class="carousel-cell bg-dark text-light overlay d-flex flex-column justify-content-end h-100" >
								<img src={event.image} alt="Image" class="bg-image opacity-80" />
								<div class="container">
								<div class="row px-2 py-3 p-lg-6">
									<div class="col">
										<div>
											<h1 class="mt-0 h3 h1-lg">{event.title}</h1>
											<div class="d-flex mt-2">
												<div class="d-flex align-items-center">
													<div class="mr-4 d-flex flex-column justify-content-center align-items-center">
														<span class="block text-small text-muted">{months[formatDate(event.start_date).split('.')[1]]}</span>
														<h4 class="lead mb-0">{formatDate(event.start_date).split('.')[0]}</h4>
													</div>
												</div>
												<div>
													<span class="text-white">{event.location}</span><br/>
													<span class="text-muted">{event.city}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> :
						<div class="carousel-cell bg-grey text-light overlay d-flex flex-column justify-content-end"	style="min-height: 15.5rem" />}
					</section>

				</div>
				<div class="embed-responsive embed-responsive-16by9 d-none d-print-block">
					<section class="p-0 mb-0 embed-responsive-item">
						{event.image ?
						<div class="carousel-cell d-flex flex-column justify-content-between h-100" >
							<div class="container">
									<div class="row p-4 py-lg-4 px-lg-6">
										<div class="col-md-8">
											<img src="/assets/lippumaatti-logo.png" style="height: 3rem;" />
										</div>
									</div>
								</div>
								<div class="container">
								<div class="row px-4 p-lg-6">
									<div class="col">
										<div>
											<h1 class="mt-0 h3 h1-lg">{event.title}</h1>
											<div class="d-flex mt-2">
												<div class="d-flex align-items-center">
													<div class="mr-4 d-flex flex-column justify-content-center align-items-center">
														<span class="block text-small text-muted">{months[formatDate(event.start_date).split('.')[1]]}</span>
														<h4 class="lead mb-0">{formatDate(event.start_date).split('.')[0]}</h4>
													</div>
												</div>
												<div>
													<span>{event.location}</span><br/>
													<span class="text-muted">{event.city}</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div> :
						<div class="carousel-cell bg-grey text-light overlay d-flex flex-column justify-content-end"	style="min-height: 15.5rem" />}
					</section>
				</div>
			</div>
		<div class="col-12 col-md-4">
			<div class="d-flex justify-content-center align-items-center">
				{user ? <div class="p-2 p-md-4">
					<div class="mb-4">
						<h4 class="mb-1">{ticket.title || 'Lipun otsikko'}</h4>
						<h5 class="text-primary"><strong>{ticket.description || 'Kuvaus'}</strong></h5>
					</div>
					<div class="d-flex justify-content-between">
						<QRCode value={props.ticket} />
					</div>
				</div> : null}
			</div>
		</div>
	</div>
</div>


*/

var Tickets = function (_Component2) {
	_inherits(Tickets, _Component2);

	function Tickets() {
		_classCallCheck(this, Tickets);

		return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	}

	Tickets.prototype.render = function render(props, state) {
		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			{ 'class': 'p-4 mt-4', style: 'position:relative;' },
			[].concat(this.props.cart.items).reverse().slice(0, 4).map(function (ticket, index, arr) {
				return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(SingleTicket, { ticket: ticket, cart: props.cart, background: arr.length - index - 1 });
			})
		);
	};

	return Tickets;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);
/* harmony default export */ __webpack_exports__["a"] = (Tickets);

/***/ }),

/***/ "TUpU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogLevel", function() { return LogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogLevel", function() { return setLogLevel; });
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function defaultLogHandler(instance, logType) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    switch (logType) {
        /**
         * By default, `console.debug` is not displayed in the developer console (in
         * chrome). To avoid forcing users to have to opt-in to these logs twice
         * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
         * logs to the `console.log` function.
         */
        case LogLevel.DEBUG:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.VERBOSE:
            console.log.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.INFO:
            console.info.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.WARN:
            console.warn.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        case LogLevel.ERROR:
            console.error.apply(console, ["[" + now + "]  " + instance.name + ":"].concat(args));
            break;
        default:
            throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};
var Logger = /** @class */function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The log handler for the Logger instance.
         */
        this._logHandler = defaultLogHandler;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }
    Object.defineProperty(Logger.prototype, "logLevel", {
        get: function get() {
            return this._logLevel;
        },
        set: function set(val) {
            if (!(val in LogLevel)) {
                throw new TypeError('Invalid value assigned to `logLevel`');
            }
            this._logLevel = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logger.prototype, "logHandler", {
        get: function get() {
            return this._logHandler;
        },
        set: function set(val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * The functions below are all based on the `console` interface
     */
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
    };
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
    };
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
    };
    return Logger;
}();

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.logLevel = level;
    });
}


//# sourceMappingURL=index.esm.js.map

/***/ }),

/***/ "UiAd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return months; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatTime; });
/* harmony export (immutable) */ __webpack_exports__["f"] = toSlug;
var parseCurrency = function parseCurrency(price) {
	return (price / 100).toFixed(2).split('.').join(',') + ' \u20AC';
};

var months = {
	'1': 'TAMMI',
	'2': 'HELMI',
	'3': 'MAALIS',
	'4': 'HUHTI',
	'5': 'TOUKO',
	'6': 'KESÄ',
	'7': 'HEINÄ',
	'8': 'ELO',
	'9': 'SYYS',
	'10': 'LOKA',
	'11': 'MARRAS',
	'12': 'JOULU'
};

var formatToDateString = function formatToDateString(date) {
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();
	return day + '.' + month + '.' + year;
};
var formatToTimeString = function formatToTimeString(date) {
	var hours = date.getHours();
	var minutes = date.getMinutes();

	return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
};

var formatDate = function formatDate(date) {
	var dateObject = date ? date.toDate ? date.toDate() : date._seconds ? new Date(date._seconds * 1000) : date : null;
	return dateObject ? formatToDateString(dateObject) : null;
};

var convertToTimestamp = function convertToTimestamp(date) {
	return date ? date.toDate ? date.toDate() : date._seconds ? new Date(date._seconds * 1000) : date : null;
};

var formatTime = function formatTime(date) {
	var dateObject = date ? date.toDate ? date.toDate() : date._seconds ? new Date(date._seconds * 1000) : date : null;
	return dateObject ? formatToTimeString(dateObject) : null;
};

function toSlug(st) {
	return st.toString().toLowerCase().replace(/[\u00C0-\u00C5]/ig, 'a').replace(/[\u00C8-\u00CB]/ig, 'e').replace(/[\u00CC-\u00CF]/ig, 'i').replace(/[\u00D2-\u00D6]/ig, 'o').replace(/[\u00D9-\u00DC]/ig, 'u').replace(/[\u00D1]/ig, 'n').replace(/\s+/g, '-') // Replace spaces with -
	.replace(/&/g, '-') // Replace & with '-'
	.replace(/\./g, '-') // Replace . with '-'
	.replace(/\:/g, '-and-') // Replace : with '-'
	.replace(/[^\w\-]+/g, '') // Remove all non-word characters
	.replace(/\-\-+/g, '-') // Replace multiple - with single -
	.replace(/^-+/, '') // Trim - from start of text
	.replace(/-+$/, ''); // Trim - from end of text
}

/***/ }),

/***/ "ZMjw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZUoI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var firebase = _interopDefault(__webpack_require__("dP58"));

/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;
//# sourceMappingURL=index.cjs.js.map

/***/ }),

/***/ "ZxPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ../node_modules/firebase/app/dist/index.cjs.js
var index_cjs = __webpack_require__("ZUoI");
var index_cjs_default = /*#__PURE__*/__webpack_require__.n(index_cjs);

// EXTERNAL MODULE: ../node_modules/@firebase/auth/dist/auth.esm.js
var auth_esm = __webpack_require__("EkFk");

// CONCATENATED MODULE: ../node_modules/firebase/auth/dist/index.esm.js


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
//# sourceMappingURL=index.esm.js.map
// EXTERNAL MODULE: ../node_modules/@firebase/firestore/dist/index.cjs.js
var dist_index_cjs = __webpack_require__("eA7g");
var dist_index_cjs_default = /*#__PURE__*/__webpack_require__.n(dist_index_cjs);

// CONCATENATED MODULE: ../node_modules/firebase/firestore/dist/index.esm.js


/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
//# sourceMappingURL=index.esm.js.map
// CONCATENATED MODULE: ./utils/firebase.js
// This import loads the firebase namespace along with all its type information.


// These imports load individual services into the firebase namespace.



var firebaseConfig = {
  apiKey: "AIzaSyAjW31wgJlckbNXy5iKbOMXN3V0Cq6hsH4",
  authDomain: "lippumaatti.firebaseapp.com",
  databaseURL: "https://lippumaatti.firebaseio.com",
  projectId: "lippumaatti",
  storageBucket: "lippumaatti.appspot.com",
  messagingSenderId: "543074153885",
  appId: "1:543074153885:web:3748ec79abfd5a56"
};

var app = index_cjs["initializeApp"](firebaseConfig);

/* harmony default export */ var firebase = __webpack_exports__["a"] = (index_cjs);

/***/ }),

/***/ "dP58":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__("vCxL");
var util = __webpack_require__("58xA");
var logger$1 = __webpack_require__("TUpU");

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;
var ERRORS = (_a = {}, _a["no-app" /* NO_APP */] = "No Firebase App '{$name}' has been created - " + 'call Firebase App.initializeApp()', _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$name}", _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$name}' already exists", _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$name}' already deleted", _a["duplicate-service" /* DUPLICATE_SERVICE */] = "Firebase service named '{$name}' already registered", _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$name}() takes either no argument or a ' + 'Firebase App instance.', _a);
var appErrors = new util.ErrorFactory('app', 'Firebase', ERRORS);
function error(code, args) {
    throw appErrors.create(code, args);
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this.automaticDataCollectionEnabled_ = config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.INTERNAL = {
            getUid: function getUid() {
                return null;
            },
            getToken: function getToken() {
                return Promise.resolve(null);
            },
            addAuthTokenListener: function addAuthTokenListener(callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () {
                    return callback(null);
                }, 0);
            },
            removeAuthTokenListener: function removeAuthTokenListener(callback) {
                tokenListeners = tokenListeners.filter(function (listener) {
                    return listener !== callback;
                });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function get() {
            this.checkDestroyed_();
            return this.automaticDataCollectionEnabled_;
        },
        set: function set(val) {
            this.checkDestroyed_();
            this.automaticDataCollectionEnabled_ = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function get() {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function get() {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        }).then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            for (var _i = 0, _a = Object.keys(_this.services_); _i < _a.length; _i++) {
                var serviceKey = _a[_i];
                for (var _b = 0, _c = Object.keys(_this.services_[serviceKey]); _b < _c.length; _b++) {
                    var instanceKey = _c[_b];
                    services.push(_this.services_[serviceKey][instanceKey]);
                }
            }
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        }).then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) {
            instanceIdentifier = DEFAULT_ENTRY_NAME;
        }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME ? instanceIdentifier : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error("app-deleted" /* APP_DELETED */, { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}();
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options || FirebaseAppImpl.prototype.delete || console.log('dc');

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
/**
 * Because auth can't share code with other components, we attach the utility functions
 * in an internal namespace to share code.
 * This function return a firebase namespace object without
 * any utility functions, so it can be shared between the regular firebaseNamespace and
 * the lite version.
 */
function createFirebaseNamespaceCore(firebaseAppImpl) {
    var apps = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        // @ts-ignore
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        SDK_VERSION: '6.0.2',
        INTERNAL: {
            registerService: registerService,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    util.patchProperty(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps[name];
        callAppHooks(app, 'delete');
        delete apps[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps, name)) {
            error("no-app" /* NO_APP */, { name: name });
        }
        return apps[name];
    }
    util.patchProperty(app, 'App', firebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) {
            rawConfig = {};
        }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error("bad-app-name" /* BAD_APP_NAME */, { name: String(name) });
        }
        if (contains(apps, name)) {
            error("duplicate-app" /* DUPLICATE_APP */, { name: name });
        }
        var app = new firebaseAppImpl(options, config, namespace);
        apps[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps).map(function (name) {
            return apps[name];
        });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        if (allowMultipleInstances === void 0) {
            allowMultipleInstances = false;
        }
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error("duplicate-service" /* DUPLICATE_SERVICE */, { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        function serviceNamespace(appArg) {
            if (appArg === void 0) {
                appArg = app();
            }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error("invalid-app-argument" /* INVALID_APP_ARGUMENT */, { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        }
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        firebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    function callAppHooks(app, eventName) {
        for (var _i = 0, _a = Object.keys(factories); _i < _a.length; _i++) {
            var serviceName = _a[_i];
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        }
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        return useService;
    }
    return namespace;
}

/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
    namespace.INTERNAL = tslib_1.__assign({}, namespace.INTERNAL, { createFirebaseNamespace: createFirebaseNamespace, extendNamespace: extendNamespace, createSubscribe: util.createSubscribe, ErrorFactory: util.ErrorFactory, deepExtend: util.deepExtend });
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    return namespace;
}

/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new logger$1.Logger('@firebase/app');
// Firebase Lite detection
if (util.isBrowser() && 'firebase' in self) {
    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
    var sdkVersion = self.firebase.SDK_VERSION;
    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
    }
}
var firebaseNamespace = createFirebaseNamespace();
var initializeApp = firebaseNamespace.initializeApp;
firebaseNamespace.initializeApp = function () {
    // Environment check before initializing app
    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
    // in @firebase/logger
    if (util.isNode()) {
        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and set \"module\"\n      to false and \"main\" to true:\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
    }
    return initializeApp.apply(undefined, arguments);
};
var firebase = firebaseNamespace;

exports.default = firebase;
exports.firebase = firebase;
//# sourceMappingURL=index.cjs.js.map

/***/ }),

/***/ "eA7g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:true});function _interopDefault(ex){return ex&&typeof ex==='object'&&'default'in ex?ex['default']:ex;}var firebase=_interopDefault(__webpack_require__("dP58"));var logger=__webpack_require__("TUpU");var tslib_1=__webpack_require__("vCxL");var webchannelWrapper=__webpack_require__("ueHA");var util=__webpack_require__("58xA");/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//** The semver (www.semver.org) version of the SDK. */var SDK_VERSION=firebase.SDK_VERSION;/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var logClient=new logger.Logger('@firebase/firestore');var LogLevel;(function(LogLevel){LogLevel[LogLevel["DEBUG"]=0]="DEBUG";LogLevel[LogLevel["ERROR"]=1]="ERROR";LogLevel[LogLevel["SILENT"]=2]="SILENT";})(LogLevel||(LogLevel={}));// Helper methods are needed because variables can't be exported as read/write
function getLogLevel(){if(logClient.logLevel===logger.LogLevel.DEBUG){return LogLevel.DEBUG;}else if(logClient.logLevel===logger.LogLevel.SILENT){return LogLevel.SILENT;}else{return LogLevel.ERROR;}}function setLogLevel(newLevel){/**
     * Map the new log level to the associated Firebase Log Level
     */switch(newLevel){case LogLevel.DEBUG:logClient.logLevel=logger.LogLevel.DEBUG;break;case LogLevel.ERROR:logClient.logLevel=logger.LogLevel.ERROR;break;case LogLevel.SILENT:logClient.logLevel=logger.LogLevel.SILENT;break;default:logClient.error("Firestore ("+SDK_VERSION+"): Invalid value passed to `setLogLevel`");}}function debug(tag,msg){var obj=[];for(var _i=2;_i<arguments.length;_i++){obj[_i-2]=arguments[_i];}if(logClient.logLevel<=logger.LogLevel.DEBUG){var args=obj.map(argToString);logClient.debug.apply(logClient,["Firestore ("+SDK_VERSION+") ["+tag+"]: "+msg].concat(args));}}function error(msg){var obj=[];for(var _i=1;_i<arguments.length;_i++){obj[_i-1]=arguments[_i];}if(logClient.logLevel<=logger.LogLevel.ERROR){var args=obj.map(argToString);logClient.error.apply(logClient,["Firestore ("+SDK_VERSION+"): "+msg].concat(args));}}/**
 * Converts an additional log parameter to a string representation.
 */function argToString(obj){if(typeof obj==='string'){return obj;}else{var platform=PlatformSupport.getPlatform();try{return platform.formatJSON(obj);}catch(e){// Converting to JSON failed, just log the object directly
return obj;}}}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Unconditionally fails, throwing an Error with the given message.
 *
 * Returns any so it can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */function fail(failure){// Log the failure in addition to throw an exception, just in case the
// exception is swallowed.
var message="FIRESTORE ("+SDK_VERSION+") INTERNAL ASSERTION FAILED: "+failure;error(message);// NOTE: We don't use FirestoreError here because these are internal failures
// that cannot be handled by the user. (Also it would create a circular
// dependency between the error and assert modules which doesn't work.)
throw new Error(message);}/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 */function assert(assertion,message){if(!assertion){fail(message);}}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Provides singleton helpers where setup code can inject a platform at runtime.
 * setPlatform needs to be set before Firestore is used and must be set exactly
 * once.
 */var PlatformSupport=/** @class */function(){function PlatformSupport(){}PlatformSupport.setPlatform=function(platform){if(PlatformSupport.platform){fail('Platform already defined');}PlatformSupport.platform=platform;};PlatformSupport.getPlatform=function(){if(!PlatformSupport.platform){fail('Platform not set');}return PlatformSupport.platform;};return PlatformSupport;}();/**
 * Returns the representation of an empty "proto" byte string for the
 * platform.
 */function emptyByteString(){return PlatformSupport.getPlatform().emptyByteString;}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */// TODO(mcg): Change to a string enum once we've upgraded to typescript 2.4.
//  tslint:disable-next-line:variable-name Intended to look like a TS 2.4 enum
var Code={// Causes are copied from:
// https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
/** Not an error; returned on success. */OK:'ok',/** The operation was cancelled (typically by the caller). */CANCELLED:'cancelled',/** Unknown error or an error from a different error domain. */UNKNOWN:'unknown',/**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */INVALID_ARGUMENT:'invalid-argument',/**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */DEADLINE_EXCEEDED:'deadline-exceeded',/** Some requested entity (e.g., file or directory) was not found. */NOT_FOUND:'not-found',/**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ALREADY_EXISTS:'already-exists',/**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */PERMISSION_DENIED:'permission-denied',/**
     * The request does not have valid authentication credentials for the
     * operation.
     */UNAUTHENTICATED:'unauthenticated',/**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */RESOURCE_EXHAUSTED:'resource-exhausted',/**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */FAILED_PRECONDITION:'failed-precondition',/**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ABORTED:'aborted',/**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */OUT_OF_RANGE:'out-of-range',/** Operation is not implemented or not supported/enabled in this service. */UNIMPLEMENTED:'unimplemented',/**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */INTERNAL:'internal',/**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */UNAVAILABLE:'unavailable',/** Unrecoverable data loss or corruption. */DATA_LOSS:'data-loss'};/**
 * An error class used for Firestore-generated errors. Ideally we should be
 * using FirebaseError, but integrating with it is overly arduous at the moment,
 * so we define our own compatible error class (with a `name` of 'FirebaseError'
 * and compatible `code` and `message` fields.)
 */var FirestoreError=/** @class */function(_super){tslib_1.__extends(FirestoreError,_super);function FirestoreError(code,message){var _this=_super.call(this,message)||this;_this.code=code;_this.message=message;_this.name='FirebaseError';// HACK: We write a toString property directly because Error is not a real
// class and so inheritance does not work correctly. We could alternatively
// do the same "back-door inheritance" trick that FirebaseError does.
_this.toString=function(){return _this.name+": [code="+_this.code+"]: "+_this.message;};return _this;}return FirestoreError;}(Error);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Helper function to prevent instantiation through the constructor.
 *
 * This method creates a new constructor that throws when it's invoked.
 * The prototype of that constructor is then set to the prototype of the hidden
 * "class" to expose all the prototype methods and allow for instanceof
 * checks.
 *
 * To also make all the static methods available, all properties of the
 * original constructor are copied to the new constructor.
 */function makeConstructorPrivate(cls,optionalMessage){function PublicConstructor(){var error='This constructor is private.';if(optionalMessage){error+=' ';error+=optionalMessage;}throw new FirestoreError(Code.INVALID_ARGUMENT,error);}// Make sure instanceof checks work and all methods are exposed on the public
// constructor
PublicConstructor.prototype=cls.prototype;// Copy any static methods/members
for(var staticProperty in cls){if(cls.hasOwnProperty(staticProperty)){PublicConstructor[staticProperty]=cls[staticProperty];}}return PublicConstructor;}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function contains(obj,key){return Object.prototype.hasOwnProperty.call(obj,key);}/** Returns the given value if it's defined or the defaultValue otherwise. */function defaulted(value,defaultValue){return value!==undefined?value:defaultValue;}function forEachNumber(obj,fn){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){var num=Number(key);if(!isNaN(num)){fn(num,obj[key]);}}}}function values(obj){var vs=[];forEach(obj,function(_,v){return vs.push(v);});return vs;}function forEach(obj,fn){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){fn(key,obj[key]);}}}function isEmpty(obj){assert(obj!=null&&typeof obj==='object','isEmpty() expects object parameter.');for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){return false;}}return true;}function shallowCopy(obj){assert(obj&&typeof obj==='object','shallowCopy() expects object parameter.');var result={};for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key)){result[key]=obj[key];}}return result;}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Validates that no arguments were passed in the invocation of functionName.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateNoArgs('myFunction', arguments);
 */function validateNoArgs(functionName,args){if(args.length!==0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() does not support arguments, "+'but was called with '+formatPlural(args.length,'argument')+'.');}}/**
 * Validates the invocation of functionName has the exact number of arguments.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateExactNumberOfArgs('myFunction', arguments, 2);
 */function validateExactNumberOfArgs(functionName,args,numberOfArgs){if(args.length!==numberOfArgs){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires "+formatPlural(numberOfArgs,'argument')+', but was called with '+formatPlural(args.length,'argument')+'.');}}/**
 * Validates the invocation of functionName has at least the provided number of
 * arguments (but can have many more).
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
 */function validateAtLeastNumberOfArgs(functionName,args,minNumberOfArgs){if(args.length<minNumberOfArgs){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires at least "+formatPlural(minNumberOfArgs,'argument')+', but was called with '+formatPlural(args.length,'argument')+'.');}}/**
 * Validates the invocation of functionName has number of arguments between
 * the values provided.
 *
 * Forward the magic "arguments" variable as second parameter on which the
 * parameter validation is performed:
 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
 */function validateBetweenNumberOfArgs(functionName,args,minNumberOfArgs,maxNumberOfArgs){if(args.length<minNumberOfArgs||args.length>maxNumberOfArgs){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires between "+minNumberOfArgs+" and "+(maxNumberOfArgs+" arguments, but was called with ")+formatPlural(args.length,'argument')+'.');}}/**
 * Validates the provided argument is an array and has as least the expected
 * number of elements.
 */function validateNamedArrayAtLeastNumberOfElements(functionName,value,name,minNumberOfElements){if(!(value instanceof Array)||value.length<minNumberOfElements){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires its "+name+" argument to be an "+'array with at least '+(formatPlural(minNumberOfElements,'element')+"."));}}/**
 * Validates the provided positional argument has the native JavaScript type
 * using typeof checks.
 */function validateArgType(functionName,type,position,argument){validateType(functionName,type,ordinal(position)+" argument",argument);}/**
 * Validates the provided argument has the native JavaScript type using
 * typeof checks or is undefined.
 */function validateOptionalArgType(functionName,type,position,argument){if(argument!==undefined){validateArgType(functionName,type,position,argument);}}/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks.
 */function validateNamedType(functionName,type,optionName,argument){validateType(functionName,type,optionName+" option",argument);}/**
 * Validates the provided named option has the native JavaScript type using
 * typeof checks or is undefined.
 */function validateNamedOptionalType(functionName,type,optionName,argument){if(argument!==undefined){validateNamedType(functionName,type,optionName,argument);}}function validateArrayElements(functionName,optionName,typeDescription,argument,validator){if(!(argument instanceof Array)){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires its "+optionName+" "+("option to be an array, but it was: "+valueDescription(argument)));}for(var i=0;i<argument.length;++i){if(!validator(argument[i])){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires all "+optionName+" "+("elements to be "+typeDescription+", but the value at index "+i+" ")+("was: "+valueDescription(argument[i])));}}}function validateOptionalArrayElements(functionName,optionName,typeDescription,argument,validator){if(argument!==undefined){validateArrayElements(functionName,optionName,typeDescription,argument,validator);}}/**
 * Validates that the provided named option equals one of the expected values.
 */function validateNamedPropertyEquals(functionName,inputName,optionName,input,expected){var expectedDescription=[];for(var _i=0,expected_1=expected;_i<expected_1.length;_i++){var val=expected_1[_i];if(val===input){return;}expectedDescription.push(valueDescription(val));}var actualDescription=valueDescription(input);throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid value "+actualDescription+" provided to function "+functionName+"() for option "+("\""+optionName+"\". Acceptable values: "+expectedDescription.join(', ')));}/**
 * Validates that the provided named option equals one of the expected values or
 * is undefined.
 */function validateNamedOptionalPropertyEquals(functionName,inputName,optionName,input,expected){if(input!==undefined){validateNamedPropertyEquals(functionName,inputName,optionName,input,expected);}}/**
 * Validates that the provided argument is a valid enum.
 *
 * @param functionName Function making the validation call.
 * @param enums Array containing all possible values for the enum.
 * @param position Position of the argument in `functionName`.
 * @param argument Arugment to validate.
 */function validateStringEnum(functionName,enums,position,argument){if(!enums.some(function(element){return element===argument;})){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid value "+valueDescription(argument)+" provided to function "+(functionName+"() for its "+ordinal(position)+" argument. Acceptable ")+("values: "+enums.join(', ')));}}/** Helper to validate the type of a provided input. */function validateType(functionName,type,inputName,input){var valid=false;if(type==='object'){valid=isPlainObject(input);}else if(type==='non-empty string'){valid=typeof input==='string'&&input!=='';}else{valid=typeof input===type;}if(!valid){var description=valueDescription(input);throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires its "+inputName+" "+("to be of type "+type+", but it was: "+description));}}/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */function isPlainObject(input){return typeof input==='object'&&input!==null&&(Object.getPrototypeOf(input)===Object.prototype||Object.getPrototypeOf(input)===null);}/** Returns a string describing the type / value of the provided input. */function valueDescription(input){if(input===undefined){return'undefined';}else if(input===null){return'null';}else if(typeof input==='string'){if(input.length>20){input=input.substring(0,20)+"...";}return JSON.stringify(input);}else if(typeof input==='number'||typeof input==='boolean'){return''+input;}else if(typeof input==='object'){if(input instanceof Array){return'an array';}else{var customObjectName=tryGetCustomObjectType(input);if(customObjectName){return"a custom "+customObjectName+" object";}else{return'an object';}}}else if(typeof input==='function'){return'a function';}else{return fail('Unknown wrong type: '+typeof input);}}/** Hacky method to try to get the constructor name for an object. */function tryGetCustomObjectType(input){if(input.constructor){var funcNameRegex=/function\s+([^\s(]+)\s*\(/;var results=funcNameRegex.exec(input.constructor.toString());if(results&&results.length>1){return results[1];}}return null;}/** Validates the provided argument is defined. */function validateDefined(functionName,position,argument){if(argument===undefined){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires a valid "+ordinal(position)+" "+"argument, but it was undefined.");}}/**
 * Validates the provided positional argument is an object, and its keys and
 * values match the expected keys and types provided in optionTypes.
 */function validateOptionNames(functionName,options,optionNames){forEach(options,function(key,_){if(optionNames.indexOf(key)<0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Unknown option '"+key+"' passed to function "+functionName+"(). "+'Available options: '+optionNames.join(', '));}});}/**
 * Helper method to throw an error that the provided argument did not pass
 * an instanceof check.
 */function invalidClassError(functionName,type,position,argument){var description=valueDescription(argument);return new FirestoreError(Code.INVALID_ARGUMENT,"Function "+functionName+"() requires its "+ordinal(position)+" "+("argument to be a "+type+", but it was: "+description));}/** Converts a number to its english word representation */function ordinal(num){switch(num){case 1:return'first';case 2:return'second';case 3:return'third';default:return num+'th';}}/**
 * Formats the given word as plural conditionally given the preceding number.
 */function formatPlural(num,str){return num+" "+str+(num===1?'':'s');}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */// tslint:disable-next-line:class-as-namespace
var AutoId=/** @class */function(){function AutoId(){}AutoId.newId=function(){// Alphanumeric characters
var chars='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';var autoId='';for(var i=0;i<20;i++){autoId+=chars.charAt(Math.floor(Math.random()*chars.length));}assert(autoId.length===20,'Invalid auto ID: '+autoId);return autoId;};return AutoId;}();function primitiveComparator(left,right){if(left<right)return-1;if(left>right)return 1;return 0;}/** Helper to compare nullable (or undefined-able) objects using isEqual(). */function equals(left,right){if(left!==null&&left!==undefined){return!!(right&&left.isEqual(right));}else{// HACK: Explicitly cast since TypeScript's type narrowing apparently isn't
// smart enough.
return left===right;}}/** Helper to compare arrays using isEqual(). */function arrayEquals(left,right){if(left.length!==right.length){return false;}for(var i=0;i<left.length;i++){if(!left[i].isEqual(right[i])){return false;}}return true;}/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */function immediateSuccessor(s){// Return the input string, with an additional NUL byte appended.
return s+'\0';}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//** Helper function to assert Uint8Array is available at runtime. */function assertUint8ArrayAvailable(){if(typeof Uint8Array==='undefined'){throw new FirestoreError(Code.UNIMPLEMENTED,'Uint8Arrays are not available in this environment.');}}/** Helper function to assert Base64 functions are available at runtime. */function assertBase64Available(){if(!PlatformSupport.getPlatform().base64Available){throw new FirestoreError(Code.UNIMPLEMENTED,'Blobs are unavailable in Firestore in this environment.');}}/**
 * Immutable class holding a blob (binary data).
 * This class is directly exposed in the public API.
 *
 * Note that while you can't hide the constructor in JavaScript code, we are
 * using the hack above to make sure no-one outside this module can call it.
 */var Blob=/** @class */function(){function Blob(binaryString){assertBase64Available();this._binaryString=binaryString;}Blob.fromBase64String=function(base64){validateExactNumberOfArgs('Blob.fromBase64String',arguments,1);validateArgType('Blob.fromBase64String','string',1,base64);assertBase64Available();try{var binaryString=PlatformSupport.getPlatform().atob(base64);return new Blob(binaryString);}catch(e){throw new FirestoreError(Code.INVALID_ARGUMENT,'Failed to construct Blob from Base64 string: '+e);}};Blob.fromUint8Array=function(array){validateExactNumberOfArgs('Blob.fromUint8Array',arguments,1);assertUint8ArrayAvailable();if(!(array instanceof Uint8Array)){throw invalidClassError('Blob.fromUint8Array','Uint8Array',1,array);}// We can't call array.map directly because it expects the return type to
// be a Uint8Array, whereas we can convert it to a regular array by invoking
// map on the Array prototype.
var binaryString=Array.prototype.map.call(array,function(char){return String.fromCharCode(char);}).join('');return new Blob(binaryString);};Blob.prototype.toBase64=function(){validateExactNumberOfArgs('Blob.toBase64',arguments,0);assertBase64Available();return PlatformSupport.getPlatform().btoa(this._binaryString);};Blob.prototype.toUint8Array=function(){validateExactNumberOfArgs('Blob.toUint8Array',arguments,0);assertUint8ArrayAvailable();var buffer=new Uint8Array(this._binaryString.length);for(var i=0;i<this._binaryString.length;i++){buffer[i]=this._binaryString.charCodeAt(i);}return buffer;};Blob.prototype.toString=function(){return'Blob(base64: '+this.toBase64()+')';};Blob.prototype.isEqual=function(other){return this._binaryString===other._binaryString;};/**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */Blob.prototype._compareTo=function(other){return primitiveComparator(this._binaryString,other._binaryString);};return Blob;}();// Public instance that disallows construction at runtime. This constructor is
// used when exporting Blob on firebase.firestore.Blob and will be called Blob
// publicly. Internally we still use Blob which has a type checked private
// constructor. Note that Blob and PublicBlob can be used interchangeably in
// instanceof checks.
// For our internal TypeScript code PublicBlob doesn't exist as a type, and so
// we need to use Blob as type and export it too.
// tslint:disable-next-line:variable-name We're treating this as a class name.
var PublicBlob=makeConstructorPrivate(Blob,'Use Blob.fromUint8Array() or Blob.fromBase64String() instead.');/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Immutable class representing a geo point as latitude-longitude pair.
 * This class is directly exposed in the public API, including its constructor.
 */var GeoPoint=/** @class */function(){function GeoPoint(latitude,longitude){validateExactNumberOfArgs('GeoPoint',arguments,2);validateArgType('GeoPoint','number',1,latitude);validateArgType('GeoPoint','number',2,longitude);if(!isFinite(latitude)||latitude<-90||latitude>90){throw new FirestoreError(Code.INVALID_ARGUMENT,'Latitude must be a number between -90 and 90, but was: '+latitude);}if(!isFinite(longitude)||longitude<-180||longitude>180){throw new FirestoreError(Code.INVALID_ARGUMENT,'Longitude must be a number between -180 and 180, but was: '+longitude);}this._lat=latitude;this._long=longitude;}Object.defineProperty(GeoPoint.prototype,"latitude",{/**
         * Returns the latitude of this geo point, a number between -90 and 90.
         */get:function get(){return this._lat;},enumerable:true,configurable:true});Object.defineProperty(GeoPoint.prototype,"longitude",{/**
         * Returns the longitude of this geo point, a number between -180 and 180.
         */get:function get(){return this._long;},enumerable:true,configurable:true});GeoPoint.prototype.isEqual=function(other){return this._lat===other._lat&&this._long===other._long;};/**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */GeoPoint.prototype._compareTo=function(other){return primitiveComparator(this._lat,other._lat)||primitiveComparator(this._long,other._long);};return GeoPoint;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var Timestamp=/** @class */function(){function Timestamp(seconds,nanoseconds){this.seconds=seconds;this.nanoseconds=nanoseconds;if(nanoseconds<0){throw new FirestoreError(Code.INVALID_ARGUMENT,'Timestamp nanoseconds out of range: '+nanoseconds);}if(nanoseconds>=1e9){throw new FirestoreError(Code.INVALID_ARGUMENT,'Timestamp nanoseconds out of range: '+nanoseconds);}// Midnight at the beginning of 1/1/1 is the earliest Firestore supports.
if(seconds<-62135596800){throw new FirestoreError(Code.INVALID_ARGUMENT,'Timestamp seconds out of range: '+seconds);}// This will break in the year 10,000.
if(seconds>=253402300800){throw new FirestoreError(Code.INVALID_ARGUMENT,'Timestamp seconds out of range: '+seconds);}}Timestamp.now=function(){return Timestamp.fromMillis(Date.now());};Timestamp.fromDate=function(date){return Timestamp.fromMillis(date.getTime());};Timestamp.fromMillis=function(milliseconds){var seconds=Math.floor(milliseconds/1000);var nanos=(milliseconds-seconds*1000)*1e6;return new Timestamp(seconds,nanos);};Timestamp.prototype.toDate=function(){return new Date(this.toMillis());};Timestamp.prototype.toMillis=function(){return this.seconds*1000+this.nanoseconds/1e6;};Timestamp.prototype._compareTo=function(other){if(this.seconds===other.seconds){return primitiveComparator(this.nanoseconds,other.nanoseconds);}return primitiveComparator(this.seconds,other.seconds);};Timestamp.prototype.isEqual=function(other){return other.seconds===this.seconds&&other.nanoseconds===this.nanoseconds;};Timestamp.prototype.toString=function(){return'Timestamp(seconds='+this.seconds+', nanoseconds='+this.nanoseconds+')';};return Timestamp;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var DatabaseInfo=/** @class */function(){/**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId The database to use.
     * @param persistenceKey A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host The Firestore backend host to connect to.
     * @param ssl Whether to use SSL when connecting.
     * @param forceLongPolling Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     */function DatabaseInfo(databaseId,persistenceKey,host,ssl,forceLongPolling){this.databaseId=databaseId;this.persistenceKey=persistenceKey;this.host=host;this.ssl=ssl;this.forceLongPolling=forceLongPolling;}return DatabaseInfo;}();/** The default database name for a project. */var DEFAULT_DATABASE_NAME='(default)';/** Represents the database ID a Firestore client is associated with. */var DatabaseId=/** @class */function(){function DatabaseId(projectId,database){this.projectId=projectId;this.database=database?database:DEFAULT_DATABASE_NAME;}Object.defineProperty(DatabaseId.prototype,"isDefaultDatabase",{get:function get(){return this.database===DEFAULT_DATABASE_NAME;},enumerable:true,configurable:true});DatabaseId.prototype.isEqual=function(other){return other instanceof DatabaseId&&other.projectId===this.projectId&&other.database===this.database;};DatabaseId.prototype.compareTo=function(other){return primitiveComparator(this.projectId,other.projectId)||primitiveComparator(this.database,other.database);};return DatabaseId;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var DOCUMENT_KEY_NAME='__name__';/**
 * Path represents an ordered sequence of string segments.
 */var Path=/** @class */function(){function Path(segments,offset,length){this.init(segments,offset,length);}/**
     * An initialization method that can be called from outside the constructor.
     * We need this so that we can have a non-static construct method that returns
     * the polymorphic `this` type.
     */Path.prototype.init=function(segments,offset,length){if(offset===undefined){offset=0;}else if(offset>segments.length){fail('offset '+offset+' out of range '+segments.length);}if(length===undefined){length=segments.length-offset;}else if(length>segments.length-offset){fail('length '+length+' out of range '+(segments.length-offset));}this.segments=segments;this.offset=offset;this.len=length;};/**
     * Constructs a new instance of Path using the same concrete type as `this`.
     * We need this instead of using the normal constructor, because polymorphic
     * `this` doesn't work on static methods.
     */Path.prototype.construct=function(segments,offset,length){var path=Object.create(Object.getPrototypeOf(this));path.init(segments,offset,length);return path;};Object.defineProperty(Path.prototype,"length",{get:function get(){return this.len;},enumerable:true,configurable:true});Path.prototype.isEqual=function(other){return Path.comparator(this,other)===0;};Path.prototype.child=function(nameOrPath){var segments=this.segments.slice(this.offset,this.limit());if(nameOrPath instanceof Path){nameOrPath.forEach(function(segment){segments.push(segment);});}else if(typeof nameOrPath==='string'){segments.push(nameOrPath);}else{fail('Unknown parameter type for Path.child(): '+nameOrPath);}return this.construct(segments);};/** The index of one past the last segment of the path. */Path.prototype.limit=function(){return this.offset+this.length;};Path.prototype.popFirst=function(size){size=size===undefined?1:size;assert(this.length>=size,"Can't call popFirst() with less segments");return this.construct(this.segments,this.offset+size,this.length-size);};Path.prototype.popLast=function(){assert(!this.isEmpty(),"Can't call popLast() on empty path");return this.construct(this.segments,this.offset,this.length-1);};Path.prototype.firstSegment=function(){assert(!this.isEmpty(),"Can't call firstSegment() on empty path");return this.segments[this.offset];};Path.prototype.lastSegment=function(){return this.get(this.length-1);};Path.prototype.get=function(index){assert(index<this.length,'Index out of range');return this.segments[this.offset+index];};Path.prototype.isEmpty=function(){return this.length===0;};Path.prototype.isPrefixOf=function(other){if(other.length<this.length){return false;}for(var i=0;i<this.length;i++){if(this.get(i)!==other.get(i)){return false;}}return true;};Path.prototype.isImmediateParentOf=function(potentialChild){if(this.length+1!==potentialChild.length){return false;}for(var i=0;i<this.length;i++){if(this.get(i)!==potentialChild.get(i)){return false;}}return true;};Path.prototype.forEach=function(fn){for(var i=this.offset,end=this.limit();i<end;i++){fn(this.segments[i]);}};Path.prototype.toArray=function(){return this.segments.slice(this.offset,this.limit());};Path.comparator=function(p1,p2){var len=Math.min(p1.length,p2.length);for(var i=0;i<len;i++){var left=p1.get(i);var right=p2.get(i);if(left<right)return-1;if(left>right)return 1;}if(p1.length<p2.length)return-1;if(p1.length>p2.length)return 1;return 0;};return Path;}();/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 */var ResourcePath=/** @class */function(_super){tslib_1.__extends(ResourcePath,_super);function ResourcePath(){return _super!==null&&_super.apply(this,arguments)||this;}ResourcePath.prototype.canonicalString=function(){// NOTE: The client is ignorant of any path segments containing escape
// sequences (e.g. __id123__) and just passes them through raw (they exist
// for legacy reasons and should not be used frequently).
return this.toArray().join('/');};ResourcePath.prototype.toString=function(){return this.canonicalString();};/**
     * Creates a resource path from the given slash-delimited string.
     */ResourcePath.fromString=function(path){// NOTE: The client is ignorant of any path segments containing escape
// sequences (e.g. __id123__) and just passes them through raw (they exist
// for legacy reasons and should not be used frequently).
if(path.indexOf('//')>=0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid path ("+path+"). Paths must not contain // in them.");}// We may still have an empty segment at the beginning or end if they had a
// leading or trailing slash (which we allow).
var segments=path.split('/').filter(function(segment){return segment.length>0;});return new ResourcePath(segments);};ResourcePath.EMPTY_PATH=new ResourcePath([]);return ResourcePath;}(Path);var identifierRegExp=/^[_a-zA-Z][_a-zA-Z0-9]*$/;/** A dot-separated path for navigating sub-objects within a document. */var FieldPath=/** @class */function(_super){tslib_1.__extends(FieldPath,_super);function FieldPath(){return _super!==null&&_super.apply(this,arguments)||this;}/**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */FieldPath.isValidIdentifier=function(segment){return identifierRegExp.test(segment);};FieldPath.prototype.canonicalString=function(){return this.toArray().map(function(str){str=str.replace('\\','\\\\').replace('`','\\`');if(!FieldPath.isValidIdentifier(str)){str='`'+str+'`';}return str;}).join('.');};FieldPath.prototype.toString=function(){return this.canonicalString();};/**
     * Returns true if this field references the key of a document.
     */FieldPath.prototype.isKeyField=function(){return this.length===1&&this.get(0)===DOCUMENT_KEY_NAME;};/**
     * The field designating the key of a document.
     */FieldPath.keyField=function(){return new FieldPath([DOCUMENT_KEY_NAME]);};/**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */FieldPath.fromServerFormat=function(path){var segments=[];var current='';var i=0;var addCurrentSegment=function addCurrentSegment(){if(current.length===0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid field path ("+path+"). Paths must not be empty, begin "+"with '.', end with '.', or contain '..'");}segments.push(current);current='';};var inBackticks=false;while(i<path.length){var c=path[i];if(c==='\\'){if(i+1===path.length){throw new FirestoreError(Code.INVALID_ARGUMENT,'Path has trailing escape character: '+path);}var next=path[i+1];if(!(next==='\\'||next==='.'||next==='`')){throw new FirestoreError(Code.INVALID_ARGUMENT,'Path has invalid escape sequence: '+path);}current+=next;i+=2;}else if(c==='`'){inBackticks=!inBackticks;i++;}else if(c==='.'&&!inBackticks){addCurrentSegment();i++;}else{current+=c;i++;}}addCurrentSegment();if(inBackticks){throw new FirestoreError(Code.INVALID_ARGUMENT,'Unterminated ` in path: '+path);}return new FieldPath(segments);};FieldPath.EMPTY_PATH=new FieldPath([]);return FieldPath;}(Path);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var DocumentKey=/** @class */function(){function DocumentKey(path){this.path=path;assert(DocumentKey.isDocumentKey(path),'Invalid DocumentKey with an odd number of segments: '+path.toArray().join('/'));}/** Returns true if the document is in the specified collectionId. */DocumentKey.prototype.hasCollectionId=function(collectionId){return this.path.length>=2&&this.path.get(this.path.length-2)===collectionId;};DocumentKey.prototype.isEqual=function(other){return other!==null&&ResourcePath.comparator(this.path,other.path)===0;};DocumentKey.prototype.toString=function(){return this.path.toString();};DocumentKey.comparator=function(k1,k2){return ResourcePath.comparator(k1.path,k2.path);};DocumentKey.isDocumentKey=function(path){return path.length%2===0;};/**
     * Creates and returns a new document key with the given segments.
     *
     * @param path The segments of the path to the document
     * @return A new instance of DocumentKey
     */DocumentKey.fromSegments=function(segments){return new DocumentKey(new ResourcePath(segments.slice()));};/**
     * Creates and returns a new document key using '/' to split the string into
     * segments.
     *
     * @param path The slash-separated path string to the document
     * @return A new instance of DocumentKey
     */DocumentKey.fromPathString=function(path){return new DocumentKey(ResourcePath.fromString(path));};DocumentKey.EMPTY=new DocumentKey(new ResourcePath([]));return DocumentKey;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * The result of a lookup for a given path may be an existing document or a
 * marker that this document does not exist at a given version.
 */var MaybeDocument=/** @class */function(){function MaybeDocument(key,version){this.key=key;this.version=version;}MaybeDocument.compareByKey=function(d1,d2){return DocumentKey.comparator(d1.key,d2.key);};return MaybeDocument;}();/**
 * Represents a document in Firestore with a key, version, data and whether the
 * data has local mutations applied to it.
 */var Document=/** @class */function(_super){tslib_1.__extends(Document,_super);function Document(key,version,data,options,/**
     * Memoized serialized form of the document for optimization purposes (avoids repeated
     * serialization). Might be undefined.
     */proto){var _this=_super.call(this,key,version)||this;_this.data=data;_this.proto=proto;_this.hasLocalMutations=!!options.hasLocalMutations;_this.hasCommittedMutations=!!options.hasCommittedMutations;return _this;}Document.prototype.field=function(path){return this.data.field(path);};Document.prototype.fieldValue=function(path){var field=this.field(path);return field?field.value():undefined;};Document.prototype.value=function(){return this.data.value();};Document.prototype.isEqual=function(other){return other instanceof Document&&this.key.isEqual(other.key)&&this.version.isEqual(other.version)&&this.data.isEqual(other.data)&&this.hasLocalMutations===other.hasLocalMutations&&this.hasCommittedMutations===other.hasCommittedMutations;};Document.prototype.toString=function(){return"Document("+this.key+", "+this.version+", "+this.data.toString()+", "+("{hasLocalMutations: "+this.hasLocalMutations+"}), ")+("{hasCommittedMutations: "+this.hasCommittedMutations+"})");};Object.defineProperty(Document.prototype,"hasPendingWrites",{get:function get(){return this.hasLocalMutations||this.hasCommittedMutations;},enumerable:true,configurable:true});Document.compareByField=function(field,d1,d2){var v1=d1.field(field);var v2=d2.field(field);if(v1!==undefined&&v2!==undefined){return v1.compareTo(v2);}else{return fail("Trying to compare documents on fields that don't exist");}};return Document;}(MaybeDocument);/**
 * A class representing a deleted document.
 * Version is set to 0 if we don't point to any specific time, otherwise it
 * denotes time we know it didn't exist at.
 */var NoDocument=/** @class */function(_super){tslib_1.__extends(NoDocument,_super);function NoDocument(key,version,options){var _this=_super.call(this,key,version)||this;_this.hasCommittedMutations=!!(options&&options.hasCommittedMutations);return _this;}NoDocument.prototype.toString=function(){return"NoDocument("+this.key+", "+this.version+")";};Object.defineProperty(NoDocument.prototype,"hasPendingWrites",{get:function get(){return this.hasCommittedMutations;},enumerable:true,configurable:true});NoDocument.prototype.isEqual=function(other){return other instanceof NoDocument&&other.hasCommittedMutations===this.hasCommittedMutations&&other.version.isEqual(this.version)&&other.key.isEqual(this.key);};return NoDocument;}(MaybeDocument);/**
 * A class representing an existing document whose data is unknown (e.g. a
 * document that was updated without a known base document).
 */var UnknownDocument=/** @class */function(_super){tslib_1.__extends(UnknownDocument,_super);function UnknownDocument(key,version){return _super.call(this,key,version)||this;}UnknownDocument.prototype.toString=function(){return"UnknownDocument("+this.key+", "+this.version+")";};Object.defineProperty(UnknownDocument.prototype,"hasPendingWrites",{get:function get(){return true;},enumerable:true,configurable:true});UnknownDocument.prototype.isEqual=function(other){return other instanceof UnknownDocument&&other.version.isEqual(this.version)&&other.key.isEqual(this.key);};return UnknownDocument;}(MaybeDocument);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */// An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var SortedMap=/** @class */function(){function SortedMap(comparator,root){this.comparator=comparator;this.root=root?root:LLRBNode.EMPTY;}// Returns a copy of the map, with the specified key/value added or replaced.
SortedMap.prototype.insert=function(key,value){return new SortedMap(this.comparator,this.root.insert(key,value,this.comparator).copy(null,null,LLRBNode.BLACK,null,null));};// Returns a copy of the map, with the specified key removed.
SortedMap.prototype.remove=function(key){return new SortedMap(this.comparator,this.root.remove(key,this.comparator).copy(null,null,LLRBNode.BLACK,null,null));};// Returns the value of the node with the given key, or null.
SortedMap.prototype.get=function(key){var node=this.root;while(!node.isEmpty()){var cmp=this.comparator(key,node.key);if(cmp===0){return node.value;}else if(cmp<0){node=node.left;}else if(cmp>0){node=node.right;}}return null;};// Returns the index of the element in this sorted map, or -1 if it doesn't
// exist.
SortedMap.prototype.indexOf=function(key){// Number of nodes that were pruned when descending right
var prunedNodes=0;var node=this.root;while(!node.isEmpty()){var cmp=this.comparator(key,node.key);if(cmp===0){return prunedNodes+node.left.size;}else if(cmp<0){node=node.left;}else{// Count all nodes left of the node plus the node itself
prunedNodes+=node.left.size+1;node=node.right;}}// Node not found
return-1;};SortedMap.prototype.isEmpty=function(){return this.root.isEmpty();};Object.defineProperty(SortedMap.prototype,"size",{// Returns the total number of nodes in the map.
get:function get(){return this.root.size;},enumerable:true,configurable:true});// Returns the minimum key in the map.
SortedMap.prototype.minKey=function(){return this.root.minKey();};// Returns the maximum key in the map.
SortedMap.prototype.maxKey=function(){return this.root.maxKey();};// Traverses the map in key order and calls the specified action function
// for each key/value pair. If action returns true, traversal is aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
SortedMap.prototype.inorderTraversal=function(action){return this.root.inorderTraversal(action);};SortedMap.prototype.forEach=function(fn){this.inorderTraversal(function(k,v){fn(k,v);return false;});};SortedMap.prototype.toString=function(){var descriptions=[];this.inorderTraversal(function(k,v){descriptions.push(k+":"+v);return false;});return"{"+descriptions.join(', ')+"}";};// Traverses the map in reverse key order and calls the specified action
// function for each key/value pair. If action returns true, traversal is
// aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
SortedMap.prototype.reverseTraversal=function(action){return this.root.reverseTraversal(action);};// Returns an iterator over the SortedMap.
SortedMap.prototype.getIterator=function(){return new SortedMapIterator(this.root,null,this.comparator,false);};SortedMap.prototype.getIteratorFrom=function(key){return new SortedMapIterator(this.root,key,this.comparator,false);};SortedMap.prototype.getReverseIterator=function(){return new SortedMapIterator(this.root,null,this.comparator,true);};SortedMap.prototype.getReverseIteratorFrom=function(key){return new SortedMapIterator(this.root,key,this.comparator,true);};return SortedMap;}();// end SortedMap
// An iterator over an LLRBNode.
var SortedMapIterator=/** @class */function(){function SortedMapIterator(node,startKey,comparator,isReverse){this.isReverse=isReverse;this.nodeStack=[];var cmp=1;while(!node.isEmpty()){cmp=startKey?comparator(node.key,startKey):1;// flip the comparison if we're going in reverse
if(isReverse)cmp*=-1;if(cmp<0){// This node is less than our start key. ignore it
if(this.isReverse){node=node.left;}else{node=node.right;}}else if(cmp===0){// This node is exactly equal to our start key. Push it on the stack,
// but stop iterating;
this.nodeStack.push(node);break;}else{// This node is greater than our start key, add it to the stack and move
// to the next one
this.nodeStack.push(node);if(this.isReverse){node=node.right;}else{node=node.left;}}}}SortedMapIterator.prototype.getNext=function(){assert(this.nodeStack.length>0,'getNext() called on iterator when hasNext() is false.');var node=this.nodeStack.pop();var result={key:node.key,value:node.value};if(this.isReverse){node=node.left;while(!node.isEmpty()){this.nodeStack.push(node);node=node.right;}}else{node=node.right;while(!node.isEmpty()){this.nodeStack.push(node);node=node.left;}}return result;};SortedMapIterator.prototype.hasNext=function(){return this.nodeStack.length>0;};SortedMapIterator.prototype.peek=function(){if(this.nodeStack.length===0)return null;var node=this.nodeStack[this.nodeStack.length-1];return{key:node.key,value:node.value};};return SortedMapIterator;}();// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var LLRBNode=/** @class */function(){function LLRBNode(key,value,color,left,right){this.key=key;this.value=value;this.color=color!=null?color:LLRBNode.RED;this.left=left!=null?left:LLRBNode.EMPTY;this.right=right!=null?right:LLRBNode.EMPTY;this.size=this.left.size+1+this.right.size;}// Returns a copy of the current node, optionally replacing pieces of it.
LLRBNode.prototype.copy=function(key,value,color,left,right){return new LLRBNode(key!=null?key:this.key,value!=null?value:this.value,color!=null?color:this.color,left!=null?left:this.left,right!=null?right:this.right);};LLRBNode.prototype.isEmpty=function(){return false;};// Traverses the tree in key order and calls the specified action function
// for each node. If action returns true, traversal is aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
LLRBNode.prototype.inorderTraversal=function(action){return this.left.inorderTraversal(action)||action(this.key,this.value)||this.right.inorderTraversal(action);};// Traverses the tree in reverse key order and calls the specified action
// function for each node. If action returns true, traversal is aborted.
// Returns the first truthy value returned by action, or the last falsey
// value returned by action.
LLRBNode.prototype.reverseTraversal=function(action){return this.right.reverseTraversal(action)||action(this.key,this.value)||this.left.reverseTraversal(action);};// Returns the minimum node in the tree.
LLRBNode.prototype.min=function(){if(this.left.isEmpty()){return this;}else{return this.left.min();}};// Returns the maximum key in the tree.
LLRBNode.prototype.minKey=function(){return this.min().key;};// Returns the maximum key in the tree.
LLRBNode.prototype.maxKey=function(){if(this.right.isEmpty()){return this.key;}else{return this.right.maxKey();}};// Returns new tree, with the key/value added.
LLRBNode.prototype.insert=function(key,value,comparator){var n=this;var cmp=comparator(key,n.key);if(cmp<0){n=n.copy(null,null,null,n.left.insert(key,value,comparator),null);}else if(cmp===0){n=n.copy(null,value,null,null,null);}else{n=n.copy(null,null,null,null,n.right.insert(key,value,comparator));}return n.fixUp();};LLRBNode.prototype.removeMin=function(){if(this.left.isEmpty()){return LLRBNode.EMPTY;}var n=this;if(!n.left.isRed()&&!n.left.left.isRed())n=n.moveRedLeft();n=n.copy(null,null,null,n.left.removeMin(),null);return n.fixUp();};// Returns new tree, with the specified item removed.
LLRBNode.prototype.remove=function(key,comparator){var smallest;var n=this;if(comparator(key,n.key)<0){if(!n.left.isEmpty()&&!n.left.isRed()&&!n.left.left.isRed()){n=n.moveRedLeft();}n=n.copy(null,null,null,n.left.remove(key,comparator),null);}else{if(n.left.isRed())n=n.rotateRight();if(!n.right.isEmpty()&&!n.right.isRed()&&!n.right.left.isRed()){n=n.moveRedRight();}if(comparator(key,n.key)===0){if(n.right.isEmpty()){return LLRBNode.EMPTY;}else{smallest=n.right.min();n=n.copy(smallest.key,smallest.value,null,null,n.right.removeMin());}}n=n.copy(null,null,null,null,n.right.remove(key,comparator));}return n.fixUp();};LLRBNode.prototype.isRed=function(){return this.color;};// Returns new tree after performing any needed rotations.
LLRBNode.prototype.fixUp=function(){var n=this;if(n.right.isRed()&&!n.left.isRed())n=n.rotateLeft();if(n.left.isRed()&&n.left.left.isRed())n=n.rotateRight();if(n.left.isRed()&&n.right.isRed())n=n.colorFlip();return n;};LLRBNode.prototype.moveRedLeft=function(){var n=this.colorFlip();if(n.right.left.isRed()){n=n.copy(null,null,null,null,n.right.rotateRight());n=n.rotateLeft();n=n.colorFlip();}return n;};LLRBNode.prototype.moveRedRight=function(){var n=this.colorFlip();if(n.left.left.isRed()){n=n.rotateRight();n=n.colorFlip();}return n;};LLRBNode.prototype.rotateLeft=function(){var nl=this.copy(null,null,LLRBNode.RED,null,this.right.left);return this.right.copy(null,null,this.color,nl,null);};LLRBNode.prototype.rotateRight=function(){var nr=this.copy(null,null,LLRBNode.RED,this.left.right,null);return this.left.copy(null,null,this.color,null,nr);};LLRBNode.prototype.colorFlip=function(){var left=this.left.copy(null,null,!this.left.color,null,null);var right=this.right.copy(null,null,!this.right.color,null,null);return this.copy(null,null,!this.color,left,right);};// For testing.
LLRBNode.prototype.checkMaxDepth=function(){var blackDepth=this.check();if(Math.pow(2.0,blackDepth)<=this.size+1){return true;}else{return false;}};// In a balanced RB tree, the black-depth (number of black nodes) from root to
// leaves is equal on both sides.  This function verifies that or asserts.
LLRBNode.prototype.check=function(){if(this.isRed()&&this.left.isRed()){throw fail('Red node has red child('+this.key+','+this.value+')');}if(this.right.isRed()){throw fail('Right child of ('+this.key+','+this.value+') is red');}var blackDepth=this.left.check();if(blackDepth!==this.right.check()){throw fail('Black depths differ');}else{return blackDepth+(this.isRed()?0:1);}};// tslint:disable-next-line:no-any Empty node is shared between all LLRB trees.
LLRBNode.EMPTY=null;LLRBNode.RED=true;LLRBNode.BLACK=false;return LLRBNode;}();// end LLRBNode
// Represents an empty node (a leaf node in the Red-Black Tree).
var LLRBEmptyNode=/** @class */function(){function LLRBEmptyNode(){this.size=0;}// Returns a copy of the current node.
LLRBEmptyNode.prototype.copy=function(key,value,color,left,right){return this;};// Returns a copy of the tree, with the specified key/value added.
LLRBEmptyNode.prototype.insert=function(key,value,comparator){return new LLRBNode(key,value);};// Returns a copy of the tree, with the specified key removed.
LLRBEmptyNode.prototype.remove=function(key,comparator){return this;};LLRBEmptyNode.prototype.isEmpty=function(){return true;};LLRBEmptyNode.prototype.inorderTraversal=function(action){return false;};LLRBEmptyNode.prototype.reverseTraversal=function(action){return false;};LLRBEmptyNode.prototype.minKey=function(){return null;};LLRBEmptyNode.prototype.maxKey=function(){return null;};LLRBEmptyNode.prototype.isRed=function(){return false;};// For testing.
LLRBEmptyNode.prototype.checkMaxDepth=function(){return true;};LLRBEmptyNode.prototype.check=function(){return 0;};return LLRBEmptyNode;}();// end LLRBEmptyNode
LLRBNode.EMPTY=new LLRBEmptyNode();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var TypeOrder;(function(TypeOrder){// This order is defined by the backend.
TypeOrder[TypeOrder["NullValue"]=0]="NullValue";TypeOrder[TypeOrder["BooleanValue"]=1]="BooleanValue";TypeOrder[TypeOrder["NumberValue"]=2]="NumberValue";TypeOrder[TypeOrder["TimestampValue"]=3]="TimestampValue";TypeOrder[TypeOrder["StringValue"]=4]="StringValue";TypeOrder[TypeOrder["BlobValue"]=5]="BlobValue";TypeOrder[TypeOrder["RefValue"]=6]="RefValue";TypeOrder[TypeOrder["GeoPointValue"]=7]="GeoPointValue";TypeOrder[TypeOrder["ArrayValue"]=8]="ArrayValue";TypeOrder[TypeOrder["ObjectValue"]=9]="ObjectValue";})(TypeOrder||(TypeOrder={}));/** Defines the return value for pending server timestamps. */var ServerTimestampBehavior;(function(ServerTimestampBehavior){ServerTimestampBehavior[ServerTimestampBehavior["Default"]=0]="Default";ServerTimestampBehavior[ServerTimestampBehavior["Estimate"]=1]="Estimate";ServerTimestampBehavior[ServerTimestampBehavior["Previous"]=2]="Previous";})(ServerTimestampBehavior||(ServerTimestampBehavior={}));/** Holds properties that define field value deserialization options. */var FieldValueOptions=/** @class */function(){function FieldValueOptions(serverTimestampBehavior,timestampsInSnapshots){this.serverTimestampBehavior=serverTimestampBehavior;this.timestampsInSnapshots=timestampsInSnapshots;}FieldValueOptions.fromSnapshotOptions=function(options,timestampsInSnapshots){switch(options.serverTimestamps){case'estimate':return new FieldValueOptions(ServerTimestampBehavior.Estimate,timestampsInSnapshots);case'previous':return new FieldValueOptions(ServerTimestampBehavior.Previous,timestampsInSnapshots);case'none':// Fall-through intended.
case undefined:return new FieldValueOptions(ServerTimestampBehavior.Default,timestampsInSnapshots);default:return fail('fromSnapshotOptions() called with invalid options.');}};return FieldValueOptions;}();/**
 * A field value represents a datatype as stored by Firestore.
 */var FieldValue=/** @class */function(){function FieldValue(){}FieldValue.prototype.toString=function(){var val=this.value();return val===null?'null':val.toString();};FieldValue.prototype.defaultCompareTo=function(other){assert(this.typeOrder!==other.typeOrder,'Default compareTo should not be used for values of same type.');var cmp=primitiveComparator(this.typeOrder,other.typeOrder);return cmp;};return FieldValue;}();var NullValue=/** @class */function(_super){tslib_1.__extends(NullValue,_super);function NullValue(){var _this=_super.call(this)||this;_this.typeOrder=TypeOrder.NullValue;// internalValue is unused but we add it to work around
// https://github.com/Microsoft/TypeScript/issues/15585
_this.internalValue=null;return _this;}NullValue.prototype.value=function(options){return null;};NullValue.prototype.isEqual=function(other){return other instanceof NullValue;};NullValue.prototype.compareTo=function(other){if(other instanceof NullValue){return 0;}return this.defaultCompareTo(other);};NullValue.INSTANCE=new NullValue();return NullValue;}(FieldValue);var BooleanValue=/** @class */function(_super){tslib_1.__extends(BooleanValue,_super);function BooleanValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.BooleanValue;return _this;}BooleanValue.prototype.value=function(options){return this.internalValue;};BooleanValue.prototype.isEqual=function(other){return other instanceof BooleanValue&&this.internalValue===other.internalValue;};BooleanValue.prototype.compareTo=function(other){if(other instanceof BooleanValue){return primitiveComparator(this,other);}return this.defaultCompareTo(other);};BooleanValue.of=function(value){return value?BooleanValue.TRUE:BooleanValue.FALSE;};BooleanValue.TRUE=new BooleanValue(true);BooleanValue.FALSE=new BooleanValue(false);return BooleanValue;}(FieldValue);/** Base class for IntegerValue and DoubleValue. */var NumberValue=/** @class */function(_super){tslib_1.__extends(NumberValue,_super);function NumberValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.NumberValue;return _this;}NumberValue.prototype.value=function(options){return this.internalValue;};NumberValue.prototype.compareTo=function(other){if(other instanceof NumberValue){return numericComparator(this.internalValue,other.internalValue);}return this.defaultCompareTo(other);};return NumberValue;}(FieldValue);/** Utility function to compare doubles (using Firestore semantics for NaN). */function numericComparator(left,right){if(left<right){return-1;}else if(left>right){return 1;}else if(left===right){return 0;}else{// one or both are NaN.
if(isNaN(left)){return isNaN(right)?0:-1;}else{return 1;}}}/**
 * Utility function to check numbers for equality using Firestore semantics
 * (NaN === NaN, -0.0 !== 0.0).
 */function numericEquals(left,right){// Implemented based on Object.is() polyfill from
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
if(left===right){// +0 != -0
return left!==0||1/left===1/right;}else{// NaN == NaN
return left!==left&&right!==right;}}var IntegerValue=/** @class */function(_super){tslib_1.__extends(IntegerValue,_super);function IntegerValue(internalValue){return _super.call(this,internalValue)||this;}IntegerValue.prototype.isEqual=function(other){// NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
// but that doesn't make them equal via isEqual().
if(other instanceof IntegerValue){return numericEquals(this.internalValue,other.internalValue);}else{return false;}};return IntegerValue;}(NumberValue);var DoubleValue=/** @class */function(_super){tslib_1.__extends(DoubleValue,_super);function DoubleValue(internalValue){var _this=_super.call(this,internalValue)||this;_this.internalValue=internalValue;return _this;}DoubleValue.prototype.isEqual=function(other){// NOTE: DoubleValue and IntegerValue instances may compareTo() the same,
// but that doesn't make them equal via isEqual().
if(other instanceof DoubleValue){return numericEquals(this.internalValue,other.internalValue);}else{return false;}};DoubleValue.NAN=new DoubleValue(NaN);DoubleValue.POSITIVE_INFINITY=new DoubleValue(Infinity);DoubleValue.NEGATIVE_INFINITY=new DoubleValue(-Infinity);return DoubleValue;}(NumberValue);// TODO(b/37267885): Add truncation support
var StringValue=/** @class */function(_super){tslib_1.__extends(StringValue,_super);function StringValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.StringValue;return _this;}StringValue.prototype.value=function(options){return this.internalValue;};StringValue.prototype.isEqual=function(other){return other instanceof StringValue&&this.internalValue===other.internalValue;};StringValue.prototype.compareTo=function(other){if(other instanceof StringValue){return primitiveComparator(this.internalValue,other.internalValue);}return this.defaultCompareTo(other);};return StringValue;}(FieldValue);var TimestampValue=/** @class */function(_super){tslib_1.__extends(TimestampValue,_super);function TimestampValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.TimestampValue;return _this;}TimestampValue.prototype.value=function(options){if(!options||options.timestampsInSnapshots){return this.internalValue;}else{return this.internalValue.toDate();}};TimestampValue.prototype.isEqual=function(other){return other instanceof TimestampValue&&this.internalValue.isEqual(other.internalValue);};TimestampValue.prototype.compareTo=function(other){if(other instanceof TimestampValue){return this.internalValue._compareTo(other.internalValue);}else if(other instanceof ServerTimestampValue){// Concrete timestamps come before server timestamps.
return-1;}else{return this.defaultCompareTo(other);}};return TimestampValue;}(FieldValue);/**
 * Represents a locally-applied ServerTimestamp.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
 *   the local view of a document. Therefore they do not need to be parsed or
 *   serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */var ServerTimestampValue=/** @class */function(_super){tslib_1.__extends(ServerTimestampValue,_super);function ServerTimestampValue(localWriteTime,previousValue){var _this=_super.call(this)||this;_this.localWriteTime=localWriteTime;_this.previousValue=previousValue;_this.typeOrder=TypeOrder.TimestampValue;return _this;}ServerTimestampValue.prototype.value=function(options){if(options&&options.serverTimestampBehavior===ServerTimestampBehavior.Estimate){return new TimestampValue(this.localWriteTime).value(options);}else if(options&&options.serverTimestampBehavior===ServerTimestampBehavior.Previous){return this.previousValue?this.previousValue.value(options):null;}else{return null;}};ServerTimestampValue.prototype.isEqual=function(other){return other instanceof ServerTimestampValue&&this.localWriteTime.isEqual(other.localWriteTime);};ServerTimestampValue.prototype.compareTo=function(other){if(other instanceof ServerTimestampValue){return this.localWriteTime._compareTo(other.localWriteTime);}else if(other instanceof TimestampValue){// Server timestamps come after all concrete timestamps.
return 1;}else{return this.defaultCompareTo(other);}};ServerTimestampValue.prototype.toString=function(){return'<ServerTimestamp localTime='+this.localWriteTime.toString()+'>';};return ServerTimestampValue;}(FieldValue);var BlobValue=/** @class */function(_super){tslib_1.__extends(BlobValue,_super);function BlobValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.BlobValue;return _this;}BlobValue.prototype.value=function(options){return this.internalValue;};BlobValue.prototype.isEqual=function(other){return other instanceof BlobValue&&this.internalValue.isEqual(other.internalValue);};BlobValue.prototype.compareTo=function(other){if(other instanceof BlobValue){return this.internalValue._compareTo(other.internalValue);}return this.defaultCompareTo(other);};return BlobValue;}(FieldValue);var RefValue=/** @class */function(_super){tslib_1.__extends(RefValue,_super);function RefValue(databaseId,key){var _this=_super.call(this)||this;_this.databaseId=databaseId;_this.key=key;_this.typeOrder=TypeOrder.RefValue;return _this;}RefValue.prototype.value=function(options){return this.key;};RefValue.prototype.isEqual=function(other){if(other instanceof RefValue){return this.key.isEqual(other.key)&&this.databaseId.isEqual(other.databaseId);}else{return false;}};RefValue.prototype.compareTo=function(other){if(other instanceof RefValue){var cmp=this.databaseId.compareTo(other.databaseId);return cmp!==0?cmp:DocumentKey.comparator(this.key,other.key);}return this.defaultCompareTo(other);};return RefValue;}(FieldValue);var GeoPointValue=/** @class */function(_super){tslib_1.__extends(GeoPointValue,_super);function GeoPointValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.GeoPointValue;return _this;}GeoPointValue.prototype.value=function(options){return this.internalValue;};GeoPointValue.prototype.isEqual=function(other){return other instanceof GeoPointValue&&this.internalValue.isEqual(other.internalValue);};GeoPointValue.prototype.compareTo=function(other){if(other instanceof GeoPointValue){return this.internalValue._compareTo(other.internalValue);}return this.defaultCompareTo(other);};return GeoPointValue;}(FieldValue);var ObjectValue=/** @class */function(_super){tslib_1.__extends(ObjectValue,_super);function ObjectValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.ObjectValue;return _this;}ObjectValue.prototype.value=function(options){var result={};this.internalValue.inorderTraversal(function(key,val){result[key]=val.value(options);});return result;};ObjectValue.prototype.forEach=function(action){this.internalValue.inorderTraversal(action);};ObjectValue.prototype.isEqual=function(other){if(other instanceof ObjectValue){var it1=this.internalValue.getIterator();var it2=other.internalValue.getIterator();while(it1.hasNext()&&it2.hasNext()){var next1=it1.getNext();var next2=it2.getNext();if(next1.key!==next2.key||!next1.value.isEqual(next2.value)){return false;}}return!it1.hasNext()&&!it2.hasNext();}return false;};ObjectValue.prototype.compareTo=function(other){if(other instanceof ObjectValue){var it1=this.internalValue.getIterator();var it2=other.internalValue.getIterator();while(it1.hasNext()&&it2.hasNext()){var next1=it1.getNext();var next2=it2.getNext();var cmp=primitiveComparator(next1.key,next2.key)||next1.value.compareTo(next2.value);if(cmp){return cmp;}}// Only equal if both iterators are exhausted
return primitiveComparator(it1.hasNext(),it2.hasNext());}else{return this.defaultCompareTo(other);}};ObjectValue.prototype.set=function(path,to){assert(!path.isEmpty(),'Cannot set field for empty path on ObjectValue');if(path.length===1){return this.setChild(path.firstSegment(),to);}else{var child=this.child(path.firstSegment());if(!(child instanceof ObjectValue)){child=ObjectValue.EMPTY;}var newChild=child.set(path.popFirst(),to);return this.setChild(path.firstSegment(),newChild);}};ObjectValue.prototype.delete=function(path){assert(!path.isEmpty(),'Cannot delete field for empty path on ObjectValue');if(path.length===1){return new ObjectValue(this.internalValue.remove(path.firstSegment()));}else{// nested field
var child=this.child(path.firstSegment());if(child instanceof ObjectValue){var newChild=child.delete(path.popFirst());return new ObjectValue(this.internalValue.insert(path.firstSegment(),newChild));}else{// Don't actually change a primitive value to an object for a delete
return this;}}};ObjectValue.prototype.contains=function(path){return this.field(path)!==undefined;};ObjectValue.prototype.field=function(path){assert(!path.isEmpty(),"Can't get field of empty path");var field=this;path.forEach(function(pathSegment){if(field instanceof ObjectValue){field=field.internalValue.get(pathSegment)||undefined;}else{field=undefined;}});return field;};ObjectValue.prototype.toString=function(){return this.internalValue.toString();};ObjectValue.prototype.child=function(childName){return this.internalValue.get(childName)||undefined;};ObjectValue.prototype.setChild=function(childName,value){return new ObjectValue(this.internalValue.insert(childName,value));};ObjectValue.EMPTY=new ObjectValue(new SortedMap(primitiveComparator));return ObjectValue;}(FieldValue);var ArrayValue=/** @class */function(_super){tslib_1.__extends(ArrayValue,_super);function ArrayValue(internalValue){var _this=_super.call(this)||this;_this.internalValue=internalValue;_this.typeOrder=TypeOrder.ArrayValue;return _this;}ArrayValue.prototype.value=function(options){return this.internalValue.map(function(v){return v.value(options);});};ArrayValue.prototype.forEach=function(action){this.internalValue.forEach(action);};ArrayValue.prototype.isEqual=function(other){if(other instanceof ArrayValue){if(this.internalValue.length!==other.internalValue.length){return false;}for(var i=0;i<this.internalValue.length;i++){if(!this.internalValue[i].isEqual(other.internalValue[i])){return false;}}return true;}return false;};ArrayValue.prototype.compareTo=function(other){if(other instanceof ArrayValue){var minLength=Math.min(this.internalValue.length,other.internalValue.length);for(var i=0;i<minLength;i++){var cmp=this.internalValue[i].compareTo(other.internalValue[i]);if(cmp){return cmp;}}return primitiveComparator(this.internalValue.length,other.internalValue.length);}else{return this.defaultCompareTo(other);}};ArrayValue.prototype.toString=function(){var descriptions=this.internalValue.map(function(v){return v.toString();});return"["+descriptions.join(',')+"]";};return ArrayValue;}(FieldValue);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */// Untyped Number alias we can use to check for ES6 methods / properties.
// tslint:disable-next-line:no-any variable-name
var NumberAsAny=Number;/**
 * Minimum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */var MIN_SAFE_INTEGER=NumberAsAny.MIN_SAFE_INTEGER||-(Math.pow(2,53)-1);/**
 * Maximum safe integer in Javascript because of floating point precision.
 * Added to not rely on ES6 features.
 */var MAX_SAFE_INTEGER=NumberAsAny.MAX_SAFE_INTEGER||Math.pow(2,53)-1;/**
 * Returns whether an number is an integer, uses native implementation if
 * available.
 * Added to not rely on ES6 features.
 * @param value The value to test for being an integer
 */var isInteger=NumberAsAny.isInteger||function(value){return typeof value==='number'&&isFinite(value)&&Math.floor(value)===value;};/**
 * Returns whether a variable is either undefined or null.
 */function isNullOrUndefined(value){return value===null||value===undefined;}/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value The value to test for being an integer and in the safe range
 */function isSafeInteger(value){return isInteger(value)&&value<=MAX_SAFE_INTEGER&&value>=MIN_SAFE_INTEGER;}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var Query=/** @class */function(){/**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */function Query(path,collectionGroup,explicitOrderBy,filters,limit,startAt,endAt){if(collectionGroup===void 0){collectionGroup=null;}if(explicitOrderBy===void 0){explicitOrderBy=[];}if(filters===void 0){filters=[];}if(limit===void 0){limit=null;}if(startAt===void 0){startAt=null;}if(endAt===void 0){endAt=null;}this.path=path;this.collectionGroup=collectionGroup;this.explicitOrderBy=explicitOrderBy;this.filters=filters;this.limit=limit;this.startAt=startAt;this.endAt=endAt;this.memoizedCanonicalId=null;this.memoizedOrderBy=null;if(this.startAt){this.assertValidBound(this.startAt);}if(this.endAt){this.assertValidBound(this.endAt);}}Query.atPath=function(path){return new Query(path);};Object.defineProperty(Query.prototype,"orderBy",{get:function get(){if(this.memoizedOrderBy===null){var inequalityField=this.getInequalityFilterField();var firstOrderByField=this.getFirstOrderByField();if(inequalityField!==null&&firstOrderByField===null){// In order to implicitly add key ordering, we must also add the
// inequality filter field for it to be a valid query.
// Note that the default inequality field and key ordering is ascending.
if(inequalityField.isKeyField()){this.memoizedOrderBy=[KEY_ORDERING_ASC];}else{this.memoizedOrderBy=[new OrderBy(inequalityField),KEY_ORDERING_ASC];}}else{assert(inequalityField===null||firstOrderByField!==null&&inequalityField.isEqual(firstOrderByField),'First orderBy should match inequality field.');this.memoizedOrderBy=[];var foundKeyOrdering=false;for(var _i=0,_a=this.explicitOrderBy;_i<_a.length;_i++){var orderBy=_a[_i];this.memoizedOrderBy.push(orderBy);if(orderBy.field.isKeyField()){foundKeyOrdering=true;}}if(!foundKeyOrdering){// The order of the implicit key ordering always matches the last
// explicit order by
var lastDirection=this.explicitOrderBy.length>0?this.explicitOrderBy[this.explicitOrderBy.length-1].dir:Direction.ASCENDING;this.memoizedOrderBy.push(lastDirection===Direction.ASCENDING?KEY_ORDERING_ASC:KEY_ORDERING_DESC);}}}return this.memoizedOrderBy;},enumerable:true,configurable:true});Query.prototype.addFilter=function(filter){assert(this.getInequalityFilterField()==null||!(filter instanceof RelationFilter)||!filter.isInequality()||filter.field.isEqual(this.getInequalityFilterField()),'Query must only have one inequality field.');assert(!this.isDocumentQuery(),'No filtering allowed for document query');var newFilters=this.filters.concat([filter]);return new Query(this.path,this.collectionGroup,this.explicitOrderBy.slice(),newFilters,this.limit,this.startAt,this.endAt);};Query.prototype.addOrderBy=function(orderBy){assert(!this.startAt&&!this.endAt,'Bounds must be set after orderBy');// TODO(dimond): validate that orderBy does not list the same key twice.
var newOrderBy=this.explicitOrderBy.concat([orderBy]);return new Query(this.path,this.collectionGroup,newOrderBy,this.filters.slice(),this.limit,this.startAt,this.endAt);};Query.prototype.withLimit=function(limit){return new Query(this.path,this.collectionGroup,this.explicitOrderBy.slice(),this.filters.slice(),limit,this.startAt,this.endAt);};Query.prototype.withStartAt=function(bound){return new Query(this.path,this.collectionGroup,this.explicitOrderBy.slice(),this.filters.slice(),this.limit,bound,this.endAt);};Query.prototype.withEndAt=function(bound){return new Query(this.path,this.collectionGroup,this.explicitOrderBy.slice(),this.filters.slice(),this.limit,this.startAt,bound);};/**
     * Helper to convert a collection group query into a collection query at a
     * specific path. This is used when executing collection group queries, since
     * we have to split the query into a set of collection queries at multiple
     * paths.
     */Query.prototype.asCollectionQueryAtPath=function(path){return new Query(path,/*collectionGroup=*/null,this.explicitOrderBy.slice(),this.filters.slice(),this.limit,this.startAt,this.endAt);};// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
Query.prototype.canonicalId=function(){if(this.memoizedCanonicalId===null){var canonicalId=this.path.canonicalString();if(this.isCollectionGroupQuery()){canonicalId+='|cg:'+this.collectionGroup;}canonicalId+='|f:';for(var _i=0,_a=this.filters;_i<_a.length;_i++){var filter=_a[_i];canonicalId+=filter.canonicalId();canonicalId+=',';}canonicalId+='|ob:';// TODO(dimond): make this collision resistant
for(var _b=0,_c=this.orderBy;_b<_c.length;_b++){var orderBy=_c[_b];canonicalId+=orderBy.canonicalId();canonicalId+=',';}if(!isNullOrUndefined(this.limit)){canonicalId+='|l:';canonicalId+=this.limit;}if(this.startAt){canonicalId+='|lb:';canonicalId+=this.startAt.canonicalId();}if(this.endAt){canonicalId+='|ub:';canonicalId+=this.endAt.canonicalId();}this.memoizedCanonicalId=canonicalId;}return this.memoizedCanonicalId;};Query.prototype.toString=function(){var str='Query('+this.path.canonicalString();if(this.isCollectionGroupQuery()){str+=' collectionGroup='+this.collectionGroup;}if(this.filters.length>0){str+=", filters: ["+this.filters.join(', ')+"]";}if(!isNullOrUndefined(this.limit)){str+=', limit: '+this.limit;}if(this.explicitOrderBy.length>0){str+=", orderBy: ["+this.explicitOrderBy.join(', ')+"]";}if(this.startAt){str+=', startAt: '+this.startAt.canonicalId();}if(this.endAt){str+=', endAt: '+this.endAt.canonicalId();}return str+')';};Query.prototype.isEqual=function(other){if(this.limit!==other.limit){return false;}if(this.orderBy.length!==other.orderBy.length){return false;}for(var i=0;i<this.orderBy.length;i++){if(!this.orderBy[i].isEqual(other.orderBy[i])){return false;}}if(this.filters.length!==other.filters.length){return false;}for(var i=0;i<this.filters.length;i++){if(!this.filters[i].isEqual(other.filters[i])){return false;}}if(this.collectionGroup!==other.collectionGroup){return false;}if(!this.path.isEqual(other.path)){return false;}if(this.startAt!==null?!this.startAt.isEqual(other.startAt):other.startAt!==null){return false;}return this.endAt!==null?this.endAt.isEqual(other.endAt):other.endAt===null;};Query.prototype.docComparator=function(d1,d2){var comparedOnKeyField=false;for(var _i=0,_a=this.orderBy;_i<_a.length;_i++){var orderBy=_a[_i];var comp=orderBy.compare(d1,d2);if(comp!==0)return comp;comparedOnKeyField=comparedOnKeyField||orderBy.field.isKeyField();}// Assert that we actually compared by key
assert(comparedOnKeyField,"orderBy used that doesn't compare on key field");return 0;};Query.prototype.matches=function(doc){return this.matchesPathAndCollectionGroup(doc)&&this.matchesOrderBy(doc)&&this.matchesFilters(doc)&&this.matchesBounds(doc);};Query.prototype.hasLimit=function(){return!isNullOrUndefined(this.limit);};Query.prototype.getFirstOrderByField=function(){return this.explicitOrderBy.length>0?this.explicitOrderBy[0].field:null;};Query.prototype.getInequalityFilterField=function(){for(var _i=0,_a=this.filters;_i<_a.length;_i++){var filter=_a[_i];if(filter instanceof RelationFilter&&filter.isInequality()){return filter.field;}}return null;};Query.prototype.hasArrayContainsFilter=function(){return this.filters.find(function(filter){return filter instanceof RelationFilter&&filter.op===RelationOp.ARRAY_CONTAINS;})!==undefined;};Query.prototype.isDocumentQuery=function(){return DocumentKey.isDocumentKey(this.path)&&this.collectionGroup===null&&this.filters.length===0;};Query.prototype.isCollectionGroupQuery=function(){return this.collectionGroup!==null;};Query.prototype.matchesPathAndCollectionGroup=function(doc){var docPath=doc.key.path;if(this.collectionGroup!==null){// NOTE: this.path is currently always empty since we don't expose Collection
// Group queries rooted at a document path yet.
return doc.key.hasCollectionId(this.collectionGroup)&&this.path.isPrefixOf(docPath);}else if(DocumentKey.isDocumentKey(this.path)){// exact match for document queries
return this.path.isEqual(docPath);}else{// shallow ancestor queries by default
return this.path.isImmediateParentOf(docPath);}};/**
     * A document must have a value for every ordering clause in order to show up
     * in the results.
     */Query.prototype.matchesOrderBy=function(doc){for(var _i=0,_a=this.explicitOrderBy;_i<_a.length;_i++){var orderBy=_a[_i];// order by key always matches
if(!orderBy.field.isKeyField()&&doc.field(orderBy.field)===undefined){return false;}}return true;};Query.prototype.matchesFilters=function(doc){for(var _i=0,_a=this.filters;_i<_a.length;_i++){var filter=_a[_i];if(!filter.matches(doc)){return false;}}return true;};/**
     * Makes sure a document is within the bounds, if provided.
     */Query.prototype.matchesBounds=function(doc){if(this.startAt&&!this.startAt.sortsBeforeDocument(this.orderBy,doc)){return false;}if(this.endAt&&this.endAt.sortsBeforeDocument(this.orderBy,doc)){return false;}return true;};Query.prototype.assertValidBound=function(bound){assert(bound.position.length<=this.orderBy.length,'Bound is longer than orderBy');};return Query;}();var Filter=/** @class */function(){function Filter(){}/**
     * Creates a filter based on the provided arguments.
     */Filter.create=function(field,op,value){if(value.isEqual(NullValue.INSTANCE)){if(op!==RelationOp.EQUAL){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. You can only perform equals comparisons on null.');}return new NullFilter(field);}else if(value.isEqual(DoubleValue.NAN)){if(op!==RelationOp.EQUAL){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. You can only perform equals comparisons on NaN.');}return new NanFilter(field);}else{return new RelationFilter(field,op,value);}};return Filter;}();var RelationOp=/** @class */function(){function RelationOp(name){this.name=name;}RelationOp.fromString=function(op){switch(op){case'<':return RelationOp.LESS_THAN;case'<=':return RelationOp.LESS_THAN_OR_EQUAL;case'==':return RelationOp.EQUAL;case'>=':return RelationOp.GREATER_THAN_OR_EQUAL;case'>':return RelationOp.GREATER_THAN;case'array-contains':return RelationOp.ARRAY_CONTAINS;default:return fail('Unknown relation: '+op);}};RelationOp.prototype.toString=function(){return this.name;};RelationOp.prototype.isEqual=function(other){return this.name===other.name;};RelationOp.LESS_THAN=new RelationOp('<');RelationOp.LESS_THAN_OR_EQUAL=new RelationOp('<=');RelationOp.EQUAL=new RelationOp('==');RelationOp.GREATER_THAN=new RelationOp('>');RelationOp.GREATER_THAN_OR_EQUAL=new RelationOp('>=');RelationOp.ARRAY_CONTAINS=new RelationOp('array-contains');return RelationOp;}();var RelationFilter=/** @class */function(_super){tslib_1.__extends(RelationFilter,_super);function RelationFilter(field,op,value){var _this=_super.call(this)||this;_this.field=field;_this.op=op;_this.value=value;return _this;}RelationFilter.prototype.matches=function(doc){if(this.field.isKeyField()){assert(this.value instanceof RefValue,'Comparing on key, but filter value not a RefValue');assert(this.op!==RelationOp.ARRAY_CONTAINS,"array-contains queries don't make sense on document keys.");var refValue=this.value;var comparison=DocumentKey.comparator(doc.key,refValue.key);return this.matchesComparison(comparison);}else{var val=doc.field(this.field);return val!==undefined&&this.matchesValue(val);}};RelationFilter.prototype.matchesValue=function(value){var _this=this;if(this.op===RelationOp.ARRAY_CONTAINS){return value instanceof ArrayValue&&value.internalValue.find(function(element){return element.isEqual(_this.value);})!==undefined;}else{// Only compare types with matching backend order (such as double and int).
return this.value.typeOrder===value.typeOrder&&this.matchesComparison(value.compareTo(this.value));}};RelationFilter.prototype.matchesComparison=function(comparison){switch(this.op){case RelationOp.LESS_THAN:return comparison<0;case RelationOp.LESS_THAN_OR_EQUAL:return comparison<=0;case RelationOp.EQUAL:return comparison===0;case RelationOp.GREATER_THAN:return comparison>0;case RelationOp.GREATER_THAN_OR_EQUAL:return comparison>=0;default:return fail('Unknown relation op'+this.op);}};RelationFilter.prototype.isInequality=function(){return this.op!==RelationOp.EQUAL&&this.op!==RelationOp.ARRAY_CONTAINS;};RelationFilter.prototype.canonicalId=function(){// TODO(b/29183165): Technically, this won't be unique if two values have
// the same description, such as the int 3 and the string "3". So we should
// add the types in here somehow, too.
return this.field.canonicalString()+this.op.toString()+this.value.toString();};RelationFilter.prototype.isEqual=function(other){if(other instanceof RelationFilter){return this.op.isEqual(other.op)&&this.field.isEqual(other.field)&&this.value.isEqual(other.value);}else{return false;}};RelationFilter.prototype.toString=function(){return this.field.canonicalString()+" "+this.op+" "+this.value.value();};return RelationFilter;}(Filter);/**
 * Filter that matches 'null' values.
 */var NullFilter=/** @class */function(_super){tslib_1.__extends(NullFilter,_super);function NullFilter(field){var _this=_super.call(this)||this;_this.field=field;return _this;}NullFilter.prototype.matches=function(doc){var val=doc.field(this.field);return val!==undefined&&val.value()===null;};NullFilter.prototype.canonicalId=function(){return this.field.canonicalString()+' IS null';};NullFilter.prototype.toString=function(){return this.field.canonicalString()+" IS null";};NullFilter.prototype.isEqual=function(other){if(other instanceof NullFilter){return this.field.isEqual(other.field);}else{return false;}};return NullFilter;}(Filter);/**
 * Filter that matches 'NaN' values.
 */var NanFilter=/** @class */function(_super){tslib_1.__extends(NanFilter,_super);function NanFilter(field){var _this=_super.call(this)||this;_this.field=field;return _this;}NanFilter.prototype.matches=function(doc){var field=doc.field(this.field);var val=field&&field.value();return typeof val==='number'&&isNaN(val);};NanFilter.prototype.canonicalId=function(){return this.field.canonicalString()+' IS NaN';};NanFilter.prototype.toString=function(){return this.field.canonicalString()+" IS NaN";};NanFilter.prototype.isEqual=function(other){if(other instanceof NanFilter){return this.field.isEqual(other.field);}else{return false;}};return NanFilter;}(Filter);/**
 * The direction of sorting in an order by.
 */var Direction=/** @class */function(){function Direction(name){this.name=name;}Direction.prototype.toString=function(){return this.name;};Direction.ASCENDING=new Direction('asc');Direction.DESCENDING=new Direction('desc');return Direction;}();/**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */var Bound=/** @class */function(){function Bound(position,before){this.position=position;this.before=before;}Bound.prototype.canonicalId=function(){// TODO(b/29183165): Make this collision robust.
var canonicalId=this.before?'b:':'a:';for(var _i=0,_a=this.position;_i<_a.length;_i++){var component=_a[_i];canonicalId+=component.toString();}return canonicalId;};/**
     * Returns true if a document sorts before a bound using the provided sort
     * order.
     */Bound.prototype.sortsBeforeDocument=function(orderBy,doc){assert(this.position.length<=orderBy.length,"Bound has more components than query's orderBy");var comparison=0;for(var i=0;i<this.position.length;i++){var orderByComponent=orderBy[i];var component=this.position[i];if(orderByComponent.field.isKeyField()){assert(component instanceof RefValue,'Bound has a non-key value where the key path is being used.');comparison=DocumentKey.comparator(component.key,doc.key);}else{var docValue=doc.field(orderByComponent.field);assert(docValue!==undefined,'Field should exist since document matched the orderBy already.');comparison=component.compareTo(docValue);}if(orderByComponent.dir===Direction.DESCENDING){comparison=comparison*-1;}if(comparison!==0){break;}}return this.before?comparison<=0:comparison<0;};Bound.prototype.isEqual=function(other){if(other===null){return false;}if(this.before!==other.before||this.position.length!==other.position.length){return false;}for(var i=0;i<this.position.length;i++){var thisPosition=this.position[i];var otherPosition=other.position[i];return thisPosition.isEqual(otherPosition);}return true;};return Bound;}();/**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */var OrderBy=/** @class */function(){function OrderBy(field,dir){this.field=field;if(dir===undefined){dir=Direction.ASCENDING;}this.dir=dir;this.isKeyOrderBy=field.isKeyField();}OrderBy.prototype.compare=function(d1,d2){var comparison=this.isKeyOrderBy?Document.compareByKey(d1,d2):Document.compareByField(this.field,d1,d2);switch(this.dir){case Direction.ASCENDING:return comparison;case Direction.DESCENDING:return-1*comparison;default:return fail('Unknown direction: '+this.dir);}};OrderBy.prototype.canonicalId=function(){// TODO(b/29183165): Make this collision robust.
return this.field.canonicalString()+this.dir.toString();};OrderBy.prototype.toString=function(){return this.field.canonicalString()+" ("+this.dir+")";};OrderBy.prototype.isEqual=function(other){return this.dir===other.dir&&this.field.isEqual(other.field);};return OrderBy;}();var KEY_ORDERING_ASC=new OrderBy(FieldPath.keyField(),Direction.ASCENDING);var KEY_ORDERING_DESC=new OrderBy(FieldPath.keyField(),Direction.DESCENDING);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */var SnapshotVersion=/** @class */function(){function SnapshotVersion(timestamp){this.timestamp=timestamp;}// TODO(b/34176344): Once we no longer need to use the old alpha protos,
// delete this constructor and use a timestamp-backed version everywhere.
SnapshotVersion.fromMicroseconds=function(value){var seconds=Math.floor(value/1e6);var nanos=value%1e6*1e3;return new SnapshotVersion(new Timestamp(seconds,nanos));};SnapshotVersion.fromTimestamp=function(value){return new SnapshotVersion(value);};SnapshotVersion.forDeletedDoc=function(){return SnapshotVersion.MIN;};SnapshotVersion.prototype.compareTo=function(other){return this.timestamp._compareTo(other.timestamp);};SnapshotVersion.prototype.isEqual=function(other){return this.timestamp.isEqual(other.timestamp);};/** Returns a number representation of the version for use in spec tests. */SnapshotVersion.prototype.toMicroseconds=function(){// Convert to microseconds.
return this.timestamp.seconds*1e6+this.timestamp.nanoseconds/1000;};SnapshotVersion.prototype.toString=function(){return'SnapshotVersion('+this.timestamp.toString()+')';};SnapshotVersion.prototype.toTimestamp=function(){return this.timestamp;};SnapshotVersion.MIN=new SnapshotVersion(new Timestamp(0,0));return SnapshotVersion;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//** An enumeration of the different purposes we have for queries. */var QueryPurpose;(function(QueryPurpose){/** A regular, normal query. */QueryPurpose[QueryPurpose["Listen"]=0]="Listen";/**
     * The query was used to refill a query after an existence filter mismatch.
     */QueryPurpose[QueryPurpose["ExistenceFilterMismatch"]=1]="ExistenceFilterMismatch";/** The query was used to resolve a limbo document. */QueryPurpose[QueryPurpose["LimboResolution"]=2]="LimboResolution";})(QueryPurpose||(QueryPurpose={}));/**
 * An immutable set of metadata that the local store tracks for each query.
 */var QueryData=/** @class */function(){function QueryData(/** The query being listened to. */query,/**
     * The target ID to which the query corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */targetId,/** The purpose of the query. */purpose,/** The sequence number of the last transaction during which this query data was modified */sequenceNumber,/** The latest snapshot version seen for this target. */snapshotVersion,/**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */resumeToken){if(snapshotVersion===void 0){snapshotVersion=SnapshotVersion.MIN;}if(resumeToken===void 0){resumeToken=emptyByteString();}this.query=query;this.targetId=targetId;this.purpose=purpose;this.sequenceNumber=sequenceNumber;this.snapshotVersion=snapshotVersion;this.resumeToken=resumeToken;}/**
     * Creates a new query data instance with an updated snapshot version and
     * resume token.
     */QueryData.prototype.copy=function(overwrite){return new QueryData(this.query,this.targetId,this.purpose,overwrite.sequenceNumber===undefined?this.sequenceNumber:overwrite.sequenceNumber,overwrite.snapshotVersion===undefined?this.snapshotVersion:overwrite.snapshotVersion,overwrite.resumeToken===undefined?this.resumeToken:overwrite.resumeToken);};QueryData.prototype.isEqual=function(other){return this.targetId===other.targetId&&this.purpose===other.purpose&&this.sequenceNumber===other.sequenceNumber&&this.snapshotVersion.isEqual(other.snapshotVersion)&&this.resumeToken===other.resumeToken&&this.query.isEqual(other.query);};return QueryData;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */var SortedSet=/** @class */function(){function SortedSet(comparator){this.comparator=comparator;this.data=new SortedMap(this.comparator);}/**
     * Creates a SortedSet from the keys of the map.
     * This is currently implemented as an O(n) copy.
     */SortedSet.fromMapKeys=function(map){var keys=new SortedSet(map.comparator);map.forEach(function(key){keys=keys.add(key);});return keys;};SortedSet.prototype.has=function(elem){return this.data.get(elem)!==null;};SortedSet.prototype.first=function(){return this.data.minKey();};SortedSet.prototype.last=function(){return this.data.maxKey();};Object.defineProperty(SortedSet.prototype,"size",{get:function get(){return this.data.size;},enumerable:true,configurable:true});SortedSet.prototype.indexOf=function(elem){return this.data.indexOf(elem);};/** Iterates elements in order defined by "comparator" */SortedSet.prototype.forEach=function(cb){this.data.inorderTraversal(function(k,v){cb(k);return false;});};/** Iterates over `elem`s such that: range[0] <= elem < range[1]. */SortedSet.prototype.forEachInRange=function(range,cb){var iter=this.data.getIteratorFrom(range[0]);while(iter.hasNext()){var elem=iter.getNext();if(this.comparator(elem.key,range[1])>=0)return;cb(elem.key);}};/**
     * Iterates over `elem`s such that: start <= elem until false is returned.
     */SortedSet.prototype.forEachWhile=function(cb,start){var iter;if(start!==undefined){iter=this.data.getIteratorFrom(start);}else{iter=this.data.getIterator();}while(iter.hasNext()){var elem=iter.getNext();var result=cb(elem.key);if(!result)return;}};/** Finds the least element greater than or equal to `elem`. */SortedSet.prototype.firstAfterOrEqual=function(elem){var iter=this.data.getIteratorFrom(elem);return iter.hasNext()?iter.getNext().key:null;};SortedSet.prototype.getIterator=function(){return new SortedSetIterator(this.data.getIterator());};SortedSet.prototype.getIteratorFrom=function(key){return new SortedSetIterator(this.data.getIteratorFrom(key));};/** Inserts or updates an element */SortedSet.prototype.add=function(elem){return this.copy(this.data.remove(elem).insert(elem,true));};/** Deletes an element */SortedSet.prototype.delete=function(elem){if(!this.has(elem))return this;return this.copy(this.data.remove(elem));};SortedSet.prototype.isEmpty=function(){return this.data.isEmpty();};SortedSet.prototype.unionWith=function(other){var result=this;other.forEach(function(elem){result=result.add(elem);});return result;};SortedSet.prototype.isEqual=function(other){if(!(other instanceof SortedSet))return false;if(this.size!==other.size)return false;var thisIt=this.data.getIterator();var otherIt=other.data.getIterator();while(thisIt.hasNext()){var thisElem=thisIt.getNext().key;var otherElem=otherIt.getNext().key;if(this.comparator(thisElem,otherElem)!==0)return false;}return true;};SortedSet.prototype.toArray=function(){var res=[];this.forEach(function(targetId){res.push(targetId);});return res;};SortedSet.prototype.toString=function(){var result=[];this.forEach(function(elem){return result.push(elem);});return'SortedSet('+result.toString()+')';};SortedSet.prototype.copy=function(data){var result=new SortedSet(this.comparator);result.data=data;return result;};return SortedSet;}();var SortedSetIterator=/** @class */function(){function SortedSetIterator(iter){this.iter=iter;}SortedSetIterator.prototype.getNext=function(){return this.iter.getNext().key;};SortedSetIterator.prototype.hasNext=function(){return this.iter.hasNext();};return SortedSetIterator;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */var FieldMask=/** @class */function(){function FieldMask(fields){this.fields=fields;// TODO(dimond): validation of FieldMask
}FieldMask.fromSet=function(fields){return new FieldMask(fields);};FieldMask.fromArray=function(fields){var fieldsAsSet=new SortedSet(FieldPath.comparator);fields.forEach(function(fieldPath){return fieldsAsSet=fieldsAsSet.add(fieldPath);});return new FieldMask(fieldsAsSet);};/**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */FieldMask.prototype.covers=function(fieldPath){var found=false;this.fields.forEach(function(fieldMaskPath){if(fieldMaskPath.isPrefixOf(fieldPath)){found=true;}});return found;};/**
     * Applies this field mask to the provided object value and returns an object
     * that only contains fields that are specified in both the input object and
     * this field mask.
     */FieldMask.prototype.applyTo=function(data){var filteredObject=ObjectValue.EMPTY;this.fields.forEach(function(fieldMaskPath){if(fieldMaskPath.isEmpty()){return data;}else{var newValue=data.field(fieldMaskPath);if(newValue!==undefined){filteredObject=filteredObject.set(fieldMaskPath,newValue);}}});return filteredObject;};FieldMask.prototype.isEqual=function(other){return this.fields.isEqual(other.fields);};return FieldMask;}();/** A field path and the TransformOperation to perform upon it. */var FieldTransform=/** @class */function(){function FieldTransform(field,transform){this.field=field;this.transform=transform;}Object.defineProperty(FieldTransform.prototype,"isIdempotent",{/** Whether this field transform is idempotent. */get:function get(){return this.transform.isIdempotent;},enumerable:true,configurable:true});FieldTransform.prototype.isEqual=function(other){return this.field.isEqual(other.field)&&this.transform.isEqual(other.transform);};return FieldTransform;}();/** The result of successfully applying a mutation to the backend. */var MutationResult=/** @class */function(){function MutationResult(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */version,/**
     * The resulting fields returned from the backend after a
     * TransformMutation has been committed. Contains one FieldValue for each
     * FieldTransform that was in the mutation.
     *
     * Will be null if the mutation was not a TransformMutation.
     */transformResults){this.version=version;this.transformResults=transformResults;}return MutationResult;}();var MutationType;(function(MutationType){MutationType[MutationType["Set"]=0]="Set";MutationType[MutationType["Patch"]=1]="Patch";MutationType[MutationType["Transform"]=2]="Transform";MutationType[MutationType["Delete"]=3]="Delete";})(MutationType||(MutationType={}));/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */var Precondition=/** @class */function(){function Precondition(updateTime,exists){this.updateTime=updateTime;this.exists=exists;assert(updateTime===undefined||exists===undefined,'Precondition can specify "exists" or "updateTime" but not both');}/** Creates a new Precondition with an exists flag. */Precondition.exists=function(exists){return new Precondition(undefined,exists);};/** Creates a new Precondition based on a version a document exists at. */Precondition.updateTime=function(version){return new Precondition(version);};Object.defineProperty(Precondition.prototype,"isNone",{/** Returns whether this Precondition is empty. */get:function get(){return this.updateTime===undefined&&this.exists===undefined;},enumerable:true,configurable:true});/**
     * Returns true if the preconditions is valid for the given document
     * (or null if no document is available).
     */Precondition.prototype.isValidFor=function(maybeDoc){if(this.updateTime!==undefined){return maybeDoc instanceof Document&&maybeDoc.version.isEqual(this.updateTime);}else if(this.exists!==undefined){return this.exists===maybeDoc instanceof Document;}else{assert(this.isNone,'Precondition should be empty');return true;}};Precondition.prototype.isEqual=function(other){return equals(this.updateTime,other.updateTime)&&this.exists===other.exists;};Precondition.NONE=new Precondition();return Precondition;}();/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also it version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set, Patch, and Transform mutations. For Delete
 * mutations, we reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        null                  Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      null                  null
 * TransformMutation  Document(v3)          Document(v3)
 * TransformMutation  NoDocument(v3)        NoDocument(v3)
 * TransformMutation  null                  null
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     null                  NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set, Patch, and Transform mutations. As deletes
 * have no explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we return an `UnknownDocument` and rely on Watch to send us the
 * updated version.
 *
 * Note that TransformMutations don't create Documents (in the case of being
 * applied to a NoDocument), even though they would on the backend. This is
 * because the client always combines the TransformMutation with a SetMutation
 * or PatchMutation and we only want to apply the transform if the prior
 * mutation resulted in a Document (always true for a SetMutation, but not
 * necessarily for a PatchMutation).
 *
 * ## Subclassing Notes
 *
 * Subclasses of Mutation need to implement applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document.
 */var Mutation=/** @class */function(){function Mutation(){}Mutation.prototype.verifyKeyMatches=function(maybeDoc){if(maybeDoc!=null){assert(maybeDoc.key.isEqual(this.key),'Can only apply a mutation to a document with the same key');}};/**
     * Returns the version from the given document for use as the result of a
     * mutation. Mutations are defined to return the version of the base document
     * only if it is an existing document. Deleted and unknown documents have a
     * post-mutation version of SnapshotVersion.MIN.
     */Mutation.getPostMutationVersion=function(maybeDoc){if(maybeDoc instanceof Document){return maybeDoc.version;}else{return SnapshotVersion.MIN;}};return Mutation;}();/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */var SetMutation=/** @class */function(_super){tslib_1.__extends(SetMutation,_super);function SetMutation(key,value,precondition){var _this=_super.call(this)||this;_this.key=key;_this.value=value;_this.precondition=precondition;_this.type=MutationType.Set;return _this;}SetMutation.prototype.applyToRemoteDocument=function(maybeDoc,mutationResult){this.verifyKeyMatches(maybeDoc);assert(mutationResult.transformResults==null,'Transform results received by SetMutation.');// Unlike applyToLocalView, if we're applying a mutation to a remote
// document the server has accepted the mutation so the precondition must
// have held.
var version=mutationResult.version;return new Document(this.key,version,this.value,{hasCommittedMutations:true});};SetMutation.prototype.applyToLocalView=function(maybeDoc,baseDoc,localWriteTime){this.verifyKeyMatches(maybeDoc);if(!this.precondition.isValidFor(maybeDoc)){return maybeDoc;}var version=Mutation.getPostMutationVersion(maybeDoc);return new Document(this.key,version,this.value,{hasLocalMutations:true});};Object.defineProperty(SetMutation.prototype,"isIdempotent",{get:function get(){return true;},enumerable:true,configurable:true});Object.defineProperty(SetMutation.prototype,"fieldMask",{get:function get(){return null;},enumerable:true,configurable:true});SetMutation.prototype.isEqual=function(other){return other instanceof SetMutation&&this.key.isEqual(other.key)&&this.value.isEqual(other.value)&&this.precondition.isEqual(other.precondition);};return SetMutation;}(Mutation);/**
 * A mutation that modifies fields of the document at the given key with the
 * given values. The values are applied through a field mask:
 *
 *  * When a field is in both the mask and the values, the corresponding field
 *    is updated.
 *  * When a field is in neither the mask nor the values, the corresponding
 *    field is unmodified.
 *  * When a field is in the mask but not in the values, the corresponding field
 *    is deleted.
 *  * When a field is not in the mask but is in the values, the values map is
 *    ignored.
 */var PatchMutation=/** @class */function(_super){tslib_1.__extends(PatchMutation,_super);function PatchMutation(key,data,fieldMask,precondition){var _this=_super.call(this)||this;_this.key=key;_this.data=data;_this.fieldMask=fieldMask;_this.precondition=precondition;_this.type=MutationType.Patch;return _this;}PatchMutation.prototype.applyToRemoteDocument=function(maybeDoc,mutationResult){this.verifyKeyMatches(maybeDoc);assert(mutationResult.transformResults==null,'Transform results received by PatchMutation.');if(!this.precondition.isValidFor(maybeDoc)){// Since the mutation was not rejected, we know that the  precondition
// matched on the backend. We therefore must not have the expected version
// of the document in our cache and return an UnknownDocument with the
// known updateTime.
return new UnknownDocument(this.key,mutationResult.version);}var newData=this.patchDocument(maybeDoc);return new Document(this.key,mutationResult.version,newData,{hasCommittedMutations:true});};PatchMutation.prototype.applyToLocalView=function(maybeDoc,baseDoc,localWriteTime){this.verifyKeyMatches(maybeDoc);if(!this.precondition.isValidFor(maybeDoc)){return maybeDoc;}var version=Mutation.getPostMutationVersion(maybeDoc);var newData=this.patchDocument(maybeDoc);return new Document(this.key,version,newData,{hasLocalMutations:true});};Object.defineProperty(PatchMutation.prototype,"isIdempotent",{get:function get(){return true;},enumerable:true,configurable:true});PatchMutation.prototype.isEqual=function(other){return other instanceof PatchMutation&&this.key.isEqual(other.key)&&this.fieldMask.isEqual(other.fieldMask)&&this.precondition.isEqual(other.precondition);};/**
     * Patches the data of document if available or creates a new document. Note
     * that this does not check whether or not the precondition of this patch
     * holds.
     */PatchMutation.prototype.patchDocument=function(maybeDoc){var data;if(maybeDoc instanceof Document){data=maybeDoc.data;}else{data=ObjectValue.EMPTY;}return this.patchObject(data);};PatchMutation.prototype.patchObject=function(data){var _this=this;this.fieldMask.fields.forEach(function(fieldPath){if(!fieldPath.isEmpty()){var newValue=_this.data.field(fieldPath);if(newValue!==undefined){data=data.set(fieldPath,newValue);}else{data=data.delete(fieldPath);}}});return data;};return PatchMutation;}(Mutation);/**
 * A mutation that modifies specific fields of the document with transform
 * operations. Currently the only supported transform is a server timestamp, but
 * IP Address, increment(n), etc. could be supported in the future.
 *
 * It is somewhat similar to a PatchMutation in that it patches specific fields
 * and has no effect when applied to a null or NoDocument (see comment on
 * Mutation for rationale).
 */var TransformMutation=/** @class */function(_super){tslib_1.__extends(TransformMutation,_super);function TransformMutation(key,fieldTransforms){var _this=_super.call(this)||this;_this.key=key;_this.fieldTransforms=fieldTransforms;_this.type=MutationType.Transform;// NOTE: We set a precondition of exists: true as a safety-check, since we
// always combine TransformMutations with a SetMutation or PatchMutation which
// (if successful) should end up with an existing document.
_this.precondition=Precondition.exists(true);return _this;}TransformMutation.prototype.applyToRemoteDocument=function(maybeDoc,mutationResult){this.verifyKeyMatches(maybeDoc);assert(mutationResult.transformResults!=null,'Transform results missing for TransformMutation.');if(!this.precondition.isValidFor(maybeDoc)){// Since the mutation was not rejected, we know that the  precondition
// matched on the backend. We therefore must not have the expected version
// of the document in our cache and return an UnknownDocument with the
// known updateTime.
return new UnknownDocument(this.key,mutationResult.version);}var doc=this.requireDocument(maybeDoc);var transformResults=this.serverTransformResults(maybeDoc,mutationResult.transformResults);var version=mutationResult.version;var newData=this.transformObject(doc.data,transformResults);return new Document(this.key,version,newData,{hasCommittedMutations:true});};TransformMutation.prototype.applyToLocalView=function(maybeDoc,baseDoc,localWriteTime){this.verifyKeyMatches(maybeDoc);if(!this.precondition.isValidFor(maybeDoc)){return maybeDoc;}var doc=this.requireDocument(maybeDoc);var transformResults=this.localTransformResults(localWriteTime,baseDoc);var newData=this.transformObject(doc.data,transformResults);return new Document(this.key,doc.version,newData,{hasLocalMutations:true});};Object.defineProperty(TransformMutation.prototype,"isIdempotent",{get:function get(){for(var _i=0,_a=this.fieldTransforms;_i<_a.length;_i++){var fieldTransform=_a[_i];if(!fieldTransform.isIdempotent){return false;}}return true;},enumerable:true,configurable:true});Object.defineProperty(TransformMutation.prototype,"fieldMask",{get:function get(){var fieldMask=new SortedSet(FieldPath.comparator);this.fieldTransforms.forEach(function(transform){return fieldMask=fieldMask.add(transform.field);});return new FieldMask(fieldMask);},enumerable:true,configurable:true});TransformMutation.prototype.isEqual=function(other){return other instanceof TransformMutation&&this.key.isEqual(other.key)&&arrayEquals(this.fieldTransforms,other.fieldTransforms)&&this.precondition.isEqual(other.precondition);};/**
     * Asserts that the given MaybeDocument is actually a Document and verifies
     * that it matches the key for this mutation. Since we only support
     * transformations with precondition exists this method is guaranteed to be
     * safe.
     */TransformMutation.prototype.requireDocument=function(maybeDoc){assert(maybeDoc instanceof Document,'Unknown MaybeDocument type '+maybeDoc);var doc=maybeDoc;assert(doc.key.isEqual(this.key),'Can only transform a document with the same key');return doc;};/**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use after a
     * TransformMutation has been acknowledged by the server.
     *
     * @param baseDoc The document prior to applying this mutation batch.
     * @param serverTransformResults The transform results received by the server.
     * @return The transform results list.
     */TransformMutation.prototype.serverTransformResults=function(baseDoc,serverTransformResults){var transformResults=[];assert(this.fieldTransforms.length===serverTransformResults.length,"server transform result count ("+serverTransformResults.length+") "+("should match field transform count ("+this.fieldTransforms.length+")"));for(var i=0;i<serverTransformResults.length;i++){var fieldTransform=this.fieldTransforms[i];var transform=fieldTransform.transform;var previousValue=null;if(baseDoc instanceof Document){previousValue=baseDoc.field(fieldTransform.field)||null;}transformResults.push(transform.applyToRemoteDocument(previousValue,serverTransformResults[i]));}return transformResults;};/**
     * Creates a list of "transform results" (a transform result is a field value
     * representing the result of applying a transform) for use when applying a
     * TransformMutation locally.
     *
     * @param localWriteTime The local time of the transform mutation (used to
     *     generate ServerTimestampValues).
     * @param baseDoc The document prior to applying this mutation batch.
     * @return The transform results list.
     */TransformMutation.prototype.localTransformResults=function(localWriteTime,baseDoc){var transformResults=[];for(var _i=0,_a=this.fieldTransforms;_i<_a.length;_i++){var fieldTransform=_a[_i];var transform=fieldTransform.transform;var previousValue=null;if(baseDoc instanceof Document){previousValue=baseDoc.field(fieldTransform.field)||null;}transformResults.push(transform.applyToLocalView(previousValue,localWriteTime));}return transformResults;};TransformMutation.prototype.transformObject=function(data,transformResults){assert(transformResults.length===this.fieldTransforms.length,'TransformResults length mismatch.');for(var i=0;i<this.fieldTransforms.length;i++){var fieldTransform=this.fieldTransforms[i];var fieldPath=fieldTransform.field;data=data.set(fieldPath,transformResults[i]);}return data;};return TransformMutation;}(Mutation);/** A mutation that deletes the document at the given key. */var DeleteMutation=/** @class */function(_super){tslib_1.__extends(DeleteMutation,_super);function DeleteMutation(key,precondition){var _this=_super.call(this)||this;_this.key=key;_this.precondition=precondition;_this.type=MutationType.Delete;return _this;}DeleteMutation.prototype.applyToRemoteDocument=function(maybeDoc,mutationResult){this.verifyKeyMatches(maybeDoc);assert(mutationResult.transformResults==null,'Transform results received by DeleteMutation.');// Unlike applyToLocalView, if we're applying a mutation to a remote
// document the server has accepted the mutation so the precondition must
// have held.
return new NoDocument(this.key,mutationResult.version,{hasCommittedMutations:true});};DeleteMutation.prototype.applyToLocalView=function(maybeDoc,baseDoc,localWriteTime){this.verifyKeyMatches(maybeDoc);if(!this.precondition.isValidFor(maybeDoc)){return maybeDoc;}if(maybeDoc){assert(maybeDoc.key.isEqual(this.key),'Can only apply mutation to document with same key');}return new NoDocument(this.key,SnapshotVersion.forDeletedDoc());};DeleteMutation.prototype.isEqual=function(other){return other instanceof DeleteMutation&&this.key.isEqual(other.key)&&this.precondition.isEqual(other.precondition);};Object.defineProperty(DeleteMutation.prototype,"isIdempotent",{get:function get(){return true;},enumerable:true,configurable:true});Object.defineProperty(DeleteMutation.prototype,"fieldMask",{get:function get(){return null;},enumerable:true,configurable:true});return DeleteMutation;}(Mutation);/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//** Transforms a value into a server-generated timestamp. */var ServerTimestampTransform=/** @class */function(){function ServerTimestampTransform(){this.isIdempotent=true;}ServerTimestampTransform.prototype.applyToLocalView=function(previousValue,localWriteTime){return new ServerTimestampValue(localWriteTime,previousValue);};ServerTimestampTransform.prototype.applyToRemoteDocument=function(previousValue,transformResult){return transformResult;};ServerTimestampTransform.prototype.isEqual=function(other){return other instanceof ServerTimestampTransform;};ServerTimestampTransform.instance=new ServerTimestampTransform();return ServerTimestampTransform;}();/** Transforms an array value via a union operation. */var ArrayUnionTransformOperation=/** @class */function(){function ArrayUnionTransformOperation(elements){this.elements=elements;this.isIdempotent=true;}ArrayUnionTransformOperation.prototype.applyToLocalView=function(previousValue,localWriteTime){return this.apply(previousValue);};ArrayUnionTransformOperation.prototype.applyToRemoteDocument=function(previousValue,transformResult){// The server just sends null as the transform result for array operations,
// so we have to calculate a result the same as we do for local
// applications.
return this.apply(previousValue);};ArrayUnionTransformOperation.prototype.apply=function(previousValue){var result=coercedFieldValuesArray(previousValue);var _loop_1=function _loop_1(toUnion){if(!result.find(function(element){return element.isEqual(toUnion);})){result.push(toUnion);}};for(var _i=0,_a=this.elements;_i<_a.length;_i++){var toUnion=_a[_i];_loop_1(toUnion);}return new ArrayValue(result);};ArrayUnionTransformOperation.prototype.isEqual=function(other){return other instanceof ArrayUnionTransformOperation&&arrayEquals(other.elements,this.elements);};return ArrayUnionTransformOperation;}();/** Transforms an array value via a remove operation. */var ArrayRemoveTransformOperation=/** @class */function(){function ArrayRemoveTransformOperation(elements){this.elements=elements;this.isIdempotent=true;}ArrayRemoveTransformOperation.prototype.applyToLocalView=function(previousValue,localWriteTime){return this.apply(previousValue);};ArrayRemoveTransformOperation.prototype.applyToRemoteDocument=function(previousValue,transformResult){// The server just sends null as the transform result for array operations,
// so we have to calculate a result the same as we do for local
// applications.
return this.apply(previousValue);};ArrayRemoveTransformOperation.prototype.apply=function(previousValue){var result=coercedFieldValuesArray(previousValue);var _loop_2=function _loop_2(toRemove){result=result.filter(function(element){return!element.isEqual(toRemove);});};for(var _i=0,_a=this.elements;_i<_a.length;_i++){var toRemove=_a[_i];_loop_2(toRemove);}return new ArrayValue(result);};ArrayRemoveTransformOperation.prototype.isEqual=function(other){return other instanceof ArrayRemoveTransformOperation&&arrayEquals(other.elements,this.elements);};return ArrayRemoveTransformOperation;}();/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */var NumericIncrementTransformOperation=/** @class */function(){function NumericIncrementTransformOperation(operand){this.operand=operand;this.isIdempotent=false;}NumericIncrementTransformOperation.prototype.applyToLocalView=function(previousValue,localWriteTime){// PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
// precision and resolves overflows by reducing precision, we do not
// manually cap overflows at 2^63.
// Return an integer value iff the previous value and the operand is an
// integer.
if(previousValue instanceof IntegerValue&&this.operand instanceof IntegerValue){var sum=previousValue.internalValue+this.operand.internalValue;return new IntegerValue(sum);}else if(previousValue instanceof NumberValue){var sum=previousValue.internalValue+this.operand.internalValue;return new DoubleValue(sum);}else{// If the existing value is not a number, use the value of the transform as
// the new base value.
return this.operand;}};NumericIncrementTransformOperation.prototype.applyToRemoteDocument=function(previousValue,transformResult){assert(transformResult!==null,"Didn't receive transformResult for NUMERIC_ADD transform");return transformResult;};NumericIncrementTransformOperation.prototype.isEqual=function(other){return other instanceof NumericIncrementTransformOperation&&this.operand.isEqual(other.operand);};return NumericIncrementTransformOperation;}();function coercedFieldValuesArray(value){if(value instanceof ArrayValue){return value.internalValue.slice();}else{// coerce to empty array.
return[];}}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var ExistenceFilter=/** @class */function(){// TODO(b/33078163): just use simplest form of existence filter for now
function ExistenceFilter(count){this.count=count;}ExistenceFilter.prototype.isEqual=function(other){return other&&other.count===this.count;};return ExistenceFilter;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers.
 */var RpcCode;(function(RpcCode){RpcCode[RpcCode["OK"]=0]="OK";RpcCode[RpcCode["CANCELLED"]=1]="CANCELLED";RpcCode[RpcCode["UNKNOWN"]=2]="UNKNOWN";RpcCode[RpcCode["INVALID_ARGUMENT"]=3]="INVALID_ARGUMENT";RpcCode[RpcCode["DEADLINE_EXCEEDED"]=4]="DEADLINE_EXCEEDED";RpcCode[RpcCode["NOT_FOUND"]=5]="NOT_FOUND";RpcCode[RpcCode["ALREADY_EXISTS"]=6]="ALREADY_EXISTS";RpcCode[RpcCode["PERMISSION_DENIED"]=7]="PERMISSION_DENIED";RpcCode[RpcCode["UNAUTHENTICATED"]=16]="UNAUTHENTICATED";RpcCode[RpcCode["RESOURCE_EXHAUSTED"]=8]="RESOURCE_EXHAUSTED";RpcCode[RpcCode["FAILED_PRECONDITION"]=9]="FAILED_PRECONDITION";RpcCode[RpcCode["ABORTED"]=10]="ABORTED";RpcCode[RpcCode["OUT_OF_RANGE"]=11]="OUT_OF_RANGE";RpcCode[RpcCode["UNIMPLEMENTED"]=12]="UNIMPLEMENTED";RpcCode[RpcCode["INTERNAL"]=13]="INTERNAL";RpcCode[RpcCode["UNAVAILABLE"]=14]="UNAVAILABLE";RpcCode[RpcCode["DATA_LOSS"]=15]="DATA_LOSS";})(RpcCode||(RpcCode={}));/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */function isPermanentError(code){switch(code){case Code.OK:return fail('Treated status OK as error');case Code.CANCELLED:case Code.UNKNOWN:case Code.DEADLINE_EXCEEDED:case Code.RESOURCE_EXHAUSTED:case Code.INTERNAL:case Code.UNAVAILABLE:// Unauthenticated means something went wrong with our token and we need
// to retry with new credentials which will happen automatically.
case Code.UNAUTHENTICATED:return false;case Code.INVALID_ARGUMENT:case Code.NOT_FOUND:case Code.ALREADY_EXISTS:case Code.PERMISSION_DENIED:case Code.FAILED_PRECONDITION:// Aborted might be retried in some scenarios, but that is dependant on
// the context and should handled individually by the calling code.
// See https://cloud.google.com/apis/design/errors.
case Code.ABORTED:case Code.OUT_OF_RANGE:case Code.UNIMPLEMENTED:case Code.DATA_LOSS:return true;default:return fail('Unknown status code: '+code);}}/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */function isPermanentWriteError(code){return isPermanentError(code)&&code!==Code.ABORTED;}/**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */function mapCodeFromRpcStatus(status){// tslint:disable-next-line:no-any lookup by string
var code=RpcCode[status];if(code===undefined){return undefined;}return mapCodeFromRpcCode(code);}/**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */function mapCodeFromRpcCode(code){if(code===undefined){// This shouldn't normally happen, but in certain error cases (like trying
// to send invalid proto messages) we may get an error with no GRPC code.
error('GRPC error has no .code');return Code.UNKNOWN;}switch(code){case RpcCode.OK:return Code.OK;case RpcCode.CANCELLED:return Code.CANCELLED;case RpcCode.UNKNOWN:return Code.UNKNOWN;case RpcCode.DEADLINE_EXCEEDED:return Code.DEADLINE_EXCEEDED;case RpcCode.RESOURCE_EXHAUSTED:return Code.RESOURCE_EXHAUSTED;case RpcCode.INTERNAL:return Code.INTERNAL;case RpcCode.UNAVAILABLE:return Code.UNAVAILABLE;case RpcCode.UNAUTHENTICATED:return Code.UNAUTHENTICATED;case RpcCode.INVALID_ARGUMENT:return Code.INVALID_ARGUMENT;case RpcCode.NOT_FOUND:return Code.NOT_FOUND;case RpcCode.ALREADY_EXISTS:return Code.ALREADY_EXISTS;case RpcCode.PERMISSION_DENIED:return Code.PERMISSION_DENIED;case RpcCode.FAILED_PRECONDITION:return Code.FAILED_PRECONDITION;case RpcCode.ABORTED:return Code.ABORTED;case RpcCode.OUT_OF_RANGE:return Code.OUT_OF_RANGE;case RpcCode.UNIMPLEMENTED:return Code.UNIMPLEMENTED;case RpcCode.DATA_LOSS:return Code.DATA_LOSS;default:return fail('Unknown status code: '+code);}}/**
 * Maps an RPC code from a Code. This is the reverse operation from
 * mapCodeFromRpcCode and should really only be used in tests.
 */function mapRpcCodeFromCode(code){if(code===undefined){return RpcCode.OK;}switch(code){case Code.OK:return RpcCode.OK;case Code.CANCELLED:return RpcCode.CANCELLED;case Code.UNKNOWN:return RpcCode.UNKNOWN;case Code.DEADLINE_EXCEEDED:return RpcCode.DEADLINE_EXCEEDED;case Code.RESOURCE_EXHAUSTED:return RpcCode.RESOURCE_EXHAUSTED;case Code.INTERNAL:return RpcCode.INTERNAL;case Code.UNAVAILABLE:return RpcCode.UNAVAILABLE;case Code.UNAUTHENTICATED:return RpcCode.UNAUTHENTICATED;case Code.INVALID_ARGUMENT:return RpcCode.INVALID_ARGUMENT;case Code.NOT_FOUND:return RpcCode.NOT_FOUND;case Code.ALREADY_EXISTS:return RpcCode.ALREADY_EXISTS;case Code.PERMISSION_DENIED:return RpcCode.PERMISSION_DENIED;case Code.FAILED_PRECONDITION:return RpcCode.FAILED_PRECONDITION;case Code.ABORTED:return RpcCode.ABORTED;case Code.OUT_OF_RANGE:return RpcCode.OUT_OF_RANGE;case Code.UNIMPLEMENTED:return RpcCode.UNIMPLEMENTED;case Code.DATA_LOSS:return RpcCode.DATA_LOSS;default:return fail('Unknown status code: '+code);}}/**
 * Converts an HTTP Status Code to the equivalent error code.
 *
 * @param status An HTTP Status Code, like 200, 404, 503, etc.
 * @returns The equivalent Code. Unknown status codes are mapped to
 *     Code.UNKNOWN.
 */function mapCodeFromHttpStatus(status){// The canonical error codes for Google APIs [1] specify mapping onto HTTP
// status codes but the mapping is not bijective. In each case of ambiguity
// this function chooses a primary error.
//
// [1]
// https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
switch(status){case 200:// OK
return Code.OK;case 400:// Bad Request
return Code.INVALID_ARGUMENT;// Other possibilities based on the forward mapping
// return Code.FAILED_PRECONDITION;
// return Code.OUT_OF_RANGE;
case 401:// Unauthorized
return Code.UNAUTHENTICATED;case 403:// Forbidden
return Code.PERMISSION_DENIED;case 404:// Not Found
return Code.NOT_FOUND;case 409:// Conflict
return Code.ABORTED;// Other possibilities:
// return Code.ALREADY_EXISTS;
case 416:// Range Not Satisfiable
return Code.OUT_OF_RANGE;case 429:// Too Many Requests
return Code.RESOURCE_EXHAUSTED;case 499:// Client Closed Request
return Code.CANCELLED;case 500:// Internal Server Error
return Code.UNKNOWN;// Other possibilities:
// return Code.INTERNAL;
// return Code.DATA_LOSS;
case 501:// Unimplemented
return Code.UNIMPLEMENTED;case 503:// Service Unavailable
return Code.UNAVAILABLE;case 504:// Gateway Timeout
return Code.DEADLINE_EXCEEDED;default:if(status>=200&&status<300)return Code.OK;if(status>=400&&status<500)return Code.FAILED_PRECONDITION;if(status>=500&&status<600)return Code.INTERNAL;return Code.UNKNOWN;}}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var EMPTY_MAYBE_DOCUMENT_MAP=new SortedMap(DocumentKey.comparator);function maybeDocumentMap(){return EMPTY_MAYBE_DOCUMENT_MAP;}function nullableMaybeDocumentMap(){return maybeDocumentMap();}var EMPTY_DOCUMENT_MAP=new SortedMap(DocumentKey.comparator);function documentMap(){return EMPTY_DOCUMENT_MAP;}var EMPTY_DOCUMENT_VERSION_MAP=new SortedMap(DocumentKey.comparator);function documentVersionMap(){return EMPTY_DOCUMENT_VERSION_MAP;}var EMPTY_DOCUMENT_KEY_SET=new SortedSet(DocumentKey.comparator);function documentKeySet(){var keys=[];for(var _i=0;_i<arguments.length;_i++){keys[_i]=arguments[_i];}var set=EMPTY_DOCUMENT_KEY_SET;for(var _a=0,keys_1=keys;_a<keys_1.length;_a++){var key=keys_1[_a];set=set.add(key);}return set;}var EMPTY_TARGET_ID_SET=new SortedSet(primitiveComparator);function targetIdSet(){return EMPTY_TARGET_ID_SET;}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */var DocumentSet=/** @class */function(){/** The default ordering is by key if the comparator is omitted */function DocumentSet(comp){// We are adding document key comparator to the end as it's the only
// guaranteed unique property of a document.
if(comp){this.comparator=function(d1,d2){return comp(d1,d2)||DocumentKey.comparator(d1.key,d2.key);};}else{this.comparator=function(d1,d2){return DocumentKey.comparator(d1.key,d2.key);};}this.keyedMap=documentMap();this.sortedSet=new SortedMap(this.comparator);}/**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */DocumentSet.emptySet=function(oldSet){return new DocumentSet(oldSet.comparator);};DocumentSet.prototype.has=function(key){return this.keyedMap.get(key)!=null;};DocumentSet.prototype.get=function(key){return this.keyedMap.get(key);};DocumentSet.prototype.first=function(){return this.sortedSet.minKey();};DocumentSet.prototype.last=function(){return this.sortedSet.maxKey();};DocumentSet.prototype.isEmpty=function(){return this.sortedSet.isEmpty();};/**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */DocumentSet.prototype.indexOf=function(key){var doc=this.keyedMap.get(key);return doc?this.sortedSet.indexOf(doc):-1;};Object.defineProperty(DocumentSet.prototype,"size",{get:function get(){return this.sortedSet.size;},enumerable:true,configurable:true});/** Iterates documents in order defined by "comparator" */DocumentSet.prototype.forEach=function(cb){this.sortedSet.inorderTraversal(function(k,v){cb(k);return false;});};/** Inserts or updates a document with the same key */DocumentSet.prototype.add=function(doc){// First remove the element if we have it.
var set=this.delete(doc.key);return set.copy(set.keyedMap.insert(doc.key,doc),set.sortedSet.insert(doc,null));};/** Deletes a document with a given key */DocumentSet.prototype.delete=function(key){var doc=this.get(key);if(!doc){return this;}return this.copy(this.keyedMap.remove(key),this.sortedSet.remove(doc));};DocumentSet.prototype.isEqual=function(other){if(!(other instanceof DocumentSet))return false;if(this.size!==other.size)return false;var thisIt=this.sortedSet.getIterator();var otherIt=other.sortedSet.getIterator();while(thisIt.hasNext()){var thisDoc=thisIt.getNext().key;var otherDoc=otherIt.getNext().key;if(!thisDoc.isEqual(otherDoc))return false;}return true;};DocumentSet.prototype.toString=function(){var docStrings=[];this.forEach(function(doc){docStrings.push(doc.toString());});if(docStrings.length===0){return'DocumentSet ()';}else{return'DocumentSet (\n  '+docStrings.join('  \n')+'\n)';}};DocumentSet.prototype.copy=function(keyedMap,sortedSet){var newSet=new DocumentSet();newSet.comparator=this.comparator;newSet.keyedMap=keyedMap;newSet.sortedSet=sortedSet;return newSet;};return DocumentSet;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var ChangeType;(function(ChangeType){ChangeType[ChangeType["Added"]=0]="Added";ChangeType[ChangeType["Removed"]=1]="Removed";ChangeType[ChangeType["Modified"]=2]="Modified";ChangeType[ChangeType["Metadata"]=3]="Metadata";})(ChangeType||(ChangeType={}));var SyncState;(function(SyncState){SyncState[SyncState["Local"]=0]="Local";SyncState[SyncState["Synced"]=1]="Synced";})(SyncState||(SyncState={}));/**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */var DocumentChangeSet=/** @class */function(){function DocumentChangeSet(){this.changeMap=new SortedMap(DocumentKey.comparator);}DocumentChangeSet.prototype.track=function(change){var key=change.doc.key;var oldChange=this.changeMap.get(key);if(!oldChange){this.changeMap=this.changeMap.insert(key,change);return;}// Merge the new change with the existing change.
if(change.type!==ChangeType.Added&&oldChange.type===ChangeType.Metadata){this.changeMap=this.changeMap.insert(key,change);}else if(change.type===ChangeType.Metadata&&oldChange.type!==ChangeType.Removed){this.changeMap=this.changeMap.insert(key,{type:oldChange.type,doc:change.doc});}else if(change.type===ChangeType.Modified&&oldChange.type===ChangeType.Modified){this.changeMap=this.changeMap.insert(key,{type:ChangeType.Modified,doc:change.doc});}else if(change.type===ChangeType.Modified&&oldChange.type===ChangeType.Added){this.changeMap=this.changeMap.insert(key,{type:ChangeType.Added,doc:change.doc});}else if(change.type===ChangeType.Removed&&oldChange.type===ChangeType.Added){this.changeMap=this.changeMap.remove(key);}else if(change.type===ChangeType.Removed&&oldChange.type===ChangeType.Modified){this.changeMap=this.changeMap.insert(key,{type:ChangeType.Removed,doc:oldChange.doc});}else if(change.type===ChangeType.Added&&oldChange.type===ChangeType.Removed){this.changeMap=this.changeMap.insert(key,{type:ChangeType.Modified,doc:change.doc});}else{// This includes these cases, which don't make sense:
// Added->Added
// Removed->Removed
// Modified->Added
// Removed->Modified
// Metadata->Added
// Removed->Metadata
fail('unsupported combination of changes: '+JSON.stringify(change)+' after '+JSON.stringify(oldChange));}};DocumentChangeSet.prototype.getChanges=function(){var changes=[];this.changeMap.inorderTraversal(function(key,change){changes.push(change);});return changes;};return DocumentChangeSet;}();var ViewSnapshot=/** @class */function(){function ViewSnapshot(query,docs,oldDocs,docChanges,mutatedKeys,fromCache,syncStateChanged,excludesMetadataChanges){this.query=query;this.docs=docs;this.oldDocs=oldDocs;this.docChanges=docChanges;this.mutatedKeys=mutatedKeys;this.fromCache=fromCache;this.syncStateChanged=syncStateChanged;this.excludesMetadataChanges=excludesMetadataChanges;}/** Returns a view snapshot as if all documents in the snapshot were added. */ViewSnapshot.fromInitialDocuments=function(query,documents,mutatedKeys,fromCache){var changes=[];documents.forEach(function(doc){changes.push({type:ChangeType.Added,doc:doc});});return new ViewSnapshot(query,documents,DocumentSet.emptySet(documents),changes,mutatedKeys,fromCache,true,false);};Object.defineProperty(ViewSnapshot.prototype,"hasPendingWrites",{get:function get(){return!this.mutatedKeys.isEmpty();},enumerable:true,configurable:true});ViewSnapshot.prototype.isEqual=function(other){if(this.fromCache!==other.fromCache||this.syncStateChanged!==other.syncStateChanged||!this.mutatedKeys.isEqual(other.mutatedKeys)||!this.query.isEqual(other.query)||!this.docs.isEqual(other.docs)||!this.oldDocs.isEqual(other.oldDocs)){return false;}var changes=this.docChanges;var otherChanges=other.docChanges;if(changes.length!==otherChanges.length){return false;}for(var i=0;i<changes.length;i++){if(changes[i].type!==otherChanges[i].type||!changes[i].doc.isEqual(otherChanges[i].doc)){return false;}}return true;};return ViewSnapshot;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */var RemoteEvent=/** @class */function(){function RemoteEvent(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */snapshotVersion,/**
     * A map from target to changes to the target. See TargetChange.
     */targetChanges,/**
     * A set of targets that is known to be inconsistent. Listens for these
     * targets should be re-established without resume tokens.
     */targetMismatches,/**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */documentUpdates,/**
     * A set of which document updates are due only to limbo resolution targets.
     */resolvedLimboDocuments){this.snapshotVersion=snapshotVersion;this.targetChanges=targetChanges;this.targetMismatches=targetMismatches;this.documentUpdates=documentUpdates;this.resolvedLimboDocuments=resolvedLimboDocuments;}/**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */// PORTING NOTE: Multi-tab only
RemoteEvent.createSynthesizedRemoteEventForCurrentChange=function(targetId,current){var _a;var targetChanges=(_a={},_a[targetId]=TargetChange.createSynthesizedTargetChangeForCurrentChange(targetId,current),_a);return new RemoteEvent(SnapshotVersion.MIN,targetChanges,targetIdSet(),maybeDocumentMap(),documentKeySet());};return RemoteEvent;}();/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */var TargetChange=/** @class */function(){function TargetChange(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */resumeToken,/**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */current,/**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */addedDocuments,/**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */modifiedDocuments,/**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */removedDocuments){this.resumeToken=resumeToken;this.current=current;this.addedDocuments=addedDocuments;this.modifiedDocuments=modifiedDocuments;this.removedDocuments=removedDocuments;}/**
     * HACK: Views require TargetChanges in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized TargetChanges that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */// PORTING NOTE: Multi-tab only
TargetChange.createSynthesizedTargetChangeForCurrentChange=function(targetId,current){return new TargetChange(emptyByteString(),current,documentKeySet(),documentKeySet(),documentKeySet());};return TargetChange;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */var DocumentWatchChange=/** @class */function(){function DocumentWatchChange(/** The new document applies to all of these targets. */updatedTargetIds,/** The new document is removed from all of these targets. */removedTargetIds,/** The key of the document for this change. */key,/**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */newDoc){this.updatedTargetIds=updatedTargetIds;this.removedTargetIds=removedTargetIds;this.key=key;this.newDoc=newDoc;}return DocumentWatchChange;}();var ExistenceFilterChange=/** @class */function(){function ExistenceFilterChange(targetId,existenceFilter){this.targetId=targetId;this.existenceFilter=existenceFilter;}return ExistenceFilterChange;}();var WatchTargetChangeState;(function(WatchTargetChangeState){WatchTargetChangeState[WatchTargetChangeState["NoChange"]=0]="NoChange";WatchTargetChangeState[WatchTargetChangeState["Added"]=1]="Added";WatchTargetChangeState[WatchTargetChangeState["Removed"]=2]="Removed";WatchTargetChangeState[WatchTargetChangeState["Current"]=3]="Current";WatchTargetChangeState[WatchTargetChangeState["Reset"]=4]="Reset";})(WatchTargetChangeState||(WatchTargetChangeState={}));var WatchTargetChange=/** @class */function(){function WatchTargetChange(/** What kind of change occurred to the watch target. */state,/** The target IDs that were added/removed/set. */targetIds,/**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the query. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */resumeToken,/** An RPC error indicating why the watch failed. */cause){if(resumeToken===void 0){resumeToken=emptyByteString();}if(cause===void 0){cause=null;}this.state=state;this.targetIds=targetIds;this.resumeToken=resumeToken;this.cause=cause;}return WatchTargetChange;}();/** Tracks the internal state of a Watch target. */var TargetState=/** @class */function(){function TargetState(){/**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */this.pendingResponses=0;/**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */this.documentChanges=snapshotChangesMap();/** See public getters for explanations of these fields. */this._resumeToken=emptyByteString();this._current=false;/**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */this._hasPendingChanges=true;}Object.defineProperty(TargetState.prototype,"current",{/**
         * Whether this target has been marked 'current'.
         *
         * 'Current' has special meaning in the RPC protocol: It implies that the
         * Watch backend has sent us all changes up to the point at which the target
         * was added and that the target is consistent with the rest of the watch
         * stream.
         */get:function get(){return this._current;},enumerable:true,configurable:true});Object.defineProperty(TargetState.prototype,"resumeToken",{/** The last resume token sent to us for this target. */get:function get(){return this._resumeToken;},enumerable:true,configurable:true});Object.defineProperty(TargetState.prototype,"isPending",{/** Whether this target has pending target adds or target removes. */get:function get(){return this.pendingResponses!==0;},enumerable:true,configurable:true});Object.defineProperty(TargetState.prototype,"hasPendingChanges",{/** Whether we have modified any state that should trigger a snapshot. */get:function get(){return this._hasPendingChanges;},enumerable:true,configurable:true});/**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */TargetState.prototype.updateResumeToken=function(resumeToken){if(resumeToken.length>0){this._hasPendingChanges=true;this._resumeToken=resumeToken;}};/**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */TargetState.prototype.toTargetChange=function(){var addedDocuments=documentKeySet();var modifiedDocuments=documentKeySet();var removedDocuments=documentKeySet();this.documentChanges.forEach(function(key,changeType){switch(changeType){case ChangeType.Added:addedDocuments=addedDocuments.add(key);break;case ChangeType.Modified:modifiedDocuments=modifiedDocuments.add(key);break;case ChangeType.Removed:removedDocuments=removedDocuments.add(key);break;default:fail('Encountered invalid change type: '+changeType);}});return new TargetChange(this._resumeToken,this._current,addedDocuments,modifiedDocuments,removedDocuments);};/**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */TargetState.prototype.clearPendingChanges=function(){this._hasPendingChanges=false;this.documentChanges=snapshotChangesMap();};TargetState.prototype.addDocumentChange=function(key,changeType){this._hasPendingChanges=true;this.documentChanges=this.documentChanges.insert(key,changeType);};TargetState.prototype.removeDocumentChange=function(key){this._hasPendingChanges=true;this.documentChanges=this.documentChanges.remove(key);};TargetState.prototype.recordPendingTargetRequest=function(){this.pendingResponses+=1;};TargetState.prototype.recordTargetResponse=function(){this.pendingResponses-=1;};TargetState.prototype.markCurrent=function(){this._hasPendingChanges=true;this._current=true;};return TargetState;}();/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */var WatchChangeAggregator=/** @class */function(){function WatchChangeAggregator(metadataProvider){this.metadataProvider=metadataProvider;/** The internal state of all tracked targets. */this.targetStates={};/** Keeps track of the documents to update since the last raised snapshot. */this.pendingDocumentUpdates=maybeDocumentMap();/** A mapping of document keys to their set of target IDs. */this.pendingDocumentTargetMapping=documentTargetMap();/**
         * A list of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */this.pendingTargetResets=new SortedSet(primitiveComparator);}/**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */WatchChangeAggregator.prototype.handleDocumentChange=function(docChange){for(var _i=0,_a=docChange.updatedTargetIds;_i<_a.length;_i++){var targetId=_a[_i];if(docChange.newDoc instanceof Document){this.addDocumentToTarget(targetId,docChange.newDoc);}else if(docChange.newDoc instanceof NoDocument){this.removeDocumentFromTarget(targetId,docChange.key,docChange.newDoc);}}for(var _b=0,_c=docChange.removedTargetIds;_b<_c.length;_b++){var targetId=_c[_b];this.removeDocumentFromTarget(targetId,docChange.key,docChange.newDoc);}};/** Processes and adds the WatchTargetChange to the current set of changes. */WatchChangeAggregator.prototype.handleTargetChange=function(targetChange){var _this=this;this.forEachTarget(targetChange,function(targetId){var targetState=_this.ensureTargetState(targetId);switch(targetChange.state){case WatchTargetChangeState.NoChange:if(_this.isActiveTarget(targetId)){targetState.updateResumeToken(targetChange.resumeToken);}break;case WatchTargetChangeState.Added:// We need to decrement the number of pending acks needed from watch
// for this targetId.
targetState.recordTargetResponse();if(!targetState.isPending){// We have a freshly added target, so we need to reset any state
// that we had previously. This can happen e.g. when remove and add
// back a target for existence filter mismatches.
targetState.clearPendingChanges();}targetState.updateResumeToken(targetChange.resumeToken);break;case WatchTargetChangeState.Removed:// We need to keep track of removed targets to we can post-filter and
// remove any target changes.
// We need to decrement the number of pending acks needed from watch
// for this targetId.
targetState.recordTargetResponse();if(!targetState.isPending){_this.removeTarget(targetId);}assert(!targetChange.cause,'WatchChangeAggregator does not handle errored targets');break;case WatchTargetChangeState.Current:if(_this.isActiveTarget(targetId)){targetState.markCurrent();targetState.updateResumeToken(targetChange.resumeToken);}break;case WatchTargetChangeState.Reset:if(_this.isActiveTarget(targetId)){// Reset the target and synthesizes removes for all existing
// documents. The backend will re-add any documents that still
// match the target before it sends the next global snapshot.
_this.resetTarget(targetId);targetState.updateResumeToken(targetChange.resumeToken);}break;default:fail('Unknown target watch change state: '+targetChange.state);}});};/**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */WatchChangeAggregator.prototype.forEachTarget=function(targetChange,fn){if(targetChange.targetIds.length>0){targetChange.targetIds.forEach(fn);}else{forEachNumber(this.targetStates,fn);}};/**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */WatchChangeAggregator.prototype.handleExistenceFilter=function(watchChange){var targetId=watchChange.targetId;var expectedCount=watchChange.existenceFilter.count;var queryData=this.queryDataForActiveTarget(targetId);if(queryData){var query=queryData.query;if(query.isDocumentQuery()){if(expectedCount===0){// The existence filter told us the document does not exist. We deduce
// that this document does not exist and apply a deleted document to
// our updates. Without applying this deleted document there might be
// another query that will raise this document as part of a snapshot
// until it is resolved, essentially exposing inconsistency between
// queries.
var key=new DocumentKey(query.path);this.removeDocumentFromTarget(targetId,key,new NoDocument(key,SnapshotVersion.forDeletedDoc()));}else{assert(expectedCount===1,'Single document existence filter with count: '+expectedCount);}}else{var currentSize=this.getCurrentDocumentCountForTarget(targetId);if(currentSize!==expectedCount){// Existence filter mismatch: We reset the mapping and raise a new
// snapshot with `isFromCache:true`.
this.resetTarget(targetId);this.pendingTargetResets=this.pendingTargetResets.add(targetId);}}}};/**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */WatchChangeAggregator.prototype.createRemoteEvent=function(snapshotVersion){var _this=this;var targetChanges={};forEachNumber(this.targetStates,function(targetId,targetState){var queryData=_this.queryDataForActiveTarget(targetId);if(queryData){if(targetState.current&&queryData.query.isDocumentQuery()){// Document queries for document that don't exist can produce an empty
// result set. To update our local cache, we synthesize a document
// delete if we have not previously received the document. This
// resolves the limbo state of the document, removing it from
// limboDocumentRefs.
//
// TODO(dimond): Ideally we would have an explicit lookup query
// instead resulting in an explicit delete message and we could
// remove this special logic.
var key=new DocumentKey(queryData.query.path);if(_this.pendingDocumentUpdates.get(key)===null&&!_this.targetContainsDocument(targetId,key)){_this.removeDocumentFromTarget(targetId,key,new NoDocument(key,snapshotVersion));}}if(targetState.hasPendingChanges){targetChanges[targetId]=targetState.toTargetChange();targetState.clearPendingChanges();}}});var resolvedLimboDocuments=documentKeySet();// We extract the set of limbo-only document updates as the GC logic
// special-cases documents that do not appear in the query cache.
//
// TODO(gsoltis): Expand on this comment once GC is available in the JS
// client.
this.pendingDocumentTargetMapping.forEach(function(key,targets){var isOnlyLimboTarget=true;targets.forEachWhile(function(targetId){var queryData=_this.queryDataForActiveTarget(targetId);if(queryData&&queryData.purpose!==QueryPurpose.LimboResolution){isOnlyLimboTarget=false;return false;}return true;});if(isOnlyLimboTarget){resolvedLimboDocuments=resolvedLimboDocuments.add(key);}});var remoteEvent=new RemoteEvent(snapshotVersion,targetChanges,this.pendingTargetResets,this.pendingDocumentUpdates,resolvedLimboDocuments);this.pendingDocumentUpdates=maybeDocumentMap();this.pendingDocumentTargetMapping=documentTargetMap();this.pendingTargetResets=new SortedSet(primitiveComparator);return remoteEvent;};/**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */// Visible for testing.
WatchChangeAggregator.prototype.addDocumentToTarget=function(targetId,document){if(!this.isActiveTarget(targetId)){return;}var changeType=this.targetContainsDocument(targetId,document.key)?ChangeType.Modified:ChangeType.Added;var targetState=this.ensureTargetState(targetId);targetState.addDocumentChange(document.key,changeType);this.pendingDocumentUpdates=this.pendingDocumentUpdates.insert(document.key,document);this.pendingDocumentTargetMapping=this.pendingDocumentTargetMapping.insert(document.key,this.ensureDocumentTargetMapping(document.key).add(targetId));};/**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */// Visible for testing.
WatchChangeAggregator.prototype.removeDocumentFromTarget=function(targetId,key,updatedDocument){if(!this.isActiveTarget(targetId)){return;}var targetState=this.ensureTargetState(targetId);if(this.targetContainsDocument(targetId,key)){targetState.addDocumentChange(key,ChangeType.Removed);}else{// The document may have entered and left the target before we raised a
// snapshot, so we can just ignore the change.
targetState.removeDocumentChange(key);}this.pendingDocumentTargetMapping=this.pendingDocumentTargetMapping.insert(key,this.ensureDocumentTargetMapping(key).delete(targetId));if(updatedDocument){this.pendingDocumentUpdates=this.pendingDocumentUpdates.insert(key,updatedDocument);}};WatchChangeAggregator.prototype.removeTarget=function(targetId){delete this.targetStates[targetId];};/**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */WatchChangeAggregator.prototype.getCurrentDocumentCountForTarget=function(targetId){var targetState=this.ensureTargetState(targetId);var targetChange=targetState.toTargetChange();return this.metadataProvider.getRemoteKeysForTarget(targetId).size+targetChange.addedDocuments.size-targetChange.removedDocuments.size;};/**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */WatchChangeAggregator.prototype.recordPendingTargetRequest=function(targetId){// For each request we get we need to record we need a response for it.
var targetState=this.ensureTargetState(targetId);targetState.recordPendingTargetRequest();};WatchChangeAggregator.prototype.ensureTargetState=function(targetId){if(!this.targetStates[targetId]){this.targetStates[targetId]=new TargetState();}return this.targetStates[targetId];};WatchChangeAggregator.prototype.ensureDocumentTargetMapping=function(key){var targetMapping=this.pendingDocumentTargetMapping.get(key);if(!targetMapping){targetMapping=new SortedSet(primitiveComparator);this.pendingDocumentTargetMapping=this.pendingDocumentTargetMapping.insert(key,targetMapping);}return targetMapping;};/**
     * Verifies that the user is still interested in this target (by calling
     * `getQueryDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */WatchChangeAggregator.prototype.isActiveTarget=function(targetId){return this.queryDataForActiveTarget(targetId)!==null;};/**
     * Returns the QueryData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */WatchChangeAggregator.prototype.queryDataForActiveTarget=function(targetId){var targetState=this.targetStates[targetId];return targetState&&targetState.isPending?null:this.metadataProvider.getQueryDataForTarget(targetId);};/**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */WatchChangeAggregator.prototype.resetTarget=function(targetId){var _this=this;assert(!this.targetStates[targetId].isPending,'Should only reset active targets');this.targetStates[targetId]=new TargetState();// Trigger removal for any documents currently mapped to this target.
// These removals will be part of the initial snapshot if Watch does not
// resend these documents.
var existingKeys=this.metadataProvider.getRemoteKeysForTarget(targetId);existingKeys.forEach(function(key){_this.removeDocumentFromTarget(targetId,key,/*updatedDocument=*/null);});};/**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */WatchChangeAggregator.prototype.targetContainsDocument=function(targetId,key){var existingKeys=this.metadataProvider.getRemoteKeysForTarget(targetId);return existingKeys.has(key);};return WatchChangeAggregator;}();function documentTargetMap(){return new SortedMap(DocumentKey.comparator);}function snapshotChangesMap(){return new SortedMap(DocumentKey.comparator);}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var DIRECTIONS=function(){var dirs={};dirs[Direction.ASCENDING.name]='ASCENDING';dirs[Direction.DESCENDING.name]='DESCENDING';return dirs;}();var OPERATORS=function(){var ops={};ops[RelationOp.LESS_THAN.name]='LESS_THAN';ops[RelationOp.LESS_THAN_OR_EQUAL.name]='LESS_THAN_OR_EQUAL';ops[RelationOp.GREATER_THAN.name]='GREATER_THAN';ops[RelationOp.GREATER_THAN_OR_EQUAL.name]='GREATER_THAN_OR_EQUAL';ops[RelationOp.EQUAL.name]='EQUAL';ops[RelationOp.ARRAY_CONTAINS.name]='ARRAY_CONTAINS';return ops;}();// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
var ISO_REG_EXP=new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);function assertPresent(value,description){assert(!isNullOrUndefined(value),description+' is missing');}function parseInt64(value){// TODO(bjornick): Handle int64 greater than 53 bits.
if(typeof value==='number'){return value;}else if(typeof value==='string'){return Number(value);}else{return fail("can't parse "+value);}}/**
 * Generates JsonObject values for the Datastore API suitable for sending to
 * either GRPC stub methods or via the JSON/HTTP REST API.
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */var JsonProtoSerializer=/** @class */function(){function JsonProtoSerializer(databaseId,options){this.databaseId=databaseId;this.options=options;}JsonProtoSerializer.prototype.emptyByteString=function(){if(this.options.useProto3Json){return'';}else{return new Uint8Array(0);}};JsonProtoSerializer.prototype.unsafeCastProtoByteString=function(byteString){// byteStrings can be either string or UInt8Array, but the typings say
// it's always a string. Cast as string to avoid type check failing
return byteString;};JsonProtoSerializer.prototype.fromRpcStatus=function(status){var code=status.code===undefined?Code.UNKNOWN:mapCodeFromRpcCode(status.code);return new FirestoreError(code,status.message||'');};/**
     * Returns a value for a number (or undefined) that's appropriate to put into
     * a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "number" because that's what
     * our generated proto interfaces say Int32Value must be. But GRPC actually
     * expects a { value: <number> } struct.
     */JsonProtoSerializer.prototype.toInt32Value=function(val){if(!isNullOrUndefined(val)){// tslint:disable-next-line:no-any We need to match generated Proto types.
return{value:val};}else{return undefined;}};/**
     * Returns a number (or null) from a google.protobuf.Int32Value proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as accepting "number" because that's what
     * our generated proto interfaces say Int32Value must be, but it actually
     * accepts { value: number } to match our serialization in toInt32Value().
     */JsonProtoSerializer.prototype.fromInt32Value=function(val){var result;if(typeof val==='object'){// tslint:disable-next-line:no-any We need to match generated Proto types.
result=val.value;}else{// We accept raw numbers (without the {value: ... } wrapper) for
// compatibility with legacy persisted data.
result=val;}return isNullOrUndefined(result)?null:result;};/**
     * Returns a value for a Date that's appropriate to put into a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say dates must be. But it's easier and safer
     * to actually return a Timestamp proto.
     */JsonProtoSerializer.prototype.toTimestamp=function(timestamp){return{seconds:''+timestamp.seconds,nanos:timestamp.nanoseconds// tslint:disable-next-line:no-any
};};JsonProtoSerializer.prototype.fromTimestamp=function(date){// The json interface (for the browser) will return an iso timestamp string,
// while the proto js library (for node) will return a
// google.protobuf.Timestamp instance.
if(typeof date==='string'){// TODO(b/37282237): Use strings for Proto3 timestamps
// assert(this.options.useProto3Json,
//   'The timestamp string format requires Proto3.');
return this.fromIso8601String(date);}else{assert(!!date,'Cannot deserialize null or undefined timestamp.');// TODO(b/37282237): Use strings for Proto3 timestamps
// assert(!this.options.useProto3Json,
//   'The timestamp instance format requires Proto JS.');
var seconds=parseInt64(date.seconds||'0');var nanos=date.nanos||0;return new Timestamp(seconds,nanos);}};JsonProtoSerializer.prototype.fromIso8601String=function(utc){// The date string can have higher precision (nanos) than the Date class
// (millis), so we do some custom parsing here.
// Parse the nanos right out of the string.
var nanos=0;var fraction=ISO_REG_EXP.exec(utc);assert(!!fraction,'invalid timestamp: '+utc);if(fraction[1]){// Pad the fraction out to 9 digits (nanos).
var nanoStr=fraction[1];nanoStr=(nanoStr+'000000000').substr(0,9);nanos=Number(nanoStr);}// Parse the date to get the seconds.
var date=new Date(utc);var seconds=Math.floor(date.getTime()/1000);return new Timestamp(seconds,nanos);};/**
     * Returns a value for bytes that's appropriate to put in a proto.
     * DO NOT USE THIS FOR ANYTHING ELSE.
     * This method cheats. It's typed as returning "string" because that's what
     * our generated proto interfaces say bytes must be. But it should return
     * an Uint8Array in Node.
     */JsonProtoSerializer.prototype.toBytes=function(bytes){if(this.options.useProto3Json){return bytes.toBase64();}else{// The typings say it's a string, but it needs to be a Uint8Array in Node.
return this.unsafeCastProtoByteString(bytes.toUint8Array());}};/**
     * Parse the blob from the protos into the internal Blob class. Note that the
     * typings assume all blobs are strings, but they are actually Uint8Arrays
     * on Node.
     */JsonProtoSerializer.prototype.fromBlob=function(blob){if(typeof blob==='string'){assert(this.options.useProto3Json,'Expected bytes to be passed in as Uint8Array, but got a string instead.');return Blob.fromBase64String(blob);}else{assert(!this.options.useProto3Json,'Expected bytes to be passed in as Uint8Array, but got a string instead.');return Blob.fromUint8Array(blob);}};JsonProtoSerializer.prototype.toVersion=function(version){return this.toTimestamp(version.toTimestamp());};JsonProtoSerializer.prototype.fromVersion=function(version){assert(!!version,"Trying to deserialize version that isn't set");return SnapshotVersion.fromTimestamp(this.fromTimestamp(version));};JsonProtoSerializer.prototype.toResourceName=function(databaseId,path){return this.fullyQualifiedPrefixPath(databaseId).child('documents').child(path).canonicalString();};JsonProtoSerializer.prototype.fromResourceName=function(name){var resource=ResourcePath.fromString(name);assert(this.isValidResourceName(resource),'Tried to deserialize invalid key '+resource.toString());return resource;};JsonProtoSerializer.prototype.toName=function(key){return this.toResourceName(this.databaseId,key.path);};JsonProtoSerializer.prototype.fromName=function(name){var resource=this.fromResourceName(name);assert(resource.get(1)===this.databaseId.projectId,'Tried to deserialize key from different project: '+resource.get(1)+' vs '+this.databaseId.projectId);assert(!resource.get(3)&&!this.databaseId.database||resource.get(3)===this.databaseId.database,'Tried to deserialize key from different database: '+resource.get(3)+' vs '+this.databaseId.database);return new DocumentKey(this.extractLocalPathFromResourceName(resource));};JsonProtoSerializer.prototype.toQueryPath=function(path){return this.toResourceName(this.databaseId,path);};JsonProtoSerializer.prototype.fromQueryPath=function(name){var resourceName=this.fromResourceName(name);// In v1beta1 queries for collections at the root did not have a trailing
// "/documents". In v1 all resource paths contain "/documents". Preserve the
// ability to read the v1beta1 form for compatibility with queries persisted
// in the local query cache.
if(resourceName.length===4){return ResourcePath.EMPTY_PATH;}return this.extractLocalPathFromResourceName(resourceName);};Object.defineProperty(JsonProtoSerializer.prototype,"encodedDatabaseId",{get:function get(){var path=new ResourcePath(['projects',this.databaseId.projectId,'databases',this.databaseId.database]);return path.canonicalString();},enumerable:true,configurable:true});JsonProtoSerializer.prototype.fullyQualifiedPrefixPath=function(databaseId){return new ResourcePath(['projects',databaseId.projectId,'databases',databaseId.database]);};JsonProtoSerializer.prototype.extractLocalPathFromResourceName=function(resourceName){assert(resourceName.length>4&&resourceName.get(4)==='documents','tried to deserialize invalid key '+resourceName.toString());return resourceName.popFirst(5);};JsonProtoSerializer.prototype.isValidResourceName=function(path){// Resource names have at least 4 components (project ID, database ID)
return path.length>=4&&path.get(0)==='projects'&&path.get(2)==='databases';};JsonProtoSerializer.prototype.toValue=function(val){if(val instanceof NullValue){return{nullValue:'NULL_VALUE'};}else if(val instanceof BooleanValue){return{booleanValue:val.value()};}else if(val instanceof IntegerValue){return{integerValue:''+val.value()};}else if(val instanceof DoubleValue){var doubleValue=val.value();if(this.options.useProto3Json){// Proto 3 let's us encode NaN and Infinity as string values as
// expected by the backend. This is currently not checked by our unit
// tests because they rely on protobuf.js.
if(isNaN(doubleValue)){return{doubleValue:'NaN'};}else if(doubleValue===Infinity){return{doubleValue:'Infinity'};}else if(doubleValue===-Infinity){return{doubleValue:'-Infinity'};}}return{doubleValue:val.value()};}else if(val instanceof StringValue){return{stringValue:val.value()};}else if(val instanceof ObjectValue){return{mapValue:this.toMapValue(val)};}else if(val instanceof ArrayValue){return{arrayValue:this.toArrayValue(val)};}else if(val instanceof TimestampValue){return{timestampValue:this.toTimestamp(val.internalValue)};}else if(val instanceof GeoPointValue){return{geoPointValue:{latitude:val.value().latitude,longitude:val.value().longitude}};}else if(val instanceof BlobValue){return{bytesValue:this.toBytes(val.value())};}else if(val instanceof RefValue){return{referenceValue:this.toResourceName(val.databaseId,val.key.path)};}else{return fail('Unknown FieldValue '+JSON.stringify(val));}};JsonProtoSerializer.prototype.fromValue=function(obj){var _this=this;if('nullValue'in obj){return NullValue.INSTANCE;}else if('booleanValue'in obj){return BooleanValue.of(obj.booleanValue);}else if('integerValue'in obj){return new IntegerValue(parseInt64(obj.integerValue));}else if('doubleValue'in obj){if(this.options.useProto3Json){// Proto 3 uses the string values 'NaN' and 'Infinity'.
if(obj.doubleValue==='NaN'){return DoubleValue.NAN;}else if(obj.doubleValue==='Infinity'){return DoubleValue.POSITIVE_INFINITY;}else if(obj.doubleValue==='-Infinity'){return DoubleValue.NEGATIVE_INFINITY;}}return new DoubleValue(obj.doubleValue);}else if('stringValue'in obj){return new StringValue(obj.stringValue);}else if('mapValue'in obj){return this.fromFields(obj.mapValue.fields||{});}else if('arrayValue'in obj){// "values" is not present if the array is empty
assertPresent(obj.arrayValue,'arrayValue');var values=obj.arrayValue.values||[];return new ArrayValue(values.map(function(v){return _this.fromValue(v);}));}else if('timestampValue'in obj){assertPresent(obj.timestampValue,'timestampValue');return new TimestampValue(this.fromTimestamp(obj.timestampValue));}else if('geoPointValue'in obj){assertPresent(obj.geoPointValue,'geoPointValue');var latitude=obj.geoPointValue.latitude||0;var longitude=obj.geoPointValue.longitude||0;return new GeoPointValue(new GeoPoint(latitude,longitude));}else if('bytesValue'in obj){assertPresent(obj.bytesValue,'bytesValue');var blob=this.fromBlob(obj.bytesValue);return new BlobValue(blob);}else if('referenceValue'in obj){assertPresent(obj.referenceValue,'referenceValue');var resourceName=this.fromResourceName(obj.referenceValue);var dbId=new DatabaseId(resourceName.get(1),resourceName.get(3));var key=new DocumentKey(this.extractLocalPathFromResourceName(resourceName));return new RefValue(dbId,key);}else{return fail('Unknown Value proto '+JSON.stringify(obj));}};/** Creates an api.Document from key and fields (but no create/update time) */JsonProtoSerializer.prototype.toMutationDocument=function(key,fields){return{name:this.toName(key),fields:this.toFields(fields)};};JsonProtoSerializer.prototype.toDocument=function(document){assert(!document.hasLocalMutations,"Can't serialize documents with mutations.");return{name:this.toName(document.key),fields:this.toFields(document.data),updateTime:this.toTimestamp(document.version.toTimestamp())};};JsonProtoSerializer.prototype.fromDocument=function(document,hasCommittedMutations){return new Document(this.fromName(document.name),this.fromVersion(document.updateTime),this.fromFields(document.fields||{}),{hasCommittedMutations:!!hasCommittedMutations});};JsonProtoSerializer.prototype.toFields=function(fields){var _this=this;var result={};fields.forEach(function(key,value){result[key]=_this.toValue(value);});return result;};JsonProtoSerializer.prototype.fromFields=function(object){var _this=this;// Proto map<string, Value> gets mapped to Object, so cast it.
var map=object;var result=ObjectValue.EMPTY;forEach(map,function(key,value){result=result.set(new FieldPath([key]),_this.fromValue(value));});return result;};JsonProtoSerializer.prototype.toMapValue=function(map){return{fields:this.toFields(map)};};JsonProtoSerializer.prototype.toArrayValue=function(array){var _this=this;var result=[];array.forEach(function(value){result.push(_this.toValue(value));});return{values:result};};JsonProtoSerializer.prototype.fromFound=function(doc){assert(!!doc.found,'Tried to deserialize a found document from a missing document.');assertPresent(doc.found.name,'doc.found.name');assertPresent(doc.found.updateTime,'doc.found.updateTime');var key=this.fromName(doc.found.name);var version=this.fromVersion(doc.found.updateTime);var fields=this.fromFields(doc.found.fields||{});return new Document(key,version,fields,{},doc.found);};JsonProtoSerializer.prototype.fromMissing=function(result){assert(!!result.missing,'Tried to deserialize a missing document from a found document.');assert(!!result.readTime,'Tried to deserialize a missing document without a read time.');var key=this.fromName(result.missing);var version=this.fromVersion(result.readTime);return new NoDocument(key,version);};JsonProtoSerializer.prototype.fromMaybeDocument=function(result){if('found'in result){return this.fromFound(result);}else if('missing'in result){return this.fromMissing(result);}return fail('invalid batch get response: '+JSON.stringify(result));};JsonProtoSerializer.prototype.toWatchTargetChangeState=function(state){switch(state){case WatchTargetChangeState.Added:return'ADD';case WatchTargetChangeState.Current:return'CURRENT';case WatchTargetChangeState.NoChange:return'NO_CHANGE';case WatchTargetChangeState.Removed:return'REMOVE';case WatchTargetChangeState.Reset:return'RESET';default:return fail('Unknown WatchTargetChangeState: '+state);}};JsonProtoSerializer.prototype.toTestWatchChange=function(watchChange){if(watchChange instanceof ExistenceFilterChange){return{filter:{count:watchChange.existenceFilter.count,targetId:watchChange.targetId}};}if(watchChange instanceof DocumentWatchChange){if(watchChange.newDoc instanceof Document){var doc=watchChange.newDoc;return{documentChange:{document:{name:this.toName(doc.key),fields:this.toFields(doc.data),updateTime:this.toVersion(doc.version)},targetIds:watchChange.updatedTargetIds,removedTargetIds:watchChange.removedTargetIds}};}else if(watchChange.newDoc instanceof NoDocument){var doc=watchChange.newDoc;return{documentDelete:{document:this.toName(doc.key),readTime:this.toVersion(doc.version),removedTargetIds:watchChange.removedTargetIds}};}else if(watchChange.newDoc===null){return{documentRemove:{document:this.toName(watchChange.key),removedTargetIds:watchChange.removedTargetIds}};}}if(watchChange instanceof WatchTargetChange){var cause=undefined;if(watchChange.cause){cause={code:mapRpcCodeFromCode(watchChange.cause.code),message:watchChange.cause.message};}return{targetChange:{targetChangeType:this.toWatchTargetChangeState(watchChange.state),targetIds:watchChange.targetIds,resumeToken:this.unsafeCastProtoByteString(watchChange.resumeToken),cause:cause}};}return fail('Unrecognized watch change: '+JSON.stringify(watchChange));};JsonProtoSerializer.prototype.fromWatchChange=function(change){var watchChange;if('targetChange'in change){assertPresent(change.targetChange,'targetChange');// proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
// if unset
var state=this.fromWatchTargetChangeState(change.targetChange.targetChangeType||'NO_CHANGE');var targetIds=change.targetChange.targetIds||[];var resumeToken=change.targetChange.resumeToken||this.emptyByteString();var causeProto=change.targetChange.cause;var cause=causeProto&&this.fromRpcStatus(causeProto);watchChange=new WatchTargetChange(state,targetIds,resumeToken,cause||null);}else if('documentChange'in change){assertPresent(change.documentChange,'documentChange');assertPresent(change.documentChange.document,'documentChange.name');assertPresent(change.documentChange.document.name,'documentChange.document.name');assertPresent(change.documentChange.document.updateTime,'documentChange.document.updateTime');var entityChange=change.documentChange;var key=this.fromName(entityChange.document.name);var version=this.fromVersion(entityChange.document.updateTime);var fields=this.fromFields(entityChange.document.fields||{});// The document may soon be re-serialized back to protos in order to store it in local
// persistence. Memoize the encoded form to avoid encoding it again.
var doc=new Document(key,version,fields,{},entityChange.document);var updatedTargetIds=entityChange.targetIds||[];var removedTargetIds=entityChange.removedTargetIds||[];watchChange=new DocumentWatchChange(updatedTargetIds,removedTargetIds,doc.key,doc);}else if('documentDelete'in change){assertPresent(change.documentDelete,'documentDelete');assertPresent(change.documentDelete.document,'documentDelete.document');var docDelete=change.documentDelete;var key=this.fromName(docDelete.document);var version=docDelete.readTime?this.fromVersion(docDelete.readTime):SnapshotVersion.forDeletedDoc();var doc=new NoDocument(key,version);var removedTargetIds=docDelete.removedTargetIds||[];watchChange=new DocumentWatchChange([],removedTargetIds,doc.key,doc);}else if('documentRemove'in change){assertPresent(change.documentRemove,'documentRemove');assertPresent(change.documentRemove.document,'documentRemove');var docRemove=change.documentRemove;var key=this.fromName(docRemove.document);var removedTargetIds=docRemove.removedTargetIds||[];watchChange=new DocumentWatchChange([],removedTargetIds,key,null);}else if('filter'in change){// TODO(dimond): implement existence filter parsing with strategy.
assertPresent(change.filter,'filter');assertPresent(change.filter.targetId,'filter.targetId');var filter=change.filter;var count=filter.count||0;var existenceFilter=new ExistenceFilter(count);var targetId=filter.targetId;watchChange=new ExistenceFilterChange(targetId,existenceFilter);}else{return fail('Unknown change type '+JSON.stringify(change));}return watchChange;};JsonProtoSerializer.prototype.fromWatchTargetChangeState=function(state){if(state==='NO_CHANGE'){return WatchTargetChangeState.NoChange;}else if(state==='ADD'){return WatchTargetChangeState.Added;}else if(state==='REMOVE'){return WatchTargetChangeState.Removed;}else if(state==='CURRENT'){return WatchTargetChangeState.Current;}else if(state==='RESET'){return WatchTargetChangeState.Reset;}else{return fail('Got unexpected TargetChange.state: '+state);}};JsonProtoSerializer.prototype.versionFromListenResponse=function(change){// We have only reached a consistent snapshot for the entire stream if there
// is a read_time set and it applies to all targets (i.e. the list of
// targets is empty). The backend is guaranteed to send such responses.
if(!('targetChange'in change)){return SnapshotVersion.MIN;}var targetChange=change.targetChange;if(targetChange.targetIds&&targetChange.targetIds.length){return SnapshotVersion.MIN;}if(!targetChange.readTime){return SnapshotVersion.MIN;}return this.fromVersion(targetChange.readTime);};JsonProtoSerializer.prototype.toMutation=function(mutation){var _this=this;var result;if(mutation instanceof SetMutation){result={update:this.toMutationDocument(mutation.key,mutation.value)};}else if(mutation instanceof DeleteMutation){result={delete:this.toName(mutation.key)};}else if(mutation instanceof PatchMutation){result={update:this.toMutationDocument(mutation.key,mutation.data),updateMask:this.toDocumentMask(mutation.fieldMask)};}else if(mutation instanceof TransformMutation){result={transform:{document:this.toName(mutation.key),fieldTransforms:mutation.fieldTransforms.map(function(transform){return _this.toFieldTransform(transform);})}};}else{return fail('Unknown mutation type '+mutation.type);}if(!mutation.precondition.isNone){result.currentDocument=this.toPrecondition(mutation.precondition);}return result;};JsonProtoSerializer.prototype.fromMutation=function(proto){var _this=this;var precondition=proto.currentDocument?this.fromPrecondition(proto.currentDocument):Precondition.NONE;if(proto.update){assertPresent(proto.update.name,'name');var key=this.fromName(proto.update.name);var value=this.fromFields(proto.update.fields||{});if(proto.updateMask){var fieldMask=this.fromDocumentMask(proto.updateMask);return new PatchMutation(key,value,fieldMask,precondition);}else{return new SetMutation(key,value,precondition);}}else if(proto.delete){var key=this.fromName(proto.delete);return new DeleteMutation(key,precondition);}else if(proto.transform){var key=this.fromName(proto.transform.document);var fieldTransforms=proto.transform.fieldTransforms.map(function(transform){return _this.fromFieldTransform(transform);});assert(precondition.exists===true,'Transforms only support precondition "exists == true"');return new TransformMutation(key,fieldTransforms);}else{return fail('unknown mutation proto: '+JSON.stringify(proto));}};JsonProtoSerializer.prototype.toPrecondition=function(precondition){assert(!precondition.isNone,"Can't serialize an empty precondition");if(precondition.updateTime!==undefined){return{updateTime:this.toVersion(precondition.updateTime)};}else if(precondition.exists!==undefined){return{exists:precondition.exists};}else{return fail('Unknown precondition');}};JsonProtoSerializer.prototype.fromPrecondition=function(precondition){if(precondition.updateTime!==undefined){return Precondition.updateTime(this.fromVersion(precondition.updateTime));}else if(precondition.exists!==undefined){return Precondition.exists(precondition.exists);}else{return Precondition.NONE;}};JsonProtoSerializer.prototype.fromWriteResult=function(proto,commitTime){var _this=this;// NOTE: Deletes don't have an updateTime.
var version=proto.updateTime?this.fromVersion(proto.updateTime):this.fromVersion(commitTime);var transformResults=null;if(proto.transformResults&&proto.transformResults.length>0){transformResults=proto.transformResults.map(function(result){return _this.fromValue(result);});}return new MutationResult(version,transformResults);};JsonProtoSerializer.prototype.fromWriteResults=function(protos,commitTime){var _this=this;if(protos&&protos.length>0){assert(commitTime!==undefined,'Received a write result without a commit time');return protos.map(function(proto){return _this.fromWriteResult(proto,commitTime);});}else{return[];}};JsonProtoSerializer.prototype.toFieldTransform=function(fieldTransform){var _this=this;var transform=fieldTransform.transform;if(transform instanceof ServerTimestampTransform){return{fieldPath:fieldTransform.field.canonicalString(),setToServerValue:'REQUEST_TIME'};}else if(transform instanceof ArrayUnionTransformOperation){return{fieldPath:fieldTransform.field.canonicalString(),appendMissingElements:{values:transform.elements.map(function(v){return _this.toValue(v);})}};}else if(transform instanceof ArrayRemoveTransformOperation){return{fieldPath:fieldTransform.field.canonicalString(),removeAllFromArray:{values:transform.elements.map(function(v){return _this.toValue(v);})}};}else if(transform instanceof NumericIncrementTransformOperation){return{fieldPath:fieldTransform.field.canonicalString(),increment:this.toValue(transform.operand)};}else{throw fail('Unknown transform: '+fieldTransform.transform);}};JsonProtoSerializer.prototype.fromFieldTransform=function(proto){var _this=this;var transform=null;if('setToServerValue'in proto){assert(proto.setToServerValue==='REQUEST_TIME','Unknown server value transform proto: '+JSON.stringify(proto));transform=ServerTimestampTransform.instance;}else if('appendMissingElements'in proto){var values=proto.appendMissingElements.values||[];transform=new ArrayUnionTransformOperation(values.map(function(v){return _this.fromValue(v);}));}else if('removeAllFromArray'in proto){var values=proto.removeAllFromArray.values||[];transform=new ArrayRemoveTransformOperation(values.map(function(v){return _this.fromValue(v);}));}else if('increment'in proto){var operand=this.fromValue(proto.increment);assert(operand instanceof NumberValue,'NUMERIC_ADD transform requires a NumberValue');transform=new NumericIncrementTransformOperation(operand);}else{fail('Unknown transform proto: '+JSON.stringify(proto));}var fieldPath=FieldPath.fromServerFormat(proto.fieldPath);return new FieldTransform(fieldPath,transform);};JsonProtoSerializer.prototype.toDocumentsTarget=function(query){return{documents:[this.toQueryPath(query.path)]};};JsonProtoSerializer.prototype.fromDocumentsTarget=function(documentsTarget){var count=documentsTarget.documents.length;assert(count===1,'DocumentsTarget contained other than 1 document: '+count);var name=documentsTarget.documents[0];return Query.atPath(this.fromQueryPath(name));};JsonProtoSerializer.prototype.toQueryTarget=function(query){// Dissect the path into parent, collectionId, and optional key filter.
var result={structuredQuery:{}};var path=query.path;if(query.collectionGroup!==null){assert(path.length%2===0,'Collection Group queries should be within a document path or root.');result.parent=this.toQueryPath(path);result.structuredQuery.from=[{collectionId:query.collectionGroup,allDescendants:true}];}else{assert(path.length%2!==0,'Document queries with filters are not supported.');result.parent=this.toQueryPath(path.popLast());result.structuredQuery.from=[{collectionId:path.lastSegment()}];}var where=this.toFilter(query.filters);if(where){result.structuredQuery.where=where;}var orderBy=this.toOrder(query.orderBy);if(orderBy){result.structuredQuery.orderBy=orderBy;}var limit=this.toInt32Value(query.limit);if(limit!==undefined){result.structuredQuery.limit=limit;}if(query.startAt){result.structuredQuery.startAt=this.toCursor(query.startAt);}if(query.endAt){result.structuredQuery.endAt=this.toCursor(query.endAt);}return result;};JsonProtoSerializer.prototype.fromQueryTarget=function(target){var path=this.fromQueryPath(target.parent);var query=target.structuredQuery;var fromCount=query.from?query.from.length:0;var collectionGroup=null;if(fromCount>0){assert(fromCount===1,'StructuredQuery.from with more than one collection is not supported.');var from=query.from[0];if(from.allDescendants){collectionGroup=from.collectionId;}else{path=path.child(from.collectionId);}}var filterBy=[];if(query.where){filterBy=this.fromFilter(query.where);}var orderBy=[];if(query.orderBy){orderBy=this.fromOrder(query.orderBy);}var limit=null;if(query.limit){limit=this.fromInt32Value(query.limit);}var startAt=null;if(query.startAt){startAt=this.fromCursor(query.startAt);}var endAt=null;if(query.endAt){endAt=this.fromCursor(query.endAt);}return new Query(path,collectionGroup,orderBy,filterBy,limit,startAt,endAt);};JsonProtoSerializer.prototype.toListenRequestLabels=function(queryData){var value=this.toLabel(queryData.purpose);if(value==null){return null;}else{return{'goog-listen-tags':value};}};JsonProtoSerializer.prototype.toLabel=function(purpose){switch(purpose){case QueryPurpose.Listen:return null;case QueryPurpose.ExistenceFilterMismatch:return'existence-filter-mismatch';case QueryPurpose.LimboResolution:return'limbo-document';default:return fail('Unrecognized query purpose: '+purpose);}};JsonProtoSerializer.prototype.toTarget=function(queryData){var result;var query=queryData.query;if(query.isDocumentQuery()){result={documents:this.toDocumentsTarget(query)};}else{result={query:this.toQueryTarget(query)};}result.targetId=queryData.targetId;if(queryData.resumeToken.length>0){result.resumeToken=this.unsafeCastProtoByteString(queryData.resumeToken);}return result;};JsonProtoSerializer.prototype.toFilter=function(filters){var _this=this;if(filters.length===0)return;var protos=filters.map(function(filter){return filter instanceof RelationFilter?_this.toRelationFilter(filter):_this.toUnaryFilter(filter);});if(protos.length===1){return protos[0];}return{compositeFilter:{op:'AND',filters:protos}};};JsonProtoSerializer.prototype.fromFilter=function(filter){var _this=this;if(!filter){return[];}else if(filter.unaryFilter!==undefined){return[this.fromUnaryFilter(filter)];}else if(filter.fieldFilter!==undefined){return[this.fromRelationFilter(filter)];}else if(filter.compositeFilter!==undefined){return filter.compositeFilter.filters.map(function(f){return _this.fromFilter(f);}).reduce(function(accum,current){return accum.concat(current);});}else{return fail('Unknown filter: '+JSON.stringify(filter));}};JsonProtoSerializer.prototype.toOrder=function(orderBys){var _this=this;if(orderBys.length===0)return;return orderBys.map(function(order){return _this.toPropertyOrder(order);});};JsonProtoSerializer.prototype.fromOrder=function(orderBys){var _this=this;return orderBys.map(function(order){return _this.fromPropertyOrder(order);});};JsonProtoSerializer.prototype.toCursor=function(cursor){var _this=this;return{before:cursor.before,values:cursor.position.map(function(component){return _this.toValue(component);})};};JsonProtoSerializer.prototype.fromCursor=function(cursor){var _this=this;var before=!!cursor.before;var position=cursor.values.map(function(component){return _this.fromValue(component);});return new Bound(position,before);};// visible for testing
JsonProtoSerializer.prototype.toDirection=function(dir){return DIRECTIONS[dir.name];};// visible for testing
JsonProtoSerializer.prototype.fromDirection=function(dir){switch(dir){case'ASCENDING':return Direction.ASCENDING;case'DESCENDING':return Direction.DESCENDING;default:return undefined;}};// visible for testing
JsonProtoSerializer.prototype.toOperatorName=function(op){return OPERATORS[op.name];};JsonProtoSerializer.prototype.fromOperatorName=function(op){switch(op){case'EQUAL':return RelationOp.EQUAL;case'GREATER_THAN':return RelationOp.GREATER_THAN;case'GREATER_THAN_OR_EQUAL':return RelationOp.GREATER_THAN_OR_EQUAL;case'LESS_THAN':return RelationOp.LESS_THAN;case'LESS_THAN_OR_EQUAL':return RelationOp.LESS_THAN_OR_EQUAL;case'ARRAY_CONTAINS':return RelationOp.ARRAY_CONTAINS;case'OPERATOR_UNSPECIFIED':return fail('Unspecified relation');default:return fail('Unknown relation');}};JsonProtoSerializer.prototype.toFieldPathReference=function(path){return{fieldPath:path.canonicalString()};};JsonProtoSerializer.prototype.fromFieldPathReference=function(fieldReference){return FieldPath.fromServerFormat(fieldReference.fieldPath);};// visible for testing
JsonProtoSerializer.prototype.toPropertyOrder=function(orderBy){return{field:this.toFieldPathReference(orderBy.field),direction:this.toDirection(orderBy.dir)};};JsonProtoSerializer.prototype.fromPropertyOrder=function(orderBy){return new OrderBy(this.fromFieldPathReference(orderBy.field),this.fromDirection(orderBy.direction));};// visible for testing
JsonProtoSerializer.prototype.toRelationFilter=function(filter){if(filter instanceof RelationFilter){return{fieldFilter:{field:this.toFieldPathReference(filter.field),op:this.toOperatorName(filter.op),value:this.toValue(filter.value)}};}else{return fail('Unrecognized filter: '+JSON.stringify(filter));}};JsonProtoSerializer.prototype.fromRelationFilter=function(filter){return new RelationFilter(this.fromFieldPathReference(filter.fieldFilter.field),this.fromOperatorName(filter.fieldFilter.op),this.fromValue(filter.fieldFilter.value));};// visible for testing
JsonProtoSerializer.prototype.toUnaryFilter=function(filter){if(filter instanceof NanFilter){return{unaryFilter:{field:this.toFieldPathReference(filter.field),op:'IS_NAN'}};}else if(filter instanceof NullFilter){return{unaryFilter:{field:this.toFieldPathReference(filter.field),op:'IS_NULL'}};}else{return fail('Unrecognized filter: '+JSON.stringify(filter));}};JsonProtoSerializer.prototype.fromUnaryFilter=function(filter){switch(filter.unaryFilter.op){case'IS_NAN':var nanField=this.fromFieldPathReference(filter.unaryFilter.field);return new NanFilter(nanField);case'IS_NULL':var nullField=this.fromFieldPathReference(filter.unaryFilter.field);return new NullFilter(nullField);case'OPERATOR_UNSPECIFIED':return fail('Unspecified filter');default:return fail('Unknown filter');}};JsonProtoSerializer.prototype.toDocumentMask=function(fieldMask){var canonicalFields=[];fieldMask.fields.forEach(function(field){return canonicalFields.push(field.canonicalString());});return{fieldPaths:canonicalFields};};JsonProtoSerializer.prototype.fromDocumentMask=function(proto){var paths=proto.fieldPaths||[];var fields=paths.map(function(path){return FieldPath.fromServerFormat(path);});return FieldMask.fromArray(fields);};return JsonProtoSerializer;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */var StreamBridge=/** @class */function(){function StreamBridge(args){this.sendFn=args.sendFn;this.closeFn=args.closeFn;}StreamBridge.prototype.onOpen=function(callback){assert(!this.wrappedOnOpen,'Called onOpen on stream twice!');this.wrappedOnOpen=callback;};StreamBridge.prototype.onClose=function(callback){assert(!this.wrappedOnClose,'Called onClose on stream twice!');this.wrappedOnClose=callback;};StreamBridge.prototype.onMessage=function(callback){assert(!this.wrappedOnMessage,'Called onMessage on stream twice!');this.wrappedOnMessage=callback;};StreamBridge.prototype.close=function(){this.closeFn();};StreamBridge.prototype.send=function(msg){this.sendFn(msg);};StreamBridge.prototype.callOnOpen=function(){assert(this.wrappedOnOpen!==undefined,'Cannot call onOpen because no callback was set');this.wrappedOnOpen();};StreamBridge.prototype.callOnClose=function(err){assert(this.wrappedOnClose!==undefined,'Cannot call onClose because no callback was set');this.wrappedOnClose(err);};StreamBridge.prototype.callOnMessage=function(msg){assert(this.wrappedOnMessage!==undefined,'Cannot call onMessage because no callback was set');this.wrappedOnMessage(msg);};return StreamBridge;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG='Connection';var RPC_STREAM_SERVICE='google.firestore.v1.Firestore';var RPC_URL_VERSION='v1';/** Maps RPC names to the corresponding REST endpoint name. */var RPC_NAME_REST_MAPPING={BatchGetDocuments:'batchGet',Commit:'commit'};// TODO(b/38203344): The SDK_VERSION is set independently from Firebase because
// we are doing out-of-band releases. Once we release as part of Firebase, we
// should use the Firebase version instead.
var X_GOOG_API_CLIENT_VALUE='gl-js/ fire/'+SDK_VERSION;var XHR_TIMEOUT_SECS=15;var WebChannelConnection=/** @class */function(){function WebChannelConnection(info){this.databaseId=info.databaseId;var proto=info.ssl?'https':'http';this.baseUrl=proto+'://'+info.host;this.forceLongPolling=info.forceLongPolling;}/**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */WebChannelConnection.prototype.modifyHeadersForRequest=function(headers,token){if(token){for(var header in token.authHeaders){if(token.authHeaders.hasOwnProperty(header)){headers[header]=token.authHeaders[header];}}}headers['X-Goog-Api-Client']=X_GOOG_API_CLIENT_VALUE;};WebChannelConnection.prototype.invokeRPC=function(rpcName,request,token){var _this=this;var url=this.makeUrl(rpcName);return new Promise(function(resolve,reject){// tslint:disable-next-line:no-any XhrIo doesn't have TS typings.
var xhr=new webchannelWrapper.XhrIo();xhr.listenOnce(webchannelWrapper.EventType.COMPLETE,function(){try{switch(xhr.getLastErrorCode()){case webchannelWrapper.ErrorCode.NO_ERROR:var json=xhr.getResponseJson();debug(LOG_TAG,'XHR received:',JSON.stringify(json));resolve(json);break;case webchannelWrapper.ErrorCode.TIMEOUT:debug(LOG_TAG,'RPC "'+rpcName+'" timed out');reject(new FirestoreError(Code.DEADLINE_EXCEEDED,'Request time out'));break;case webchannelWrapper.ErrorCode.HTTP_ERROR:var status_1=xhr.getStatus();debug(LOG_TAG,'RPC "'+rpcName+'" failed with status:',status_1,'response text:',xhr.getResponseText());if(status_1>0){reject(new FirestoreError(mapCodeFromHttpStatus(status_1),'Server responded with status '+xhr.getStatusText()));}else{// If we received an HTTP_ERROR but there's no status code,
// it's most probably a connection issue
debug(LOG_TAG,'RPC "'+rpcName+'" failed');reject(new FirestoreError(Code.UNAVAILABLE,'Connection failed.'));}break;default:fail('RPC "'+rpcName+'" failed with unanticipated '+'webchannel error '+xhr.getLastErrorCode()+': '+xhr.getLastError()+', giving up.');}}finally{debug(LOG_TAG,'RPC "'+rpcName+'" completed.');}});var requestString=JSON.stringify(request);debug(LOG_TAG,'XHR sending: ',url+' '+requestString);// Content-Type: text/plain will avoid preflight requests which might
// mess with CORS and redirects by proxies. If we add custom headers
// we will need to change this code to potentially use the
// $httpOverwrite parameter supported by ESF to avoid
// triggering preflight requests.
var headers={'Content-Type':'text/plain'};_this.modifyHeadersForRequest(headers,token);xhr.send(url,'POST',requestString,headers,XHR_TIMEOUT_SECS);});};WebChannelConnection.prototype.invokeStreamingRPC=function(rpcName,request,token){// The REST API automatically aggregates all of the streamed results, so we
// can just use the normal invoke() method.
return this.invokeRPC(rpcName,request,token);};WebChannelConnection.prototype.openStream=function(rpcName,token){var urlParts=[this.baseUrl,'/',RPC_STREAM_SERVICE,'/',rpcName,'/channel'];var webchannelTransport=webchannelWrapper.createWebChannelTransport();var request={// Background channel test avoids the initial two test calls and decreases
// initial cold start time.
// TODO(dimond): wenboz@ mentioned this might affect use with proxies and
// we should monitor closely for any reports.
backgroundChannelTest:true,// Required for backend stickiness, routing behavior is based on this
// parameter.
httpSessionIdParam:'gsessionid',initMessageHeaders:{},messageUrlParams:{// This param is used to improve routing and project isolation by the
// backend and must be included in every request.
database:"projects/"+this.databaseId.projectId+"/databases/"+this.databaseId.database},sendRawJson:true,supportsCrossDomainXhr:true,internalChannelParams:{// Override the default timeout (randomized between 10-20 seconds) since
// a large write batch on a slow internet connection may take a long
// time to send to the backend. Rather than have WebChannel impose a
// tight timeout which could lead to infinite timeouts and retries, we
// set it very large (5-10 minutes) and rely on the browser's builtin
// timeouts to kick in if the request isn't working.
forwardChannelRequestTimeoutMs:10*60*1000},forceLongPolling:this.forceLongPolling};this.modifyHeadersForRequest(request.initMessageHeaders,token);// Sending the custom headers we just added to request.initMessageHeaders
// (Authorization, etc.) will trigger the browser to make a CORS preflight
// request because the XHR will no longer meet the criteria for a "simple"
// CORS request:
// https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
//
// Therefore to avoid the CORS preflight request (an extra network
// roundtrip), we use the httpHeadersOverwriteParam option to specify that
// the headers should instead be encoded into a special "$httpHeaders" query
// parameter, which is recognized by the webchannel backend. This is
// formally defined here:
// https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
//
// But for some unclear reason (see
// https://github.com/firebase/firebase-js-sdk/issues/703), this breaks
// ReactNative and so we exclude it, which just means ReactNative may be
// subject to the extra network roundtrip for CORS preflight.
if(!util.isReactNative()){request['httpHeadersOverwriteParam']='$httpHeaders';}var url=urlParts.join('');debug(LOG_TAG,'Creating WebChannel: '+url+' '+request);// tslint:disable-next-line:no-any Because listen isn't defined on it.
var channel=webchannelTransport.createWebChannel(url,request);// WebChannel supports sending the first message with the handshake - saving
// a network round trip. However, it will have to call send in the same
// JS event loop as open. In order to enforce this, we delay actually
// opening the WebChannel until send is called. Whether we have called
// open is tracked with this variable.
var opened=false;// A flag to determine whether the stream was closed (by us or through an
// error/close event) to avoid delivering multiple close events or sending
// on a closed stream
var closed=false;var streamBridge=new StreamBridge({sendFn:function sendFn(msg){if(!closed){if(!opened){debug(LOG_TAG,'Opening WebChannel transport.');channel.open();opened=true;}debug(LOG_TAG,'WebChannel sending:',msg);channel.send(msg);}else{debug(LOG_TAG,'Not sending because WebChannel is closed:',msg);}},closeFn:function closeFn(){return channel.close();}});// Closure events are guarded and exceptions are swallowed, so catch any
// exception and rethrow using a setTimeout so they become visible again.
// Note that eventually this function could go away if we are confident
// enough the code is exception free.
var unguardedEventListen=function unguardedEventListen(type,fn){// TODO(dimond): closure typing seems broken because WebChannel does
// not implement goog.events.Listenable
channel.listen(type,function(param){try{fn(param);}catch(e){setTimeout(function(){throw e;},0);}});};unguardedEventListen(webchannelWrapper.WebChannel.EventType.OPEN,function(){if(!closed){debug(LOG_TAG,'WebChannel transport opened.');}});unguardedEventListen(webchannelWrapper.WebChannel.EventType.CLOSE,function(){if(!closed){closed=true;debug(LOG_TAG,'WebChannel transport closed');streamBridge.callOnClose();}});unguardedEventListen(webchannelWrapper.WebChannel.EventType.ERROR,function(err){if(!closed){closed=true;debug(LOG_TAG,'WebChannel transport errored:',err);streamBridge.callOnClose(new FirestoreError(Code.UNAVAILABLE,'The operation could not be completed'));}});unguardedEventListen(webchannelWrapper.WebChannel.EventType.MESSAGE,function(msg){if(!closed){var msgData=msg.data[0];assert(!!msgData,'Got a webchannel message without data.');// TODO(b/35143891): There is a bug in One Platform that caused errors
// (and only errors) to be wrapped in an extra array. To be forward
// compatible with the bug we need to check either condition. The latter
// can be removed once the fix has been rolled out.
var error=// tslint:disable-next-line:no-any msgData.error is not typed.
msgData.error||msgData[0]&&msgData[0].error;if(error){debug(LOG_TAG,'WebChannel received error:',error);// error.status will be a string like 'OK' or 'NOT_FOUND'.
var status_2=error.status;var code=mapCodeFromRpcStatus(status_2);var message=error.message;if(code===undefined){code=Code.INTERNAL;message='Unknown error status: '+status_2+' with message '+error.message;}// Mark closed so no further events are propagated
closed=true;streamBridge.callOnClose(new FirestoreError(code,message));channel.close();}else{debug(LOG_TAG,'WebChannel received:',msgData);streamBridge.callOnMessage(msgData);}}});setTimeout(function(){// Technically we could/should wait for the WebChannel opened event,
// but because we want to send the first message with the WebChannel
// handshake we pretend the channel opened here (asynchronously), and
// then delay the actual open until the first message is sent.
streamBridge.callOnOpen();},0);return streamBridge;};// visible for testing
WebChannelConnection.prototype.makeUrl=function(rpcName){var urlRpcName=RPC_NAME_REST_MAPPING[rpcName];assert(urlRpcName!==undefined,'Unknown REST mapping for: '+rpcName);var url=[this.baseUrl,'/',RPC_URL_VERSION];url.push('/projects/');url.push(this.databaseId.projectId);url.push('/databases/');url.push(this.databaseId.database);url.push('/documents');url.push(':');url.push(urlRpcName);return url.join('');};return WebChannelConnection;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var BrowserPlatform=/** @class */function(){function BrowserPlatform(){this.emptyByteString='';this.base64Available=typeof atob!=='undefined';}Object.defineProperty(BrowserPlatform.prototype,"document",{get:function get(){return typeof document!=='undefined'?document:null;},enumerable:true,configurable:true});Object.defineProperty(BrowserPlatform.prototype,"window",{get:function get(){return typeof window!=='undefined'?window:null;},enumerable:true,configurable:true});BrowserPlatform.prototype.loadConnection=function(databaseInfo){return Promise.resolve(new WebChannelConnection(databaseInfo));};BrowserPlatform.prototype.newSerializer=function(databaseId){return new JsonProtoSerializer(databaseId,{useProto3Json:true});};BrowserPlatform.prototype.formatJSON=function(value){return JSON.stringify(value);};BrowserPlatform.prototype.atob=function(encoded){return atob(encoded);};BrowserPlatform.prototype.btoa=function(raw){return btoa(raw);};return BrowserPlatform;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * This code needs to run before Firestore is used. This can be achieved in
 * several ways:
 *   1) Through the JSCompiler compiling this code and then (automatically)
 *      executing it before exporting the Firestore symbols.
 *   2) Through importing this module first in a Firestore main module
 */PlatformSupport.setPlatform(new BrowserPlatform());/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */var ListenSequence=/** @class */function(){function ListenSequence(previousValue,sequenceNumberSyncer){var _this=this;this.previousValue=previousValue;if(sequenceNumberSyncer){sequenceNumberSyncer.sequenceNumberHandler=function(sequenceNumber){return _this.setPreviousValue(sequenceNumber);};this.writeNewSequenceNumber=function(sequenceNumber){return sequenceNumberSyncer.writeSequenceNumber(sequenceNumber);};}}ListenSequence.prototype.setPreviousValue=function(externalPreviousValue){this.previousValue=Math.max(externalPreviousValue,this.previousValue);return this.previousValue;};ListenSequence.prototype.next=function(){var nextValue=++this.previousValue;if(this.writeNewSequenceNumber){this.writeNewSequenceNumber(nextValue);}return nextValue;};ListenSequence.INVALID=-1;return ListenSequence;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var Deferred=/** @class */function(){function Deferred(){var _this=this;this.promise=new Promise(function(resolve,reject){_this.resolve=resolve;_this.reject=reject;});}return Deferred;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Wellknown "timer" IDs used when scheduling delayed operations on the
 * AsyncQueue. These IDs can then be used from tests to check for the presence
 * of operations or to run them early.
 *
 * The string values are used when encoding these timer IDs in JSON spec tests.
 */var TimerId;(function(TimerId){/** All can be used with runDelayedOperationsEarly() to run all timers. */TimerId["All"]="all";/**
     * The following 4 timers are used in persistent_stream.ts for the listen and
     * write streams. The "Idle" timer is used to close the stream due to
     * inactivity. The "ConnectionBackoff" timer is used to restart a stream once
     * the appropriate backoff delay has elapsed.
     */TimerId["ListenStreamIdle"]="listen_stream_idle";TimerId["ListenStreamConnectionBackoff"]="listen_stream_connection_backoff";TimerId["WriteStreamIdle"]="write_stream_idle";TimerId["WriteStreamConnectionBackoff"]="write_stream_connection_backoff";/**
     * A timer used in online_state_tracker.ts to transition from
     * OnlineState.Unknown to Offline after a set timeout, rather than waiting
     * indefinitely for success or failure.
     */TimerId["OnlineStateTimeout"]="online_state_timeout";/**
     * A timer used to update the client metadata in IndexedDb, which is used
     * to determine the primary leaseholder.
     */TimerId["ClientMetadataRefresh"]="client_metadata_refresh";/** A timer used to periodically attempt LRU Garbage collection */TimerId["LruGarbageCollection"]="lru_garbage_collection";})(TimerId||(TimerId={}));/**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 */var DelayedOperation=/** @class */function(){function DelayedOperation(asyncQueue,timerId,targetTimeMs,op,removalCallback){this.asyncQueue=asyncQueue;this.timerId=timerId;this.targetTimeMs=targetTimeMs;this.op=op;this.removalCallback=removalCallback;this.deferred=new Deferred();this.then=this.deferred.promise.then.bind(this.deferred.promise);this.catch=this.deferred.promise.catch.bind(this.deferred.promise);// It's normal for the deferred promise to be canceled (due to cancellation)
// and so we attach a dummy catch callback to avoid
// 'UnhandledPromiseRejectionWarning' log spam.
this.deferred.promise.catch(function(err){});}/**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue The queue to schedule the operation on.
     * @param id A Timer ID identifying the type of operation this is.
     * @param delayMs The delay (ms) before the operation should be scheduled.
     * @param op The operation to run.
     * @param removalCallback A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */DelayedOperation.createAndSchedule=function(asyncQueue,timerId,delayMs,op,removalCallback){var targetTime=Date.now()+delayMs;var delayedOp=new DelayedOperation(asyncQueue,timerId,targetTime,op,removalCallback);delayedOp.start(delayMs);return delayedOp;};/**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */DelayedOperation.prototype.start=function(delayMs){var _this=this;this.timerHandle=setTimeout(function(){return _this.handleDelayElapsed();},delayMs);};/**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */DelayedOperation.prototype.skipDelay=function(){return this.handleDelayElapsed();};/**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */DelayedOperation.prototype.cancel=function(reason){if(this.timerHandle!==null){this.clearTimeout();this.deferred.reject(new FirestoreError(Code.CANCELLED,'Operation cancelled'+(reason?': '+reason:'')));}};DelayedOperation.prototype.handleDelayElapsed=function(){var _this=this;this.asyncQueue.enqueueAndForget(function(){if(_this.timerHandle!==null){_this.clearTimeout();return _this.op().then(function(result){return _this.deferred.resolve(result);});}else{return Promise.resolve();}});};DelayedOperation.prototype.clearTimeout=function(){if(this.timerHandle!==null){this.removalCallback(this);clearTimeout(this.timerHandle);this.timerHandle=null;}};return DelayedOperation;}();var AsyncQueue=/** @class */function(){function AsyncQueue(){// The last promise in the queue.
this.tail=Promise.resolve();// Operations scheduled to be queued in the future. Operations are
// automatically removed after they are run or canceled.
this.delayedOperations=[];// Flag set while there's an outstanding AsyncQueue operation, used for
// assertion sanity-checks.
this.operationInProgress=false;}/**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */AsyncQueue.prototype.enqueueAndForget=function(op){// tslint:disable-next-line:no-floating-promises
this.enqueue(op);};/**
     * Adds a new operation to the queue. Returns a promise that will be resolved
     * when the promise returned by the new operation is (with its value).
     */AsyncQueue.prototype.enqueue=function(op){var _this=this;this.verifyNotFailed();var newTail=this.tail.then(function(){_this.operationInProgress=true;return op().catch(function(error$1){_this.failure=error$1;_this.operationInProgress=false;var message=error$1.stack||error$1.message||'';error('INTERNAL UNHANDLED ERROR: ',message);// Escape the promise chain and throw the error globally so that
// e.g. any global crash reporting library detects and reports it.
// (but not for simulated errors in our tests since this breaks mocha)
if(message.indexOf('Firestore Test Simulated Error')<0){setTimeout(function(){throw error$1;},0);}// Re-throw the error so that this.tail becomes a rejected Promise and
// all further attempts to chain (via .then) will just short-circuit
// and return the rejected Promise.
throw error$1;}).then(function(result){_this.operationInProgress=false;return result;});});this.tail=newTail;return newTail;};/**
     * Schedules an operation to be queued on the AsyncQueue once the specified
     * `delayMs` has elapsed. The returned CancelablePromise can be used to cancel
     * the operation prior to its running.
     */AsyncQueue.prototype.enqueueAfterDelay=function(timerId,delayMs,op){var _this=this;this.verifyNotFailed();assert(delayMs>=0,"Attempted to schedule an operation with a negative delay of "+delayMs);// While not necessarily harmful, we currently don't expect to have multiple
// ops with the same timer id in the queue, so defensively reject them.
assert(!this.containsDelayedOperation(timerId),"Attempted to schedule multiple operations with timer id "+timerId+".");var delayedOp=DelayedOperation.createAndSchedule(this,timerId,delayMs,op,function(op){return _this.removeDelayedOperation(op);});this.delayedOperations.push(delayedOp);return delayedOp;};AsyncQueue.prototype.verifyNotFailed=function(){if(this.failure){fail('AsyncQueue is already failed: '+(this.failure.stack||this.failure.message));}};/**
     * Verifies there's an operation currently in-progress on the AsyncQueue.
     * Unfortunately we can't verify that the running code is in the promise chain
     * of that operation, so this isn't a foolproof check, but it should be enough
     * to catch some bugs.
     */AsyncQueue.prototype.verifyOperationInProgress=function(){assert(this.operationInProgress,'verifyOpInProgress() called when no op in progress on this queue.');};/**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */AsyncQueue.prototype.drain=function(){return this.enqueue(function(){return Promise.resolve();});};/**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */AsyncQueue.prototype.containsDelayedOperation=function(timerId){for(var _i=0,_a=this.delayedOperations;_i<_a.length;_i++){var op=_a[_i];if(op.timerId===timerId){return true;}}return false;};/**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId Delayed operations up to and including this TimerId will
     *  be drained. Throws if no such operation exists. Pass TimerId.All to run
     *  all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */AsyncQueue.prototype.runDelayedOperationsEarly=function(lastTimerId){var _this=this;// Note that draining may generate more delayed ops, so we do that first.
return this.drain().then(function(){assert(lastTimerId===TimerId.All||_this.containsDelayedOperation(lastTimerId),"Attempted to drain to missing operation "+lastTimerId);// Run ops in the same order they'd run if they ran naturally.
_this.delayedOperations.sort(function(a,b){return a.targetTimeMs-b.targetTimeMs;});for(var _i=0,_a=_this.delayedOperations;_i<_a.length;_i++){var op=_a[_i];op.skipDelay();if(lastTimerId!==TimerId.All&&op.timerId===lastTimerId){break;}}return _this.drain();});};/** Called once a DelayedOperation is run or canceled. */AsyncQueue.prototype.removeDelayedOperation=function(op){// NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
var index=this.delayedOperations.indexOf(op);assert(index>=0,'Delayed operation not found.');this.delayedOperations.splice(index,1);};return AsyncQueue;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var escapeChar='\x01';var encodedSeparatorChar='\x01';var encodedNul='\x10';var encodedEscape='\x11';/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */function encode(path){var result='';for(var i=0;i<path.length;i++){if(result.length>0){result=encodeSeparator(result);}result=encodeSegment(path.get(i),result);}return encodeSeparator(result);}/** Encodes a single segment of a resource path into the given result */function encodeSegment(segment,resultBuf){var result=resultBuf;var length=segment.length;for(var i=0;i<length;i++){var c=segment.charAt(i);switch(c){case'\0':result+=escapeChar+encodedNul;break;case escapeChar:result+=escapeChar+encodedEscape;break;default:result+=c;}}return result;}/** Encodes a path separator into the given result */function encodeSeparator(result){return result+escapeChar+encodedSeparatorChar;}/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */function decode(path){// Event the empty path must encode as a path of at least length 2. A path
// with exactly 2 must be the empty path.
var length=path.length;assert(length>=2,'Invalid path '+path);if(length===2){assert(path.charAt(0)===escapeChar&&path.charAt(1)===encodedSeparatorChar,'Non-empty path '+path+' had length 2');return ResourcePath.EMPTY_PATH;}// Escape characters cannot exist past the second-to-last position in the
// source value.
var lastReasonableEscapeIndex=length-2;var segments=[];var segmentBuilder='';for(var start=0;start<length;){// The last two characters of a valid encoded path must be a separator, so
// there must be an end to this segment.
var end=path.indexOf(escapeChar,start);if(end<0||end>lastReasonableEscapeIndex){fail('Invalid encoded resource path: "'+path+'"');}var next=path.charAt(end+1);switch(next){case encodedSeparatorChar:var currentPiece=path.substring(start,end);var segment=void 0;if(segmentBuilder.length===0){// Avoid copying for the common case of a segment that excludes \0
// and \001
segment=currentPiece;}else{segmentBuilder+=currentPiece;segment=segmentBuilder;segmentBuilder='';}segments.push(segment);break;case encodedNul:segmentBuilder+=path.substring(start,end);segmentBuilder+='\0';break;case encodedEscape:// The escape character can be used in the output to encode itself.
segmentBuilder+=path.substring(start,end+1);break;default:fail('Invalid encoded resource path: "'+path+'"');}start=end+2;}return new ResourcePath(segments);}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var BATCHID_UNKNOWN=-1;/**
 * A batch of mutations that will be sent as one unit to the backend.
 */var MutationBatch=/** @class */function(){/**
     * @param batchId The unique ID of this mutation batch.
     * @param localWriteTime The original write time of this mutation.
     * @param baseMutations Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */function MutationBatch(batchId,localWriteTime,baseMutations,mutations){this.batchId=batchId;this.localWriteTime=localWriteTime;this.baseMutations=baseMutations;this.mutations=mutations;assert(mutations.length>0,'Cannot create an empty mutation batch');}/**
     * Applies all the mutations in this MutationBatch to the specified document
     * to create a new remote document
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     * @param batchResult The result of applying the MutationBatch to the
     * backend.
     */MutationBatch.prototype.applyToRemoteDocument=function(docKey,maybeDoc,batchResult){if(maybeDoc){assert(maybeDoc.key.isEqual(docKey),"applyToRemoteDocument: key "+docKey+" should match maybeDoc key\n        "+maybeDoc.key);}var mutationResults=batchResult.mutationResults;assert(mutationResults.length===this.mutations.length,"Mismatch between mutations length\n      ("+this.mutations.length+") and mutation results length\n      ("+mutationResults.length+").");for(var i=0;i<this.mutations.length;i++){var mutation=this.mutations[i];if(mutation.key.isEqual(docKey)){var mutationResult=mutationResults[i];maybeDoc=mutation.applyToRemoteDocument(maybeDoc,mutationResult);}}return maybeDoc;};/**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param docKey The key of the document to apply mutations to.
     * @param maybeDoc The document to apply mutations to.
     */MutationBatch.prototype.applyToLocalView=function(docKey,maybeDoc){if(maybeDoc){assert(maybeDoc.key.isEqual(docKey),"applyToLocalDocument: key "+docKey+" should match maybeDoc key\n        "+maybeDoc.key);}// First, apply the base state. This allows us to apply non-idempotent
// transform against a consistent set of values.
for(var _i=0,_a=this.baseMutations;_i<_a.length;_i++){var mutation=_a[_i];if(mutation.key.isEqual(docKey)){maybeDoc=mutation.applyToLocalView(maybeDoc,maybeDoc,this.localWriteTime);}}var baseDoc=maybeDoc;// Second, apply all user-provided mutations.
for(var _b=0,_c=this.mutations;_b<_c.length;_b++){var mutation=_c[_b];if(mutation.key.isEqual(docKey)){maybeDoc=mutation.applyToLocalView(maybeDoc,baseDoc,this.localWriteTime);}}return maybeDoc;};/**
     * Computes the local view for all provided documents given the mutations in
     * this batch.
     */MutationBatch.prototype.applyToLocalDocumentSet=function(maybeDocs){var _this=this;// TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
// directly (as done in `applyToLocalView()`), we can reduce the complexity
// to O(n).
var mutatedDocuments=maybeDocs;this.mutations.forEach(function(m){var mutatedDocument=_this.applyToLocalView(m.key,maybeDocs.get(m.key));if(mutatedDocument){mutatedDocuments=mutatedDocuments.insert(m.key,mutatedDocument);}});return mutatedDocuments;};MutationBatch.prototype.keys=function(){return this.mutations.reduce(function(keys,m){return keys.add(m.key);},documentKeySet());};MutationBatch.prototype.isEqual=function(other){return this.batchId===other.batchId&&arrayEquals(this.mutations,other.mutations)&&arrayEquals(this.baseMutations,other.baseMutations);};return MutationBatch;}();/** The result of applying a mutation batch to the backend. */var MutationBatchResult=/** @class */function(){function MutationBatchResult(batch,commitVersion,mutationResults,streamToken,/**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */docVersions){this.batch=batch;this.commitVersion=commitVersion;this.mutationResults=mutationResults;this.streamToken=streamToken;this.docVersions=docVersions;}/**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=>version mapping (docVersions).
     */MutationBatchResult.from=function(batch,commitVersion,results,streamToken){assert(batch.mutations.length===results.length,'Mutations sent '+batch.mutations.length+' must equal results received '+results.length);var versionMap=documentVersionMap();var mutations=batch.mutations;for(var i=0;i<mutations.length;i++){versionMap=versionMap.insert(mutations[i].key,results[i].version);}return new MutationBatchResult(batch,commitVersion,results,streamToken,versionMap);};return MutationBatchResult;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * PersistencePromise<> is essentially a re-implementation of Promise<> except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise<> implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */var PersistencePromise=/** @class */function(){function PersistencePromise(callback){var _this=this;// NOTE: next/catchCallback will always point to our own wrapper functions,
// not the user's raw next() or catch() callbacks.
// tslint:disable-next-line:no-any Accept any result type for the next call in the Promise chain.
this.nextCallback=null;// tslint:disable-next-line:no-any Accept any result type for the error handler.
this.catchCallback=null;// When the operation resolves, we'll set result or error and mark isDone.
this.result=undefined;this.error=undefined;this.isDone=false;// Set to true when .then() or .catch() are called and prevents additional
// chaining.
this.callbackAttached=false;callback(function(value){_this.isDone=true;_this.result=value;if(_this.nextCallback){// value should be defined unless T is Void, but we can't express
// that in the type system.
_this.nextCallback(value);}},function(error){_this.isDone=true;_this.error=error;if(_this.catchCallback){_this.catchCallback(error);}});}PersistencePromise.prototype.catch=function(fn){return this.next(undefined,fn);};PersistencePromise.prototype.next=function(nextFn,catchFn){var _this=this;if(this.callbackAttached){fail('Called next() or catch() twice for PersistencePromise');}this.callbackAttached=true;if(this.isDone){if(!this.error){return this.wrapSuccess(nextFn,this.result);}else{return this.wrapFailure(catchFn,this.error);}}else{return new PersistencePromise(function(resolve,reject){_this.nextCallback=function(value){_this.wrapSuccess(nextFn,value).next(resolve,reject);};_this.catchCallback=function(error){_this.wrapFailure(catchFn,error).next(resolve,reject);};});}};PersistencePromise.prototype.toPromise=function(){var _this=this;return new Promise(function(resolve,reject){_this.next(resolve,reject);});};PersistencePromise.prototype.wrapUserFunction=function(fn){try{var result=fn();if(result instanceof PersistencePromise){return result;}else{return PersistencePromise.resolve(result);}}catch(e){return PersistencePromise.reject(e);}};PersistencePromise.prototype.wrapSuccess=function(nextFn,value){if(nextFn){return this.wrapUserFunction(function(){return nextFn(value);});}else{// If there's no nextFn, then R must be the same as T but we
// can't express that in the type system.
// tslint:disable-next-line:no-any
return PersistencePromise.resolve(value);}};PersistencePromise.prototype.wrapFailure=function(catchFn,error){if(catchFn){return this.wrapUserFunction(function(){return catchFn(error);});}else{return PersistencePromise.reject(error);}};PersistencePromise.resolve=function(result){return new PersistencePromise(function(resolve,reject){resolve(result);});};PersistencePromise.reject=function(error){return new PersistencePromise(function(resolve,reject){reject(error);});};PersistencePromise.waitFor=function(// tslint:disable-next-line:no-any Accept all Promise types in waitFor().
all){return new PersistencePromise(function(resolve,reject){var expectedCount=0;var resolvedCount=0;var done=false;all.forEach(function(element){++expectedCount;element.next(function(){++resolvedCount;if(done&&resolvedCount===expectedCount){resolve();}},function(err){return reject(err);});});done=true;if(resolvedCount===expectedCount){resolve();}});};/**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */PersistencePromise.or=function(predicates){var p=PersistencePromise.resolve(false);var _loop_1=function _loop_1(predicate){p=p.next(function(isTrue){if(isTrue){return PersistencePromise.resolve(isTrue);}else{return predicate();}});};for(var _i=0,predicates_1=predicates;_i<predicates_1.length;_i++){var predicate=predicates_1[_i];_loop_1(predicate);}return p;};/**
     * Given an iterable, call the given function on each element in the
     * collection and wait for all of the resulting concurrent PersistencePromises
     * to resolve.
     */PersistencePromise.forEach=function(collection,f){var _this=this;var promises=[];collection.forEach(function(r,s){promises.push(f.call(_this,r,s));});return this.waitFor(promises);};return PersistencePromise;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//** A mutation queue for a specific user, backed by IndexedDB. */var IndexedDbMutationQueue=/** @class */function(){function IndexedDbMutationQueue(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */userId,serializer,indexManager,referenceDelegate){this.userId=userId;this.serializer=serializer;this.indexManager=indexManager;this.referenceDelegate=referenceDelegate;/**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */// PORTING NOTE: Multi-tab only.
this.documentKeysByBatchId={};}/**
     * Creates a new mutation queue for the given user.
     * @param user The user for which to create a mutation queue.
     * @param serializer The serializer to use when persisting to IndexedDb.
     */IndexedDbMutationQueue.forUser=function(user,serializer,indexManager,referenceDelegate){// TODO(mcg): Figure out what constraints there are on userIDs
// In particular, are there any reserved characters? are empty ids allowed?
// For the moment store these together in the same mutations table assuming
// that empty userIDs aren't allowed.
assert(user.uid!=='','UserID must not be an empty string.');var userId=user.isAuthenticated()?user.uid:'';return new IndexedDbMutationQueue(userId,serializer,indexManager,referenceDelegate);};IndexedDbMutationQueue.prototype.checkEmpty=function(transaction){var empty=true;var range=IDBKeyRange.bound([this.userId,Number.NEGATIVE_INFINITY],[this.userId,Number.POSITIVE_INFINITY]);return mutationsStore(transaction).iterate({index:DbMutationBatch.userMutationsIndex,range:range},function(key,value,control){empty=false;control.done();}).next(function(){return empty;});};IndexedDbMutationQueue.prototype.acknowledgeBatch=function(transaction,batch,streamToken){return this.getMutationQueueMetadata(transaction).next(function(metadata){metadata.lastStreamToken=convertStreamToken(streamToken);return mutationQueuesStore(transaction).put(metadata);});};IndexedDbMutationQueue.prototype.getLastStreamToken=function(transaction){return this.getMutationQueueMetadata(transaction).next(function(metadata){return metadata.lastStreamToken;});};IndexedDbMutationQueue.prototype.setLastStreamToken=function(transaction,streamToken){return this.getMutationQueueMetadata(transaction).next(function(metadata){metadata.lastStreamToken=convertStreamToken(streamToken);return mutationQueuesStore(transaction).put(metadata);});};IndexedDbMutationQueue.prototype.addMutationBatch=function(transaction,localWriteTime,baseMutations,mutations){var _this=this;var documentStore=documentMutationsStore(transaction);var mutationStore=mutationsStore(transaction);// The IndexedDb implementation in Chrome (and Firefox) does not handle
// compound indices that include auto-generated keys correctly. To ensure
// that the index entry is added correctly in all browsers, we perform two
// writes: The first write is used to retrieve the next auto-generated Batch
// ID, and the second write populates the index and stores the actual
// mutation batch.
// See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
// tslint:disable-next-line:no-any We write an empty object to obtain key
return mutationStore.add({}).next(function(batchId){assert(typeof batchId==='number','Auto-generated key is not a number');var batch=new MutationBatch(batchId,localWriteTime,baseMutations,mutations);var dbBatch=_this.serializer.toDbMutationBatch(_this.userId,batch);_this.documentKeysByBatchId[batchId]=batch.keys();var promises=[];for(var _i=0,mutations_1=mutations;_i<mutations_1.length;_i++){var mutation=mutations_1[_i];var indexKey=DbDocumentMutation.key(_this.userId,mutation.key.path,batchId);promises.push(mutationStore.put(dbBatch));promises.push(documentStore.put(indexKey,DbDocumentMutation.PLACEHOLDER));promises.push(_this.indexManager.addToCollectionParentIndex(transaction,mutation.key.path.popLast()));}return PersistencePromise.waitFor(promises).next(function(){return batch;});});};IndexedDbMutationQueue.prototype.lookupMutationBatch=function(transaction,batchId){var _this=this;return mutationsStore(transaction).get(batchId).next(function(dbBatch){if(dbBatch){assert(dbBatch.userId===_this.userId,"Unexpected user '"+dbBatch.userId+"' for mutation batch "+batchId);return _this.serializer.fromDbMutationBatch(dbBatch);}return null;});};IndexedDbMutationQueue.prototype.lookupMutationKeys=function(transaction,batchId){var _this=this;if(this.documentKeysByBatchId[batchId]){return PersistencePromise.resolve(this.documentKeysByBatchId[batchId]);}else{return this.lookupMutationBatch(transaction,batchId).next(function(batch){if(batch){var keys=batch.keys();_this.documentKeysByBatchId[batchId]=keys;return keys;}else{return null;}});}};IndexedDbMutationQueue.prototype.getNextMutationBatchAfterBatchId=function(transaction,batchId){var _this=this;return this.getMutationQueueMetadata(transaction).next(function(metadata){var nextBatchId=batchId+1;var range=IDBKeyRange.lowerBound([_this.userId,nextBatchId]);var foundBatch=null;return mutationsStore(transaction).iterate({index:DbMutationBatch.userMutationsIndex,range:range},function(key,dbBatch,control){if(dbBatch.userId===_this.userId){assert(dbBatch.batchId>=nextBatchId,'Should have found mutation after '+nextBatchId);foundBatch=_this.serializer.fromDbMutationBatch(dbBatch);}control.done();}).next(function(){return foundBatch;});});};IndexedDbMutationQueue.prototype.getAllMutationBatches=function(transaction){var _this=this;var range=IDBKeyRange.bound([this.userId,BATCHID_UNKNOWN],[this.userId,Number.POSITIVE_INFINITY]);return mutationsStore(transaction).loadAll(DbMutationBatch.userMutationsIndex,range).next(function(dbBatches){return dbBatches.map(function(dbBatch){return _this.serializer.fromDbMutationBatch(dbBatch);});});};IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey=function(transaction,documentKey){var _this=this;// Scan the document-mutation index starting with a prefix starting with
// the given documentKey.
var indexPrefix=DbDocumentMutation.prefixForPath(this.userId,documentKey.path);var indexStart=IDBKeyRange.lowerBound(indexPrefix);var results=[];return documentMutationsStore(transaction).iterate({range:indexStart},function(indexKey,_,control){var userID=indexKey[0],encodedPath=indexKey[1],batchId=indexKey[2];// Only consider rows matching exactly the specific key of
// interest. Note that because we order by path first, and we
// order terminators before path separators, we'll encounter all
// the index rows for documentKey contiguously. In particular, all
// the rows for documentKey will occur before any rows for
// documents nested in a subcollection beneath documentKey so we
// can stop as soon as we hit any such row.
var path=decode(encodedPath);if(userID!==_this.userId||!documentKey.path.isEqual(path)){control.done();return;}// Look up the mutation batch in the store.
return mutationsStore(transaction).get(batchId).next(function(mutation){if(!mutation){throw fail('Dangling document-mutation reference found: '+indexKey+' which points to '+batchId);}assert(mutation.userId===_this.userId,"Unexpected user '"+mutation.userId+"' for mutation batch "+batchId);results.push(_this.serializer.fromDbMutationBatch(mutation));});}).next(function(){return results;});};IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys=function(transaction,documentKeys){var _this=this;var uniqueBatchIDs=new SortedSet(primitiveComparator);var promises=[];documentKeys.forEach(function(documentKey){var indexStart=DbDocumentMutation.prefixForPath(_this.userId,documentKey.path);var range=IDBKeyRange.lowerBound(indexStart);var promise=documentMutationsStore(transaction).iterate({range:range},function(indexKey,_,control){var userID=indexKey[0],encodedPath=indexKey[1],batchID=indexKey[2];// Only consider rows matching exactly the specific key of
// interest. Note that because we order by path first, and we
// order terminators before path separators, we'll encounter all
// the index rows for documentKey contiguously. In particular, all
// the rows for documentKey will occur before any rows for
// documents nested in a subcollection beneath documentKey so we
// can stop as soon as we hit any such row.
var path=decode(encodedPath);if(userID!==_this.userId||!documentKey.path.isEqual(path)){control.done();return;}uniqueBatchIDs=uniqueBatchIDs.add(batchID);});promises.push(promise);});return PersistencePromise.waitFor(promises).next(function(){return _this.lookupMutationBatches(transaction,uniqueBatchIDs);});};IndexedDbMutationQueue.prototype.getAllMutationBatchesAffectingQuery=function(transaction,query){var _this=this;assert(!query.isDocumentQuery(),"Document queries shouldn't go down this path");assert(!query.isCollectionGroupQuery(),'CollectionGroup queries should be handled in LocalDocumentsView');var queryPath=query.path;var immediateChildrenLength=queryPath.length+1;// TODO(mcg): Actually implement a single-collection query
//
// This is actually executing an ancestor query, traversing the whole
// subtree below the collection which can be horrifically inefficient for
// some structures. The right way to solve this is to implement the full
// value index, but that's not in the cards in the near future so this is
// the best we can do for the moment.
//
// Since we don't yet index the actual properties in the mutations, our
// current approach is to just return all mutation batches that affect
// documents in the collection being queried.
var indexPrefix=DbDocumentMutation.prefixForPath(this.userId,queryPath);var indexStart=IDBKeyRange.lowerBound(indexPrefix);// Collect up unique batchIDs encountered during a scan of the index. Use a
// SortedSet to accumulate batch IDs so they can be traversed in order in a
// scan of the main table.
var uniqueBatchIDs=new SortedSet(primitiveComparator);return documentMutationsStore(transaction).iterate({range:indexStart},function(indexKey,_,control){var userID=indexKey[0],encodedPath=indexKey[1],batchID=indexKey[2];var path=decode(encodedPath);if(userID!==_this.userId||!queryPath.isPrefixOf(path)){control.done();return;}// Rows with document keys more than one segment longer than the
// query path can't be matches. For example, a query on 'rooms'
// can't match the document /rooms/abc/messages/xyx.
// TODO(mcg): we'll need a different scanner when we implement
// ancestor queries.
if(path.length!==immediateChildrenLength){return;}uniqueBatchIDs=uniqueBatchIDs.add(batchID);}).next(function(){return _this.lookupMutationBatches(transaction,uniqueBatchIDs);});};IndexedDbMutationQueue.prototype.lookupMutationBatches=function(transaction,batchIDs){var _this=this;var results=[];var promises=[];// TODO(rockwood): Implement this using iterate.
batchIDs.forEach(function(batchId){promises.push(mutationsStore(transaction).get(batchId).next(function(mutation){if(mutation===null){throw fail('Dangling document-mutation reference found, '+'which points to '+batchId);}assert(mutation.userId===_this.userId,"Unexpected user '"+mutation.userId+"' for mutation batch "+batchId);results.push(_this.serializer.fromDbMutationBatch(mutation));}));});return PersistencePromise.waitFor(promises).next(function(){return results;});};IndexedDbMutationQueue.prototype.removeMutationBatch=function(transaction,batch){var _this=this;return removeMutationBatch(transaction.simpleDbTransaction,this.userId,batch).next(function(removedDocuments){_this.removeCachedMutationKeys(batch.batchId);return PersistencePromise.forEach(removedDocuments,function(key){return _this.referenceDelegate.removeMutationReference(transaction,key);});});};IndexedDbMutationQueue.prototype.removeCachedMutationKeys=function(batchId){delete this.documentKeysByBatchId[batchId];};IndexedDbMutationQueue.prototype.performConsistencyCheck=function(txn){var _this=this;return this.checkEmpty(txn).next(function(empty){if(!empty){return PersistencePromise.resolve();}// Verify that there are no entries in the documentMutations index if
// the queue is empty.
var startRange=IDBKeyRange.lowerBound(DbDocumentMutation.prefixForUser(_this.userId));var danglingMutationReferences=[];return documentMutationsStore(txn).iterate({range:startRange},function(key,_,control){var userID=key[0];if(userID!==_this.userId){control.done();return;}else{var path=decode(key[1]);danglingMutationReferences.push(path);}}).next(function(){assert(danglingMutationReferences.length===0,'Document leak -- detected dangling mutation references when queue is empty. '+'Dangling keys: '+danglingMutationReferences.map(function(p){return p.canonicalString();}));});});};IndexedDbMutationQueue.prototype.containsKey=function(txn,key){return mutationQueueContainsKey(txn,this.userId,key);};// PORTING NOTE: Multi-tab only (state is held in memory in other clients).
/** Returns the mutation queue's metadata from IndexedDb. */IndexedDbMutationQueue.prototype.getMutationQueueMetadata=function(transaction){var _this=this;return mutationQueuesStore(transaction).get(this.userId).next(function(metadata){return metadata||new DbMutationQueue(_this.userId,BATCHID_UNKNOWN,/*lastStreamToken=*/'');});};return IndexedDbMutationQueue;}();/**
 * @return true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */function mutationQueueContainsKey(txn,userId,key){var indexKey=DbDocumentMutation.prefixForPath(userId,key.path);var encodedPath=indexKey[1];var startRange=IDBKeyRange.lowerBound(indexKey);var containsKey=false;return documentMutationsStore(txn).iterate({range:startRange,keysOnly:true},function(key,value,control){var userID=key[0],keyPath=key[1],/*batchID*/_=key[2];if(userID===userId&&keyPath===encodedPath){containsKey=true;}control.done();}).next(function(){return containsKey;});}/** Returns true if any mutation queue contains the given document. */function mutationQueuesContainKey(txn,docKey){var found=false;return mutationQueuesStore(txn).iterateSerial(function(userId){return mutationQueueContainsKey(txn,userId,docKey).next(function(containsKey){if(containsKey){found=true;}return PersistencePromise.resolve(!containsKey);});}).next(function(){return found;});}/**
 * Delete a mutation batch and the associated document mutations.
 * @return A PersistencePromise of the document mutations that were removed.
 */function removeMutationBatch(txn,userId,batch){var mutationStore=txn.store(DbMutationBatch.store);var indexTxn=txn.store(DbDocumentMutation.store);var promises=[];var range=IDBKeyRange.only(batch.batchId);var numDeleted=0;var removePromise=mutationStore.iterate({range:range},function(key,value,control){numDeleted++;return control.delete();});promises.push(removePromise.next(function(){assert(numDeleted===1,'Dangling document-mutation reference found: Missing batch '+batch.batchId);}));var removedDocuments=[];for(var _i=0,_a=batch.mutations;_i<_a.length;_i++){var mutation=_a[_i];var indexKey=DbDocumentMutation.key(userId,mutation.key.path,batch.batchId);promises.push(indexTxn.delete(indexKey));removedDocuments.push(mutation.key);}return PersistencePromise.waitFor(promises).next(function(){return removedDocuments;});}function convertStreamToken(token){if(token instanceof Uint8Array){// TODO(b/78771403): Convert tokens to strings during deserialization
assert(process.env.USE_MOCK_PERSISTENCE==='YES','Persisting non-string stream tokens is only supported with mock persistence.');return token.toString();}else{return token;}}/**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */function mutationsStore(txn){return IndexedDbPersistence.getStore(txn,DbMutationBatch.store);}/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */function documentMutationsStore(txn){return IndexedDbPersistence.getStore(txn,DbDocumentMutation.store);}/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */function mutationQueuesStore(txn){return IndexedDbPersistence.getStore(txn,DbMutationQueue.store);}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var RESERVED_BITS=1;var GeneratorIds;(function(GeneratorIds){GeneratorIds[GeneratorIds["QueryCache"]=0]="QueryCache";GeneratorIds[GeneratorIds["SyncEngine"]=1]="SyncEngine";// The target IDs for limbo detection are odd (end in 1).
})(GeneratorIds||(GeneratorIds={}));/**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the query cache (via
 * forQueryCache()), and one for limbo documents (via forSyncEngine()). These
 * two generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */// TODO(mrschmidt): Explore removing this class in favor of generating these IDs
// directly in SyncEngine and LocalStore.
var TargetIdGenerator=/** @class */function(){/**
     * Instantiates a new TargetIdGenerator. If a seed is provided, the generator
     * will use the seed value as the next target ID.
     */function TargetIdGenerator(generatorId,seed){this.generatorId=generatorId;assert((generatorId&RESERVED_BITS)===generatorId,"Generator ID "+generatorId+" contains more than "+RESERVED_BITS+" reserved bits");this.seek(seed!==undefined?seed:this.generatorId);}TargetIdGenerator.prototype.next=function(){var nextId=this.nextId;this.nextId+=1<<RESERVED_BITS;return nextId;};/**
     * Returns the ID that follows the given ID. Subsequent calls to `next()`
     * use the newly returned target ID as their base.
     */// PORTING NOTE: Multi-tab only.
TargetIdGenerator.prototype.after=function(targetId){this.seek(targetId+(1<<RESERVED_BITS));return this.next();};TargetIdGenerator.prototype.seek=function(targetId){assert((targetId&RESERVED_BITS)===this.generatorId,'Cannot supply target ID from different generator ID');this.nextId=targetId;};TargetIdGenerator.forQueryCache=function(){// We seed the query cache generator to return '2' as its first ID, as there
// is no differentiation in the protocol layer between an unset number and
// the number '0'. If we were to sent a target with target ID '0', the
// backend would consider it unset and replace it with its own ID.
var targetIdGenerator=new TargetIdGenerator(GeneratorIds.QueryCache,2);return targetIdGenerator;};TargetIdGenerator.forSyncEngine=function(){// Sync engine assigns target IDs for limbo document detection.
return new TargetIdGenerator(GeneratorIds.SyncEngine);};return TargetIdGenerator;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$1='SimpleDb';/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */var SimpleDb=/** @class */function(){function SimpleDb(db){this.db=db;}/**
     * Opens the specified database, creating or upgrading it if necessary.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
     * mechanism, as only version-upgrade transactions are allowed to do things like create
     * objectstores.
     */SimpleDb.openOrCreate=function(name,version,schemaConverter){assert(SimpleDb.isAvailable(),'IndexedDB not supported in current environment.');debug(LOG_TAG$1,'Opening database:',name);return new PersistencePromise(function(resolve,reject){// TODO(mikelehen): Investigate browser compatibility.
// https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
// suggests IE9 and older WebKit browsers handle upgrade
// differently. They expect setVersion, as described here:
// https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
var request=window.indexedDB.open(name,version);request.onsuccess=function(event){var db=event.target.result;resolve(new SimpleDb(db));};request.onblocked=function(){reject(new FirestoreError(Code.FAILED_PRECONDITION,'Cannot upgrade IndexedDB schema while another tab is open. '+'Close all tabs that access Firestore and reload this page to proceed.'));};request.onerror=function(event){var error=event.target.error;if(error.name==='VersionError'){reject(new FirestoreError(Code.FAILED_PRECONDITION,'A newer version of the Firestore SDK was previously used and so the persisted '+'data is not compatible with the version of the SDK you are now using. The SDK '+'will operate with persistence disabled. If you need persistence, please '+'re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB '+'data for your app to start fresh.'));}else{reject(error);}};request.onupgradeneeded=function(event){debug(LOG_TAG$1,'Database "'+name+'" requires upgrade from version:',event.oldVersion);var db=event.target.result;// We are provided a version upgrade transaction from the request, so
// we wrap that in a SimpleDbTransaction to allow use of our friendlier
// API for schema migration operations.
var txn=new SimpleDbTransaction(request.transaction);schemaConverter.createOrUpgrade(db,txn,event.oldVersion,SCHEMA_VERSION).next(function(){debug(LOG_TAG$1,'Database upgrade to version '+SCHEMA_VERSION+' complete');});};}).toPromise();};/** Deletes the specified database. */SimpleDb.delete=function(name){debug(LOG_TAG$1,'Removing database:',name);return wrapRequest(window.indexedDB.deleteDatabase(name)).toPromise();};/** Returns true if IndexedDB is available in the current environment. */SimpleDb.isAvailable=function(){if(typeof window==='undefined'||window.indexedDB==null){return false;}// We extensively use indexed array values and compound keys,
// which IE and Edge do not support. However, they still have indexedDB
// defined on the window, so we need to check for them here and make sure
// to return that persistence is not enabled for those browsers.
// For tracking support of this feature, see here:
// https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
// If we are running in Node using the IndexedDBShim, `window` is defined,
// but `window.navigator` is not. In this case, we support IndexedDB and
// return `true`.
if(window.navigator===undefined){return process.env.USE_MOCK_PERSISTENCE==='YES';}// Check the UA string to find out the browser.
// TODO(mikelehen): Move this logic into packages/util/environment.ts
var ua=window.navigator.userAgent;// IE 10
// ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
// IE 11
// ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
// Edge
// ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
// like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
// iOS Safari: Disable for users running iOS version < 10.
var iOSVersion=SimpleDb.getIOSVersion(ua);var isUnsupportedIOS=0<iOSVersion&&iOSVersion<10;// Android browser: Disable for userse running version < 4.5.
var androidVersion=SimpleDb.getAndroidVersion(ua);var isUnsupportedAndroid=0<androidVersion&&androidVersion<4.5;if(ua.indexOf('MSIE ')>0||ua.indexOf('Trident/')>0||ua.indexOf('Edge/')>0||isUnsupportedIOS||isUnsupportedAndroid){return false;}else{return true;}};/** Helper to get a typed SimpleDbStore from a transaction. */SimpleDb.getStore=function(txn,store){return txn.store(store);};// visible for testing
/** Parse User Agent to determine iOS version. Returns -1 if not found. */SimpleDb.getIOSVersion=function(ua){var iOSVersionRegex=ua.match(/i(?:phone|pad|pod) os ([\d_]+)/i);var version=iOSVersionRegex?iOSVersionRegex[1].split('_')[0]:'-1';return Number(version);};// visible for testing
/** Parse User Agent to determine Android version. Returns -1 if not found. */SimpleDb.getAndroidVersion=function(ua){var androidVersionRegex=ua.match(/Android ([\d.]+)/i);var version=androidVersionRegex?androidVersionRegex[1].split('.').slice(0,2).join('.'):'-1';return Number(version);};SimpleDb.prototype.setVersionChangeListener=function(versionChangeListener){this.db.onversionchange=function(event){return versionChangeListener(event);};};SimpleDb.prototype.runTransaction=function(mode,objectStores,transactionFn){var transaction=SimpleDbTransaction.open(this.db,mode,objectStores);var transactionFnResult=transactionFn(transaction).catch(function(error){// Abort the transaction if there was an error.
transaction.abort(error);// We cannot actually recover, and calling `abort()` will cause the transaction's
// completion promise to be rejected. This in turn means that we won't use
// `transactionFnResult` below. We return a rejection here so that we don't add the
// possibility of returning `void` to the type of `transactionFnResult`.
return PersistencePromise.reject(error);}).toPromise();// As noted above, errors are propagated by aborting the transaction. So
// we swallow any error here to avoid the browser logging it as unhandled.
transactionFnResult.catch(function(){});// Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
// fire), but still return the original transactionFnResult back to the
// caller.
return transaction.completionPromise.then(function(){return transactionFnResult;});};SimpleDb.prototype.close=function(){this.db.close();};return SimpleDb;}();/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */var IterationController=/** @class */function(){function IterationController(dbCursor){this.dbCursor=dbCursor;this.shouldStop=false;this.nextKey=null;}Object.defineProperty(IterationController.prototype,"isDone",{get:function get(){return this.shouldStop;},enumerable:true,configurable:true});Object.defineProperty(IterationController.prototype,"skipToKey",{get:function get(){return this.nextKey;},enumerable:true,configurable:true});Object.defineProperty(IterationController.prototype,"cursor",{set:function set(value){this.dbCursor=value;},enumerable:true,configurable:true});/**
     * This function can be called to stop iteration at any point.
     */IterationController.prototype.done=function(){this.shouldStop=true;};/**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */IterationController.prototype.skip=function(key){this.nextKey=key;};/**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */IterationController.prototype.delete=function(){return wrapRequest(this.dbCursor.delete());};return IterationController;}();/**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */var SimpleDbTransaction=/** @class */function(){function SimpleDbTransaction(transaction){var _this=this;this.transaction=transaction;this.aborted=false;/**
         * A promise that resolves with the result of the IndexedDb transaction.
         */this.completionDeferred=new Deferred();this.transaction.oncomplete=function(){_this.completionDeferred.resolve();};this.transaction.onabort=function(){if(transaction.error){_this.completionDeferred.reject(transaction.error);}else{_this.completionDeferred.resolve();}};this.transaction.onerror=function(event){_this.completionDeferred.reject(event.target.error);};}SimpleDbTransaction.open=function(db,mode,objectStoreNames){return new SimpleDbTransaction(db.transaction(objectStoreNames,mode));};Object.defineProperty(SimpleDbTransaction.prototype,"completionPromise",{get:function get(){return this.completionDeferred.promise;},enumerable:true,configurable:true});SimpleDbTransaction.prototype.abort=function(error){if(error){this.completionDeferred.reject(error);}if(!this.aborted){debug(LOG_TAG$1,'Aborting transaction:',error?error.message:'Client-initiated abort');this.aborted=true;this.transaction.abort();}};/**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */SimpleDbTransaction.prototype.store=function(storeName){var store=this.transaction.objectStore(storeName);assert(!!store,'Object store not part of transaction: '+storeName);return new SimpleDbStore(store);};return SimpleDbTransaction;}();/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */var SimpleDbStore=/** @class */function(){function SimpleDbStore(store){this.store=store;}SimpleDbStore.prototype.put=function(keyOrValue,value){var request;if(value!==undefined){debug(LOG_TAG$1,'PUT',this.store.name,keyOrValue,value);request=this.store.put(value,keyOrValue);}else{debug(LOG_TAG$1,'PUT',this.store.name,'<auto-key>',keyOrValue);request=this.store.put(keyOrValue);}return wrapRequest(request);};/**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value The object to write.
     * @return The key of the value to add.
     */SimpleDbStore.prototype.add=function(value){debug(LOG_TAG$1,'ADD',this.store.name,value,value);var request=this.store.add(value);return wrapRequest(request);};/**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @return The object with the specified key or null if no object exists.
     */SimpleDbStore.prototype.get=function(key){var _this=this;var request=this.store.get(key);// tslint:disable-next-line:no-any We're doing an unsafe cast to ValueType.
return wrapRequest(request).next(function(result){// Normalize nonexistence to null.
if(result===undefined){result=null;}debug(LOG_TAG$1,'GET',_this.store.name,key,result);return result;});};SimpleDbStore.prototype.delete=function(key){debug(LOG_TAG$1,'DELETE',this.store.name,key);var request=this.store.delete(key);return wrapRequest(request);};/**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */SimpleDbStore.prototype.count=function(){debug(LOG_TAG$1,'COUNT',this.store.name);var request=this.store.count();return wrapRequest(request);};SimpleDbStore.prototype.loadAll=function(indexOrRange,range){var cursor=this.cursor(this.options(indexOrRange,range));var results=[];return this.iterateCursor(cursor,function(key,value){results.push(value);}).next(function(){return results;});};SimpleDbStore.prototype.deleteAll=function(indexOrRange,range){debug(LOG_TAG$1,'DELETE ALL',this.store.name);var options=this.options(indexOrRange,range);options.keysOnly=false;var cursor=this.cursor(options);return this.iterateCursor(cursor,function(key,value,control){// NOTE: Calling delete() on a cursor is documented as more efficient than
// calling delete() on an object store with a single key
// (https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/delete),
// however, this requires us *not* to use a keysOnly cursor
// (https://developer.mozilla.org/en-US/docs/Web/API/IDBCursor/delete). We
// may want to compare the performance of each method.
return control.delete();});};SimpleDbStore.prototype.iterate=function(optionsOrCallback,callback){var options;if(!callback){options={};callback=optionsOrCallback;}else{options=optionsOrCallback;}var cursor=this.cursor(options);return this.iterateCursor(cursor,callback);};/**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */SimpleDbStore.prototype.iterateSerial=function(callback){var cursorRequest=this.cursor({});return new PersistencePromise(function(resolve,reject){cursorRequest.onerror=function(event){reject(event.target.error);};cursorRequest.onsuccess=function(event){var cursor=event.target.result;if(!cursor){resolve();return;}callback(cursor.primaryKey,cursor.value).next(function(shouldContinue){if(shouldContinue){cursor.continue();}else{resolve();}});};});};SimpleDbStore.prototype.iterateCursor=function(cursorRequest,fn){var results=[];return new PersistencePromise(function(resolve,reject){cursorRequest.onerror=function(event){reject(event.target.error);};cursorRequest.onsuccess=function(event){var cursor=event.target.result;if(!cursor){resolve();return;}var controller=new IterationController(cursor);var userResult=fn(cursor.primaryKey,cursor.value,controller);if(userResult instanceof PersistencePromise){var userPromise=userResult.catch(function(err){controller.done();return PersistencePromise.reject(err);});results.push(userPromise);}if(controller.isDone){resolve();}else if(controller.skipToKey===null){cursor.continue();}else{cursor.continue(controller.skipToKey);}};}).next(function(){return PersistencePromise.waitFor(results);});};SimpleDbStore.prototype.options=function(indexOrRange,range){var indexName=undefined;if(indexOrRange!==undefined){if(typeof indexOrRange==='string'){indexName=indexOrRange;}else{assert(range===undefined,'3rd argument must not be defined if 2nd is a range.');range=indexOrRange;}}return{index:indexName,range:range};};SimpleDbStore.prototype.cursor=function(options){var direction='next';if(options.reverse){direction='prev';}if(options.index){var index=this.store.index(options.index);if(options.keysOnly){return index.openKeyCursor(options.range,direction);}else{return index.openCursor(options.range,direction);}}else{return this.store.openCursor(options.range,direction);}};return SimpleDbStore;}();/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */function wrapRequest(request){return new PersistencePromise(function(resolve,reject){request.onsuccess=function(event){var result=event.target.result;resolve(result);};request.onerror=function(event){reject(event.target.error);};});}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var IndexedDbQueryCache=/** @class */function(){function IndexedDbQueryCache(referenceDelegate,serializer){this.referenceDelegate=referenceDelegate;this.serializer=serializer;// PORTING NOTE: We don't cache global metadata for the query cache, since
// some of it (in particular `highestTargetId`) can be modified by secondary
// tabs. We could perhaps be more granular (and e.g. still cache
// `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
// to IndexedDb whenever we need to read metadata. We can revisit if it turns
// out to have a meaningful performance impact.
this.targetIdGenerator=TargetIdGenerator.forQueryCache();}IndexedDbQueryCache.prototype.allocateTargetId=function(transaction){var _this=this;return this.retrieveMetadata(transaction).next(function(metadata){metadata.highestTargetId=_this.targetIdGenerator.after(metadata.highestTargetId);return _this.saveMetadata(transaction,metadata).next(function(){return metadata.highestTargetId;});});};IndexedDbQueryCache.prototype.getLastRemoteSnapshotVersion=function(transaction){return this.retrieveMetadata(transaction).next(function(metadata){return SnapshotVersion.fromTimestamp(new Timestamp(metadata.lastRemoteSnapshotVersion.seconds,metadata.lastRemoteSnapshotVersion.nanoseconds));});};IndexedDbQueryCache.prototype.getHighestSequenceNumber=function(transaction){return getHighestListenSequenceNumber(transaction.simpleDbTransaction);};IndexedDbQueryCache.prototype.setTargetsMetadata=function(transaction,highestListenSequenceNumber,lastRemoteSnapshotVersion){var _this=this;return this.retrieveMetadata(transaction).next(function(metadata){metadata.highestListenSequenceNumber=highestListenSequenceNumber;if(lastRemoteSnapshotVersion){metadata.lastRemoteSnapshotVersion=lastRemoteSnapshotVersion.toTimestamp();}if(highestListenSequenceNumber>metadata.highestListenSequenceNumber){metadata.highestListenSequenceNumber=highestListenSequenceNumber;}return _this.saveMetadata(transaction,metadata);});};IndexedDbQueryCache.prototype.addQueryData=function(transaction,queryData){var _this=this;return this.saveQueryData(transaction,queryData).next(function(){return _this.retrieveMetadata(transaction).next(function(metadata){metadata.targetCount+=1;_this.updateMetadataFromQueryData(queryData,metadata);return _this.saveMetadata(transaction,metadata);});});};IndexedDbQueryCache.prototype.updateQueryData=function(transaction,queryData){return this.saveQueryData(transaction,queryData);};IndexedDbQueryCache.prototype.removeQueryData=function(transaction,queryData){var _this=this;return this.removeMatchingKeysForTargetId(transaction,queryData.targetId).next(function(){return targetsStore(transaction).delete(queryData.targetId);}).next(function(){return _this.retrieveMetadata(transaction);}).next(function(metadata){assert(metadata.targetCount>0,'Removing from an empty query cache');metadata.targetCount-=1;return _this.saveMetadata(transaction,metadata);});};/**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */IndexedDbQueryCache.prototype.removeTargets=function(txn,upperBound,activeTargetIds){var _this=this;var count=0;var promises=[];return targetsStore(txn).iterate(function(key,value){var queryData=_this.serializer.fromDbTarget(value);if(queryData.sequenceNumber<=upperBound&&activeTargetIds[queryData.targetId]===undefined){count++;promises.push(_this.removeQueryData(txn,queryData));}}).next(function(){return PersistencePromise.waitFor(promises);}).next(function(){return count;});};/**
     * Call provided function with each `QueryData` that we have cached.
     */IndexedDbQueryCache.prototype.forEachTarget=function(txn,f){var _this=this;return targetsStore(txn).iterate(function(key,value){var queryData=_this.serializer.fromDbTarget(value);f(queryData);});};IndexedDbQueryCache.prototype.retrieveMetadata=function(transaction){return retrieveMetadata(transaction.simpleDbTransaction);};IndexedDbQueryCache.prototype.saveMetadata=function(transaction,metadata){return globalTargetStore(transaction).put(DbTargetGlobal.key,metadata);};IndexedDbQueryCache.prototype.saveQueryData=function(transaction,queryData){return targetsStore(transaction).put(this.serializer.toDbTarget(queryData));};/**
     * In-place updates the provided metadata to account for values in the given
     * QueryData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */IndexedDbQueryCache.prototype.updateMetadataFromQueryData=function(queryData,metadata){var updated=false;if(queryData.targetId>metadata.highestTargetId){metadata.highestTargetId=queryData.targetId;updated=true;}if(queryData.sequenceNumber>metadata.highestListenSequenceNumber){metadata.highestListenSequenceNumber=queryData.sequenceNumber;updated=true;}return updated;};IndexedDbQueryCache.prototype.getQueryCount=function(transaction){return this.retrieveMetadata(transaction).next(function(metadata){return metadata.targetCount;});};IndexedDbQueryCache.prototype.getQueryData=function(transaction,query){var _this=this;// Iterating by the canonicalId may yield more than one result because
// canonicalId values are not required to be unique per target. This query
// depends on the queryTargets index to be efficient.
var canonicalId=query.canonicalId();var range=IDBKeyRange.bound([canonicalId,Number.NEGATIVE_INFINITY],[canonicalId,Number.POSITIVE_INFINITY]);var result=null;return targetsStore(transaction).iterate({range:range,index:DbTarget.queryTargetsIndexName},function(key,value,control){var found=_this.serializer.fromDbTarget(value);// After finding a potential match, check that the query is
// actually equal to the requested query.
if(query.isEqual(found.query)){result=found;control.done();}}).next(function(){return result;});};IndexedDbQueryCache.prototype.addMatchingKeys=function(txn,keys,targetId){var _this=this;// PORTING NOTE: The reverse index (documentsTargets) is maintained by
// IndexedDb.
var promises=[];var store=documentTargetStore(txn);keys.forEach(function(key){var path=encode(key.path);promises.push(store.put(new DbTargetDocument(targetId,path)));promises.push(_this.referenceDelegate.addReference(txn,key));});return PersistencePromise.waitFor(promises);};IndexedDbQueryCache.prototype.removeMatchingKeys=function(txn,keys,targetId){var _this=this;// PORTING NOTE: The reverse index (documentsTargets) is maintained by
// IndexedDb.
var store=documentTargetStore(txn);return PersistencePromise.forEach(keys,function(key){var path=encode(key.path);return PersistencePromise.waitFor([store.delete([targetId,path]),_this.referenceDelegate.removeReference(txn,key)]);});};IndexedDbQueryCache.prototype.removeMatchingKeysForTargetId=function(txn,targetId){var store=documentTargetStore(txn);var range=IDBKeyRange.bound([targetId],[targetId+1],/*lowerOpen=*/false,/*upperOpen=*/true);return store.delete(range);};IndexedDbQueryCache.prototype.getMatchingKeysForTargetId=function(txn,targetId){var range=IDBKeyRange.bound([targetId],[targetId+1],/*lowerOpen=*/false,/*upperOpen=*/true);var store=documentTargetStore(txn);var result=documentKeySet();return store.iterate({range:range,keysOnly:true},function(key,_,control){var path=decode(key[1]);var docKey=new DocumentKey(path);result=result.add(docKey);}).next(function(){return result;});};IndexedDbQueryCache.prototype.containsKey=function(txn,key){var path=encode(key.path);var range=IDBKeyRange.bound([path],[immediateSuccessor(path)],/*lowerOpen=*/false,/*upperOpen=*/true);var count=0;return documentTargetStore(txn).iterate({index:DbTargetDocument.documentTargetsIndex,keysOnly:true,range:range},function(_a,_,control){var targetId=_a[0],path=_a[1];// Having a sentinel row for a document does not count as containing that document;
// For the query cache, containing the document means the document is part of some
// target.
if(targetId!==0){count++;control.done();}}).next(function(){return count>0;});};IndexedDbQueryCache.prototype.getQueryDataForTarget=function(transaction,targetId){var _this=this;return targetsStore(transaction).get(targetId).next(function(found){if(found){return _this.serializer.fromDbTarget(found);}else{return null;}});};return IndexedDbQueryCache;}();/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */function targetsStore(txn){return IndexedDbPersistence.getStore(txn,DbTarget.store);}/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */function globalTargetStore(txn){return IndexedDbPersistence.getStore(txn,DbTargetGlobal.store);}function retrieveMetadata(txn){var globalStore=SimpleDb.getStore(txn,DbTargetGlobal.store);return globalStore.get(DbTargetGlobal.key).next(function(metadata){assert(metadata!==null,'Missing metadata row.');return metadata;});}function getHighestListenSequenceNumber(txn){return retrieveMetadata(txn).next(function(targetGlobal){return targetGlobal.highestListenSequenceNumber;});}/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */function documentTargetStore(txn){return IndexedDbPersistence.getStore(txn,DbTargetDocument.store);}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * A map implementation that uses objects as keys. Objects must implement the
 * Equatable interface and must be immutable. Entries in the map are stored
 * together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */var ObjectMap=/** @class */function(){function ObjectMap(mapKeyFn){this.mapKeyFn=mapKeyFn;/**
         * The inner map for a key -> value pair. Due to the possibility of
         * collisions we keep a list of entries that we do a linear search through
         * to find an actual match. Note that collisions should be rare, so we still
         * expect near constant time lookups in practice.
         */this.inner={};}/** Get a value for this key, or undefined if it does not exist. */ObjectMap.prototype.get=function(key){var id=this.mapKeyFn(key);var matches=this.inner[id];if(matches===undefined){return undefined;}for(var _i=0,matches_1=matches;_i<matches_1.length;_i++){var _a=matches_1[_i],otherKey=_a[0],value=_a[1];if(otherKey.isEqual(key)){return value;}}return undefined;};ObjectMap.prototype.has=function(key){return this.get(key)!==undefined;};/** Put this key and value in the map. */ObjectMap.prototype.set=function(key,value){var id=this.mapKeyFn(key);var matches=this.inner[id];if(matches===undefined){this.inner[id]=[[key,value]];return;}for(var i=0;i<matches.length;i++){if(matches[i][0].isEqual(key)){matches[i]=[key,value];return;}}matches.push([key,value]);};/**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ObjectMap.prototype.delete=function(key){var id=this.mapKeyFn(key);var matches=this.inner[id];if(matches===undefined){return false;}for(var i=0;i<matches.length;i++){if(matches[i][0].isEqual(key)){if(matches.length===1){delete this.inner[id];}else{matches.splice(i,1);}return true;}}return false;};ObjectMap.prototype.forEach=function(fn){forEach(this.inner,function(_,entries){for(var _i=0,entries_1=entries;_i<entries_1.length;_i++){var _a=entries_1[_i],k=_a[0],v=_a[1];fn(k,v);}});};ObjectMap.prototype.isEmpty=function(){return isEmpty(this.inner);};return ObjectMap;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */var RemoteDocumentChangeBuffer=/** @class */function(){function RemoteDocumentChangeBuffer(){this.changes=maybeDocumentMap();this.documentSizes=new ObjectMap(function(key){return key.toString();});}/** Buffers a `RemoteDocumentCache.addEntry()` call. */RemoteDocumentChangeBuffer.prototype.addEntry=function(maybeDocument){var changes=this.assertChanges();this.changes=changes.insert(maybeDocument.key,maybeDocument);};// NOTE: removeEntry() is intentionally omitted. If it needs to be added in
// the future it must take byte counting into account.
/**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKey The key of the entry to look up.
     * @return The cached Document or NoDocument entry, or null if we have nothing
     * cached.
     */RemoteDocumentChangeBuffer.prototype.getEntry=function(transaction,documentKey){var _this=this;var changes=this.assertChanges();var bufferedEntry=changes.get(documentKey);if(bufferedEntry){return PersistencePromise.resolve(bufferedEntry);}else{// Record the size of everything we load from the cache so we can compute a delta later.
return this.getFromCache(transaction,documentKey).next(function(getResult){if(getResult===null){_this.documentSizes.set(documentKey,0);return null;}else{_this.documentSizes.set(documentKey,getResult.size);return getResult.maybeDocument;}});}};/**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys The keys of the entries to look up.
     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
     *     entry cannot be found, the corresponding key will be mapped to a null
     *     value.
     */RemoteDocumentChangeBuffer.prototype.getEntries=function(transaction,documentKeys){var _this=this;// Record the size of everything we load from the cache so we can compute
// a delta later.
return this.getAllFromCache(transaction,documentKeys).next(function(_a){var maybeDocuments=_a.maybeDocuments,sizeMap=_a.sizeMap;// Note: `getAllFromCache` returns two maps instead of a single map from
// keys to `DocumentSizeEntry`s. This is to allow returning the
// `NullableMaybeDocumentMap` directly, without a conversion.
sizeMap.forEach(function(documentKey,size){_this.documentSizes.set(documentKey,size);});return maybeDocuments;});};/**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */RemoteDocumentChangeBuffer.prototype.apply=function(transaction){var result=this.applyChanges(transaction);// We should not buffer any more changes.
this.changes=null;return result;};/** Helper to assert this.changes is not null and return it. */RemoteDocumentChangeBuffer.prototype.assertChanges=function(){assert(this.changes!==null,'Changes have already been applied.');return this.changes;};return RemoteDocumentChangeBuffer;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG='The remote document changelog no longer contains all changes for all '+'local query views. It may be necessary to rebuild these views.';var IndexedDbRemoteDocumentCache=/** @class */function(){/**
     * @param {LocalSerializer} serializer The document serializer.
     * @param {IndexManager} indexManager The query indexes that need to be maintained.
     * @param keepDocumentChangeLog Whether to keep a document change log in
     * IndexedDb. This change log is required for Multi-Tab synchronization, but
     * not needed in clients that don't share access to their remote document
     * cache.
     */function IndexedDbRemoteDocumentCache(serializer,indexManager,keepDocumentChangeLog){this.serializer=serializer;this.indexManager=indexManager;this.keepDocumentChangeLog=keepDocumentChangeLog;/** The last id read by `getNewDocumentChanges()`. */this._lastProcessedDocumentChangeId=0;}Object.defineProperty(IndexedDbRemoteDocumentCache.prototype,"lastProcessedDocumentChangeId",{get:function get(){return this._lastProcessedDocumentChangeId;},enumerable:true,configurable:true});/**
     * Starts up the remote document cache.
     *
     * Reads the ID of the last  document change from the documentChanges store.
     * Existing changes will not be returned as part of
     * `getNewDocumentChanges()`.
     */// PORTING NOTE: This is only used for multi-tab synchronization.
IndexedDbRemoteDocumentCache.prototype.start=function(transaction){var store=SimpleDb.getStore(transaction,DbRemoteDocumentChanges.store);return this.synchronizeLastDocumentChangeId(store);};/**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */IndexedDbRemoteDocumentCache.prototype.addEntries=function(transaction,entries,sizeDelta){var promises=[];if(entries.length>0){var documentStore=remoteDocumentsStore(transaction);var changedKeys=documentKeySet();for(var _i=0,entries_1=entries;_i<entries_1.length;_i++){var _a=entries_1[_i],key=_a.key,doc=_a.doc;promises.push(documentStore.put(dbKey(key),doc));changedKeys=changedKeys.add(key);promises.push(this.indexManager.addToCollectionParentIndex(transaction,key.path.popLast()));}if(this.keepDocumentChangeLog){promises.push(documentChangesStore(transaction).put({changes:this.serializer.toDbResourcePaths(changedKeys)}));}promises.push(this.updateSize(transaction,sizeDelta));}return PersistencePromise.waitFor(promises);};/**
     * Removes a document from the cache. Note that this method does *not* do any
     * size accounting. It is the responsibility of the caller to count the bytes removed
     * and issue a final updateSize() call after removing documents.
     *
     * @param documentKey The key of the document to remove
     * @return The size of the document that was removed.
     */IndexedDbRemoteDocumentCache.prototype.removeEntry=function(transaction,documentKey){// We don't need to keep changelog for these removals since `removeEntry` is
// only used for garbage collection.
var store=remoteDocumentsStore(transaction);var key=dbKey(documentKey);return store.get(key).next(function(document){if(document){return store.delete(key).next(function(){return dbDocumentSize(document);});}else{return PersistencePromise.resolve(0);}});};IndexedDbRemoteDocumentCache.prototype.getEntry=function(transaction,documentKey){var _this=this;return remoteDocumentsStore(transaction).get(dbKey(documentKey)).next(function(dbRemoteDoc){return dbRemoteDoc?_this.serializer.fromDbRemoteDocument(dbRemoteDoc):null;});};/**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */IndexedDbRemoteDocumentCache.prototype.getSizedEntry=function(transaction,documentKey){var _this=this;return remoteDocumentsStore(transaction).get(dbKey(documentKey)).next(function(dbRemoteDoc){return dbRemoteDoc?{maybeDocument:_this.serializer.fromDbRemoteDocument(dbRemoteDoc),size:dbDocumentSize(dbRemoteDoc)}:null;});};IndexedDbRemoteDocumentCache.prototype.getEntries=function(transaction,documentKeys){var _this=this;var results=nullableMaybeDocumentMap();return this.forEachDbEntry(transaction,documentKeys,function(key,dbRemoteDoc){if(dbRemoteDoc){results=results.insert(key,_this.serializer.fromDbRemoteDocument(dbRemoteDoc));}else{results=results.insert(key,null);}}).next(function(){return results;});};/**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */IndexedDbRemoteDocumentCache.prototype.getSizedEntries=function(transaction,documentKeys){var _this=this;var results=nullableMaybeDocumentMap();var sizeMap=new SortedMap(DocumentKey.comparator);return this.forEachDbEntry(transaction,documentKeys,function(key,dbRemoteDoc){if(dbRemoteDoc){results=results.insert(key,_this.serializer.fromDbRemoteDocument(dbRemoteDoc));sizeMap=sizeMap.insert(key,dbDocumentSize(dbRemoteDoc));}else{results=results.insert(key,null);sizeMap=sizeMap.insert(key,0);}}).next(function(){return{maybeDocuments:results,sizeMap:sizeMap};});};IndexedDbRemoteDocumentCache.prototype.forEachDbEntry=function(transaction,documentKeys,callback){if(documentKeys.isEmpty()){return PersistencePromise.resolve();}var range=IDBKeyRange.bound(documentKeys.first().path.toArray(),documentKeys.last().path.toArray());var keyIter=documentKeys.getIterator();var nextKey=keyIter.getNext();return remoteDocumentsStore(transaction).iterate({range:range},function(potentialKeyRaw,dbRemoteDoc,control){var potentialKey=DocumentKey.fromSegments(potentialKeyRaw);// Go through keys not found in cache.
while(nextKey&&DocumentKey.comparator(nextKey,potentialKey)<0){callback(nextKey,null);nextKey=keyIter.getNext();}if(nextKey&&nextKey.isEqual(potentialKey)){// Key found in cache.
callback(nextKey,dbRemoteDoc);nextKey=keyIter.hasNext()?keyIter.getNext():null;}// Skip to the next key (if there is one).
if(nextKey){control.skip(nextKey.path.toArray());}else{control.done();}}).next(function(){// The rest of the keys are not in the cache. One case where `iterate`
// above won't go through them is when the cache is empty.
while(nextKey){callback(nextKey,null);nextKey=keyIter.hasNext()?keyIter.getNext():null;}});};IndexedDbRemoteDocumentCache.prototype.getDocumentsMatchingQuery=function(transaction,query){var _this=this;assert(!query.isCollectionGroupQuery(),'CollectionGroup queries should be handled in LocalDocumentsView');var results=documentMap();var immediateChildrenPathLength=query.path.length+1;// Documents are ordered by key, so we can use a prefix scan to narrow down
// the documents we need to match the query against.
var startKey=query.path.toArray();var range=IDBKeyRange.lowerBound(startKey);return remoteDocumentsStore(transaction).iterate({range:range},function(key,dbRemoteDoc,control){// The query is actually returning any path that starts with the query
// path prefix which may include documents in subcollections. For
// example, a query on 'rooms' will return rooms/abc/messages/xyx but we
// shouldn't match it. Fix this by discarding rows with document keys
// more than one segment longer than the query path.
if(key.length!==immediateChildrenPathLength){return;}var maybeDoc=_this.serializer.fromDbRemoteDocument(dbRemoteDoc);if(!query.path.isPrefixOf(maybeDoc.key.path)){control.done();}else if(maybeDoc instanceof Document&&query.matches(maybeDoc)){results=results.insert(maybeDoc.key,maybeDoc);}}).next(function(){return results;});};IndexedDbRemoteDocumentCache.prototype.getNewDocumentChanges=function(transaction){var _this=this;assert(this.keepDocumentChangeLog,'Can only call getNewDocumentChanges() when document change log is enabled');var changedKeys=documentKeySet();var changedDocs=maybeDocumentMap();var range=IDBKeyRange.lowerBound(this._lastProcessedDocumentChangeId+1);var firstIteration=true;var changesStore=documentChangesStore(transaction);return changesStore.iterate({range:range},function(_,documentChange){if(firstIteration){firstIteration=false;// If our client was throttled for more than 30 minutes, another
// client may have garbage collected the remote document changelog.
if(_this._lastProcessedDocumentChangeId+1!==documentChange.id){// Reset the `lastProcessedDocumentChangeId` to allow further
// invocations to successfully return the changes after this
// rejection.
return _this.synchronizeLastDocumentChangeId(changesStore).next(function(){return PersistencePromise.reject(new FirestoreError(Code.DATA_LOSS,REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG));});}}changedKeys=changedKeys.unionWith(_this.serializer.fromDbResourcePaths(documentChange.changes));_this._lastProcessedDocumentChangeId=documentChange.id;}).next(function(){var documentPromises=[];changedKeys.forEach(function(key){documentPromises.push(_this.getEntry(transaction,key).next(function(maybeDocument){var doc=maybeDocument||new NoDocument(key,SnapshotVersion.forDeletedDoc());changedDocs=changedDocs.insert(key,doc);}));});return PersistencePromise.waitFor(documentPromises);}).next(function(){return changedDocs;});};/**
     * Removes all changes in the remote document changelog through `changeId`
     * (inclusive).
     */IndexedDbRemoteDocumentCache.prototype.removeDocumentChangesThroughChangeId=function(transaction,changeId){var range=IDBKeyRange.upperBound(changeId);return documentChangesStore(transaction).delete(range);};IndexedDbRemoteDocumentCache.prototype.synchronizeLastDocumentChangeId=function(documentChangesStore){var _this=this;// If there are no existing changes, we set `lastProcessedDocumentChangeId`
// to 0 since IndexedDb's auto-generated keys start at 1.
this._lastProcessedDocumentChangeId=0;return documentChangesStore.iterate({keysOnly:true,reverse:true},function(key,value,control){_this._lastProcessedDocumentChangeId=key;control.done();});};IndexedDbRemoteDocumentCache.prototype.newChangeBuffer=function(){return new IndexedDbRemoteDocumentChangeBuffer(this);};IndexedDbRemoteDocumentCache.prototype.getSize=function(txn){return this.getMetadata(txn).next(function(metadata){return metadata.byteSize;});};IndexedDbRemoteDocumentCache.prototype.getMetadata=function(txn){return documentGlobalStore(txn).get(DbRemoteDocumentGlobal.key).next(function(metadata){assert(!!metadata,'Missing document cache metadata');return metadata;});};IndexedDbRemoteDocumentCache.prototype.setMetadata=function(txn,metadata){return documentGlobalStore(txn).put(DbRemoteDocumentGlobal.key,metadata);};/**
     * Adds the given delta to the cached current size. Callers to removeEntry *must* call this
     * afterwards to update the size of the cache.
     *
     * @param sizeDelta
     */IndexedDbRemoteDocumentCache.prototype.updateSize=function(txn,sizeDelta){var _this=this;return this.getMetadata(txn).next(function(metadata){metadata.byteSize+=sizeDelta;return _this.setMetadata(txn,metadata);});};return IndexedDbRemoteDocumentCache;}();function documentGlobalStore(txn){return IndexedDbPersistence.getStore(txn,DbRemoteDocumentGlobal.store);}/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache
 */var IndexedDbRemoteDocumentChangeBuffer=/** @class */function(_super){tslib_1.__extends(IndexedDbRemoteDocumentChangeBuffer,_super);function IndexedDbRemoteDocumentChangeBuffer(documentCache){var _this=_super.call(this)||this;_this.documentCache=documentCache;return _this;}IndexedDbRemoteDocumentChangeBuffer.prototype.applyChanges=function(transaction){var _this=this;var changes=this.assertChanges();var delta=0;var toApply=[];changes.forEach(function(key,maybeDocument){var doc=_this.documentCache.serializer.toDbRemoteDocument(maybeDocument);var previousSize=_this.documentSizes.get(key);// NOTE: if we ever decide we need to support doing writes without
// reading first, this assert will need to change to do the read automatically.
assert(previousSize!==undefined,"Attempting to change document "+key.toString()+" without having read it first");var size=dbDocumentSize(doc);delta+=size-previousSize;toApply.push({key:key,doc:doc});});return this.documentCache.addEntries(transaction,toApply,delta);};IndexedDbRemoteDocumentChangeBuffer.prototype.getFromCache=function(transaction,documentKey){return this.documentCache.getSizedEntry(transaction,documentKey);};IndexedDbRemoteDocumentChangeBuffer.prototype.getAllFromCache=function(transaction,documentKeys){return this.documentCache.getSizedEntries(transaction,documentKeys);};return IndexedDbRemoteDocumentChangeBuffer;}(RemoteDocumentChangeBuffer);function isDocumentChangeMissingError(err){return err.code===Code.DATA_LOSS&&err.message===REMOTE_DOCUMENT_CHANGE_MISSING_ERR_MSG;}/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */function remoteDocumentsStore(txn){return IndexedDbPersistence.getStore(txn,DbRemoteDocument.store);}/**
 * Helper to get a typed SimpleDbStore for the remoteDocumentChanges object
 * store.
 */function documentChangesStore(txn){return IndexedDbPersistence.getStore(txn,DbRemoteDocumentChanges.store);}function dbKey(docKey){return docKey.path.toArray();}/**
 * Retrusn an approximate size for the given document.
 */function dbDocumentSize(doc){var value;if(doc.document){value=doc.document;}else if(doc.unknownDocument){value=doc.unknownDocument;}else if(doc.noDocument){value=doc.noDocument;}else{throw fail('Unknown remote document type');}return JSON.stringify(value).length;}/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * An in-memory implementation of IndexManager.
 */var MemoryIndexManager=/** @class */function(){function MemoryIndexManager(){this.collectionParentIndex=new MemoryCollectionParentIndex();}MemoryIndexManager.prototype.addToCollectionParentIndex=function(transaction,collectionPath){this.collectionParentIndex.add(collectionPath);return PersistencePromise.resolve();};MemoryIndexManager.prototype.getCollectionParents=function(transaction,collectionId){return PersistencePromise.resolve(this.collectionParentIndex.getEntries(collectionId));};return MemoryIndexManager;}();/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */var MemoryCollectionParentIndex=/** @class */function(){function MemoryCollectionParentIndex(){this.index={};}// Returns false if the entry already existed.
MemoryCollectionParentIndex.prototype.add=function(collectionPath){assert(collectionPath.length%2===1,'Expected a collection path.');var collectionId=collectionPath.lastSegment();var parentPath=collectionPath.popLast();var existingParents=this.index[collectionId]||new SortedSet(ResourcePath.comparator);var added=!existingParents.has(parentPath);this.index[collectionId]=existingParents.add(parentPath);return added;};MemoryCollectionParentIndex.prototype.getEntries=function(collectionId){var parentPaths=this.index[collectionId]||new SortedSet(ResourcePath.comparator);return parentPaths.toArray();};return MemoryCollectionParentIndex;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Schema Version for the Web client:
 * 1. Initial version including Mutation Queue, Query Cache, and Remote Document
 *    Cache
 * 2. Used to ensure a targetGlobal object exists and add targetCount to it. No
 *    longer required because migration 3 unconditionally clears it.
 * 3. Dropped and re-created Query Cache to deal with cache corruption related
 *    to limbo resolution. Addresses
 *    https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4. Multi-Tab Support.
 * 5. Removal of held write acks.
 * 6. Create document global for tracking document cache size.
 * 7. Ensure every cached document has a sentinel row with a sequence number.
 * 8. Add collection-parent index for Collection Group queries.
 */var SCHEMA_VERSION=8;/** Performs database creation and schema upgrades. */var SchemaConverter=/** @class */function(){function SchemaConverter(serializer){this.serializer=serializer;}/**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */SchemaConverter.prototype.createOrUpgrade=function(db,txn,fromVersion,toVersion){var _this=this;assert(fromVersion<toVersion&&fromVersion>=0&&toVersion<=SCHEMA_VERSION,"Unexpected schema upgrade from v"+fromVersion+" to v{toVersion}.");if(fromVersion<1&&toVersion>=1){createPrimaryClientStore(db);createMutationQueue(db);createQueryCache(db);createRemoteDocumentCache(db);}// Migration 2 to populate the targetGlobal object no longer needed since
// migration 3 unconditionally clears it.
var p=PersistencePromise.resolve();if(fromVersion<3&&toVersion>=3){// Brand new clients don't need to drop and recreate--only clients that
// potentially have corrupt data.
if(fromVersion!==0){dropQueryCache(db);createQueryCache(db);}p=p.next(function(){return writeEmptyTargetGlobalEntry(txn);});}if(fromVersion<4&&toVersion>=4){if(fromVersion!==0){// Schema version 3 uses auto-generated keys to generate globally unique
// mutation batch IDs (this was previously ensured internally by the
// client). To migrate to the new schema, we have to read all mutations
// and write them back out. We preserve the existing batch IDs to guarantee
// consistency with other object stores. Any further mutation batch IDs will
// be auto-generated.
p=p.next(function(){return upgradeMutationBatchSchemaAndMigrateData(db,txn);});}p=p.next(function(){createClientMetadataStore(db);createRemoteDocumentChangesStore(db);});}if(fromVersion<5&&toVersion>=5){p=p.next(function(){return _this.removeAcknowledgedMutations(txn);});}if(fromVersion<6&&toVersion>=6){p=p.next(function(){createDocumentGlobalStore(db);return _this.addDocumentGlobal(txn);});}if(fromVersion<7&&toVersion>=7){p=p.next(function(){return _this.ensureSequenceNumbers(txn);});}if(fromVersion<8&&toVersion>=8){p=p.next(function(){return _this.createCollectionParentIndex(db,txn);});}return p;};SchemaConverter.prototype.addDocumentGlobal=function(txn){var byteCount=0;return txn.store(DbRemoteDocument.store).iterate(function(_,doc){byteCount+=dbDocumentSize(doc);}).next(function(){var metadata=new DbRemoteDocumentGlobal(byteCount);return txn.store(DbRemoteDocumentGlobal.store).put(DbRemoteDocumentGlobal.key,metadata);});};SchemaConverter.prototype.removeAcknowledgedMutations=function(txn){var _this=this;var queuesStore=txn.store(DbMutationQueue.store);var mutationsStore=txn.store(DbMutationBatch.store);return queuesStore.loadAll().next(function(queues){return PersistencePromise.forEach(queues,function(queue){var range=IDBKeyRange.bound([queue.userId,BATCHID_UNKNOWN],[queue.userId,queue.lastAcknowledgedBatchId]);return mutationsStore.loadAll(DbMutationBatch.userMutationsIndex,range).next(function(dbBatches){return PersistencePromise.forEach(dbBatches,function(dbBatch){assert(dbBatch.userId===queue.userId,"Cannot process batch "+dbBatch.batchId+" from unexpected user");var batch=_this.serializer.fromDbMutationBatch(dbBatch);return removeMutationBatch(txn,queue.userId,batch).next(function(){});});});});});};/**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */SchemaConverter.prototype.ensureSequenceNumbers=function(txn){var documentTargetStore=txn.store(DbTargetDocument.store);var documentsStore=txn.store(DbRemoteDocument.store);return getHighestListenSequenceNumber(txn).next(function(currentSequenceNumber){var writeSentinelKey=function writeSentinelKey(path){return documentTargetStore.put(new DbTargetDocument(0,encode(path),currentSequenceNumber));};var promises=[];return documentsStore.iterate(function(key,doc){var path=new ResourcePath(key);var docSentinelKey=sentinelKey(path);promises.push(documentTargetStore.get(docSentinelKey).next(function(maybeSentinel){if(!maybeSentinel){return writeSentinelKey(path);}else{return PersistencePromise.resolve();}}));}).next(function(){return PersistencePromise.waitFor(promises);});});};SchemaConverter.prototype.createCollectionParentIndex=function(db,txn){// Create the index.
db.createObjectStore(DbCollectionParent.store,{keyPath:DbCollectionParent.keyPath});var collectionParentsStore=txn.store(DbCollectionParent.store);// Helper to add an index entry iff we haven't already written it.
var cache=new MemoryCollectionParentIndex();var addEntry=function addEntry(collectionPath){if(cache.add(collectionPath)){var collectionId=collectionPath.lastSegment();var parentPath=collectionPath.popLast();return collectionParentsStore.put({collectionId:collectionId,parent:encode(parentPath)});}};// Index existing remote documents.
return txn.store(DbRemoteDocument.store).iterate({keysOnly:true},function(pathSegments,_){var path=new ResourcePath(pathSegments);return addEntry(path.popLast());}).next(function(){// Index existing mutations.
return txn.store(DbDocumentMutation.store).iterate({keysOnly:true},function(_a,_){var userID=_a[0],encodedPath=_a[1],batchId=_a[2];var path=decode(encodedPath);return addEntry(path.popLast());});});};return SchemaConverter;}();function sentinelKey(path){return[0,encode(path)];}/**
 * Wrapper class to store timestamps (seconds and nanos) in IndexedDb objects.
 */var DbTimestamp=/** @class */function(){function DbTimestamp(seconds,nanoseconds){this.seconds=seconds;this.nanoseconds=nanoseconds;}return DbTimestamp;}();/**
 * A singleton object to be stored in the 'owner' store in IndexedDb.
 *
 * A given database can have a single primary tab assigned at a given time. That
 * tab must validate that it is still holding the primary lease before every
 * operation that requires locked access. The primary tab should regularly
 * write an updated timestamp to this lease to prevent other tabs from
 * "stealing" the primary lease
 */var DbPrimaryClient=/** @class */function(){function DbPrimaryClient(ownerId,/** Whether to allow shared access from multiple tabs. */allowTabSynchronization,leaseTimestampMs){this.ownerId=ownerId;this.allowTabSynchronization=allowTabSynchronization;this.leaseTimestampMs=leaseTimestampMs;}/**
     * Name of the IndexedDb object store.
     *
     * Note that the name 'owner' is chosen to ensure backwards compatibility with
     * older clients that only supported single locked access to the persistence
     * layer.
     */DbPrimaryClient.store='owner';/**
     * The key string used for the single object that exists in the
     * DbPrimaryClient store.
     */DbPrimaryClient.key='owner';return DbPrimaryClient;}();function createPrimaryClientStore(db){db.createObjectStore(DbPrimaryClient.store);}/**
 * An object to be stored in the 'mutationQueues' store in IndexedDb.
 *
 * Each user gets a single queue of MutationBatches to apply to the server.
 * DbMutationQueue tracks the metadata about the queue.
 */var DbMutationQueue=/** @class */function(){function DbMutationQueue(/**
     * The normalized user ID to which this queue belongs.
     */userId,/**
     * An identifier for the highest numbered batch that has been acknowledged
     * by the server. All MutationBatches in this queue with batchIds less
     * than or equal to this value are considered to have been acknowledged by
     * the server.
     *
     * NOTE: this is deprecated and no longer used by the code.
     */lastAcknowledgedBatchId,/**
     * A stream token that was previously sent by the server.
     *
     * See StreamingWriteRequest in datastore.proto for more details about
     * usage.
     *
     * After sending this token, earlier tokens may not be used anymore so
     * only a single stream token is retained.
     */lastStreamToken){this.userId=userId;this.lastAcknowledgedBatchId=lastAcknowledgedBatchId;this.lastStreamToken=lastStreamToken;}/** Name of the IndexedDb object store.  */DbMutationQueue.store='mutationQueues';/** Keys are automatically assigned via the userId property. */DbMutationQueue.keyPath='userId';return DbMutationQueue;}();/**
 * An object to be stored in the 'mutations' store in IndexedDb.
 *
 * Represents a batch of user-level mutations intended to be sent to the server
 * in a single write. Each user-level batch gets a separate DbMutationBatch
 * with a new batchId.
 */var DbMutationBatch=/** @class */function(){function DbMutationBatch(/**
     * The normalized user ID to which this batch belongs.
     */userId,/**
     * An identifier for this batch, allocated using an auto-generated key.
     */batchId,/**
     * The local write time of the batch, stored as milliseconds since the
     * epoch.
     */localWriteTimeMs,/**
     * A list of "mutations" that represent a partial base state from when this
     * write batch was initially created. During local application of the write
     * batch, these baseMutations are applied prior to the real writes in order
     * to override certain document fields from the remote document cache. This
     * is necessary in the case of non-idempotent writes (e.g. `increment()`
     * transforms) to make sure that the local view of the modified documents
     * doesn't flicker if the remote document cache receives the result of the
     * non-idempotent write before the write is removed from the queue.
     *
     * These mutations are never sent to the backend.
     */baseMutations,/**
     * A list of mutations to apply. All mutations will be applied atomically.
     *
     * Mutations are serialized via JsonProtoSerializer.toMutation().
     */mutations){this.userId=userId;this.batchId=batchId;this.localWriteTimeMs=localWriteTimeMs;this.baseMutations=baseMutations;this.mutations=mutations;}/** Name of the IndexedDb object store.  */DbMutationBatch.store='mutations';/** Keys are automatically assigned via the userId, batchId properties. */DbMutationBatch.keyPath='batchId';/** The index name for lookup of mutations by user. */DbMutationBatch.userMutationsIndex='userMutationsIndex';/** The user mutations index is keyed by [userId, batchId] pairs. */DbMutationBatch.userMutationsKeyPath=['userId','batchId'];return DbMutationBatch;}();function createMutationQueue(db){db.createObjectStore(DbMutationQueue.store,{keyPath:DbMutationQueue.keyPath});var mutationBatchesStore=db.createObjectStore(DbMutationBatch.store,{keyPath:DbMutationBatch.keyPath,autoIncrement:true});mutationBatchesStore.createIndex(DbMutationBatch.userMutationsIndex,DbMutationBatch.userMutationsKeyPath,{unique:true});db.createObjectStore(DbDocumentMutation.store);}/**
 * Upgrade function to migrate the 'mutations' store from V1 to V3. Loads
 * and rewrites all data.
 */function upgradeMutationBatchSchemaAndMigrateData(db,txn){var v1MutationsStore=txn.store(DbMutationBatch.store);return v1MutationsStore.loadAll().next(function(existingMutations){db.deleteObjectStore(DbMutationBatch.store);var mutationsStore=db.createObjectStore(DbMutationBatch.store,{keyPath:DbMutationBatch.keyPath,autoIncrement:true});mutationsStore.createIndex(DbMutationBatch.userMutationsIndex,DbMutationBatch.userMutationsKeyPath,{unique:true});var v3MutationsStore=txn.store(DbMutationBatch.store);var writeAll=existingMutations.map(function(mutation){return v3MutationsStore.put(mutation);});return PersistencePromise.waitFor(writeAll);});}/**
 * An object to be stored in the 'documentMutations' store in IndexedDb.
 *
 * A manually maintained index of all the mutation batches that affect a given
 * document key. The rows in this table are references based on the contents of
 * DbMutationBatch.mutations.
 */var DbDocumentMutation=/** @class */function(){function DbDocumentMutation(){}/**
     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
     * over all of a user's document mutations.
     */DbDocumentMutation.prefixForUser=function(userId){return[userId];};/**
     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
     * index to iterate over all at document mutations for a given path or lower.
     */DbDocumentMutation.prefixForPath=function(userId,path){return[userId,encode(path)];};/**
     * Creates a full index key of [userId, encodedPath, batchId] for inserting
     * and deleting into the DbDocumentMutations index.
     */DbDocumentMutation.key=function(userId,path,batchId){return[userId,encode(path),batchId];};DbDocumentMutation.store='documentMutations';/**
     * Because we store all the useful information for this store in the key,
     * there is no useful information to store as the value. The raw (unencoded)
     * path cannot be stored because IndexedDb doesn't store prototype
     * information.
     */DbDocumentMutation.PLACEHOLDER=new DbDocumentMutation();return DbDocumentMutation;}();function createRemoteDocumentCache(db){db.createObjectStore(DbRemoteDocument.store);}/**
 * Represents the known absence of a document at a particular version.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */var DbNoDocument=/** @class */function(){function DbNoDocument(path,readTime){this.path=path;this.readTime=readTime;}return DbNoDocument;}();/**
 * Represents a document that is known to exist but whose data is unknown.
 * Stored in IndexedDb as part of a DbRemoteDocument object.
 */var DbUnknownDocument=/** @class */function(){function DbUnknownDocument(path,version){this.path=path;this.version=version;}return DbUnknownDocument;}();/**
 * An object to be stored in the 'remoteDocuments' store in IndexedDb.
 * It represents either:
 *
 * - A complete document.
 * - A "no document" representing a document that is known not to exist (at
 * some version).
 * - An "unknown document" representing a document that is known to exist (at
 * some version) but whose contents are unknown.
 *
 * Note: This is the persisted equivalent of a MaybeDocument and could perhaps
 * be made more general if necessary.
 */var DbRemoteDocument=/** @class */function(){function DbRemoteDocument(/**
     * Set to an instance of DbUnknownDocument if the data for a document is
     * not known, but it is known that a document exists at the specified
     * version (e.g. it had a successful update applied to it)
     */unknownDocument,/**
     * Set to an instance of a DbNoDocument if it is known that no document
     * exists.
     */noDocument,/**
     * Set to an instance of a Document if there's a cached version of the
     * document.
     */document,/**
     * Documents that were written to the remote document store based on
     * a write acknowledgment are marked with `hasCommittedMutations`. These
     * documents are potentially inconsistent with the backend's copy and use
     * the write's commit version as their document version.
     */hasCommittedMutations){this.unknownDocument=unknownDocument;this.noDocument=noDocument;this.document=document;this.hasCommittedMutations=hasCommittedMutations;}DbRemoteDocument.store='remoteDocuments';return DbRemoteDocument;}();/**
 * Contains a single entry that has metadata about the remote document cache.
 */var DbRemoteDocumentGlobal=/** @class */function(){/**
     * @param byteSize Approximately the total size in bytes of all the documents in the document
     * cache.
     */function DbRemoteDocumentGlobal(byteSize){this.byteSize=byteSize;}DbRemoteDocumentGlobal.store='remoteDocumentGlobal';DbRemoteDocumentGlobal.key='remoteDocumentGlobalKey';return DbRemoteDocumentGlobal;}();function createDocumentGlobalStore(db){db.createObjectStore(DbRemoteDocumentGlobal.store);}/**
 * An object to be stored in the 'targets' store in IndexedDb.
 *
 * This is based on and should be kept in sync with the proto used in the iOS
 * client.
 *
 * Each query the client listens to against the server is tracked on disk so
 * that the query can be efficiently resumed on restart.
 */var DbTarget=/** @class */function(){function DbTarget(/**
     * An auto-generated sequential numeric identifier for the query.
     *
     * Queries are stored using their canonicalId as the key, but these
     * canonicalIds can be quite long so we additionally assign a unique
     * queryId which can be used by referenced data structures (e.g.
     * indexes) to minimize the on-disk cost.
     */targetId,/**
     * The canonical string representing this query. This is not unique.
     */canonicalId,/**
     * The last readTime received from the Watch Service for this query.
     *
     * This is the same value as TargetChange.read_time in the protos.
     */readTime,/**
     * An opaque, server-assigned token that allows watching a query to be
     * resumed after disconnecting without retransmitting all the data
     * that matches the query. The resume token essentially identifies a
     * point in time from which the server should resume sending results.
     *
     * This is related to the snapshotVersion in that the resumeToken
     * effectively also encodes that value, but the resumeToken is opaque
     * and sometimes encodes additional information.
     *
     * A consequence of this is that the resumeToken should be used when
     * asking the server to reason about where this client is in the watch
     * stream, but the client should use the snapshotVersion for its own
     * purposes.
     *
     * This is the same value as TargetChange.resume_token in the protos.
     */resumeToken,/**
     * A sequence number representing the last time this query was
     * listened to, used for garbage collection purposes.
     *
     * Conventionally this would be a timestamp value, but device-local
     * clocks are unreliable and they must be able to create new listens
     * even while disconnected. Instead this should be a monotonically
     * increasing number that's incremented on each listen call.
     *
     * This is different from the queryId since the queryId is an
     * immutable identifier assigned to the Query on first use while
     * lastListenSequenceNumber is updated every time the query is
     * listened to.
     */lastListenSequenceNumber,/**
     * The query for this target.
     *
     * Because canonical ids are not unique we must store the actual query. We
     * use the proto to have an object we can persist without having to
     * duplicate translation logic to and from a `Query` object.
     */query){this.targetId=targetId;this.canonicalId=canonicalId;this.readTime=readTime;this.resumeToken=resumeToken;this.lastListenSequenceNumber=lastListenSequenceNumber;this.query=query;}DbTarget.store='targets';/** Keys are automatically assigned via the targetId property. */DbTarget.keyPath='targetId';/** The name of the queryTargets index. */DbTarget.queryTargetsIndexName='queryTargetsIndex';/**
     * The index of all canonicalIds to the targets that they match. This is not
     * a unique mapping because canonicalId does not promise a unique name for all
     * possible queries, so we append the targetId to make the mapping unique.
     */DbTarget.queryTargetsKeyPath=['canonicalId','targetId'];return DbTarget;}();/**
 * An object representing an association between a target and a document, or a
 * sentinel row marking the last sequence number at which a document was used.
 * Each document cached must have a corresponding sentinel row before lru
 * garbage collection is enabled.
 *
 * The target associations and sentinel rows are co-located so that orphaned
 * documents and their sequence numbers can be identified efficiently via a scan
 * of this store.
 */var DbTargetDocument=/** @class */function(){function DbTargetDocument(/**
     * The targetId identifying a target or 0 for a sentinel row.
     */targetId,/**
     * The path to the document, as encoded in the key.
     */path,/**
     * If this is a sentinel row, this should be the sequence number of the last
     * time the document specified by `path` was used. Otherwise, it should be
     * `undefined`.
     */sequenceNumber){this.targetId=targetId;this.path=path;this.sequenceNumber=sequenceNumber;assert(targetId===0===(sequenceNumber!==undefined),// tslint:disable-next-line:max-line-length
'A target-document row must either have targetId == 0 and a defined sequence number, or a non-zero targetId and no sequence number');}/** Name of the IndexedDb object store.  */DbTargetDocument.store='targetDocuments';/** Keys are automatically assigned via the targetId, path properties. */DbTargetDocument.keyPath=['targetId','path'];/** The index name for the reverse index. */DbTargetDocument.documentTargetsIndex='documentTargetsIndex';/** We also need to create the reverse index for these properties. */DbTargetDocument.documentTargetsKeyPath=['path','targetId'];return DbTargetDocument;}();/**
 * A record of global state tracked across all Targets, tracked separately
 * to avoid the need for extra indexes.
 *
 * This should be kept in-sync with the proto used in the iOS client.
 */var DbTargetGlobal=/** @class */function(){function DbTargetGlobal(/**
     * The highest numbered target id across all targets.
     *
     * See DbTarget.targetId.
     */highestTargetId,/**
     * The highest numbered lastListenSequenceNumber across all targets.
     *
     * See DbTarget.lastListenSequenceNumber.
     */highestListenSequenceNumber,/**
     * A global snapshot version representing the last consistent snapshot we
     * received from the backend. This is monotonically increasing and any
     * snapshots received from the backend prior to this version (e.g. for
     * targets resumed with a resumeToken) should be suppressed (buffered)
     * until the backend has caught up to this snapshot version again. This
     * prevents our cache from ever going backwards in time.
     */lastRemoteSnapshotVersion,/**
     * The number of targets persisted.
     */targetCount){this.highestTargetId=highestTargetId;this.highestListenSequenceNumber=highestListenSequenceNumber;this.lastRemoteSnapshotVersion=lastRemoteSnapshotVersion;this.targetCount=targetCount;}/**
     * The key string used for the single object that exists in the
     * DbTargetGlobal store.
     */DbTargetGlobal.key='targetGlobalKey';DbTargetGlobal.store='targetGlobal';return DbTargetGlobal;}();/**
 * An object representing an association between a Collection id (e.g. 'messages')
 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
 * This is used to efficiently find all collections to query when performing
 * a Collection Group query.
 */var DbCollectionParent=/** @class */function(){function DbCollectionParent(/**
     * The collectionId (e.g. 'messages')
     */collectionId,/**
     * The path to the parent (either a document location or an empty path for
     * a root-level collection).
     */parent){this.collectionId=collectionId;this.parent=parent;}/** Name of the IndexedDb object store. */DbCollectionParent.store='collectionParents';/** Keys are automatically assigned via the collectionId, parent properties. */DbCollectionParent.keyPath=['collectionId','parent'];return DbCollectionParent;}();function createQueryCache(db){var targetDocumentsStore=db.createObjectStore(DbTargetDocument.store,{keyPath:DbTargetDocument.keyPath});targetDocumentsStore.createIndex(DbTargetDocument.documentTargetsIndex,DbTargetDocument.documentTargetsKeyPath,{unique:true});var targetStore=db.createObjectStore(DbTarget.store,{keyPath:DbTarget.keyPath});// NOTE: This is unique only because the TargetId is the suffix.
targetStore.createIndex(DbTarget.queryTargetsIndexName,DbTarget.queryTargetsKeyPath,{unique:true});db.createObjectStore(DbTargetGlobal.store);}function dropQueryCache(db){db.deleteObjectStore(DbTargetDocument.store);db.deleteObjectStore(DbTarget.store);db.deleteObjectStore(DbTargetGlobal.store);}/**
 * Creates the target global singleton row.
 *
 * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
 */function writeEmptyTargetGlobalEntry(txn){var globalStore=txn.store(DbTargetGlobal.store);var metadata=new DbTargetGlobal(/*highestTargetId=*/0,/*lastListenSequenceNumber=*/0,SnapshotVersion.MIN.toTimestamp(),/*targetCount=*/0);return globalStore.put(DbTargetGlobal.key,metadata);}/**
 * An object store to store the keys of changed documents. This is used to
 * facilitate storing document changelogs in the Remote Document Cache.
 *
 * PORTING NOTE: This is used for change propagation during multi-tab syncing
 * and not needed on iOS and Android.
 */var DbRemoteDocumentChanges=/** @class */function(){function DbRemoteDocumentChanges(/** The keys of the changed documents. */changes){this.changes=changes;}/** Name of the IndexedDb object store.  */DbRemoteDocumentChanges.store='remoteDocumentChanges';/** Keys are auto-generated via the `id` property. */DbRemoteDocumentChanges.keyPath='id';return DbRemoteDocumentChanges;}();function createRemoteDocumentChangesStore(db){db.createObjectStore(DbRemoteDocumentChanges.store,{keyPath:'id',autoIncrement:true});}/**
 * A record of the metadata state of each client.
 *
 * PORTING NOTE: This is used to synchronize multi-tab state and does not need
 * to be ported to iOS or Android.
 */var DbClientMetadata=/** @class */function(){function DbClientMetadata(/** The auto-generated client id assigned at client startup. */clientId,/** The last time this state was updated. */updateTimeMs,/** Whether the client's network connection is enabled. */networkEnabled,/** Whether this client is running in a foreground tab. */inForeground,/**
     * The last change read from the DbRemoteDocumentChanges store.
     * Can be undefined for backwards compatibility.
     */lastProcessedDocumentChangeId){this.clientId=clientId;this.updateTimeMs=updateTimeMs;this.networkEnabled=networkEnabled;this.inForeground=inForeground;this.lastProcessedDocumentChangeId=lastProcessedDocumentChangeId;}/** Name of the IndexedDb object store. */DbClientMetadata.store='clientMetadata';/** Keys are automatically assigned via the clientId properties. */DbClientMetadata.keyPath='clientId';return DbClientMetadata;}();function createClientMetadataStore(db){db.createObjectStore(DbClientMetadata.store,{keyPath:DbClientMetadata.keyPath});}// Visible for testing
var V1_STORES=[DbMutationQueue.store,DbMutationBatch.store,DbDocumentMutation.store,DbRemoteDocument.store,DbTarget.store,DbPrimaryClient.store,DbTargetGlobal.store,DbTargetDocument.store];// V2 is no longer usable (see comment at top of file)
// Visible for testing
var V3_STORES=V1_STORES;// Visible for testing
var V4_STORES=V3_STORES.concat([DbClientMetadata.store,DbRemoteDocumentChanges.store]);// V5 does not change the set of stores.
var V6_STORES=V4_STORES.concat([DbRemoteDocumentGlobal.store]);// V7 does not change the set of stores.
var V8_STORES=V6_STORES.concat([DbCollectionParent.store]);/**
 * The list of all default IndexedDB stores used throughout the SDK. This is
 * used when creating transactions so that access across all stores is done
 * atomically.
 */var ALL_STORES=V8_STORES;/**
 * @license
 * Copyright 2019 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * A persisted implementation of IndexManager.
 */var IndexedDbIndexManager=/** @class */function(){function IndexedDbIndexManager(){/**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be used to
         * satisfy reads.
         */this.collectionParentsCache=new MemoryCollectionParentIndex();}IndexedDbIndexManager.prototype.addToCollectionParentIndex=function(transaction,collectionPath){assert(collectionPath.length%2===1,'Expected a collection path.');if(this.collectionParentsCache.add(collectionPath)){assert(collectionPath.length>=1,'Invalid collection path.');var collectionId=collectionPath.lastSegment();var parentPath=collectionPath.popLast();return collectionParentsStore(transaction).put({collectionId:collectionId,parent:encode(parentPath)});}return PersistencePromise.resolve();};IndexedDbIndexManager.prototype.getCollectionParents=function(transaction,collectionId){var parentPaths=[];var range=IDBKeyRange.bound([collectionId,''],[immediateSuccessor(collectionId),''],/*lowerOpen=*/false,/*upperOpen=*/true);return collectionParentsStore(transaction).loadAll(range).next(function(entries){for(var _i=0,entries_1=entries;_i<entries_1.length;_i++){var entry=entries_1[_i];// This collectionId guard shouldn't be necessary (and isn't as long
// as we're running in a real browser), but there's a bug in
// indexeddbshim that breaks our range in our tests running in node:
// https://github.com/axemclion/IndexedDBShim/issues/334
if(entry.collectionId!==collectionId){break;}parentPaths.push(decode(entry.parent));}return parentPaths;});};return IndexedDbIndexManager;}();/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */function collectionParentsStore(txn){return IndexedDbPersistence.getStore(txn,DbCollectionParent.store);}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//** Serializer for values stored in the LocalStore. */var LocalSerializer=/** @class */function(){function LocalSerializer(remoteSerializer){this.remoteSerializer=remoteSerializer;}/** Decodes a remote document from storage locally to a Document. */LocalSerializer.prototype.fromDbRemoteDocument=function(remoteDoc){if(remoteDoc.document){return this.remoteSerializer.fromDocument(remoteDoc.document,!!remoteDoc.hasCommittedMutations);}else if(remoteDoc.noDocument){var key=DocumentKey.fromSegments(remoteDoc.noDocument.path);var version=this.fromDbTimestamp(remoteDoc.noDocument.readTime);return new NoDocument(key,version,{hasCommittedMutations:!!remoteDoc.hasCommittedMutations});}else if(remoteDoc.unknownDocument){var key=DocumentKey.fromSegments(remoteDoc.unknownDocument.path);var version=this.fromDbTimestamp(remoteDoc.unknownDocument.version);return new UnknownDocument(key,version);}else{return fail('Unexpected DbRemoteDocument');}};/** Encodes a document for storage locally. */LocalSerializer.prototype.toDbRemoteDocument=function(maybeDoc){if(maybeDoc instanceof Document){var doc=maybeDoc.proto?maybeDoc.proto:this.remoteSerializer.toDocument(maybeDoc);var hasCommittedMutations=maybeDoc.hasCommittedMutations;return new DbRemoteDocument(/* unknownDocument= */null,/* noDocument= */null,doc,hasCommittedMutations);}else if(maybeDoc instanceof NoDocument){var path=maybeDoc.key.path.toArray();var readTime=this.toDbTimestamp(maybeDoc.version);var hasCommittedMutations=maybeDoc.hasCommittedMutations;return new DbRemoteDocument(/* unknownDocument= */null,new DbNoDocument(path,readTime),/* document= */null,hasCommittedMutations);}else if(maybeDoc instanceof UnknownDocument){var path=maybeDoc.key.path.toArray();var readTime=this.toDbTimestamp(maybeDoc.version);return new DbRemoteDocument(new DbUnknownDocument(path,readTime),/* noDocument= */null,/* document= */null,/* hasCommittedMutations= */true);}else{return fail('Unexpected MaybeDocumment');}};LocalSerializer.prototype.toDbTimestamp=function(snapshotVersion){var timestamp=snapshotVersion.toTimestamp();return new DbTimestamp(timestamp.seconds,timestamp.nanoseconds);};LocalSerializer.prototype.fromDbTimestamp=function(dbTimestamp){var timestamp=new Timestamp(dbTimestamp.seconds,dbTimestamp.nanoseconds);return SnapshotVersion.fromTimestamp(timestamp);};/** Encodes a batch of mutations into a DbMutationBatch for local storage. */LocalSerializer.prototype.toDbMutationBatch=function(userId,batch){var _this=this;var serializedBaseMutations=batch.baseMutations.map(function(m){return _this.remoteSerializer.toMutation(m);});var serializedMutations=batch.mutations.map(function(m){return _this.remoteSerializer.toMutation(m);});return new DbMutationBatch(userId,batch.batchId,batch.localWriteTime.toMillis(),serializedBaseMutations,serializedMutations);};/** Decodes a DbMutationBatch into a MutationBatch */LocalSerializer.prototype.fromDbMutationBatch=function(dbBatch){var _this=this;var baseMutations=(dbBatch.baseMutations||[]).map(function(m){return _this.remoteSerializer.fromMutation(m);});var mutations=dbBatch.mutations.map(function(m){return _this.remoteSerializer.fromMutation(m);});var timestamp=Timestamp.fromMillis(dbBatch.localWriteTimeMs);return new MutationBatch(dbBatch.batchId,timestamp,baseMutations,mutations);};/*
     * Encodes a set of document keys into an array of EncodedResourcePaths.
     */LocalSerializer.prototype.toDbResourcePaths=function(keys){var encodedKeys=[];keys.forEach(function(key){encodedKeys.push(encode(key.path));});return encodedKeys;};/** Decodes an array of EncodedResourcePaths into a set of document keys. */LocalSerializer.prototype.fromDbResourcePaths=function(encodedPaths){var keys=documentKeySet();for(var _i=0,encodedPaths_1=encodedPaths;_i<encodedPaths_1.length;_i++){var documentKey=encodedPaths_1[_i];keys=keys.add(new DocumentKey(decode(documentKey)));}return keys;};/** Decodes a DbTarget into QueryData */LocalSerializer.prototype.fromDbTarget=function(dbTarget){var version=this.fromDbTimestamp(dbTarget.readTime);var query;if(isDocumentQuery(dbTarget.query)){query=this.remoteSerializer.fromDocumentsTarget(dbTarget.query);}else{query=this.remoteSerializer.fromQueryTarget(dbTarget.query);}return new QueryData(query,dbTarget.targetId,QueryPurpose.Listen,dbTarget.lastListenSequenceNumber,version,dbTarget.resumeToken);};/** Encodes QueryData into a DbTarget for storage locally. */LocalSerializer.prototype.toDbTarget=function(queryData){assert(QueryPurpose.Listen===queryData.purpose,'Only queries with purpose '+QueryPurpose.Listen+' may be stored, got '+queryData.purpose);var dbTimestamp=this.toDbTimestamp(queryData.snapshotVersion);var queryProto;if(queryData.query.isDocumentQuery()){queryProto=this.remoteSerializer.toDocumentsTarget(queryData.query);}else{queryProto=this.remoteSerializer.toQueryTarget(queryData.query);}var resumeToken;if(queryData.resumeToken instanceof Uint8Array){// TODO(b/78771403): Convert tokens to strings during deserialization
assert(process.env.USE_MOCK_PERSISTENCE==='YES','Persisting non-string stream tokens is only supported with mock persistence .');resumeToken=queryData.resumeToken.toString();}else{resumeToken=queryData.resumeToken;}// lastListenSequenceNumber is always 0 until we do real GC.
return new DbTarget(queryData.targetId,queryData.query.canonicalId(),dbTimestamp,resumeToken,queryData.sequenceNumber,queryProto);};return LocalSerializer;}();/**
 * A helper function for figuring out what kind of query has been stored.
 */function isDocumentQuery(dbQuery){return dbQuery.documents!==undefined;}/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function bufferEntryComparator(_a,_b){var aSequence=_a[0],aIndex=_a[1];var bSequence=_b[0],bIndex=_b[1];var seqCmp=primitiveComparator(aSequence,bSequence);if(seqCmp===0){// This order doesn't matter, but we can bias against churn by sorting
// entries created earlier as less than newer entries.
return primitiveComparator(aIndex,bIndex);}else{return seqCmp;}}/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */var RollingSequenceNumberBuffer=/** @class */function(){function RollingSequenceNumberBuffer(maxElements){this.maxElements=maxElements;this.buffer=new SortedSet(bufferEntryComparator);this.previousIndex=0;}RollingSequenceNumberBuffer.prototype.nextIndex=function(){return++this.previousIndex;};RollingSequenceNumberBuffer.prototype.addElement=function(sequenceNumber){var entry=[sequenceNumber,this.nextIndex()];if(this.buffer.size<this.maxElements){this.buffer=this.buffer.add(entry);}else{var highestValue=this.buffer.last();if(bufferEntryComparator(entry,highestValue)<0){this.buffer=this.buffer.delete(highestValue).add(entry);}}};Object.defineProperty(RollingSequenceNumberBuffer.prototype,"maxValue",{get:function get(){// Guaranteed to be non-empty. If we decide we are not collecting any
// sequence numbers, nthSequenceNumber below short-circuits. If we have
// decided that we are collecting n sequence numbers, it's because n is some
// percentage of the existing sequence numbers. That means we should never
// be in a situation where we are collecting sequence numbers but don't
// actually have any.
return this.buffer.last()[0];},enumerable:true,configurable:true});return RollingSequenceNumberBuffer;}();var GC_DID_NOT_RUN={didRun:false,sequenceNumbersCollected:0,targetsRemoved:0,documentsRemoved:0};var LruParams=/** @class */function(){function LruParams(// When we attempt to collect, we will only do so if the cache size is greater than this
// threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
cacheSizeCollectionThreshold,// The percentage of sequence numbers that we will attempt to collect
percentileToCollect,// A cap on the total number of sequence numbers that will be collected. This prevents
// us from collecting a huge number of sequence numbers if the cache has grown very large.
maximumSequenceNumbersToCollect){this.cacheSizeCollectionThreshold=cacheSizeCollectionThreshold;this.percentileToCollect=percentileToCollect;this.maximumSequenceNumbersToCollect=maximumSequenceNumbersToCollect;}LruParams.withCacheSize=function(cacheSize){return new LruParams(cacheSize,LruParams.DEFAULT_COLLECTION_PERCENTILE,LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);};LruParams.COLLECTION_DISABLED=-1;LruParams.MINIMUM_CACHE_SIZE_BYTES=1*1024*1024;LruParams.DEFAULT_CACHE_SIZE_BYTES=40*1024*1024;LruParams.DEFAULT_COLLECTION_PERCENTILE=10;LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT=1000;LruParams.DEFAULT=new LruParams(LruParams.DEFAULT_CACHE_SIZE_BYTES,LruParams.DEFAULT_COLLECTION_PERCENTILE,LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);LruParams.DISABLED=new LruParams(LruParams.COLLECTION_DISABLED,0,0);return LruParams;}();/** How long we wait to try running LRU GC after SDK initialization. */var INITIAL_GC_DELAY_MS=1*60*1000;/** Minimum amount of time between GC checks, after the first one. */var REGULAR_GC_DELAY_MS=5*60*1000;/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */var LruScheduler=/** @class */function(){function LruScheduler(garbageCollector,asyncQueue,localStore){this.garbageCollector=garbageCollector;this.asyncQueue=asyncQueue;this.localStore=localStore;this.gcTask=null;}LruScheduler.prototype.start=function(){assert(this.gcTask===null,'Cannot start an already started LruScheduler');if(this.garbageCollector.params.cacheSizeCollectionThreshold!==LruParams.COLLECTION_DISABLED){this.scheduleGC();}};LruScheduler.prototype.stop=function(){if(this.gcTask){this.gcTask.cancel();this.gcTask=null;}};Object.defineProperty(LruScheduler.prototype,"started",{get:function get(){return this.gcTask!==null;},enumerable:true,configurable:true});LruScheduler.prototype.scheduleGC=function(){var _this=this;assert(this.gcTask===null,'Cannot schedule GC while a task is pending');var delay=this.hasRun?REGULAR_GC_DELAY_MS:INITIAL_GC_DELAY_MS;debug('LruGarbageCollector',"Garbage collection scheduled in "+delay+"ms");this.gcTask=this.asyncQueue.enqueueAfterDelay(TimerId.LruGarbageCollection,delay,function(){_this.gcTask=null;_this.hasRun=true;return _this.localStore.collectGarbage(_this.garbageCollector).then(function(){return _this.scheduleGC();}).catch(ignoreIfPrimaryLeaseLoss);});};return LruScheduler;}();/** Implements the steps for LRU garbage collection. */var LruGarbageCollector=/** @class */function(){function LruGarbageCollector(delegate,params){this.delegate=delegate;this.params=params;}/** Given a percentile of target to collect, returns the number of targets to collect. */LruGarbageCollector.prototype.calculateTargetCount=function(txn,percentile){return this.delegate.getSequenceNumberCount(txn).next(function(targetCount){return Math.floor(percentile/100.0*targetCount);});};/** Returns the nth sequence number, counting in order from the smallest. */LruGarbageCollector.prototype.nthSequenceNumber=function(txn,n){var _this=this;if(n===0){return PersistencePromise.resolve(ListenSequence.INVALID);}var buffer=new RollingSequenceNumberBuffer(n);return this.delegate.forEachTarget(txn,function(target){return buffer.addElement(target.sequenceNumber);}).next(function(){return _this.delegate.forEachOrphanedDocumentSequenceNumber(txn,function(sequenceNumber){return buffer.addElement(sequenceNumber);});}).next(function(){return buffer.maxValue;});};/**
     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
     * document associations with those targets.
     */LruGarbageCollector.prototype.removeTargets=function(txn,upperBound,activeTargetIds){return this.delegate.removeTargets(txn,upperBound,activeTargetIds);};/**
     * Removes documents that have a sequence number equal to or less than the upper bound and are not
     * otherwise pinned.
     */LruGarbageCollector.prototype.removeOrphanedDocuments=function(txn,upperBound){return this.delegate.removeOrphanedDocuments(txn,upperBound);};LruGarbageCollector.prototype.collect=function(txn,activeTargetIds){var _this=this;if(this.params.cacheSizeCollectionThreshold===LruParams.COLLECTION_DISABLED){debug('LruGarbageCollector','Garbage collection skipped; disabled');return PersistencePromise.resolve(GC_DID_NOT_RUN);}return this.getCacheSize(txn).next(function(cacheSize){if(cacheSize<_this.params.cacheSizeCollectionThreshold){debug('LruGarbageCollector',"Garbage collection skipped; Cache size "+cacheSize+" "+("is lower than threshold "+_this.params.cacheSizeCollectionThreshold));return GC_DID_NOT_RUN;}else{return _this.runGarbageCollection(txn,activeTargetIds);}});};LruGarbageCollector.prototype.getCacheSize=function(txn){return this.delegate.getCacheSize(txn);};LruGarbageCollector.prototype.runGarbageCollection=function(txn,activeTargetIds){var _this=this;var upperBoundSequenceNumber;var sequenceNumbersToCollect,targetsRemoved;// Timestamps for various pieces of the process
var startTs,countedTargetsTs,foundUpperBoundTs,removedTargetsTs,removedDocumentsTs;startTs=Date.now();return this.calculateTargetCount(txn,this.params.percentileToCollect).next(function(sequenceNumbers){// Cap at the configured max
if(sequenceNumbers>_this.params.maximumSequenceNumbersToCollect){debug('LruGarbageCollector','Capping sequence numbers to collect down '+("to the maximum of "+_this.params.maximumSequenceNumbersToCollect+" ")+("from "+sequenceNumbers));sequenceNumbersToCollect=_this.params.maximumSequenceNumbersToCollect;}else{sequenceNumbersToCollect=sequenceNumbers;}countedTargetsTs=Date.now();return _this.nthSequenceNumber(txn,sequenceNumbersToCollect);}).next(function(upperBound){upperBoundSequenceNumber=upperBound;foundUpperBoundTs=Date.now();return _this.removeTargets(txn,upperBoundSequenceNumber,activeTargetIds);}).next(function(numTargetsRemoved){targetsRemoved=numTargetsRemoved;removedTargetsTs=Date.now();return _this.removeOrphanedDocuments(txn,upperBoundSequenceNumber);}).next(function(documentsRemoved){removedDocumentsTs=Date.now();if(getLogLevel()<=LogLevel.DEBUG){var desc='LRU Garbage Collection\n'+("\tCounted targets in "+(countedTargetsTs-startTs)+"ms\n")+("\tDetermined least recently used "+sequenceNumbersToCollect+" in ")+(foundUpperBoundTs-countedTargetsTs+"ms\n")+("\tRemoved "+targetsRemoved+" targets in ")+(removedTargetsTs-foundUpperBoundTs+"ms\n")+("\tRemoved "+documentsRemoved+" documents in ")+(removedDocumentsTs-removedTargetsTs+"ms\n")+("Total Duration: "+(removedDocumentsTs-startTs)+"ms");debug('LruGarbageCollector',desc);}return PersistencePromise.resolve({didRun:true,sequenceNumbersCollected:sequenceNumbersToCollect,targetsRemoved:targetsRemoved,documentsRemoved:documentsRemoved});});};return LruGarbageCollector;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Opaque interface representing a persistence transaction.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */var PersistenceTransaction=/** @class */function(){function PersistenceTransaction(){}return PersistenceTransaction;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$2='IndexedDbPersistence';/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data (such as the remote document
 * cache changelog) is garbage collected.
 */var MAX_CLIENT_AGE_MS=30*60*1000;// 30 minutes
/**
 * Oldest acceptable metadata age for clients that may participate in the
 * primary lease election. Clients that have not updated their client metadata
 * within 5 seconds are not eligible to receive a primary lease.
 */var MAX_PRIMARY_ELIGIBLE_AGE_MS=5000;/**
 * The interval at which clients will update their metadata, including
 * refreshing their primary lease if held or potentially trying to acquire it if
 * not held.
 *
 * Primary clients may opportunistically refresh their metadata earlier
 * if they're already performing an IndexedDB operation.
 */var CLIENT_METADATA_REFRESH_INTERVAL_MS=4000;/** User-facing error when the primary lease is required but not available. */var PRIMARY_LEASE_LOST_ERROR_MSG='The current tab is not in the required state to perform this operation. '+'It might be necessary to refresh the browser tab.';var PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG='Another tab has exclusive access to the persistence layer. '+'To allow shared access, make sure to invoke '+'`enablePersistence()` with `synchronizeTabs:true` in all tabs.';var UNSUPPORTED_PLATFORM_ERROR_MSG='This platform is either missing'+' IndexedDB or is known to have an incomplete implementation. Offline'+' persistence has been disabled.';// The format of the LocalStorage key that stores zombied client is:
//     firestore_zombie_<persistence_prefix>_<instance_key>
var ZOMBIED_CLIENTS_KEY_PREFIX='firestore_zombie';var IndexedDbTransaction=/** @class */function(_super){tslib_1.__extends(IndexedDbTransaction,_super);function IndexedDbTransaction(simpleDbTransaction,currentSequenceNumber){var _this=_super.call(this)||this;_this.simpleDbTransaction=simpleDbTransaction;_this.currentSequenceNumber=currentSequenceNumber;return _this;}return IndexedDbTransaction;}(PersistenceTransaction);var IndexedDbPersistence=/** @class */function(){// Note that `multiClientParams` must be present to enable multi-client support while multi-tab
// is still experimental. When multi-client is switched to always on, `multiClientParams` will
// no longer be optional.
function IndexedDbPersistence(persistenceKey,clientId,platform,queue,serializer,lruParams,multiClientParams){this.persistenceKey=persistenceKey;this.clientId=clientId;this.queue=queue;this.multiClientParams=multiClientParams;this._started=false;this.isPrimary=false;this.networkEnabled=true;this.inForeground=false;/** The last time we garbage collected the Remote Document Changelog. */this.lastGarbageCollectionTime=Number.NEGATIVE_INFINITY;/** A listener to notify on primary state changes. */this.primaryStateListener=function(_){return Promise.resolve();};if(!IndexedDbPersistence.isAvailable()){throw new FirestoreError(Code.UNIMPLEMENTED,UNSUPPORTED_PLATFORM_ERROR_MSG);}this.referenceDelegate=new IndexedDbLruDelegate(this,lruParams);this.dbName=persistenceKey+IndexedDbPersistence.MAIN_DATABASE;this.serializer=new LocalSerializer(serializer);this.document=platform.document;this.allowTabSynchronization=multiClientParams!==undefined;this.queryCache=new IndexedDbQueryCache(this.referenceDelegate,this.serializer);this.indexManager=new IndexedDbIndexManager();this.remoteDocumentCache=new IndexedDbRemoteDocumentCache(this.serializer,this.indexManager,/*keepDocumentChangeLog=*/this.allowTabSynchronization);if(platform.window&&platform.window.localStorage){this.window=platform.window;this.webStorage=this.window.localStorage;}else{throw new FirestoreError(Code.UNIMPLEMENTED,'IndexedDB persistence is only available on platforms that support LocalStorage.');}}IndexedDbPersistence.getStore=function(txn,store){if(txn instanceof IndexedDbTransaction){return SimpleDb.getStore(txn.simpleDbTransaction,store);}else{throw fail('IndexedDbPersistence must use instances of IndexedDbTransaction');}};IndexedDbPersistence.createIndexedDbPersistence=function(persistenceKey,clientId,platform,queue,serializer,lruParams){return tslib_1.__awaiter(this,void 0,void 0,function(){var persistence;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:persistence=new IndexedDbPersistence(persistenceKey,clientId,platform,queue,serializer,lruParams);return[4/*yield*/,persistence.start()];case 1:_a.sent();return[2/*return*/,persistence];}});});};IndexedDbPersistence.createMultiClientIndexedDbPersistence=function(persistenceKey,clientId,platform,queue,serializer,lruParams,multiClientParams){return tslib_1.__awaiter(this,void 0,void 0,function(){var persistence;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:persistence=new IndexedDbPersistence(persistenceKey,clientId,platform,queue,serializer,lruParams,multiClientParams);return[4/*yield*/,persistence.start()];case 1:_a.sent();return[2/*return*/,persistence];}});});};/**
     * Attempt to start IndexedDb persistence.
     *
     * @return {Promise<void>} Whether persistence was enabled.
     */IndexedDbPersistence.prototype.start=function(){var _this=this;assert(!this.started,'IndexedDbPersistence double-started!');assert(this.window!==null,"Expected 'window' to be defined");return SimpleDb.openOrCreate(this.dbName,SCHEMA_VERSION,new SchemaConverter(this.serializer)).then(function(db){_this.simpleDb=db;// NOTE: This is expected to fail sometimes (in the case of another tab already
// having the persistence lock), so it's the first thing we should do.
return _this.updateClientMetadataAndTryBecomePrimary();}).then(function(){_this.attachVisibilityHandler();_this.attachWindowUnloadHook();_this.scheduleClientMetadataAndPrimaryLeaseRefreshes();return _this.startRemoteDocumentCache();}).then(function(){return _this.simpleDb.runTransaction('readonly',[DbTargetGlobal.store],function(txn){return getHighestListenSequenceNumber(txn).next(function(highestListenSequenceNumber){var sequenceNumberSyncer=_this.multiClientParams?_this.multiClientParams.sequenceNumberSyncer:undefined;_this.listenSequence=new ListenSequence(highestListenSequenceNumber,sequenceNumberSyncer);});});}).then(function(){_this._started=true;}).catch(function(reason){_this.simpleDb&&_this.simpleDb.close();return Promise.reject(reason);});};IndexedDbPersistence.prototype.startRemoteDocumentCache=function(){var _this=this;return this.simpleDb.runTransaction('readonly',ALL_STORES,function(txn){return _this.remoteDocumentCache.start(txn);});};IndexedDbPersistence.prototype.setPrimaryStateListener=function(primaryStateListener){var _this=this;this.primaryStateListener=function(primaryState){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(this.started){return[2/*return*/,primaryStateListener(primaryState)];}return[2/*return*/];});});};return primaryStateListener(this.isPrimary);};IndexedDbPersistence.prototype.setDatabaseDeletedListener=function(databaseDeletedListener){var _this=this;this.simpleDb.setVersionChangeListener(function(event){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!(event.newVersion===null))return[3/*break*/,2];return[4/*yield*/,databaseDeletedListener()];case 1:_a.sent();_a.label=2;case 2:return[2/*return*/];}});});});};IndexedDbPersistence.prototype.setNetworkEnabled=function(networkEnabled){var _this=this;if(this.networkEnabled!==networkEnabled){this.networkEnabled=networkEnabled;// Schedule a primary lease refresh for immediate execution. The eventual
// lease update will be propagated via `primaryStateListener`.
this.queue.enqueueAndForget(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!this.started)return[3/*break*/,2];return[4/*yield*/,this.updateClientMetadataAndTryBecomePrimary()];case 1:_a.sent();_a.label=2;case 2:return[2/*return*/];}});});});}};/**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */IndexedDbPersistence.prototype.updateClientMetadataAndTryBecomePrimary=function(){var _this=this;return this.simpleDb.runTransaction('readwrite',ALL_STORES,function(txn){var metadataStore=clientMetadataStore(txn);return metadataStore.put(new DbClientMetadata(_this.clientId,Date.now(),_this.networkEnabled,_this.inForeground,_this.remoteDocumentCache.lastProcessedDocumentChangeId)).next(function(){if(_this.isPrimary){return _this.verifyPrimaryLease(txn).next(function(success){if(!success){_this.isPrimary=false;_this.queue.enqueueAndForget(function(){return _this.primaryStateListener(false);});}});}}).next(function(){return _this.canActAsPrimary(txn);}).next(function(canActAsPrimary){var wasPrimary=_this.isPrimary;_this.isPrimary=canActAsPrimary;if(wasPrimary!==_this.isPrimary){_this.queue.enqueueAndForget(function(){return _this.primaryStateListener(_this.isPrimary);});}if(wasPrimary&&!_this.isPrimary){return _this.releasePrimaryLeaseIfHeld(txn);}else if(_this.isPrimary){return _this.acquireOrExtendPrimaryLease(txn);}});});};IndexedDbPersistence.prototype.verifyPrimaryLease=function(txn){var _this=this;var store=primaryClientStore(txn);return store.get(DbPrimaryClient.key).next(function(primaryClient){return PersistencePromise.resolve(_this.isLocalClient(primaryClient));});};IndexedDbPersistence.prototype.removeClientMetadata=function(txn){var metadataStore=clientMetadataStore(txn);return metadataStore.delete(this.clientId);};/**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */IndexedDbPersistence.prototype.maybeGarbageCollectMultiClientState=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){var activeClients_1,inactiveClients_1;var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!(this.isPrimary&&!this.isWithinAge(this.lastGarbageCollectionTime,MAX_CLIENT_AGE_MS)))return[3/*break*/,2];this.lastGarbageCollectionTime=Date.now();inactiveClients_1=[];return[4/*yield*/,this.runTransaction('maybeGarbageCollectMultiClientState','readwrite-primary',function(txn){var metadataStore=IndexedDbPersistence.getStore(txn,DbClientMetadata.store);return metadataStore.loadAll().next(function(existingClients){activeClients_1=_this.filterActiveClients(existingClients,MAX_CLIENT_AGE_MS);inactiveClients_1=existingClients.filter(function(client){return activeClients_1.indexOf(client)===-1;});}).next(function(){// Delete metadata for clients that are no longer considered active.
return PersistencePromise.forEach(inactiveClients_1,function(inactiveClient){return metadataStore.delete(inactiveClient.clientId);});}).next(function(){// Retrieve the minimum change ID from the set of active clients.
// The primary client doesn't read from the document change log,
// and hence we exclude it when we determine the minimum
// `lastProcessedDocumentChangeId`.
activeClients_1=activeClients_1.filter(function(client){return client.clientId!==_this.clientId;});if(activeClients_1.length>0){var processedChangeIds=activeClients_1.map(function(client){return client.lastProcessedDocumentChangeId||0;});var oldestChangeId=Math.min.apply(Math,processedChangeIds);return _this.remoteDocumentCache.removeDocumentChangesThroughChangeId(txn,oldestChangeId);}});})];case 1:_a.sent();// Delete potential leftover entries that may continue to mark the
// inactive clients as zombied in LocalStorage.
// Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
// the client atomically, but we can't. So we opt to delete the IndexedDb
// entries first to avoid potentially reviving a zombied client.
inactiveClients_1.forEach(function(inactiveClient){_this.window.localStorage.removeItem(_this.zombiedClientLocalStorageKey(inactiveClient.clientId));});_a.label=2;case 2:return[2/*return*/];}});});};/**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */IndexedDbPersistence.prototype.scheduleClientMetadataAndPrimaryLeaseRefreshes=function(){var _this=this;this.clientMetadataRefresher=this.queue.enqueueAfterDelay(TimerId.ClientMetadataRefresh,CLIENT_METADATA_REFRESH_INTERVAL_MS,function(){return _this.updateClientMetadataAndTryBecomePrimary().then(function(){return _this.maybeGarbageCollectMultiClientState();}).then(function(){return _this.scheduleClientMetadataAndPrimaryLeaseRefreshes();});});};/** Checks whether `client` is the local client. */IndexedDbPersistence.prototype.isLocalClient=function(client){return client?client.ownerId===this.clientId:false;};/**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */IndexedDbPersistence.prototype.canActAsPrimary=function(txn){var _this=this;var store=primaryClientStore(txn);return store.get(DbPrimaryClient.key).next(function(currentPrimary){var currentLeaseIsValid=currentPrimary!==null&&_this.isWithinAge(currentPrimary.leaseTimestampMs,MAX_PRIMARY_ELIGIBLE_AGE_MS)&&!_this.isClientZombied(currentPrimary.ownerId);// A client is eligible for the primary lease if:
// - its network is enabled and the client's tab is in the foreground.
// - its network is enabled and no other client's tab is in the
//   foreground.
// - every clients network is disabled and the client's tab is in the
//   foreground.
// - every clients network is disabled and no other client's tab is in
//   the foreground.
if(currentLeaseIsValid){if(_this.isLocalClient(currentPrimary)&&_this.networkEnabled){return true;}if(!_this.isLocalClient(currentPrimary)){if(!currentPrimary.allowTabSynchronization){// Fail the `canActAsPrimary` check if the current leaseholder has
// not opted into multi-tab synchronization. If this happens at
// client startup, we reject the Promise returned by
// `enablePersistence()` and the user can continue to use Firestore
// with in-memory persistence.
// If this fails during a lease refresh, we will instead block the
// AsyncQueue from executing further operations. Note that this is
// acceptable since mixing & matching different `synchronizeTabs`
// settings is not supported.
//
// TODO(b/114226234): Remove this check when `synchronizeTabs` can
// no longer be turned off.
throw new FirestoreError(Code.FAILED_PRECONDITION,PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);}return false;}}if(_this.networkEnabled&&_this.inForeground){return true;}return clientMetadataStore(txn).loadAll().next(function(existingClients){// Process all existing clients and determine whether at least one of
// them is better suited to obtain the primary lease.
var preferredCandidate=_this.filterActiveClients(existingClients,MAX_PRIMARY_ELIGIBLE_AGE_MS).find(function(otherClient){if(_this.clientId!==otherClient.clientId){var otherClientHasBetterNetworkState=!_this.networkEnabled&&otherClient.networkEnabled;var otherClientHasBetterVisibility=!_this.inForeground&&otherClient.inForeground;var otherClientHasSameNetworkState=_this.networkEnabled===otherClient.networkEnabled;if(otherClientHasBetterNetworkState||otherClientHasBetterVisibility&&otherClientHasSameNetworkState){return true;}}return false;});return preferredCandidate===undefined;});}).next(function(canActAsPrimary){if(_this.isPrimary!==canActAsPrimary){debug(LOG_TAG$2,"Client "+(canActAsPrimary?'is':'is not')+" eligible for a primary lease.");}return canActAsPrimary;});};IndexedDbPersistence.prototype.shutdown=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:// The shutdown() operations are idempotent and can be called even when
// start() aborted (e.g. because it couldn't acquire the persistence lease).
this._started=false;this.markClientZombied();if(this.clientMetadataRefresher){this.clientMetadataRefresher.cancel();}this.detachVisibilityHandler();this.detachWindowUnloadHook();return[4/*yield*/,this.simpleDb.runTransaction('readwrite',[DbPrimaryClient.store,DbClientMetadata.store],function(txn){return _this.releasePrimaryLeaseIfHeld(txn).next(function(){return _this.removeClientMetadata(txn);});})];case 1:_a.sent();this.simpleDb.close();// Remove the entry marking the client as zombied from LocalStorage since
// we successfully deleted its metadata from IndexedDb.
this.removeClientZombiedEntry();return[2/*return*/];}});});};/**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */IndexedDbPersistence.prototype.filterActiveClients=function(clients,activityThresholdMs){var _this=this;return clients.filter(function(client){return _this.isWithinAge(client.updateTimeMs,activityThresholdMs)&&!_this.isClientZombied(client.clientId);});};IndexedDbPersistence.prototype.getActiveClients=function(){var _this=this;return this.simpleDb.runTransaction('readonly',[DbClientMetadata.store],function(txn){return clientMetadataStore(txn).loadAll().next(function(clients){return _this.filterActiveClients(clients,MAX_CLIENT_AGE_MS).map(function(clientMetadata){return clientMetadata.clientId;});});});};IndexedDbPersistence.clearPersistence=function(persistenceKey){return tslib_1.__awaiter(this,void 0,void 0,function(){var dbName;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!IndexedDbPersistence.isAvailable()){return[2/*return*/,Promise.resolve()];}dbName=persistenceKey+IndexedDbPersistence.MAIN_DATABASE;return[4/*yield*/,SimpleDb.delete(dbName)];case 1:_a.sent();return[2/*return*/];}});});};Object.defineProperty(IndexedDbPersistence.prototype,"started",{get:function get(){return this._started;},enumerable:true,configurable:true});IndexedDbPersistence.prototype.getMutationQueue=function(user){assert(this.started,'Cannot initialize MutationQueue before persistence is started.');return IndexedDbMutationQueue.forUser(user,this.serializer,this.indexManager,this.referenceDelegate);};IndexedDbPersistence.prototype.getQueryCache=function(){assert(this.started,'Cannot initialize QueryCache before persistence is started.');return this.queryCache;};IndexedDbPersistence.prototype.getRemoteDocumentCache=function(){assert(this.started,'Cannot initialize RemoteDocumentCache before persistence is started.');return this.remoteDocumentCache;};IndexedDbPersistence.prototype.getIndexManager=function(){assert(this.started,'Cannot initialize IndexManager before persistence is started.');return this.indexManager;};IndexedDbPersistence.prototype.runTransaction=function(action,mode,transactionOperation){var _this=this;debug(LOG_TAG$2,'Starting transaction:',action);// Do all transactions as readwrite against all object stores, since we
// are the only reader/writer.
return this.simpleDb.runTransaction(mode==='readonly'?'readonly':'readwrite',ALL_STORES,function(simpleDbTxn){if(mode==='readwrite-primary'){// While we merely verify that we have (or can acquire) the lease
// immediately, we wait to extend the primary lease until after
// executing transactionOperation(). This ensures that even if the
// transactionOperation takes a long time, we'll use a recent
// leaseTimestampMs in the extended (or newly acquired) lease.
return _this.verifyPrimaryLease(simpleDbTxn).next(function(success){if(!success){error("Failed to obtain primary lease for action '"+action+"'.");_this.isPrimary=false;_this.queue.enqueueAndForget(function(){return _this.primaryStateListener(false);});throw new FirestoreError(Code.FAILED_PRECONDITION,PRIMARY_LEASE_LOST_ERROR_MSG);}return transactionOperation(new IndexedDbTransaction(simpleDbTxn,_this.listenSequence.next()));}).next(function(result){return _this.acquireOrExtendPrimaryLease(simpleDbTxn).next(function(){return result;});});}else{return _this.verifyAllowTabSynchronization(simpleDbTxn).next(function(){return transactionOperation(new IndexedDbTransaction(simpleDbTxn,_this.listenSequence.next()));});}});};/**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */// TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
// be turned off.
IndexedDbPersistence.prototype.verifyAllowTabSynchronization=function(txn){var _this=this;var store=primaryClientStore(txn);return store.get(DbPrimaryClient.key).next(function(currentPrimary){var currentLeaseIsValid=currentPrimary!==null&&_this.isWithinAge(currentPrimary.leaseTimestampMs,MAX_PRIMARY_ELIGIBLE_AGE_MS)&&!_this.isClientZombied(currentPrimary.ownerId);if(currentLeaseIsValid&&!_this.isLocalClient(currentPrimary)){if(!currentPrimary.allowTabSynchronization){throw new FirestoreError(Code.FAILED_PRECONDITION,PRIMARY_LEASE_EXCLUSIVE_ERROR_MSG);}}});};/**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */IndexedDbPersistence.prototype.acquireOrExtendPrimaryLease=function(txn){var newPrimary=new DbPrimaryClient(this.clientId,this.allowTabSynchronization,Date.now());return primaryClientStore(txn).put(DbPrimaryClient.key,newPrimary);};IndexedDbPersistence.isAvailable=function(){return SimpleDb.isAvailable();};/**
     * Generates a string used as a prefix when storing data in IndexedDB and
     * LocalStorage.
     */IndexedDbPersistence.buildStoragePrefix=function(databaseInfo){// Use two different prefix formats:
//
//   * firestore / persistenceKey / projectID . databaseID / ...
//   * firestore / persistenceKey / projectID / ...
//
// projectIDs are DNS-compatible names and cannot contain dots
// so there's no danger of collisions.
var database=databaseInfo.databaseId.projectId;if(!databaseInfo.databaseId.isDefaultDatabase){database+='.'+databaseInfo.databaseId.database;}return'firestore/'+databaseInfo.persistenceKey+'/'+database+'/';};/** Checks the primary lease and removes it if we are the current primary. */IndexedDbPersistence.prototype.releasePrimaryLeaseIfHeld=function(txn){var _this=this;var store=primaryClientStore(txn);return store.get(DbPrimaryClient.key).next(function(primaryClient){if(_this.isLocalClient(primaryClient)){debug(LOG_TAG$2,'Releasing primary lease.');return store.delete(DbPrimaryClient.key);}else{return PersistencePromise.resolve();}});};/** Verifies that `updateTimeMs` is within `maxAgeMs`. */IndexedDbPersistence.prototype.isWithinAge=function(updateTimeMs,maxAgeMs){var now=Date.now();var minAcceptable=now-maxAgeMs;var maxAcceptable=now;if(updateTimeMs<minAcceptable){return false;}else if(updateTimeMs>maxAcceptable){error("Detected an update time that is in the future: "+updateTimeMs+" > "+maxAcceptable);return false;}return true;};IndexedDbPersistence.prototype.attachVisibilityHandler=function(){var _this=this;if(this.document!==null&&typeof this.document.addEventListener==='function'){this.documentVisibilityHandler=function(){_this.queue.enqueueAndForget(function(){_this.inForeground=_this.document.visibilityState==='visible';return _this.updateClientMetadataAndTryBecomePrimary();});};this.document.addEventListener('visibilitychange',this.documentVisibilityHandler);this.inForeground=this.document.visibilityState==='visible';}};IndexedDbPersistence.prototype.detachVisibilityHandler=function(){if(this.documentVisibilityHandler){assert(this.document!==null&&typeof this.document.addEventListener==='function',"Expected 'document.addEventListener' to be a function");this.document.removeEventListener('visibilitychange',this.documentVisibilityHandler);this.documentVisibilityHandler=null;}};/**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */IndexedDbPersistence.prototype.attachWindowUnloadHook=function(){var _this=this;if(typeof this.window.addEventListener==='function'){this.windowUnloadHandler=function(){// Note: In theory, this should be scheduled on the AsyncQueue since it
// accesses internal state. We execute this code directly during shutdown
// to make sure it gets a chance to run.
_this.markClientZombied();_this.queue.enqueueAndForget(function(){// Attempt graceful shutdown (including releasing our primary lease),
// but there's no guarantee it will complete.
return _this.shutdown();});};this.window.addEventListener('unload',this.windowUnloadHandler);}};IndexedDbPersistence.prototype.detachWindowUnloadHook=function(){if(this.windowUnloadHandler){assert(typeof this.window.removeEventListener==='function',"Expected 'window.removeEventListener' to be a function");this.window.removeEventListener('unload',this.windowUnloadHandler);this.windowUnloadHandler=null;}};/**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */IndexedDbPersistence.prototype.isClientZombied=function(clientId){try{var isZombied=this.webStorage.getItem(this.zombiedClientLocalStorageKey(clientId))!==null;debug(LOG_TAG$2,"Client '"+clientId+"' "+(isZombied?'is':'is not')+" zombied in LocalStorage");return isZombied;}catch(e){// Gracefully handle if LocalStorage isn't working.
error(LOG_TAG$2,'Failed to get zombied client id.',e);return false;}};/**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */IndexedDbPersistence.prototype.markClientZombied=function(){try{this.webStorage.setItem(this.zombiedClientLocalStorageKey(this.clientId),String(Date.now()));}catch(e){// Gracefully handle if LocalStorage isn't available / working.
error('Failed to set zombie client id.',e);}};/** Removes the zombied client entry if it exists. */IndexedDbPersistence.prototype.removeClientZombiedEntry=function(){try{this.webStorage.removeItem(this.zombiedClientLocalStorageKey(this.clientId));}catch(e){// Ignore
}};IndexedDbPersistence.prototype.zombiedClientLocalStorageKey=function(clientId){return ZOMBIED_CLIENTS_KEY_PREFIX+"_"+this.persistenceKey+"_"+clientId;};/**
     * The name of the main (and currently only) IndexedDB database. this name is
     * appended to the prefix provided to the IndexedDbPersistence constructor.
     */IndexedDbPersistence.MAIN_DATABASE='main';return IndexedDbPersistence;}();function isPrimaryLeaseLostError(err){return err.code===Code.FAILED_PRECONDITION&&err.message===PRIMARY_LEASE_LOST_ERROR_MSG;}/**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err An error returned by a LocalStore operation.
 * @return A Promise that resolves after we recovered, or the original error.
 */function ignoreIfPrimaryLeaseLoss(err){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(isPrimaryLeaseLostError(err)){debug(LOG_TAG$2,'Unexpectedly lost primary lease');}else{throw err;}return[2/*return*/];});});}/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */function primaryClientStore(txn){return txn.store(DbPrimaryClient.store);}/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */function clientMetadataStore(txn){return txn.store(DbClientMetadata.store);}/** Provides LRU functionality for IndexedDB persistence. */var IndexedDbLruDelegate=/** @class */function(){function IndexedDbLruDelegate(db,params){this.db=db;this.garbageCollector=new LruGarbageCollector(this,params);}IndexedDbLruDelegate.prototype.getSequenceNumberCount=function(txn){var docCountPromise=this.orphanedDocmentCount(txn);var targetCountPromise=this.db.getQueryCache().getQueryCount(txn);return targetCountPromise.next(function(targetCount){return docCountPromise.next(function(docCount){return targetCount+docCount;});});};IndexedDbLruDelegate.prototype.orphanedDocmentCount=function(txn){var orphanedCount=0;return this.forEachOrphanedDocumentSequenceNumber(txn,function(_){orphanedCount++;}).next(function(){return orphanedCount;});};IndexedDbLruDelegate.prototype.forEachTarget=function(txn,f){return this.db.getQueryCache().forEachTarget(txn,f);};IndexedDbLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber=function(txn,f){return this.forEachOrphanedDocument(txn,function(docKey,sequenceNumber){return f(sequenceNumber);});};IndexedDbLruDelegate.prototype.setInMemoryPins=function(inMemoryPins){this.inMemoryPins=inMemoryPins;};IndexedDbLruDelegate.prototype.addReference=function(txn,key){return writeSentinelKey(txn,key);};IndexedDbLruDelegate.prototype.removeReference=function(txn,key){return writeSentinelKey(txn,key);};IndexedDbLruDelegate.prototype.removeTargets=function(txn,upperBound,activeTargetIds){return this.db.getQueryCache().removeTargets(txn,upperBound,activeTargetIds);};IndexedDbLruDelegate.prototype.removeMutationReference=function(txn,key){return writeSentinelKey(txn,key);};/**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */IndexedDbLruDelegate.prototype.isPinned=function(txn,docKey){if(this.inMemoryPins.containsKey(docKey)){return PersistencePromise.resolve(true);}else{return mutationQueuesContainKey(txn,docKey);}};IndexedDbLruDelegate.prototype.removeOrphanedDocuments=function(txn,upperBound){var _this=this;var count=0;var bytesRemoved=0;var promises=[];var iteration=this.forEachOrphanedDocument(txn,function(docKey,sequenceNumber){if(sequenceNumber<=upperBound){var p=_this.isPinned(txn,docKey).next(function(isPinned){if(!isPinned){count++;return _this.removeOrphanedDocument(txn,docKey).next(function(documentBytes){bytesRemoved+=documentBytes;});}});promises.push(p);}});// Wait for iteration first to make sure we have a chance to add all of the
// removal promises to the array.
return iteration.next(function(){return PersistencePromise.waitFor(promises);}).next(function(){return _this.db.getRemoteDocumentCache().updateSize(txn,-bytesRemoved);}).next(function(){return count;});};/**
     * Clears a document from the cache. The document is assumed to be orphaned, so target-document
     * associations are not queried. We remove it from the remote document cache, as well as remove
     * its sentinel row.
     */IndexedDbLruDelegate.prototype.removeOrphanedDocument=function(txn,docKey){var totalBytesRemoved=0;var documentCache=this.db.getRemoteDocumentCache();return PersistencePromise.waitFor([documentTargetStore(txn).delete(sentinelKey$1(docKey)),documentCache.removeEntry(txn,docKey).next(function(bytesRemoved){totalBytesRemoved+=bytesRemoved;})]).next(function(){return totalBytesRemoved;});};IndexedDbLruDelegate.prototype.removeTarget=function(txn,queryData){var updated=queryData.copy({sequenceNumber:txn.currentSequenceNumber});return this.db.getQueryCache().updateQueryData(txn,updated);};IndexedDbLruDelegate.prototype.updateLimboDocument=function(txn,key){return writeSentinelKey(txn,key);};/**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */IndexedDbLruDelegate.prototype.forEachOrphanedDocument=function(txn,f){var store=documentTargetStore(txn);var nextToReport=ListenSequence.INVALID;var nextPath;return store.iterate({index:DbTargetDocument.documentTargetsIndex},function(_a,_b){var targetId=_a[0],docKey=_a[1];var path=_b.path,sequenceNumber=_b.sequenceNumber;if(targetId===0){// if nextToReport is valid, report it, this is a new key so the
// last one must not be a member of any targets.
if(nextToReport!==ListenSequence.INVALID){f(new DocumentKey(decode(nextPath)),nextToReport);}// set nextToReport to be this sequence number. It's the next one we
// might report, if we don't find any targets for this document.
// Note that the sequence number must be defined when the targetId
// is 0.
nextToReport=sequenceNumber;nextPath=path;}else{// set nextToReport to be invalid, we know we don't need to report
// this one since we found a target for it.
nextToReport=ListenSequence.INVALID;}}).next(function(){// Since we report sequence numbers after getting to the next key, we
// need to check if the last key we iterated over was an orphaned
// document and report it.
if(nextToReport!==ListenSequence.INVALID){f(new DocumentKey(decode(nextPath)),nextToReport);}});};IndexedDbLruDelegate.prototype.getCacheSize=function(txn){return this.db.getRemoteDocumentCache().getSize(txn);};return IndexedDbLruDelegate;}();function sentinelKey$1(key){return[0,encode(key.path)];}/**
 * @return A value suitable for writing a sentinel row in the target-document
 * store.
 */function sentinelRow(key,sequenceNumber){return new DbTargetDocument(0,encode(key.path),sequenceNumber);}function writeSentinelKey(txn,key){return documentTargetStore(txn).put(sentinelRow(key,txn.currentSequenceNumber));}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */var LocalDocumentsView=/** @class */function(){function LocalDocumentsView(remoteDocumentCache,mutationQueue,indexManager){this.remoteDocumentCache=remoteDocumentCache;this.mutationQueue=mutationQueue;this.indexManager=indexManager;}/**
     * Get the local view of the document identified by `key`.
     *
     * @return Local view of the document or null if we don't have any cached
     * state for it.
     */LocalDocumentsView.prototype.getDocument=function(transaction,key){var _this=this;return this.mutationQueue.getAllMutationBatchesAffectingDocumentKey(transaction,key).next(function(batches){return _this.getDocumentInternal(transaction,key,batches);});};/** Internal version of `getDocument` that allows reusing batches. */LocalDocumentsView.prototype.getDocumentInternal=function(transaction,key,inBatches){return this.remoteDocumentCache.getEntry(transaction,key).next(function(doc){for(var _i=0,inBatches_1=inBatches;_i<inBatches_1.length;_i++){var batch=inBatches_1[_i];doc=batch.applyToLocalView(key,doc);}return doc;});};// Returns the view of the given `docs` as they would appear after applying
// all mutations in the given `batches`.
LocalDocumentsView.prototype.applyLocalMutationsToDocuments=function(transaction,docs,batches){var results=nullableMaybeDocumentMap();docs.forEach(function(key,localView){for(var _i=0,batches_1=batches;_i<batches_1.length;_i++){var batch=batches_1[_i];localView=batch.applyToLocalView(key,localView);}results=results.insert(key,localView);});return results;};/**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */LocalDocumentsView.prototype.getDocuments=function(transaction,keys){var _this=this;return this.remoteDocumentCache.getEntries(transaction,keys).next(function(docs){return _this.getLocalViewOfDocuments(transaction,docs);});};/**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     */LocalDocumentsView.prototype.getLocalViewOfDocuments=function(transaction,baseDocs){var _this=this;return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(transaction,baseDocs).next(function(batches){var docs=_this.applyLocalMutationsToDocuments(transaction,baseDocs,batches);var results=maybeDocumentMap();docs.forEach(function(key,maybeDoc){// TODO(http://b/32275378): Don't conflate missing / deleted.
if(!maybeDoc){maybeDoc=new NoDocument(key,SnapshotVersion.forDeletedDoc());}results=results.insert(key,maybeDoc);});return results;});};/** Performs a query against the local view of all documents. */LocalDocumentsView.prototype.getDocumentsMatchingQuery=function(transaction,query){if(query.isDocumentQuery()){return this.getDocumentsMatchingDocumentQuery(transaction,query.path);}else if(query.isCollectionGroupQuery()){return this.getDocumentsMatchingCollectionGroupQuery(transaction,query);}else{return this.getDocumentsMatchingCollectionQuery(transaction,query);}};LocalDocumentsView.prototype.getDocumentsMatchingDocumentQuery=function(transaction,docPath){// Just do a simple document lookup.
return this.getDocument(transaction,new DocumentKey(docPath)).next(function(maybeDoc){var result=documentMap();if(maybeDoc instanceof Document){result=result.insert(maybeDoc.key,maybeDoc);}return result;});};LocalDocumentsView.prototype.getDocumentsMatchingCollectionGroupQuery=function(transaction,query){var _this=this;assert(query.path.isEmpty(),'Currently we only support collection group queries at the root.');var collectionId=query.collectionGroup;var results=documentMap();return this.indexManager.getCollectionParents(transaction,collectionId).next(function(parents){// Perform a collection query against each parent that contains the
// collectionId and aggregate the results.
return PersistencePromise.forEach(parents,function(parent){var collectionQuery=query.asCollectionQueryAtPath(parent.child(collectionId));return _this.getDocumentsMatchingCollectionQuery(transaction,collectionQuery).next(function(r){r.forEach(function(key,doc){results=results.insert(key,doc);});});}).next(function(){return results;});});};LocalDocumentsView.prototype.getDocumentsMatchingCollectionQuery=function(transaction,query){var _this=this;// Query the remote documents and overlay mutations.
var results;return this.remoteDocumentCache.getDocumentsMatchingQuery(transaction,query).next(function(queryResults){results=queryResults;return _this.mutationQueue.getAllMutationBatchesAffectingQuery(transaction,query);}).next(function(matchingMutationBatches){for(var _i=0,matchingMutationBatches_1=matchingMutationBatches;_i<matchingMutationBatches_1.length;_i++){var batch=matchingMutationBatches_1[_i];for(var _a=0,_b=batch.mutations;_a<_b.length;_a++){var mutation=_b[_a];var key=mutation.key;// Only process documents belonging to the collection.
if(!query.path.isImmediateParentOf(key.path)){continue;}var baseDoc=results.get(key);var mutatedDoc=mutation.applyToLocalView(baseDoc,baseDoc,batch.localWriteTime);if(mutatedDoc instanceof Document){results=results.insert(key,mutatedDoc);}else{results=results.remove(key);}}}}).next(function(){// Finally, filter out any documents that don't actually match
// the query.
results.forEach(function(key,doc){if(!query.matches(doc)){results=results.remove(key);}});return results;});};return LocalDocumentsView;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */var ReferenceSet=/** @class */function(){function ReferenceSet(){// A set of outstanding references to a document sorted by key.
this.refsByKey=new SortedSet(DocReference.compareByKey);// A set of outstanding references to a document sorted by target id.
this.refsByTarget=new SortedSet(DocReference.compareByTargetId);}/** Returns true if the reference set contains no references. */ReferenceSet.prototype.isEmpty=function(){return this.refsByKey.isEmpty();};/** Adds a reference to the given document key for the given ID. */ReferenceSet.prototype.addReference=function(key,id){var ref=new DocReference(key,id);this.refsByKey=this.refsByKey.add(ref);this.refsByTarget=this.refsByTarget.add(ref);};/** Add references to the given document keys for the given ID. */ReferenceSet.prototype.addReferences=function(keys,id){var _this=this;keys.forEach(function(key){return _this.addReference(key,id);});};/**
     * Removes a reference to the given document key for the given
     * ID.
     */ReferenceSet.prototype.removeReference=function(key,id){this.removeRef(new DocReference(key,id));};ReferenceSet.prototype.removeReferences=function(keys,id){var _this=this;keys.forEach(function(key){return _this.removeReference(key,id);});};/**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ReferenceSet.prototype.removeReferencesForId=function(id){var _this=this;var emptyKey=DocumentKey.EMPTY;var startRef=new DocReference(emptyKey,id);var endRef=new DocReference(emptyKey,id+1);var keys=[];this.refsByTarget.forEachInRange([startRef,endRef],function(ref){_this.removeRef(ref);keys.push(ref.key);});return keys;};ReferenceSet.prototype.removeAllReferences=function(){var _this=this;this.refsByKey.forEach(function(ref){return _this.removeRef(ref);});};ReferenceSet.prototype.removeRef=function(ref){this.refsByKey=this.refsByKey.delete(ref);this.refsByTarget=this.refsByTarget.delete(ref);};ReferenceSet.prototype.referencesForId=function(id){var emptyKey=DocumentKey.EMPTY;var startRef=new DocReference(emptyKey,id);var endRef=new DocReference(emptyKey,id+1);var keys=documentKeySet();this.refsByTarget.forEachInRange([startRef,endRef],function(ref){keys=keys.add(ref.key);});return keys;};ReferenceSet.prototype.containsKey=function(key){var ref=new DocReference(key,0);var firstRef=this.refsByKey.firstAfterOrEqual(ref);return firstRef!==null&&key.isEqual(firstRef.key);};return ReferenceSet;}();var DocReference=/** @class */function(){function DocReference(key,targetOrBatchId){this.key=key;this.targetOrBatchId=targetOrBatchId;}/** Compare by key then by ID */DocReference.compareByKey=function(left,right){return DocumentKey.comparator(left.key,right.key)||primitiveComparator(left.targetOrBatchId,right.targetOrBatchId);};/** Compare by ID then by key */DocReference.compareByTargetId=function(left,right){return primitiveComparator(left.targetOrBatchId,right.targetOrBatchId)||DocumentKey.comparator(left.key,right.key);};return DocReference;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$3='LocalStore';/**
 * Local storage in the Firestore client. Coordinates persistence components
 * like the mutation queue and remote document cache to present a
 * latency-compensated view of stored data.
 *
 * The LocalStore is responsible for accepting mutations from the Sync Engine.
 * Writes from the client are put into a queue as provisional Mutations until
 * they are processed by the RemoteStore and confirmed as having been written
 * to the server.
 *
 * The local store provides the local version of documents that have been
 * modified locally. It maintains the constraint:
 *
 *   LocalDocument = RemoteDocument + Active(LocalMutations)
 *
 * (Active mutations are those that are enqueued and have not been previously
 * acknowledged or rejected).
 *
 * The RemoteDocument ("ground truth") state is provided via the
 * applyChangeBatch method. It will be some version of a server-provided
 * document OR will be a server-provided document PLUS acknowledged mutations:
 *
 *   RemoteDocument' = RemoteDocument + Acknowledged(LocalMutations)
 *
 * Note that this "dirty" version of a RemoteDocument will not be identical to a
 * server base version, since it has LocalMutations added to it pending getting
 * an authoritative copy from the server.
 *
 * Since LocalMutations can be rejected by the server, we have to be able to
 * revert a LocalMutation that has already been applied to the LocalDocument
 * (typically done by replaying all remaining LocalMutations to the
 * RemoteDocument to re-apply).
 *
 * The LocalStore is responsible for the garbage collection of the documents it
 * contains. For now, it every doc referenced by a view, the mutation queue, or
 * the RemoteStore.
 *
 * It also maintains the persistence of mapping queries to resume tokens and
 * target ids. It needs to know this data about queries to properly know what
 * docs it would be allowed to garbage collect.
 *
 * The LocalStore must be able to efficiently execute queries against its local
 * cache of the documents, to provide the initial set of results before any
 * remote changes have been received.
 *
 * Note: In TypeScript, most methods return Promises since the implementation
 * may rely on fetching data from IndexedDB which is async.
 * These Promises will only be rejected on an I/O error or other internal
 * (unexpected) failure (e.g. failed assert) and always represent an
 * unrecoverable error (should be caught / reported by the async_queue).
 */var LocalStore=/** @class */function(){function LocalStore(/** Manages our in-memory or durable persistence. */persistence,initialUser){this.persistence=persistence;/**
         * The set of document references maintained by any local views.
         */this.localViewReferences=new ReferenceSet();/** Maps a targetID to data about its query. */this.queryDataByTarget={};assert(persistence.started,'LocalStore was passed an unstarted persistence implementation');this.persistence.referenceDelegate.setInMemoryPins(this.localViewReferences);this.mutationQueue=persistence.getMutationQueue(initialUser);this.remoteDocuments=persistence.getRemoteDocumentCache();this.queryCache=persistence.getQueryCache();this.localDocuments=new LocalDocumentsView(this.remoteDocuments,this.mutationQueue,this.persistence.getIndexManager());}/**
     * Tells the LocalStore that the currently authenticated user has changed.
     *
     * In response the local store switches the mutation queue to the new user and
     * returns any resulting document changes.
     */// PORTING NOTE: Android and iOS only return the documents affected by the
// change.
LocalStore.prototype.handleUserChange=function(user){var _this=this;return this.persistence.runTransaction('Handle user change','readonly',function(txn){// Swap out the mutation queue, grabbing the pending mutation batches
// before and after.
var oldBatches;return _this.mutationQueue.getAllMutationBatches(txn).next(function(promisedOldBatches){oldBatches=promisedOldBatches;_this.mutationQueue=_this.persistence.getMutationQueue(user);// Recreate our LocalDocumentsView using the new
// MutationQueue.
_this.localDocuments=new LocalDocumentsView(_this.remoteDocuments,_this.mutationQueue,_this.persistence.getIndexManager());return _this.mutationQueue.getAllMutationBatches(txn);}).next(function(newBatches){var removedBatchIds=[];var addedBatchIds=[];// Union the old/new changed keys.
var changedKeys=documentKeySet();for(var _i=0,oldBatches_1=oldBatches;_i<oldBatches_1.length;_i++){var batch=oldBatches_1[_i];removedBatchIds.push(batch.batchId);for(var _a=0,_b=batch.mutations;_a<_b.length;_a++){var mutation=_b[_a];changedKeys=changedKeys.add(mutation.key);}}for(var _c=0,newBatches_1=newBatches;_c<newBatches_1.length;_c++){var batch=newBatches_1[_c];addedBatchIds.push(batch.batchId);for(var _d=0,_e=batch.mutations;_d<_e.length;_d++){var mutation=_e[_d];changedKeys=changedKeys.add(mutation.key);}}// Return the set of all (potentially) changed documents and the list
// of mutation batch IDs that were affected by change.
return _this.localDocuments.getDocuments(txn,changedKeys).next(function(affectedDocuments){return{affectedDocuments:affectedDocuments,removedBatchIds:removedBatchIds,addedBatchIds:addedBatchIds};});});});};/* Accept locally generated Mutations and commit them to storage. */LocalStore.prototype.localWrite=function(mutations){var _this=this;var localWriteTime=Timestamp.now();var keys=mutations.reduce(function(keys,m){return keys.add(m.key);},documentKeySet());return this.persistence.runTransaction('Locally write mutations','readwrite',function(txn){// Load and apply all existing mutations. This lets us compute the
// current base state for all non-idempotent transforms before applying
// any additional user-provided writes.
return _this.localDocuments.getDocuments(txn,keys).next(function(existingDocs){// For non-idempotent mutations (such as `FieldValue.increment()`),
// we record the base state in a separate patch mutation. This is
// later used to guarantee consistent values and prevents flicker
// even if the backend sends us an update that already includes our
// transform.
var baseMutations=[];for(var _i=0,mutations_1=mutations;_i<mutations_1.length;_i++){var mutation=mutations_1[_i];var maybeDoc=existingDocs.get(mutation.key);if(!mutation.isIdempotent){// Theoretically, we should only include non-idempotent fields
// in this field mask as this mask is used to populate the base
// state for all DocumentTransforms.  By  including all fields,
// we incorrectly prevent rebasing of idempotent transforms
// (such as `arrayUnion()`) when any non-idempotent transforms
// are present.
var fieldMask=mutation.fieldMask;if(fieldMask){var baseValues=maybeDoc instanceof Document?fieldMask.applyTo(maybeDoc.data):ObjectValue.EMPTY;// NOTE: The base state should only be applied if there's some
// existing document to override, so use a Precondition of
// exists=true
baseMutations.push(new PatchMutation(mutation.key,baseValues,fieldMask,Precondition.exists(true)));}}}return _this.mutationQueue.addMutationBatch(txn,localWriteTime,baseMutations,mutations).next(function(batch){var changes=batch.applyToLocalDocumentSet(existingDocs);return{batchId:batch.batchId,changes:changes};});});});};/** Returns the local view of the documents affected by a mutation batch. */// PORTING NOTE: Multi-tab only.
LocalStore.prototype.lookupMutationDocuments=function(batchId){var _this=this;return this.persistence.runTransaction('Lookup mutation documents','readonly',function(txn){return _this.mutationQueue.lookupMutationKeys(txn,batchId).next(function(keys){if(keys){return _this.localDocuments.getDocuments(txn,keys);}else{return PersistencePromise.resolve(null);}});});};/**
     * Acknowledge the given batch.
     *
     * On the happy path when a batch is acknowledged, the local store will
     *
     *  + remove the batch from the mutation queue;
     *  + apply the changes to the remote document cache;
     *  + recalculate the latency compensated view implied by those changes (there
     *    may be mutations in the queue that affect the documents but haven't been
     *    acknowledged yet); and
     *  + give the changed documents back the sync engine
     *
     * @returns The resulting (modified) documents.
     */LocalStore.prototype.acknowledgeBatch=function(batchResult){var _this=this;return this.persistence.runTransaction('Acknowledge batch','readwrite-primary',function(txn){var affected=batchResult.batch.keys();var documentBuffer=_this.remoteDocuments.newChangeBuffer();return _this.mutationQueue.acknowledgeBatch(txn,batchResult.batch,batchResult.streamToken).next(function(){return _this.applyWriteToRemoteDocuments(txn,batchResult,documentBuffer);}).next(function(){return documentBuffer.apply(txn);}).next(function(){return _this.mutationQueue.performConsistencyCheck(txn);}).next(function(){return _this.localDocuments.getDocuments(txn,affected);});});};/**
     * Remove mutations from the MutationQueue for the specified batch;
     * LocalDocuments will be recalculated.
     *
     * @returns The resulting modified documents.
     */LocalStore.prototype.rejectBatch=function(batchId){var _this=this;return this.persistence.runTransaction('Reject batch','readwrite-primary',function(txn){var affectedKeys;return _this.mutationQueue.lookupMutationBatch(txn,batchId).next(function(batch){assert(batch!==null,'Attempt to reject nonexistent batch!');affectedKeys=batch.keys();return _this.mutationQueue.removeMutationBatch(txn,batch);}).next(function(){return _this.mutationQueue.performConsistencyCheck(txn);}).next(function(){return _this.localDocuments.getDocuments(txn,affectedKeys);});});};/** Returns the last recorded stream token for the current user. */LocalStore.prototype.getLastStreamToken=function(){var _this=this;return this.persistence.runTransaction('Get last stream token','readonly',function(txn){return _this.mutationQueue.getLastStreamToken(txn);});};/**
     * Sets the stream token for the current user without acknowledging any
     * mutation batch. This is usually only useful after a stream handshake or in
     * response to an error that requires clearing the stream token.
     */LocalStore.prototype.setLastStreamToken=function(streamToken){var _this=this;return this.persistence.runTransaction('Set last stream token','readwrite-primary',function(txn){return _this.mutationQueue.setLastStreamToken(txn,streamToken);});};/**
     * Returns the last consistent snapshot processed (used by the RemoteStore to
     * determine whether to buffer incoming snapshots from the backend).
     */LocalStore.prototype.getLastRemoteSnapshotVersion=function(){var _this=this;return this.persistence.runTransaction('Get last remote snapshot version','readonly',function(txn){return _this.queryCache.getLastRemoteSnapshotVersion(txn);});};/**
     * Update the "ground-state" (remote) documents. We assume that the remote
     * event reflects any write batches that have been acknowledged or rejected
     * (i.e. we do not re-apply local mutations to updates from this event).
     *
     * LocalDocuments are re-calculated if there are remaining mutations in the
     * queue.
     */LocalStore.prototype.applyRemoteEvent=function(remoteEvent){var _this=this;var documentBuffer=this.remoteDocuments.newChangeBuffer();return this.persistence.runTransaction('Apply remote event','readwrite-primary',function(txn){var promises=[];var authoritativeUpdates=documentKeySet();forEachNumber(remoteEvent.targetChanges,function(targetId,change){// Do not ref/unref unassigned targetIds - it may lead to leaks.
var queryData=_this.queryDataByTarget[targetId];if(!queryData)return;// When a global snapshot contains updates (either add or modify) we
// can completely trust these updates as authoritative and blindly
// apply them to our cache (as a defensive measure to promote
// self-healing in the unfortunate case that our cache is ever somehow
// corrupted / out-of-sync).
//
// If the document is only updated while removing it from a target
// then watch isn't obligated to send the absolute latest version: it
// can send the first version that caused the document not to match.
change.addedDocuments.forEach(function(key){authoritativeUpdates=authoritativeUpdates.add(key);});change.modifiedDocuments.forEach(function(key){authoritativeUpdates=authoritativeUpdates.add(key);});promises.push(_this.queryCache.removeMatchingKeys(txn,change.removedDocuments,targetId).next(function(){return _this.queryCache.addMatchingKeys(txn,change.addedDocuments,targetId);}));// Update the resume token if the change includes one. Don't clear
// any preexisting value.
var resumeToken=change.resumeToken;if(resumeToken.length>0){var oldQueryData=queryData;queryData=queryData.copy({resumeToken:resumeToken,snapshotVersion:remoteEvent.snapshotVersion});_this.queryDataByTarget[targetId]=queryData;if(LocalStore.shouldPersistQueryData(oldQueryData,queryData,change)){promises.push(_this.queryCache.updateQueryData(txn,queryData));}}});var changedDocs=maybeDocumentMap();var updatedKeys=documentKeySet();remoteEvent.documentUpdates.forEach(function(key,doc){updatedKeys=updatedKeys.add(key);});// Each loop iteration only affects its "own" doc, so it's safe to get all the remote
// documents in advance in a single call.
promises.push(documentBuffer.getEntries(txn,updatedKeys).next(function(existingDocs){remoteEvent.documentUpdates.forEach(function(key,doc){var existingDoc=existingDocs.get(key);// If a document update isn't authoritative, make sure we don't
// apply an old document version to the remote cache. We make an
// exception for SnapshotVersion.MIN which can happen for
// manufactured events (e.g. in the case of a limbo document
// resolution failing).
if(existingDoc==null||doc.version.isEqual(SnapshotVersion.MIN)||authoritativeUpdates.has(doc.key)&&!existingDoc.hasPendingWrites||doc.version.compareTo(existingDoc.version)>=0){documentBuffer.addEntry(doc);changedDocs=changedDocs.insert(key,doc);}else{debug(LOG_TAG$3,'Ignoring outdated watch update for ',key,'. Current version:',existingDoc.version,' Watch version:',doc.version);}if(remoteEvent.resolvedLimboDocuments.has(key)){promises.push(_this.persistence.referenceDelegate.updateLimboDocument(txn,key));}});}));// HACK: The only reason we allow a null snapshot version is so that we
// can synthesize remote events when we get permission denied errors while
// trying to resolve the state of a locally cached document that is in
// limbo.
var remoteVersion=remoteEvent.snapshotVersion;if(!remoteVersion.isEqual(SnapshotVersion.MIN)){var updateRemoteVersion=_this.queryCache.getLastRemoteSnapshotVersion(txn).next(function(lastRemoteVersion){assert(remoteVersion.compareTo(lastRemoteVersion)>=0,'Watch stream reverted to previous snapshot?? '+remoteVersion+' < '+lastRemoteVersion);return _this.queryCache.setTargetsMetadata(txn,txn.currentSequenceNumber,remoteVersion);});promises.push(updateRemoteVersion);}return PersistencePromise.waitFor(promises).next(function(){return documentBuffer.apply(txn);}).next(function(){return _this.localDocuments.getLocalViewOfDocuments(txn,changedDocs);});});};/**
     * Returns true if the newQueryData should be persisted during an update of
     * an active target. QueryData should always be persisted when a target is
     * being released and should not call this function.
     *
     * While the target is active, QueryData updates can be omitted when nothing
     * about the target has changed except metadata like the resume token or
     * snapshot version. Occasionally it's worth the extra write to prevent these
     * values from getting too stale after a crash, but this doesn't have to be
     * too frequent.
     */LocalStore.shouldPersistQueryData=function(oldQueryData,newQueryData,change){// Avoid clearing any existing value
if(newQueryData.resumeToken.length===0)return false;// Any resume token is interesting if there isn't one already.
if(oldQueryData.resumeToken.length===0)return true;// Don't allow resume token changes to be buffered indefinitely. This
// allows us to be reasonably up-to-date after a crash and avoids needing
// to loop over all active queries on shutdown. Especially in the browser
// we may not get time to do anything interesting while the current tab is
// closing.
var timeDelta=newQueryData.snapshotVersion.toMicroseconds()-oldQueryData.snapshotVersion.toMicroseconds();if(timeDelta>=this.RESUME_TOKEN_MAX_AGE_MICROS)return true;// Otherwise if the only thing that has changed about a target is its resume
// token it's not worth persisting. Note that the RemoteStore keeps an
// in-memory view of the currently active targets which includes the current
// resume token, so stream failure or user changes will still use an
// up-to-date resume token regardless of what we do here.
var changes=change.addedDocuments.size+change.modifiedDocuments.size+change.removedDocuments.size;return changes>0;};/**
     * Notify local store of the changed views to locally pin documents.
     */LocalStore.prototype.notifyLocalViewChanges=function(viewChanges){var _this=this;return this.persistence.runTransaction('notifyLocalViewChanges','readwrite',function(txn){return PersistencePromise.forEach(viewChanges,function(viewChange){_this.localViewReferences.addReferences(viewChange.addedKeys,viewChange.targetId);_this.localViewReferences.removeReferences(viewChange.removedKeys,viewChange.targetId);return PersistencePromise.forEach(viewChange.removedKeys,function(key){return _this.persistence.referenceDelegate.removeReference(txn,key);});});});};/**
     * Gets the mutation batch after the passed in batchId in the mutation queue
     * or null if empty.
     * @param afterBatchId If provided, the batch to search after.
     * @returns The next mutation or null if there wasn't one.
     */LocalStore.prototype.nextMutationBatch=function(afterBatchId){var _this=this;return this.persistence.runTransaction('Get next mutation batch','readonly',function(txn){if(afterBatchId===undefined){afterBatchId=BATCHID_UNKNOWN;}return _this.mutationQueue.getNextMutationBatchAfterBatchId(txn,afterBatchId);});};/**
     * Read the current value of a Document with a given key or null if not
     * found - used for testing.
     */LocalStore.prototype.readDocument=function(key){var _this=this;return this.persistence.runTransaction('read document','readonly',function(txn){return _this.localDocuments.getDocument(txn,key);});};/**
     * Assigns the given query an internal ID so that its results can be pinned so
     * they don't get GC'd. A query must be allocated in the local store before
     * the store can be used to manage its view.
     */LocalStore.prototype.allocateQuery=function(query){var _this=this;return this.persistence.runTransaction('Allocate query','readwrite',function(txn){var queryData;return _this.queryCache.getQueryData(txn,query).next(function(cached){if(cached){// This query has been listened to previously, so reuse the
// previous targetID.
// TODO(mcg): freshen last accessed date?
queryData=cached;return PersistencePromise.resolve();}else{return _this.queryCache.allocateTargetId(txn).next(function(targetId){queryData=new QueryData(query,targetId,QueryPurpose.Listen,txn.currentSequenceNumber);return _this.queryCache.addQueryData(txn,queryData);});}}).next(function(){assert(!_this.queryDataByTarget[queryData.targetId],'Tried to allocate an already allocated query: '+query);_this.queryDataByTarget[queryData.targetId]=queryData;return queryData;});});};/**
     * Unpin all the documents associated with the given query. If
     * `keepPersistedQueryData` is set to false and Eager GC enabled, the method
     * directly removes the associated query data from the query cache.
     */// PORTING NOTE: `keepPersistedQueryData` is multi-tab only.
LocalStore.prototype.releaseQuery=function(query,keepPersistedQueryData){var _this=this;var mode=keepPersistedQueryData?'readwrite':'readwrite-primary';return this.persistence.runTransaction('Release query',mode,function(txn){return _this.queryCache.getQueryData(txn,query).next(function(queryData){assert(queryData!=null,'Tried to release nonexistent query: '+query);var targetId=queryData.targetId;var cachedQueryData=_this.queryDataByTarget[targetId];// References for documents sent via Watch are automatically removed when we delete a
// query's target data from the reference delegate. Since this does not remove references
// for locally mutated documents, we have to remove the target associations for these
// documents manually.
var removed=_this.localViewReferences.removeReferencesForId(targetId);delete _this.queryDataByTarget[targetId];if(!keepPersistedQueryData){return PersistencePromise.forEach(removed,function(key){return _this.persistence.referenceDelegate.removeReference(txn,key);}).next(function(){return _this.persistence.referenceDelegate.removeTarget(txn,cachedQueryData);});}else{return PersistencePromise.resolve();}});});};/**
     * Runs the specified query against all the documents in the local store and
     * returns the results.
     */LocalStore.prototype.executeQuery=function(query){var _this=this;return this.persistence.runTransaction('Execute query','readonly',function(txn){return _this.localDocuments.getDocumentsMatchingQuery(txn,query);});};/**
     * Returns the keys of the documents that are associated with the given
     * target id in the remote table.
     */LocalStore.prototype.remoteDocumentKeys=function(targetId){var _this=this;return this.persistence.runTransaction('Remote document keys','readonly',function(txn){return _this.queryCache.getMatchingKeysForTargetId(txn,targetId);});};// PORTING NOTE: Multi-tab only.
LocalStore.prototype.getActiveClients=function(){return this.persistence.getActiveClients();};// PORTING NOTE: Multi-tab only.
LocalStore.prototype.removeCachedMutationBatchMetadata=function(batchId){this.mutationQueue.removeCachedMutationKeys(batchId);};// PORTING NOTE: Multi-tab only.
LocalStore.prototype.setNetworkEnabled=function(networkEnabled){this.persistence.setNetworkEnabled(networkEnabled);};LocalStore.prototype.applyWriteToRemoteDocuments=function(txn,batchResult,documentBuffer){var _this=this;var batch=batchResult.batch;var docKeys=batch.keys();var promiseChain=PersistencePromise.resolve();docKeys.forEach(function(docKey){promiseChain=promiseChain.next(function(){return documentBuffer.getEntry(txn,docKey);}).next(function(remoteDoc){var doc=remoteDoc;var ackVersion=batchResult.docVersions.get(docKey);assert(ackVersion!==null,'ackVersions should contain every doc in the write.');if(!doc||doc.version.compareTo(ackVersion)<0){doc=batch.applyToRemoteDocument(docKey,doc,batchResult);if(!doc){assert(!remoteDoc,'Mutation batch '+batch+' applied to document '+remoteDoc+' resulted in null');}else{documentBuffer.addEntry(doc);}}});});return promiseChain.next(function(){return _this.mutationQueue.removeMutationBatch(txn,batch);});};LocalStore.prototype.collectGarbage=function(garbageCollector){var _this=this;return this.persistence.runTransaction('Collect garbage','readwrite-primary',function(txn){return garbageCollector.collect(txn,_this.queryDataByTarget);});};// PORTING NOTE: Multi-tab only.
LocalStore.prototype.getQueryForTarget=function(targetId){var _this=this;if(this.queryDataByTarget[targetId]){return Promise.resolve(this.queryDataByTarget[targetId].query);}else{return this.persistence.runTransaction('Get query data','readonly',function(txn){return _this.queryCache.getQueryDataForTarget(txn,targetId).next(function(queryData){return queryData?queryData.query:null;});});}};// PORTING NOTE: Multi-tab only.
LocalStore.prototype.getNewDocumentChanges=function(){var _this=this;return this.persistence.runTransaction('Get new document changes','readonly',function(txn){return _this.remoteDocuments.getNewDocumentChanges(txn);});};/**
     * The maximum time to leave a resume token buffered without writing it out.
     * This value is arbitrary: it's long enough to avoid several writes
     * (possibly indefinitely if updates come more frequently than this) but
     * short enough that restarting after crashing will still have a pretty
     * recent resume token.
     */LocalStore.RESUME_TOKEN_MAX_AGE_MICROS=5*60*1e6;return LocalStore;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var MemoryMutationQueue=/** @class */function(){function MemoryMutationQueue(indexManager,referenceDelegate){this.indexManager=indexManager;this.referenceDelegate=referenceDelegate;/**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */this.mutationQueue=[];/** Next value to use when assigning sequential IDs to each mutation batch. */this.nextBatchId=1;/** The last received stream token from the server, used to acknowledge which
         * responses the client has processed. Stream tokens are opaque checkpoint
         * markers whose only real value is their inclusion in the next request.
         */this.lastStreamToken=emptyByteString();/** An ordered mapping between documents and the mutations batch IDs. */this.batchesByDocumentKey=new SortedSet(DocReference.compareByKey);}MemoryMutationQueue.prototype.checkEmpty=function(transaction){return PersistencePromise.resolve(this.mutationQueue.length===0);};MemoryMutationQueue.prototype.acknowledgeBatch=function(transaction,batch,streamToken){var batchId=batch.batchId;var batchIndex=this.indexOfExistingBatchId(batchId,'acknowledged');assert(batchIndex===0,'Can only acknowledge the first batch in the mutation queue');// Verify that the batch in the queue is the one to be acknowledged.
var check=this.mutationQueue[batchIndex];assert(batchId===check.batchId,'Queue ordering failure: expected batch '+batchId+', got batch '+check.batchId);this.lastStreamToken=streamToken;return PersistencePromise.resolve();};MemoryMutationQueue.prototype.getLastStreamToken=function(transaction){return PersistencePromise.resolve(this.lastStreamToken);};MemoryMutationQueue.prototype.setLastStreamToken=function(transaction,streamToken){this.lastStreamToken=streamToken;return PersistencePromise.resolve();};MemoryMutationQueue.prototype.addMutationBatch=function(transaction,localWriteTime,baseMutations,mutations){assert(mutations.length!==0,'Mutation batches should not be empty');var batchId=this.nextBatchId;this.nextBatchId++;if(this.mutationQueue.length>0){var prior=this.mutationQueue[this.mutationQueue.length-1];assert(prior.batchId<batchId,'Mutation batchIDs must be monotonically increasing order');}var batch=new MutationBatch(batchId,localWriteTime,baseMutations,mutations);this.mutationQueue.push(batch);// Track references by document key and index collection parents.
for(var _i=0,mutations_1=mutations;_i<mutations_1.length;_i++){var mutation=mutations_1[_i];this.batchesByDocumentKey=this.batchesByDocumentKey.add(new DocReference(mutation.key,batchId));this.indexManager.addToCollectionParentIndex(transaction,mutation.key.path.popLast());}return PersistencePromise.resolve(batch);};MemoryMutationQueue.prototype.lookupMutationBatch=function(transaction,batchId){return PersistencePromise.resolve(this.findMutationBatch(batchId));};MemoryMutationQueue.prototype.lookupMutationKeys=function(transaction,batchId){var mutationBatch=this.findMutationBatch(batchId);assert(mutationBatch!=null,'Failed to find local mutation batch.');return PersistencePromise.resolve(mutationBatch.keys());};MemoryMutationQueue.prototype.getNextMutationBatchAfterBatchId=function(transaction,batchId){var nextBatchId=batchId+1;// The requested batchId may still be out of range so normalize it to the
// start of the queue.
var rawIndex=this.indexOfBatchId(nextBatchId);var index=rawIndex<0?0:rawIndex;return PersistencePromise.resolve(this.mutationQueue.length>index?this.mutationQueue[index]:null);};MemoryMutationQueue.prototype.getAllMutationBatches=function(transaction){return PersistencePromise.resolve(this.mutationQueue.slice());};MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKey=function(transaction,documentKey){var _this=this;var start=new DocReference(documentKey,0);var end=new DocReference(documentKey,Number.POSITIVE_INFINITY);var result=[];this.batchesByDocumentKey.forEachInRange([start,end],function(ref){assert(documentKey.isEqual(ref.key),"Should only iterate over a single key's batches");var batch=_this.findMutationBatch(ref.targetOrBatchId);assert(batch!==null,'Batches in the index must exist in the main table');result.push(batch);});return PersistencePromise.resolve(result);};MemoryMutationQueue.prototype.getAllMutationBatchesAffectingDocumentKeys=function(transaction,documentKeys){var _this=this;var uniqueBatchIDs=new SortedSet(primitiveComparator);documentKeys.forEach(function(documentKey){var start=new DocReference(documentKey,0);var end=new DocReference(documentKey,Number.POSITIVE_INFINITY);_this.batchesByDocumentKey.forEachInRange([start,end],function(ref){assert(documentKey.isEqual(ref.key),"For each key, should only iterate over a single key's batches");uniqueBatchIDs=uniqueBatchIDs.add(ref.targetOrBatchId);});});return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));};MemoryMutationQueue.prototype.getAllMutationBatchesAffectingQuery=function(transaction,query){assert(!query.isCollectionGroupQuery(),'CollectionGroup queries should be handled in LocalDocumentsView');// Use the query path as a prefix for testing if a document matches the
// query.
var prefix=query.path;var immediateChildrenPathLength=prefix.length+1;// Construct a document reference for actually scanning the index. Unlike
// the prefix the document key in this reference must have an even number of
// segments. The empty segment can be used a suffix of the query path
// because it precedes all other segments in an ordered traversal.
var startPath=prefix;if(!DocumentKey.isDocumentKey(startPath)){startPath=startPath.child('');}var start=new DocReference(new DocumentKey(startPath),0);// Find unique batchIDs referenced by all documents potentially matching the
// query.
var uniqueBatchIDs=new SortedSet(primitiveComparator);this.batchesByDocumentKey.forEachWhile(function(ref){var rowKeyPath=ref.key.path;if(!prefix.isPrefixOf(rowKeyPath)){return false;}else{// Rows with document keys more than one segment longer than the query
// path can't be matches. For example, a query on 'rooms' can't match
// the document /rooms/abc/messages/xyx.
// TODO(mcg): we'll need a different scanner when we implement
// ancestor queries.
if(rowKeyPath.length===immediateChildrenPathLength){uniqueBatchIDs=uniqueBatchIDs.add(ref.targetOrBatchId);}return true;}},start);return PersistencePromise.resolve(this.findMutationBatches(uniqueBatchIDs));};MemoryMutationQueue.prototype.findMutationBatches=function(batchIDs){var _this=this;// Construct an array of matching batches, sorted by batchID to ensure that
// multiple mutations affecting the same document key are applied in order.
var result=[];batchIDs.forEach(function(batchId){var batch=_this.findMutationBatch(batchId);if(batch!==null){result.push(batch);}});return result;};MemoryMutationQueue.prototype.removeMutationBatch=function(transaction,batch){var _this=this;// Find the position of the first batch for removal. This need not be the
// first entry in the queue.
var batchIndex=this.indexOfExistingBatchId(batch.batchId,'removed');assert(batchIndex===0,'Can only remove the first entry of the mutation queue');this.mutationQueue.shift();var references=this.batchesByDocumentKey;return PersistencePromise.forEach(batch.mutations,function(mutation){var ref=new DocReference(mutation.key,batch.batchId);references=references.delete(ref);return _this.referenceDelegate.removeMutationReference(transaction,mutation.key);}).next(function(){_this.batchesByDocumentKey=references;});};MemoryMutationQueue.prototype.removeCachedMutationKeys=function(batchId){// No-op since the memory mutation queue does not maintain a separate cache.
};MemoryMutationQueue.prototype.containsKey=function(txn,key){var ref=new DocReference(key,0);var firstRef=this.batchesByDocumentKey.firstAfterOrEqual(ref);return PersistencePromise.resolve(key.isEqual(firstRef&&firstRef.key));};MemoryMutationQueue.prototype.performConsistencyCheck=function(txn){if(this.mutationQueue.length===0){assert(this.batchesByDocumentKey.isEmpty(),'Document leak -- detected dangling mutation references when queue is empty.');}return PersistencePromise.resolve();};/**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId The batchId to search for
     * @param action A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */MemoryMutationQueue.prototype.indexOfExistingBatchId=function(batchId,action){var index=this.indexOfBatchId(batchId);assert(index>=0&&index<this.mutationQueue.length,'Batches must exist to be '+action);return index;};/**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @return The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */MemoryMutationQueue.prototype.indexOfBatchId=function(batchId){if(this.mutationQueue.length===0){// As an index this is past the end of the queue
return 0;}// Examine the front of the queue to figure out the difference between the
// batchId and indexes in the array. Note that since the queue is ordered
// by batchId, if the first batch has a larger batchId then the requested
// batchId doesn't exist in the queue.
var firstBatchId=this.mutationQueue[0].batchId;return batchId-firstBatchId;};/**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */MemoryMutationQueue.prototype.findMutationBatch=function(batchId){var index=this.indexOfBatchId(batchId);if(index<0||index>=this.mutationQueue.length){return null;}var batch=this.mutationQueue[index];assert(batch.batchId===batchId,'If found batch must match');return batch;};return MemoryMutationQueue;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var MemoryQueryCache=/** @class */function(){function MemoryQueryCache(persistence){this.persistence=persistence;/**
         * Maps a query to the data about that query
         */this.queries=new ObjectMap(function(q){return q.canonicalId();});/** The last received snapshot version. */this.lastRemoteSnapshotVersion=SnapshotVersion.MIN;/** The highest numbered target ID encountered. */this.highestTargetId=0;/** The highest sequence number encountered. */this.highestSequenceNumber=0;/**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */this.references=new ReferenceSet();this.targetCount=0;this.targetIdGenerator=TargetIdGenerator.forQueryCache();}MemoryQueryCache.prototype.getTargetCount=function(txn){return PersistencePromise.resolve(this.targetCount);};MemoryQueryCache.prototype.forEachTarget=function(txn,f){this.queries.forEach(function(_,queryData){return f(queryData);});return PersistencePromise.resolve();};MemoryQueryCache.prototype.getLastRemoteSnapshotVersion=function(transaction){return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);};MemoryQueryCache.prototype.getHighestSequenceNumber=function(transaction){return PersistencePromise.resolve(this.highestSequenceNumber);};MemoryQueryCache.prototype.allocateTargetId=function(transaction){var nextTargetId=this.targetIdGenerator.after(this.highestTargetId);this.highestTargetId=nextTargetId;return PersistencePromise.resolve(nextTargetId);};MemoryQueryCache.prototype.setTargetsMetadata=function(transaction,highestListenSequenceNumber,lastRemoteSnapshotVersion){if(lastRemoteSnapshotVersion){this.lastRemoteSnapshotVersion=lastRemoteSnapshotVersion;}if(highestListenSequenceNumber>this.highestSequenceNumber){this.highestSequenceNumber=highestListenSequenceNumber;}return PersistencePromise.resolve();};MemoryQueryCache.prototype.saveQueryData=function(queryData){this.queries.set(queryData.query,queryData);var targetId=queryData.targetId;if(targetId>this.highestTargetId){this.highestTargetId=targetId;}if(queryData.sequenceNumber>this.highestSequenceNumber){this.highestSequenceNumber=queryData.sequenceNumber;}};MemoryQueryCache.prototype.addQueryData=function(transaction,queryData){assert(!this.queries.has(queryData.query),'Adding a query that already exists');this.saveQueryData(queryData);this.targetCount+=1;return PersistencePromise.resolve();};MemoryQueryCache.prototype.updateQueryData=function(transaction,queryData){assert(this.queries.has(queryData.query),'Updating a non-existent query');this.saveQueryData(queryData);return PersistencePromise.resolve();};MemoryQueryCache.prototype.removeQueryData=function(transaction,queryData){assert(this.targetCount>0,'Removing a target from an empty cache');assert(this.queries.has(queryData.query),'Removing a non-existent target from the cache');this.queries.delete(queryData.query);this.references.removeReferencesForId(queryData.targetId);this.targetCount-=1;return PersistencePromise.resolve();};MemoryQueryCache.prototype.removeTargets=function(transaction,upperBound,activeTargetIds){var _this=this;var count=0;var removals=[];this.queries.forEach(function(key,queryData){if(queryData.sequenceNumber<=upperBound&&!activeTargetIds[queryData.targetId]){_this.queries.delete(key);removals.push(_this.removeMatchingKeysForTargetId(transaction,queryData.targetId));count++;}});return PersistencePromise.waitFor(removals).next(function(){return count;});};MemoryQueryCache.prototype.getQueryCount=function(transaction){return PersistencePromise.resolve(this.targetCount);};MemoryQueryCache.prototype.getQueryData=function(transaction,query){var queryData=this.queries.get(query)||null;return PersistencePromise.resolve(queryData);};MemoryQueryCache.prototype.getQueryDataForTarget=function(transaction,targetId){// This method is only needed for multi-tab and we can't implement it
// efficiently without additional data structures.
return fail('Not yet implemented.');};MemoryQueryCache.prototype.addMatchingKeys=function(txn,keys,targetId){this.references.addReferences(keys,targetId);var referenceDelegate=this.persistence.referenceDelegate;var promises=[];if(referenceDelegate){keys.forEach(function(key){promises.push(referenceDelegate.addReference(txn,key));});}return PersistencePromise.waitFor(promises);};MemoryQueryCache.prototype.removeMatchingKeys=function(txn,keys,targetId){this.references.removeReferences(keys,targetId);var referenceDelegate=this.persistence.referenceDelegate;var promises=[];if(referenceDelegate){keys.forEach(function(key){promises.push(referenceDelegate.removeReference(txn,key));});}return PersistencePromise.waitFor(promises);};MemoryQueryCache.prototype.removeMatchingKeysForTargetId=function(txn,targetId){this.references.removeReferencesForId(targetId);return PersistencePromise.resolve();};MemoryQueryCache.prototype.getMatchingKeysForTargetId=function(txn,targetId){var matchingKeys=this.references.referencesForId(targetId);return PersistencePromise.resolve(matchingKeys);};MemoryQueryCache.prototype.containsKey=function(txn,key){return PersistencePromise.resolve(this.references.containsKey(key));};return MemoryQueryCache;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function documentSizeMap(){return new SortedMap(DocumentKey.comparator);}var MemoryRemoteDocumentCache=/** @class */function(){/**
     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
     * return 0 to avoid unnecessarily doing the work of calculating the size.
     */function MemoryRemoteDocumentCache(indexManager,sizer){this.indexManager=indexManager;this.sizer=sizer;this.docs=documentSizeMap();this.newDocumentChanges=documentKeySet();this.size=0;}/**
     * Adds the supplied entries to the cache. Adds the given size delta to the cached size.
     */MemoryRemoteDocumentCache.prototype.addEntries=function(transaction,entries,sizeDelta){var promises=[];for(var _i=0,entries_1=entries;_i<entries_1.length;_i++){var entry=entries_1[_i];var key=entry.maybeDocument.key;this.docs=this.docs.insert(key,entry);this.newDocumentChanges=this.newDocumentChanges.add(key);promises.push(this.indexManager.addToCollectionParentIndex(transaction,key.path.popLast()));}this.size+=sizeDelta;return PersistencePromise.waitFor(promises);};/**
     * Removes the specified entry from the cache and updates the size as appropriate.
     */MemoryRemoteDocumentCache.prototype.removeEntry=function(transaction,documentKey){var entry=this.docs.get(documentKey);if(entry){this.docs=this.docs.remove(documentKey);this.size-=entry.size;return PersistencePromise.resolve(entry.size);}else{return PersistencePromise.resolve(0);}};MemoryRemoteDocumentCache.prototype.getEntry=function(transaction,documentKey){var entry=this.docs.get(documentKey);return PersistencePromise.resolve(entry?entry.maybeDocument:null);};/**
     * Looks up an entry in the cache.
     *
     * @param documentKey The key of the entry to look up.
     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
     */MemoryRemoteDocumentCache.prototype.getSizedEntry=function(transaction,documentKey){return PersistencePromise.resolve(this.docs.get(documentKey));};MemoryRemoteDocumentCache.prototype.getEntries=function(transaction,documentKeys){var _this=this;var results=nullableMaybeDocumentMap();documentKeys.forEach(function(documentKey){var entry=_this.docs.get(documentKey);results=results.insert(documentKey,entry?entry.maybeDocument:null);});return PersistencePromise.resolve(results);};/**
     * Looks up several entries in the cache.
     *
     * @param documentKeys The set of keys entries to look up.
     * @return A map of MaybeDocuments indexed by key (if a document cannot be
     *     found, the key will be mapped to null) and a map of sizes indexed by
     *     key (zero if the key cannot be found).
     */MemoryRemoteDocumentCache.prototype.getSizedEntries=function(transaction,documentKeys){var _this=this;var results=nullableMaybeDocumentMap();var sizeMap=new SortedMap(DocumentKey.comparator);documentKeys.forEach(function(documentKey){var entry=_this.docs.get(documentKey);results=results.insert(documentKey,entry?entry.maybeDocument:null);sizeMap=sizeMap.insert(documentKey,entry?entry.size:0);});return PersistencePromise.resolve({maybeDocuments:results,sizeMap:sizeMap});};MemoryRemoteDocumentCache.prototype.getDocumentsMatchingQuery=function(transaction,query){assert(!query.isCollectionGroupQuery(),'CollectionGroup queries should be handled in LocalDocumentsView');var results=documentMap();// Documents are ordered by key, so we can use a prefix scan to narrow down
// the documents we need to match the query against.
var prefix=new DocumentKey(query.path.child(''));var iterator=this.docs.getIteratorFrom(prefix);while(iterator.hasNext()){var _a=iterator.getNext(),key=_a.key,maybeDocument=_a.value.maybeDocument;if(!query.path.isPrefixOf(key.path)){break;}if(maybeDocument instanceof Document&&query.matches(maybeDocument)){results=results.insert(maybeDocument.key,maybeDocument);}}return PersistencePromise.resolve(results);};MemoryRemoteDocumentCache.prototype.forEachDocumentKey=function(transaction,f){return PersistencePromise.forEach(this.docs,function(key){return f(key);});};MemoryRemoteDocumentCache.prototype.getNewDocumentChanges=function(transaction){var _this=this;var changedDocs=maybeDocumentMap();this.newDocumentChanges.forEach(function(key){var entry=_this.docs.get(key);var changedDoc=entry?entry.maybeDocument:new NoDocument(key,SnapshotVersion.forDeletedDoc());changedDocs=changedDocs.insert(key,changedDoc);});this.newDocumentChanges=documentKeySet();return PersistencePromise.resolve(changedDocs);};MemoryRemoteDocumentCache.prototype.newChangeBuffer=function(){return new MemoryRemoteDocumentChangeBuffer(this.sizer,this);};MemoryRemoteDocumentCache.prototype.getSize=function(txn){return PersistencePromise.resolve(this.size);};return MemoryRemoteDocumentCache;}();/**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */var MemoryRemoteDocumentChangeBuffer=/** @class */function(_super){tslib_1.__extends(MemoryRemoteDocumentChangeBuffer,_super);function MemoryRemoteDocumentChangeBuffer(sizer,documentCache){var _this=_super.call(this)||this;_this.sizer=sizer;_this.documentCache=documentCache;return _this;}MemoryRemoteDocumentChangeBuffer.prototype.applyChanges=function(transaction){var _this=this;var changes=this.assertChanges();var delta=0;var docs=[];changes.forEach(function(key,maybeDocument){var previousSize=_this.documentSizes.get(key);assert(previousSize!==undefined,"Attempting to change document "+key.toString()+" without having read it first");var size=_this.sizer(maybeDocument);delta+=size-previousSize;docs.push({maybeDocument:maybeDocument,size:size});});return this.documentCache.addEntries(transaction,docs,delta);};MemoryRemoteDocumentChangeBuffer.prototype.getFromCache=function(transaction,documentKey){return this.documentCache.getSizedEntry(transaction,documentKey);};MemoryRemoteDocumentChangeBuffer.prototype.getAllFromCache=function(transaction,documentKeys){return this.documentCache.getSizedEntries(transaction,documentKeys);};return MemoryRemoteDocumentChangeBuffer;}(RemoteDocumentChangeBuffer);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$4='MemoryPersistence';/**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */var MemoryPersistence=/** @class */function(){/**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */function MemoryPersistence(clientId,referenceDelegateFactory){var _this=this;this.clientId=clientId;this.mutationQueues={};this.listenSequence=new ListenSequence(0);this._started=false;this._started=true;this.referenceDelegate=referenceDelegateFactory(this);this.queryCache=new MemoryQueryCache(this);var sizer=function sizer(doc){return _this.referenceDelegate.documentSize(doc);};this.indexManager=new MemoryIndexManager();this.remoteDocumentCache=new MemoryRemoteDocumentCache(this.indexManager,sizer);}MemoryPersistence.createLruPersistence=function(clientId,serializer,params){var factory=function factory(p){return new MemoryLruDelegate(p,new LocalSerializer(serializer),params);};return new MemoryPersistence(clientId,factory);};MemoryPersistence.createEagerPersistence=function(clientId){var factory=function factory(p){return new MemoryEagerDelegate(p);};return new MemoryPersistence(clientId,factory);};MemoryPersistence.prototype.shutdown=function(){// No durable state to ensure is closed on shutdown.
this._started=false;return Promise.resolve();};Object.defineProperty(MemoryPersistence.prototype,"started",{get:function get(){return this._started;},enumerable:true,configurable:true});MemoryPersistence.prototype.getActiveClients=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){return[2/*return*/,[this.clientId]];});});};MemoryPersistence.prototype.setPrimaryStateListener=function(primaryStateListener){// All clients using memory persistence act as primary.
return primaryStateListener(true);};MemoryPersistence.prototype.setDatabaseDeletedListener=function(){// No op.
};MemoryPersistence.prototype.setNetworkEnabled=function(networkEnabled){// No op.
};MemoryPersistence.prototype.getIndexManager=function(){return this.indexManager;};MemoryPersistence.prototype.getMutationQueue=function(user){var queue=this.mutationQueues[user.toKey()];if(!queue){queue=new MemoryMutationQueue(this.indexManager,this.referenceDelegate);this.mutationQueues[user.toKey()]=queue;}return queue;};MemoryPersistence.prototype.getQueryCache=function(){return this.queryCache;};MemoryPersistence.prototype.getRemoteDocumentCache=function(){return this.remoteDocumentCache;};MemoryPersistence.prototype.runTransaction=function(action,mode,transactionOperation){var _this=this;debug(LOG_TAG$4,'Starting transaction:',action);var txn=new MemoryTransaction(this.listenSequence.next());this.referenceDelegate.onTransactionStarted();return transactionOperation(txn).next(function(result){return _this.referenceDelegate.onTransactionCommitted(txn).next(function(){return result;});}).toPromise();};MemoryPersistence.prototype.mutationQueuesContainKey=function(transaction,key){return PersistencePromise.or(values(this.mutationQueues).map(function(queue){return function(){return queue.containsKey(transaction,key);};}));};return MemoryPersistence;}();/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */var MemoryTransaction=/** @class */function(){function MemoryTransaction(currentSequenceNumber){this.currentSequenceNumber=currentSequenceNumber;}return MemoryTransaction;}();var MemoryEagerDelegate=/** @class */function(){function MemoryEagerDelegate(persistence){this.persistence=persistence;}MemoryEagerDelegate.prototype.setInMemoryPins=function(inMemoryPins){this.inMemoryPins=inMemoryPins;};MemoryEagerDelegate.prototype.addReference=function(txn,key){this.orphanedDocuments.delete(key);return PersistencePromise.resolve();};MemoryEagerDelegate.prototype.removeReference=function(txn,key){this.orphanedDocuments.add(key);return PersistencePromise.resolve();};MemoryEagerDelegate.prototype.removeMutationReference=function(txn,key){this.orphanedDocuments.add(key);return PersistencePromise.resolve();};MemoryEagerDelegate.prototype.removeTarget=function(txn,queryData){var _this=this;var cache=this.persistence.getQueryCache();return cache.getMatchingKeysForTargetId(txn,queryData.targetId).next(function(keys){keys.forEach(function(key){return _this.orphanedDocuments.add(key);});}).next(function(){return cache.removeQueryData(txn,queryData);});};MemoryEagerDelegate.prototype.onTransactionStarted=function(){this.orphanedDocuments=new Set();};MemoryEagerDelegate.prototype.onTransactionCommitted=function(txn){var _this=this;var cache=this.persistence.getRemoteDocumentCache();return PersistencePromise.forEach(this.orphanedDocuments,function(key){return _this.isReferenced(txn,key).next(function(isReferenced){if(!isReferenced){// Since this is the eager delegate and memory persistence,
// we don't care about the size of documents. We don't track
// the size of the cache for eager GC.
return cache.removeEntry(txn,key).next(function(){});}return PersistencePromise.resolve();});});};MemoryEagerDelegate.prototype.updateLimboDocument=function(txn,key){var _this=this;return this.isReferenced(txn,key).next(function(isReferenced){if(isReferenced){_this.orphanedDocuments.delete(key);}else{_this.orphanedDocuments.add(key);}});};MemoryEagerDelegate.prototype.documentSize=function(doc){// For eager GC, we don't care about the document size, there are no size thresholds.
return 0;};MemoryEagerDelegate.prototype.isReferenced=function(txn,key){var _this=this;return PersistencePromise.or([function(){return _this.persistence.getQueryCache().containsKey(txn,key);},function(){return _this.persistence.mutationQueuesContainKey(txn,key);},function(){return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key));}]);};return MemoryEagerDelegate;}();var MemoryLruDelegate=/** @class */function(){function MemoryLruDelegate(persistence,serializer,lruParams){this.persistence=persistence;this.serializer=serializer;this.orphanedSequenceNumbers=new ObjectMap(function(k){return encode(k.path);});this.garbageCollector=new LruGarbageCollector(this,lruParams);}// No-ops, present so memory persistence doesn't have to care which delegate
// it has.
MemoryLruDelegate.prototype.onTransactionStarted=function(){};MemoryLruDelegate.prototype.onTransactionCommitted=function(txn){return PersistencePromise.resolve();};MemoryLruDelegate.prototype.forEachTarget=function(txn,f){return this.persistence.getQueryCache().forEachTarget(txn,f);};MemoryLruDelegate.prototype.getSequenceNumberCount=function(txn){var docCountPromise=this.orphanedDocumentCount(txn);var targetCountPromise=this.persistence.getQueryCache().getTargetCount(txn);return targetCountPromise.next(function(targetCount){return docCountPromise.next(function(docCount){return targetCount+docCount;});});};MemoryLruDelegate.prototype.orphanedDocumentCount=function(txn){var orphanedCount=0;return this.forEachOrphanedDocumentSequenceNumber(txn,function(_){orphanedCount++;}).next(function(){return orphanedCount;});};MemoryLruDelegate.prototype.forEachOrphanedDocumentSequenceNumber=function(txn,f){var _this=this;return PersistencePromise.forEach(this.orphanedSequenceNumbers,function(key,sequenceNumber){// Pass in the exact sequence number as the upper bound so we know it won't be pinned by
// being too recent.
return _this.isPinned(txn,key,sequenceNumber).next(function(isPinned){if(!isPinned){return f(sequenceNumber);}else{return PersistencePromise.resolve();}});});};MemoryLruDelegate.prototype.setInMemoryPins=function(inMemoryPins){this.inMemoryPins=inMemoryPins;};MemoryLruDelegate.prototype.removeTargets=function(txn,upperBound,activeTargetIds){return this.persistence.getQueryCache().removeTargets(txn,upperBound,activeTargetIds);};MemoryLruDelegate.prototype.removeOrphanedDocuments=function(txn,upperBound){var _this=this;var count=0;var cache=this.persistence.getRemoteDocumentCache();var p=cache.forEachDocumentKey(txn,function(key){return _this.isPinned(txn,key,upperBound).next(function(isPinned){if(isPinned){return PersistencePromise.resolve();}else{count++;// The memory remote document cache does its own byte
// accounting on removal. This is ok because updating the size
// for memory persistence does not incur IO.
return cache.removeEntry(txn,key).next();}});});return p.next(function(){return count;});};MemoryLruDelegate.prototype.removeMutationReference=function(txn,key){this.orphanedSequenceNumbers.set(key,txn.currentSequenceNumber);return PersistencePromise.resolve();};MemoryLruDelegate.prototype.removeTarget=function(txn,queryData){var updated=queryData.copy({sequenceNumber:txn.currentSequenceNumber});return this.persistence.getQueryCache().updateQueryData(txn,updated);};MemoryLruDelegate.prototype.addReference=function(txn,key){this.orphanedSequenceNumbers.set(key,txn.currentSequenceNumber);return PersistencePromise.resolve();};MemoryLruDelegate.prototype.removeReference=function(txn,key){this.orphanedSequenceNumbers.set(key,txn.currentSequenceNumber);return PersistencePromise.resolve();};MemoryLruDelegate.prototype.updateLimboDocument=function(txn,key){this.orphanedSequenceNumbers.set(key,txn.currentSequenceNumber);return PersistencePromise.resolve();};MemoryLruDelegate.prototype.documentSize=function(maybeDoc){var remoteDocument=this.serializer.toDbRemoteDocument(maybeDoc);var value;if(remoteDocument.document){value=remoteDocument.document;}else if(remoteDocument.unknownDocument){value=remoteDocument.unknownDocument;}else if(remoteDocument.noDocument){value=remoteDocument.noDocument;}else{throw fail('Unknown remote document type');}return JSON.stringify(value).length;};MemoryLruDelegate.prototype.isPinned=function(txn,key,upperBound){var _this=this;return PersistencePromise.or([function(){return _this.persistence.mutationQueuesContainKey(txn,key);},function(){return PersistencePromise.resolve(_this.inMemoryPins.containsKey(key));},function(){return _this.persistence.getQueryCache().containsKey(txn,key);},function(){var orphanedAt=_this.orphanedSequenceNumbers.get(key);return PersistencePromise.resolve(orphanedAt!==undefined&&orphanedAt>upperBound);}]);};MemoryLruDelegate.prototype.getCacheSize=function(txn){return this.persistence.getRemoteDocumentCache().getSize(txn);};return MemoryLruDelegate;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$5='ExponentialBackoff';/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */var ExponentialBackoff=/** @class */function(){function ExponentialBackoff(/**
     * The AsyncQueue to run backoff operations on.
     */queue,/**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */timerId,/**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */initialDelayMs,/**
     * The multiplier to use to determine the extended base delay after each
     * attempt.
     */backoffFactor,/**
     * The maximum base delay after which no further backoff is performed.
     * Note that jitter will still be applied, so the actual delay could be as
     * much as 1.5*maxDelayMs.
     */maxDelayMs){this.queue=queue;this.timerId=timerId;this.initialDelayMs=initialDelayMs;this.backoffFactor=backoffFactor;this.maxDelayMs=maxDelayMs;this.timerPromise=null;/** The last backoff attempt, as epoch milliseconds. */this.lastAttemptTime=Date.now();this.reset();}/**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ExponentialBackoff.prototype.reset=function(){this.currentBaseMs=0;};/**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ExponentialBackoff.prototype.resetToMax=function(){this.currentBaseMs=this.maxDelayMs;};/**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ExponentialBackoff.prototype.backoffAndRun=function(op){var _this=this;// Cancel any pending backoff operation.
this.cancel();// First schedule using the current base (which may be 0 and should be
// honored as such).
var desiredDelayWithJitterMs=Math.floor(this.currentBaseMs+this.jitterDelayMs());// Guard against lastAttemptTime being in the future due to a clock change.
var delaySoFarMs=Math.max(0,Date.now()-this.lastAttemptTime);// Guard against the backoff delay already being past.
var remainingDelayMs=Math.max(0,desiredDelayWithJitterMs-delaySoFarMs);if(this.currentBaseMs>0){debug(LOG_TAG$5,"Backing off for "+remainingDelayMs+" ms "+("(base delay: "+this.currentBaseMs+" ms, ")+("delay with jitter: "+desiredDelayWithJitterMs+" ms, ")+("last attempt: "+delaySoFarMs+" ms ago)"));}this.timerPromise=this.queue.enqueueAfterDelay(this.timerId,remainingDelayMs,function(){_this.lastAttemptTime=Date.now();return op();});// Apply backoff factor to determine next delay and ensure it is within
// bounds.
this.currentBaseMs*=this.backoffFactor;if(this.currentBaseMs<this.initialDelayMs){this.currentBaseMs=this.initialDelayMs;}if(this.currentBaseMs>this.maxDelayMs){this.currentBaseMs=this.maxDelayMs;}};ExponentialBackoff.prototype.cancel=function(){if(this.timerPromise!==null){this.timerPromise.cancel();this.timerPromise=null;}};/** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ExponentialBackoff.prototype.jitterDelayMs=function(){return(Math.random()-0.5)*this.currentBaseMs;};return ExponentialBackoff;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$6='PersistentStream';/**
 * PersistentStream can be in one of 5 states (each described in detail below)
 * based on the following state transition diagram:
 *
 *          start() called             auth & connection succeeded
 * INITIAL ----------------> STARTING -----------------------------> OPEN
 *                             ^  |                                   |
 *                             |  |                    error occurred |
 *                             |  \-----------------------------v-----/
 *                             |                                |
 *                    backoff  |                                |
 *                    elapsed  |              start() called    |
 *                             \--- BACKOFF <---------------- ERROR
 *
 * [any state] --------------------------> INITIAL
 *               stop() called or
 *               idle timer expired
 */var PersistentStreamState;(function(PersistentStreamState){/**
     * The streaming RPC is not yet running and there's no error condition.
     * Calling start() will start the stream immediately without backoff.
     * While in this state isStarted() will return false.
     */PersistentStreamState[PersistentStreamState["Initial"]=0]="Initial";/**
     * The stream is starting, either waiting for an auth token or for the stream
     * to successfully open. While in this state, isStarted() will return true but
     * isOpen() will return false.
     */PersistentStreamState[PersistentStreamState["Starting"]=1]="Starting";/**
     * The streaming RPC is up and running. Requests and responses can flow
     * freely. Both isStarted() and isOpen() will return true.
     */PersistentStreamState[PersistentStreamState["Open"]=2]="Open";/**
     * The stream encountered an error. The next start attempt will back off.
     * While in this state isStarted() will return false.
     */PersistentStreamState[PersistentStreamState["Error"]=3]="Error";/**
     * An in-between state after an error where the stream is waiting before
     * re-starting. After waiting is complete, the stream will try to open.
     * While in this state isStarted() will return true but isOpen() will return
     * false.
     */PersistentStreamState[PersistentStreamState["Backoff"]=4]="Backoff";})(PersistentStreamState||(PersistentStreamState={}));/**
 * Initial backoff time in milliseconds after an error.
 * Set to 1s according to https://cloud.google.com/apis/design/errors.
 */var BACKOFF_INITIAL_DELAY_MS=1000;/** Maximum backoff time in milliseconds */var BACKOFF_MAX_DELAY_MS=60*1000;var BACKOFF_FACTOR=1.5;/** The time a stream stays open after it is marked idle. */var IDLE_TIMEOUT_MS=60*1000;/**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */var PersistentStream=/** @class */function(){function PersistentStream(queue,connectionTimerId,idleTimerId,connection,credentialsProvider,listener){this.queue=queue;this.idleTimerId=idleTimerId;this.connection=connection;this.credentialsProvider=credentialsProvider;this.listener=listener;this.state=PersistentStreamState.Initial;/**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */this.closeCount=0;this.idleTimer=null;this.stream=null;this.backoff=new ExponentialBackoff(queue,connectionTimerId,BACKOFF_INITIAL_DELAY_MS,BACKOFF_FACTOR,BACKOFF_MAX_DELAY_MS);}/**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */PersistentStream.prototype.isStarted=function(){return this.state===PersistentStreamState.Starting||this.state===PersistentStreamState.Open||this.state===PersistentStreamState.Backoff;};/**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */PersistentStream.prototype.isOpen=function(){return this.state===PersistentStreamState.Open;};/**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */PersistentStream.prototype.start=function(){if(this.state===PersistentStreamState.Error){this.performBackoff();return;}assert(this.state===PersistentStreamState.Initial,'Already started');this.auth();};/**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */PersistentStream.prototype.stop=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!this.isStarted())return[3/*break*/,2];return[4/*yield*/,this.close(PersistentStreamState.Initial)];case 1:_a.sent();_a.label=2;case 2:return[2/*return*/];}});});};/**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */PersistentStream.prototype.inhibitBackoff=function(){assert(!this.isStarted(),'Can only inhibit backoff in a stopped state');this.state=PersistentStreamState.Initial;this.backoff.reset();};/**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */PersistentStream.prototype.markIdle=function(){var _this=this;// Starts the idle time if we are in state 'Open' and are not yet already
// running a timer (in which case the previous idle timeout still applies).
if(this.isOpen()&&this.idleTimer===null){this.idleTimer=this.queue.enqueueAfterDelay(this.idleTimerId,IDLE_TIMEOUT_MS,function(){return _this.handleIdleCloseTimer();});}};/** Sends a message to the underlying stream. */PersistentStream.prototype.sendRequest=function(msg){this.cancelIdleCheck();this.stream.send(msg);};/** Called by the idle timer when the stream should close due to inactivity. */PersistentStream.prototype.handleIdleCloseTimer=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(this.isOpen()){// When timing out an idle stream there's no reason to force the stream into backoff when
// it restarts so set the stream state to Initial instead of Error.
return[2/*return*/,this.close(PersistentStreamState.Initial)];}return[2/*return*/];});});};/** Marks the stream as active again. */PersistentStream.prototype.cancelIdleCheck=function(){if(this.idleTimer){this.idleTimer.cancel();this.idleTimer=null;}};/**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState the intended state of the stream after closing.
     * @param error the error the connection was closed with.
     */PersistentStream.prototype.close=function(finalState,error$1){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:assert(this.isStarted(),'Only started streams should be closed.');assert(finalState===PersistentStreamState.Error||isNullOrUndefined(error$1),"Can't provide an error when not in an error state.");// Cancel any outstanding timers (they're guaranteed not to execute).
this.cancelIdleCheck();this.backoff.cancel();// Invalidates any stream-related callbacks (e.g. from auth or the
// underlying stream), guaranteeing they won't execute.
this.closeCount++;if(finalState!==PersistentStreamState.Error){// If this is an intentional close ensure we don't delay our next connection attempt.
this.backoff.reset();}else if(error$1&&error$1.code===Code.RESOURCE_EXHAUSTED){// Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
error(error$1.toString());error('Using maximum backoff delay to prevent overloading the backend.');this.backoff.resetToMax();}else if(error$1&&error$1.code===Code.UNAUTHENTICATED){// "unauthenticated" error means the token was rejected. Try force refreshing it in case it
// just expired.
this.credentialsProvider.invalidateToken();}// Clean up the underlying stream because we are no longer interested in events.
if(this.stream!==null){this.tearDown();this.stream.close();this.stream=null;}// This state must be assigned before calling onClose() to allow the callback to
// inhibit backoff or otherwise manipulate the state in its non-started state.
this.state=finalState;// Notify the listener that the stream closed.
return[4/*yield*/,this.listener.onClose(error$1)];case 1:// Notify the listener that the stream closed.
_a.sent();return[2/*return*/];}});});};/**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */PersistentStream.prototype.tearDown=function(){};PersistentStream.prototype.auth=function(){var _this=this;assert(this.state===PersistentStreamState.Initial,'Must be in initial state to auth');this.state=PersistentStreamState.Starting;var dispatchIfNotClosed=this.getCloseGuardedDispatcher(this.closeCount);// TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
var closeCount=this.closeCount;this.credentialsProvider.getToken().then(function(token){// Stream can be stopped while waiting for authentication.
// TODO(mikelehen): We really should just use dispatchIfNotClosed
// and let this dispatch onto the queue, but that opened a spec test can
// of worms that I don't want to deal with in this PR.
if(_this.closeCount===closeCount){// Normally we'd have to schedule the callback on the AsyncQueue.
// However, the following calls are safe to be called outside the
// AsyncQueue since they don't chain asynchronous calls
_this.startStream(token);}},function(error){dispatchIfNotClosed(function(){var rpcError=new FirestoreError(Code.UNKNOWN,'Fetching auth token failed: '+error.message);return _this.handleStreamClose(rpcError);});});};PersistentStream.prototype.startStream=function(token){var _this=this;assert(this.state===PersistentStreamState.Starting,'Trying to start stream in a non-starting state');var dispatchIfNotClosed=this.getCloseGuardedDispatcher(this.closeCount);this.stream=this.startRpc(token);this.stream.onOpen(function(){dispatchIfNotClosed(function(){assert(_this.state===PersistentStreamState.Starting,'Expected stream to be in state Starting, but was '+_this.state);_this.state=PersistentStreamState.Open;return _this.listener.onOpen();});});this.stream.onClose(function(error){dispatchIfNotClosed(function(){return _this.handleStreamClose(error);});});this.stream.onMessage(function(msg){dispatchIfNotClosed(function(){return _this.onMessage(msg);});});};PersistentStream.prototype.performBackoff=function(){var _this=this;assert(this.state===PersistentStreamState.Error,'Should only perform backoff when in Error state');this.state=PersistentStreamState.Backoff;this.backoff.backoffAndRun(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){assert(this.state===PersistentStreamState.Backoff,'Backoff elapsed but state is now: '+this.state);this.state=PersistentStreamState.Initial;this.start();assert(this.isStarted(),'PersistentStream should have started');return[2/*return*/];});});});};// Visible for tests
PersistentStream.prototype.handleStreamClose=function(error){assert(this.isStarted(),"Can't handle server close on non-started stream");debug(LOG_TAG$6,"close with error: "+error);this.stream=null;// In theory the stream could close cleanly, however, in our current model
// we never expect this to happen because if we stop a stream ourselves,
// this callback will never be called. To prevent cases where we retry
// without a backoff accidentally, we set the stream to error in all cases.
return this.close(PersistentStreamState.Error,error);};/**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */PersistentStream.prototype.getCloseGuardedDispatcher=function(startCloseCount){var _this=this;return function(fn){_this.queue.enqueueAndForget(function(){if(_this.closeCount===startCloseCount){return fn();}else{debug(LOG_TAG$6,'stream callback skipped by getCloseGuardedDispatcher.');return Promise.resolve();}});};};return PersistentStream;}();/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */var PersistentListenStream=/** @class */function(_super){tslib_1.__extends(PersistentListenStream,_super);function PersistentListenStream(queue,connection,credentials,serializer,listener){var _this=_super.call(this,queue,TimerId.ListenStreamConnectionBackoff,TimerId.ListenStreamIdle,connection,credentials,listener)||this;_this.serializer=serializer;return _this;}PersistentListenStream.prototype.startRpc=function(token){return this.connection.openStream('Listen',token);};PersistentListenStream.prototype.onMessage=function(watchChangeProto){// A successful response means the stream is healthy
this.backoff.reset();var watchChange=this.serializer.fromWatchChange(watchChangeProto);var snapshot=this.serializer.versionFromListenResponse(watchChangeProto);return this.listener.onWatchChange(watchChange,snapshot);};/**
     * Registers interest in the results of the given query. If the query
     * includes a resumeToken it will be included in the request. Results that
     * affect the query will be streamed back as WatchChange messages that
     * reference the targetId.
     */PersistentListenStream.prototype.watch=function(queryData){var request={};request.database=this.serializer.encodedDatabaseId;request.addTarget=this.serializer.toTarget(queryData);var labels=this.serializer.toListenRequestLabels(queryData);if(labels){request.labels=labels;}this.sendRequest(request);};/**
     * Unregisters interest in the results of the query associated with the
     * given targetId.
     */PersistentListenStream.prototype.unwatch=function(targetId){var request={};request.database=this.serializer.encodedDatabaseId;request.removeTarget=targetId;this.sendRequest(request);};return PersistentListenStream;}(PersistentStream);/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */var PersistentWriteStream=/** @class */function(_super){tslib_1.__extends(PersistentWriteStream,_super);function PersistentWriteStream(queue,connection,credentials,serializer,listener){var _this=_super.call(this,queue,TimerId.WriteStreamConnectionBackoff,TimerId.WriteStreamIdle,connection,credentials,listener)||this;_this.serializer=serializer;_this.handshakeComplete_=false;return _this;}Object.defineProperty(PersistentWriteStream.prototype,"handshakeComplete",{/**
         * Tracks whether or not a handshake has been successfully exchanged and
         * the stream is ready to accept mutations.
         */get:function get(){return this.handshakeComplete_;},enumerable:true,configurable:true});// Override of PersistentStream.start
PersistentWriteStream.prototype.start=function(){this.handshakeComplete_=false;_super.prototype.start.call(this);};PersistentWriteStream.prototype.tearDown=function(){if(this.handshakeComplete_){this.writeMutations([]);}};PersistentWriteStream.prototype.startRpc=function(token){return this.connection.openStream('Write',token);};PersistentWriteStream.prototype.onMessage=function(responseProto){// Always capture the last stream token.
assert(!!responseProto.streamToken,'Got a write response without a stream token');this.lastStreamToken=responseProto.streamToken;if(!this.handshakeComplete_){// The first response is always the handshake response
assert(!responseProto.writeResults||responseProto.writeResults.length===0,'Got mutation results for handshake');this.handshakeComplete_=true;return this.listener.onHandshakeComplete();}else{// A successful first write response means the stream is healthy,
// Note, that we could consider a successful handshake healthy, however,
// the write itself might be causing an error we want to back off from.
this.backoff.reset();var results=this.serializer.fromWriteResults(responseProto.writeResults,responseProto.commitTime);var commitVersion=this.serializer.fromVersion(responseProto.commitTime);return this.listener.onMutationResult(commitVersion,results);}};/**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */PersistentWriteStream.prototype.writeHandshake=function(){assert(this.isOpen(),'Writing handshake requires an opened stream');assert(!this.handshakeComplete_,'Handshake already completed');// TODO(dimond): Support stream resumption. We intentionally do not set the
// stream token on the handshake, ignoring any stream token we might have.
var request={};request.database=this.serializer.encodedDatabaseId;this.sendRequest(request);};/** Sends a group of mutations to the Firestore backend to apply. */PersistentWriteStream.prototype.writeMutations=function(mutations){var _this=this;assert(this.isOpen(),'Writing mutations requires an opened stream');assert(this.handshakeComplete_,'Handshake must be complete before writing mutations');assert(this.lastStreamToken.length>0,'Trying to write mutation without a token');var request={// Protos are typed with string, but we support UInt8Array on Node
// tslint:disable-next-line:no-any
streamToken:this.lastStreamToken,writes:mutations.map(function(mutation){return _this.serializer.toMutation(mutation);})};this.sendRequest(request);};return PersistentWriteStream;}(PersistentStream);/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Datastore is a wrapper around the external Google Cloud Datastore grpc API,
 * which provides an interface that is more convenient for the rest of the
 * client SDK architecture to consume.
 */var Datastore=/** @class */function(){function Datastore(queue,connection,credentials,serializer){this.queue=queue;this.connection=connection;this.credentials=credentials;this.serializer=serializer;}Datastore.prototype.newPersistentWriteStream=function(listener){return new PersistentWriteStream(this.queue,this.connection,this.credentials,this.serializer,listener);};Datastore.prototype.newPersistentWatchStream=function(listener){return new PersistentListenStream(this.queue,this.connection,this.credentials,this.serializer,listener);};Datastore.prototype.commit=function(mutations){var _this=this;var params={database:this.serializer.encodedDatabaseId,writes:mutations.map(function(m){return _this.serializer.toMutation(m);})};return this.invokeRPC('Commit',params).then(function(response){return _this.serializer.fromWriteResults(response.writeResults,response.commitTime);});};Datastore.prototype.lookup=function(keys){var _this=this;var params={database:this.serializer.encodedDatabaseId,documents:keys.map(function(k){return _this.serializer.toName(k);})};return this.invokeStreamingRPC('BatchGetDocuments',params).then(function(response){var docs=maybeDocumentMap();response.forEach(function(proto){var doc=_this.serializer.fromMaybeDocument(proto);docs=docs.insert(doc.key,doc);});var result=[];keys.forEach(function(key){var doc=docs.get(key);assert(!!doc,'Missing entity in write response for '+key);result.push(doc);});return result;});};/** Gets an auth token and invokes the provided RPC. */Datastore.prototype.invokeRPC=function(rpcName,request){var _this=this;return this.credentials.getToken().then(function(token){return _this.connection.invokeRPC(rpcName,request,token);}).catch(function(error){if(error.code===Code.UNAUTHENTICATED){_this.credentials.invalidateToken();}throw error;});};/** Gets an auth token and invokes the provided RPC with streamed results. */Datastore.prototype.invokeStreamingRPC=function(rpcName,request){var _this=this;return this.credentials.getToken().then(function(token){return _this.connection.invokeStreamingRPC(rpcName,request,token);}).catch(function(error){if(error.code===Code.UNAUTHENTICATED){_this.credentials.invalidateToken();}throw error;});};return Datastore;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */var Transaction=/** @class */function(){function Transaction(datastore){this.datastore=datastore;// The version of each document that was read during this transaction.
this.readVersions=documentVersionMap();this.mutations=[];this.committed=false;}Transaction.prototype.recordVersion=function(doc){var docVersion;if(doc instanceof Document){docVersion=doc.version;}else if(doc instanceof NoDocument){// For deleted docs, we must use baseVersion 0 when we overwrite them.
docVersion=SnapshotVersion.forDeletedDoc();}else{throw fail('Document in a transaction was a '+doc.constructor.name);}var existingVersion=this.readVersions.get(doc.key);if(existingVersion!==null){if(!docVersion.isEqual(existingVersion)){// This transaction will fail no matter what.
throw new FirestoreError(Code.ABORTED,'Document version changed between two reads.');}}else{this.readVersions=this.readVersions.insert(doc.key,docVersion);}};Transaction.prototype.lookup=function(keys){var _this=this;if(this.committed){return Promise.reject('Transaction has already completed.');}if(this.mutations.length>0){return Promise.reject('Transactions lookups are invalid after writes.');}return this.datastore.lookup(keys).then(function(docs){docs.forEach(function(doc){if(doc instanceof NoDocument||doc instanceof Document){_this.recordVersion(doc);}else{fail('Document in a transaction was a '+doc.constructor.name);}});return docs;});};Transaction.prototype.write=function(mutations){if(this.committed){throw new FirestoreError(Code.FAILED_PRECONDITION,'Transaction has already completed.');}this.mutations=this.mutations.concat(mutations);};/**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */Transaction.prototype.precondition=function(key){var version=this.readVersions.get(key);if(version){return Precondition.updateTime(version);}else{return Precondition.NONE;}};/**
     * Returns the precondition for a document if the operation is an update.
     */Transaction.prototype.preconditionForUpdate=function(key){var version=this.readVersions.get(key);if(version&&version.isEqual(SnapshotVersion.forDeletedDoc())){// The document doesn't exist, so fail the transaction.
throw new FirestoreError(Code.FAILED_PRECONDITION,"Can't update a document that doesn't exist.");}else if(version){// Document exists, base precondition on document update time.
return Precondition.updateTime(version);}else{// Document was not read, so we just use the preconditions for a blind
// update.
return Precondition.exists(true);}};Transaction.prototype.set=function(key,data){this.write(data.toMutations(key,this.precondition(key)));};Transaction.prototype.update=function(key,data){this.write(data.toMutations(key,this.preconditionForUpdate(key)));};Transaction.prototype.delete=function(key){this.write([new DeleteMutation(key,this.precondition(key))]);// Since the delete will be applied before all following writes, we need to
// ensure that the precondition for the next write will be exists: false.
this.readVersions=this.readVersions.insert(key,SnapshotVersion.forDeletedDoc());};Transaction.prototype.commit=function(){var _this=this;var unwritten=this.readVersions;// For each mutation, note that the doc was written.
this.mutations.forEach(function(mutation){unwritten=unwritten.remove(mutation.key);});if(!unwritten.isEmpty()){return Promise.reject(Error('Every document read in a transaction must also be written.'));}return this.datastore.commit(this.mutations).then(function(){_this.committed=true;});};return Transaction;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Describes the online state of the Firestore client. Note that this does not
 * indicate whether or not the remote store is trying to connect or not. This is
 * primarily used by the View / EventManager code to change their behavior while
 * offline (e.g. get() calls shouldn't wait for data from the server and
 * snapshot events should set metadata.isFromCache=true).
 */var OnlineState;(function(OnlineState){/**
     * The Firestore client is in an unknown online state. This means the client
     * is either not actively trying to establish a connection or it is currently
     * trying to establish a connection, but it has not succeeded or failed yet.
     * Higher-level components should not operate in offline mode.
     */OnlineState[OnlineState["Unknown"]=0]="Unknown";/**
     * The client is connected and the connections are healthy. This state is
     * reached after a successful connection and there has been at least one
     * successful message received from the backends.
     */OnlineState[OnlineState["Online"]=1]="Online";/**
     * The client is either trying to establish a connection but failing, or it
     * has been explicitly marked offline via a call to disableNetwork().
     * Higher-level components should operate in offline mode.
     */OnlineState[OnlineState["Offline"]=2]="Offline";})(OnlineState||(OnlineState={}));/** The source of an online state event. */var OnlineStateSource;(function(OnlineStateSource){OnlineStateSource[OnlineStateSource["RemoteStore"]=0]="RemoteStore";OnlineStateSource[OnlineStateSource["SharedClientState"]=1]="SharedClientState";})(OnlineStateSource||(OnlineStateSource={}));/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$7='OnlineStateTracker';// To deal with transient failures, we allow multiple stream attempts before
// giving up and transitioning from OnlineState.Unknown to Offline.
// TODO(mikelehen): This used to be set to 2 as a mitigation for b/66228394.
// @jdimond thinks that bug is sufficiently fixed so that we can set this back
// to 1. If that works okay, we could potentially remove this logic entirely.
var MAX_WATCH_STREAM_FAILURES=1;// To deal with stream attempts that don't succeed or fail in a timely manner,
// we have a timeout for OnlineState to reach Online or Offline.
// If the timeout is reached, we transition to Offline rather than waiting
// indefinitely.
var ONLINE_STATE_TIMEOUT_MS=10*1000;/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */var OnlineStateTracker=/** @class */function(){function OnlineStateTracker(asyncQueue,onlineStateHandler){this.asyncQueue=asyncQueue;this.onlineStateHandler=onlineStateHandler;/** The current OnlineState. */this.state=OnlineState.Unknown;/**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */this.watchStreamFailures=0;/**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */this.onlineStateTimer=null;/**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */this.shouldWarnClientIsOffline=true;}/**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */OnlineStateTracker.prototype.handleWatchStreamStart=function(){var _this=this;if(this.watchStreamFailures===0){this.setAndBroadcast(OnlineState.Unknown);assert(this.onlineStateTimer===null,"onlineStateTimer shouldn't be started yet");this.onlineStateTimer=this.asyncQueue.enqueueAfterDelay(TimerId.OnlineStateTimeout,ONLINE_STATE_TIMEOUT_MS,function(){_this.onlineStateTimer=null;assert(_this.state===OnlineState.Unknown,'Timer should be canceled if we transitioned to a different state.');_this.logClientOfflineWarningIfNecessary("Backend didn't respond within "+ONLINE_STATE_TIMEOUT_MS/1000+" "+"seconds.");_this.setAndBroadcast(OnlineState.Offline);// NOTE: handleWatchStreamFailure() will continue to increment
// watchStreamFailures even though we are already marked Offline,
// but this is non-harmful.
return Promise.resolve();});}};/**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */OnlineStateTracker.prototype.handleWatchStreamFailure=function(error){if(this.state===OnlineState.Online){this.setAndBroadcast(OnlineState.Unknown);// To get to OnlineState.Online, set() must have been called which would
// have reset our heuristics.
assert(this.watchStreamFailures===0,'watchStreamFailures must be 0');assert(this.onlineStateTimer===null,'onlineStateTimer must be null');}else{this.watchStreamFailures++;if(this.watchStreamFailures>=MAX_WATCH_STREAM_FAILURES){this.clearOnlineStateTimer();this.logClientOfflineWarningIfNecessary("Connection failed "+MAX_WATCH_STREAM_FAILURES+" "+("times. Most recent error: "+error.toString()));this.setAndBroadcast(OnlineState.Offline);}}};/**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */OnlineStateTracker.prototype.set=function(newState){this.clearOnlineStateTimer();this.watchStreamFailures=0;if(newState===OnlineState.Online){// We've connected to watch at least once. Don't warn the developer
// about being offline going forward.
this.shouldWarnClientIsOffline=false;}this.setAndBroadcast(newState);};OnlineStateTracker.prototype.setAndBroadcast=function(newState){if(newState!==this.state){this.state=newState;this.onlineStateHandler(newState);}};OnlineStateTracker.prototype.logClientOfflineWarningIfNecessary=function(details){var message="Could not reach Cloud Firestore backend. "+details+"\n"+"This typically indicates that your device does not have a healthy "+"Internet connection at the moment. The client will operate in offline "+"mode until it is able to successfully connect to the backend.";if(this.shouldWarnClientIsOffline){error(message);this.shouldWarnClientIsOffline=false;}else{debug(LOG_TAG$7,message);}};OnlineStateTracker.prototype.clearOnlineStateTimer=function(){if(this.onlineStateTimer!==null){this.onlineStateTimer.cancel();this.onlineStateTimer=null;}};return OnlineStateTracker;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$8='RemoteStore';// TODO(b/35853402): Negotiate this with the stream.
var MAX_PENDING_WRITES=10;/**
 * RemoteStore - An interface to remotely stored data, basically providing a
 * wrapper around the Datastore that is more reliable for the rest of the
 * system.
 *
 * RemoteStore is responsible for maintaining the connection to the server.
 * - maintaining a list of active listens.
 * - reconnecting when the connection is dropped.
 * - resuming all the active listens on reconnect.
 *
 * RemoteStore handles all incoming events from the Datastore.
 * - listening to the watch stream and repackaging the events as RemoteEvents
 * - notifying SyncEngine of any changes to the active listens.
 *
 * RemoteStore takes writes from other components and handles them reliably.
 * - pulling pending mutations from LocalStore and sending them to Datastore.
 * - retrying mutations that failed because of network problems.
 * - acking mutations to the SyncEngine once they are accepted or rejected.
 */var RemoteStore=/** @class */function(){function RemoteStore(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */localStore,/** The client-side proxy for interacting with the backend. */datastore,asyncQueue,onlineStateHandler){this.localStore=localStore;this.datastore=datastore;/**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */this.writePipeline=[];/**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */this.listenTargets={};this.watchChangeAggregator=null;/**
         * Set to true by enableNetwork() and false by disableNetwork() and indicates
         * the user-preferred network state.
         */this.networkEnabled=false;this.isPrimary=false;this.onlineStateTracker=new OnlineStateTracker(asyncQueue,onlineStateHandler);// Create streams (but note they're not started yet).
this.watchStream=this.datastore.newPersistentWatchStream({onOpen:this.onWatchStreamOpen.bind(this),onClose:this.onWatchStreamClose.bind(this),onWatchChange:this.onWatchStreamChange.bind(this)});this.writeStream=this.datastore.newPersistentWriteStream({onOpen:this.onWriteStreamOpen.bind(this),onClose:this.onWriteStreamClose.bind(this),onHandshakeComplete:this.onWriteHandshakeComplete.bind(this),onMutationResult:this.onMutationResult.bind(this)});}/**
     * Starts up the remote store, creating streams, restoring state from
     * LocalStore, etc.
     */RemoteStore.prototype.start=function(){return this.enableNetwork();};/** Re-enables the network. Idempotent. */RemoteStore.prototype.enableNetwork=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){var _a;return tslib_1.__generator(this,function(_b){switch(_b.label){case 0:this.networkEnabled=true;if(!this.canUseNetwork())return[3/*break*/,3];_a=this.writeStream;return[4/*yield*/,this.localStore.getLastStreamToken()];case 1:_a.lastStreamToken=_b.sent();if(this.shouldStartWatchStream()){this.startWatchStream();}else{this.onlineStateTracker.set(OnlineState.Unknown);}// This will start the write stream if necessary.
return[4/*yield*/,this.fillWritePipeline()];case 2:// This will start the write stream if necessary.
_b.sent();_b.label=3;case 3:return[2/*return*/];}});});};/**
     * Temporarily disables the network. The network can be re-enabled using
     * enableNetwork().
     */RemoteStore.prototype.disableNetwork=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.networkEnabled=false;return[4/*yield*/,this.disableNetworkInternal()];case 1:_a.sent();// Set the OnlineState to Offline so get()s return from cache, etc.
this.onlineStateTracker.set(OnlineState.Offline);return[2/*return*/];}});});};RemoteStore.prototype.disableNetworkInternal=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:return[4/*yield*/,this.writeStream.stop()];case 1:_a.sent();return[4/*yield*/,this.watchStream.stop()];case 2:_a.sent();if(this.writePipeline.length>0){debug(LOG_TAG$8,"Stopping write stream with "+this.writePipeline.length+" pending writes");this.writePipeline=[];}this.cleanUpWatchStreamState();return[2/*return*/];}});});};RemoteStore.prototype.shutdown=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:debug(LOG_TAG$8,'RemoteStore shutting down.');this.networkEnabled=false;return[4/*yield*/,this.disableNetworkInternal()];case 1:_a.sent();// Set the OnlineState to Unknown (rather than Offline) to avoid potentially
// triggering spurious listener events with cached data, etc.
this.onlineStateTracker.set(OnlineState.Unknown);return[2/*return*/];}});});};/** Starts new listen for the given query. Uses resume token if provided */RemoteStore.prototype.listen=function(queryData){assert(!contains(this.listenTargets,queryData.targetId),'listen called with duplicate targetId!');// Mark this as something the client is currently listening for.
this.listenTargets[queryData.targetId]=queryData;if(this.shouldStartWatchStream()){// The listen will be sent in onWatchStreamOpen
this.startWatchStream();}else if(this.watchStream.isOpen()){this.sendWatchRequest(queryData);}};/** Removes the listen from server */RemoteStore.prototype.unlisten=function(targetId){assert(contains(this.listenTargets,targetId),'unlisten called without assigned target ID!');delete this.listenTargets[targetId];if(this.watchStream.isOpen()){this.sendUnwatchRequest(targetId);}if(isEmpty(this.listenTargets)){if(this.watchStream.isOpen()){this.watchStream.markIdle();}else if(this.canUseNetwork()){// Revert to OnlineState.Unknown if the watch stream is not open and we
// have no listeners, since without any listens to send we cannot
// confirm if the stream is healthy and upgrade to OnlineState.Online.
this.onlineStateTracker.set(OnlineState.Unknown);}}};/** {@link TargetMetadataProvider.getQueryDataForTarget} */RemoteStore.prototype.getQueryDataForTarget=function(targetId){return this.listenTargets[targetId]||null;};/** {@link TargetMetadataProvider.getRemoteKeysForTarget} */RemoteStore.prototype.getRemoteKeysForTarget=function(targetId){return this.syncEngine.getRemoteKeysForTarget(targetId);};/**
     * We need to increment the the expected number of pending responses we're due
     * from watch so we wait for the ack to process any messages from this target.
     */RemoteStore.prototype.sendWatchRequest=function(queryData){this.watchChangeAggregator.recordPendingTargetRequest(queryData.targetId);this.watchStream.watch(queryData);};/**
     * We need to increment the expected number of pending responses we're due
     * from watch so we wait for the removal on the server before we process any
     * messages from this target.
     */RemoteStore.prototype.sendUnwatchRequest=function(targetId){this.watchChangeAggregator.recordPendingTargetRequest(targetId);this.watchStream.unwatch(targetId);};RemoteStore.prototype.startWatchStream=function(){assert(this.shouldStartWatchStream(),'startWatchStream() called when shouldStartWatchStream() is false.');this.watchChangeAggregator=new WatchChangeAggregator(this);this.watchStream.start();this.onlineStateTracker.handleWatchStreamStart();};/**
     * Returns whether the watch stream should be started because it's necessary
     * and has not yet been started.
     */RemoteStore.prototype.shouldStartWatchStream=function(){return this.canUseNetwork()&&!this.watchStream.isStarted()&&!isEmpty(this.listenTargets);};RemoteStore.prototype.canUseNetwork=function(){return this.isPrimary&&this.networkEnabled;};RemoteStore.prototype.cleanUpWatchStreamState=function(){this.watchChangeAggregator=null;};RemoteStore.prototype.onWatchStreamOpen=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){var _this=this;return tslib_1.__generator(this,function(_a){forEachNumber(this.listenTargets,function(targetId,queryData){_this.sendWatchRequest(queryData);});return[2/*return*/];});});};RemoteStore.prototype.onWatchStreamClose=function(error){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(error===undefined){// Graceful stop (due to stop() or idle timeout). Make sure that's
// desirable.
assert(!this.shouldStartWatchStream(),'Watch stream was stopped gracefully while still needed.');}this.cleanUpWatchStreamState();// If we still need the watch stream, retry the connection.
if(this.shouldStartWatchStream()){this.onlineStateTracker.handleWatchStreamFailure(error);this.startWatchStream();}else{// No need to restart watch stream because there are no active targets.
// The online state is set to unknown because there is no active attempt
// at establishing a connection
this.onlineStateTracker.set(OnlineState.Unknown);}return[2/*return*/];});});};RemoteStore.prototype.onWatchStreamChange=function(watchChange,snapshotVersion){return tslib_1.__awaiter(this,void 0,void 0,function(){var lastRemoteSnapshotVersion;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:// Mark the client as online since we got a message from the server
this.onlineStateTracker.set(OnlineState.Online);if(watchChange instanceof WatchTargetChange&&watchChange.state===WatchTargetChangeState.Removed&&watchChange.cause){// There was an error on a target, don't wait for a consistent snapshot
// to raise events
return[2/*return*/,this.handleTargetError(watchChange)];}if(watchChange instanceof DocumentWatchChange){this.watchChangeAggregator.handleDocumentChange(watchChange);}else if(watchChange instanceof ExistenceFilterChange){this.watchChangeAggregator.handleExistenceFilter(watchChange);}else{assert(watchChange instanceof WatchTargetChange,'Expected watchChange to be an instance of WatchTargetChange');this.watchChangeAggregator.handleTargetChange(watchChange);}if(!!snapshotVersion.isEqual(SnapshotVersion.MIN))return[3/*break*/,3];return[4/*yield*/,this.localStore.getLastRemoteSnapshotVersion()];case 1:lastRemoteSnapshotVersion=_a.sent();if(!(snapshotVersion.compareTo(lastRemoteSnapshotVersion)>=0))return[3/*break*/,3];// We have received a target change with a global snapshot if the snapshot
// version is not equal to SnapshotVersion.MIN.
return[4/*yield*/,this.raiseWatchSnapshot(snapshotVersion)];case 2:// We have received a target change with a global snapshot if the snapshot
// version is not equal to SnapshotVersion.MIN.
_a.sent();_a.label=3;case 3:return[2/*return*/];}});});};/**
     * Takes a batch of changes from the Datastore, repackages them as a
     * RemoteEvent, and passes that on to the listener, which is typically the
     * SyncEngine.
     */RemoteStore.prototype.raiseWatchSnapshot=function(snapshotVersion){var _this=this;assert(!snapshotVersion.isEqual(SnapshotVersion.MIN),"Can't raise event for unknown SnapshotVersion");var remoteEvent=this.watchChangeAggregator.createRemoteEvent(snapshotVersion);// Update in-memory resume tokens. LocalStore will update the
// persistent view of these when applying the completed RemoteEvent.
forEachNumber(remoteEvent.targetChanges,function(targetId,change){if(change.resumeToken.length>0){var queryData=_this.listenTargets[targetId];// A watched target might have been removed already.
if(queryData){_this.listenTargets[targetId]=queryData.copy({resumeToken:change.resumeToken,snapshotVersion:snapshotVersion});}}});// Re-establish listens for the targets that have been invalidated by
// existence filter mismatches.
remoteEvent.targetMismatches.forEach(function(targetId){var queryData=_this.listenTargets[targetId];if(!queryData){// A watched target might have been removed already.
return;}// Clear the resume token for the query, since we're in a known mismatch
// state.
_this.listenTargets[targetId]=queryData.copy({resumeToken:emptyByteString()});// Cause a hard reset by unwatching and rewatching immediately, but
// deliberately don't send a resume token so that we get a full update.
_this.sendUnwatchRequest(targetId);// Mark the query we send as being on behalf of an existence filter
// mismatch, but don't actually retain that in listenTargets. This ensures
// that we flag the first re-listen this way without impacting future
// listens of this target (that might happen e.g. on reconnect).
var requestQueryData=new QueryData(queryData.query,targetId,QueryPurpose.ExistenceFilterMismatch,queryData.sequenceNumber);_this.sendWatchRequest(requestQueryData);});// Finally raise remote event
return this.syncEngine.applyRemoteEvent(remoteEvent);};/** Handles an error on a target */RemoteStore.prototype.handleTargetError=function(watchChange){var _this=this;assert(!!watchChange.cause,'Handling target error without a cause');var error=watchChange.cause;var promiseChain=Promise.resolve();watchChange.targetIds.forEach(function(targetId){promiseChain=promiseChain.then(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){// A watched target might have been removed already.
if(contains(this.listenTargets,targetId)){delete this.listenTargets[targetId];this.watchChangeAggregator.removeTarget(targetId);return[2/*return*/,this.syncEngine.rejectListen(targetId,error)];}return[2/*return*/];});});});});return promiseChain;};/**
     * Attempts to fill our write pipeline with writes from the LocalStore.
     *
     * Called internally to bootstrap or refill the write pipeline and by
     * SyncEngine whenever there are new mutations to process.
     *
     * Starts the write stream if necessary.
     */RemoteStore.prototype.fillWritePipeline=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){var lastBatchIdRetrieved,batch;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!this.canAddToWritePipeline())return[3/*break*/,4];lastBatchIdRetrieved=this.writePipeline.length>0?this.writePipeline[this.writePipeline.length-1].batchId:BATCHID_UNKNOWN;return[4/*yield*/,this.localStore.nextMutationBatch(lastBatchIdRetrieved)];case 1:batch=_a.sent();if(!(batch===null))return[3/*break*/,2];if(this.writePipeline.length===0){this.writeStream.markIdle();}return[3/*break*/,4];case 2:this.addToWritePipeline(batch);return[4/*yield*/,this.fillWritePipeline()];case 3:_a.sent();_a.label=4;case 4:if(this.shouldStartWriteStream()){this.startWriteStream();}return[2/*return*/];}});});};/**
     * Returns true if we can add to the write pipeline (i.e. the network is
     * enabled and the write pipeline is not full).
     */RemoteStore.prototype.canAddToWritePipeline=function(){return this.canUseNetwork()&&this.writePipeline.length<MAX_PENDING_WRITES;};// For testing
RemoteStore.prototype.outstandingWrites=function(){return this.writePipeline.length;};/**
     * Queues additional writes to be sent to the write stream, sending them
     * immediately if the write stream is established.
     */RemoteStore.prototype.addToWritePipeline=function(batch){assert(this.canAddToWritePipeline(),'addToWritePipeline called when pipeline is full');this.writePipeline.push(batch);if(this.writeStream.isOpen()&&this.writeStream.handshakeComplete){this.writeStream.writeMutations(batch.mutations);}};RemoteStore.prototype.shouldStartWriteStream=function(){return this.canUseNetwork()&&!this.writeStream.isStarted()&&this.writePipeline.length>0;};RemoteStore.prototype.startWriteStream=function(){assert(this.shouldStartWriteStream(),'startWriteStream() called when shouldStartWriteStream() is false.');this.writeStream.start();};RemoteStore.prototype.onWriteStreamOpen=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){this.writeStream.writeHandshake();return[2/*return*/];});});};RemoteStore.prototype.onWriteHandshakeComplete=function(){var _this=this;// Record the stream token.
return this.localStore.setLastStreamToken(this.writeStream.lastStreamToken).then(function(){// Send the write pipeline now that the stream is established.
for(var _i=0,_a=_this.writePipeline;_i<_a.length;_i++){var batch=_a[_i];_this.writeStream.writeMutations(batch.mutations);}}).catch(ignoreIfPrimaryLeaseLoss);};RemoteStore.prototype.onMutationResult=function(commitVersion,results){var _this=this;// This is a response to a write containing mutations and should be
// correlated to the first write in our write pipeline.
assert(this.writePipeline.length>0,'Got result for empty write pipeline');var batch=this.writePipeline.shift();var success=MutationBatchResult.from(batch,commitVersion,results,this.writeStream.lastStreamToken);return this.syncEngine.applySuccessfulWrite(success).then(function(){// It's possible that with the completion of this mutation another
// slot has freed up.
return _this.fillWritePipeline();});};RemoteStore.prototype.onWriteStreamClose=function(error){return tslib_1.__awaiter(this,void 0,void 0,function(){var errorHandling;var _this=this;return tslib_1.__generator(this,function(_a){if(error===undefined){// Graceful stop (due to stop() or idle timeout). Make sure that's
// desirable.
assert(!this.shouldStartWriteStream(),'Write stream was stopped gracefully while still needed.');}// If the write stream closed due to an error, invoke the error callbacks if
// there are pending writes.
if(error&&this.writePipeline.length>0){errorHandling=void 0;if(this.writeStream.handshakeComplete){// This error affects the actual write.
errorHandling=this.handleWriteError(error);}else{// If there was an error before the handshake has finished, it's
// possible that the server is unable to process the stream token
// we're sending. (Perhaps it's too old?)
errorHandling=this.handleHandshakeError(error);}return[2/*return*/,errorHandling.then(function(){// The write stream might have been started by refilling the write
// pipeline for failed writes
if(_this.shouldStartWriteStream()){_this.startWriteStream();}})];}return[2/*return*/];});});};RemoteStore.prototype.handleHandshakeError=function(error){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){// Reset the token if it's a permanent error, signaling the write stream is
// no longer valid. Note that the handshake does not count as a write: see
// comments on isPermanentWriteError for details.
if(isPermanentError(error.code)){debug(LOG_TAG$8,'RemoteStore error before completed handshake; resetting stream token: ',this.writeStream.lastStreamToken);this.writeStream.lastStreamToken=emptyByteString();return[2/*return*/,this.localStore.setLastStreamToken(emptyByteString()).catch(ignoreIfPrimaryLeaseLoss)];}return[2/*return*/];});});};RemoteStore.prototype.handleWriteError=function(error){return tslib_1.__awaiter(this,void 0,void 0,function(){var batch;var _this=this;return tslib_1.__generator(this,function(_a){// Only handle permanent errors here. If it's transient, just let the retry
// logic kick in.
if(isPermanentWriteError(error.code)){batch=this.writePipeline.shift();// In this case it's also unlikely that the server itself is melting
// down -- this was just a bad request so inhibit backoff on the next
// restart.
this.writeStream.inhibitBackoff();return[2/*return*/,this.syncEngine.rejectFailedWrite(batch.batchId,error).then(function(){// It's possible that with the completion of this mutation
// another slot has freed up.
return _this.fillWritePipeline();})];}return[2/*return*/];});});};RemoteStore.prototype.createTransaction=function(){return new Transaction(this.datastore);};RemoteStore.prototype.handleCredentialChange=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!this.canUseNetwork())return[3/*break*/,3];// Tear down and re-create our network streams. This will ensure we get a fresh auth token
// for the new user and re-fill the write pipeline with new mutations from the LocalStore
// (since mutations are per-user).
debug(LOG_TAG$8,'RemoteStore restarting streams for new credential');this.networkEnabled=false;return[4/*yield*/,this.disableNetworkInternal()];case 1:_a.sent();this.onlineStateTracker.set(OnlineState.Unknown);return[4/*yield*/,this.enableNetwork()];case 2:_a.sent();_a.label=3;case 3:return[2/*return*/];}});});};/**
     * Toggles the network state when the client gains or loses its primary lease.
     */RemoteStore.prototype.applyPrimaryState=function(isPrimary){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.isPrimary=isPrimary;if(!(isPrimary&&this.networkEnabled))return[3/*break*/,2];return[4/*yield*/,this.enableNetwork()];case 1:_a.sent();return[3/*break*/,4];case 2:if(!!isPrimary)return[3/*break*/,4];return[4/*yield*/,this.disableNetworkInternal()];case 3:_a.sent();this.onlineStateTracker.set(OnlineState.Unknown);_a.label=4;case 4:return[2/*return*/];}});});};return RemoteStore;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */var QueryListenersInfo=/** @class */function(){function QueryListenersInfo(){this.listeners=[];}return QueryListenersInfo;}();/**
 * EventManager is responsible for mapping queries to query event emitters.
 * It handles "fan-out". -- Identical queries will re-use the same watch on the
 * backend.
 */var EventManager=/** @class */function(){function EventManager(syncEngine){this.syncEngine=syncEngine;this.queries=new ObjectMap(function(q){return q.canonicalId();});this.onlineState=OnlineState.Unknown;this.syncEngine.subscribe(this);}EventManager.prototype.listen=function(listener){var query=listener.query;var firstListen=false;var queryInfo=this.queries.get(query);if(!queryInfo){firstListen=true;queryInfo=new QueryListenersInfo();this.queries.set(query,queryInfo);}queryInfo.listeners.push(listener);listener.applyOnlineStateChange(this.onlineState);if(queryInfo.viewSnap)listener.onViewSnapshot(queryInfo.viewSnap);if(firstListen){return this.syncEngine.listen(query).then(function(targetId){queryInfo.targetId=targetId;return targetId;});}else{return Promise.resolve(queryInfo.targetId);}};EventManager.prototype.unlisten=function(listener){return tslib_1.__awaiter(this,void 0,void 0,function(){var query,lastListen,queryInfo,i;return tslib_1.__generator(this,function(_a){query=listener.query;lastListen=false;queryInfo=this.queries.get(query);if(queryInfo){i=queryInfo.listeners.indexOf(listener);if(i>=0){queryInfo.listeners.splice(i,1);lastListen=queryInfo.listeners.length===0;}}if(lastListen){this.queries.delete(query);return[2/*return*/,this.syncEngine.unlisten(query)];}return[2/*return*/];});});};EventManager.prototype.onWatchChange=function(viewSnaps){for(var _i=0,viewSnaps_1=viewSnaps;_i<viewSnaps_1.length;_i++){var viewSnap=viewSnaps_1[_i];var query=viewSnap.query;var queryInfo=this.queries.get(query);if(queryInfo){for(var _a=0,_b=queryInfo.listeners;_a<_b.length;_a++){var listener=_b[_a];listener.onViewSnapshot(viewSnap);}queryInfo.viewSnap=viewSnap;}}};EventManager.prototype.onWatchError=function(query,error){var queryInfo=this.queries.get(query);if(queryInfo){for(var _i=0,_a=queryInfo.listeners;_i<_a.length;_i++){var listener=_a[_i];listener.onError(error);}}// Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
// after an error.
this.queries.delete(query);};EventManager.prototype.onOnlineStateChange=function(onlineState){this.onlineState=onlineState;this.queries.forEach(function(_,queryInfo){for(var _i=0,_a=queryInfo.listeners;_i<_a.length;_i++){var listener=_a[_i];listener.applyOnlineStateChange(onlineState);}});};return EventManager;}();/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */var QueryListener=/** @class */function(){function QueryListener(query,queryObserver,options){this.query=query;this.queryObserver=queryObserver;/**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */this.raisedInitialEvent=false;this.onlineState=OnlineState.Unknown;this.options=options||{};}QueryListener.prototype.onViewSnapshot=function(snap){assert(snap.docChanges.length>0||snap.syncStateChanged,'We got a new snapshot with no changes?');if(!this.options.includeMetadataChanges){// Remove the metadata only changes.
var docChanges=[];for(var _i=0,_a=snap.docChanges;_i<_a.length;_i++){var docChange=_a[_i];if(docChange.type!==ChangeType.Metadata){docChanges.push(docChange);}}snap=new ViewSnapshot(snap.query,snap.docs,snap.oldDocs,docChanges,snap.mutatedKeys,snap.fromCache,snap.syncStateChanged,/* excludesMetadataChanges= */true);}if(!this.raisedInitialEvent){if(this.shouldRaiseInitialEvent(snap,this.onlineState)){this.raiseInitialEvent(snap);}}else if(this.shouldRaiseEvent(snap)){this.queryObserver.next(snap);}this.snap=snap;};QueryListener.prototype.onError=function(error){this.queryObserver.error(error);};QueryListener.prototype.applyOnlineStateChange=function(onlineState){this.onlineState=onlineState;if(this.snap&&!this.raisedInitialEvent&&this.shouldRaiseInitialEvent(this.snap,onlineState)){this.raiseInitialEvent(this.snap);}};QueryListener.prototype.shouldRaiseInitialEvent=function(snap,onlineState){assert(!this.raisedInitialEvent,'Determining whether to raise first event but already had first event');// Always raise the first event when we're synced
if(!snap.fromCache){return true;}// NOTE: We consider OnlineState.Unknown as online (it should become Offline
// or Online if we wait long enough).
var maybeOnline=onlineState!==OnlineState.Offline;// Don't raise the event if we're online, aren't synced yet (checked
// above) and are waiting for a sync.
if(this.options.waitForSyncWhenOnline&&maybeOnline){assert(snap.fromCache,'Waiting for sync, but snapshot is not from cache');return false;}// Raise data from cache if we have any documents or we are offline
return!snap.docs.isEmpty()||onlineState===OnlineState.Offline;};QueryListener.prototype.shouldRaiseEvent=function(snap){// We don't need to handle includeDocumentMetadataChanges here because
// the Metadata only changes have already been stripped out if needed.
// At this point the only changes we will see are the ones we should
// propagate.
if(snap.docChanges.length>0){return true;}var hasPendingWritesChanged=this.snap&&this.snap.hasPendingWrites!==snap.hasPendingWrites;if(snap.syncStateChanged||hasPendingWritesChanged){return this.options.includeMetadataChanges===true;}// Generally we should have hit one of the cases above, but it's possible
// to get here if there were only metadata docChanges and they got
// stripped out.
return false;};QueryListener.prototype.raiseInitialEvent=function(snap){assert(!this.raisedInitialEvent,'Trying to raise initial events for second time');snap=ViewSnapshot.fromInitialDocuments(snap.query,snap.docs,snap.mutatedKeys,snap.fromCache);this.raisedInitialEvent=true;this.queryObserver.next(snap);};return QueryListener;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */var LocalViewChanges=/** @class */function(){function LocalViewChanges(targetId,addedKeys,removedKeys){this.targetId=targetId;this.addedKeys=addedKeys;this.removedKeys=removedKeys;}LocalViewChanges.fromSnapshot=function(targetId,viewSnapshot){var addedKeys=documentKeySet();var removedKeys=documentKeySet();for(var _i=0,_a=viewSnapshot.docChanges;_i<_a.length;_i++){var docChange=_a[_i];switch(docChange.type){case ChangeType.Added:addedKeys=addedKeys.add(docChange.doc.key);break;case ChangeType.Removed:removedKeys=removedKeys.add(docChange.doc.key);break;default:// do nothing
}}return new LocalViewChanges(targetId,addedKeys,removedKeys);};return LocalViewChanges;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var AddedLimboDocument=/** @class */function(){function AddedLimboDocument(key){this.key=key;}return AddedLimboDocument;}();var RemovedLimboDocument=/** @class */function(){function RemovedLimboDocument(key){this.key=key;}return RemovedLimboDocument;}();/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */var View=/** @class */function(){function View(query,/** Documents included in the remote target */_syncedDocuments){this.query=query;this._syncedDocuments=_syncedDocuments;this.syncState=null;/**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */this.current=false;/** Documents in the view but not in the remote target */this.limboDocuments=documentKeySet();/** Document Keys that have local changes */this.mutatedKeys=documentKeySet();this.documentSet=new DocumentSet(query.docComparator.bind(query));}Object.defineProperty(View.prototype,"syncedDocuments",{/**
         * The set of remote documents that the server has told us belongs to the target associated with
         * this view.
         */get:function get(){return this._syncedDocuments;},enumerable:true,configurable:true});/**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges The doc changes to apply to this view.
     * @param previousChanges If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @return a new set of docs, changes, and refill flag.
     */View.prototype.computeDocChanges=function(docChanges,previousChanges){var _this=this;var changeSet=previousChanges?previousChanges.changeSet:new DocumentChangeSet();var oldDocumentSet=previousChanges?previousChanges.documentSet:this.documentSet;var newMutatedKeys=previousChanges?previousChanges.mutatedKeys:this.mutatedKeys;var newDocumentSet=oldDocumentSet;var needsRefill=false;// Track the last doc in a (full) limit. This is necessary, because some
// update (a delete, or an update moving a doc past the old limit) might
// mean there is some other document in the local cache that either should
// come (1) between the old last limit doc and the new last document, in the
// case of updates, or (2) after the new last document, in the case of
// deletes. So we keep this doc at the old limit to compare the updates to.
//
// Note that this should never get used in a refill (when previousChanges is
// set), because there will only be adds -- no deletes or updates.
var lastDocInLimit=this.query.hasLimit()&&oldDocumentSet.size===this.query.limit?oldDocumentSet.last():null;docChanges.inorderTraversal(function(key,newMaybeDoc){var oldDoc=oldDocumentSet.get(key);var newDoc=newMaybeDoc instanceof Document?newMaybeDoc:null;if(newDoc){assert(key.isEqual(newDoc.key),'Mismatching keys found in document changes: '+key+' != '+newDoc.key);newDoc=_this.query.matches(newDoc)?newDoc:null;}var oldDocHadPendingMutations=oldDoc?_this.mutatedKeys.has(oldDoc.key):false;var newDocHasPendingMutations=newDoc?newDoc.hasLocalMutations||// We only consider committed mutations for documents that were
// mutated during the lifetime of the view.
_this.mutatedKeys.has(newDoc.key)&&newDoc.hasCommittedMutations:false;var changeApplied=false;// Calculate change
if(oldDoc&&newDoc){var docsEqual=oldDoc.data.isEqual(newDoc.data);if(!docsEqual){if(!_this.shouldWaitForSyncedDocument(oldDoc,newDoc)){changeSet.track({type:ChangeType.Modified,doc:newDoc});changeApplied=true;if(lastDocInLimit&&_this.query.docComparator(newDoc,lastDocInLimit)>0){// This doc moved from inside the limit to after the limit.
// That means there may be some doc in the local cache that's
// actually less than this one.
needsRefill=true;}}}else if(oldDocHadPendingMutations!==newDocHasPendingMutations){changeSet.track({type:ChangeType.Metadata,doc:newDoc});changeApplied=true;}}else if(!oldDoc&&newDoc){changeSet.track({type:ChangeType.Added,doc:newDoc});changeApplied=true;}else if(oldDoc&&!newDoc){changeSet.track({type:ChangeType.Removed,doc:oldDoc});changeApplied=true;if(lastDocInLimit){// A doc was removed from a full limit query. We'll need to
// requery from the local cache to see if we know about some other
// doc that should be in the results.
needsRefill=true;}}if(changeApplied){if(newDoc){newDocumentSet=newDocumentSet.add(newDoc);if(newDocHasPendingMutations){newMutatedKeys=newMutatedKeys.add(key);}else{newMutatedKeys=newMutatedKeys.delete(key);}}else{newDocumentSet=newDocumentSet.delete(key);newMutatedKeys=newMutatedKeys.delete(key);}}});if(this.query.hasLimit()){while(newDocumentSet.size>this.query.limit){var oldDoc=newDocumentSet.last();newDocumentSet=newDocumentSet.delete(oldDoc.key);newMutatedKeys=newMutatedKeys.delete(oldDoc.key);changeSet.track({type:ChangeType.Removed,doc:oldDoc});}}assert(!needsRefill||!previousChanges,'View was refilled using docs that themselves needed refilling.');return{documentSet:newDocumentSet,changeSet:changeSet,needsRefill:needsRefill,mutatedKeys:newMutatedKeys};};View.prototype.shouldWaitForSyncedDocument=function(oldDoc,newDoc){// We suppress the initial change event for documents that were modified as
// part of a write acknowledgment (e.g. when the value of a server transform
// is applied) as Watch will send us the same document again.
// By suppressing the event, we only raise two user visible events (one with
// `hasPendingWrites` and the final state of the document) instead of three
// (one with `hasPendingWrites`, the modified document with
// `hasPendingWrites` and the final state of the document).
return oldDoc.hasLocalMutations&&newDoc.hasCommittedMutations&&!newDoc.hasLocalMutations;};/**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges The set of changes to make to the view's docs.
     * @param updateLimboDocuments Whether to update limbo documents based on this
     *        change.
     * @param targetChange A target change to apply for computing limbo docs and
     *        sync state.
     * @return A new ViewChange with the given docs, changes, and sync state.
     */// PORTING NOTE: The iOS/Android clients always compute limbo document changes.
View.prototype.applyChanges=function(docChanges,updateLimboDocuments,targetChange){var _this=this;assert(!docChanges.needsRefill,'Cannot apply changes that need a refill');var oldDocs=this.documentSet;this.documentSet=docChanges.documentSet;this.mutatedKeys=docChanges.mutatedKeys;// Sort changes based on type and query comparator
var changes=docChanges.changeSet.getChanges();changes.sort(function(c1,c2){return compareChangeType(c1.type,c2.type)||_this.query.docComparator(c1.doc,c2.doc);});this.applyTargetChange(targetChange);var limboChanges=updateLimboDocuments?this.updateLimboDocuments():[];var synced=this.limboDocuments.size===0&&this.current;var newSyncState=synced?SyncState.Synced:SyncState.Local;var syncStateChanged=newSyncState!==this.syncState;this.syncState=newSyncState;if(changes.length===0&&!syncStateChanged){// no changes
return{limboChanges:limboChanges};}else{var snap=new ViewSnapshot(this.query,docChanges.documentSet,oldDocs,changes,docChanges.mutatedKeys,newSyncState===SyncState.Local,syncStateChanged,/* excludesMetadataChanges= */false);return{snapshot:snap,limboChanges:limboChanges};}};/**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */View.prototype.applyOnlineStateChange=function(onlineState){if(this.current&&onlineState===OnlineState.Offline){// If we're offline, set `current` to false and then call applyChanges()
// to refresh our syncState and generate a ViewChange as appropriate. We
// are guaranteed to get a new TargetChange that sets `current` back to
// true once the client is back online.
this.current=false;return this.applyChanges({documentSet:this.documentSet,changeSet:new DocumentChangeSet(),mutatedKeys:this.mutatedKeys,needsRefill:false},/* updateLimboDocuments= */false);}else{// No effect, just return a no-op ViewChange.
return{limboChanges:[]};}};/**
     * Returns whether the doc for the given key should be in limbo.
     */View.prototype.shouldBeInLimbo=function(key){// If the remote end says it's part of this query, it's not in limbo.
if(this._syncedDocuments.has(key)){return false;}// The local store doesn't think it's a result, so it shouldn't be in limbo.
if(!this.documentSet.has(key)){return false;}// If there are local changes to the doc, they might explain why the server
// doesn't know that it's part of the query. So don't put it in limbo.
// TODO(klimt): Ideally, we would only consider changes that might actually
// affect this specific query.
if(this.documentSet.get(key).hasLocalMutations){return false;}// Everything else is in limbo.
return true;};/**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */View.prototype.applyTargetChange=function(targetChange){var _this=this;if(targetChange){targetChange.addedDocuments.forEach(function(key){return _this._syncedDocuments=_this._syncedDocuments.add(key);});targetChange.modifiedDocuments.forEach(function(key){return assert(_this._syncedDocuments.has(key),"Modified document "+key+" not found in view.");});targetChange.removedDocuments.forEach(function(key){return _this._syncedDocuments=_this._syncedDocuments.delete(key);});this.current=targetChange.current;}};View.prototype.updateLimboDocuments=function(){var _this=this;// We can only determine limbo documents when we're in-sync with the server.
if(!this.current){return[];}// TODO(klimt): Do this incrementally so that it's not quadratic when
// updating many documents.
var oldLimboDocuments=this.limboDocuments;this.limboDocuments=documentKeySet();this.documentSet.forEach(function(doc){if(_this.shouldBeInLimbo(doc.key)){_this.limboDocuments=_this.limboDocuments.add(doc.key);}});// Diff the new limbo docs with the old limbo docs.
var changes=[];oldLimboDocuments.forEach(function(key){if(!_this.limboDocuments.has(key)){changes.push(new RemovedLimboDocument(key));}});this.limboDocuments.forEach(function(key){if(!oldLimboDocuments.has(key)){changes.push(new AddedLimboDocument(key));}});return changes;};/**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param localDocs - The documents that match the query according to the
     * LocalStore.
     * @param remoteKeys - The keys of the documents that match the query
     * according to the backend.
     *
     * @return The ViewChange that resulted from this synchronization.
     */// PORTING NOTE: Multi-tab only.
View.prototype.synchronizeWithPersistedState=function(localDocs,remoteKeys){this._syncedDocuments=remoteKeys;this.limboDocuments=documentKeySet();var docChanges=this.computeDocChanges(localDocs);return this.applyChanges(docChanges,/*updateLimboDocuments=*/true);};/**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */// PORTING NOTE: Multi-tab only.
View.prototype.computeInitialSnapshot=function(){return ViewSnapshot.fromInitialDocuments(this.query,this.documentSet,this.mutatedKeys,this.syncState===SyncState.Local);};return View;}();function compareChangeType(c1,c2){var order=function order(change){switch(change){case ChangeType.Added:return 1;case ChangeType.Modified:return 2;case ChangeType.Metadata:// A metadata change is converted to a modified change at the public
// api layer.  Since we sort by document key and then change type,
// metadata and modified changes must be sorted equivalently.
return 2;case ChangeType.Removed:return 0;default:return fail('Unknown ChangeType: '+change);}};return order(c1)-order(c2);}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$9='SyncEngine';/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */var QueryView=/** @class */function(){function QueryView(/**
     * The query itself.
     */query,/**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */targetId,/**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */view){this.query=query;this.targetId=targetId;this.view=view;}return QueryView;}();/** Tracks a limbo resolution. */var LimboResolution=/** @class */function(){function LimboResolution(key){this.key=key;}return LimboResolution;}();/**
 * SyncEngine is the central controller in the client SDK architecture. It is
 * the glue code between the EventManager, LocalStore, and RemoteStore. Some of
 * SyncEngine's responsibilities include:
 * 1. Coordinating client requests and remote events between the EventManager
 *    and the local and remote data stores.
 * 2. Managing a View object for each query, providing the unified view between
 *    the local and remote data stores.
 * 3. Notifying the RemoteStore when the LocalStore has new mutations in its
 *    queue that need sending to the backend.
 *
 * The SyncEngine’s methods should only ever be called by methods running in the
 * global async queue.
 */var SyncEngine=/** @class */function(){function SyncEngine(localStore,remoteStore,// PORTING NOTE: Manages state synchronization in multi-tab environments.
sharedClientState,currentUser){this.localStore=localStore;this.remoteStore=remoteStore;this.sharedClientState=sharedClientState;this.currentUser=currentUser;this.syncEngineListener=null;this.queryViewsByQuery=new ObjectMap(function(q){return q.canonicalId();});this.queryViewsByTarget={};this.limboTargetsByKey=new SortedMap(DocumentKey.comparator);this.limboResolutionsByTarget={};this.limboDocumentRefs=new ReferenceSet();/** Stores user completion handlers, indexed by User and BatchId. */this.mutationUserCallbacks={};this.limboTargetIdGenerator=TargetIdGenerator.forSyncEngine();// The primary state is set to `true` or `false` immediately after Firestore
// startup. In the interim, a client should only be considered primary if
// `isPrimary` is true.
this.isPrimary=undefined;this.onlineState=OnlineState.Unknown;}Object.defineProperty(SyncEngine.prototype,"isPrimaryClient",{// Only used for testing.
get:function get(){return this.isPrimary===true;},enumerable:true,configurable:true});/** Subscribes to SyncEngine notifications. Has to be called exactly once. */SyncEngine.prototype.subscribe=function(syncEngineListener){assert(syncEngineListener!==null,'SyncEngine listener cannot be null');assert(this.syncEngineListener===null,'SyncEngine already has a subscriber.');this.syncEngineListener=syncEngineListener;};/**
     * Initiates the new listen, resolves promise when listen enqueued to the
     * server. All the subsequent view snapshots or errors are sent to the
     * subscribed handlers. Returns the targetId of the query.
     */SyncEngine.prototype.listen=function(query){return tslib_1.__awaiter(this,void 0,void 0,function(){var targetId,viewSnapshot,queryView,queryData,status_1;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.assertSubscribed('listen()');queryView=this.queryViewsByQuery.get(query);if(!queryView)return[3/*break*/,1];// PORTING NOTE: With Multi-Tab Web, it is possible that a query view
// already exists when EventManager calls us for the first time. This
// happens when the primary tab is already listening to this query on
// behalf of another tab and the user of the primary also starts listening
// to the query. EventManager will not have an assigned target ID in this
// case and calls `listen` to obtain this ID.
targetId=queryView.targetId;this.sharedClientState.addLocalQueryTarget(targetId);viewSnapshot=queryView.view.computeInitialSnapshot();return[3/*break*/,4];case 1:return[4/*yield*/,this.localStore.allocateQuery(query)];case 2:queryData=_a.sent();status_1=this.sharedClientState.addLocalQueryTarget(queryData.targetId);targetId=queryData.targetId;return[4/*yield*/,this.initializeViewAndComputeSnapshot(queryData,status_1==='current')];case 3:viewSnapshot=_a.sent();if(this.isPrimary){this.remoteStore.listen(queryData);}_a.label=4;case 4:this.syncEngineListener.onWatchChange([viewSnapshot]);return[2/*return*/,targetId];}});});};/**
     * Registers a view for a previously unknown query and computes its initial
     * snapshot.
     */SyncEngine.prototype.initializeViewAndComputeSnapshot=function(queryData,current){var _this=this;var query=queryData.query;return this.localStore.executeQuery(query).then(function(docs){return _this.localStore.remoteDocumentKeys(queryData.targetId).then(function(remoteKeys){var view=new View(query,remoteKeys);var viewDocChanges=view.computeDocChanges(docs);// tslint:disable-next-line:max-line-length Prettier formats this exceed 100 characters.
var synthesizedTargetChange=TargetChange.createSynthesizedTargetChangeForCurrentChange(queryData.targetId,current&&_this.onlineState!==OnlineState.Offline);var viewChange=view.applyChanges(viewDocChanges,/* updateLimboDocuments= */_this.isPrimary===true,synthesizedTargetChange);assert(viewChange.limboChanges.length===0,'View returned limbo docs before target ack from the server.');assert(!!viewChange.snapshot,'applyChanges for new view should always return a snapshot');var data=new QueryView(query,queryData.targetId,view);_this.queryViewsByQuery.set(query,data);_this.queryViewsByTarget[queryData.targetId]=data;return viewChange.snapshot;});});};/**
     * Reconcile the list of synced documents in an existing view with those
     * from persistence.
     */// PORTING NOTE: Multi-tab only.
SyncEngine.prototype.synchronizeViewAndComputeSnapshot=function(queryView){var _this=this;return this.localStore.executeQuery(queryView.query).then(function(docs){return _this.localStore.remoteDocumentKeys(queryView.targetId).then(function(remoteKeys){return tslib_1.__awaiter(_this,void 0,void 0,function(){var viewSnapshot;return tslib_1.__generator(this,function(_a){viewSnapshot=queryView.view.synchronizeWithPersistedState(docs,remoteKeys);if(this.isPrimary){this.updateTrackedLimbos(queryView.targetId,viewSnapshot.limboChanges);}return[2/*return*/,viewSnapshot];});});});});};/** Stops listening to the query. */SyncEngine.prototype.unlisten=function(query){return tslib_1.__awaiter(this,void 0,void 0,function(){var queryView,targetRemainsActive;var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.assertSubscribed('unlisten()');queryView=this.queryViewsByQuery.get(query);assert(!!queryView,'Trying to unlisten on query not found:'+query);if(!this.isPrimary)return[3/*break*/,3];// We need to remove the local query target first to allow us to verify
// whether any other client is still interested in this target.
this.sharedClientState.removeLocalQueryTarget(queryView.targetId);targetRemainsActive=this.sharedClientState.isActiveQueryTarget(queryView.targetId);if(!!targetRemainsActive)return[3/*break*/,2];return[4/*yield*/,this.localStore.releaseQuery(query,/*keepPersistedQueryData=*/false).then(function(){_this.sharedClientState.clearQueryState(queryView.targetId);_this.remoteStore.unlisten(queryView.targetId);_this.removeAndCleanupQuery(queryView);}).catch(ignoreIfPrimaryLeaseLoss)];case 1:_a.sent();_a.label=2;case 2:return[3/*break*/,5];case 3:this.removeAndCleanupQuery(queryView);return[4/*yield*/,this.localStore.releaseQuery(query,/*keepPersistedQueryData=*/true)];case 4:_a.sent();_a.label=5;case 5:return[2/*return*/];}});});};/**
     * Initiates the write of local mutation batch which involves adding the
     * writes to the mutation queue, notifying the remote store about new
     * mutations and raising events for any changes this write caused.
     *
     * The promise returned by this call is resolved when the above steps
     * have completed, *not* when the write was acked by the backend. The
     * userCallback is resolved once the write was acked/rejected by the
     * backend (or failed locally for any other reason).
     */SyncEngine.prototype.write=function(batch,userCallback){var _this=this;this.assertSubscribed('write()');return this.localStore.localWrite(batch).then(function(result){_this.sharedClientState.addPendingMutation(result.batchId);_this.addMutationCallback(result.batchId,userCallback);return _this.emitNewSnapsAndNotifyLocalStore(result.changes);}).then(function(){return _this.remoteStore.fillWritePipeline();});};// TODO(klimt): Wrap the given error in a standard Firestore error object.
SyncEngine.prototype.wrapUpdateFunctionError=function(error){return error;};/**
     * Takes an updateFunction in which a set of reads and writes can be performed
     * atomically. In the updateFunction, the client can read and write values
     * using the supplied transaction object. After the updateFunction, all
     * changes will be committed. If some other client has changed any of the data
     * referenced, then the updateFunction will be called again. If the
     * updateFunction still fails after the given number of retries, then the
     * transaction will be rejection.
     *
     * The transaction object passed to the updateFunction contains methods for
     * accessing documents and collections. Unlike other datastore access, data
     * accessed with the transaction will not reflect local changes that have not
     * been committed. For this reason, it is required that all reads are
     * performed before any writes. Transactions must be performed while online.
     *
     * The promise returned is resolved when the transaction is fully committed.
     */SyncEngine.prototype.runTransaction=function(updateFunction,retries){var _this=this;if(retries===void 0){retries=5;}assert(retries>=0,'Got negative number of retries for transaction.');var transaction=this.remoteStore.createTransaction();var wrappedUpdateFunction=function wrappedUpdateFunction(){try{var userPromise=updateFunction(transaction);if(isNullOrUndefined(userPromise)||!userPromise.catch||!userPromise.then){return Promise.reject(Error('Transaction callback must return a Promise'));}return userPromise.catch(function(e){return Promise.reject(_this.wrapUpdateFunctionError(e));});}catch(e){return Promise.reject(_this.wrapUpdateFunctionError(e));}};return wrappedUpdateFunction().then(function(result){return transaction.commit().then(function(){return result;}).catch(function(error){if(retries===0){return Promise.reject(error);}// TODO(klimt): Put in a retry delay?
return _this.runTransaction(updateFunction,retries-1);});});};SyncEngine.prototype.applyRemoteEvent=function(remoteEvent){var _this=this;this.assertSubscribed('applyRemoteEvent()');return this.localStore.applyRemoteEvent(remoteEvent).then(function(changes){// Update `receivedDocument` as appropriate for any limbo targets.
forEach(remoteEvent.targetChanges,function(targetId,targetChange){var limboResolution=_this.limboResolutionsByTarget[targetId];if(limboResolution){// Since this is a limbo resolution lookup, it's for a single document
// and it could be added, modified, or removed, but not a combination.
assert(targetChange.addedDocuments.size+targetChange.modifiedDocuments.size+targetChange.removedDocuments.size<=1,'Limbo resolution for single document contains multiple changes.');if(targetChange.addedDocuments.size>0){limboResolution.receivedDocument=true;}else if(targetChange.modifiedDocuments.size>0){assert(limboResolution.receivedDocument,'Received change for limbo target document without add.');}else if(targetChange.removedDocuments.size>0){assert(limboResolution.receivedDocument,'Received remove for limbo target document without add.');limboResolution.receivedDocument=false;}}});return _this.emitNewSnapsAndNotifyLocalStore(changes,remoteEvent);}).catch(ignoreIfPrimaryLeaseLoss);};/**
     * Applies an OnlineState change to the sync engine and notifies any views of
     * the change.
     */SyncEngine.prototype.applyOnlineStateChange=function(onlineState,source){// If we are the secondary client, we explicitly ignore the remote store's
// online state (the local client may go offline, even though the primary
// tab remains online) and only apply the primary tab's online state from
// SharedClientState.
if(this.isPrimary&&source===OnlineStateSource.RemoteStore||!this.isPrimary&&source===OnlineStateSource.SharedClientState){var newViewSnapshots_1=[];this.queryViewsByQuery.forEach(function(query,queryView){var viewChange=queryView.view.applyOnlineStateChange(onlineState);assert(viewChange.limboChanges.length===0,'OnlineState should not affect limbo documents.');if(viewChange.snapshot){newViewSnapshots_1.push(viewChange.snapshot);}});this.syncEngineListener.onOnlineStateChange(onlineState);this.syncEngineListener.onWatchChange(newViewSnapshots_1);this.onlineState=onlineState;if(this.isPrimary){this.sharedClientState.setOnlineState(onlineState);}}};SyncEngine.prototype.rejectListen=function(targetId,err){return tslib_1.__awaiter(this,void 0,void 0,function(){var limboResolution,limboKey,documentUpdates,resolvedLimboDocuments,event_1,queryView_1;var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.assertSubscribed('rejectListens()');// PORTING NOTE: Multi-tab only.
this.sharedClientState.updateQueryState(targetId,'rejected',err);limboResolution=this.limboResolutionsByTarget[targetId];limboKey=limboResolution&&limboResolution.key;if(!limboKey)return[3/*break*/,1];// Since this query failed, we won't want to manually unlisten to it.
// So go ahead and remove it from bookkeeping.
this.limboTargetsByKey=this.limboTargetsByKey.remove(limboKey);delete this.limboResolutionsByTarget[targetId];documentUpdates=new SortedMap(DocumentKey.comparator);documentUpdates=documentUpdates.insert(limboKey,new NoDocument(limboKey,SnapshotVersion.forDeletedDoc()));resolvedLimboDocuments=documentKeySet().add(limboKey);event_1=new RemoteEvent(SnapshotVersion.MIN,/* targetChanges= */{},/* targetMismatches= */new SortedSet(primitiveComparator),documentUpdates,resolvedLimboDocuments);return[2/*return*/,this.applyRemoteEvent(event_1)];case 1:queryView_1=this.queryViewsByTarget[targetId];assert(!!queryView_1,'Unknown targetId: '+targetId);return[4/*yield*/,this.localStore.releaseQuery(queryView_1.query,/* keepPersistedQueryData */false).then(function(){return _this.removeAndCleanupQuery(queryView_1);}).catch(ignoreIfPrimaryLeaseLoss)];case 2:_a.sent();this.syncEngineListener.onWatchError(queryView_1.query,err);_a.label=3;case 3:return[2/*return*/];}});});};// PORTING NOTE: Multi-tab only
SyncEngine.prototype.applyBatchState=function(batchId,batchState,error){return tslib_1.__awaiter(this,void 0,void 0,function(){var documents;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.assertSubscribed('applyBatchState()');return[4/*yield*/,this.localStore.lookupMutationDocuments(batchId)];case 1:documents=_a.sent();if(documents===null){// A throttled tab may not have seen the mutation before it was completed
// and removed from the mutation queue, in which case we won't have cached
// the affected documents. In this case we can safely ignore the update
// since that means we didn't apply the mutation locally at all (if we
// had, we would have cached the affected documents), and so we will just
// see any resulting document changes via normal remote document updates
// as applicable.
debug(LOG_TAG$9,'Cannot apply mutation batch with id: '+batchId);return[2/*return*/];}if(!(batchState==='pending'))return[3/*break*/,3];// If we are the primary client, we need to send this write to the
// backend. Secondary clients will ignore these writes since their remote
// connection is disabled.
return[4/*yield*/,this.remoteStore.fillWritePipeline()];case 2:// If we are the primary client, we need to send this write to the
// backend. Secondary clients will ignore these writes since their remote
// connection is disabled.
_a.sent();return[3/*break*/,4];case 3:if(batchState==='acknowledged'||batchState==='rejected'){// NOTE: Both these methods are no-ops for batches that originated from
// other clients.
this.processUserCallback(batchId,error?error:null);this.localStore.removeCachedMutationBatchMetadata(batchId);}else{fail("Unknown batchState: "+batchState);}_a.label=4;case 4:return[4/*yield*/,this.emitNewSnapsAndNotifyLocalStore(documents)];case 5:_a.sent();return[2/*return*/];}});});};SyncEngine.prototype.applySuccessfulWrite=function(mutationBatchResult){var _this=this;this.assertSubscribed('applySuccessfulWrite()');var batchId=mutationBatchResult.batch.batchId;// The local store may or may not be able to apply the write result and
// raise events immediately (depending on whether the watcher is caught
// up), so we raise user callbacks first so that they consistently happen
// before listen events.
this.processUserCallback(batchId,/*error=*/null);return this.localStore.acknowledgeBatch(mutationBatchResult).then(function(changes){_this.sharedClientState.updateMutationState(batchId,'acknowledged');return _this.emitNewSnapsAndNotifyLocalStore(changes);}).catch(ignoreIfPrimaryLeaseLoss);};SyncEngine.prototype.rejectFailedWrite=function(batchId,error){var _this=this;this.assertSubscribed('rejectFailedWrite()');// The local store may or may not be able to apply the write result and
// raise events immediately (depending on whether the watcher is caught up),
// so we raise user callbacks first so that they consistently happen before
// listen events.
this.processUserCallback(batchId,error);return this.localStore.rejectBatch(batchId).then(function(changes){_this.sharedClientState.updateMutationState(batchId,'rejected',error);return _this.emitNewSnapsAndNotifyLocalStore(changes);}).catch(ignoreIfPrimaryLeaseLoss);};SyncEngine.prototype.addMutationCallback=function(batchId,callback){var newCallbacks=this.mutationUserCallbacks[this.currentUser.toKey()];if(!newCallbacks){newCallbacks=new SortedMap(primitiveComparator);}newCallbacks=newCallbacks.insert(batchId,callback);this.mutationUserCallbacks[this.currentUser.toKey()]=newCallbacks;};/**
     * Resolves or rejects the user callback for the given batch and then discards
     * it.
     */SyncEngine.prototype.processUserCallback=function(batchId,error){var newCallbacks=this.mutationUserCallbacks[this.currentUser.toKey()];// NOTE: Mutations restored from persistence won't have callbacks, so it's
// okay for there to be no callback for this ID.
if(newCallbacks){var callback=newCallbacks.get(batchId);if(callback){assert(batchId===newCallbacks.minKey(),'Mutation callbacks processed out-of-order?');if(error){callback.reject(error);}else{callback.resolve();}newCallbacks=newCallbacks.remove(batchId);}this.mutationUserCallbacks[this.currentUser.toKey()]=newCallbacks;}};SyncEngine.prototype.removeAndCleanupQuery=function(queryView){var _this=this;this.sharedClientState.removeLocalQueryTarget(queryView.targetId);this.queryViewsByQuery.delete(queryView.query);delete this.queryViewsByTarget[queryView.targetId];if(this.isPrimary){var limboKeys=this.limboDocumentRefs.referencesForId(queryView.targetId);this.limboDocumentRefs.removeReferencesForId(queryView.targetId);limboKeys.forEach(function(limboKey){var isReferenced=_this.limboDocumentRefs.containsKey(limboKey);if(!isReferenced){// We removed the last reference for this key
_this.removeLimboTarget(limboKey);}});}};SyncEngine.prototype.removeLimboTarget=function(key){// It's possible that the target already got removed because the query failed. In that case,
// the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
var limboTargetId=this.limboTargetsByKey.get(key);if(limboTargetId===null){// This target already got removed, because the query failed.
return;}this.remoteStore.unlisten(limboTargetId);this.limboTargetsByKey=this.limboTargetsByKey.remove(key);delete this.limboResolutionsByTarget[limboTargetId];};SyncEngine.prototype.updateTrackedLimbos=function(targetId,limboChanges){for(var _i=0,limboChanges_1=limboChanges;_i<limboChanges_1.length;_i++){var limboChange=limboChanges_1[_i];if(limboChange instanceof AddedLimboDocument){this.limboDocumentRefs.addReference(limboChange.key,targetId);this.trackLimboChange(limboChange);}else if(limboChange instanceof RemovedLimboDocument){debug(LOG_TAG$9,'Document no longer in limbo: '+limboChange.key);this.limboDocumentRefs.removeReference(limboChange.key,targetId);var isReferenced=this.limboDocumentRefs.containsKey(limboChange.key);if(!isReferenced){// We removed the last reference for this key
this.removeLimboTarget(limboChange.key);}}else{fail('Unknown limbo change: '+JSON.stringify(limboChange));}}};SyncEngine.prototype.trackLimboChange=function(limboChange){var key=limboChange.key;if(!this.limboTargetsByKey.get(key)){debug(LOG_TAG$9,'New document in limbo: '+key);var limboTargetId=this.limboTargetIdGenerator.next();var query=Query.atPath(key.path);this.limboResolutionsByTarget[limboTargetId]=new LimboResolution(key);this.remoteStore.listen(new QueryData(query,limboTargetId,QueryPurpose.LimboResolution,ListenSequence.INVALID));this.limboTargetsByKey=this.limboTargetsByKey.insert(key,limboTargetId);}};// Visible for testing
SyncEngine.prototype.currentLimboDocs=function(){return this.limboTargetsByKey;};SyncEngine.prototype.emitNewSnapsAndNotifyLocalStore=function(changes,remoteEvent){return tslib_1.__awaiter(this,void 0,void 0,function(){var newSnaps,docChangesInAllViews,queriesProcessed;var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:newSnaps=[];docChangesInAllViews=[];queriesProcessed=[];this.queryViewsByQuery.forEach(function(_,queryView){queriesProcessed.push(Promise.resolve().then(function(){var viewDocChanges=queryView.view.computeDocChanges(changes);if(!viewDocChanges.needsRefill){return viewDocChanges;}// The query has a limit and some docs were removed, so we need
// to re-run the query against the local store to make sure we
// didn't lose any good docs that had been past the limit.
return _this.localStore.executeQuery(queryView.query).then(function(docs){return queryView.view.computeDocChanges(docs,viewDocChanges);});}).then(function(viewDocChanges){var targetChange=remoteEvent&&remoteEvent.targetChanges[queryView.targetId];var viewChange=queryView.view.applyChanges(viewDocChanges,/* updateLimboDocuments= */_this.isPrimary===true,targetChange);_this.updateTrackedLimbos(queryView.targetId,viewChange.limboChanges);if(viewChange.snapshot){if(_this.isPrimary){_this.sharedClientState.updateQueryState(queryView.targetId,viewChange.snapshot.fromCache?'not-current':'current');}newSnaps.push(viewChange.snapshot);var docChanges=LocalViewChanges.fromSnapshot(queryView.targetId,viewChange.snapshot);docChangesInAllViews.push(docChanges);}}));});return[4/*yield*/,Promise.all(queriesProcessed)];case 1:_a.sent();this.syncEngineListener.onWatchChange(newSnaps);return[4/*yield*/,this.localStore.notifyLocalViewChanges(docChangesInAllViews)];case 2:_a.sent();return[2/*return*/];}});});};SyncEngine.prototype.assertSubscribed=function(fnName){assert(this.syncEngineListener!==null,'Trying to call '+fnName+' before calling subscribe().');};SyncEngine.prototype.handleCredentialChange=function(user){return tslib_1.__awaiter(this,void 0,void 0,function(){var userChanged,result;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:userChanged=!this.currentUser.isEqual(user);this.currentUser=user;if(!userChanged)return[3/*break*/,3];return[4/*yield*/,this.localStore.handleUserChange(user)];case 1:result=_a.sent();// TODO(b/114226417): Consider calling this only in the primary tab.
this.sharedClientState.handleUserChange(user,result.removedBatchIds,result.addedBatchIds);return[4/*yield*/,this.emitNewSnapsAndNotifyLocalStore(result.affectedDocuments)];case 2:_a.sent();_a.label=3;case 3:return[4/*yield*/,this.remoteStore.handleCredentialChange()];case 4:_a.sent();return[2/*return*/];}});});};// PORTING NOTE: Multi-tab only
SyncEngine.prototype.applyPrimaryState=function(isPrimary){return tslib_1.__awaiter(this,void 0,void 0,function(){var activeTargets,activeQueries,_i,activeQueries_1,queryData,activeTargets_1,p_1;var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!(isPrimary===true&&this.isPrimary!==true))return[3/*break*/,3];this.isPrimary=true;return[4/*yield*/,this.remoteStore.applyPrimaryState(true)];case 1:_a.sent();activeTargets=this.sharedClientState.getAllActiveQueryTargets();return[4/*yield*/,this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets.toArray())];case 2:activeQueries=_a.sent();for(_i=0,activeQueries_1=activeQueries;_i<activeQueries_1.length;_i++){queryData=activeQueries_1[_i];this.remoteStore.listen(queryData);}return[3/*break*/,7];case 3:if(!(isPrimary===false&&this.isPrimary!==false))return[3/*break*/,7];this.isPrimary=false;activeTargets_1=[];p_1=Promise.resolve();forEachNumber(this.queryViewsByTarget,function(targetId,queryView){if(_this.sharedClientState.isLocalQueryTarget(targetId)){activeTargets_1.push(targetId);}else{p_1=p_1.then(function(){return _this.unlisten(queryView.query);});}_this.remoteStore.unlisten(queryView.targetId);});return[4/*yield*/,p_1];case 4:_a.sent();return[4/*yield*/,this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_1)];case 5:_a.sent();this.resetLimboDocuments();return[4/*yield*/,this.remoteStore.applyPrimaryState(false)];case 6:_a.sent();_a.label=7;case 7:return[2/*return*/];}});});};// PORTING NOTE: Multi-tab only.
SyncEngine.prototype.resetLimboDocuments=function(){var _this=this;forEachNumber(this.limboResolutionsByTarget,function(targetId){_this.remoteStore.unlisten(targetId);});this.limboDocumentRefs.removeAllReferences();this.limboResolutionsByTarget=[];this.limboTargetsByKey=new SortedMap(DocumentKey.comparator);};/**
     * Reconcile the query views of the provided query targets with the state from
     * persistence. Raises snapshots for any changes that affect the local
     * client and returns the updated state of all target's query data.
     */// PORTING NOTE: Multi-tab only.
SyncEngine.prototype.synchronizeQueryViewsAndRaiseSnapshots=function(targets){var _this=this;var p=Promise.resolve();var activeQueries=[];var newViewSnapshots=[];var _loop_1=function _loop_1(targetId){p=p.then(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){var queryData,queryView,viewChange,query;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:queryView=this.queryViewsByTarget[targetId];if(!queryView)return[3/*break*/,4];// For queries that have a local View, we need to update their state
// in LocalStore (as the resume token and the snapshot version
// might have changed) and reconcile their views with the persisted
// state (the list of syncedDocuments may have gotten out of sync).
return[4/*yield*/,this.localStore.releaseQuery(queryView.query,/*keepPersistedQueryData=*/true)];case 1:// For queries that have a local View, we need to update their state
// in LocalStore (as the resume token and the snapshot version
// might have changed) and reconcile their views with the persisted
// state (the list of syncedDocuments may have gotten out of sync).
_a.sent();return[4/*yield*/,this.localStore.allocateQuery(queryView.query)];case 2:queryData=_a.sent();return[4/*yield*/,this.synchronizeViewAndComputeSnapshot(queryView)];case 3:viewChange=_a.sent();if(viewChange.snapshot){newViewSnapshots.push(viewChange.snapshot);}return[3/*break*/,8];case 4:assert(this.isPrimary===true,'A secondary tab should never have an active query without an active view.');return[4/*yield*/,this.localStore.getQueryForTarget(targetId)];case 5:query=_a.sent();assert(!!query,"Query data for target "+targetId+" not found");return[4/*yield*/,this.localStore.allocateQuery(query)];case 6:queryData=_a.sent();return[4/*yield*/,this.initializeViewAndComputeSnapshot(queryData,/*current=*/false)];case 7:_a.sent();_a.label=8;case 8:activeQueries.push(queryData);return[2/*return*/];}});});});};for(var _i=0,targets_1=targets;_i<targets_1.length;_i++){var targetId=targets_1[_i];_loop_1(targetId);}return p.then(function(){_this.syncEngineListener.onWatchChange(newViewSnapshots);return activeQueries;});};// PORTING NOTE: Multi-tab only
SyncEngine.prototype.getActiveClients=function(){return this.localStore.getActiveClients();};// PORTING NOTE: Multi-tab only
SyncEngine.prototype.applyTargetState=function(targetId,state,error){return tslib_1.__awaiter(this,void 0,void 0,function(){var _a,queryView;var _this=this;return tslib_1.__generator(this,function(_b){switch(_b.label){case 0:if(this.isPrimary){// If we receive a target state notification via WebStorage, we are
// either already secondary or another tab has taken the primary lease.
debug(LOG_TAG$9,'Ignoring unexpected query state notification.');return[2/*return*/];}if(!this.queryViewsByTarget[targetId])return[3/*break*/,5];_a=state;switch(_a){case'current':return[3/*break*/,1];case'not-current':return[3/*break*/,1];case'rejected':return[3/*break*/,2];}return[3/*break*/,4];case 1:{return[2/*return*/,this.localStore.getNewDocumentChanges().then(function(changes){return tslib_1.__awaiter(_this,void 0,void 0,function(){var synthesizedRemoteEvent;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:synthesizedRemoteEvent=RemoteEvent.createSynthesizedRemoteEventForCurrentChange(targetId,state==='current');return[4/*yield*/,this.emitNewSnapsAndNotifyLocalStore(changes,synthesizedRemoteEvent)];case 1:_a.sent();return[2/*return*/];}});});},function(err){return tslib_1.__awaiter(_this,void 0,void 0,function(){var activeTargets_2;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(!isDocumentChangeMissingError(err))return[3/*break*/,2];activeTargets_2=[];forEachNumber(this.queryViewsByTarget,function(target){return activeTargets_2.push(target);});return[4/*yield*/,this.synchronizeQueryViewsAndRaiseSnapshots(activeTargets_2)];case 1:_a.sent();return[3/*break*/,3];case 2:throw err;case 3:return[2/*return*/];}});});})];}_b.label=2;case 2:queryView=this.queryViewsByTarget[targetId];this.removeAndCleanupQuery(queryView);return[4/*yield*/,this.localStore.releaseQuery(queryView.query,/*keepPersistedQueryData=*/true)];case 3:_b.sent();this.syncEngineListener.onWatchError(queryView.query,error);return[3/*break*/,5];case 4:fail('Unexpected target state: '+state);_b.label=5;case 5:return[2/*return*/];}});});};// PORTING NOTE: Multi-tab only
SyncEngine.prototype.applyActiveTargetsChange=function(added,removed){return tslib_1.__awaiter(this,void 0,void 0,function(){var _i,added_1,targetId,query,queryData,_loop_2,this_1,_a,removed_1,targetId;var _this=this;return tslib_1.__generator(this,function(_b){switch(_b.label){case 0:if(!this.isPrimary){return[2/*return*/];}_i=0,added_1=added;_b.label=1;case 1:if(!(_i<added_1.length))return[3/*break*/,6];targetId=added_1[_i];assert(!this.queryViewsByTarget[targetId],'Trying to add an already active target');return[4/*yield*/,this.localStore.getQueryForTarget(targetId)];case 2:query=_b.sent();assert(!!query,"Query data for active target "+targetId+" not found");return[4/*yield*/,this.localStore.allocateQuery(query)];case 3:queryData=_b.sent();return[4/*yield*/,this.initializeViewAndComputeSnapshot(queryData,/*current=*/false)];case 4:_b.sent();this.remoteStore.listen(queryData);_b.label=5;case 5:_i++;return[3/*break*/,1];case 6:_loop_2=function _loop_2(targetId){var queryView;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:queryView=this_1.queryViewsByTarget[targetId];if(!queryView)return[3/*break*/,2];return[4/*yield*/,this_1.localStore.releaseQuery(queryView.query,/*keepPersistedQueryData=*/false).then(function(){_this.remoteStore.unlisten(targetId);_this.removeAndCleanupQuery(queryView);}).catch(ignoreIfPrimaryLeaseLoss)];case 1:_a.sent();_a.label=2;case 2:return[2/*return*/];}});};this_1=this;_a=0,removed_1=removed;_b.label=7;case 7:if(!(_a<removed_1.length))return[3/*break*/,10];targetId=removed_1[_a];return[5/*yield**/,_loop_2(targetId)];case 8:_b.sent();_b.label=9;case 9:_a++;return[3/*break*/,7];case 10:return[2/*return*/];}});});};// PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
// the online state.
SyncEngine.prototype.enableNetwork=function(){this.localStore.setNetworkEnabled(true);return this.remoteStore.enableNetwork();};// PORTING NOTE: Multi-tab only. In other clients, LocalStore is unaware of
// the online state.
SyncEngine.prototype.disableNetwork=function(){this.localStore.setNetworkEnabled(false);return this.remoteStore.disableNetwork();};SyncEngine.prototype.getRemoteKeysForTarget=function(targetId){var limboResolution=this.limboResolutionsByTarget[targetId];if(limboResolution&&limboResolution.receivedDocument){return documentKeySet().add(limboResolution.key);}else{return this.queryViewsByTarget[targetId]?this.queryViewsByTarget[targetId].view.syncedDocuments:documentKeySet();}};return SyncEngine;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */var User=/** @class */function(){function User(uid){this.uid=uid;}User.prototype.isAuthenticated=function(){return this.uid!=null;};/**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */User.prototype.toKey=function(){if(this.isAuthenticated()){return'uid:'+this.uid;}else{return'anonymous-user';}};User.prototype.isEqual=function(otherUser){return otherUser.uid===this.uid;};/** A user with a null UID. */User.UNAUTHENTICATED=new User(null);// TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
User.GOOGLE_CREDENTIALS=new User('google-credentials-uid');User.FIRST_PARTY=new User('first-party-uid');return User;}();/**
 * @license
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$a='SharedClientState';// The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
var CLIENT_STATE_KEY_PREFIX='firestore_clients';// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
//
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
var MUTATION_BATCH_KEY_PREFIX='firestore_mutations';// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
var QUERY_TARGET_KEY_PREFIX='firestore_targets';// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
var ONLINE_STATE_KEY_PREFIX='firestore_online_state';// The WebStorage key prefix for the key that stores the last sequence number allocated. The key
// looks like 'firestore_sequence_number_<persistence_prefix>'.
var SEQUENCE_NUMBER_KEY_PREFIX='firestore_sequence_number';/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */// Visible for testing
var MutationMetadata=/** @class */function(){function MutationMetadata(user,batchId,state,error){this.user=user;this.batchId=batchId;this.state=state;this.error=error;assert(error!==undefined===(state==='rejected'),"MutationMetadata must contain an error iff state is 'rejected'");}/**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */MutationMetadata.fromWebStorageEntry=function(user,batchId,value){var mutationBatch=JSON.parse(value);var validData=typeof mutationBatch==='object'&&['pending','acknowledged','rejected'].indexOf(mutationBatch.state)!==-1&&(mutationBatch.error===undefined||typeof mutationBatch.error==='object');var firestoreError=undefined;if(validData&&mutationBatch.error){validData=typeof mutationBatch.error.message==='string'&&typeof mutationBatch.error.code==='string';if(validData){firestoreError=new FirestoreError(mutationBatch.error.code,mutationBatch.error.message);}}if(validData){return new MutationMetadata(user,batchId,mutationBatch.state,firestoreError);}else{error(LOG_TAG$a,"Failed to parse mutation state for ID '"+batchId+"': "+value);return null;}};MutationMetadata.prototype.toWebStorageJSON=function(){var batchMetadata={state:this.state,updateTimeMs:Date.now()// Modify the existing value to trigger update.
};if(this.error){batchMetadata.error={code:this.error.code,message:this.error.message};}return JSON.stringify(batchMetadata);};return MutationMetadata;}();/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */// Visible for testing
var QueryTargetMetadata=/** @class */function(){function QueryTargetMetadata(targetId,state,error){this.targetId=targetId;this.state=state;this.error=error;assert(error!==undefined===(state==='rejected'),"QueryTargetMetadata must contain an error iff state is 'rejected'");}/**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */QueryTargetMetadata.fromWebStorageEntry=function(targetId,value){var targetState=JSON.parse(value);var validData=typeof targetState==='object'&&['not-current','current','rejected'].indexOf(targetState.state)!==-1&&(targetState.error===undefined||typeof targetState.error==='object');var firestoreError=undefined;if(validData&&targetState.error){validData=typeof targetState.error.message==='string'&&typeof targetState.error.code==='string';if(validData){firestoreError=new FirestoreError(targetState.error.code,targetState.error.message);}}if(validData){return new QueryTargetMetadata(targetId,targetState.state,firestoreError);}else{error(LOG_TAG$a,"Failed to parse target state for ID '"+targetId+"': "+value);return null;}};QueryTargetMetadata.prototype.toWebStorageJSON=function(){var targetState={state:this.state,updateTimeMs:Date.now()// Modify the existing value to trigger update.
};if(this.error){targetState.error={code:this.error.code,message:this.error.message};}return JSON.stringify(targetState);};return QueryTargetMetadata;}();/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */var RemoteClientState=/** @class */function(){function RemoteClientState(clientId,activeTargetIds){this.clientId=clientId;this.activeTargetIds=activeTargetIds;}/**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */RemoteClientState.fromWebStorageEntry=function(clientId,value){var clientState=JSON.parse(value);var validData=typeof clientState==='object'&&clientState.activeTargetIds instanceof Array;var activeTargetIdsSet=targetIdSet();for(var i=0;validData&&i<clientState.activeTargetIds.length;++i){validData=isSafeInteger(clientState.activeTargetIds[i]);activeTargetIdsSet=activeTargetIdsSet.add(clientState.activeTargetIds[i]);}if(validData){return new RemoteClientState(clientId,activeTargetIdsSet);}else{error(LOG_TAG$a,"Failed to parse client data for instance '"+clientId+"': "+value);return null;}};return RemoteClientState;}();/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */var SharedOnlineState=/** @class */function(){function SharedOnlineState(clientId,onlineState){this.clientId=clientId;this.onlineState=onlineState;}/**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */SharedOnlineState.fromWebStorageEntry=function(value){var onlineState=JSON.parse(value);var validData=typeof onlineState==='object'&&OnlineState[onlineState.onlineState]!==undefined&&typeof onlineState.clientId==='string';if(validData){return new SharedOnlineState(onlineState.clientId,OnlineState[onlineState.onlineState]);}else{error(LOG_TAG$a,"Failed to parse online state: "+value);return null;}};return SharedOnlineState;}();/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */// Visible for testing.
var LocalClientState=/** @class */function(){function LocalClientState(){this.activeTargetIds=targetIdSet();}LocalClientState.prototype.addQueryTarget=function(targetId){assert(!this.activeTargetIds.has(targetId),"Target with ID '"+targetId+"' already active.");this.activeTargetIds=this.activeTargetIds.add(targetId);};LocalClientState.prototype.removeQueryTarget=function(targetId){this.activeTargetIds=this.activeTargetIds.delete(targetId);};/**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */LocalClientState.prototype.toWebStorageJSON=function(){var data={activeTargetIds:this.activeTargetIds.toArray(),updateTimeMs:Date.now()// Modify the existing value to trigger update.
};return JSON.stringify(data);};return LocalClientState;}();/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */var WebStorageSharedClientState=/** @class */function(){function WebStorageSharedClientState(queue,platform,persistenceKey,localClientId,initialUser){this.queue=queue;this.platform=platform;this.persistenceKey=persistenceKey;this.localClientId=localClientId;this.syncEngine=null;this.onlineStateHandler=null;this.sequenceNumberHandler=null;this.activeClients={};this.storageListener=this.handleWebStorageEvent.bind(this);this.started=false;/**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */this.earlyEvents=[];if(!WebStorageSharedClientState.isAvailable(this.platform)){throw new FirestoreError(Code.UNIMPLEMENTED,'LocalStorage is not available on this platform.');}// Escape the special characters mentioned here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
var escapedPersistenceKey=persistenceKey.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');this.storage=this.platform.window.localStorage;this.currentUser=initialUser;this.localClientStorageKey=this.toWebStorageClientStateKey(this.localClientId);this.sequenceNumberKey=SEQUENCE_NUMBER_KEY_PREFIX+"_"+persistenceKey;this.activeClients[this.localClientId]=new LocalClientState();this.clientStateKeyRe=new RegExp("^"+CLIENT_STATE_KEY_PREFIX+"_"+escapedPersistenceKey+"_([^_]*)$");this.mutationBatchKeyRe=new RegExp("^"+MUTATION_BATCH_KEY_PREFIX+"_"+escapedPersistenceKey+"_(\\d+)(?:_(.*))?$");this.queryTargetKeyRe=new RegExp("^"+QUERY_TARGET_KEY_PREFIX+"_"+escapedPersistenceKey+"_(\\d+)$");this.onlineStateKey=ONLINE_STATE_KEY_PREFIX+"_"+persistenceKey;// Rather than adding the storage observer during start(), we add the
// storage observer during initialization. This ensures that we collect
// events before other components populate their initial state (during their
// respective start() calls). Otherwise, we might for example miss a
// mutation that is added after LocalStore's start() processed the existing
// mutations but before we observe WebStorage events.
this.platform.window.addEventListener('storage',this.storageListener);}/** Returns 'true' if WebStorage is available in the current environment. */WebStorageSharedClientState.isAvailable=function(platform){return!!(platform.window&&platform.window.localStorage!=null);};WebStorageSharedClientState.prototype.start=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){var existingClients,_i,existingClients_1,clientId,storageItem,clientState,onlineStateJSON,onlineState,_a,_b,event_1;var _this=this;return tslib_1.__generator(this,function(_c){switch(_c.label){case 0:assert(!this.started,'WebStorageSharedClientState already started');assert(this.syncEngine!==null,'syncEngine property must be set before calling start()');assert(this.onlineStateHandler!==null,'onlineStateHandler property must be set before calling start()');return[4/*yield*/,this.syncEngine.getActiveClients()];case 1:existingClients=_c.sent();for(_i=0,existingClients_1=existingClients;_i<existingClients_1.length;_i++){clientId=existingClients_1[_i];if(clientId===this.localClientId){continue;}storageItem=this.getItem(this.toWebStorageClientStateKey(clientId));if(storageItem){clientState=RemoteClientState.fromWebStorageEntry(clientId,storageItem);if(clientState){this.activeClients[clientState.clientId]=clientState;}}}this.persistClientState();onlineStateJSON=this.storage.getItem(this.onlineStateKey);if(onlineStateJSON){onlineState=this.fromWebStorageOnlineState(onlineStateJSON);if(onlineState){this.handleOnlineStateEvent(onlineState);}}for(_a=0,_b=this.earlyEvents;_a<_b.length;_a++){event_1=_b[_a];this.handleWebStorageEvent(event_1);}this.earlyEvents=[];// Register a window unload hook to remove the client metadata entry from
// WebStorage even if `shutdown()` was not called.
this.platform.window.addEventListener('unload',function(){return _this.shutdown();});this.started=true;return[2/*return*/];}});});};WebStorageSharedClientState.prototype.writeSequenceNumber=function(sequenceNumber){this.setItem(this.sequenceNumberKey,JSON.stringify(sequenceNumber));};WebStorageSharedClientState.prototype.getAllActiveQueryTargets=function(){var activeTargets=targetIdSet();forEach(this.activeClients,function(key,value){activeTargets=activeTargets.unionWith(value.activeTargetIds);});return activeTargets;};WebStorageSharedClientState.prototype.isActiveQueryTarget=function(targetId){// This is not using `obj.forEach` since `forEach` doesn't support early
// return.
for(var clientId in this.activeClients){if(this.activeClients.hasOwnProperty(clientId)){if(this.activeClients[clientId].activeTargetIds.has(targetId)){return true;}}}return false;};WebStorageSharedClientState.prototype.addPendingMutation=function(batchId){this.persistMutationState(batchId,'pending');};WebStorageSharedClientState.prototype.updateMutationState=function(batchId,state,error){this.persistMutationState(batchId,state,error);// Once a final mutation result is observed by other clients, they no longer
// access the mutation's metadata entry. Since WebStorage replays events
// in order, it is safe to delete the entry right after updating it.
this.removeMutationState(batchId);};WebStorageSharedClientState.prototype.addLocalQueryTarget=function(targetId){var queryState='not-current';// Lookup an existing query state if the target ID was already registered
// by another tab
if(this.isActiveQueryTarget(targetId)){var storageItem=this.storage.getItem(this.toWebStorageQueryTargetMetadataKey(targetId));if(storageItem){var metadata=QueryTargetMetadata.fromWebStorageEntry(targetId,storageItem);if(metadata){queryState=metadata.state;}}}this.localClientState.addQueryTarget(targetId);this.persistClientState();return queryState;};WebStorageSharedClientState.prototype.removeLocalQueryTarget=function(targetId){this.localClientState.removeQueryTarget(targetId);this.persistClientState();};WebStorageSharedClientState.prototype.isLocalQueryTarget=function(targetId){return this.localClientState.activeTargetIds.has(targetId);};WebStorageSharedClientState.prototype.clearQueryState=function(targetId){this.removeItem(this.toWebStorageQueryTargetMetadataKey(targetId));};WebStorageSharedClientState.prototype.updateQueryState=function(targetId,state,error){this.persistQueryTargetState(targetId,state,error);};WebStorageSharedClientState.prototype.handleUserChange=function(user,removedBatchIds,addedBatchIds){var _this=this;removedBatchIds.forEach(function(batchId){_this.removeMutationState(batchId);});this.currentUser=user;addedBatchIds.forEach(function(batchId){_this.addPendingMutation(batchId);});};WebStorageSharedClientState.prototype.setOnlineState=function(onlineState){this.persistOnlineState(onlineState);};WebStorageSharedClientState.prototype.shutdown=function(){if(this.started){this.platform.window.removeEventListener('storage',this.storageListener);this.removeItem(this.localClientStorageKey);this.started=false;}};WebStorageSharedClientState.prototype.getItem=function(key){var value=this.storage.getItem(key);debug(LOG_TAG$a,'READ',key,value);return value;};WebStorageSharedClientState.prototype.setItem=function(key,value){debug(LOG_TAG$a,'SET',key,value);this.storage.setItem(key,value);};WebStorageSharedClientState.prototype.removeItem=function(key){debug(LOG_TAG$a,'REMOVE',key);this.storage.removeItem(key);};WebStorageSharedClientState.prototype.handleWebStorageEvent=function(event){var _this=this;if(event.storageArea===this.storage){debug(LOG_TAG$a,'EVENT',event.key,event.newValue);if(event.key===this.localClientStorageKey){error('Received WebStorage notification for local change. Another client might have '+'garbage-collected our state');return;}this.queue.enqueueAndForget(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){var clientState,clientId,mutationMetadata,queryTargetMetadata,onlineState,sequenceNumber;return tslib_1.__generator(this,function(_a){if(!this.started){this.earlyEvents.push(event);return[2/*return*/];}if(event.key===null){return[2/*return*/];}if(this.clientStateKeyRe.test(event.key)){if(event.newValue!=null){clientState=this.fromWebStorageClientState(event.key,event.newValue);if(clientState){return[2/*return*/,this.handleClientStateEvent(clientState.clientId,clientState)];}}else{clientId=this.fromWebStorageClientStateKey(event.key);return[2/*return*/,this.handleClientStateEvent(clientId,null)];}}else if(this.mutationBatchKeyRe.test(event.key)){if(event.newValue!==null){mutationMetadata=this.fromWebStorageMutationMetadata(event.key,event.newValue);if(mutationMetadata){return[2/*return*/,this.handleMutationBatchEvent(mutationMetadata)];}}}else if(this.queryTargetKeyRe.test(event.key)){if(event.newValue!==null){queryTargetMetadata=this.fromWebStorageQueryTargetMetadata(event.key,event.newValue);if(queryTargetMetadata){return[2/*return*/,this.handleQueryTargetEvent(queryTargetMetadata)];}}}else if(event.key===this.onlineStateKey){if(event.newValue!==null){onlineState=this.fromWebStorageOnlineState(event.newValue);if(onlineState){return[2/*return*/,this.handleOnlineStateEvent(onlineState)];}}}else if(event.key===this.sequenceNumberKey){assert(!!this.sequenceNumberHandler,'Missing sequenceNumberHandler');sequenceNumber=fromWebStorageSequenceNumber(event.newValue);if(sequenceNumber!==ListenSequence.INVALID){this.sequenceNumberHandler(sequenceNumber);}}return[2/*return*/];});});});}};Object.defineProperty(WebStorageSharedClientState.prototype,"localClientState",{get:function get(){return this.activeClients[this.localClientId];},enumerable:true,configurable:true});WebStorageSharedClientState.prototype.persistClientState=function(){this.setItem(this.localClientStorageKey,this.localClientState.toWebStorageJSON());};WebStorageSharedClientState.prototype.persistMutationState=function(batchId,state,error){var mutationState=new MutationMetadata(this.currentUser,batchId,state,error);var mutationKey=this.toWebStorageMutationBatchKey(batchId);this.setItem(mutationKey,mutationState.toWebStorageJSON());};WebStorageSharedClientState.prototype.removeMutationState=function(batchId){var mutationKey=this.toWebStorageMutationBatchKey(batchId);this.removeItem(mutationKey);};WebStorageSharedClientState.prototype.persistOnlineState=function(onlineState){var entry={clientId:this.localClientId,onlineState:OnlineState[onlineState]};this.storage.setItem(this.onlineStateKey,JSON.stringify(entry));};WebStorageSharedClientState.prototype.persistQueryTargetState=function(targetId,state,error){var targetKey=this.toWebStorageQueryTargetMetadataKey(targetId);var targetMetadata=new QueryTargetMetadata(targetId,state,error);this.setItem(targetKey,targetMetadata.toWebStorageJSON());};/** Assembles the key for a client state in WebStorage */WebStorageSharedClientState.prototype.toWebStorageClientStateKey=function(clientId){assert(clientId.indexOf('_')===-1,"Client key cannot contain '_', but was '"+clientId+"'");return CLIENT_STATE_KEY_PREFIX+"_"+this.persistenceKey+"_"+clientId;};/** Assembles the key for a query state in WebStorage */WebStorageSharedClientState.prototype.toWebStorageQueryTargetMetadataKey=function(targetId){return QUERY_TARGET_KEY_PREFIX+"_"+this.persistenceKey+"_"+targetId;};/** Assembles the key for a mutation batch in WebStorage */WebStorageSharedClientState.prototype.toWebStorageMutationBatchKey=function(batchId){var mutationKey=MUTATION_BATCH_KEY_PREFIX+"_"+this.persistenceKey+"_"+batchId;if(this.currentUser.isAuthenticated()){mutationKey+="_"+this.currentUser.uid;}return mutationKey;};/**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */WebStorageSharedClientState.prototype.fromWebStorageClientStateKey=function(key){var match=this.clientStateKeyRe.exec(key);return match?match[1]:null;};/**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */WebStorageSharedClientState.prototype.fromWebStorageClientState=function(key,value){var clientId=this.fromWebStorageClientStateKey(key);assert(clientId!==null,"Cannot parse client state key '"+key+"'");return RemoteClientState.fromWebStorageEntry(clientId,value);};/**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */WebStorageSharedClientState.prototype.fromWebStorageMutationMetadata=function(key,value){var match=this.mutationBatchKeyRe.exec(key);assert(match!==null,"Cannot parse mutation batch key '"+key+"'");var batchId=Number(match[1]);var userId=match[2]!==undefined?match[2]:null;return MutationMetadata.fromWebStorageEntry(new User(userId),batchId,value);};/**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */WebStorageSharedClientState.prototype.fromWebStorageQueryTargetMetadata=function(key,value){var match=this.queryTargetKeyRe.exec(key);assert(match!==null,"Cannot parse query target key '"+key+"'");var targetId=Number(match[1]);return QueryTargetMetadata.fromWebStorageEntry(targetId,value);};/**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */WebStorageSharedClientState.prototype.fromWebStorageOnlineState=function(value){return SharedOnlineState.fromWebStorageEntry(value);};WebStorageSharedClientState.prototype.handleMutationBatchEvent=function(mutationBatch){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(mutationBatch.user.uid!==this.currentUser.uid){debug(LOG_TAG$a,"Ignoring mutation for non-active user "+mutationBatch.user.uid);return[2/*return*/];}return[2/*return*/,this.syncEngine.applyBatchState(mutationBatch.batchId,mutationBatch.state,mutationBatch.error)];});});};WebStorageSharedClientState.prototype.handleQueryTargetEvent=function(targetMetadata){return this.syncEngine.applyTargetState(targetMetadata.targetId,targetMetadata.state,targetMetadata.error);};WebStorageSharedClientState.prototype.handleClientStateEvent=function(clientId,clientState){var _this=this;var existingTargets=this.getAllActiveQueryTargets();if(clientState){this.activeClients[clientId]=clientState;}else{delete this.activeClients[clientId];}var newTargets=this.getAllActiveQueryTargets();var addedTargets=[];var removedTargets=[];newTargets.forEach(function(targetId){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(!existingTargets.has(targetId)){addedTargets.push(targetId);}return[2/*return*/];});});});existingTargets.forEach(function(targetId){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){if(!newTargets.has(targetId)){removedTargets.push(targetId);}return[2/*return*/];});});});return this.syncEngine.applyActiveTargetsChange(addedTargets,removedTargets);};WebStorageSharedClientState.prototype.handleOnlineStateEvent=function(onlineState){// We check whether the client that wrote this online state is still active
// by comparing its client ID to the list of clients kept active in
// IndexedDb. If a client does not update their IndexedDb client state
// within 5 seconds, it is considered inactive and we don't emit an online
// state event.
if(this.activeClients[onlineState.clientId]){this.onlineStateHandler(onlineState.onlineState);}};return WebStorageSharedClientState;}();function fromWebStorageSequenceNumber(seqString){var sequenceNumber=ListenSequence.INVALID;if(seqString!=null){try{var parsed=JSON.parse(seqString);assert(typeof parsed==='number','Found non-numeric sequence number');sequenceNumber=parsed;}catch(e){error(LOG_TAG$a,'Failed to read sequence number from WebStorage',e);}}return sequenceNumber;}/**
 * `MemorySharedClientState` is a simple implementation of SharedClientState for
 * clients using memory persistence. The state in this class remains fully
 * isolated and no synchronization is performed.
 */var MemorySharedClientState=/** @class */function(){function MemorySharedClientState(){this.localState=new LocalClientState();this.queryState={};this.syncEngine=null;this.onlineStateHandler=null;this.sequenceNumberHandler=null;}MemorySharedClientState.prototype.addPendingMutation=function(batchId){// No op.
};MemorySharedClientState.prototype.updateMutationState=function(batchId,state,error){// No op.
};MemorySharedClientState.prototype.addLocalQueryTarget=function(targetId){this.localState.addQueryTarget(targetId);return this.queryState[targetId]||'not-current';};MemorySharedClientState.prototype.updateQueryState=function(targetId,state,error){this.queryState[targetId]=state;};MemorySharedClientState.prototype.removeLocalQueryTarget=function(targetId){this.localState.removeQueryTarget(targetId);};MemorySharedClientState.prototype.isLocalQueryTarget=function(targetId){return this.localState.activeTargetIds.has(targetId);};MemorySharedClientState.prototype.clearQueryState=function(targetId){delete this.queryState[targetId];};MemorySharedClientState.prototype.getAllActiveQueryTargets=function(){return this.localState.activeTargetIds;};MemorySharedClientState.prototype.isActiveQueryTarget=function(targetId){return this.localState.activeTargetIds.has(targetId);};MemorySharedClientState.prototype.start=function(){this.localState=new LocalClientState();return Promise.resolve();};MemorySharedClientState.prototype.handleUserChange=function(user,removedBatchIds,addedBatchIds){// No op.
};MemorySharedClientState.prototype.setOnlineState=function(onlineState){// No op.
};MemorySharedClientState.prototype.shutdown=function(){};MemorySharedClientState.prototype.writeSequenceNumber=function(sequenceNumber){};return MemorySharedClientState;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var LOG_TAG$b='FirestoreClient';/** The DOMException code for an aborted operation. */var DOM_EXCEPTION_ABORTED=20;/** The DOMException code for quota exceeded. */var DOM_EXCEPTION_QUOTA_EXCEEDED=22;var IndexedDbPersistenceSettings=/** @class */function(){function IndexedDbPersistenceSettings(cacheSizeBytes,synchronizeTabs){this.cacheSizeBytes=cacheSizeBytes;this.synchronizeTabs=synchronizeTabs;}IndexedDbPersistenceSettings.prototype.lruParams=function(){return LruParams.withCacheSize(this.cacheSizeBytes);};return IndexedDbPersistenceSettings;}();var MemoryPersistenceSettings=/** @class */function(){function MemoryPersistenceSettings(){}return MemoryPersistenceSettings;}();/**
 * FirestoreClient is a top-level class that constructs and owns all of the
 * pieces of the client SDK architecture. It is responsible for creating the
 * async queue that is shared by all of the other components in the system.
 */var FirestoreClient=/** @class */function(){function FirestoreClient(platform,databaseInfo,credentials,/**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */asyncQueue){this.platform=platform;this.databaseInfo=databaseInfo;this.credentials=credentials;this.asyncQueue=asyncQueue;this.clientId=AutoId.newId();this.isShutdown=false;}/**
     * Starts up the FirestoreClient, returning only whether or not enabling
     * persistence succeeded.
     *
     * The intent here is to "do the right thing" as far as users are concerned.
     * Namely, in cases where offline persistence is requested and possible,
     * enable it, but otherwise fall back to persistence disabled. For the most
     * part we expect this to succeed one way or the other so we don't expect our
     * users to actually wait on the firestore.enablePersistence Promise since
     * they generally won't care.
     *
     * Of course some users actually do care about whether or not persistence
     * was successfully enabled, so the Promise returned from this method
     * indicates this outcome.
     *
     * This presents a problem though: even before enablePersistence resolves or
     * rejects, users may have made calls to e.g. firestore.collection() which
     * means that the FirestoreClient in there will be available and will be
     * enqueuing actions on the async queue.
     *
     * Meanwhile any failure of an operation on the async queue causes it to
     * panic and reject any further work, on the premise that unhandled errors
     * are fatal.
     *
     * Consequently the fallback is handled internally here in start, and if the
     * fallback succeeds we signal success to the async queue even though the
     * start() itself signals failure.
     *
     * @param persistenceSettings Settings object to configure offline
     *     persistence.
     * @returns A deferred result indicating the user-visible result of enabling
     *     offline persistence. This method will reject this if IndexedDB fails to
     *     start for any reason. If usePersistence is false this is
     *     unconditionally resolved.
     */FirestoreClient.prototype.start=function(persistenceSettings){var _this=this;this.verifyNotShutdown();// We defer our initialization until we get the current user from
// setChangeListener(). We block the async queue until we got the initial
// user and the initialization is completed. This will prevent any scheduled
// work from happening before initialization is completed.
//
// If initializationDone resolved then the FirestoreClient is in a usable
// state.
var initializationDone=new Deferred();// If usePersistence is true, certain classes of errors while starting are
// recoverable but only by falling back to persistence disabled.
//
// If there's an error in the first case but not in recovery we cannot
// reject the promise blocking the async queue because this will cause the
// async queue to panic.
var persistenceResult=new Deferred();var initialized=false;this.credentials.setChangeListener(function(user){if(!initialized){initialized=true;_this.initializePersistence(persistenceSettings,persistenceResult,user).then(function(maybeLruGc){return _this.initializeRest(user,maybeLruGc);}).then(initializationDone.resolve,initializationDone.reject);}else{_this.asyncQueue.enqueueAndForget(function(){return _this.handleCredentialChange(user);});}});// Block the async queue until initialization is done
this.asyncQueue.enqueueAndForget(function(){return initializationDone.promise;});// Return only the result of enabling persistence. Note that this does not
// need to await the completion of initializationDone because the result of
// this method should not reflect any other kind of failure to start.
return persistenceResult.promise;};/** Enables the network connection and requeues all pending operations. */FirestoreClient.prototype.enableNetwork=function(){var _this=this;this.verifyNotShutdown();return this.asyncQueue.enqueue(function(){return _this.syncEngine.enableNetwork();});};/**
     * Initializes persistent storage, attempting to use IndexedDB if
     * usePersistence is true or memory-only if false.
     *
     * If IndexedDB fails because it's already open in another tab or because the
     * platform can't possibly support our implementation then this method rejects
     * the persistenceResult and falls back on memory-only persistence.
     *
     * @param persistenceSettings Settings object to configure offline persistence
     * @param persistenceResult A deferred result indicating the user-visible
     *     result of enabling offline persistence. This method will reject this if
     *     IndexedDB fails to start for any reason. If usePersistence is false
     *     this is unconditionally resolved.
     * @returns a Promise indicating whether or not initialization should
     *     continue, i.e. that one of the persistence implementations actually
     *     succeeded.
     */FirestoreClient.prototype.initializePersistence=function(persistenceSettings,persistenceResult,user){var _this=this;if(persistenceSettings instanceof IndexedDbPersistenceSettings){return this.startIndexedDbPersistence(user,persistenceSettings).then(function(maybeLruGc){persistenceResult.resolve();return maybeLruGc;}).catch(function(error){// Regardless of whether or not the retry succeeds, from an user
// perspective, offline persistence has failed.
persistenceResult.reject(error);// An unknown failure on the first stage shuts everything down.
if(!_this.canFallback(error)){throw error;}console.warn('Error enabling offline storage. Falling back to'+' storage disabled: '+error);return _this.startMemoryPersistence();});}else{// When usePersistence == false, enabling offline persistence is defined
// to unconditionally succeed. This allows start() to have the same
// signature for both cases, despite the fact that the returned promise
// is only used in the enablePersistence call.
persistenceResult.resolve();return this.startMemoryPersistence();}};/**
     * Decides whether the provided error allows us to gracefully disable
     * persistence (as opposed to crashing the client).
     */FirestoreClient.prototype.canFallback=function(error){if(error instanceof FirestoreError){return error.code===Code.FAILED_PRECONDITION||error.code===Code.UNIMPLEMENTED;}else if(typeof DOMException!=='undefined'&&error instanceof DOMException){// We fall back to memory persistence if we cannot write the primary
// lease. This can happen can during a schema migration, or if we run out
// of quota when we try to write the primary lease.
// For both the `QuotaExceededError` and the  `AbortError`, it is safe to
// fall back to memory persistence since all modifications to IndexedDb
// failed to commit.
return error.code===DOM_EXCEPTION_QUOTA_EXCEEDED||error.code===DOM_EXCEPTION_ABORTED;}return true;};/**
     * Checks that the client has not been shutdown. Ensures that other methods on
     * this class cannot be called after the client is shutdown.
     */FirestoreClient.prototype.verifyNotShutdown=function(){if(this.isShutdown){throw new FirestoreError(Code.FAILED_PRECONDITION,'The client has already been shutdown.');}};/**
     * Starts IndexedDB-based persistence.
     *
     * @returns A promise indicating success or failure.
     */FirestoreClient.prototype.startIndexedDbPersistence=function(user,settings){var _this=this;// TODO(http://b/33384523): For now we just disable garbage collection
// when persistence is enabled.
var storagePrefix=IndexedDbPersistence.buildStoragePrefix(this.databaseInfo);// Opt to use proto3 JSON in case the platform doesn't support Uint8Array.
var serializer=new JsonProtoSerializer(this.databaseInfo.databaseId,{useProto3Json:true});return Promise.resolve().then(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){var persistence,lruParams;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:if(settings.synchronizeTabs&&!WebStorageSharedClientState.isAvailable(this.platform)){throw new FirestoreError(Code.UNIMPLEMENTED,'IndexedDB persistence is only available on platforms that support LocalStorage.');}lruParams=settings.lruParams();if(!settings.synchronizeTabs)return[3/*break*/,2];this.sharedClientState=new WebStorageSharedClientState(this.asyncQueue,this.platform,storagePrefix,this.clientId,user);return[4/*yield*/,IndexedDbPersistence.createMultiClientIndexedDbPersistence(storagePrefix,this.clientId,this.platform,this.asyncQueue,serializer,lruParams,{sequenceNumberSyncer:this.sharedClientState})];case 1:persistence=_a.sent();return[3/*break*/,4];case 2:this.sharedClientState=new MemorySharedClientState();return[4/*yield*/,IndexedDbPersistence.createIndexedDbPersistence(storagePrefix,this.clientId,this.platform,this.asyncQueue,serializer,lruParams)];case 3:persistence=_a.sent();_a.label=4;case 4:this.persistence=persistence;return[2/*return*/,persistence.referenceDelegate.garbageCollector];}});});});};/**
     * Starts Memory-backed persistence. In practice this cannot fail.
     *
     * @returns A promise that will successfully resolve.
     */FirestoreClient.prototype.startMemoryPersistence=function(){this.persistence=MemoryPersistence.createEagerPersistence(this.clientId);this.sharedClientState=new MemorySharedClientState();return Promise.resolve(null);};/**
     * Initializes the rest of the FirestoreClient, assuming the initial user
     * has been obtained from the credential provider and some persistence
     * implementation is available in this.persistence.
     */FirestoreClient.prototype.initializeRest=function(user,maybeLruGc){var _this=this;debug(LOG_TAG$b,'Initializing. user=',user.uid);return this.platform.loadConnection(this.databaseInfo).then(function(connection){return tslib_1.__awaiter(_this,void 0,void 0,function(){var serializer,datastore,remoteStoreOnlineStateChangedHandler,sharedClientStateOnlineStateChangedHandler;var _this=this;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:this.localStore=new LocalStore(this.persistence,user);if(maybeLruGc){// We're running LRU Garbage collection. Set up the scheduler.
this.lruScheduler=new LruScheduler(maybeLruGc,this.asyncQueue,this.localStore);}serializer=this.platform.newSerializer(this.databaseInfo.databaseId);datastore=new Datastore(this.asyncQueue,connection,this.credentials,serializer);remoteStoreOnlineStateChangedHandler=function remoteStoreOnlineStateChangedHandler(onlineState){return _this.syncEngine.applyOnlineStateChange(onlineState,OnlineStateSource.RemoteStore);};sharedClientStateOnlineStateChangedHandler=function sharedClientStateOnlineStateChangedHandler(onlineState){return _this.syncEngine.applyOnlineStateChange(onlineState,OnlineStateSource.SharedClientState);};this.remoteStore=new RemoteStore(this.localStore,datastore,this.asyncQueue,remoteStoreOnlineStateChangedHandler);this.syncEngine=new SyncEngine(this.localStore,this.remoteStore,this.sharedClientState,user);this.sharedClientState.onlineStateHandler=sharedClientStateOnlineStateChangedHandler;// Set up wiring between sync engine and other components
this.remoteStore.syncEngine=this.syncEngine;this.sharedClientState.syncEngine=this.syncEngine;this.eventMgr=new EventManager(this.syncEngine);// PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
return[4/*yield*/,this.sharedClientState.start()];case 1:// PORTING NOTE: LocalStore doesn't need an explicit start() on the Web.
_a.sent();return[4/*yield*/,this.remoteStore.start()];case 2:_a.sent();// NOTE: This will immediately call the listener, so we make sure to
// set it after localStore / remoteStore are started.
return[4/*yield*/,this.persistence.setPrimaryStateListener(function(isPrimary){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:return[4/*yield*/,this.syncEngine.applyPrimaryState(isPrimary)];case 1:_a.sent();if(this.lruScheduler){if(isPrimary&&!this.lruScheduler.started){this.lruScheduler.start();}else if(!isPrimary){this.lruScheduler.stop();}}return[2/*return*/];}});});})];case 3:// NOTE: This will immediately call the listener, so we make sure to
// set it after localStore / remoteStore are started.
_a.sent();// When a user calls clearPersistence() in one client, all other clientfs
// need to shut down to allow the delete to succeed.
return[4/*yield*/,this.persistence.setDatabaseDeletedListener(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:return[4/*yield*/,this.shutdown()];case 1:_a.sent();return[2/*return*/];}});});})];case 4:// When a user calls clearPersistence() in one client, all other clientfs
// need to shut down to allow the delete to succeed.
_a.sent();return[2/*return*/];}});});});};FirestoreClient.prototype.handleCredentialChange=function(user){this.asyncQueue.verifyOperationInProgress();debug(LOG_TAG$b,'Credential Changed. Current user: '+user.uid);return this.syncEngine.handleCredentialChange(user);};/** Disables the network connection. Pending operations will not complete. */FirestoreClient.prototype.disableNetwork=function(){var _this=this;this.verifyNotShutdown();return this.asyncQueue.enqueue(function(){return _this.syncEngine.disableNetwork();});};FirestoreClient.prototype.shutdown=function(){var _this=this;if(this.isShutdown===true){return Promise.resolve();}return this.asyncQueue.enqueue(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:// PORTING NOTE: LocalStore does not need an explicit shutdown on web.
if(this.lruScheduler){this.lruScheduler.stop();}return[4/*yield*/,this.remoteStore.shutdown()];case 1:_a.sent();return[4/*yield*/,this.sharedClientState.shutdown()];case 2:_a.sent();return[4/*yield*/,this.persistence.shutdown()];case 3:_a.sent();// `removeChangeListener` must be called after shutting down the
// RemoteStore as it will prevent the RemoteStore from retrieving
// auth tokens.
this.credentials.removeChangeListener();this.isShutdown=true;return[2/*return*/];}});});});};FirestoreClient.prototype.listen=function(query,observer,options){var _this=this;this.verifyNotShutdown();var listener=new QueryListener(query,observer,options);this.asyncQueue.enqueueAndForget(function(){return _this.eventMgr.listen(listener);});return listener;};FirestoreClient.prototype.unlisten=function(listener){var _this=this;this.verifyNotShutdown();this.asyncQueue.enqueueAndForget(function(){return _this.eventMgr.unlisten(listener);});};FirestoreClient.prototype.getDocumentFromLocalCache=function(docKey){var _this=this;this.verifyNotShutdown();return this.asyncQueue.enqueue(function(){return _this.localStore.readDocument(docKey);}).then(function(maybeDoc){if(maybeDoc instanceof Document){return maybeDoc;}else if(maybeDoc instanceof NoDocument){return null;}else{throw new FirestoreError(Code.UNAVAILABLE,'Failed to get document from cache. (However, this document may '+"exist on the server. Run again without setting 'source' in "+'the GetOptions to attempt to retrieve the document from the '+'server.)');}});};FirestoreClient.prototype.getDocumentsFromLocalCache=function(query){var _this=this;this.verifyNotShutdown();return this.asyncQueue.enqueue(function(){return _this.localStore.executeQuery(query);}).then(function(docs){var remoteKeys=documentKeySet();var view=new View(query,remoteKeys);var viewDocChanges=view.computeDocChanges(docs);return view.applyChanges(viewDocChanges,/* updateLimboDocuments= */false).snapshot;});};FirestoreClient.prototype.write=function(mutations){var _this=this;this.verifyNotShutdown();var deferred=new Deferred();this.asyncQueue.enqueueAndForget(function(){return _this.syncEngine.write(mutations,deferred);});return deferred.promise;};FirestoreClient.prototype.databaseId=function(){return this.databaseInfo.databaseId;};FirestoreClient.prototype.transaction=function(updateFunction){var _this=this;this.verifyNotShutdown();// We have to wait for the async queue to be sure syncEngine is initialized.
return this.asyncQueue.enqueue(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){return[2/*return*/];});});}).then(function(){return _this.syncEngine.runTransaction(updateFunction);});};return FirestoreClient;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */var AsyncObserver=/** @class */function(){function AsyncObserver(observer){this.observer=observer;/**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */this.muted=false;}AsyncObserver.prototype.next=function(value){this.scheduleEvent(this.observer.next,value);};AsyncObserver.prototype.error=function(error){this.scheduleEvent(this.observer.error,error);};AsyncObserver.prototype.mute=function(){this.muted=true;};AsyncObserver.prototype.scheduleEvent=function(eventHandler,event){var _this=this;if(!this.muted){setTimeout(function(){if(!_this.muted){eventHandler(event);}},0);}};return AsyncObserver;}();/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
/**
 * A FieldPath refers to a field in a document. The path may consist of a single
 * field name (referring to a top-level field in the document), or a list of
 * field names (referring to a nested field in the document).
 */var FieldPath$1=/** @class */function(){/**
     * Creates a FieldPath from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames A list of field names.
     */function FieldPath$1(){var fieldNames=[];for(var _i=0;_i<arguments.length;_i++){fieldNames[_i]=arguments[_i];}validateNamedArrayAtLeastNumberOfElements('FieldPath',fieldNames,'fieldNames',1);for(var i=0;i<fieldNames.length;++i){validateArgType('FieldPath','string',i,fieldNames[i]);if(fieldNames[i].length===0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid field name at argument $(i + 1). "+'Field names must not be empty.');}}this._internalPath=new FieldPath(fieldNames);}FieldPath$1.documentId=function(){return FieldPath$1._DOCUMENT_ID;};FieldPath$1.prototype.isEqual=function(other){if(!(other instanceof FieldPath$1)){throw invalidClassError('isEqual','FieldPath',1,other);}return this._internalPath.isEqual(other._internalPath);};/**
     * Internal Note: The backend doesn't technically support querying by
     * document ID. Instead it queries by the entire document name (full path
     * included), but in the cases we currently support documentId(), the net
     * effect is the same.
     */FieldPath$1._DOCUMENT_ID=new FieldPath$1(FieldPath.keyField().canonicalString());return FieldPath$1;}();/**
 * Matches any characters in a field path string that are reserved.
 */var RESERVED=new RegExp('[~\\*/\\[\\]]');/**
 * Parses a field path string into a FieldPath, treating dots as separators.
 */function fromDotSeparatedString(path){var found=path.search(RESERVED);if(found>=0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid field path ("+path+"). Paths must not contain "+"'~', '*', '/', '[', or ']'");}try{return new(FieldPath$1.bind.apply(FieldPath$1,[void 0].concat(path.split('.'))))();}catch(e){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid field path ("+path+"). Paths must not be empty, "+"begin with '.', end with '.', or contain '..'");}}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var OAuthToken=/** @class */function(){function OAuthToken(value,user){this.user=user;this.type='OAuth';this.authHeaders={Authorization:"Bearer "+value};}return OAuthToken;}();/** A CredentialsProvider that always yields an empty token. */var EmptyCredentialsProvider=/** @class */function(){function EmptyCredentialsProvider(){/**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */this.changeListener=null;}EmptyCredentialsProvider.prototype.getToken=function(){return Promise.resolve(null);};EmptyCredentialsProvider.prototype.invalidateToken=function(){};EmptyCredentialsProvider.prototype.setChangeListener=function(changeListener){assert(!this.changeListener,'Can only call setChangeListener() once.');this.changeListener=changeListener;// Fire with initial user.
changeListener(User.UNAUTHENTICATED);};EmptyCredentialsProvider.prototype.removeChangeListener=function(){assert(this.changeListener!==null,'removeChangeListener() when no listener registered');this.changeListener=null;};return EmptyCredentialsProvider;}();var FirebaseCredentialsProvider=/** @class */function(){function FirebaseCredentialsProvider(app){var _this=this;this.app=app;/**
         * The auth token listener registered with FirebaseApp, retained here so we
         * can unregister it.
         */this.tokenListener=null;/**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */this.tokenCounter=0;/** The listener registered with setChangeListener(). */this.changeListener=null;this.forceRefresh=false;this.tokenListener=function(){_this.tokenCounter++;_this.currentUser=_this.getUser();if(_this.changeListener){_this.changeListener(_this.currentUser);}};this.tokenCounter=0;// Will fire at least once where we set this.currentUser
this.app.INTERNAL.addAuthTokenListener(this.tokenListener);}FirebaseCredentialsProvider.prototype.getToken=function(){var _this=this;assert(this.tokenListener!=null,'getToken cannot be called after listener removed.');// Take note of the current value of the tokenCounter so that this method
// can fail (with an ABORTED error) if there is a token change while the
// request is outstanding.
var initialTokenCounter=this.tokenCounter;var forceRefresh=this.forceRefresh;this.forceRefresh=false;return this.app.INTERNAL.getToken(forceRefresh).then(function(tokenData){// Cancel the request since the token changed while the request was
// outstanding so the response is potentially for a previous user (which
// user, we can't be sure).
if(_this.tokenCounter!==initialTokenCounter){throw new FirestoreError(Code.ABORTED,'getToken aborted due to token change.');}else{if(tokenData){assert(typeof tokenData.accessToken==='string','Invalid tokenData returned from getToken():'+tokenData);return new OAuthToken(tokenData.accessToken,_this.currentUser);}else{return null;}}});};FirebaseCredentialsProvider.prototype.invalidateToken=function(){this.forceRefresh=true;};FirebaseCredentialsProvider.prototype.setChangeListener=function(changeListener){assert(!this.changeListener,'Can only call setChangeListener() once.');this.changeListener=changeListener;// Fire the initial event, but only if we received the initial user
if(this.currentUser){changeListener(this.currentUser);}};FirebaseCredentialsProvider.prototype.removeChangeListener=function(){assert(this.tokenListener!=null,'removeChangeListener() called twice');assert(this.changeListener!==null,'removeChangeListener() called when no listener registered');this.app.INTERNAL.removeAuthTokenListener(this.tokenListener);this.tokenListener=null;this.changeListener=null;};FirebaseCredentialsProvider.prototype.getUser=function(){var currentUid=this.app.INTERNAL.getUid();assert(currentUid===null||typeof currentUid==='string','Received invalid UID: '+currentUid);return new User(currentUid);};return FirebaseCredentialsProvider;}();/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */var FirstPartyToken=/** @class */function(){function FirstPartyToken(gapi,sessionIndex){this.gapi=gapi;this.sessionIndex=sessionIndex;this.type='FirstParty';this.user=User.FIRST_PARTY;}Object.defineProperty(FirstPartyToken.prototype,"authHeaders",{get:function get(){var headers={'X-Goog-AuthUser':this.sessionIndex};var authHeader=this.gapi.auth.getAuthHeaderValueForFirstParty([]);if(authHeader){headers['Authorization']=authHeader;}return headers;},enumerable:true,configurable:true});return FirstPartyToken;}();/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */var FirstPartyCredentialsProvider=/** @class */function(){function FirstPartyCredentialsProvider(gapi,sessionIndex){this.gapi=gapi;this.sessionIndex=sessionIndex;}FirstPartyCredentialsProvider.prototype.getToken=function(){return Promise.resolve(new FirstPartyToken(this.gapi,this.sessionIndex));};FirstPartyCredentialsProvider.prototype.setChangeListener=function(changeListener){// Fire with initial uid.
changeListener(User.FIRST_PARTY);};FirstPartyCredentialsProvider.prototype.removeChangeListener=function(){};FirstPartyCredentialsProvider.prototype.invalidateToken=function(){};return FirstPartyCredentialsProvider;}();/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */function makeCredentialsProvider(credentials){if(!credentials){return new EmptyCredentialsProvider();}switch(credentials.type){case'gapi':var client=credentials.client;// Make sure this is a Gapi client.
assert(!!(typeof client==='object'&&client!==null&&client['auth']&&client['auth']['getAuthHeaderValueForFirstParty']),'unexpected gapi interface');return new FirstPartyCredentialsProvider(client,credentials.sessionIndex||'0');case'provider':return credentials.client;default:throw new FirestoreError(Code.INVALID_ARGUMENT,'makeCredentialsProvider failed due to invalid credential type');}}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function isPartialObserver(obj){return implementsAnyMethods(obj,['next','error','complete']);}/**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */function implementsAnyMethods(obj,methods){if(typeof obj!=='object'||obj===null){return false;}var object=obj;for(var _i=0,methods_1=methods;_i<methods_1.length;_i++){var method=methods_1[_i];if(method in object&&typeof object[method]==='function'){return true;}}return false;}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *//**
 * An opaque base class for FieldValue sentinel objects in our public API,
 * with public static methods for creating said sentinel objects.
 */// tslint:disable-next-line:class-as-namespace  We use this as a base class.
var FieldValueImpl=/** @class */function(){function FieldValueImpl(_methodName){this._methodName=_methodName;}FieldValueImpl.delete=function(){validateNoArgs('FieldValue.delete',arguments);return DeleteFieldValueImpl.instance;};FieldValueImpl.serverTimestamp=function(){validateNoArgs('FieldValue.serverTimestamp',arguments);return ServerTimestampFieldValueImpl.instance;};FieldValueImpl.arrayUnion=function(){var elements=[];for(var _i=0;_i<arguments.length;_i++){elements[_i]=arguments[_i];}validateAtLeastNumberOfArgs('FieldValue.arrayUnion',arguments,1);// NOTE: We don't actually parse the data until it's used in set() or
// update() since we need access to the Firestore instance.
return new ArrayUnionFieldValueImpl(elements);};FieldValueImpl.arrayRemove=function(){var elements=[];for(var _i=0;_i<arguments.length;_i++){elements[_i]=arguments[_i];}validateAtLeastNumberOfArgs('FieldValue.arrayRemove',arguments,1);// NOTE: We don't actually parse the data until it's used in set() or
// update() since we need access to the Firestore instance.
return new ArrayRemoveFieldValueImpl(elements);};FieldValueImpl.increment=function(n){validateArgType('FieldValue.increment','number',1,n);validateExactNumberOfArgs('FieldValue.increment',arguments,1);return new NumericIncrementFieldValueImpl(n);};FieldValueImpl.prototype.isEqual=function(other){return this===other;};return FieldValueImpl;}();var DeleteFieldValueImpl=/** @class */function(_super){tslib_1.__extends(DeleteFieldValueImpl,_super);function DeleteFieldValueImpl(){return _super.call(this,'FieldValue.delete')||this;}/** Singleton instance. */DeleteFieldValueImpl.instance=new DeleteFieldValueImpl();return DeleteFieldValueImpl;}(FieldValueImpl);var ServerTimestampFieldValueImpl=/** @class */function(_super){tslib_1.__extends(ServerTimestampFieldValueImpl,_super);function ServerTimestampFieldValueImpl(){return _super.call(this,'FieldValue.serverTimestamp')||this;}/** Singleton instance. */ServerTimestampFieldValueImpl.instance=new ServerTimestampFieldValueImpl();return ServerTimestampFieldValueImpl;}(FieldValueImpl);var ArrayUnionFieldValueImpl=/** @class */function(_super){tslib_1.__extends(ArrayUnionFieldValueImpl,_super);function ArrayUnionFieldValueImpl(_elements){var _this=_super.call(this,'FieldValue.arrayUnion')||this;_this._elements=_elements;return _this;}return ArrayUnionFieldValueImpl;}(FieldValueImpl);var ArrayRemoveFieldValueImpl=/** @class */function(_super){tslib_1.__extends(ArrayRemoveFieldValueImpl,_super);function ArrayRemoveFieldValueImpl(_elements){var _this=_super.call(this,'FieldValue.arrayRemove')||this;_this._elements=_elements;return _this;}return ArrayRemoveFieldValueImpl;}(FieldValueImpl);var NumericIncrementFieldValueImpl=/** @class */function(_super){tslib_1.__extends(NumericIncrementFieldValueImpl,_super);function NumericIncrementFieldValueImpl(_operand){var _this=_super.call(this,'FieldValue.increment')||this;_this._operand=_operand;return _this;}return NumericIncrementFieldValueImpl;}(FieldValueImpl);// Public instance that disallows construction at runtime. This constructor is
// used when exporting FieldValueImpl on firebase.firestore.FieldValue and will
// be called FieldValue publicly. Internally we still use FieldValueImpl which
// has a type-checked private constructor. Note that FieldValueImpl and
// PublicFieldValue can be used interchangeably in instanceof checks.
// For our internal TypeScript code PublicFieldValue doesn't exist as a type,
// and so we need to use FieldValueImpl as type and export it too.
// tslint:disable-next-line:variable-name  We treat this as a class name.
var PublicFieldValue=makeConstructorPrivate(FieldValueImpl,'Use FieldValue.<field>() instead.');/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var RESERVED_FIELD_REGEX=/^__.*__$/;/** The result of parsing document data (e.g. for a setData call). */var ParsedSetData=/** @class */function(){function ParsedSetData(data,fieldMask,fieldTransforms){this.data=data;this.fieldMask=fieldMask;this.fieldTransforms=fieldTransforms;}ParsedSetData.prototype.toMutations=function(key,precondition){var mutations=[];if(this.fieldMask!==null){mutations.push(new PatchMutation(key,this.data,this.fieldMask,precondition));}else{mutations.push(new SetMutation(key,this.data,precondition));}if(this.fieldTransforms.length>0){mutations.push(new TransformMutation(key,this.fieldTransforms));}return mutations;};return ParsedSetData;}();/** The result of parsing "update" data (i.e. for an updateData call). */var ParsedUpdateData=/** @class */function(){function ParsedUpdateData(data,fieldMask,fieldTransforms){this.data=data;this.fieldMask=fieldMask;this.fieldTransforms=fieldTransforms;}ParsedUpdateData.prototype.toMutations=function(key,precondition){var mutations=[new PatchMutation(key,this.data,this.fieldMask,precondition)];if(this.fieldTransforms.length>0){mutations.push(new TransformMutation(key,this.fieldTransforms));}return mutations;};return ParsedUpdateData;}();/*
 * Represents what type of API method provided the data being parsed; useful
 * for determining which error conditions apply during parsing and providing
 * better error messages.
 */var UserDataSource;(function(UserDataSource){UserDataSource[UserDataSource["Set"]=0]="Set";UserDataSource[UserDataSource["Update"]=1]="Update";UserDataSource[UserDataSource["MergeSet"]=2]="MergeSet";/**
     * Indicates the source is a where clause, cursor bound, arrayUnion()
     * element, etc. Of note, isWrite(source) will return false.
     */UserDataSource[UserDataSource["Argument"]=3]="Argument";})(UserDataSource||(UserDataSource={}));function isWrite(dataSource){switch(dataSource){case UserDataSource.Set:// fall through
case UserDataSource.MergeSet:// fall through
case UserDataSource.Update:return true;case UserDataSource.Argument:return false;default:throw fail("Unexpected case for UserDataSource: "+dataSource);}}/** A "context" object passed around while parsing user data. */var ParseContext=/** @class */function(){/**
     * Initializes a ParseContext with the given source and path.
     *
     * @param dataSource Indicates what kind of API method this data came from.
     * @param methodName The name of the method the user called to create this
     *     ParseContext.
     * @param path A path within the object being parsed. This could be an empty
     *     path (in which case the context represents the root of the data being
     *     parsed), or a nonempty path (indicating the context represents a nested
     *     location within the data).
     * @param arrayElement Whether or not this context corresponds to an element
     *     of an array.
     * @param fieldTransforms A mutable list of field transforms encountered while
     *     parsing the data.
     * @param fieldMask A mutable list of field paths encountered while parsing
     *     the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */function ParseContext(dataSource,methodName,path,arrayElement,fieldTransforms,fieldMask){this.dataSource=dataSource;this.methodName=methodName;this.path=path;this.arrayElement=arrayElement;// Minor hack: If fieldTransforms is undefined, we assume this is an
// external call and we need to validate the entire path.
if(fieldTransforms===undefined){this.validatePath();}this.arrayElement=arrayElement!==undefined?arrayElement:false;this.fieldTransforms=fieldTransforms||[];this.fieldMask=fieldMask||[];}ParseContext.prototype.childContextForField=function(field){var childPath=this.path==null?null:this.path.child(field);var context=new ParseContext(this.dataSource,this.methodName,childPath,/*arrayElement=*/false,this.fieldTransforms,this.fieldMask);context.validatePathSegment(field);return context;};ParseContext.prototype.childContextForFieldPath=function(field){var childPath=this.path==null?null:this.path.child(field);var context=new ParseContext(this.dataSource,this.methodName,childPath,/*arrayElement=*/false,this.fieldTransforms,this.fieldMask);context.validatePath();return context;};ParseContext.prototype.childContextForArray=function(index){// TODO(b/34871131): We don't support array paths right now; so make path
// null.
return new ParseContext(this.dataSource,this.methodName,/*path=*/null,/*arrayElement=*/true,this.fieldTransforms,this.fieldMask);};ParseContext.prototype.createError=function(reason){var fieldDescription=this.path===null||this.path.isEmpty()?'':" (found in field "+this.path.toString()+")";return new FirestoreError(Code.INVALID_ARGUMENT,"Function "+this.methodName+"() called with invalid data. "+reason+fieldDescription);};/** Returns 'true' if 'fieldPath' was traversed when creating this context. */ParseContext.prototype.contains=function(fieldPath){return this.fieldMask.find(function(field){return fieldPath.isPrefixOf(field);})!==undefined||this.fieldTransforms.find(function(transform){return fieldPath.isPrefixOf(transform.field);})!==undefined;};ParseContext.prototype.validatePath=function(){// TODO(b/34871131): Remove null check once we have proper paths for fields
// within arrays.
if(this.path===null){return;}for(var i=0;i<this.path.length;i++){this.validatePathSegment(this.path.get(i));}};ParseContext.prototype.validatePathSegment=function(segment){if(isWrite(this.dataSource)&&RESERVED_FIELD_REGEX.test(segment)){throw this.createError('Document fields cannot begin and end with __');}};return ParseContext;}();/**
 * A placeholder object for DocumentReferences in this file, in order to
 * avoid a circular dependency. See the comments for `DataPreConverter` for
 * the full context.
 */var DocumentKeyReference=/** @class */function(){function DocumentKeyReference(databaseId,key){this.databaseId=databaseId;this.key=key;}return DocumentKeyReference;}();/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */var UserDataConverter=/** @class */function(){function UserDataConverter(preConverter){this.preConverter=preConverter;}/** Parse document data from a non-merge set() call. */UserDataConverter.prototype.parseSetData=function(methodName,input){var context=new ParseContext(UserDataSource.Set,methodName,FieldPath.EMPTY_PATH);validatePlainObject('Data must be an object, but it was:',context,input);var updateData=this.parseData(input,context);return new ParsedSetData(updateData,/* fieldMask= */null,context.fieldTransforms);};/** Parse document data from a set() call with '{merge:true}'. */UserDataConverter.prototype.parseMergeData=function(methodName,input,fieldPaths){var context=new ParseContext(UserDataSource.MergeSet,methodName,FieldPath.EMPTY_PATH);validatePlainObject('Data must be an object, but it was:',context,input);var updateData=this.parseData(input,context);var fieldMask;var fieldTransforms;if(!fieldPaths){fieldMask=FieldMask.fromArray(context.fieldMask);fieldTransforms=context.fieldTransforms;}else{var validatedFieldPaths=new SortedSet(FieldPath.comparator);for(var _i=0,fieldPaths_1=fieldPaths;_i<fieldPaths_1.length;_i++){var stringOrFieldPath=fieldPaths_1[_i];var fieldPath=void 0;if(stringOrFieldPath instanceof FieldPath$1){fieldPath=stringOrFieldPath._internalPath;}else if(typeof stringOrFieldPath==='string'){fieldPath=fieldPathFromDotSeparatedString(methodName,stringOrFieldPath);}else{throw fail('Expected stringOrFieldPath to be a string or a FieldPath');}if(!context.contains(fieldPath)){throw new FirestoreError(Code.INVALID_ARGUMENT,"Field '"+fieldPath+"' is specified in your field mask but missing from your input data.");}validatedFieldPaths=validatedFieldPaths.add(fieldPath);}fieldMask=FieldMask.fromSet(validatedFieldPaths);fieldTransforms=context.fieldTransforms.filter(function(transform){return fieldMask.covers(transform.field);});}return new ParsedSetData(updateData,fieldMask,fieldTransforms);};/** Parse update data from an update() call. */UserDataConverter.prototype.parseUpdateData=function(methodName,input){var _this=this;var context=new ParseContext(UserDataSource.Update,methodName,FieldPath.EMPTY_PATH);validatePlainObject('Data must be an object, but it was:',context,input);var fieldMaskPaths=new SortedSet(FieldPath.comparator);var updateData=ObjectValue.EMPTY;forEach(input,function(key,value){var path=fieldPathFromDotSeparatedString(methodName,key);var childContext=context.childContextForFieldPath(path);value=_this.runPreConverter(value,childContext);if(value instanceof DeleteFieldValueImpl){// Add it to the field mask, but don't add anything to updateData.
fieldMaskPaths=fieldMaskPaths.add(path);}else{var parsedValue=_this.parseData(value,childContext);if(parsedValue!=null){fieldMaskPaths=fieldMaskPaths.add(path);updateData=updateData.set(path,parsedValue);}}});var mask=FieldMask.fromSet(fieldMaskPaths);return new ParsedUpdateData(updateData,mask,context.fieldTransforms);};/** Parse update data from a list of field/value arguments. */UserDataConverter.prototype.parseUpdateVarargs=function(methodName,field,value,moreFieldsAndValues){var context=new ParseContext(UserDataSource.Update,methodName,FieldPath.EMPTY_PATH);var keys=[fieldPathFromArgument(methodName,field)];var values=[value];if(moreFieldsAndValues.length%2!==0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+methodName+"() needs to be called with an even number "+'of arguments that alternate between field names and values.');}for(var i=0;i<moreFieldsAndValues.length;i+=2){keys.push(fieldPathFromArgument(methodName,moreFieldsAndValues[i]));values.push(moreFieldsAndValues[i+1]);}var fieldMaskPaths=new SortedSet(FieldPath.comparator);var updateData=ObjectValue.EMPTY;for(var i=0;i<keys.length;++i){var path=keys[i];var childContext=context.childContextForFieldPath(path);var value_1=this.runPreConverter(values[i],childContext);if(value_1 instanceof DeleteFieldValueImpl){// Add it to the field mask, but don't add anything to updateData.
fieldMaskPaths=fieldMaskPaths.add(path);}else{var parsedValue=this.parseData(value_1,childContext);if(parsedValue!=null){fieldMaskPaths=fieldMaskPaths.add(path);updateData=updateData.set(path,parsedValue);}}}var mask=FieldMask.fromSet(fieldMaskPaths);return new ParsedUpdateData(updateData,mask,context.fieldTransforms);};/**
     * Parse a "query value" (e.g. value in a where filter or a value in a cursor
     * bound).
     */UserDataConverter.prototype.parseQueryValue=function(methodName,input){var context=new ParseContext(UserDataSource.Argument,methodName,FieldPath.EMPTY_PATH);var parsed=this.parseData(input,context);assert(parsed!=null,'Parsed data should not be null.');assert(context.fieldTransforms.length===0,'Field transforms should have been disallowed.');return parsed;};/** Sends data through this.preConverter, handling any thrown errors. */UserDataConverter.prototype.runPreConverter=function(input,context){try{return this.preConverter(input);}catch(e){var message=errorMessage(e);throw context.createError(message);}};/**
     * Internal helper for parsing user data.
     *
     * @param input Data to be parsed.
     * @param context A context object representing the current path being parsed,
     * the source of the data being parsed, etc.
     * @return The parsed value, or null if the value was a FieldValue sentinel
     * that should not be included in the resulting parsed data.
     */UserDataConverter.prototype.parseData=function(input,context){input=this.runPreConverter(input,context);if(looksLikeJsonObject(input)){validatePlainObject('Unsupported field value:',context,input);return this.parseObject(input,context);}else if(input instanceof FieldValueImpl){// FieldValues usually parse into transforms (except FieldValue.delete())
// in which case we do not want to include this field in our parsed data
// (as doing so will overwrite the field directly prior to the transform
// trying to transform it). So we don't add this location to
// context.fieldMask and we return null as our parsing result.
this.parseSentinelFieldValue(input,context);return null;}else{// If context.path is null we are inside an array and we don't support
// field mask paths more granular than the top-level array.
if(context.path){context.fieldMask.push(context.path);}if(input instanceof Array){// TODO(b/34871131): Include the path containing the array in the error
// message.
if(context.arrayElement){throw context.createError('Nested arrays are not supported');}return this.parseArray(input,context);}else{return this.parseScalarValue(input,context);}}};UserDataConverter.prototype.parseObject=function(obj,context){var _this=this;var result=new SortedMap(primitiveComparator);if(isEmpty(obj)){// If we encounter an empty object, we explicitly add it to the update
// mask to ensure that the server creates a map entry.
if(context.path&&context.path.length>0){context.fieldMask.push(context.path);}}else{forEach(obj,function(key,val){var parsedValue=_this.parseData(val,context.childContextForField(key));if(parsedValue!=null){result=result.insert(key,parsedValue);}});}return new ObjectValue(result);};UserDataConverter.prototype.parseArray=function(array,context){var result=[];var entryIndex=0;for(var _i=0,array_1=array;_i<array_1.length;_i++){var entry=array_1[_i];var parsedEntry=this.parseData(entry,context.childContextForArray(entryIndex));if(parsedEntry==null){// Just include nulls in the array for fields being replaced with a
// sentinel.
parsedEntry=NullValue.INSTANCE;}result.push(parsedEntry);entryIndex++;}return new ArrayValue(result);};/**
     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
     * context.fieldTransforms.
     */UserDataConverter.prototype.parseSentinelFieldValue=function(value,context){// Sentinels are only supported with writes, and not within arrays.
if(!isWrite(context.dataSource)){throw context.createError(value._methodName+"() can only be used with update() and set()");}if(context.path===null){throw context.createError(value._methodName+"() is not currently supported inside arrays");}if(value instanceof DeleteFieldValueImpl){if(context.dataSource===UserDataSource.MergeSet){// No transform to add for a delete, but we need to add it to our
// fieldMask so it gets deleted.
context.fieldMask.push(context.path);}else if(context.dataSource===UserDataSource.Update){assert(context.path.length>0,'FieldValue.delete() at the top level should have already'+' been handled.');throw context.createError('FieldValue.delete() can only appear at the top level '+'of your update data');}else{// We shouldn't encounter delete sentinels for queries or non-merge set() calls.
throw context.createError('FieldValue.delete() cannot be used with set() unless you pass '+'{merge:true}');}}else if(value instanceof ServerTimestampFieldValueImpl){context.fieldTransforms.push(new FieldTransform(context.path,ServerTimestampTransform.instance));}else if(value instanceof ArrayUnionFieldValueImpl){var parsedElements=this.parseArrayTransformElements(value._methodName,value._elements);var arrayUnion=new ArrayUnionTransformOperation(parsedElements);context.fieldTransforms.push(new FieldTransform(context.path,arrayUnion));}else if(value instanceof ArrayRemoveFieldValueImpl){var parsedElements=this.parseArrayTransformElements(value._methodName,value._elements);var arrayRemove=new ArrayRemoveTransformOperation(parsedElements);context.fieldTransforms.push(new FieldTransform(context.path,arrayRemove));}else if(value instanceof NumericIncrementFieldValueImpl){var operand=this.parseQueryValue('FieldValue.increment',value._operand);var numericIncrement=new NumericIncrementTransformOperation(operand);context.fieldTransforms.push(new FieldTransform(context.path,numericIncrement));}else{fail('Unknown FieldValue type: '+value);}};/**
     * Helper to parse a scalar value (i.e. not an Object, Array, or FieldValue)
     *
     * @return The parsed value
     */UserDataConverter.prototype.parseScalarValue=function(value,context){if(value===null){return NullValue.INSTANCE;}else if(typeof value==='number'){if(isSafeInteger(value)){return new IntegerValue(value);}else{return new DoubleValue(value);}}else if(typeof value==='boolean'){return BooleanValue.of(value);}else if(typeof value==='string'){return new StringValue(value);}else if(value instanceof Date){return new TimestampValue(Timestamp.fromDate(value));}else if(value instanceof Timestamp){// Firestore backend truncates precision down to microseconds. To ensure
// offline mode works the same with regards to truncation, perform the
// truncation immediately without waiting for the backend to do that.
return new TimestampValue(new Timestamp(value.seconds,Math.floor(value.nanoseconds/1000)*1000));}else if(value instanceof GeoPoint){return new GeoPointValue(value);}else if(value instanceof Blob){return new BlobValue(value);}else if(value instanceof DocumentKeyReference){return new RefValue(value.databaseId,value.key);}else{throw context.createError("Unsupported field value: "+valueDescription(value));}};UserDataConverter.prototype.parseArrayTransformElements=function(methodName,elements){var _this=this;return elements.map(function(element,i){// Although array transforms are used with writes, the actual elements
// being unioned or removed are not considered writes since they cannot
// contain any FieldValue sentinels, etc.
var context=new ParseContext(UserDataSource.Argument,methodName,FieldPath.EMPTY_PATH);return _this.parseData(element,context.childContextForArray(i));});};return UserDataConverter;}();/**
 * Checks whether an object looks like a JSON object that should be converted
 * into a struct. Normal class/prototype instances are considered to look like
 * JSON objects since they should be converted to a struct value. Arrays, Dates,
 * GeoPoints, etc. are not considered to look like JSON objects since they map
 * to specific FieldValue types other than ObjectValue.
 */function looksLikeJsonObject(input){return typeof input==='object'&&input!==null&&!(input instanceof Array)&&!(input instanceof Date)&&!(input instanceof Timestamp)&&!(input instanceof GeoPoint)&&!(input instanceof Blob)&&!(input instanceof DocumentKeyReference)&&!(input instanceof FieldValueImpl);}function validatePlainObject(message,context,input){if(!looksLikeJsonObject(input)||!isPlainObject(input)){var description=valueDescription(input);if(description==='an object'){// Massage the error if it was an object.
throw context.createError(message+' a custom object');}else{throw context.createError(message+' '+description);}}}/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */function fieldPathFromArgument(methodName,path){if(path instanceof FieldPath$1){return path._internalPath;}else if(typeof path==='string'){return fieldPathFromDotSeparatedString(methodName,path);}else{var message='Field path arguments must be of type string or FieldPath.';throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+methodName+"() called with invalid data. "+message);}}/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName The publicly visible method name
 * @param path The dot-separated string form of a field path which will be split
 * on dots.
 */function fieldPathFromDotSeparatedString(methodName,path){try{return fromDotSeparatedString(path)._internalPath;}catch(e){var message=errorMessage(e);throw new FirestoreError(Code.INVALID_ARGUMENT,"Function "+methodName+"() called with invalid data. "+message);}}/**
 * Extracts the message from a caught exception, which should be an Error object
 * though JS doesn't guarantee that.
 */function errorMessage(error){return error instanceof Error?error.message:error.toString();}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */// The objects that are a part of this API are exposed to third-parties as
// compiled javascript so we want to flag our private members with a leading
// underscore to discourage their use.
// tslint:disable:strip-private-property-underscore
// settings() defaults:
var DEFAULT_HOST='firestore.googleapis.com';var DEFAULT_SSL=true;var DEFAULT_TIMESTAMPS_IN_SNAPSHOTS=true;var DEFAULT_FORCE_LONG_POLLING=false;/**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * `Firestore` instance.
 */var CACHE_SIZE_UNLIMITED=LruParams.COLLECTION_DISABLED;// enablePersistence() defaults:
var DEFAULT_SYNCHRONIZE_TABS=false;/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied firestore.Settings object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */var FirestoreSettings=/** @class */function(){function FirestoreSettings(settings){if(settings.host===undefined){if(settings.ssl!==undefined){throw new FirestoreError(Code.INVALID_ARGUMENT,"Can't provide ssl option if host option is not set");}this.host=DEFAULT_HOST;this.ssl=DEFAULT_SSL;}else{validateNamedType('settings','non-empty string','host',settings.host);this.host=settings.host;validateNamedOptionalType('settings','boolean','ssl',settings.ssl);this.ssl=defaulted(settings.ssl,DEFAULT_SSL);}validateOptionNames('settings',settings,['host','ssl','credentials','timestampsInSnapshots','cacheSizeBytes','experimentalForceLongPolling']);validateNamedOptionalType('settings','object','credentials',settings.credentials);this.credentials=settings.credentials;validateNamedOptionalType('settings','boolean','timestampsInSnapshots',settings.timestampsInSnapshots);// Nobody should set timestampsInSnapshots anymore, but the error depends on
// whether they set it to true or false...
if(settings.timestampsInSnapshots===true){error("\n  The timestampsInSnapshots setting now defaults to true and you no\n  longer need to explicitly set it. In a future release, the setting\n  will be removed entirely and so it is recommended that you remove it\n  from your firestore.settings() call now.");}else if(settings.timestampsInSnapshots===false){error("\n  The timestampsInSnapshots setting will soon be removed. YOU MUST UPDATE\n  YOUR CODE.\n\n  To hide this warning, stop using the timestampsInSnapshots setting in your\n  firestore.settings({ ... }) call.\n\n  Once you remove the setting, Timestamps stored in Cloud Firestore will be\n  read back as Firebase Timestamp objects instead of as system Date objects.\n  So you will also need to update code expecting a Date to instead expect a\n  Timestamp. For example:\n\n  // Old:\n  const date = snapshot.get('created_at');\n  // New:\n  const timestamp = snapshot.get('created_at'); const date =\n  timestamp.toDate();\n\n  Please audit all existing usages of Date when you enable the new\n  behavior.");}this.timestampsInSnapshots=defaulted(settings.timestampsInSnapshots,DEFAULT_TIMESTAMPS_IN_SNAPSHOTS);validateNamedOptionalType('settings','number','cacheSizeBytes',settings.cacheSizeBytes);if(settings.cacheSizeBytes===undefined){this.cacheSizeBytes=LruParams.DEFAULT_CACHE_SIZE_BYTES;}else{if(settings.cacheSizeBytes!==CACHE_SIZE_UNLIMITED&&settings.cacheSizeBytes<LruParams.MINIMUM_CACHE_SIZE_BYTES){throw new FirestoreError(Code.INVALID_ARGUMENT,"cacheSizeBytes must be at least "+LruParams.MINIMUM_CACHE_SIZE_BYTES);}else{this.cacheSizeBytes=settings.cacheSizeBytes;}}validateNamedOptionalType('settings','boolean','experimentalForceLongPolling',settings.experimentalForceLongPolling);this.forceLongPolling=settings.experimentalForceLongPolling===undefined?DEFAULT_FORCE_LONG_POLLING:settings.experimentalForceLongPolling;}FirestoreSettings.prototype.isEqual=function(other){return this.host===other.host&&this.ssl===other.ssl&&this.timestampsInSnapshots===other.timestampsInSnapshots&&this.credentials===other.credentials&&this.cacheSizeBytes===other.cacheSizeBytes&&this.forceLongPolling===other.forceLongPolling;};return FirestoreSettings;}();var FirestoreConfig=/** @class */function(){function FirestoreConfig(){}return FirestoreConfig;}();/**
 * The root reference to the database.
 */var Firestore=/** @class */function(){function Firestore(databaseIdOrApp){var _this=this;// Public for use in tests.
// TODO(mikelehen): Use modularized initialization instead.
this._queue=new AsyncQueue();this.INTERNAL={delete:function _delete(){return tslib_1.__awaiter(_this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:// The client must be initalized to ensure that all subsequent API usage
// throws an exception.
this.ensureClientConfigured();return[4/*yield*/,this._firestoreClient.shutdown()];case 1:_a.sent();this.clientRunning=false;return[2/*return*/];}});});}};this.clientRunning=false;var config=new FirestoreConfig();if(typeof databaseIdOrApp.options==='object'){// This is very likely a Firebase app object
// TODO(b/34177605): Can we somehow use instanceof?
var app=databaseIdOrApp;config.firebaseApp=app;config.databaseId=Firestore.databaseIdFromApp(app);config.persistenceKey=config.firebaseApp.name;config.credentials=new FirebaseCredentialsProvider(app);}else{var external_1=databaseIdOrApp;if(!external_1.projectId){throw new FirestoreError(Code.INVALID_ARGUMENT,'Must provide projectId');}config.databaseId=new DatabaseId(external_1.projectId,external_1.database);// Use a default persistenceKey that lines up with FirebaseApp.
config.persistenceKey='[DEFAULT]';config.credentials=new EmptyCredentialsProvider();}config.settings=new FirestoreSettings({});this._config=config;this._databaseId=config.databaseId;}Firestore.prototype.settings=function(settingsLiteral){validateExactNumberOfArgs('Firestore.settings',arguments,1);validateArgType('Firestore.settings','object',1,settingsLiteral);if(contains(settingsLiteral,'persistence')){throw new FirestoreError(Code.INVALID_ARGUMENT,'"persistence" is now specified with a separate call to '+'firestore.enablePersistence().');}var newSettings=new FirestoreSettings(settingsLiteral);if(this._firestoreClient&&!this._config.settings.isEqual(newSettings)){throw new FirestoreError(Code.FAILED_PRECONDITION,'Firestore has already been started and its settings can no longer '+'be changed. You can only call settings() before calling any other '+'methods on a Firestore object.');}this._config.settings=newSettings;if(newSettings.credentials!==undefined){this._config.credentials=makeCredentialsProvider(newSettings.credentials);}};Firestore.prototype.enableNetwork=function(){this.ensureClientConfigured();return this._firestoreClient.enableNetwork();};Firestore.prototype.disableNetwork=function(){this.ensureClientConfigured();return this._firestoreClient.disableNetwork();};Firestore.prototype.enablePersistence=function(settings){if(this._firestoreClient){throw new FirestoreError(Code.FAILED_PRECONDITION,'Firestore has already been started and persistence can no longer '+'be enabled. You can only call enablePersistence() before calling '+'any other methods on a Firestore object.');}var synchronizeTabs=false;if(settings){if(settings.experimentalTabSynchronization!==undefined){error("The 'experimentalTabSynchronization' setting has been renamed to "+"'synchronizeTabs'. In a future release, the setting will be removed "+'and it is recommended that you update your '+"firestore.enablePersistence() call to use 'synchronizeTabs'.");}synchronizeTabs=defaulted(settings.synchronizeTabs!==undefined?settings.synchronizeTabs:settings.experimentalTabSynchronization,DEFAULT_SYNCHRONIZE_TABS);}return this.configureClient(new IndexedDbPersistenceSettings(this._config.settings.cacheSizeBytes,synchronizeTabs));};Firestore.prototype._clearPersistence=function(){var _this=this;if(this.clientRunning){throw new FirestoreError(Code.FAILED_PRECONDITION,'Persistence cannot be cleared while the client is running');}var persistenceKey=IndexedDbPersistence.buildStoragePrefix(this.makeDatabaseInfo());var deferred=new Deferred();this._queue.enqueueAndForget(function(){return tslib_1.__awaiter(_this,void 0,void 0,function(){var e_1;return tslib_1.__generator(this,function(_a){switch(_a.label){case 0:_a.trys.push([0,2,,3]);return[4/*yield*/,IndexedDbPersistence.clearPersistence(persistenceKey)];case 1:_a.sent();deferred.resolve();return[3/*break*/,3];case 2:e_1=_a.sent();deferred.reject(e_1);return[3/*break*/,3];case 3:return[2/*return*/];}});});});return deferred.promise;};Firestore.prototype.ensureClientConfigured=function(){if(!this._firestoreClient){// Kick off starting the client but don't actually wait for it.
// tslint:disable-next-line:no-floating-promises
this.configureClient(new MemoryPersistenceSettings());}return this._firestoreClient;};Firestore.prototype.makeDatabaseInfo=function(){return new DatabaseInfo(this._config.databaseId,this._config.persistenceKey,this._config.settings.host,this._config.settings.ssl,this._config.settings.forceLongPolling);};Firestore.prototype.configureClient=function(persistenceSettings){var _this=this;assert(!!this._config.settings.host,'FirestoreSettings.host cannot be falsey');assert(!this._firestoreClient,'configureClient() called multiple times');this.clientRunning=true;var databaseInfo=this.makeDatabaseInfo();var preConverter=function preConverter(value){if(value instanceof DocumentReference){var thisDb=_this._config.databaseId;var otherDb=value.firestore._config.databaseId;if(!otherDb.isEqual(thisDb)){throw new FirestoreError(Code.INVALID_ARGUMENT,'Document reference is for database '+(otherDb.projectId+"/"+otherDb.database+" but should be ")+("for database "+thisDb.projectId+"/"+thisDb.database));}return new DocumentKeyReference(_this._config.databaseId,value._key);}else{return value;}};this._dataConverter=new UserDataConverter(preConverter);this._firestoreClient=new FirestoreClient(PlatformSupport.getPlatform(),databaseInfo,this._config.credentials,this._queue);return this._firestoreClient.start(persistenceSettings);};Firestore.databaseIdFromApp=function(app){var options=app.options;if(!contains(options,'projectId')){throw new FirestoreError(Code.INVALID_ARGUMENT,'"projectId" not provided in firebase.initializeApp.');}var projectId=options['projectId'];if(!projectId||typeof projectId!=='string'){throw new FirestoreError(Code.INVALID_ARGUMENT,'projectId must be a string in FirebaseApp.options');}return new DatabaseId(projectId);};Object.defineProperty(Firestore.prototype,"app",{get:function get(){if(!this._config.firebaseApp){throw new FirestoreError(Code.FAILED_PRECONDITION,"Firestore was not initialized using the Firebase SDK. 'app' is "+'not available');}return this._config.firebaseApp;},enumerable:true,configurable:true});Firestore.prototype.collection=function(pathString){validateExactNumberOfArgs('Firestore.collection',arguments,1);validateArgType('Firestore.collection','non-empty string',1,pathString);this.ensureClientConfigured();return new CollectionReference(ResourcePath.fromString(pathString),this);};Firestore.prototype.doc=function(pathString){validateExactNumberOfArgs('Firestore.doc',arguments,1);validateArgType('Firestore.doc','non-empty string',1,pathString);this.ensureClientConfigured();return DocumentReference.forPath(ResourcePath.fromString(pathString),this);};Firestore.prototype.collectionGroup=function(collectionId){validateExactNumberOfArgs('Firestore.collectionGroup',arguments,1);validateArgType('Firestore.collectionGroup','non-empty string',1,collectionId);if(collectionId.indexOf('/')>=0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid collection ID '"+collectionId+"' passed to function "+"Firestore.collectionGroup(). Collection IDs must not contain '/'.");}this.ensureClientConfigured();return new Query$1(new Query(ResourcePath.EMPTY_PATH,collectionId),this);};Firestore.prototype.runTransaction=function(updateFunction){var _this=this;validateExactNumberOfArgs('Firestore.runTransaction',arguments,1);validateArgType('Firestore.runTransaction','function',1,updateFunction);return this.ensureClientConfigured().transaction(function(transaction){return updateFunction(new Transaction$1(_this,transaction));});};Firestore.prototype.batch=function(){this.ensureClientConfigured();return new WriteBatch(this);};Object.defineProperty(Firestore,"logLevel",{get:function get(){switch(getLogLevel()){case LogLevel.DEBUG:return'debug';case LogLevel.ERROR:return'error';case LogLevel.SILENT:return'silent';default:return fail('Unknown log level: '+getLogLevel());}},enumerable:true,configurable:true});Firestore.setLogLevel=function(level){validateExactNumberOfArgs('Firestore.setLogLevel',arguments,1);validateArgType('Firestore.setLogLevel','non-empty string',1,level);switch(level){case'debug':setLogLevel(LogLevel.DEBUG);break;case'error':setLogLevel(LogLevel.ERROR);break;case'silent':setLogLevel(LogLevel.SILENT);break;default:throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid log level: '+level);}};// Note: this is not a property because the minifier can't work correctly with
// the way TypeScript compiler outputs properties.
Firestore.prototype._areTimestampsInSnapshotsEnabled=function(){return this._config.settings.timestampsInSnapshots;};return Firestore;}();/**
 * A reference to a transaction.
 */var Transaction$1=/** @class */function(){function Transaction(_firestore,_transaction){this._firestore=_firestore;this._transaction=_transaction;}Transaction.prototype.get=function(documentRef){var _this=this;validateExactNumberOfArgs('Transaction.get',arguments,1);var ref=validateReference('Transaction.get',documentRef,this._firestore);return this._transaction.lookup([ref._key]).then(function(docs){if(!docs||docs.length!==1){return fail('Mismatch in docs returned from document lookup.');}var doc=docs[0];if(doc instanceof NoDocument){return new DocumentSnapshot(_this._firestore,ref._key,null,/* fromCache= */false,/* hasPendingWrites= */false);}else if(doc instanceof Document){return new DocumentSnapshot(_this._firestore,ref._key,doc,/* fromCache= */false,/* hasPendingWrites= */false);}else{throw fail("BatchGetDocumentsRequest returned unexpected document type: "+doc.constructor.name);}});};Transaction.prototype.set=function(documentRef,value,options){validateBetweenNumberOfArgs('Transaction.set',arguments,2,3);var ref=validateReference('Transaction.set',documentRef,this._firestore);options=validateSetOptions('Transaction.set',options);var parsed=options.merge||options.mergeFields?this._firestore._dataConverter.parseMergeData('Transaction.set',value,options.mergeFields):this._firestore._dataConverter.parseSetData('Transaction.set',value);this._transaction.set(ref._key,parsed);return this;};Transaction.prototype.update=function(documentRef,fieldOrUpdateData,value){var moreFieldsAndValues=[];for(var _i=3;_i<arguments.length;_i++){moreFieldsAndValues[_i-3]=arguments[_i];}var ref;var parsed;if(typeof fieldOrUpdateData==='string'||fieldOrUpdateData instanceof FieldPath$1){validateAtLeastNumberOfArgs('Transaction.update',arguments,3);ref=validateReference('Transaction.update',documentRef,this._firestore);parsed=this._firestore._dataConverter.parseUpdateVarargs('Transaction.update',fieldOrUpdateData,value,moreFieldsAndValues);}else{validateExactNumberOfArgs('Transaction.update',arguments,2);ref=validateReference('Transaction.update',documentRef,this._firestore);parsed=this._firestore._dataConverter.parseUpdateData('Transaction.update',fieldOrUpdateData);}this._transaction.update(ref._key,parsed);return this;};Transaction.prototype.delete=function(documentRef){validateExactNumberOfArgs('Transaction.delete',arguments,1);var ref=validateReference('Transaction.delete',documentRef,this._firestore);this._transaction.delete(ref._key);return this;};return Transaction;}();var WriteBatch=/** @class */function(){function WriteBatch(_firestore){this._firestore=_firestore;this._mutations=[];this._committed=false;}WriteBatch.prototype.set=function(documentRef,value,options){validateBetweenNumberOfArgs('WriteBatch.set',arguments,2,3);this.verifyNotCommitted();var ref=validateReference('WriteBatch.set',documentRef,this._firestore);options=validateSetOptions('WriteBatch.set',options);var parsed=options.merge||options.mergeFields?this._firestore._dataConverter.parseMergeData('WriteBatch.set',value,options.mergeFields):this._firestore._dataConverter.parseSetData('WriteBatch.set',value);this._mutations=this._mutations.concat(parsed.toMutations(ref._key,Precondition.NONE));return this;};WriteBatch.prototype.update=function(documentRef,fieldOrUpdateData,value){var moreFieldsAndValues=[];for(var _i=3;_i<arguments.length;_i++){moreFieldsAndValues[_i-3]=arguments[_i];}this.verifyNotCommitted();var ref;var parsed;if(typeof fieldOrUpdateData==='string'||fieldOrUpdateData instanceof FieldPath$1){validateAtLeastNumberOfArgs('WriteBatch.update',arguments,3);ref=validateReference('WriteBatch.update',documentRef,this._firestore);parsed=this._firestore._dataConverter.parseUpdateVarargs('WriteBatch.update',fieldOrUpdateData,value,moreFieldsAndValues);}else{validateExactNumberOfArgs('WriteBatch.update',arguments,2);ref=validateReference('WriteBatch.update',documentRef,this._firestore);parsed=this._firestore._dataConverter.parseUpdateData('WriteBatch.update',fieldOrUpdateData);}this._mutations=this._mutations.concat(parsed.toMutations(ref._key,Precondition.exists(true)));return this;};WriteBatch.prototype.delete=function(documentRef){validateExactNumberOfArgs('WriteBatch.delete',arguments,1);this.verifyNotCommitted();var ref=validateReference('WriteBatch.delete',documentRef,this._firestore);this._mutations=this._mutations.concat(new DeleteMutation(ref._key,Precondition.NONE));return this;};WriteBatch.prototype.commit=function(){return tslib_1.__awaiter(this,void 0,void 0,function(){return tslib_1.__generator(this,function(_a){this.verifyNotCommitted();this._committed=true;if(this._mutations.length>0){return[2/*return*/,this._firestore.ensureClientConfigured().write(this._mutations)];}return[2/*return*/];});});};WriteBatch.prototype.verifyNotCommitted=function(){if(this._committed){throw new FirestoreError(Code.FAILED_PRECONDITION,'A write batch can no longer be used after commit() '+'has been called.');}};return WriteBatch;}();/**
 * A reference to a particular document in a collection in the database.
 */var DocumentReference=/** @class */function(){function DocumentReference(_key,firestore){this._key=_key;this.firestore=firestore;this._firestoreClient=this.firestore.ensureClientConfigured();}DocumentReference.forPath=function(path,firestore){if(path.length%2!==0){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid document reference. Document '+'references must have an even number of segments, but '+(path.canonicalString()+" has "+path.length));}return new DocumentReference(new DocumentKey(path),firestore);};Object.defineProperty(DocumentReference.prototype,"id",{get:function get(){return this._key.path.lastSegment();},enumerable:true,configurable:true});Object.defineProperty(DocumentReference.prototype,"parent",{get:function get(){return new CollectionReference(this._key.path.popLast(),this.firestore);},enumerable:true,configurable:true});Object.defineProperty(DocumentReference.prototype,"path",{get:function get(){return this._key.path.canonicalString();},enumerable:true,configurable:true});DocumentReference.prototype.collection=function(pathString){validateExactNumberOfArgs('DocumentReference.collection',arguments,1);validateArgType('DocumentReference.collection','non-empty string',1,pathString);if(!pathString){throw new FirestoreError(Code.INVALID_ARGUMENT,'Must provide a non-empty collection name to collection()');}var path=ResourcePath.fromString(pathString);return new CollectionReference(this._key.path.child(path),this.firestore);};DocumentReference.prototype.isEqual=function(other){if(!(other instanceof DocumentReference)){throw invalidClassError('isEqual','DocumentReference',1,other);}return this.firestore===other.firestore&&this._key.isEqual(other._key);};DocumentReference.prototype.set=function(value,options){validateBetweenNumberOfArgs('DocumentReference.set',arguments,1,2);options=validateSetOptions('DocumentReference.set',options);var parsed=options.merge||options.mergeFields?this.firestore._dataConverter.parseMergeData('DocumentReference.set',value,options.mergeFields):this.firestore._dataConverter.parseSetData('DocumentReference.set',value);return this._firestoreClient.write(parsed.toMutations(this._key,Precondition.NONE));};DocumentReference.prototype.update=function(fieldOrUpdateData,value){var moreFieldsAndValues=[];for(var _i=2;_i<arguments.length;_i++){moreFieldsAndValues[_i-2]=arguments[_i];}var parsed;if(typeof fieldOrUpdateData==='string'||fieldOrUpdateData instanceof FieldPath$1){validateAtLeastNumberOfArgs('DocumentReference.update',arguments,2);parsed=this.firestore._dataConverter.parseUpdateVarargs('DocumentReference.update',fieldOrUpdateData,value,moreFieldsAndValues);}else{validateExactNumberOfArgs('DocumentReference.update',arguments,1);parsed=this.firestore._dataConverter.parseUpdateData('DocumentReference.update',fieldOrUpdateData);}return this._firestoreClient.write(parsed.toMutations(this._key,Precondition.exists(true)));};DocumentReference.prototype.delete=function(){validateExactNumberOfArgs('DocumentReference.delete',arguments,0);return this._firestoreClient.write([new DeleteMutation(this._key,Precondition.NONE)]);};DocumentReference.prototype.onSnapshot=function(){var args=[];for(var _i=0;_i<arguments.length;_i++){args[_i]=arguments[_i];}validateBetweenNumberOfArgs('DocumentReference.onSnapshot',arguments,1,4);var options={includeMetadataChanges:false};var observer;var currArg=0;if(typeof args[currArg]==='object'&&!isPartialObserver(args[currArg])){options=args[currArg];validateOptionNames('DocumentReference.onSnapshot',options,['includeMetadataChanges']);validateNamedOptionalType('DocumentReference.onSnapshot','boolean','includeMetadataChanges',options.includeMetadataChanges);currArg++;}var internalOptions={includeMetadataChanges:options.includeMetadataChanges};if(isPartialObserver(args[currArg])){observer=args[currArg];}else{validateArgType('DocumentReference.onSnapshot','function',currArg,args[currArg]);validateOptionalArgType('DocumentReference.onSnapshot','function',currArg+1,args[currArg+1]);validateOptionalArgType('DocumentReference.onSnapshot','function',currArg+2,args[currArg+2]);observer={next:args[currArg],error:args[currArg+1],complete:args[currArg+2]};}return this.onSnapshotInternal(internalOptions,observer);};DocumentReference.prototype.onSnapshotInternal=function(options,observer){var _this=this;var errHandler=function errHandler(err){console.error('Uncaught Error in onSnapshot:',err);};if(observer.error){errHandler=observer.error.bind(observer);}var asyncObserver=new AsyncObserver({next:function next(snapshot){if(observer.next){assert(snapshot.docs.size<=1,'Too many documents returned on a document query');var doc=snapshot.docs.get(_this._key);observer.next(new DocumentSnapshot(_this.firestore,_this._key,doc,snapshot.fromCache,snapshot.hasPendingWrites));}},error:errHandler});var internalListener=this._firestoreClient.listen(Query.atPath(this._key.path),asyncObserver,options);return function(){asyncObserver.mute();_this._firestoreClient.unlisten(internalListener);};};DocumentReference.prototype.get=function(options){var _this=this;validateBetweenNumberOfArgs('DocumentReference.get',arguments,0,1);validateGetOptions('DocumentReference.get',options);return new Promise(function(resolve,reject){if(options&&options.source==='cache'){_this.firestore.ensureClientConfigured().getDocumentFromLocalCache(_this._key).then(function(doc){resolve(new DocumentSnapshot(_this.firestore,_this._key,doc,/*fromCache=*/true,doc instanceof Document?doc.hasLocalMutations:false));},reject);}else{_this.getViaSnapshotListener(resolve,reject,options);}});};DocumentReference.prototype.getViaSnapshotListener=function(resolve,reject,options){var unlisten=this.onSnapshotInternal({includeMetadataChanges:true,waitForSyncWhenOnline:true},{next:function next(snap){// Remove query first before passing event to user to avoid
// user actions affecting the now stale query.
unlisten();if(!snap.exists&&snap.metadata.fromCache){// TODO(dimond): If we're online and the document doesn't
// exist then we resolve with a doc.exists set to false. If
// we're offline however, we reject the Promise in this
// case. Two options: 1) Cache the negative response from
// the server so we can deliver that even when you're
// offline 2) Actually reject the Promise in the online case
// if the document doesn't exist.
reject(new FirestoreError(Code.UNAVAILABLE,'Failed to get document because the client is '+'offline.'));}else if(snap.exists&&snap.metadata.fromCache&&options&&options.source==='server'){reject(new FirestoreError(Code.UNAVAILABLE,'Failed to get document from server. (However, this '+'document does exist in the local cache. Run again '+'without setting source to "server" to '+'retrieve the cached document.)'));}else{resolve(snap);}},error:reject});};return DocumentReference;}();var SnapshotMetadata=/** @class */function(){function SnapshotMetadata(hasPendingWrites,fromCache){this.hasPendingWrites=hasPendingWrites;this.fromCache=fromCache;}SnapshotMetadata.prototype.isEqual=function(other){return this.hasPendingWrites===other.hasPendingWrites&&this.fromCache===other.fromCache;};return SnapshotMetadata;}();var DocumentSnapshot=/** @class */function(){function DocumentSnapshot(_firestore,_key,_document,_fromCache,_hasPendingWrites){this._firestore=_firestore;this._key=_key;this._document=_document;this._fromCache=_fromCache;this._hasPendingWrites=_hasPendingWrites;}DocumentSnapshot.prototype.data=function(options){validateBetweenNumberOfArgs('DocumentSnapshot.data',arguments,0,1);options=validateSnapshotOptions('DocumentSnapshot.data',options);return!this._document?undefined:this.convertObject(this._document.data,FieldValueOptions.fromSnapshotOptions(options,this._firestore._areTimestampsInSnapshotsEnabled()));};DocumentSnapshot.prototype.get=function(fieldPath,options){validateBetweenNumberOfArgs('DocumentSnapshot.get',arguments,1,2);options=validateSnapshotOptions('DocumentSnapshot.get',options);if(this._document){var value=this._document.data.field(fieldPathFromArgument('DocumentSnapshot.get',fieldPath));if(value!==undefined){return this.convertValue(value,FieldValueOptions.fromSnapshotOptions(options,this._firestore._areTimestampsInSnapshotsEnabled()));}}return undefined;};Object.defineProperty(DocumentSnapshot.prototype,"id",{get:function get(){return this._key.path.lastSegment();},enumerable:true,configurable:true});Object.defineProperty(DocumentSnapshot.prototype,"ref",{get:function get(){return new DocumentReference(this._key,this._firestore);},enumerable:true,configurable:true});Object.defineProperty(DocumentSnapshot.prototype,"exists",{get:function get(){return this._document!==null;},enumerable:true,configurable:true});Object.defineProperty(DocumentSnapshot.prototype,"metadata",{get:function get(){return new SnapshotMetadata(this._hasPendingWrites,this._fromCache);},enumerable:true,configurable:true});DocumentSnapshot.prototype.isEqual=function(other){if(!(other instanceof DocumentSnapshot)){throw invalidClassError('isEqual','DocumentSnapshot',1,other);}return this._firestore===other._firestore&&this._fromCache===other._fromCache&&this._key.isEqual(other._key)&&(this._document===null?other._document===null:this._document.isEqual(other._document));};DocumentSnapshot.prototype.convertObject=function(data,options){var _this=this;var result={};data.forEach(function(key,value){result[key]=_this.convertValue(value,options);});return result;};DocumentSnapshot.prototype.convertValue=function(value,options){if(value instanceof ObjectValue){return this.convertObject(value,options);}else if(value instanceof ArrayValue){return this.convertArray(value,options);}else if(value instanceof RefValue){var key=value.value(options);var database=this._firestore.ensureClientConfigured().databaseId();if(!value.databaseId.isEqual(database)){// TODO(b/64130202): Somehow support foreign references.
error("Document "+this._key.path+" contains a document "+"reference within a different database ("+(value.databaseId.projectId+"/"+value.databaseId.database+") which is not ")+"supported. It will be treated as a reference in the current "+("database ("+database.projectId+"/"+database.database+") ")+"instead.");}return new DocumentReference(key,this._firestore);}else{return value.value(options);}};DocumentSnapshot.prototype.convertArray=function(data,options){var _this=this;return data.internalValue.map(function(value){return _this.convertValue(value,options);});};return DocumentSnapshot;}();var QueryDocumentSnapshot=/** @class */function(_super){tslib_1.__extends(QueryDocumentSnapshot,_super);function QueryDocumentSnapshot(firestore,key,document,fromCache,hasPendingWrites){return _super.call(this,firestore,key,document,fromCache,hasPendingWrites)||this;}QueryDocumentSnapshot.prototype.data=function(options){var data=_super.prototype.data.call(this,options);assert(typeof data==='object','Document in a QueryDocumentSnapshot should exist');return data;};return QueryDocumentSnapshot;}(DocumentSnapshot);var Query$1=/** @class */function(){function Query(_query,firestore){this._query=_query;this.firestore=firestore;}Query.prototype.where=function(field,opStr,value){validateExactNumberOfArgs('Query.where',arguments,3);validateDefined('Query.where',3,value);// Enumerated from the WhereFilterOp type in index.d.ts.
var whereFilterOpEnums=['<','<=','==','>=','>','array-contains'];validateStringEnum('Query.where',whereFilterOpEnums,2,opStr);var fieldValue;var fieldPath=fieldPathFromArgument('Query.where',field);var relationOp=RelationOp.fromString(opStr);if(fieldPath.isKeyField()){if(relationOp===RelationOp.ARRAY_CONTAINS){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid Query. You can't perform array-contains queries on "+'FieldPath.documentId() since document IDs are not arrays.');}if(typeof value==='string'){if(value===''){throw new FirestoreError(Code.INVALID_ARGUMENT,'Function Query.where() requires its third parameter to be a '+'valid document ID if the first parameter is '+'FieldPath.documentId(), but it was an empty string.');}if(!this._query.isCollectionGroupQuery()&&value.indexOf('/')!==-1){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid third parameter to Query.where(). When querying a collection by "+"FieldPath.documentId(), the value provided must be a plain document ID, but "+("'"+value+"' contains a slash."));}var path=this._query.path.child(ResourcePath.fromString(value));if(!DocumentKey.isDocumentKey(path)){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid third parameter to Query.where(). When querying a collection group by "+"FieldPath.documentId(), the value provided must result in a valid document path, "+("but '"+path+"' is not because it has an odd number of segments ("+path.length+")."));}fieldValue=new RefValue(this.firestore._databaseId,new DocumentKey(path));}else if(value instanceof DocumentReference){var ref=value;fieldValue=new RefValue(this.firestore._databaseId,ref._key);}else{throw new FirestoreError(Code.INVALID_ARGUMENT,"Function Query.where() requires its third parameter to be a "+"string or a DocumentReference if the first parameter is "+"FieldPath.documentId(), but it was: "+(valueDescription(value)+"."));}}else{fieldValue=this.firestore._dataConverter.parseQueryValue('Query.where',value);}var filter=Filter.create(fieldPath,relationOp,fieldValue);this.validateNewFilter(filter);return new Query(this._query.addFilter(filter),this.firestore);};Query.prototype.orderBy=function(field,directionStr){validateBetweenNumberOfArgs('Query.orderBy',arguments,1,2);validateOptionalArgType('Query.orderBy','non-empty string',2,directionStr);var direction;if(directionStr===undefined||directionStr==='asc'){direction=Direction.ASCENDING;}else if(directionStr==='desc'){direction=Direction.DESCENDING;}else{throw new FirestoreError(Code.INVALID_ARGUMENT,"Function Query.orderBy() has unknown direction '"+directionStr+"', "+"expected 'asc' or 'desc'.");}if(this._query.startAt!==null){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. You must not call Query.startAt() or '+'Query.startAfter() before calling Query.orderBy().');}if(this._query.endAt!==null){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. You must not call Query.endAt() or '+'Query.endBefore() before calling Query.orderBy().');}var fieldPath=fieldPathFromArgument('Query.orderBy',field);var orderBy=new OrderBy(fieldPath,direction);this.validateNewOrderBy(orderBy);return new Query(this._query.addOrderBy(orderBy),this.firestore);};Query.prototype.limit=function(n){validateExactNumberOfArgs('Query.limit',arguments,1);validateArgType('Query.limit','number',1,n);if(n<=0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid Query. Query limit ("+n+") is invalid. Limit must be "+'positive.');}return new Query(this._query.withLimit(n),this.firestore);};Query.prototype.startAt=function(docOrField){var fields=[];for(var _i=1;_i<arguments.length;_i++){fields[_i-1]=arguments[_i];}validateAtLeastNumberOfArgs('Query.startAt',arguments,1);var bound=this.boundFromDocOrFields('Query.startAt',docOrField,fields,/*before=*/true);return new Query(this._query.withStartAt(bound),this.firestore);};Query.prototype.startAfter=function(docOrField){var fields=[];for(var _i=1;_i<arguments.length;_i++){fields[_i-1]=arguments[_i];}validateAtLeastNumberOfArgs('Query.startAfter',arguments,1);var bound=this.boundFromDocOrFields('Query.startAfter',docOrField,fields,/*before=*/false);return new Query(this._query.withStartAt(bound),this.firestore);};Query.prototype.endBefore=function(docOrField){var fields=[];for(var _i=1;_i<arguments.length;_i++){fields[_i-1]=arguments[_i];}validateAtLeastNumberOfArgs('Query.endBefore',arguments,1);var bound=this.boundFromDocOrFields('Query.endBefore',docOrField,fields,/*before=*/true);return new Query(this._query.withEndAt(bound),this.firestore);};Query.prototype.endAt=function(docOrField){var fields=[];for(var _i=1;_i<arguments.length;_i++){fields[_i-1]=arguments[_i];}validateAtLeastNumberOfArgs('Query.endAt',arguments,1);var bound=this.boundFromDocOrFields('Query.endAt',docOrField,fields,/*before=*/false);return new Query(this._query.withEndAt(bound),this.firestore);};Query.prototype.isEqual=function(other){if(!(other instanceof Query)){throw invalidClassError('isEqual','Query',1,other);}return this.firestore===other.firestore&&this._query.isEqual(other._query);};/** Helper function to create a bound from a document or fields */Query.prototype.boundFromDocOrFields=function(methodName,docOrField,fields,before){validateDefined(methodName,1,docOrField);if(docOrField instanceof DocumentSnapshot){if(fields.length>0){throw new FirestoreError(Code.INVALID_ARGUMENT,"Too many arguments provided to "+methodName+"().");}var snap=docOrField;if(!snap.exists){throw new FirestoreError(Code.NOT_FOUND,"Can't use a DocumentSnapshot that doesn't exist for "+(methodName+"()."));}return this.boundFromDocument(methodName,snap._document,before);}else{var allFields=[docOrField].concat(fields);return this.boundFromFields(methodName,allFields,before);}};/**
     * Create a Bound from a query and a document.
     *
     * Note that the Bound will always include the key of the document
     * and so only the provided document will compare equal to the returned
     * position.
     *
     * Will throw if the document does not contain all fields of the order by
     * of the query or if any of the fields in the order by are an uncommitted
     * server timestamp.
     */Query.prototype.boundFromDocument=function(methodName,doc,before){var components=[];// Because people expect to continue/end a query at the exact document
// provided, we need to use the implicit sort order rather than the explicit
// sort order, because it's guaranteed to contain the document key. That way
// the position becomes unambiguous and the query continues/ends exactly at
// the provided document. Without the key (by using the explicit sort
// orders), multiple documents could match the position, yielding duplicate
// results.
for(var _i=0,_a=this._query.orderBy;_i<_a.length;_i++){var orderBy=_a[_i];if(orderBy.field.isKeyField()){components.push(new RefValue(this.firestore._databaseId,doc.key));}else{var value=doc.field(orderBy.field);if(value instanceof ServerTimestampValue){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. You are trying to start or end a query using a '+'document for which the field "'+orderBy.field+'" is an uncommitted server timestamp. (Since the value of '+'this field is unknown, you cannot start/end a query with it.)');}else if(value!==undefined){components.push(value);}else{var field=orderBy.field.canonicalString();throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid query. You are trying to start or end a query using a "+("document for which the field '"+field+"' (used as the ")+"orderBy) does not exist.");}}}return new Bound(components,before);};/**
     * Converts a list of field values to a Bound for the given query.
     */Query.prototype.boundFromFields=function(methodName,values,before){// Use explicit order by's because it has to match the query the user made
var orderBy=this._query.explicitOrderBy;if(values.length>orderBy.length){throw new FirestoreError(Code.INVALID_ARGUMENT,"Too many arguments provided to "+methodName+"(). "+"The number of arguments must be less than or equal to the "+"number of Query.orderBy() clauses");}var components=[];for(var i=0;i<values.length;i++){var rawValue=values[i];var orderByComponent=orderBy[i];if(orderByComponent.field.isKeyField()){if(typeof rawValue!=='string'){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid query. Expected a string for document ID in "+(methodName+"(), but got a "+typeof rawValue));}if(!this._query.isCollectionGroupQuery()&&rawValue.indexOf('/')!==-1){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid query. When querying a collection and ordering by FieldPath.documentId(), "+("the value passed to "+methodName+"() must be a plain document ID, but ")+("'"+rawValue+"' contains a slash."));}var path=this._query.path.child(ResourcePath.fromString(rawValue));if(!DocumentKey.isDocumentKey(path)){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid query. When querying a collection group and ordering by "+("FieldPath.documentId(), the value passed to "+methodName+"() must result in a ")+("valid document path, but '"+path+"' is not because it contains an odd number ")+"of segments.");}var key=new DocumentKey(path);components.push(new RefValue(this.firestore._databaseId,key));}else{var wrapped=this.firestore._dataConverter.parseQueryValue(methodName,rawValue);components.push(wrapped);}}return new Bound(components,before);};Query.prototype.onSnapshot=function(){var args=[];for(var _i=0;_i<arguments.length;_i++){args[_i]=arguments[_i];}validateBetweenNumberOfArgs('Query.onSnapshot',arguments,1,4);var options={};var observer;var currArg=0;if(typeof args[currArg]==='object'&&!isPartialObserver(args[currArg])){options=args[currArg];validateOptionNames('Query.onSnapshot',options,['includeMetadataChanges']);validateNamedOptionalType('Query.onSnapshot','boolean','includeMetadataChanges',options.includeMetadataChanges);currArg++;}if(isPartialObserver(args[currArg])){observer=args[currArg];}else{validateArgType('Query.onSnapshot','function',currArg,args[currArg]);validateOptionalArgType('Query.onSnapshot','function',currArg+1,args[currArg+1]);validateOptionalArgType('Query.onSnapshot','function',currArg+2,args[currArg+2]);observer={next:args[currArg],error:args[currArg+1],complete:args[currArg+2]};}return this.onSnapshotInternal(options,observer);};Query.prototype.onSnapshotInternal=function(options,observer){var _this=this;var errHandler=function errHandler(err){console.error('Uncaught Error in onSnapshot:',err);};if(observer.error){errHandler=observer.error.bind(observer);}var asyncObserver=new AsyncObserver({next:function next(result){if(observer.next){observer.next(new QuerySnapshot(_this.firestore,_this._query,result));}},error:errHandler});var firestoreClient=this.firestore.ensureClientConfigured();var internalListener=firestoreClient.listen(this._query,asyncObserver,options);return function(){asyncObserver.mute();firestoreClient.unlisten(internalListener);};};Query.prototype.get=function(options){var _this=this;validateBetweenNumberOfArgs('Query.get',arguments,0,1);validateGetOptions('Query.get',options);return new Promise(function(resolve,reject){if(options&&options.source==='cache'){_this.firestore.ensureClientConfigured().getDocumentsFromLocalCache(_this._query).then(function(viewSnap){resolve(new QuerySnapshot(_this.firestore,_this._query,viewSnap));},reject);}else{_this.getViaSnapshotListener(resolve,reject,options);}});};Query.prototype.getViaSnapshotListener=function(resolve,reject,options){var unlisten=this.onSnapshotInternal({includeMetadataChanges:true,waitForSyncWhenOnline:true},{next:function next(result){// Remove query first before passing event to user to avoid
// user actions affecting the now stale query.
unlisten();if(result.metadata.fromCache&&options&&options.source==='server'){reject(new FirestoreError(Code.UNAVAILABLE,'Failed to get documents from server. (However, these '+'documents may exist in the local cache. Run again '+'without setting source to "server" to '+'retrieve the cached documents.)'));}else{resolve(result);}},error:reject});};Query.prototype.validateNewFilter=function(filter){if(filter instanceof RelationFilter){if(filter.isInequality()){var existingField=this._query.getInequalityFilterField();if(existingField!==null&&!existingField.isEqual(filter.field)){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. All where filters with an inequality'+' (<, <=, >, or >=) must be on the same field. But you have'+(" inequality filters on '"+existingField.toString()+"'")+(" and '"+filter.field.toString()+"'"));}var firstOrderByField=this._query.getFirstOrderByField();if(firstOrderByField!==null){this.validateOrderByAndInequalityMatch(filter.field,firstOrderByField);}}else if(filter.op===RelationOp.ARRAY_CONTAINS){if(this._query.hasArrayContainsFilter()){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid query. Queries only support a single array-contains '+'filter.');}}}};Query.prototype.validateNewOrderBy=function(orderBy){if(this._query.getFirstOrderByField()===null){// This is the first order by. It must match any inequality.
var inequalityField=this._query.getInequalityFilterField();if(inequalityField!==null){this.validateOrderByAndInequalityMatch(inequalityField,orderBy.field);}}};Query.prototype.validateOrderByAndInequalityMatch=function(inequality,orderBy){if(!orderBy.isEqual(inequality)){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid query. You have a where filter with an inequality "+("(<, <=, >, or >=) on field '"+inequality.toString()+"' ")+("and so you must also use '"+inequality.toString()+"' ")+"as your first Query.orderBy(), but your first Query.orderBy() "+("is on field '"+orderBy.toString()+"' instead."));}};return Query;}();var QuerySnapshot=/** @class */function(){function QuerySnapshot(_firestore,_originalQuery,_snapshot){this._firestore=_firestore;this._originalQuery=_originalQuery;this._snapshot=_snapshot;this._cachedChanges=null;this._cachedChangesIncludeMetadataChanges=null;this.metadata=new SnapshotMetadata(_snapshot.hasPendingWrites,_snapshot.fromCache);}Object.defineProperty(QuerySnapshot.prototype,"docs",{get:function get(){var result=[];this.forEach(function(doc){return result.push(doc);});return result;},enumerable:true,configurable:true});Object.defineProperty(QuerySnapshot.prototype,"empty",{get:function get(){return this._snapshot.docs.isEmpty();},enumerable:true,configurable:true});Object.defineProperty(QuerySnapshot.prototype,"size",{get:function get(){return this._snapshot.docs.size;},enumerable:true,configurable:true});QuerySnapshot.prototype.forEach=function(callback,thisArg){var _this=this;validateBetweenNumberOfArgs('QuerySnapshot.forEach',arguments,1,2);validateArgType('QuerySnapshot.forEach','function',1,callback);this._snapshot.docs.forEach(function(doc){callback.call(thisArg,_this.convertToDocumentImpl(doc));});};Object.defineProperty(QuerySnapshot.prototype,"query",{get:function get(){return new Query$1(this._originalQuery,this._firestore);},enumerable:true,configurable:true});QuerySnapshot.prototype.docChanges=function(options){if(options){validateOptionNames('QuerySnapshot.docChanges',options,['includeMetadataChanges']);validateNamedOptionalType('QuerySnapshot.docChanges','boolean','includeMetadataChanges',options.includeMetadataChanges);}var includeMetadataChanges=!!(options&&options.includeMetadataChanges);if(includeMetadataChanges&&this._snapshot.excludesMetadataChanges){throw new FirestoreError(Code.INVALID_ARGUMENT,'To include metadata changes with your document changes, you must '+'also pass { includeMetadataChanges:true } to onSnapshot().');}if(!this._cachedChanges||this._cachedChangesIncludeMetadataChanges!==includeMetadataChanges){this._cachedChanges=changesFromSnapshot(this._firestore,includeMetadataChanges,this._snapshot);this._cachedChangesIncludeMetadataChanges=includeMetadataChanges;}return this._cachedChanges;};/** Check the equality. The call can be very expensive. */QuerySnapshot.prototype.isEqual=function(other){if(!(other instanceof QuerySnapshot)){throw invalidClassError('isEqual','QuerySnapshot',1,other);}return this._firestore===other._firestore&&this._originalQuery.isEqual(other._originalQuery)&&this._snapshot.isEqual(other._snapshot);};QuerySnapshot.prototype.convertToDocumentImpl=function(doc){return new QueryDocumentSnapshot(this._firestore,doc.key,doc,this.metadata.fromCache,this._snapshot.mutatedKeys.has(doc.key));};return QuerySnapshot;}();// TODO(2018/11/01): As of 2018/04/17 we're changing docChanges from an array
// into a method. Because this is a runtime breaking change and somewhat subtle
// (both Array and Function have a .length, etc.), we'll replace commonly-used
// properties (including Symbol.iterator) to throw a custom error message. In
// ~6 months we can delete the custom error as most folks will have hopefully
// migrated.
function throwDocChangesMethodError(){throw new FirestoreError(Code.INVALID_ARGUMENT,'QuerySnapshot.docChanges has been changed from a property into a '+'method, so usages like "querySnapshot.docChanges" should become '+'"querySnapshot.docChanges()"');}var docChangesPropertiesToOverride=['length','forEach','map'].concat(typeof Symbol!=='undefined'?[Symbol.iterator]:[]);docChangesPropertiesToOverride.forEach(function(property){/**
     * We are (re-)defining properties on QuerySnapshot.prototype.docChanges which
     * is a Function. This could fail, in particular in the case of 'length' which
     * already exists on Function.prototype and on IE11 is improperly defined with
     * `{ configurable: false }`. So we wrap this in a try/catch to ensure that we
     * still have a functional SDK.
     */try{Object.defineProperty(QuerySnapshot.prototype.docChanges,property,{get:function get(){return throwDocChangesMethodError();}});}catch(err){}// Ignore this failure intentionally
});var CollectionReference=/** @class */function(_super){tslib_1.__extends(CollectionReference,_super);function CollectionReference(path,firestore){var _this=_super.call(this,Query.atPath(path),firestore)||this;if(path.length%2!==1){throw new FirestoreError(Code.INVALID_ARGUMENT,'Invalid collection reference. Collection '+'references must have an odd number of segments, but '+(path.canonicalString()+" has "+path.length));}return _this;}Object.defineProperty(CollectionReference.prototype,"id",{get:function get(){return this._query.path.lastSegment();},enumerable:true,configurable:true});Object.defineProperty(CollectionReference.prototype,"parent",{get:function get(){var parentPath=this._query.path.popLast();if(parentPath.isEmpty()){return null;}else{return new DocumentReference(new DocumentKey(parentPath),this.firestore);}},enumerable:true,configurable:true});Object.defineProperty(CollectionReference.prototype,"path",{get:function get(){return this._query.path.canonicalString();},enumerable:true,configurable:true});CollectionReference.prototype.doc=function(pathString){validateBetweenNumberOfArgs('CollectionReference.doc',arguments,0,1);// We allow omission of 'pathString' but explicitly prohibit passing in both
// 'undefined' and 'null'.
if(arguments.length===0){pathString=AutoId.newId();}validateArgType('CollectionReference.doc','non-empty string',1,pathString);if(pathString===''){throw new FirestoreError(Code.INVALID_ARGUMENT,'Document path must be a non-empty string');}var path=ResourcePath.fromString(pathString);return DocumentReference.forPath(this._query.path.child(path),this.firestore);};CollectionReference.prototype.add=function(value){validateExactNumberOfArgs('CollectionReference.add',arguments,1);validateArgType('CollectionReference.add','object',1,value);var docRef=this.doc();return docRef.set(value).then(function(){return docRef;});};return CollectionReference;}(Query$1);function validateSetOptions(methodName,options){if(options===undefined){return{merge:false};}validateOptionNames(methodName,options,['merge','mergeFields']);validateNamedOptionalType(methodName,'boolean','merge',options.merge);validateOptionalArrayElements(methodName,'mergeFields','a string or a FieldPath',options.mergeFields,function(element){return typeof element==='string'||element instanceof FieldPath$1;});if(options.mergeFields!==undefined&&options.merge!==undefined){throw new FirestoreError(Code.INVALID_ARGUMENT,"Invalid options passed to function "+methodName+"(): You cannot specify both \"merge\" "+"and \"mergeFields\".");}return options;}function validateSnapshotOptions(methodName,options){if(options===undefined){return{};}validateOptionNames(methodName,options,['serverTimestamps']);validateNamedOptionalPropertyEquals(methodName,'options','serverTimestamps',options.serverTimestamps,['estimate','previous','none']);return options;}function validateGetOptions(methodName,options){validateOptionalArgType(methodName,'object',1,options);if(options){validateOptionNames(methodName,options,['source']);validateNamedOptionalPropertyEquals(methodName,'options','source',options.source,['default','server','cache']);}}function validateReference(methodName,documentRef,firestore){if(!(documentRef instanceof DocumentReference)){throw invalidClassError(methodName,'DocumentReference',1,documentRef);}else if(documentRef.firestore!==firestore){throw new FirestoreError(Code.INVALID_ARGUMENT,'Provided document reference is from a different Firestore instance.');}else{return documentRef;}}/**
 * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
 *
 * Exported for testing.
 */function changesFromSnapshot(firestore,includeMetadataChanges,snapshot){if(snapshot.oldDocs.isEmpty()){// Special case the first snapshot because index calculation is easy and
// fast
var lastDoc_1;var index_1=0;return snapshot.docChanges.map(function(change){var doc=new QueryDocumentSnapshot(firestore,change.doc.key,change.doc,snapshot.fromCache,snapshot.mutatedKeys.has(change.doc.key));assert(change.type===ChangeType.Added,'Invalid event type for first snapshot');assert(!lastDoc_1||snapshot.query.docComparator(lastDoc_1,change.doc)<0,'Got added events in wrong order');lastDoc_1=change.doc;return{type:'added',doc:doc,oldIndex:-1,newIndex:index_1++};});}else{// A DocumentSet that is updated incrementally as changes are applied to use
// to lookup the index of a document.
var indexTracker_1=snapshot.oldDocs;return snapshot.docChanges.filter(function(change){return includeMetadataChanges||change.type!==ChangeType.Metadata;}).map(function(change){var doc=new QueryDocumentSnapshot(firestore,change.doc.key,change.doc,snapshot.fromCache,snapshot.mutatedKeys.has(change.doc.key));var oldIndex=-1;var newIndex=-1;if(change.type!==ChangeType.Added){oldIndex=indexTracker_1.indexOf(change.doc.key);assert(oldIndex>=0,'Index for document not found');indexTracker_1=indexTracker_1.delete(change.doc.key);}if(change.type!==ChangeType.Removed){indexTracker_1=indexTracker_1.add(change.doc);newIndex=indexTracker_1.indexOf(change.doc.key);}return{type:resultChangeType(change.type),doc:doc,oldIndex:oldIndex,newIndex:newIndex};});}}function resultChangeType(type){switch(type){case ChangeType.Added:return'added';case ChangeType.Modified:case ChangeType.Metadata:return'modified';case ChangeType.Removed:return'removed';default:return fail('Unknown change type: '+type);}}// Export the classes with a private constructor (it will fail if invoked
// at runtime). Note that this still allows instanceof checks.
// We're treating the variables as class names, so disable checking for lower
// case variable names.
// tslint:disable:variable-name
var PublicFirestore=makeConstructorPrivate(Firestore,'Use firebase.firestore() instead.');var PublicTransaction=makeConstructorPrivate(Transaction$1,'Use firebase.firestore().runTransaction() instead.');var PublicWriteBatch=makeConstructorPrivate(WriteBatch,'Use firebase.firestore().batch() instead.');var PublicDocumentReference=makeConstructorPrivate(DocumentReference,'Use firebase.firestore().doc() instead.');var PublicDocumentSnapshot=makeConstructorPrivate(DocumentSnapshot);var PublicQueryDocumentSnapshot=makeConstructorPrivate(QueryDocumentSnapshot);var PublicQuery=makeConstructorPrivate(Query$1);var PublicQuerySnapshot=makeConstructorPrivate(QuerySnapshot);var PublicCollectionReference=makeConstructorPrivate(CollectionReference,'Use firebase.firestore().collection() instead.');// tslint:enable:variable-name
/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */var firestoreNamespace={Firestore:PublicFirestore,GeoPoint:GeoPoint,Timestamp:Timestamp,Blob:PublicBlob,Transaction:PublicTransaction,WriteBatch:PublicWriteBatch,DocumentReference:PublicDocumentReference,DocumentSnapshot:PublicDocumentSnapshot,Query:PublicQuery,QueryDocumentSnapshot:PublicQueryDocumentSnapshot,QuerySnapshot:PublicQuerySnapshot,CollectionReference:PublicCollectionReference,FieldPath:FieldPath$1,FieldValue:PublicFieldValue,setLogLevel:Firestore.setLogLevel,CACHE_SIZE_UNLIMITED:CACHE_SIZE_UNLIMITED};/**
 * Configures Firestore as part of the Firebase SDK by calling registerService.
 */function configureForFirebase(firebase){firebase.INTERNAL.registerService('firestore',function(app){return new Firestore(app);},shallowCopy(firestoreNamespace));}/**
 * @license
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */function registerFirestore(instance){configureForFirebase(instance);}registerFirestore(firebase);exports.registerFirestore=registerFirestore;//# sourceMappingURL=index.cjs.js.map

/***/ }),

/***/ "fbon":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_linkstate__ = __webpack_require__("CSCC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_firebase__ = __webpack_require__("ZxPa");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'modal-backdrop fade show' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'svg',
	{ 'class': 'icon bg-dark', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M16.2426 6.34311L6.34309 16.2426C5.95257 16.6331 5.95257 17.2663 6.34309 17.6568C6.73362 18.0473 7.36678 18.0473 7.75731 17.6568L17.6568 7.75732C18.0473 7.36679 18.0473 6.73363 17.6568 6.34311C17.2663 5.95258 16.6331 5.95258 16.2426 6.34311Z', fill: '#212529' }),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M17.6568 16.2426L7.75734 6.34309C7.36681 5.95257 6.73365 5.95257 6.34313 6.34309C5.9526 6.73362 5.9526 7.36678 6.34313 7.75731L16.2426 17.6568C16.6331 18.0473 17.2663 18.0473 17.6568 17.6568C18.0474 17.2663 18.0474 16.6331 17.6568 16.2426Z', fill: '#212529' })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h5',
	null,
	'Luo tili'
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('hr', { 'class': 'mt-0' });

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('hr', { 'class': 'mb-2' });

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'label',
	{ 'class': 'custom-control-label', 'for': 'marketingPermission' },
	'Haluan saada s\xE4hk\xF6postiini tiedon uusista mielenkiintoisista tapahtumista'
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'button',
	{ 'class': 'btn btn-primary-3 btn-block btn-loading btn-loading-animate', disabled: true },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'svg',
		{ xmlns: 'http://www.w3.org/2000/svg', width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', 'class': 'injected-svg icon', 'data-src': 'assets/img/icons/theme/code/loading.svg' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'title',
			null,
			'Icon For Loading'
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'g',
			{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('polygon', { points: '0 0 24 0 24 24 0 24', opacity: '0' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z', fill: '#000000', 'fill-rule': 'nonzero', transform: 'translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, 12.000000)' })
		)
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'Luodaan tili\xE4'
	)
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'mt-2' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'p',
		{ 'class': 'text-muted form-text' },
		'Luomalla tilin olet lukenut Lippumaatin ',
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'a',
			{ href: '/tietosuojalauseke', target: '_blank' },
			'tietosuojalausekkeen'
		),
		' ja hyv\xE4ksyt ',
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'a',
			{ href: '/kayttoehdot', target: '_blank' },
			'k\xE4ytt\xF6ehdot'
		)
	)
);

var Register = function (_Component) {
	_inherits(Register, _Component);

	function Register() {
		var _temp, _this, _ret;

		_classCallCheck(this, Register);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.generatePassword = function () {
			return Array(6).fill("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz?!=()").map(function (x) {
				return x[Math.floor(Math.random() * x.length)];
			}).join('');
		}, _this.generateSecurePasswords = function () {
			_this.generatedPassword = _this.generatePassword() + '-' + _this.generatePassword() + '-' + _this.generatePassword() + '-' + _this.generatePassword();
			_this.setState({
				password: _this.generatedPassword,
				repassword: _this.generatedPassword
			});
		}, _this.validate = function () {
			var _this$state = _this.state,
			    name = _this$state.name,
			    email = _this$state.email,
			    reemail = _this$state.reemail,
			    password = _this$state.password,
			    repassword = _this$state.repassword;


			if (!name || name.trim().length < 3 || name.trim().indexOf(' ') === -1) {
				_this.setState({ error: 'name' });
				return false;
			}

			if (!email || !email.split('@')[1] || email.split('@')[1].indexOf('.') === -1 || !email.split('@')[1].split('.')[1]) {
				_this.setState({ error: 'email' });
				return false;
			}
			if (!reemail || reemail !== email) {
				_this.setState({ error: 'reemail' });
				return false;
			}
			if (!password || password.length < 6) {
				_this.setState({ error: 'password' });
				return false;
			}
			if (!repassword || repassword !== password) {
				_this.setState({ error: 'repassword' });
				return false;
			}
			return true;
		}, _this.submit = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			_this.setState({ loading: true });

			var _this$state2 = _this.state,
			    name = _this$state2.name,
			    email = _this$state2.email,
			    password = _this$state2.password,
			    repassword = _this$state2.repassword,
			    terms = _this$state2.terms;


			if (_this.validate()) {
				_this.setState({ loading: true });
				__WEBPACK_IMPORTED_MODULE_2_utils_firebase__["a" /* default */].auth().createUserWithEmailAndPassword(email, password).catch(function (error) {
					// Handle Errors here.
					_this.setState({ loading: false, error: error });
					console.error(error);
				});
			} else {
				_this.setState({ loading: false });
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Register.prototype.componentDidMount = function componentDidMount() {
		this.generateSecurePasswords();
	};

	Register.prototype.componentWillUnmount = function componentWillUnmount() {
		var user = __WEBPACK_IMPORTED_MODULE_2_utils_firebase__["a" /* default */].auth().currentUser;
		var name = this.state.name;


		console.log({ user: user, name: name });
		if (user && name) {
			this.context.updateProfile({
				displayName: this.state.name.trim()
			});
		}
	};

	Register.prototype.render = function render(props, state) {
		var _h, _h2, _h3, _h4, _h5;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			_ref,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'modal fade show', id: 'contact-box-modal', tabindex: '-1', role: 'dialog', 'aria-modal': 'true', style: 'display: block;' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'modal-dialog modal-dialog-centered', role: 'document' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'modal-content' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': 'modal-body' },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'button',
								{ type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: props.onClose },
								_ref2
							),
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'm-3' },
								_ref3,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'row text-left' },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'col-auto' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ 'class': 'text-small text-600' },
											'Onko sinulla jo tunnus? ',
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'a',
												{ href: '#', onClick: function onClick(e) {
														e.preventDefault();e.stopImmediatePropagation();props.onLogin();
													} },
												'Kirjaudu sis\xE4\xE4n'
											)
										)
									)
								),
								state.error && typeof state.error !== 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'alert alert-primary', role: 'alert' },
									'Tili\xE4 ei voida luoda, tarkistathan tietosi. Jos ongelma jatkuu, ota yhteytt\xE4 asiakaspalveluun.',
									_ref4,
									_ref5,
									'Virheviesti: "',
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'em',
										null,
										state.error.message
									),
									'"'
								) : null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'form',
									{ 'class': 'needs-validation', novalidate: '', onSubmit: this.submit },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'row' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col-md-12 mb-3' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h = { type: 'text', 'class': 'form-control', id: 'name', placeholder: '', autocomplete: 'name', onInput: Object(__WEBPACK_IMPORTED_MODULE_1_linkstate__["a" /* default */])(this, 'name'), value: state.name, required: '' }, _h['placeholder'] = 'Koko nimi', _h)),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': 'invalid-feedback', style: state.error === 'name' ? 'display:block;' : null },
												'Tarkista, ett\xE4 sy\xF6tit etunimen ja sukunimen.'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col-6 mb-3' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h2 = { type: 'email', 'class': 'form-control', autocomplete: 'email', id: 'email', placeholder: '', onInput: Object(__WEBPACK_IMPORTED_MODULE_1_linkstate__["a" /* default */])(this, 'email'), value: state.email, required: '' }, _h2['placeholder'] = 'S\xE4hk\xF6postiosoite', _h2)),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': 'invalid-feedback', style: state.error === 'email' ? 'display:block;' : null },
												'S\xE4hk\xF6postiosoite on pakollinen kentt\xE4.'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col-6 mb-3' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h3 = { type: 'email', 'class': 'form-control', id: 'reemail', placeholder: '', onInput: Object(__WEBPACK_IMPORTED_MODULE_1_linkstate__["a" /* default */])(this, 'reemail'), value: state.reemail, required: '' }, _h3['placeholder'] = 'Vahvista s\xE4hk\xF6postiosoite', _h3)),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': 'invalid-feedback', style: state.error === 'reemail' ? 'display:block;' : null },
												'S\xE4hk\xF6postiosoitteet eiv\xE4t t\xE4sm\xE4\xE4.'
											)
										)
									),
									_ref6,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'row mb-2' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col-md-6 mb-3' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h4 = { type: state.password === this.generatedPassword ? "text" : "password", autocomplete: 'new-password', 'class': 'form-control', id: 'password', placeholder: '', onInput: Object(__WEBPACK_IMPORTED_MODULE_1_linkstate__["a" /* default */])(this, 'password'), value: state.password, required: '' }, _h4['placeholder'] = 'Salasana', _h4)),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': 'invalid-feedback', style: state.error === 'password' ? 'display:block;' : null },
												'Salasana on pakollinen kentt\xE4. Salasanan tulee olla v\xE4hint\xE4\xE4n 6 merkki\xE4.'
											)
										),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col-md-6 mb-3' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h5 = { type: state.password === this.generatedPassword ? "text" : "password", autocomplete: 'new-password', 'class': 'form-control', id: 'repassword', placeholder: '', onInput: Object(__WEBPACK_IMPORTED_MODULE_1_linkstate__["a" /* default */])(this, 'repassword'), value: state.repassword, required: '' }, _h5['placeholder'] = 'Vahvista salasana', _h5)),
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'div',
												{ 'class': 'invalid-feedback', style: state.error === 'repassword' ? 'display:block;' : null },
												'Salasanat eiv\xE4t t\xE4sm\xE4\xE4.'
											)
										)
									),
									false ? h(
										'div',
										null,
										_ref7,
										h(
											'div',
											{ 'class': 'row mb-3' },
											h(
												'div',
												{ 'class': 'col-12 mb-2' },
												h(
													'div',
													{ 'class': 'custom-control custom-switch' },
													h('input', { type: 'checkbox', 'class': 'custom-control-input', id: 'marketingPermission', onClick: linkState(this, 'marketingPermission'), checked: state.marketingPermission }),
													_ref8
												)
											)
										)
									) : null,
									state.loading ? _ref9 : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'button',
										{ 'class': 'btn btn-primary-3 btn-block', type: 'submit', onClick: this.submit },
										'Luo tili'
									),
									_ref10
								)
							)
						)
					)
				)
			)
		);
	};

	return Register;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Register);

/***/ }),

/***/ "h6ac":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "juYr":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.4.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2019-05-01T21:04Z
 */
(function (global, factory) {

	"use strict";

	if (typeof module === "object" && typeof module.exports === "object") {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ? factory(global, true) : function (w) {
			if (!w.document) {
				throw new Error("jQuery requires a window with a document");
			}
			return factory(w);
		};
	} else {
		factory(global);
	}

	// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {

	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";

	var arr = [];

	var document = window.document;

	var getProto = Object.getPrototypeOf;

	var _slice = arr.slice;

	var concat = arr.concat;

	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call(Object);

	var support = {};

	var isFunction = function isFunction(obj) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		return typeof obj === "function" && typeof obj.nodeType !== "number";
	};

	var isWindow = function isWindow(obj) {
		return obj != null && obj === obj.window;
	};

	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval(code, node, doc) {
		doc = doc || document;

		var i,
		    val,
		    script = doc.createElement("script");

		script.text = code;
		if (node) {
			for (i in preservedScriptAttributes) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[i] || node.getAttribute && node.getAttribute(i);
				if (val) {
					script.setAttribute(i, val);
				}
			}
		}
		doc.head.appendChild(script).parentNode.removeChild(script);
	}

	function toType(obj) {
		if (obj == null) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module


	var version = "3.4.1",


	// Define a local copy of jQuery
	jQuery = function jQuery(selector, context) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init(selector, context);
	},


	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function toArray() {
			return _slice.call(this);
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function get(num) {

			// Return all the elements in a clean array
			if (num == null) {
				return _slice.call(this);
			}

			// Return just the one element from the set
			return num < 0 ? this[num + this.length] : this[num];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function pushStack(elems) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge(this.constructor(), elems);

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function each(callback) {
			return jQuery.each(this, callback);
		},

		map: function map(callback) {
			return this.pushStack(jQuery.map(this, function (elem, i) {
				return callback.call(elem, i, elem);
			}));
		},

		slice: function slice() {
			return this.pushStack(_slice.apply(this, arguments));
		},

		first: function first() {
			return this.eq(0);
		},

		last: function last() {
			return this.eq(-1);
		},

		eq: function eq(i) {
			var len = this.length,
			    j = +i + (i < 0 ? len : 0);
			return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
		},

		end: function end() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function () {
		var options,
		    name,
		    src,
		    copy,
		    copyIsArray,
		    clone,
		    target = arguments[0] || {},
		    i = 1,
		    length = arguments.length,
		    deep = false;

		// Handle a deep copy situation
		if (typeof target === "boolean") {
			deep = target;

			// Skip the boolean and the target
			target = arguments[i] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if (typeof target !== "object" && !isFunction(target)) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if (i === length) {
			target = this;
			i--;
		}

		for (; i < length; i++) {

			// Only deal with non-null/undefined values
			if ((options = arguments[i]) != null) {

				// Extend the base object
				for (name in options) {
					copy = options[name];

					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if (name === "__proto__" || target === copy) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
						src = target[name];

						// Ensure proper type for the source value
						if (copyIsArray && !Array.isArray(src)) {
							clone = [];
						} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;

						// Never move original objects, clone them
						target[name] = jQuery.extend(deep, clone, copy);

						// Don't bring in undefined values
					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend({

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function error(msg) {
			throw new Error(msg);
		},

		noop: function noop() {},

		isPlainObject: function isPlainObject(obj) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if (!obj || toString.call(obj) !== "[object Object]") {
				return false;
			}

			proto = getProto(obj);

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if (!proto) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
			return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
		},

		isEmptyObject: function isEmptyObject(obj) {
			var name;

			for (name in obj) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a global context
		globalEval: function globalEval(code, options) {
			DOMEval(code, { nonce: options && options.nonce });
		},

		each: function each(obj, callback) {
			var length,
			    i = 0;

			if (isArrayLike(obj)) {
				length = obj.length;
				for (; i < length; i++) {
					if (callback.call(obj[i], i, obj[i]) === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (callback.call(obj[i], i, obj[i]) === false) {
						break;
					}
				}
			}

			return obj;
		},

		// Support: Android <=4.0 only
		trim: function trim(text) {
			return text == null ? "" : (text + "").replace(rtrim, "");
		},

		// results is for internal usage only
		makeArray: function makeArray(arr, results) {
			var ret = results || [];

			if (arr != null) {
				if (isArrayLike(Object(arr))) {
					jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
				} else {
					push.call(ret, arr);
				}
			}

			return ret;
		},

		inArray: function inArray(elem, arr, i) {
			return arr == null ? -1 : indexOf.call(arr, elem, i);
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function merge(first, second) {
			var len = +second.length,
			    j = 0,
			    i = first.length;

			for (; j < len; j++) {
				first[i++] = second[j];
			}

			first.length = i;

			return first;
		},

		grep: function grep(elems, callback, invert) {
			var callbackInverse,
			    matches = [],
			    i = 0,
			    length = elems.length,
			    callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for (; i < length; i++) {
				callbackInverse = !callback(elems[i], i);
				if (callbackInverse !== callbackExpect) {
					matches.push(elems[i]);
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function map(elems, callback, arg) {
			var length,
			    value,
			    i = 0,
			    ret = [];

			// Go through the array, translating each of the items to their new values
			if (isArrayLike(elems)) {
				length = elems.length;
				for (; i < length; i++) {
					value = callback(elems[i], i, arg);

					if (value != null) {
						ret.push(value);
					}
				}

				// Go through every key on the object,
			} else {
				for (i in elems) {
					value = callback(elems[i], i, arg);

					if (value != null) {
						ret.push(value);
					}
				}
			}

			// Flatten any nested arrays
			return concat.apply([], ret);
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});

	if (typeof Symbol === "function") {
		jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
	}

	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (i, name) {
		class2type["[object " + name + "]"] = name.toLowerCase();
	});

	function isArrayLike(obj) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
		    type = toType(obj);

		if (isFunction(obj) || isWindow(obj)) {
			return false;
		}

		return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
	}
	var Sizzle =
	/*!
  * Sizzle CSS Selector Engine v2.3.4
  * https://sizzlejs.com/
  *
  * Copyright JS Foundation and other contributors
  * Released under the MIT license
  * https://js.foundation/
  *
  * Date: 2019-04-08
  */
	function (window) {

		var i,
		    support,
		    Expr,
		    getText,
		    isXML,
		    tokenize,
		    compile,
		    select,
		    outermostContext,
		    sortInput,
		    hasDuplicate,


		// Local document vars
		setDocument,
		    document,
		    docElem,
		    documentIsHTML,
		    rbuggyQSA,
		    rbuggyMatches,
		    matches,
		    contains,


		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		    preferredDoc = window.document,
		    dirruns = 0,
		    done = 0,
		    classCache = createCache(),
		    tokenCache = createCache(),
		    compilerCache = createCache(),
		    nonnativeSelectorCache = createCache(),
		    sortOrder = function sortOrder(a, b) {
			if (a === b) {
				hasDuplicate = true;
			}
			return 0;
		},


		// Instance methods
		hasOwn = {}.hasOwnProperty,
		    arr = [],
		    pop = arr.pop,
		    push_native = arr.push,
		    push = arr.push,
		    slice = arr.slice,

		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function indexOf(list, elem) {
			var i = 0,
			    len = list.length;
			for (; i < len; i++) {
				if (list[i] === elem) {
					return i;
				}
			}
			return -1;
		},
		    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",


		// Regular expressions

		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",


		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",


		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
		    pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" + ")\\)|)",


		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp(whitespace + "+", "g"),
		    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
		    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
		    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
		    rdescend = new RegExp(whitespace + "|>"),
		    rpseudo = new RegExp(pseudos),
		    ridentifier = new RegExp("^" + identifier + "$"),
		    matchExpr = {
			"ID": new RegExp("^#(" + identifier + ")"),
			"CLASS": new RegExp("^\\.(" + identifier + ")"),
			"TAG": new RegExp("^(" + identifier + "|[*])"),
			"ATTR": new RegExp("^" + attributes),
			"PSEUDO": new RegExp("^" + pseudos),
			"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
			"bool": new RegExp("^(?:" + booleans + ")$", "i"),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
		},
		    rhtml = /HTML$/i,
		    rinputs = /^(?:input|select|textarea|button)$/i,
		    rheader = /^h\d$/i,
		    rnative = /^[^{]+\{\s*\[native \w/,


		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
		    rsibling = /[+~]/,


		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
		    funescape = function funescape(_, escaped, escapedWhitespace) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ? escaped : high < 0 ?
			// BMP codepoint
			String.fromCharCode(high + 0x10000) :
			// Supplemental Plane codepoint (surrogate pair)
			String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
		},


		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		    fcssescape = function fcssescape(ch, asCodePoint) {
			if (asCodePoint) {

				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if (ch === "\0") {
					return "\uFFFD";
				}

				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
			}

			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},


		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function unloadHandler() {
			setDocument();
		},
		    inDisabledFieldset = addCombinator(function (elem) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		}, { dir: "parentNode", next: "legend" });

		// Optimize for push.apply( _, NodeList )
		try {
			push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
			// Support: Android<4.0
			// Detect silently failing push.apply
			arr[preferredDoc.childNodes.length].nodeType;
		} catch (e) {
			push = { apply: arr.length ?

				// Leverage slice if possible
				function (target, els) {
					push_native.apply(target, slice.call(els));
				} :

				// Support: IE<9
				// Otherwise append directly
				function (target, els) {
					var j = target.length,
					    i = 0;
					// Can't trust NodeList.length
					while (target[j++] = els[i++]) {}
					target.length = j - 1;
				}
			};
		}

		function Sizzle(selector, context, results, seed) {
			var m,
			    i,
			    elem,
			    nid,
			    match,
			    groups,
			    newSelector,
			    newContext = context && context.ownerDocument,


			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;

			results = results || [];

			// Return early from calls with invalid selector or context
			if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

				return results;
			}

			// Try to shortcut find operations (as opposed to filters) in HTML documents
			if (!seed) {

				if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
					setDocument(context);
				}
				context = context || document;

				if (documentIsHTML) {

					// If the selector is sufficiently simple, try using a "get*By*" DOM method
					// (excepting DocumentFragment context, where the methods don't exist)
					if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

						// ID selector
						if (m = match[1]) {

							// Document context
							if (nodeType === 9) {
								if (elem = context.getElementById(m)) {

									// Support: IE, Opera, Webkit
									// TODO: identify versions
									// getElementById can match elements by name instead of ID
									if (elem.id === m) {
										results.push(elem);
										return results;
									}
								} else {
									return results;
								}

								// Element context
							} else {

								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {

									results.push(elem);
									return results;
								}
							}

							// Type selector
						} else if (match[2]) {
							push.apply(results, context.getElementsByTagName(selector));
							return results;

							// Class selector
						} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {

							push.apply(results, context.getElementsByClassName(m));
							return results;
						}
					}

					// Take advantage of querySelectorAll
					if (support.qsa && !nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector)) && (

					// Support: IE 8 only
					// Exclude object elements
					nodeType !== 1 || context.nodeName.toLowerCase() !== "object")) {

						newSelector = selector;
						newContext = context;

						// qSA considers elements outside a scoping root when evaluating child or
						// descendant combinators, which is not what we want.
						// In such cases, we work around the behavior by prefixing every selector in the
						// list with an ID selector referencing the scope context.
						// Thanks to Andrew Dupont for this technique.
						if (nodeType === 1 && rdescend.test(selector)) {

							// Capture the context ID, setting it first if necessary
							if (nid = context.getAttribute("id")) {
								nid = nid.replace(rcssescape, fcssescape);
							} else {
								context.setAttribute("id", nid = expando);
							}

							// Prefix every selector in the list
							groups = tokenize(selector);
							i = groups.length;
							while (i--) {
								groups[i] = "#" + nid + " " + toSelector(groups[i]);
							}
							newSelector = groups.join(",");

							// Expand context for sibling selectors
							newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
						}

						try {
							push.apply(results, newContext.querySelectorAll(newSelector));
							return results;
						} catch (qsaError) {
							nonnativeSelectorCache(selector, true);
						} finally {
							if (nid === expando) {
								context.removeAttribute("id");
							}
						}
					}
				}
			}

			// All others
			return select(selector.replace(rtrim, "$1"), context, results, seed);
		}

		/**
   * Create key-value caches of limited size
   * @returns {function(string, object)} Returns the Object data after storing it on itself with
   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
   *	deleting the oldest entry
   */
		function createCache() {
			var keys = [];

			function cache(key, value) {
				// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
				if (keys.push(key + " ") > Expr.cacheLength) {
					// Only keep the most recent entries
					delete cache[keys.shift()];
				}
				return cache[key + " "] = value;
			}
			return cache;
		}

		/**
   * Mark a function for special use by Sizzle
   * @param {Function} fn The function to mark
   */
		function markFunction(fn) {
			fn[expando] = true;
			return fn;
		}

		/**
   * Support testing using an element
   * @param {Function} fn Passed the created element and returns a boolean result
   */
		function assert(fn) {
			var el = document.createElement("fieldset");

			try {
				return !!fn(el);
			} catch (e) {
				return false;
			} finally {
				// Remove from its parent by default
				if (el.parentNode) {
					el.parentNode.removeChild(el);
				}
				// release memory in IE
				el = null;
			}
		}

		/**
   * Adds the same handler for all of the specified attrs
   * @param {String} attrs Pipe-separated list of attributes
   * @param {Function} handler The method that will be applied
   */
		function addHandle(attrs, handler) {
			var arr = attrs.split("|"),
			    i = arr.length;

			while (i--) {
				Expr.attrHandle[arr[i]] = handler;
			}
		}

		/**
   * Checks document order of two siblings
   * @param {Element} a
   * @param {Element} b
   * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
   */
		function siblingCheck(a, b) {
			var cur = b && a,
			    diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;

			// Use IE sourceIndex if available on both nodes
			if (diff) {
				return diff;
			}

			// Check if b follows a
			if (cur) {
				while (cur = cur.nextSibling) {
					if (cur === b) {
						return -1;
					}
				}
			}

			return a ? 1 : -1;
		}

		/**
   * Returns a function to use in pseudos for input types
   * @param {String} type
   */
		function createInputPseudo(type) {
			return function (elem) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === type;
			};
		}

		/**
   * Returns a function to use in pseudos for buttons
   * @param {String} type
   */
		function createButtonPseudo(type) {
			return function (elem) {
				var name = elem.nodeName.toLowerCase();
				return (name === "input" || name === "button") && elem.type === type;
			};
		}

		/**
   * Returns a function to use in pseudos for :enabled/:disabled
   * @param {Boolean} disabled true for :disabled; false for :enabled
   */
		function createDisabledPseudo(disabled) {

			// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
			return function (elem) {

				// Only certain elements can match :enabled or :disabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
				if ("form" in elem) {

					// Check for inherited disabledness on relevant non-disabled elements:
					// * listed form-associated elements in a disabled fieldset
					//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
					// * option elements in a disabled optgroup
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
					// All such elements have a "form" property.
					if (elem.parentNode && elem.disabled === false) {

						// Option elements defer to a parent optgroup if present
						if ("label" in elem) {
							if ("label" in elem.parentNode) {
								return elem.parentNode.disabled === disabled;
							} else {
								return elem.disabled === disabled;
							}
						}

						// Support: IE 6 - 11
						// Use the isDisabled shortcut property to check for disabled fieldset ancestors
						return elem.isDisabled === disabled ||

						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
					}

					return elem.disabled === disabled;

					// Try to winnow out elements that can't be disabled before trusting the disabled property.
					// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
					// even exist on them, let alone have a boolean value.
				} else if ("label" in elem) {
					return elem.disabled === disabled;
				}

				// Remaining elements are neither :enabled nor :disabled
				return false;
			};
		}

		/**
   * Returns a function to use in pseudos for positionals
   * @param {Function} fn
   */
		function createPositionalPseudo(fn) {
			return markFunction(function (argument) {
				argument = +argument;
				return markFunction(function (seed, matches) {
					var j,
					    matchIndexes = fn([], seed.length, argument),
					    i = matchIndexes.length;

					// Match elements found at the specified indexes
					while (i--) {
						if (seed[j = matchIndexes[i]]) {
							seed[j] = !(matches[j] = seed[j]);
						}
					}
				});
			});
		}

		/**
   * Checks a node for validity as a Sizzle context
   * @param {Element|Object=} context
   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
   */
		function testContext(context) {
			return context && typeof context.getElementsByTagName !== "undefined" && context;
		}

		// Expose support vars for convenience
		support = Sizzle.support = {};

		/**
   * Detects XML nodes
   * @param {Element|Object} elem An element or a document
   * @returns {Boolean} True iff elem is a non-HTML XML node
   */
		isXML = Sizzle.isXML = function (elem) {
			var namespace = elem.namespaceURI,
			    docElem = (elem.ownerDocument || elem).documentElement;

			// Support: IE <=8
			// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
			// https://bugs.jquery.com/ticket/4833
			return !rhtml.test(namespace || docElem && docElem.nodeName || "HTML");
		};

		/**
   * Sets document-related variables once based on the current document
   * @param {Element|Object} [doc] An element or document object to use to set the document
   * @returns {Object} Returns the current document
   */
		setDocument = Sizzle.setDocument = function (node) {
			var hasCompare,
			    subWindow,
			    doc = node ? node.ownerDocument || node : preferredDoc;

			// Return early if doc is invalid or already selected
			if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
				return document;
			}

			// Update global variables
			document = doc;
			docElem = document.documentElement;
			documentIsHTML = !isXML(document);

			// Support: IE 9-11, Edge
			// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
			if (preferredDoc !== document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {

				// Support: IE 11, Edge
				if (subWindow.addEventListener) {
					subWindow.addEventListener("unload", unloadHandler, false);

					// Support: IE 9 - 10 only
				} else if (subWindow.attachEvent) {
					subWindow.attachEvent("onunload", unloadHandler);
				}
			}

			/* Attributes
   ---------------------------------------------------------------------- */

			// Support: IE<8
			// Verify that getAttribute really returns attributes and not properties
			// (excepting IE8 booleans)
			support.attributes = assert(function (el) {
				el.className = "i";
				return !el.getAttribute("className");
			});

			/* getElement(s)By*
   ---------------------------------------------------------------------- */

			// Check if getElementsByTagName("*") returns only elements
			support.getElementsByTagName = assert(function (el) {
				el.appendChild(document.createComment(""));
				return !el.getElementsByTagName("*").length;
			});

			// Support: IE<9
			support.getElementsByClassName = rnative.test(document.getElementsByClassName);

			// Support: IE<10
			// Check if getElementById returns elements by name
			// The broken getElementById methods don't pick up programmatically-set names,
			// so use a roundabout getElementsByName test
			support.getById = assert(function (el) {
				docElem.appendChild(el).id = expando;
				return !document.getElementsByName || !document.getElementsByName(expando).length;
			});

			// ID filter and find
			if (support.getById) {
				Expr.filter["ID"] = function (id) {
					var attrId = id.replace(runescape, funescape);
					return function (elem) {
						return elem.getAttribute("id") === attrId;
					};
				};
				Expr.find["ID"] = function (id, context) {
					if (typeof context.getElementById !== "undefined" && documentIsHTML) {
						var elem = context.getElementById(id);
						return elem ? [elem] : [];
					}
				};
			} else {
				Expr.filter["ID"] = function (id) {
					var attrId = id.replace(runescape, funescape);
					return function (elem) {
						var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
						return node && node.value === attrId;
					};
				};

				// Support: IE 6 - 7 only
				// getElementById is not reliable as a find shortcut
				Expr.find["ID"] = function (id, context) {
					if (typeof context.getElementById !== "undefined" && documentIsHTML) {
						var node,
						    i,
						    elems,
						    elem = context.getElementById(id);

						if (elem) {

							// Verify the id attribute
							node = elem.getAttributeNode("id");
							if (node && node.value === id) {
								return [elem];
							}

							// Fall back on getElementsByName
							elems = context.getElementsByName(id);
							i = 0;
							while (elem = elems[i++]) {
								node = elem.getAttributeNode("id");
								if (node && node.value === id) {
									return [elem];
								}
							}
						}

						return [];
					}
				};
			}

			// Tag
			Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
				if (typeof context.getElementsByTagName !== "undefined") {
					return context.getElementsByTagName(tag);

					// DocumentFragment nodes don't have gEBTN
				} else if (support.qsa) {
					return context.querySelectorAll(tag);
				}
			} : function (tag, context) {
				var elem,
				    tmp = [],
				    i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName(tag);

				// Filter out possible comments
				if (tag === "*") {
					while (elem = results[i++]) {
						if (elem.nodeType === 1) {
							tmp.push(elem);
						}
					}

					return tmp;
				}
				return results;
			};

			// Class
			Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
				if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
					return context.getElementsByClassName(className);
				}
			};

			/* QSA/matchesSelector
   ---------------------------------------------------------------------- */

			// QSA and matchesSelector support

			// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
			rbuggyMatches = [];

			// qSa(:focus) reports false when true (Chrome 21)
			// We allow this because of a bug in IE8/9 that throws an error
			// whenever `document.activeElement` is accessed on an iframe
			// So, we allow :focus to pass through QSA all the time to avoid the IE error
			// See https://bugs.jquery.com/ticket/13378
			rbuggyQSA = [];

			if (support.qsa = rnative.test(document.querySelectorAll)) {
				// Build QSA regex
				// Regex strategy adopted from Diego Perini
				assert(function (el) {
					// Select is set to empty string on purpose
					// This is to test IE's treatment of not explicitly
					// setting a boolean content attribute,
					// since its presence should be enough
					// https://bugs.jquery.com/ticket/12359
					docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";

					// Support: IE8, Opera 11-12.16
					// Nothing should be selected when empty strings follow ^= or $= or *=
					// The test attribute must be unknown in Opera but "safe" for WinRT
					// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
					if (el.querySelectorAll("[msallowcapture^='']").length) {
						rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
					}

					// Support: IE8
					// Boolean attributes and "value" are not treated correctly
					if (!el.querySelectorAll("[selected]").length) {
						rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
					}

					// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
					if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
						rbuggyQSA.push("~=");
					}

					// Webkit/Opera - :checked should return selected option elements
					// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					// IE8 throws error here and will not see later tests
					if (!el.querySelectorAll(":checked").length) {
						rbuggyQSA.push(":checked");
					}

					// Support: Safari 8+, iOS 8+
					// https://bugs.webkit.org/show_bug.cgi?id=136851
					// In-page `selector#id sibling-combinator selector` fails
					if (!el.querySelectorAll("a#" + expando + "+*").length) {
						rbuggyQSA.push(".#.+[+~]");
					}
				});

				assert(function (el) {
					el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";

					// Support: Windows 8 Native Apps
					// The type and name attributes are restricted during .innerHTML assignment
					var input = document.createElement("input");
					input.setAttribute("type", "hidden");
					el.appendChild(input).setAttribute("name", "D");

					// Support: IE8
					// Enforce case-sensitivity of name attribute
					if (el.querySelectorAll("[name=d]").length) {
						rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
					}

					// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
					// IE8 throws error here and will not see later tests
					if (el.querySelectorAll(":enabled").length !== 2) {
						rbuggyQSA.push(":enabled", ":disabled");
					}

					// Support: IE9-11+
					// IE's :disabled selector does not pick up the children of disabled fieldsets
					docElem.appendChild(el).disabled = true;
					if (el.querySelectorAll(":disabled").length !== 2) {
						rbuggyQSA.push(":enabled", ":disabled");
					}

					// Opera 10-11 does not throw on post-comma invalid pseudos
					el.querySelectorAll("*,:x");
					rbuggyQSA.push(",.*:");
				});
			}

			if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {

				assert(function (el) {
					// Check to see if it's possible to do matchesSelector
					// on a disconnected node (IE 9)
					support.disconnectedMatch = matches.call(el, "*");

					// This should fail with an exception
					// Gecko does not error, returns false instead
					matches.call(el, "[s!='']:x");
					rbuggyMatches.push("!=", pseudos);
				});
			}

			rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
			rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

			/* Contains
   ---------------------------------------------------------------------- */
			hasCompare = rnative.test(docElem.compareDocumentPosition);

			// Element contains another
			// Purposefully self-exclusive
			// As in, an element does not contain itself
			contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
				    bup = b && b.parentNode;
				return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
			} : function (a, b) {
				if (b) {
					while (b = b.parentNode) {
						if (b === a) {
							return true;
						}
					}
				}
				return false;
			};

			/* Sorting
   ---------------------------------------------------------------------- */

			// Document order sorting
			sortOrder = hasCompare ? function (a, b) {

				// Flag for duplicate removal
				if (a === b) {
					hasDuplicate = true;
					return 0;
				}

				// Sort on method existence if only one input has compareDocumentPosition
				var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
				if (compare) {
					return compare;
				}

				// Calculate position if both inputs belong to the same document
				compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) :

				// Otherwise we know they are disconnected
				1;

				// Disconnected nodes
				if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {

					// Choose the first element that is related to our preferred document
					if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
						return -1;
					}
					if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
						return 1;
					}

					// Maintain original order
					return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
				}

				return compare & 4 ? -1 : 1;
			} : function (a, b) {
				// Exit early if the nodes are identical
				if (a === b) {
					hasDuplicate = true;
					return 0;
				}

				var cur,
				    i = 0,
				    aup = a.parentNode,
				    bup = b.parentNode,
				    ap = [a],
				    bp = [b];

				// Parentless nodes are either documents or disconnected
				if (!aup || !bup) {
					return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;

					// If the nodes are siblings, we can do a quick check
				} else if (aup === bup) {
					return siblingCheck(a, b);
				}

				// Otherwise we need full lists of their ancestors for comparison
				cur = a;
				while (cur = cur.parentNode) {
					ap.unshift(cur);
				}
				cur = b;
				while (cur = cur.parentNode) {
					bp.unshift(cur);
				}

				// Walk down the tree looking for a discrepancy
				while (ap[i] === bp[i]) {
					i++;
				}

				return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck(ap[i], bp[i]) :

				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
			};

			return document;
		};

		Sizzle.matches = function (expr, elements) {
			return Sizzle(expr, null, null, elements);
		};

		Sizzle.matchesSelector = function (elem, expr) {
			// Set document vars if needed
			if ((elem.ownerDocument || elem) !== document) {
				setDocument(elem);
			}

			if (support.matchesSelector && documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {

				try {
					var ret = matches.call(elem, expr);

					// IE 9's matchesSelector returns false on disconnected nodes
					if (ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11) {
						return ret;
					}
				} catch (e) {
					nonnativeSelectorCache(expr, true);
				}
			}

			return Sizzle(expr, document, null, [elem]).length > 0;
		};

		Sizzle.contains = function (context, elem) {
			// Set document vars if needed
			if ((context.ownerDocument || context) !== document) {
				setDocument(context);
			}
			return contains(context, elem);
		};

		Sizzle.attr = function (elem, name) {
			// Set document vars if needed
			if ((elem.ownerDocument || elem) !== document) {
				setDocument(elem);
			}

			var fn = Expr.attrHandle[name.toLowerCase()],

			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;

			return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
		};

		Sizzle.escape = function (sel) {
			return (sel + "").replace(rcssescape, fcssescape);
		};

		Sizzle.error = function (msg) {
			throw new Error("Syntax error, unrecognized expression: " + msg);
		};

		/**
   * Document sorting and removing duplicates
   * @param {ArrayLike} results
   */
		Sizzle.uniqueSort = function (results) {
			var elem,
			    duplicates = [],
			    j = 0,
			    i = 0;

			// Unless we *know* we can detect duplicates, assume their presence
			hasDuplicate = !support.detectDuplicates;
			sortInput = !support.sortStable && results.slice(0);
			results.sort(sortOrder);

			if (hasDuplicate) {
				while (elem = results[i++]) {
					if (elem === results[i]) {
						j = duplicates.push(i);
					}
				}
				while (j--) {
					results.splice(duplicates[j], 1);
				}
			}

			// Clear input after sorting to release objects
			// See https://github.com/jquery/sizzle/pull/225
			sortInput = null;

			return results;
		};

		/**
   * Utility function for retrieving the text value of an array of DOM nodes
   * @param {Array|Element} elem
   */
		getText = Sizzle.getText = function (elem) {
			var node,
			    ret = "",
			    i = 0,
			    nodeType = elem.nodeType;

			if (!nodeType) {
				// If no nodeType, this is expected to be an array
				while (node = elem[i++]) {
					// Do not traverse comment nodes
					ret += getText(node);
				}
			} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
				// Use textContent for elements
				// innerText usage removed for consistency of new lines (jQuery #11153)
				if (typeof elem.textContent === "string") {
					return elem.textContent;
				} else {
					// Traverse its children
					for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
						ret += getText(elem);
					}
				}
			} else if (nodeType === 3 || nodeType === 4) {
				return elem.nodeValue;
			}
			// Do not include comment or processing instruction nodes

			return ret;
		};

		Expr = Sizzle.selectors = {

			// Can be adjusted by the user
			cacheLength: 50,

			createPseudo: markFunction,

			match: matchExpr,

			attrHandle: {},

			find: {},

			relative: {
				">": { dir: "parentNode", first: true },
				" ": { dir: "parentNode" },
				"+": { dir: "previousSibling", first: true },
				"~": { dir: "previousSibling" }
			},

			preFilter: {
				"ATTR": function ATTR(match) {
					match[1] = match[1].replace(runescape, funescape);

					// Move the given value to match[3] whether quoted or unquoted
					match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

					if (match[2] === "~=") {
						match[3] = " " + match[3] + " ";
					}

					return match.slice(0, 4);
				},

				"CHILD": function CHILD(match) {
					/* matches from matchExpr["CHILD"]
     	1 type (only|nth|...)
     	2 what (child|of-type)
     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
     	4 xn-component of xn+y argument ([+-]?\d*n|)
     	5 sign of xn-component
     	6 x of xn-component
     	7 sign of y-component
     	8 y of y-component
     */
					match[1] = match[1].toLowerCase();

					if (match[1].slice(0, 3) === "nth") {
						// nth-* requires argument
						if (!match[3]) {
							Sizzle.error(match[0]);
						}

						// numeric x and y parameters for Expr.filter.CHILD
						// remember that false/true cast respectively to 0/1
						match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
						match[5] = +(match[7] + match[8] || match[3] === "odd");

						// other types prohibit arguments
					} else if (match[3]) {
						Sizzle.error(match[0]);
					}

					return match;
				},

				"PSEUDO": function PSEUDO(match) {
					var excess,
					    unquoted = !match[6] && match[2];

					if (matchExpr["CHILD"].test(match[0])) {
						return null;
					}

					// Accept quoted arguments as-is
					if (match[3]) {
						match[2] = match[4] || match[5] || "";

						// Strip excess characters from unquoted arguments
					} else if (unquoted && rpseudo.test(unquoted) && (
					// Get excess from tokenize (recursively)
					excess = tokenize(unquoted, true)) && (
					// advance to the next closing parenthesis
					excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

						// excess is a negative index
						match[0] = match[0].slice(0, excess);
						match[2] = unquoted.slice(0, excess);
					}

					// Return only captures needed by the pseudo filter method (type and argument)
					return match.slice(0, 3);
				}
			},

			filter: {

				"TAG": function TAG(nodeNameSelector) {
					var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
					return nodeNameSelector === "*" ? function () {
						return true;
					} : function (elem) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
				},

				"CLASS": function CLASS(className) {
					var pattern = classCache[className + " "];

					return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
						return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
					});
				},

				"ATTR": function ATTR(name, operator, check) {
					return function (elem) {
						var result = Sizzle.attr(elem, name);

						if (result == null) {
							return operator === "!=";
						}
						if (!operator) {
							return true;
						}

						result += "";

						return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
					};
				},

				"CHILD": function CHILD(type, what, argument, first, last) {
					var simple = type.slice(0, 3) !== "nth",
					    forward = type.slice(-4) !== "last",
					    ofType = what === "of-type";

					return first === 1 && last === 0 ?

					// Shortcut for :nth-*(n)
					function (elem) {
						return !!elem.parentNode;
					} : function (elem, context, xml) {
						var cache,
						    uniqueCache,
						    outerCache,
						    node,
						    nodeIndex,
						    start,
						    dir = simple !== forward ? "nextSibling" : "previousSibling",
						    parent = elem.parentNode,
						    name = ofType && elem.nodeName.toLowerCase(),
						    useCache = !xml && !ofType,
						    diff = false;

						if (parent) {

							// :(first|last|only)-(child|of-type)
							if (simple) {
								while (dir) {
									node = elem;
									while (node = node[dir]) {
										if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {

											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}

							start = [forward ? parent.firstChild : parent.lastChild];

							// non-xml :nth-child(...) stores cache data on `parent`
							if (forward && useCache) {

								// Seek `elem` from a previously-cached index

								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[expando] || (node[expando] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

								cache = uniqueCache[type] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = nodeIndex && cache[2];
								node = nodeIndex && parent.childNodes[nodeIndex];

								while (node = ++nodeIndex && node && node[dir] || (

								// Fallback to seeking `elem` from the start
								diff = nodeIndex = 0) || start.pop()) {

									// When found, cache indexes on `parent` and break
									if (node.nodeType === 1 && ++diff && node === elem) {
										uniqueCache[type] = [dirruns, nodeIndex, diff];
										break;
									}
								}
							} else {
								// Use previously-cached element index if available
								if (useCache) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[expando] || (node[expando] = {});

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

									cache = uniqueCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex;
								}

								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if (diff === false) {
									// Use the same loop as above to seek `elem` from the start
									while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {

										if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {

											// Cache the index of each encountered element
											if (useCache) {
												outerCache = node[expando] || (node[expando] = {});

												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

												uniqueCache[type] = [dirruns, diff];
											}

											if (node === elem) {
												break;
											}
										}
									}
								}
							}

							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || diff % first === 0 && diff / first >= 0;
						}
					};
				},

				"PSEUDO": function PSEUDO(pseudo, argument) {
					// pseudo-class names are case-insensitive
					// http://www.w3.org/TR/selectors/#pseudo-classes
					// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
					// Remember that setFilters inherits from pseudos
					var args,
					    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);

					// The user may use createPseudo to indicate that
					// arguments are needed to create the filter function
					// just as Sizzle does
					if (fn[expando]) {
						return fn(argument);
					}

					// But maintain support for old signatures
					if (fn.length > 1) {
						args = [pseudo, pseudo, "", argument];
						return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
							var idx,
							    matched = fn(seed, argument),
							    i = matched.length;
							while (i--) {
								idx = indexOf(seed, matched[i]);
								seed[idx] = !(matches[idx] = matched[i]);
							}
						}) : function (elem) {
							return fn(elem, 0, args);
						};
					}

					return fn;
				}
			},

			pseudos: {
				// Potentially complex pseudos
				"not": markFunction(function (selector) {
					// Trim the selector passed to compile
					// to avoid treating leading and trailing
					// spaces as combinators
					var input = [],
					    results = [],
					    matcher = compile(selector.replace(rtrim, "$1"));

					return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
						var elem,
						    unmatched = matcher(seed, null, xml, []),
						    i = seed.length;

						// Match elements unmatched by `matcher`
						while (i--) {
							if (elem = unmatched[i]) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) : function (elem, context, xml) {
						input[0] = elem;
						matcher(input, null, xml, results);
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
				}),

				"has": markFunction(function (selector) {
					return function (elem) {
						return Sizzle(selector, elem).length > 0;
					};
				}),

				"contains": markFunction(function (text) {
					text = text.replace(runescape, funescape);
					return function (elem) {
						return (elem.textContent || getText(elem)).indexOf(text) > -1;
					};
				}),

				// "Whether an element is represented by a :lang() selector
				// is based solely on the element's language value
				// being equal to the identifier C,
				// or beginning with the identifier C immediately followed by "-".
				// The matching of C against the element's language value is performed case-insensitively.
				// The identifier C does not have to be a valid language name."
				// http://www.w3.org/TR/selectors/#lang-pseudo
				"lang": markFunction(function (lang) {
					// lang value must be a valid identifier
					if (!ridentifier.test(lang || "")) {
						Sizzle.error("unsupported lang: " + lang);
					}
					lang = lang.replace(runescape, funescape).toLowerCase();
					return function (elem) {
						var elemLang;
						do {
							if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {

								elemLang = elemLang.toLowerCase();
								return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
							}
						} while ((elem = elem.parentNode) && elem.nodeType === 1);
						return false;
					};
				}),

				// Miscellaneous
				"target": function target(elem) {
					var hash = window.location && window.location.hash;
					return hash && hash.slice(1) === elem.id;
				},

				"root": function root(elem) {
					return elem === docElem;
				},

				"focus": function focus(elem) {
					return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
				},

				// Boolean properties
				"enabled": createDisabledPseudo(false),
				"disabled": createDisabledPseudo(true),

				"checked": function checked(elem) {
					// In CSS3, :checked should return both checked and selected elements
					// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					var nodeName = elem.nodeName.toLowerCase();
					return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
				},

				"selected": function selected(elem) {
					// Accessing this property makes selected-by-default
					// options in Safari work properly
					if (elem.parentNode) {
						elem.parentNode.selectedIndex;
					}

					return elem.selected === true;
				},

				// Contents
				"empty": function empty(elem) {
					// http://www.w3.org/TR/selectors/#empty-pseudo
					// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
					//   but not by others (comment: 8; processing instruction: 7; etc.)
					// nodeType < 6 works because attributes (2) do not appear as children
					for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
						if (elem.nodeType < 6) {
							return false;
						}
					}
					return true;
				},

				"parent": function parent(elem) {
					return !Expr.pseudos["empty"](elem);
				},

				// Element/input types
				"header": function header(elem) {
					return rheader.test(elem.nodeName);
				},

				"input": function input(elem) {
					return rinputs.test(elem.nodeName);
				},

				"button": function button(elem) {
					var name = elem.nodeName.toLowerCase();
					return name === "input" && elem.type === "button" || name === "button";
				},

				"text": function text(elem) {
					var attr;
					return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (

					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
				},

				// Position-in-collection
				"first": createPositionalPseudo(function () {
					return [0];
				}),

				"last": createPositionalPseudo(function (matchIndexes, length) {
					return [length - 1];
				}),

				"eq": createPositionalPseudo(function (matchIndexes, length, argument) {
					return [argument < 0 ? argument + length : argument];
				}),

				"even": createPositionalPseudo(function (matchIndexes, length) {
					var i = 0;
					for (; i < length; i += 2) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				"odd": createPositionalPseudo(function (matchIndexes, length) {
					var i = 1;
					for (; i < length; i += 2) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
					var i = argument < 0 ? argument + length : argument > length ? length : argument;
					for (; --i >= 0;) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
					var i = argument < 0 ? argument + length : argument;
					for (; ++i < length;) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				})
			}
		};

		Expr.pseudos["nth"] = Expr.pseudos["eq"];

		// Add button/input type pseudos
		for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
			Expr.pseudos[i] = createInputPseudo(i);
		}
		for (i in { submit: true, reset: true }) {
			Expr.pseudos[i] = createButtonPseudo(i);
		}

		// Easy API for creating new setFilters
		function setFilters() {}
		setFilters.prototype = Expr.filters = Expr.pseudos;
		Expr.setFilters = new setFilters();

		tokenize = Sizzle.tokenize = function (selector, parseOnly) {
			var matched,
			    match,
			    tokens,
			    type,
			    soFar,
			    groups,
			    preFilters,
			    cached = tokenCache[selector + " "];

			if (cached) {
				return parseOnly ? 0 : cached.slice(0);
			}

			soFar = selector;
			groups = [];
			preFilters = Expr.preFilter;

			while (soFar) {

				// Comma and first run
				if (!matched || (match = rcomma.exec(soFar))) {
					if (match) {
						// Don't consume trailing commas as valid
						soFar = soFar.slice(match[0].length) || soFar;
					}
					groups.push(tokens = []);
				}

				matched = false;

				// Combinators
				if (match = rcombinators.exec(soFar)) {
					matched = match.shift();
					tokens.push({
						value: matched,
						// Cast descendant combinators to space
						type: match[0].replace(rtrim, " ")
					});
					soFar = soFar.slice(matched.length);
				}

				// Filters
				for (type in Expr.filter) {
					if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
						matched = match.shift();
						tokens.push({
							value: matched,
							type: type,
							matches: match
						});
						soFar = soFar.slice(matched.length);
					}
				}

				if (!matched) {
					break;
				}
			}

			// Return the length of the invalid excess
			// if we're just parsing
			// Otherwise, throw an error or return tokens
			return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :
			// Cache the tokens
			tokenCache(selector, groups).slice(0);
		};

		function toSelector(tokens) {
			var i = 0,
			    len = tokens.length,
			    selector = "";
			for (; i < len; i++) {
				selector += tokens[i].value;
			}
			return selector;
		}

		function addCombinator(matcher, combinator, base) {
			var dir = combinator.dir,
			    skip = combinator.next,
			    key = skip || dir,
			    checkNonElements = base && key === "parentNode",
			    doneName = done++;

			return combinator.first ?
			// Check against closest ancestor/preceding element
			function (elem, context, xml) {
				while (elem = elem[dir]) {
					if (elem.nodeType === 1 || checkNonElements) {
						return matcher(elem, context, xml);
					}
				}
				return false;
			} :

			// Check against all ancestor/preceding elements
			function (elem, context, xml) {
				var oldCache,
				    uniqueCache,
				    outerCache,
				    newCache = [dirruns, doneName];

				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if (xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							if (matcher(elem, context, xml)) {
								return true;
							}
						}
					}
				} else {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							outerCache = elem[expando] || (elem[expando] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

							if (skip && skip === elem.nodeName.toLowerCase()) {
								elem = elem[dir] || elem;
							} else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {

								// Assign to newCache so results back-propagate to previous elements
								return newCache[2] = oldCache[2];
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[key] = newCache;

								// A match means we're done; a fail means we have to keep checking
								if (newCache[2] = matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
		}

		function elementMatcher(matchers) {
			return matchers.length > 1 ? function (elem, context, xml) {
				var i = matchers.length;
				while (i--) {
					if (!matchers[i](elem, context, xml)) {
						return false;
					}
				}
				return true;
			} : matchers[0];
		}

		function multipleContexts(selector, contexts, results) {
			var i = 0,
			    len = contexts.length;
			for (; i < len; i++) {
				Sizzle(selector, contexts[i], results);
			}
			return results;
		}

		function condense(unmatched, map, filter, context, xml) {
			var elem,
			    newUnmatched = [],
			    i = 0,
			    len = unmatched.length,
			    mapped = map != null;

			for (; i < len; i++) {
				if (elem = unmatched[i]) {
					if (!filter || filter(elem, context, xml)) {
						newUnmatched.push(elem);
						if (mapped) {
							map.push(i);
						}
					}
				}
			}

			return newUnmatched;
		}

		function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
			if (postFilter && !postFilter[expando]) {
				postFilter = setMatcher(postFilter);
			}
			if (postFinder && !postFinder[expando]) {
				postFinder = setMatcher(postFinder, postSelector);
			}
			return markFunction(function (seed, results, context, xml) {
				var temp,
				    i,
				    elem,
				    preMap = [],
				    postMap = [],
				    preexisting = results.length,


				// Get initial elements from seed or context
				elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),


				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
				    matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || (seed ? preFilter : preexisting || postFilter) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results : matcherIn;

				// Find primary matches
				if (matcher) {
					matcher(matcherIn, matcherOut, context, xml);
				}

				// Apply postFilter
				if (postFilter) {
					temp = condense(matcherOut, postMap);
					postFilter(temp, [], context, xml);

					// Un-match failing elements by moving them back to matcherIn
					i = temp.length;
					while (i--) {
						if (elem = temp[i]) {
							matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
						}
					}
				}

				if (seed) {
					if (postFinder || preFilter) {
						if (postFinder) {
							// Get the final matcherOut by condensing this intermediate into postFinder contexts
							temp = [];
							i = matcherOut.length;
							while (i--) {
								if (elem = matcherOut[i]) {
									// Restore matcherIn since elem is not yet a final match
									temp.push(matcherIn[i] = elem);
								}
							}
							postFinder(null, matcherOut = [], temp, xml);
						}

						// Move matched elements from seed to results to keep them synchronized
						i = matcherOut.length;
						while (i--) {
							if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {

								seed[temp] = !(results[temp] = elem);
							}
						}
					}

					// Add elements to results, through postFinder if defined
				} else {
					matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
					if (postFinder) {
						postFinder(null, results, matcherOut, xml);
					} else {
						push.apply(results, matcherOut);
					}
				}
			});
		}

		function matcherFromTokens(tokens) {
			var checkContext,
			    matcher,
			    j,
			    len = tokens.length,
			    leadingRelative = Expr.relative[tokens[0].type],
			    implicitRelative = leadingRelative || Expr.relative[" "],
			    i = leadingRelative ? 1 : 0,


			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator(function (elem) {
				return elem === checkContext;
			}, implicitRelative, true),
			    matchAnyContext = addCombinator(function (elem) {
				return indexOf(checkContext, elem) > -1;
			}, implicitRelative, true),
			    matchers = [function (elem, context, xml) {
				var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			}];

			for (; i < len; i++) {
				if (matcher = Expr.relative[tokens[i].type]) {
					matchers = [addCombinator(elementMatcher(matchers), matcher)];
				} else {
					matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

					// Return special upon seeing a positional matcher
					if (matcher[expando]) {
						// Find the next relative operator (if any) for proper handling
						j = ++i;
						for (; j < len; j++) {
							if (Expr.relative[tokens[j].type]) {
								break;
							}
						}
						return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
					}
					matchers.push(matcher);
				}
			}

			return elementMatcher(matchers);
		}

		function matcherFromGroupMatchers(elementMatchers, setMatchers) {
			var bySet = setMatchers.length > 0,
			    byElement = elementMatchers.length > 0,
			    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
				var elem,
				    j,
				    matcher,
				    matchedCount = 0,
				    i = "0",
				    unmatched = seed && [],
				    setMatched = [],
				    contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]("*", outermost),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
				    len = elems.length;

				if (outermost) {
					outermostContext = context === document || context || outermost;
				}

				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for (; i !== len && (elem = elems[i]) != null; i++) {
					if (byElement && elem) {
						j = 0;
						if (!context && elem.ownerDocument !== document) {
							setDocument(elem);
							xml = !documentIsHTML;
						}
						while (matcher = elementMatchers[j++]) {
							if (matcher(elem, context || document, xml)) {
								results.push(elem);
								break;
							}
						}
						if (outermost) {
							dirruns = dirrunsUnique;
						}
					}

					// Track unmatched elements for set filters
					if (bySet) {
						// They will have gone through all possible matchers
						if (elem = !matcher && elem) {
							matchedCount--;
						}

						// Lengthen the array for every element, matched or not
						if (seed) {
							unmatched.push(elem);
						}
					}
				}

				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;

				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if (bySet && i !== matchedCount) {
					j = 0;
					while (matcher = setMatchers[j++]) {
						matcher(unmatched, setMatched, context, xml);
					}

					if (seed) {
						// Reintegrate element matches to eliminate the need for sorting
						if (matchedCount > 0) {
							while (i--) {
								if (!(unmatched[i] || setMatched[i])) {
									setMatched[i] = pop.call(results);
								}
							}
						}

						// Discard index placeholder values to get only actual matches
						setMatched = condense(setMatched);
					}

					// Add matches to results
					push.apply(results, setMatched);

					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {

						Sizzle.uniqueSort(results);
					}
				}

				// Override manipulation of globals by nested matchers
				if (outermost) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}

				return unmatched;
			};

			return bySet ? markFunction(superMatcher) : superMatcher;
		}

		compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
			var i,
			    setMatchers = [],
			    elementMatchers = [],
			    cached = compilerCache[selector + " "];

			if (!cached) {
				// Generate a function of recursive functions that can be used to check each element
				if (!match) {
					match = tokenize(selector);
				}
				i = match.length;
				while (i--) {
					cached = matcherFromTokens(match[i]);
					if (cached[expando]) {
						setMatchers.push(cached);
					} else {
						elementMatchers.push(cached);
					}
				}

				// Cache the compiled function
				cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

				// Save selector and tokenization
				cached.selector = selector;
			}
			return cached;
		};

		/**
   * A low-level selection function that works with Sizzle's compiled
   *  selector functions
   * @param {String|Function} selector A selector or a pre-compiled
   *  selector function built with Sizzle.compile
   * @param {Element} context
   * @param {Array} [results]
   * @param {Array} [seed] A set of elements to match against
   */
		select = Sizzle.select = function (selector, context, results, seed) {
			var i,
			    tokens,
			    token,
			    type,
			    find,
			    compiled = typeof selector === "function" && selector,
			    match = !seed && tokenize(selector = compiled.selector || selector);

			results = results || [];

			// Try to minimize operations if there is only one selector in the list and no seed
			// (the latter of which guarantees us context)
			if (match.length === 1) {

				// Reduce context if the leading compound selector is an ID
				tokens = match[0] = match[0].slice(0);
				if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

					context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
					if (!context) {
						return results;

						// Precompiled matchers will still verify ancestry, so step up a level
					} else if (compiled) {
						context = context.parentNode;
					}

					selector = selector.slice(tokens.shift().value.length);
				}

				// Fetch a seed set for right-to-left matching
				i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
				while (i--) {
					token = tokens[i];

					// Abort if we hit a combinator
					if (Expr.relative[type = token.type]) {
						break;
					}
					if (find = Expr.find[type]) {
						// Search, expanding context for leading sibling combinators
						if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {

							// If seed is empty or no tokens remain, we can return early
							tokens.splice(i, 1);
							selector = seed.length && toSelector(tokens);
							if (!selector) {
								push.apply(results, seed);
								return results;
							}

							break;
						}
					}
				}
			}

			// Compile and execute a filtering function if one is not provided
			// Provide `match` to avoid retokenization if we modified the selector above
			(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
			return results;
		};

		// One-time assignments

		// Sort stability
		support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

		// Support: Chrome 14-35+
		// Always assume duplicates if they aren't passed to the comparison function
		support.detectDuplicates = !!hasDuplicate;

		// Initialize against the default document
		setDocument();

		// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
		// Detached nodes confoundingly follow *each other*
		support.sortDetached = assert(function (el) {
			// Should return 1, but returns 4 (following)
			return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
		});

		// Support: IE<8
		// Prevent attribute/property "interpolation"
		// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
		if (!assert(function (el) {
			el.innerHTML = "<a href='#'></a>";
			return el.firstChild.getAttribute("href") === "#";
		})) {
			addHandle("type|href|height|width", function (elem, name, isXML) {
				if (!isXML) {
					return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
				}
			});
		}

		// Support: IE<9
		// Use defaultValue in place of getAttribute("value")
		if (!support.attributes || !assert(function (el) {
			el.innerHTML = "<input/>";
			el.firstChild.setAttribute("value", "");
			return el.firstChild.getAttribute("value") === "";
		})) {
			addHandle("value", function (elem, name, isXML) {
				if (!isXML && elem.nodeName.toLowerCase() === "input") {
					return elem.defaultValue;
				}
			});
		}

		// Support: IE<9
		// Use getAttributeNode to fetch booleans when getAttribute lies
		if (!assert(function (el) {
			return el.getAttribute("disabled") == null;
		})) {
			addHandle(booleans, function (elem, name, isXML) {
				var val;
				if (!isXML) {
					return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
				}
			});
		}

		return Sizzle;
	}(window);

	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;

	// Deprecated
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;

	var dir = function dir(elem, _dir, until) {
		var matched = [],
		    truncate = until !== undefined;

		while ((elem = elem[_dir]) && elem.nodeType !== 9) {
			if (elem.nodeType === 1) {
				if (truncate && jQuery(elem).is(until)) {
					break;
				}
				matched.push(elem);
			}
		}
		return matched;
	};

	var _siblings = function _siblings(n, elem) {
		var matched = [];

		for (; n; n = n.nextSibling) {
			if (n.nodeType === 1 && n !== elem) {
				matched.push(n);
			}
		}

		return matched;
	};

	var rneedsContext = jQuery.expr.match.needsContext;

	function nodeName(elem, name) {

		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	};
	var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

	// Implement the identical functionality for filter and not
	function winnow(elements, qualifier, not) {
		if (isFunction(qualifier)) {
			return jQuery.grep(elements, function (elem, i) {
				return !!qualifier.call(elem, i, elem) !== not;
			});
		}

		// Single element
		if (qualifier.nodeType) {
			return jQuery.grep(elements, function (elem) {
				return elem === qualifier !== not;
			});
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if (typeof qualifier !== "string") {
			return jQuery.grep(elements, function (elem) {
				return indexOf.call(qualifier, elem) > -1 !== not;
			});
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter(qualifier, elements, not);
	}

	jQuery.filter = function (expr, elems, not) {
		var elem = elems[0];

		if (not) {
			expr = ":not(" + expr + ")";
		}

		if (elems.length === 1 && elem.nodeType === 1) {
			return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
		}

		return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
			return elem.nodeType === 1;
		}));
	};

	jQuery.fn.extend({
		find: function find(selector) {
			var i,
			    ret,
			    len = this.length,
			    self = this;

			if (typeof selector !== "string") {
				return this.pushStack(jQuery(selector).filter(function () {
					for (i = 0; i < len; i++) {
						if (jQuery.contains(self[i], this)) {
							return true;
						}
					}
				}));
			}

			ret = this.pushStack([]);

			for (i = 0; i < len; i++) {
				jQuery.find(selector, self[i], ret);
			}

			return len > 1 ? jQuery.uniqueSort(ret) : ret;
		},
		filter: function filter(selector) {
			return this.pushStack(winnow(this, selector || [], false));
		},
		not: function not(selector) {
			return this.pushStack(winnow(this, selector || [], true));
		},
		is: function is(selector) {
			return !!winnow(this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
		}
	});

	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,


	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	    init = jQuery.fn.init = function (selector, context, root) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if (!selector) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if (typeof selector === "string") {
			if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [null, selector, null];
			} else {
				match = rquickExpr.exec(selector);
			}

			// Match html or make sure no context is specified for #id
			if (match && (match[1] || !context)) {

				// HANDLE: $(html) -> $(array)
				if (match[1]) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

					// HANDLE: $(html, props)
					if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
						for (match in context) {

							// Properties of context are called as methods if possible
							if (isFunction(this[match])) {
								this[match](context[match]);

								// ...and otherwise set as attributes
							} else {
								this.attr(match, context[match]);
							}
						}
					}

					return this;

					// HANDLE: $(#id)
				} else {
					elem = document.getElementById(match[2]);

					if (elem) {

						// Inject the element directly into the jQuery object
						this[0] = elem;
						this.length = 1;
					}
					return this;
				}

				// HANDLE: $(expr, $(...))
			} else if (!context || context.jquery) {
				return (context || root).find(selector);

				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor(context).find(selector);
			}

			// HANDLE: $(DOMElement)
		} else if (selector.nodeType) {
			this[0] = selector;
			this.length = 1;
			return this;

			// HANDLE: $(function)
			// Shortcut for document ready
		} else if (isFunction(selector)) {
			return root.ready !== undefined ? root.ready(selector) :

			// Execute immediately if ready is not present
			selector(jQuery);
		}

		return jQuery.makeArray(selector, this);
	};

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery(document);

	var rparentsprev = /^(?:parents|prev(?:Until|All))/,


	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

	jQuery.fn.extend({
		has: function has(target) {
			var targets = jQuery(target, this),
			    l = targets.length;

			return this.filter(function () {
				var i = 0;
				for (; i < l; i++) {
					if (jQuery.contains(this, targets[i])) {
						return true;
					}
				}
			});
		},

		closest: function closest(selectors, context) {
			var cur,
			    i = 0,
			    l = this.length,
			    matched = [],
			    targets = typeof selectors !== "string" && jQuery(selectors);

			// Positional selectors never match, since there's no _selection_ context
			if (!rneedsContext.test(selectors)) {
				for (; i < l; i++) {
					for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

						// Always skip document fragments
						if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {

							matched.push(cur);
							break;
						}
					}
				}
			}

			return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
		},

		// Determine the position of an element within the set
		index: function index(elem) {

			// No argument, return index in parent
			if (!elem) {
				return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if (typeof elem === "string") {
				return indexOf.call(jQuery(elem), this[0]);
			}

			// Locate the position of the desired element
			return indexOf.call(this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[0] : elem);
		},

		add: function add(selector, context) {
			return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
		},

		addBack: function addBack(selector) {
			return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
		}
	});

	function sibling(cur, dir) {
		while ((cur = cur[dir]) && cur.nodeType !== 1) {}
		return cur;
	}

	jQuery.each({
		parent: function parent(elem) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function parents(elem) {
			return dir(elem, "parentNode");
		},
		parentsUntil: function parentsUntil(elem, i, until) {
			return dir(elem, "parentNode", until);
		},
		next: function next(elem) {
			return sibling(elem, "nextSibling");
		},
		prev: function prev(elem) {
			return sibling(elem, "previousSibling");
		},
		nextAll: function nextAll(elem) {
			return dir(elem, "nextSibling");
		},
		prevAll: function prevAll(elem) {
			return dir(elem, "previousSibling");
		},
		nextUntil: function nextUntil(elem, i, until) {
			return dir(elem, "nextSibling", until);
		},
		prevUntil: function prevUntil(elem, i, until) {
			return dir(elem, "previousSibling", until);
		},
		siblings: function siblings(elem) {
			return _siblings((elem.parentNode || {}).firstChild, elem);
		},
		children: function children(elem) {
			return _siblings(elem.firstChild);
		},
		contents: function contents(elem) {
			if (typeof elem.contentDocument !== "undefined") {
				return elem.contentDocument;
			}

			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if (nodeName(elem, "template")) {
				elem = elem.content || elem;
			}

			return jQuery.merge([], elem.childNodes);
		}
	}, function (name, fn) {
		jQuery.fn[name] = function (until, selector) {
			var matched = jQuery.map(this, fn, until);

			if (name.slice(-5) !== "Until") {
				selector = until;
			}

			if (selector && typeof selector === "string") {
				matched = jQuery.filter(selector, matched);
			}

			if (this.length > 1) {

				// Remove duplicates
				if (!guaranteedUnique[name]) {
					jQuery.uniqueSort(matched);
				}

				// Reverse order for parents* and prev-derivatives
				if (rparentsprev.test(name)) {
					matched.reverse();
				}
			}

			return this.pushStack(matched);
		};
	});
	var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

	// Convert String-formatted options into Object-formatted ones
	function createOptions(options) {
		var object = {};
		jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
			object[flag] = true;
		});
		return object;
	}

	/*
  * Create a callback list using the following parameters:
  *
  *	options: an optional list of space-separated options that will change how
  *			the callback list behaves or a more traditional option object
  *
  * By default a callback list will act like an event callback list and can be
  * "fired" multiple times.
  *
  * Possible options:
  *
  *	once:			will ensure the callback list can only be fired once (like a Deferred)
  *
  *	memory:			will keep track of previous values and will call any callback added
  *					after the list has been fired right away with the latest "memorized"
  *					values (like a Deferred)
  *
  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
  *
  *	stopOnFalse:	interrupt callings when a callback returns false
  *
  */
	jQuery.Callbacks = function (options) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);

		var // Flag to know if list is currently firing
		firing,


		// Last fire value for non-forgettable lists
		memory,


		// Flag to know if list was already fired
		_fired,


		// Flag to prevent firing
		_locked,


		// Actual callback list
		list = [],


		// Queue of execution data for repeatable lists
		queue = [],


		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,


		// Fire callbacks
		fire = function fire() {

			// Enforce single-firing
			_locked = _locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			_fired = firing = true;
			for (; queue.length; firingIndex = -1) {
				memory = queue.shift();
				while (++firingIndex < list.length) {

					// Run callback and check for early termination
					if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if (!options.memory) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if (_locked) {

				// Keep an empty list if we have data for future add calls
				if (memory) {
					list = [];

					// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},


		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function add() {
				if (list) {

					// If we have memory from a past run, we should fire after adding
					if (memory && !firing) {
						firingIndex = list.length - 1;
						queue.push(memory);
					}

					(function add(args) {
						jQuery.each(args, function (_, arg) {
							if (isFunction(arg)) {
								if (!options.unique || !self.has(arg)) {
									list.push(arg);
								}
							} else if (arg && arg.length && toType(arg) !== "string") {

								// Inspect recursively
								add(arg);
							}
						});
					})(arguments);

					if (memory && !firing) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function remove() {
				jQuery.each(arguments, function (_, arg) {
					var index;
					while ((index = jQuery.inArray(arg, list, index)) > -1) {
						list.splice(index, 1);

						// Handle firing indexes
						if (index <= firingIndex) {
							firingIndex--;
						}
					}
				});
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function has(fn) {
				return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function empty() {
				if (list) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function disable() {
				_locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function disabled() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function lock() {
				_locked = queue = [];
				if (!memory && !firing) {
					list = memory = "";
				}
				return this;
			},
			locked: function locked() {
				return !!_locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function fireWith(context, args) {
				if (!_locked) {
					args = args || [];
					args = [context, args.slice ? args.slice() : args];
					queue.push(args);
					if (!firing) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function fire() {
				self.fireWith(this, arguments);
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function fired() {
				return !!_fired;
			}
		};

		return self;
	};

	function Identity(v) {
		return v;
	}
	function Thrower(ex) {
		throw ex;
	}

	function adoptValue(value, resolve, reject, noValue) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if (value && isFunction(method = value.promise)) {
				method.call(value).done(resolve).fail(reject);

				// Other thenables
			} else if (value && isFunction(method = value.then)) {
				method.call(value, resolve, reject);

				// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply(undefined, [value].slice(noValue));
			}

			// For Promises/A+, convert exceptions into rejections
			// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
			// Deferred#then to conditionally suppress rejection.
		} catch (value) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply(undefined, [value]);
		}
	}

	jQuery.extend({

		Deferred: function Deferred(func) {
			var tuples = [

			// action, add listener, callbacks,
			// ... .then handlers, argument index, [final state]
			["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
			    _state = "pending",
			    _promise = {
				state: function state() {
					return _state;
				},
				always: function always() {
					deferred.done(arguments).fail(arguments);
					return this;
				},
				"catch": function _catch(fn) {
					return _promise.then(null, fn);
				},

				// Keep pipe for back-compat
				pipe: function pipe() /* fnDone, fnFail, fnProgress */{
					var fns = arguments;

					return jQuery.Deferred(function (newDefer) {
						jQuery.each(tuples, function (i, tuple) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[tuple[1]](function () {
								var returned = fn && fn.apply(this, arguments);
								if (returned && isFunction(returned.promise)) {
									returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
								} else {
									newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
								}
							});
						});
						fns = null;
					}).promise();
				},
				then: function then(onFulfilled, onRejected, onProgress) {
					var maxDepth = 0;
					function resolve(depth, deferred, handler, special) {
						return function () {
							var that = this,
							    args = arguments,
							    mightThrow = function mightThrow() {
								var returned, then;

								// Support: Promises/A+ section 2.3.3.3.3
								// https://promisesaplus.com/#point-59
								// Ignore double-resolution attempts
								if (depth < maxDepth) {
									return;
								}

								returned = handler.apply(that, args);

								// Support: Promises/A+ section 2.3.1
								// https://promisesaplus.com/#point-48
								if (returned === deferred.promise()) {
									throw new TypeError("Thenable self-resolution");
								}

								// Support: Promises/A+ sections 2.3.3.1, 3.5
								// https://promisesaplus.com/#point-54
								// https://promisesaplus.com/#point-75
								// Retrieve `then` only once
								then = returned && (

								// Support: Promises/A+ section 2.3.4
								// https://promisesaplus.com/#point-64
								// Only check objects and functions for thenability
								typeof returned === "object" || typeof returned === "function") && returned.then;

								// Handle a returned thenable
								if (isFunction(then)) {

									// Special processors (notify) just wait for resolution
									if (special) {
										then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

										// Normal processors (resolve) also hook into progress
									} else {

										// ...and disregard older resolution values
										maxDepth++;

										then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
									}

									// Handle all other returned values
								} else {

									// Only substitute handlers pass on context
									// and multiple values (non-spec behavior)
									if (handler !== Identity) {
										that = undefined;
										args = [returned];
									}

									// Process the value(s)
									// Default process is resolve
									(special || deferred.resolveWith)(that, args);
								}
							},


							// Only normal processors (resolve) catch and reject exceptions
							process = special ? mightThrow : function () {
								try {
									mightThrow();
								} catch (e) {

									if (jQuery.Deferred.exceptionHook) {
										jQuery.Deferred.exceptionHook(e, process.stackTrace);
									}

									// Support: Promises/A+ section 2.3.3.3.4.1
									// https://promisesaplus.com/#point-61
									// Ignore post-resolution exceptions
									if (depth + 1 >= maxDepth) {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if (handler !== Thrower) {
											that = undefined;
											args = [e];
										}

										deferred.rejectWith(that, args);
									}
								}
							};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if (depth) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if (jQuery.Deferred.getStackHook) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout(process);
							}
						};
					}

					return jQuery.Deferred(function (newDefer) {

						// progress_handlers.add( ... )
						tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

						// fulfilled_handlers.add( ... )
						tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

						// rejected_handlers.add( ... )
						tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
					}).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function promise(obj) {
					return obj != null ? jQuery.extend(obj, _promise) : _promise;
				}
			},
			    deferred = {};

			// Add list-specific methods
			jQuery.each(tuples, function (i, tuple) {
				var list = tuple[2],
				    stateString = tuple[5];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				_promise[tuple[1]] = list.add;

				// Handle state
				if (stateString) {
					list.add(function () {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						_state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[3 - i][2].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[3 - i][3].disable,

					// progress_callbacks.lock
					tuples[0][2].lock,

					// progress_handlers.lock
					tuples[0][3].lock);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add(tuple[3].fire);

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[tuple[0]] = function () {
					deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[tuple[0] + "With"] = list.fireWith;
			});

			// Make the deferred a promise
			_promise.promise(deferred);

			// Call given func if any
			if (func) {
				func.call(deferred, deferred);
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function when(singleValue) {
			var

			// count of uncompleted subordinates
			remaining = arguments.length,


			// count of unprocessed arguments
			i = remaining,


			// subordinate fulfillment data
			resolveContexts = Array(i),
			    resolveValues = _slice.call(arguments),


			// the master Deferred
			master = jQuery.Deferred(),


			// subordinate callback factory
			updateFunc = function updateFunc(i) {
				return function (value) {
					resolveContexts[i] = this;
					resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
					if (! --remaining) {
						master.resolveWith(resolveContexts, resolveValues);
					}
				};
			};

			// Single- and empty arguments are adopted like Promise.resolve
			if (remaining <= 1) {
				adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {

					return master.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while (i--) {
				adoptValue(resolveValues[i], updateFunc(i), master.reject);
			}

			return master.promise();
		}
	});

	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

	jQuery.Deferred.exceptionHook = function (error, stack) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
			window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
		}
	};

	jQuery.readyException = function (error) {
		window.setTimeout(function () {
			throw error;
		});
	};

	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function (fn) {

		readyList.then(fn)

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch(function (error) {
			jQuery.readyException(error);
		});

		return this;
	};

	jQuery.extend({

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function ready(wait) {

			// Abort if there are pending holds or we're already ready
			if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if (wait !== true && --jQuery.readyWait > 0) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith(document, [jQuery]);
		}
	});

	jQuery.ready.then = readyList.then;

	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener("DOMContentLoaded", completed);
		window.removeEventListener("load", completed);
		jQuery.ready();
	}

	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout(jQuery.ready);
	} else {

		// Use the handy event callback
		document.addEventListener("DOMContentLoaded", completed);

		// A fallback to window.onload, that will always work
		window.addEventListener("load", completed);
	}

	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
		var i = 0,
		    len = elems.length,
		    bulk = key == null;

		// Sets many values
		if (toType(key) === "object") {
			chainable = true;
			for (i in key) {
				access(elems, fn, i, key[i], true, emptyGet, raw);
			}

			// Sets one value
		} else if (value !== undefined) {
			chainable = true;

			if (!isFunction(value)) {
				raw = true;
			}

			if (bulk) {

				// Bulk operations run against the entire set
				if (raw) {
					fn.call(elems, value);
					fn = null;

					// ...except when executing function values
				} else {
					bulk = fn;
					fn = function fn(elem, key, value) {
						return bulk.call(jQuery(elem), value);
					};
				}
			}

			if (fn) {
				for (; i < len; i++) {
					fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
				}
			}
		}

		if (chainable) {
			return elems;
		}

		// Gets
		if (bulk) {
			return fn.call(elems);
		}

		return len ? fn(elems[0], key) : emptyGet;
	};

	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
	    rdashAlpha = /-([a-z])/g;

	// Used by camelCase as callback to replace()
	function fcamelCase(all, letter) {
		return letter.toUpperCase();
	}

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase(string) {
		return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
	}
	var acceptData = function acceptData(owner) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
	};

	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function cache(owner) {

			// Check if the owner object already has a cache
			var value = owner[this.expando];

			// If not, create one
			if (!value) {
				value = {};

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if (acceptData(owner)) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if (owner.nodeType) {
						owner[this.expando] = value;

						// Otherwise secure it in a non-enumerable property
						// configurable must be true to allow the property to be
						// deleted when data is removed
					} else {
						Object.defineProperty(owner, this.expando, {
							value: value,
							configurable: true
						});
					}
				}
			}

			return value;
		},
		set: function set(owner, data, value) {
			var prop,
			    cache = this.cache(owner);

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if (typeof data === "string") {
				cache[camelCase(data)] = value;

				// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for (prop in data) {
					cache[camelCase(prop)] = data[prop];
				}
			}
			return cache;
		},
		get: function get(owner, key) {
			return key === undefined ? this.cache(owner) :

			// Always use camelCase key (gh-2257)
			owner[this.expando] && owner[this.expando][camelCase(key)];
		},
		access: function access(owner, key, value) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if (key === undefined || key && typeof key === "string" && value === undefined) {

				return this.get(owner, key);
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set(owner, key, value);

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function remove(owner, key) {
			var i,
			    cache = owner[this.expando];

			if (cache === undefined) {
				return;
			}

			if (key !== undefined) {

				// Support array or space separated string of keys
				if (Array.isArray(key)) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map(camelCase);
				} else {
					key = camelCase(key);

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
				}

				i = key.length;

				while (i--) {
					delete cache[key[i]];
				}
			}

			// Remove the expando if there's no more data
			if (key === undefined || jQuery.isEmptyObject(cache)) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if (owner.nodeType) {
					owner[this.expando] = undefined;
				} else {
					delete owner[this.expando];
				}
			}
		},
		hasData: function hasData(owner) {
			var cache = owner[this.expando];
			return cache !== undefined && !jQuery.isEmptyObject(cache);
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();

	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	    rmultiDash = /[A-Z]/g;

	function getData(data) {
		if (data === "true") {
			return true;
		}

		if (data === "false") {
			return false;
		}

		if (data === "null") {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if (data === +data + "") {
			return +data;
		}

		if (rbrace.test(data)) {
			return JSON.parse(data);
		}

		return data;
	}

	function dataAttr(elem, key, data) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if (data === undefined && elem.nodeType === 1) {
			name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
			data = elem.getAttribute(name);

			if (typeof data === "string") {
				try {
					data = getData(data);
				} catch (e) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set(elem, key, data);
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend({
		hasData: function hasData(elem) {
			return dataUser.hasData(elem) || dataPriv.hasData(elem);
		},

		data: function data(elem, name, _data) {
			return dataUser.access(elem, name, _data);
		},

		removeData: function removeData(elem, name) {
			dataUser.remove(elem, name);
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function _data(elem, name, data) {
			return dataPriv.access(elem, name, data);
		},

		_removeData: function _removeData(elem, name) {
			dataPriv.remove(elem, name);
		}
	});

	jQuery.fn.extend({
		data: function data(key, value) {
			var i,
			    name,
			    data,
			    elem = this[0],
			    attrs = elem && elem.attributes;

			// Gets all values
			if (key === undefined) {
				if (this.length) {
					data = dataUser.get(elem);

					if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
						i = attrs.length;
						while (i--) {

							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if (attrs[i]) {
								name = attrs[i].name;
								if (name.indexOf("data-") === 0) {
									name = camelCase(name.slice(5));
									dataAttr(elem, name, data[name]);
								}
							}
						}
						dataPriv.set(elem, "hasDataAttrs", true);
					}
				}

				return data;
			}

			// Sets multiple values
			if (typeof key === "object") {
				return this.each(function () {
					dataUser.set(this, key);
				});
			}

			return access(this, function (value) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if (elem && value === undefined) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get(elem, key);
					if (data !== undefined) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr(elem, key);
					if (data !== undefined) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each(function () {

					// We always store the camelCased key
					dataUser.set(this, key, value);
				});
			}, null, value, arguments.length > 1, null, true);
		},

		removeData: function removeData(key) {
			return this.each(function () {
				dataUser.remove(this, key);
			});
		}
	});

	jQuery.extend({
		queue: function queue(elem, type, data) {
			var queue;

			if (elem) {
				type = (type || "fx") + "queue";
				queue = dataPriv.get(elem, type);

				// Speed up dequeue by getting out quickly if this is just a lookup
				if (data) {
					if (!queue || Array.isArray(data)) {
						queue = dataPriv.access(elem, type, jQuery.makeArray(data));
					} else {
						queue.push(data);
					}
				}
				return queue || [];
			}
		},

		dequeue: function dequeue(elem, type) {
			type = type || "fx";

			var queue = jQuery.queue(elem, type),
			    startLength = queue.length,
			    fn = queue.shift(),
			    hooks = jQuery._queueHooks(elem, type),
			    next = function next() {
				jQuery.dequeue(elem, type);
			};

			// If the fx queue is dequeued, always remove the progress sentinel
			if (fn === "inprogress") {
				fn = queue.shift();
				startLength--;
			}

			if (fn) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if (type === "fx") {
					queue.unshift("inprogress");
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call(elem, next, hooks);
			}

			if (!startLength && hooks) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function _queueHooks(elem, type) {
			var key = type + "queueHooks";
			return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
				empty: jQuery.Callbacks("once memory").add(function () {
					dataPriv.remove(elem, [type + "queue", key]);
				})
			});
		}
	});

	jQuery.fn.extend({
		queue: function queue(type, data) {
			var setter = 2;

			if (typeof type !== "string") {
				data = type;
				type = "fx";
				setter--;
			}

			if (arguments.length < setter) {
				return jQuery.queue(this[0], type);
			}

			return data === undefined ? this : this.each(function () {
				var queue = jQuery.queue(this, type, data);

				// Ensure a hooks for this queue
				jQuery._queueHooks(this, type);

				if (type === "fx" && queue[0] !== "inprogress") {
					jQuery.dequeue(this, type);
				}
			});
		},
		dequeue: function dequeue(type) {
			return this.each(function () {
				jQuery.dequeue(this, type);
			});
		},
		clearQueue: function clearQueue(type) {
			return this.queue(type || "fx", []);
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function promise(type, obj) {
			var tmp,
			    count = 1,
			    defer = jQuery.Deferred(),
			    elements = this,
			    i = this.length,
			    resolve = function resolve() {
				if (! --count) {
					defer.resolveWith(elements, [elements]);
				}
			};

			if (typeof type !== "string") {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while (i--) {
				tmp = dataPriv.get(elements[i], type + "queueHooks");
				if (tmp && tmp.empty) {
					count++;
					tmp.empty.add(resolve);
				}
			}
			resolve();
			return defer.promise(obj);
		}
	});
	var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

	var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");

	var cssExpand = ["Top", "Right", "Bottom", "Left"];

	var documentElement = document.documentElement;

	var isAttached = function isAttached(elem) {
		return jQuery.contains(elem.ownerDocument, elem);
	},
	    composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if (documentElement.getRootNode) {
		isAttached = function isAttached(elem) {
			return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
		};
	}
	var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" || elem.style.display === "" &&

		// Otherwise, check computed style
		// Support: Firefox <=43 - 45
		// Disconnected elements can have computed display: none, so first confirm that elem is
		// in the document.
		isAttached(elem) && jQuery.css(elem, "display") === "none";
	};

	var swap = function swap(elem, options, callback, args) {
		var ret,
		    name,
		    old = {};

		// Remember the old values, and insert the new ones
		for (name in options) {
			old[name] = elem.style[name];
			elem.style[name] = options[name];
		}

		ret = callback.apply(elem, args || []);

		// Revert the old values
		for (name in options) {
			elem.style[name] = old[name];
		}

		return ret;
	};

	function adjustCSS(elem, prop, valueParts, tween) {
		var adjusted,
		    scale,
		    maxIterations = 20,
		    currentValue = tween ? function () {
			return tween.cur();
		} : function () {
			return jQuery.css(elem, prop, "");
		},
		    initial = currentValue(),
		    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),


		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));

		if (initialInUnit && initialInUnit[3] !== unit) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[3];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while (maxIterations--) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style(elem, prop, initialInUnit + unit);
				if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
			}

			initialInUnit = initialInUnit * 2;
			jQuery.style(elem, prop, initialInUnit + unit);

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if (valueParts) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
			if (tween) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}

	var defaultDisplayMap = {};

	function getDefaultDisplay(elem) {
		var temp,
		    doc = elem.ownerDocument,
		    nodeName = elem.nodeName,
		    display = defaultDisplayMap[nodeName];

		if (display) {
			return display;
		}

		temp = doc.body.appendChild(doc.createElement(nodeName));
		display = jQuery.css(temp, "display");

		temp.parentNode.removeChild(temp);

		if (display === "none") {
			display = "block";
		}
		defaultDisplayMap[nodeName] = display;

		return display;
	}

	function showHide(elements, show) {
		var display,
		    elem,
		    values = [],
		    index = 0,
		    length = elements.length;

		// Determine new display value for elements that need to change
		for (; index < length; index++) {
			elem = elements[index];
			if (!elem.style) {
				continue;
			}

			display = elem.style.display;
			if (show) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if (display === "none") {
					values[index] = dataPriv.get(elem, "display") || null;
					if (!values[index]) {
						elem.style.display = "";
					}
				}
				if (elem.style.display === "" && isHiddenWithinTree(elem)) {
					values[index] = getDefaultDisplay(elem);
				}
			} else {
				if (display !== "none") {
					values[index] = "none";

					// Remember what we're overwriting
					dataPriv.set(elem, "display", display);
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for (index = 0; index < length; index++) {
			if (values[index] != null) {
				elements[index].style.display = values[index];
			}
		}

		return elements;
	}

	jQuery.fn.extend({
		show: function show() {
			return showHide(this, true);
		},
		hide: function hide() {
			return showHide(this);
		},
		toggle: function toggle(state) {
			if (typeof state === "boolean") {
				return state ? this.show() : this.hide();
			}

			return this.each(function () {
				if (isHiddenWithinTree(this)) {
					jQuery(this).show();
				} else {
					jQuery(this).hide();
				}
			});
		}
	});
	var rcheckableType = /^(?:checkbox|radio)$/i;

	var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

	var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {

		// Support: IE <=9 only
		option: [1, "<select multiple='multiple'>", "</select>"],

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [1, "<table>", "</table>"],
		col: [2, "<table><colgroup>", "</colgroup></table>"],
		tr: [2, "<table><tbody>", "</tbody></table>"],
		td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

		_default: [0, "", ""]
	};

	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	function getAll(context, tag) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;

		if (typeof context.getElementsByTagName !== "undefined") {
			ret = context.getElementsByTagName(tag || "*");
		} else if (typeof context.querySelectorAll !== "undefined") {
			ret = context.querySelectorAll(tag || "*");
		} else {
			ret = [];
		}

		if (tag === undefined || tag && nodeName(context, tag)) {
			return jQuery.merge([context], ret);
		}

		return ret;
	}

	// Mark scripts as having already been evaluated
	function setGlobalEval(elems, refElements) {
		var i = 0,
		    l = elems.length;

		for (; i < l; i++) {
			dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
		}
	}

	var rhtml = /<|&#?\w+;/;

	function buildFragment(elems, context, scripts, selection, ignored) {
		var elem,
		    tmp,
		    tag,
		    wrap,
		    attached,
		    j,
		    fragment = context.createDocumentFragment(),
		    nodes = [],
		    i = 0,
		    l = elems.length;

		for (; i < l; i++) {
			elem = elems[i];

			if (elem || elem === 0) {

				// Add nodes directly
				if (toType(elem) === "object") {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

					// Convert non-html into a text node
				} else if (!rhtml.test(elem)) {
					nodes.push(context.createTextNode(elem));

					// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild(context.createElement("div"));

					// Deserialize a standard representation
					tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
					wrap = wrapMap[tag] || wrapMap._default;
					tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

					// Descend through wrappers to the right content
					j = wrap[0];
					while (j--) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge(nodes, tmp.childNodes);

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while (elem = nodes[i++]) {

			// Skip elements already in the context collection (trac-4087)
			if (selection && jQuery.inArray(elem, selection) > -1) {
				if (ignored) {
					ignored.push(elem);
				}
				continue;
			}

			attached = isAttached(elem);

			// Append to fragment
			tmp = getAll(fragment.appendChild(elem), "script");

			// Preserve script evaluation history
			if (attached) {
				setGlobalEval(tmp);
			}

			// Capture executables
			if (scripts) {
				j = 0;
				while (elem = tmp[j++]) {
					if (rscriptType.test(elem.type || "")) {
						scripts.push(elem);
					}
				}
			}
		}

		return fragment;
	}

	(function () {
		var fragment = document.createDocumentFragment(),
		    div = fragment.appendChild(document.createElement("div")),
		    input = document.createElement("input");

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute("type", "radio");
		input.setAttribute("checked", "checked");
		input.setAttribute("name", "t");

		div.appendChild(input);

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
	})();

	var rkeyEvent = /^key/,
	    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync(elem, type) {
		return elem === safeActiveElement() === (type === "focus");
	}

	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch (err) {}
	}

	function _on(elem, types, selector, data, fn, one) {
		var origFn, type;

		// Types can be a map of types/handlers
		if (typeof types === "object") {

			// ( types-Object, selector, data )
			if (typeof selector !== "string") {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for (type in types) {
				_on(elem, type, selector, data, types[type], one);
			}
			return elem;
		}

		if (data == null && fn == null) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if (fn == null) {
			if (typeof selector === "string") {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if (fn === false) {
			fn = returnFalse;
		} else if (!fn) {
			return elem;
		}

		if (one === 1) {
			origFn = fn;
			fn = function fn(event) {

				// Can use an empty set, since event contains the info
				jQuery().off(event);
				return origFn.apply(this, arguments);
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
		}
		return elem.each(function () {
			jQuery.event.add(this, types, fn, data, selector);
		});
	}

	/*
  * Helper functions for managing events -- not part of the public interface.
  * Props to Dean Edwards' addEvent library for many of the ideas.
  */
	jQuery.event = {

		global: {},

		add: function add(elem, types, handler, data, selector) {

			var handleObjIn,
			    eventHandle,
			    tmp,
			    events,
			    t,
			    handleObj,
			    special,
			    handlers,
			    type,
			    namespaces,
			    origType,
			    elemData = dataPriv.get(elem);

			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if (!elemData) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if (handler.handler) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if (selector) {
				jQuery.find.matchesSelector(documentElement, selector);
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if (!handler.guid) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if (!(events = elemData.events)) {
				events = elemData.events = {};
			}
			if (!(eventHandle = elemData.handle)) {
				eventHandle = elemData.handle = function (e) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = (types || "").match(rnothtmlwhite) || [""];
			t = types.length;
			while (t--) {
				tmp = rtypenamespace.exec(types[t]) || [];
				type = origType = tmp[1];
				namespaces = (tmp[2] || "").split(".").sort();

				// There *must* be a type, no attaching namespace-only handlers
				if (!type) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[type] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = (selector ? special.delegateType : special.bindType) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[type] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test(selector),
					namespace: namespaces.join(".")
				}, handleObjIn);

				// Init the event handler queue if we're the first
				if (!(handlers = events[type])) {
					handlers = events[type] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {

						if (elem.addEventListener) {
							elem.addEventListener(type, eventHandle);
						}
					}
				}

				if (special.add) {
					special.add.call(elem, handleObj);

					if (!handleObj.handler.guid) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if (selector) {
					handlers.splice(handlers.delegateCount++, 0, handleObj);
				} else {
					handlers.push(handleObj);
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[type] = true;
			}
		},

		// Detach an event or set of events from an element
		remove: function remove(elem, types, handler, selector, mappedTypes) {

			var j,
			    origCount,
			    tmp,
			    events,
			    t,
			    handleObj,
			    special,
			    handlers,
			    type,
			    namespaces,
			    origType,
			    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

			if (!elemData || !(events = elemData.events)) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = (types || "").match(rnothtmlwhite) || [""];
			t = types.length;
			while (t--) {
				tmp = rtypenamespace.exec(types[t]) || [];
				type = origType = tmp[1];
				namespaces = (tmp[2] || "").split(".").sort();

				// Unbind all events (on this namespace, if provided) for the element
				if (!type) {
					for (type in events) {
						jQuery.event.remove(elem, type + types[t], handler, selector, true);
					}
					continue;
				}

				special = jQuery.event.special[type] || {};
				type = (selector ? special.delegateType : special.bindType) || type;
				handlers = events[type] || [];
				tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

				// Remove matching events
				origCount = j = handlers.length;
				while (j--) {
					handleObj = handlers[j];

					if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
						handlers.splice(j, 1);

						if (handleObj.selector) {
							handlers.delegateCount--;
						}
						if (special.remove) {
							special.remove.call(elem, handleObj);
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if (origCount && !handlers.length) {
					if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {

						jQuery.removeEvent(elem, type, elemData.handle);
					}

					delete events[type];
				}
			}

			// Remove data and the expando if it's no longer used
			if (jQuery.isEmptyObject(events)) {
				dataPriv.remove(elem, "handle events");
			}
		},

		dispatch: function dispatch(nativeEvent) {

			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix(nativeEvent);

			var i,
			    j,
			    ret,
			    matched,
			    handleObj,
			    handlerQueue,
			    args = new Array(arguments.length),
			    handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
			    special = jQuery.event.special[event.type] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;

			for (i = 1; i < arguments.length; i++) {
				args[i] = arguments[i];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if (special.preDispatch && special.preDispatch.call(this, event) === false) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call(this, event, handlers);

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
				event.currentTarget = matched.elem;

				j = 0;
				while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {

					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

						if (ret !== undefined) {
							if ((event.result = ret) === false) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if (special.postDispatch) {
				special.postDispatch.call(this, event);
			}

			return event.result;
		},

		handlers: function handlers(event, _handlers) {
			var i,
			    handleObj,
			    sel,
			    matchedHandlers,
			    matchedSelectors,
			    handlerQueue = [],
			    delegateCount = _handlers.delegateCount,
			    cur = event.target;

			// Find delegate handlers
			if (delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!(event.type === "click" && event.button >= 1)) {

				for (; cur !== this; cur = cur.parentNode || this) {

					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
						matchedHandlers = [];
						matchedSelectors = {};
						for (i = 0; i < delegateCount; i++) {
							handleObj = _handlers[i];

							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";

							if (matchedSelectors[sel] === undefined) {
								matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
							}
							if (matchedSelectors[sel]) {
								matchedHandlers.push(handleObj);
							}
						}
						if (matchedHandlers.length) {
							handlerQueue.push({ elem: cur, handlers: matchedHandlers });
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if (delegateCount < _handlers.length) {
				handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
			}

			return handlerQueue;
		},

		addProp: function addProp(name, hook) {
			Object.defineProperty(jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction(hook) ? function () {
					if (this.originalEvent) {
						return hook(this.originalEvent);
					}
				} : function () {
					if (this.originalEvent) {
						return this.originalEvent[name];
					}
				},

				set: function set(value) {
					Object.defineProperty(this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					});
				}
			});
		},

		fix: function fix(originalEvent) {
			return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {

				// Utilize native event to ensure correct state for checkable inputs
				setup: function setup(data) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Claim the first handler
					if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

						// dataPriv.set( el, "click", ... )
						leverageNative(el, "click", returnTrue);
					}

					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function trigger(data) {

					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;

					// Force setup before triggering a click
					if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

						leverageNative(el, "click");
					}

					// Return non-false to allow normal event-path propagation
					return true;
				},

				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function _default(event) {
					var target = event.target;
					return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
				}
			},

			beforeunload: {
				postDispatch: function postDispatch(event) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if (event.result !== undefined && event.originalEvent) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative(el, type, expectSync) {

		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if (!expectSync) {
			if (dataPriv.get(el, type) === undefined) {
				jQuery.event.add(el, type, returnTrue);
			}
			return;
		}

		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set(el, type, false);
		jQuery.event.add(el, type, {
			namespace: false,
			handler: function handler(event) {
				var notAsync,
				    result,
				    saved = dataPriv.get(this, type);

				if (event.isTrigger & 1 && this[type]) {

					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if (!saved.length) {

						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = _slice.call(arguments);
						dataPriv.set(this, type, saved);

						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync(this, type);
						this[type]();
						result = dataPriv.get(this, type);
						if (saved !== result || notAsync) {
							dataPriv.set(this, type, false);
						} else {
							result = {};
						}
						if (saved !== result) {

							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}

						// If this is an inner synthetic event for an event with a bubbling surrogate
						// (focus or blur), assume that the surrogate already propagated from triggering the
						// native event and prevent that from happening again here.
						// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
						// bubbling surrogate propagates *after* the non-bubbling base), but that seems
						// less bad than duplication.
					} else if ((jQuery.event.special[type] || {}).delegateType) {
						event.stopPropagation();
					}

					// If this is a native event triggered above, everything is now in order
					// Fire an inner synthetic event with the original arguments
				} else if (saved.length) {

					// ...and capture the result
					dataPriv.set(this, type, {
						value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend(saved[0], jQuery.Event.prototype), saved.slice(1), this)
					});

					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		});
	}

	jQuery.removeEvent = function (elem, type, handle) {

		// This "if" is needed for plain objects
		if (elem.removeEventListener) {
			elem.removeEventListener(type, handle);
		}
	};

	jQuery.Event = function (src, props) {

		// Allow instantiation without the 'new' keyword
		if (!(this instanceof jQuery.Event)) {
			return new jQuery.Event(src, props);
		}

		// Event object
		if (src && src.type) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&

			// Support: Android <=2.3 only
			src.returnValue === false ? returnTrue : returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

			// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if (props) {
			jQuery.extend(this, props);
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[jQuery.expando] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function preventDefault() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if (e && !this.isSimulated) {
				e.preventDefault();
			}
		},
		stopPropagation: function stopPropagation() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if (e && !this.isSimulated) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function stopImmediatePropagation() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if (e && !this.isSimulated) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each({
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,

		which: function which(event) {
			var button = event.button;

			// Add which for key events
			if (event.which == null && rkeyEvent.test(event.type)) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
				if (button & 1) {
					return 1;
				}

				if (button & 2) {
					return 3;
				}

				if (button & 4) {
					return 2;
				}

				return 0;
			}

			return event.which;
		}
	}, jQuery.event.addProp);

	jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {
		jQuery.event.special[type] = {

			// Utilize native event if possible so blur/focus sequence is correct
			setup: function setup() {

				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative(this, type, expectSync);

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function trigger() {

				// Force setup before trigger
				leverageNative(this, type);

				// Return non-false to allow normal event-path propagation
				return true;
			},

			delegateType: delegateType
		};
	});

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function (orig, fix) {
		jQuery.event.special[orig] = {
			delegateType: fix,
			bindType: fix,

			handle: function handle(event) {
				var ret,
				    target = this,
				    related = event.relatedTarget,
				    handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if (!related || related !== target && !jQuery.contains(target, related)) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply(this, arguments);
					event.type = fix;
				}
				return ret;
			}
		};
	});

	jQuery.fn.extend({

		on: function on(types, selector, data, fn) {
			return _on(this, types, selector, data, fn);
		},
		one: function one(types, selector, data, fn) {
			return _on(this, types, selector, data, fn, 1);
		},
		off: function off(types, selector, fn) {
			var handleObj, type;
			if (types && types.preventDefault && types.handleObj) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
				return this;
			}
			if (typeof types === "object") {

				// ( types-object [, selector] )
				for (type in types) {
					this.off(type, selector, types[type]);
				}
				return this;
			}
			if (selector === false || typeof selector === "function") {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if (fn === false) {
				fn = returnFalse;
			}
			return this.each(function () {
				jQuery.event.remove(this, types, fn, selector);
			});
		}
	});

	var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,


	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,


	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget(elem, content) {
		if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

			return jQuery(elem).children("tbody")[0] || elem;
		}

		return elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript(elem) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript(elem) {
		if ((elem.type || "").slice(0, 5) === "true/") {
			elem.type = elem.type.slice(5);
		} else {
			elem.removeAttribute("type");
		}

		return elem;
	}

	function cloneCopyEvent(src, dest) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

		if (dest.nodeType !== 1) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if (dataPriv.hasData(src)) {
			pdataOld = dataPriv.access(src);
			pdataCur = dataPriv.set(dest, pdataOld);
			events = pdataOld.events;

			if (events) {
				delete pdataCur.handle;
				pdataCur.events = {};

				for (type in events) {
					for (i = 0, l = events[type].length; i < l; i++) {
						jQuery.event.add(dest, type, events[type][i]);
					}
				}
			}
		}

		// 2. Copy user data
		if (dataUser.hasData(src)) {
			udataOld = dataUser.access(src);
			udataCur = jQuery.extend({}, udataOld);

			dataUser.set(dest, udataCur);
		}
	}

	// Fix IE bugs, see support tests
	function fixInput(src, dest) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if (nodeName === "input" && rcheckableType.test(src.type)) {
			dest.checked = src.checked;

			// Fails to return the selected option to the default selected state when cloning options
		} else if (nodeName === "input" || nodeName === "textarea") {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip(collection, args, callback, ignored) {

		// Flatten any nested arrays
		args = concat.apply([], args);

		var fragment,
		    first,
		    scripts,
		    hasScripts,
		    node,
		    doc,
		    i = 0,
		    l = collection.length,
		    iNoClone = l - 1,
		    value = args[0],
		    valueIsFunction = isFunction(value);

		// We can't cloneNode fragments that contain checked, in WebKit
		if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
			return collection.each(function (index) {
				var self = collection.eq(index);
				if (valueIsFunction) {
					args[0] = value.call(this, index, self.html());
				}
				domManip(self, args, callback, ignored);
			});
		}

		if (l) {
			fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
			first = fragment.firstChild;

			if (fragment.childNodes.length === 1) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if (first || ignored) {
				scripts = jQuery.map(getAll(fragment, "script"), disableScript);
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for (; i < l; i++) {
					node = fragment;

					if (i !== iNoClone) {
						node = jQuery.clone(node, true, true);

						// Keep references to cloned scripts for later restoration
						if (hasScripts) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge(scripts, getAll(node, "script"));
						}
					}

					callback.call(collection[i], node, i);
				}

				if (hasScripts) {
					doc = scripts[scripts.length - 1].ownerDocument;

					// Reenable scripts
					jQuery.map(scripts, restoreScript);

					// Evaluate executable scripts on first document insertion
					for (i = 0; i < hasScripts; i++) {
						node = scripts[i];
						if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {

							if (node.src && (node.type || "").toLowerCase() !== "module") {

								// Optional AJAX dependency, but won't run scripts if not present
								if (jQuery._evalUrl && !node.noModule) {
									jQuery._evalUrl(node.src, {
										nonce: node.nonce || node.getAttribute("nonce")
									});
								}
							} else {
								DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function _remove(elem, selector, keepData) {
		var node,
		    nodes = selector ? jQuery.filter(selector, elem) : elem,
		    i = 0;

		for (; (node = nodes[i]) != null; i++) {
			if (!keepData && node.nodeType === 1) {
				jQuery.cleanData(getAll(node));
			}

			if (node.parentNode) {
				if (keepData && isAttached(node)) {
					setGlobalEval(getAll(node, "script"));
				}
				node.parentNode.removeChild(node);
			}
		}

		return elem;
	}

	jQuery.extend({
		htmlPrefilter: function htmlPrefilter(html) {
			return html.replace(rxhtmlTag, "<$1></$2>");
		},

		clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
			var i,
			    l,
			    srcElements,
			    destElements,
			    clone = elem.cloneNode(true),
			    inPage = isAttached(elem);

			// Fix IE cloning issues
			if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {

				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll(clone);
				srcElements = getAll(elem);

				for (i = 0, l = srcElements.length; i < l; i++) {
					fixInput(srcElements[i], destElements[i]);
				}
			}

			// Copy the events from the original to the clone
			if (dataAndEvents) {
				if (deepDataAndEvents) {
					srcElements = srcElements || getAll(elem);
					destElements = destElements || getAll(clone);

					for (i = 0, l = srcElements.length; i < l; i++) {
						cloneCopyEvent(srcElements[i], destElements[i]);
					}
				} else {
					cloneCopyEvent(elem, clone);
				}
			}

			// Preserve script evaluation history
			destElements = getAll(clone, "script");
			if (destElements.length > 0) {
				setGlobalEval(destElements, !inPage && getAll(elem, "script"));
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function cleanData(elems) {
			var data,
			    elem,
			    type,
			    special = jQuery.event.special,
			    i = 0;

			for (; (elem = elems[i]) !== undefined; i++) {
				if (acceptData(elem)) {
					if (data = elem[dataPriv.expando]) {
						if (data.events) {
							for (type in data.events) {
								if (special[type]) {
									jQuery.event.remove(elem, type);

									// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent(elem, type, data.handle);
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[dataPriv.expando] = undefined;
					}
					if (elem[dataUser.expando]) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[dataUser.expando] = undefined;
					}
				}
			}
		}
	});

	jQuery.fn.extend({
		detach: function detach(selector) {
			return _remove(this, selector, true);
		},

		remove: function remove(selector) {
			return _remove(this, selector);
		},

		text: function text(value) {
			return access(this, function (value) {
				return value === undefined ? jQuery.text(this) : this.empty().each(function () {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						this.textContent = value;
					}
				});
			}, null, value, arguments.length);
		},

		append: function append() {
			return domManip(this, arguments, function (elem) {
				if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
					var target = manipulationTarget(this, elem);
					target.appendChild(elem);
				}
			});
		},

		prepend: function prepend() {
			return domManip(this, arguments, function (elem) {
				if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
					var target = manipulationTarget(this, elem);
					target.insertBefore(elem, target.firstChild);
				}
			});
		},

		before: function before() {
			return domManip(this, arguments, function (elem) {
				if (this.parentNode) {
					this.parentNode.insertBefore(elem, this);
				}
			});
		},

		after: function after() {
			return domManip(this, arguments, function (elem) {
				if (this.parentNode) {
					this.parentNode.insertBefore(elem, this.nextSibling);
				}
			});
		},

		empty: function empty() {
			var elem,
			    i = 0;

			for (; (elem = this[i]) != null; i++) {
				if (elem.nodeType === 1) {

					// Prevent memory leaks
					jQuery.cleanData(getAll(elem, false));

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function clone(dataAndEvents, deepDataAndEvents) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map(function () {
				return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
			});
		},

		html: function html(value) {
			return access(this, function (value) {
				var elem = this[0] || {},
				    i = 0,
				    l = this.length;

				if (value === undefined && elem.nodeType === 1) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

					value = jQuery.htmlPrefilter(value);

					try {
						for (; i < l; i++) {
							elem = this[i] || {};

							// Remove element nodes and prevent memory leaks
							if (elem.nodeType === 1) {
								jQuery.cleanData(getAll(elem, false));
								elem.innerHTML = value;
							}
						}

						elem = 0;

						// If using innerHTML throws an exception, use the fallback method
					} catch (e) {}
				}

				if (elem) {
					this.empty().append(value);
				}
			}, null, value, arguments.length);
		},

		replaceWith: function replaceWith() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip(this, arguments, function (elem) {
				var parent = this.parentNode;

				if (jQuery.inArray(this, ignored) < 0) {
					jQuery.cleanData(getAll(this));
					if (parent) {
						parent.replaceChild(elem, this);
					}
				}

				// Force callback invocation
			}, ignored);
		}
	});

	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function (name, original) {
		jQuery.fn[name] = function (selector) {
			var elems,
			    ret = [],
			    insert = jQuery(selector),
			    last = insert.length - 1,
			    i = 0;

			for (; i <= last; i++) {
				elems = i === last ? this : this.clone(true);
				jQuery(insert[i])[original](elems);

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply(ret, elems.get());
			}

			return this.pushStack(ret);
		};
	});
	var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

	var getStyles = function getStyles(elem) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if (!view || !view.opener) {
			view = window;
		}

		return view.getComputedStyle(elem);
	};

	var rboxStyle = new RegExp(cssExpand.join("|"), "i");

	(function () {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if (!div) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
			div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
			documentElement.appendChild(container).appendChild(div);

			var divStyle = window.getComputedStyle(div);
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

			documentElement.removeChild(container);

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures(measure) {
			return Math.round(parseFloat(measure));
		}

		var pixelPositionVal,
		    boxSizingReliableVal,
		    scrollboxSizeVal,
		    pixelBoxStylesVal,
		    reliableMarginLeftVal,
		    container = document.createElement("div"),
		    div = document.createElement("div");

		// Finish early in limited (non-browser) environments
		if (!div.style) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode(true).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend(support, {
			boxSizingReliable: function boxSizingReliable() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function pixelBoxStyles() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function pixelPosition() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function reliableMarginLeft() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function scrollboxSize() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		});
	})();

	function curCSS(elem, name, computed) {
		var width,
		    minWidth,
		    maxWidth,
		    ret,


		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

		computed = computed || getStyles(elem);

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if (computed) {
			ret = computed.getPropertyValue(name) || computed[name];

			if (ret === "" && !isAttached(elem)) {
				ret = jQuery.style(elem, name);
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" : ret;
	}

	function addGetHookIf(conditionFn, hookFn) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function get() {
				if (conditionFn()) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply(this, arguments);
			}
		};
	}

	var cssPrefixes = ["Webkit", "Moz", "ms"],
	    emptyStyle = document.createElement("div").style,
	    vendorProps = {};

	// Return a vendor-prefixed property or undefined
	function vendorPropName(name) {

		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
		    i = cssPrefixes.length;

		while (i--) {
			name = cssPrefixes[i] + capName;
			if (name in emptyStyle) {
				return name;
			}
		}
	}

	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName(name) {
		var final = jQuery.cssProps[name] || vendorProps[name];

		if (final) {
			return final;
		}
		if (name in emptyStyle) {
			return name;
		}
		return vendorProps[name] = vendorPropName(name) || name;
	}

	var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	    rcustomProp = /^--/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	    cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

	function setPositiveNumber(elem, value, subtract) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec(value);
		return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
	}

	function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
		var i = dimension === "width" ? 1 : 0,
		    extra = 0,
		    delta = 0;

		// Adjustment may not be necessary
		if (box === (isBorderBox ? "border" : "content")) {
			return 0;
		}

		for (; i < 4; i += 2) {

			// Both box models exclude margin
			if (box === "margin") {
				delta += jQuery.css(elem, box + cssExpand[i], true, styles);
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if (!isBorderBox) {

				// Add padding
				delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

				// For "border" or "margin", add border
				if (box !== "padding") {
					delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

					// But still keep track of it otherwise
				} else {
					extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
				}

				// If we get here with a border-box (content + padding + border), we're seeking "content" or
				// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if (box === "content") {
					delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
				}

				// For "content" or "padding", subtract border
				if (box !== "margin") {
					delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if (!isBorderBox && computedVal >= 0) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			)) || 0;
		}

		return delta;
	}

	function getWidthOrHeight(elem, dimension, extra) {

		// Start with computed style
		var styles = getStyles(elem),


		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
		    valueIsBorderBox = isBorderBox,
		    val = curCSS(elem, dimension, styles),
		    offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if (rnumnonpx.test(val)) {
			if (!extra) {
				return val;
			}
			val = "auto";
		}

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		// Support: IE 9-11 only
		// Also use offsetWidth/offsetHeight for when box sizing is unreliable
		// We use getClientRects() to check for hidden/disconnected.
		// In those cases, the computed value can be trusted to be border-box
		if ((!support.boxSizingReliable() && isBorderBox || val === "auto" || !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && elem.getClientRects().length) {

			isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if (valueIsBorderBox) {
				val = elem[offsetProp];
			}
		}

		// Normalize "" and auto
		val = parseFloat(val) || 0;

		// Adjust for the element's box model
		return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,

		// Provide the current computed size to request scroll gutter calculation (gh-3589)
		val) + "px";
	}

	jQuery.extend({

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function get(elem, computed) {
					if (computed) {

						// We should always get a number back from opacity
						var ret = curCSS(elem, "opacity");
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function style(elem, name, value, extra) {

			// Don't set styles on text and comment nodes
			if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
				return;
			}

			// Make sure that we're working with the right name
			var ret,
			    type,
			    hooks,
			    origName = camelCase(name),
			    isCustomProp = rcustomProp.test(name),
			    style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if (!isCustomProp) {
				name = finalPropName(origName);
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

			// Check if we're setting a value
			if (value !== undefined) {
				type = typeof value;

				// Convert "+=" or "-=" to relative numbers (#7345)
				if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
					value = adjustCSS(elem, name, ret);

					// Fixes bug #9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (#7116)
				if (value == null || value !== value) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if (type === "number" && !isCustomProp) {
					value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
				}

				// background-* props affect original clone's values
				if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
					style[name] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {

					if (isCustomProp) {
						style.setProperty(name, value);
					} else {
						style[name] = value;
					}
				}
			} else {

				// If a hook was provided get the non-computed value from there
				if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[name];
			}
		},

		css: function css(elem, name, extra, styles) {
			var val,
			    num,
			    hooks,
			    origName = camelCase(name),
			    isCustomProp = rcustomProp.test(name);

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if (!isCustomProp) {
				name = finalPropName(origName);
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

			// If a hook was provided get the computed value from there
			if (hooks && "get" in hooks) {
				val = hooks.get(elem, true, extra);
			}

			// Otherwise, if a way to get the computed value exists, use that
			if (val === undefined) {
				val = curCSS(elem, name, styles);
			}

			// Convert "normal" to computed value
			if (val === "normal" && name in cssNormalTransform) {
				val = cssNormalTransform[name];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if (extra === "" || extra) {
				num = parseFloat(val);
				return extra === true || isFinite(num) ? num || 0 : val;
			}

			return val;
		}
	});

	jQuery.each(["height", "width"], function (i, dimension) {
		jQuery.cssHooks[dimension] = {
			get: function get(elem, computed, extra) {
				if (computed) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test(jQuery.css(elem, "display")) && (

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
						return getWidthOrHeight(elem, dimension, extra);
					}) : getWidthOrHeight(elem, dimension, extra);
				}
			},

			set: function set(elem, value, extra) {
				var matches,
				    styles = getStyles(elem),


				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",


				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
				    subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if (isBorderBox && scrollboxSizeBuggy) {
					subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
				}

				// Convert to pixels if value adjustment is needed
				if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {

					elem.style[dimension] = value;
					value = jQuery.css(elem, dimension);
				}

				return setPositiveNumber(elem, value, subtract);
			}
		};
	});

	jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
		if (computed) {
			return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
				return elem.getBoundingClientRect().left;
			})) + "px";
		}
	});

	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function (prefix, suffix) {
		jQuery.cssHooks[prefix + suffix] = {
			expand: function expand(value) {
				var i = 0,
				    expanded = {},


				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [value];

				for (; i < 4; i++) {
					expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
				}

				return expanded;
			}
		};

		if (prefix !== "margin") {
			jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
		}
	});

	jQuery.fn.extend({
		css: function css(name, value) {
			return access(this, function (elem, name, value) {
				var styles,
				    len,
				    map = {},
				    i = 0;

				if (Array.isArray(name)) {
					styles = getStyles(elem);
					len = name.length;

					for (; i < len; i++) {
						map[name[i]] = jQuery.css(elem, name[i], false, styles);
					}

					return map;
				}

				return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
			}, name, value, arguments.length > 1);
		}
	});

	function Tween(elem, options, prop, end, easing) {
		return new Tween.prototype.init(elem, options, prop, end, easing);
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function init(elem, options, prop, end, easing, unit) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
		},
		cur: function cur() {
			var hooks = Tween.propHooks[this.prop];

			return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
		},
		run: function run(percent) {
			var eased,
			    hooks = Tween.propHooks[this.prop];

			if (this.options.duration) {
				this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
			} else {
				this.pos = eased = percent;
			}
			this.now = (this.end - this.start) * eased + this.start;

			if (this.options.step) {
				this.options.step.call(this.elem, this.now, this);
			}

			if (hooks && hooks.set) {
				hooks.set(this);
			} else {
				Tween.propHooks._default.set(this);
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function get(tween) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
					return tween.elem[tween.prop];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css(tween.elem, tween.prop, "");

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function set(tween) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if (jQuery.fx.step[tween.prop]) {
					jQuery.fx.step[tween.prop](tween);
				} else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
					jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
				} else {
					tween.elem[tween.prop] = tween.now;
				}
			}
		}
	};

	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function set(tween) {
			if (tween.elem.nodeType && tween.elem.parentNode) {
				tween.elem[tween.prop] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function linear(p) {
			return p;
		},
		swing: function swing(p) {
			return 0.5 - Math.cos(p * Math.PI) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

	// Back compat <1.8 extension point
	jQuery.fx.step = {};

	var fxNow,
	    inProgress,
	    rfxtypes = /^(?:toggle|show|hide)$/,
	    rrun = /queueHooks$/;

	function schedule() {
		if (inProgress) {
			if (document.hidden === false && window.requestAnimationFrame) {
				window.requestAnimationFrame(schedule);
			} else {
				window.setTimeout(schedule, jQuery.fx.interval);
			}

			jQuery.fx.tick();
		}
	}

	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout(function () {
			fxNow = undefined;
		});
		return fxNow = Date.now();
	}

	// Generate parameters to create a standard animation
	function genFx(type, includeWidth) {
		var which,
		    i = 0,
		    attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for (; i < 4; i += 2 - includeWidth) {
			which = cssExpand[i];
			attrs["margin" + which] = attrs["padding" + which] = type;
		}

		if (includeWidth) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween(value, prop, animation) {
		var tween,
		    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
		    index = 0,
		    length = collection.length;
		for (; index < length; index++) {
			if (tween = collection[index].call(animation, prop, value)) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter(elem, props, opts) {
		var prop,
		    value,
		    toggle,
		    hooks,
		    oldfire,
		    propTween,
		    restoreDisplay,
		    display,
		    isBox = "width" in props || "height" in props,
		    anim = this,
		    orig = {},
		    style = elem.style,
		    hidden = elem.nodeType && isHiddenWithinTree(elem),
		    dataShow = dataPriv.get(elem, "fxshow");

		// Queue-skipping animations hijack the fx hooks
		if (!opts.queue) {
			hooks = jQuery._queueHooks(elem, "fx");
			if (hooks.unqueued == null) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function () {
					if (!hooks.unqueued) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always(function () {

				// Ensure the complete handler is called before this completes
				anim.always(function () {
					hooks.unqueued--;
					if (!jQuery.queue(elem, "fx").length) {
						hooks.empty.fire();
					}
				});
			});
		}

		// Detect show/hide animations
		for (prop in props) {
			value = props[prop];
			if (rfxtypes.test(value)) {
				delete props[prop];
				toggle = toggle || value === "toggle";
				if (value === (hidden ? "hide" : "show")) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if (value === "show" && dataShow && dataShow[prop] !== undefined) {
						hidden = true;

						// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject(props);
		if (!propTween && jQuery.isEmptyObject(orig)) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if (isBox && elem.nodeType === 1) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [style.overflow, style.overflowX, style.overflowY];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if (restoreDisplay == null) {
				restoreDisplay = dataPriv.get(elem, "display");
			}
			display = jQuery.css(elem, "display");
			if (display === "none") {
				if (restoreDisplay) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide([elem], true);
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css(elem, "display");
					showHide([elem]);
				}
			}

			// Animate inline elements as inline-block
			if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
				if (jQuery.css(elem, "float") === "none") {

					// Restore the original display value at the end of pure show/hide animations
					if (!propTween) {
						anim.done(function () {
							style.display = restoreDisplay;
						});
						if (restoreDisplay == null) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if (opts.overflow) {
			style.overflow = "hidden";
			anim.always(function () {
				style.overflow = opts.overflow[0];
				style.overflowX = opts.overflow[1];
				style.overflowY = opts.overflow[2];
			});
		}

		// Implement show/hide animations
		propTween = false;
		for (prop in orig) {

			// General show/hide setup for this element animation
			if (!propTween) {
				if (dataShow) {
					if ("hidden" in dataShow) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if (toggle) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if (hidden) {
					showHide([elem], true);
				}

				/* eslint-disable no-loop-func */

				anim.done(function () {

					/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if (!hidden) {
						showHide([elem]);
					}
					dataPriv.remove(elem, "fxshow");
					for (prop in orig) {
						jQuery.style(elem, prop, orig[prop]);
					}
				});
			}

			// Per-property setup
			propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
			if (!(prop in dataShow)) {
				dataShow[prop] = propTween.start;
				if (hidden) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter(props, specialEasing) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for (index in props) {
			name = camelCase(index);
			easing = specialEasing[name];
			value = props[index];
			if (Array.isArray(value)) {
				easing = value[1];
				value = props[index] = value[0];
			}

			if (index !== name) {
				props[name] = value;
				delete props[index];
			}

			hooks = jQuery.cssHooks[name];
			if (hooks && "expand" in hooks) {
				value = hooks.expand(value);
				delete props[name];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for (index in value) {
					if (!(index in props)) {
						props[index] = value[index];
						specialEasing[index] = easing;
					}
				}
			} else {
				specialEasing[name] = easing;
			}
		}
	}

	function Animation(elem, properties, options) {
		var result,
		    stopped,
		    index = 0,
		    length = Animation.prefilters.length,
		    deferred = jQuery.Deferred().always(function () {

			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		    tick = function tick() {
			if (stopped) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
			    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),


			// Support: Android 2.3 only
			// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
			temp = remaining / animation.duration || 0,
			    percent = 1 - temp,
			    index = 0,
			    length = animation.tweens.length;

			for (; index < length; index++) {
				animation.tweens[index].run(percent);
			}

			deferred.notifyWith(elem, [animation, percent, remaining]);

			// If there's more to do, yield
			if (percent < 1 && length) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if (!length) {
				deferred.notifyWith(elem, [animation, 1, 0]);
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith(elem, [animation]);
			return false;
		},
		    animation = deferred.promise({
			elem: elem,
			props: jQuery.extend({}, properties),
			opts: jQuery.extend(true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function createTween(prop, end) {
				var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
				animation.tweens.push(tween);
				return tween;
			},
			stop: function stop(gotoEnd) {
				var index = 0,


				// If we are going to the end, we want to run all the tweens
				// otherwise we skip this part
				length = gotoEnd ? animation.tweens.length : 0;
				if (stopped) {
					return this;
				}
				stopped = true;
				for (; index < length; index++) {
					animation.tweens[index].run(1);
				}

				// Resolve when we played the last frame; otherwise, reject
				if (gotoEnd) {
					deferred.notifyWith(elem, [animation, 1, 0]);
					deferred.resolveWith(elem, [animation, gotoEnd]);
				} else {
					deferred.rejectWith(elem, [animation, gotoEnd]);
				}
				return this;
			}
		}),
		    props = animation.props;

		propFilter(props, animation.opts.specialEasing);

		for (; index < length; index++) {
			result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
			if (result) {
				if (isFunction(result.stop)) {
					jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
				}
				return result;
			}
		}

		jQuery.map(props, createTween, animation);

		if (isFunction(animation.opts.start)) {
			animation.opts.start.call(elem, animation);
		}

		// Attach callbacks from options
		animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);

		jQuery.fx.timer(jQuery.extend(tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		}));

		return animation;
	}

	jQuery.Animation = jQuery.extend(Animation, {

		tweeners: {
			"*": [function (prop, value) {
				var tween = this.createTween(prop, value);
				adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
				return tween;
			}]
		},

		tweener: function tweener(props, callback) {
			if (isFunction(props)) {
				callback = props;
				props = ["*"];
			} else {
				props = props.match(rnothtmlwhite);
			}

			var prop,
			    index = 0,
			    length = props.length;

			for (; index < length; index++) {
				prop = props[index];
				Animation.tweeners[prop] = Animation.tweeners[prop] || [];
				Animation.tweeners[prop].unshift(callback);
			}
		},

		prefilters: [defaultPrefilter],

		prefilter: function prefilter(callback, prepend) {
			if (prepend) {
				Animation.prefilters.unshift(callback);
			} else {
				Animation.prefilters.push(callback);
			}
		}
	});

	jQuery.speed = function (speed, easing, fn) {
		var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
			complete: fn || !fn && easing || isFunction(speed) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction(easing) && easing
		};

		// Go to the end state if fx are off
		if (jQuery.fx.off) {
			opt.duration = 0;
		} else {
			if (typeof opt.duration !== "number") {
				if (opt.duration in jQuery.fx.speeds) {
					opt.duration = jQuery.fx.speeds[opt.duration];
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if (opt.queue == null || opt.queue === true) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function () {
			if (isFunction(opt.old)) {
				opt.old.call(this);
			}

			if (opt.queue) {
				jQuery.dequeue(this, opt.queue);
			}
		};

		return opt;
	};

	jQuery.fn.extend({
		fadeTo: function fadeTo(speed, to, easing, callback) {

			// Show any hidden elements after setting opacity to 0
			return this.filter(isHiddenWithinTree).css("opacity", 0).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback);
		},
		animate: function animate(prop, speed, easing, callback) {
			var empty = jQuery.isEmptyObject(prop),
			    optall = jQuery.speed(speed, easing, callback),
			    doAnimation = function doAnimation() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation(this, jQuery.extend({}, prop), optall);

				// Empty animations, or finishing resolves immediately
				if (empty || dataPriv.get(this, "finish")) {
					anim.stop(true);
				}
			};
			doAnimation.finish = doAnimation;

			return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
		},
		stop: function stop(type, clearQueue, gotoEnd) {
			var stopQueue = function stopQueue(hooks) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop(gotoEnd);
			};

			if (typeof type !== "string") {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if (clearQueue && type !== false) {
				this.queue(type || "fx", []);
			}

			return this.each(function () {
				var dequeue = true,
				    index = type != null && type + "queueHooks",
				    timers = jQuery.timers,
				    data = dataPriv.get(this);

				if (index) {
					if (data[index] && data[index].stop) {
						stopQueue(data[index]);
					}
				} else {
					for (index in data) {
						if (data[index] && data[index].stop && rrun.test(index)) {
							stopQueue(data[index]);
						}
					}
				}

				for (index = timers.length; index--;) {
					if (timers[index].elem === this && (type == null || timers[index].queue === type)) {

						timers[index].anim.stop(gotoEnd);
						dequeue = false;
						timers.splice(index, 1);
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if (dequeue || !gotoEnd) {
					jQuery.dequeue(this, type);
				}
			});
		},
		finish: function finish(type) {
			if (type !== false) {
				type = type || "fx";
			}
			return this.each(function () {
				var index,
				    data = dataPriv.get(this),
				    queue = data[type + "queue"],
				    hooks = data[type + "queueHooks"],
				    timers = jQuery.timers,
				    length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue(this, type, []);

				if (hooks && hooks.stop) {
					hooks.stop.call(this, true);
				}

				// Look for any active animations, and finish them
				for (index = timers.length; index--;) {
					if (timers[index].elem === this && timers[index].queue === type) {
						timers[index].anim.stop(true);
						timers.splice(index, 1);
					}
				}

				// Look for any animations in the old queue and finish them
				for (index = 0; index < length; index++) {
					if (queue[index] && queue[index].finish) {
						queue[index].finish.call(this);
					}
				}

				// Turn off finishing flag
				delete data.finish;
			});
		}
	});

	jQuery.each(["toggle", "show", "hide"], function (i, name) {
		var cssFn = jQuery.fn[name];
		jQuery.fn[name] = function (speed, easing, callback) {
			return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
		};
	});

	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function (name, props) {
		jQuery.fn[name] = function (speed, easing, callback) {
			return this.animate(props, speed, easing, callback);
		};
	});

	jQuery.timers = [];
	jQuery.fx.tick = function () {
		var timer,
		    i = 0,
		    timers = jQuery.timers;

		fxNow = Date.now();

		for (; i < timers.length; i++) {
			timer = timers[i];

			// Run the timer and safely remove it when done (allowing for external removal)
			if (!timer() && timers[i] === timer) {
				timers.splice(i--, 1);
			}
		}

		if (!timers.length) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function (timer) {
		jQuery.timers.push(timer);
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function () {
		if (inProgress) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function () {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};

	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function (time, type) {
		time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
		type = type || "fx";

		return this.queue(type, function (next, hooks) {
			var timeout = window.setTimeout(next, time);
			hooks.stop = function () {
				window.clearTimeout(timeout);
			};
		});
	};

	(function () {
		var input = document.createElement("input"),
		    select = document.createElement("select"),
		    opt = select.appendChild(document.createElement("option"));

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement("input");
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();

	var boolHook,
	    attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend({
		attr: function attr(name, value) {
			return access(this, jQuery.attr, name, value, arguments.length > 1);
		},

		removeAttr: function removeAttr(name) {
			return this.each(function () {
				jQuery.removeAttr(this, name);
			});
		}
	});

	jQuery.extend({
		attr: function attr(elem, name, value) {
			var ret,
			    hooks,
			    nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if (nType === 3 || nType === 8 || nType === 2) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if (typeof elem.getAttribute === "undefined") {
				return jQuery.prop(elem, name, value);
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
				hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
			}

			if (value !== undefined) {
				if (value === null) {
					jQuery.removeAttr(elem, name);
					return;
				}

				if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
					return ret;
				}

				elem.setAttribute(name, value + "");
				return value;
			}

			if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
				return ret;
			}

			ret = jQuery.find.attr(elem, name);

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function set(elem, value) {
					if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
						var val = elem.value;
						elem.setAttribute("type", value);
						if (val) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function removeAttr(elem, value) {
			var name,
			    i = 0,


			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match(rnothtmlwhite);

			if (attrNames && elem.nodeType === 1) {
				while (name = attrNames[i++]) {
					elem.removeAttribute(name);
				}
			}
		}
	});

	// Hooks for boolean attributes
	boolHook = {
		set: function set(elem, value, name) {
			if (value === false) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr(elem, name);
			} else {
				elem.setAttribute(name, name);
			}
			return name;
		}
	};

	jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
		var getter = attrHandle[name] || jQuery.find.attr;

		attrHandle[name] = function (elem, name, isXML) {
			var ret,
			    handle,
			    lowercaseName = name.toLowerCase();

			if (!isXML) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[lowercaseName];
				attrHandle[lowercaseName] = ret;
				ret = getter(elem, name, isXML) != null ? lowercaseName : null;
				attrHandle[lowercaseName] = handle;
			}
			return ret;
		};
	});

	var rfocusable = /^(?:input|select|textarea|button)$/i,
	    rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend({
		prop: function prop(name, value) {
			return access(this, jQuery.prop, name, value, arguments.length > 1);
		},

		removeProp: function removeProp(name) {
			return this.each(function () {
				delete this[jQuery.propFix[name] || name];
			});
		}
	});

	jQuery.extend({
		prop: function prop(elem, name, value) {
			var ret,
			    hooks,
			    nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if (nType === 3 || nType === 8 || nType === 2) {
				return;
			}

			if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

				// Fix name and attach hooks
				name = jQuery.propFix[name] || name;
				hooks = jQuery.propHooks[name];
			}

			if (value !== undefined) {
				if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
					return ret;
				}

				return elem[name] = value;
			}

			if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
				return ret;
			}

			return elem[name];
		},

		propHooks: {
			tabIndex: {
				get: function get(elem) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr(elem, "tabindex");

					if (tabindex) {
						return parseInt(tabindex, 10);
					}

					if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	});

	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if (!support.optSelected) {
		jQuery.propHooks.selected = {
			get: function get(elem) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if (parent && parent.parentNode) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function set(elem) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if (parent) {
					parent.selectedIndex;

					if (parent.parentNode) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
		jQuery.propFix[this.toLowerCase()] = this;
	});

	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse(value) {
		var tokens = value.match(rnothtmlwhite) || [];
		return tokens.join(" ");
	}

	function getClass(elem) {
		return elem.getAttribute && elem.getAttribute("class") || "";
	}

	function classesToArray(value) {
		if (Array.isArray(value)) {
			return value;
		}
		if (typeof value === "string") {
			return value.match(rnothtmlwhite) || [];
		}
		return [];
	}

	jQuery.fn.extend({
		addClass: function addClass(value) {
			var classes,
			    elem,
			    cur,
			    curValue,
			    clazz,
			    j,
			    finalValue,
			    i = 0;

			if (isFunction(value)) {
				return this.each(function (j) {
					jQuery(this).addClass(value.call(this, j, getClass(this)));
				});
			}

			classes = classesToArray(value);

			if (classes.length) {
				while (elem = this[i++]) {
					curValue = getClass(elem);
					cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

					if (cur) {
						j = 0;
						while (clazz = classes[j++]) {
							if (cur.indexOf(" " + clazz + " ") < 0) {
								cur += clazz + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse(cur);
						if (curValue !== finalValue) {
							elem.setAttribute("class", finalValue);
						}
					}
				}
			}

			return this;
		},

		removeClass: function removeClass(value) {
			var classes,
			    elem,
			    cur,
			    curValue,
			    clazz,
			    j,
			    finalValue,
			    i = 0;

			if (isFunction(value)) {
				return this.each(function (j) {
					jQuery(this).removeClass(value.call(this, j, getClass(this)));
				});
			}

			if (!arguments.length) {
				return this.attr("class", "");
			}

			classes = classesToArray(value);

			if (classes.length) {
				while (elem = this[i++]) {
					curValue = getClass(elem);

					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

					if (cur) {
						j = 0;
						while (clazz = classes[j++]) {

							// Remove *all* instances
							while (cur.indexOf(" " + clazz + " ") > -1) {
								cur = cur.replace(" " + clazz + " ", " ");
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse(cur);
						if (curValue !== finalValue) {
							elem.setAttribute("class", finalValue);
						}
					}
				}
			}

			return this;
		},

		toggleClass: function toggleClass(value, stateVal) {
			var type = typeof value,
			    isValidValue = type === "string" || Array.isArray(value);

			if (typeof stateVal === "boolean" && isValidValue) {
				return stateVal ? this.addClass(value) : this.removeClass(value);
			}

			if (isFunction(value)) {
				return this.each(function (i) {
					jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
				});
			}

			return this.each(function () {
				var className, i, self, classNames;

				if (isValidValue) {

					// Toggle individual class names
					i = 0;
					self = jQuery(this);
					classNames = classesToArray(value);

					while (className = classNames[i++]) {

						// Check each className given, space separated list
						if (self.hasClass(className)) {
							self.removeClass(className);
						} else {
							self.addClass(className);
						}
					}

					// Toggle whole class name
				} else if (value === undefined || type === "boolean") {
					className = getClass(this);
					if (className) {

						// Store className if set
						dataPriv.set(this, "__className__", className);
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if (this.setAttribute) {
						this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
					}
				}
			});
		},

		hasClass: function hasClass(selector) {
			var className,
			    elem,
			    i = 0;

			className = " " + selector + " ";
			while (elem = this[i++]) {
				if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
					return true;
				}
			}

			return false;
		}
	});

	var rreturn = /\r/g;

	jQuery.fn.extend({
		val: function val(value) {
			var hooks,
			    ret,
			    valueIsFunction,
			    elem = this[0];

			if (!arguments.length) {
				if (elem) {
					hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

					if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if (typeof ret === "string") {
						return ret.replace(rreturn, "");
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction(value);

			return this.each(function (i) {
				var val;

				if (this.nodeType !== 1) {
					return;
				}

				if (valueIsFunction) {
					val = value.call(this, i, jQuery(this).val());
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if (val == null) {
					val = "";
				} else if (typeof val === "number") {
					val += "";
				} else if (Array.isArray(val)) {
					val = jQuery.map(val, function (value) {
						return value == null ? "" : value + "";
					});
				}

				hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

				// If set returns undefined, fall back to normal setting
				if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
					this.value = val;
				}
			});
		}
	});

	jQuery.extend({
		valHooks: {
			option: {
				get: function get(elem) {

					var val = jQuery.find.attr(elem, "value");
					return val != null ? val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse(jQuery.text(elem));
				}
			},
			select: {
				get: function get(elem) {
					var value,
					    option,
					    i,
					    options = elem.options,
					    index = elem.selectedIndex,
					    one = elem.type === "select-one",
					    values = one ? null : [],
					    max = one ? index + 1 : options.length;

					if (index < 0) {
						i = max;
					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for (; i < max; i++) {
						option = options[i];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ((option.selected || i === index) &&

						// Don't return options that are disabled or in a disabled optgroup
						!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {

							// Get the specific value for the option
							value = jQuery(option).val();

							// We don't need an array for one selects
							if (one) {
								return value;
							}

							// Multi-Selects return an array
							values.push(value);
						}
					}

					return values;
				},

				set: function set(elem, value) {
					var optionSet,
					    option,
					    options = elem.options,
					    values = jQuery.makeArray(value),
					    i = options.length;

					while (i--) {
						option = options[i];

						/* eslint-disable no-cond-assign */

						if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if (!optionSet) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});

	// Radios and checkboxes getter/setter
	jQuery.each(["radio", "checkbox"], function () {
		jQuery.valHooks[this] = {
			set: function set(elem, value) {
				if (Array.isArray(value)) {
					return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
				}
			}
		};
		if (!support.checkOn) {
			jQuery.valHooks[this].get = function (elem) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});

	// Return jQuery for attributes-only inclusion


	support.focusin = "onfocusin" in window;

	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	    stopPropagationCallback = function stopPropagationCallback(e) {
		e.stopPropagation();
	};

	jQuery.extend(jQuery.event, {

		trigger: function trigger(event, data, elem, onlyHandlers) {

			var i,
			    cur,
			    tmp,
			    bubbleType,
			    ontype,
			    handle,
			    special,
			    lastElement,
			    eventPath = [elem || document],
			    type = hasOwn.call(event, "type") ? event.type : event,
			    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if (elem.nodeType === 3 || elem.nodeType === 8) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if (rfocusMorph.test(type + jQuery.event.triggered)) {
				return;
			}

			if (type.indexOf(".") > -1) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if (!event.target) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ? [event] : jQuery.makeArray(data, [event]);

			// Allow special events to draw outside the lines
			special = jQuery.event.special[type] || {};
			if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

				bubbleType = special.delegateType || type;
				if (!rfocusMorph.test(bubbleType + type)) {
					cur = cur.parentNode;
				}
				for (; cur; cur = cur.parentNode) {
					eventPath.push(cur);
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if (tmp === (elem.ownerDocument || document)) {
					eventPath.push(tmp.defaultView || tmp.parentWindow || window);
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
				lastElement = cur;
				event.type = i > 1 ? bubbleType : special.bindType || type;

				// jQuery handler
				handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
				if (handle) {
					handle.apply(cur, data);
				}

				// Native handler
				handle = ontype && cur[ontype];
				if (handle && handle.apply && acceptData(cur)) {
					event.result = handle.apply(cur, data);
					if (event.result === false) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if (!onlyHandlers && !event.isDefaultPrevented()) {

				if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ontype];

						if (tmp) {
							elem[ontype] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if (event.isPropagationStopped()) {
							lastElement.addEventListener(type, stopPropagationCallback);
						}

						elem[type]();

						if (event.isPropagationStopped()) {
							lastElement.removeEventListener(type, stopPropagationCallback);
						}

						jQuery.event.triggered = undefined;

						if (tmp) {
							elem[ontype] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function simulate(type, elem, event) {
			var e = jQuery.extend(new jQuery.Event(), event, {
				type: type,
				isSimulated: true
			});

			jQuery.event.trigger(e, null, elem);
		}

	});

	jQuery.fn.extend({

		trigger: function trigger(type, data) {
			return this.each(function () {
				jQuery.event.trigger(type, data, this);
			});
		},
		triggerHandler: function triggerHandler(type, data) {
			var elem = this[0];
			if (elem) {
				return jQuery.event.trigger(type, data, elem, true);
			}
		}
	});

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if (!support.focusin) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {

			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function handler(event) {
				jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
			};

			jQuery.event.special[fix] = {
				setup: function setup() {
					var doc = this.ownerDocument || this,
					    attaches = dataPriv.access(doc, fix);

					if (!attaches) {
						doc.addEventListener(orig, handler, true);
					}
					dataPriv.access(doc, fix, (attaches || 0) + 1);
				},
				teardown: function teardown() {
					var doc = this.ownerDocument || this,
					    attaches = dataPriv.access(doc, fix) - 1;

					if (!attaches) {
						doc.removeEventListener(orig, handler, true);
						dataPriv.remove(doc, fix);
					} else {
						dataPriv.access(doc, fix, attaches);
					}
				}
			};
		});
	}
	var location = window.location;

	var nonce = Date.now();

	var rquery = /\?/;

	// Cross-browser xml parsing
	jQuery.parseXML = function (data) {
		var xml;
		if (!data || typeof data !== "string") {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = new window.DOMParser().parseFromString(data, "text/xml");
		} catch (e) {
			xml = undefined;
		}

		if (!xml || xml.getElementsByTagName("parsererror").length) {
			jQuery.error("Invalid XML: " + data);
		}
		return xml;
	};

	var rbracket = /\[\]$/,
	    rCRLF = /\r?\n/g,
	    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	    rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams(prefix, obj, traditional, add) {
		var name;

		if (Array.isArray(obj)) {

			// Serialize array item.
			jQuery.each(obj, function (i, v) {
				if (traditional || rbracket.test(prefix)) {

					// Treat each array item as a scalar.
					add(prefix, v);
				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
				}
			});
		} else if (!traditional && toType(obj) === "object") {

			// Serialize object item.
			for (name in obj) {
				buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
			}
		} else {

			// Serialize scalar item.
			add(prefix, obj);
		}
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function (a, traditional) {
		var prefix,
		    s = [],
		    add = function add(key, valueOrFunction) {

			// If value is a function, invoke it and use its return value
			var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;

			s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
		};

		if (a == null) {
			return "";
		}

		// If an array was passed in, assume that it is an array of form elements.
		if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {

			// Serialize the form elements
			jQuery.each(a, function () {
				add(this.name, this.value);
			});
		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for (prefix in a) {
				buildParams(prefix, a[prefix], traditional, add);
			}
		}

		// Return the resulting serialization
		return s.join("&");
	};

	jQuery.fn.extend({
		serialize: function serialize() {
			return jQuery.param(this.serializeArray());
		},
		serializeArray: function serializeArray() {
			return this.map(function () {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop(this, "elements");
				return elements ? jQuery.makeArray(elements) : this;
			}).filter(function () {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
			}).map(function (i, elem) {
				var val = jQuery(this).val();

				if (val == null) {
					return null;
				}

				if (Array.isArray(val)) {
					return jQuery.map(val, function (val) {
						return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
					});
				}

				return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
			}).get();
		}
	});

	var r20 = /%20/g,
	    rhash = /#.*$/,
	    rantiCache = /([?&])_=[^&]*/,
	    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,


	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	    rnoContent = /^(?:GET|HEAD)$/,
	    rprotocol = /^\/\//,


	/* Prefilters
  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
  * 2) These are called:
  *    - BEFORE asking for a transport
  *    - AFTER param serialization (s.data is a string if s.processData is true)
  * 3) key is the dataType
  * 4) the catchall symbol "*" can be used
  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
  */
	prefilters = {},


	/* Transports bindings
  * 1) key is the dataType
  * 2) the catchall symbol "*" can be used
  * 3) selection will start with transport dataType and THEN go to "*" if needed
  */
	transports = {},


	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat("*"),


	// Anchor tag for parsing the document origin
	originAnchor = document.createElement("a");
	originAnchor.href = location.href;

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports(structure) {

		// dataTypeExpression is optional and defaults to "*"
		return function (dataTypeExpression, func) {

			if (typeof dataTypeExpression !== "string") {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
			    i = 0,
			    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

			if (isFunction(func)) {

				// For each dataType in the dataTypeExpression
				while (dataType = dataTypes[i++]) {

					// Prepend if requested
					if (dataType[0] === "+") {
						dataType = dataType.slice(1) || "*";
						(structure[dataType] = structure[dataType] || []).unshift(func);

						// Otherwise append
					} else {
						(structure[dataType] = structure[dataType] || []).push(func);
					}
				}
			}
		};
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

		var inspected = {},
		    seekingTransport = structure === transports;

		function inspect(dataType) {
			var selected;
			inspected[dataType] = true;
			jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
				var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
				if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {

					options.dataTypes.unshift(dataTypeOrTransport);
					inspect(dataTypeOrTransport);
					return false;
				} else if (seekingTransport) {
					return !(selected = dataTypeOrTransport);
				}
			});
			return selected;
		}

		return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend(target, src) {
		var key,
		    deep,
		    flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for (key in src) {
			if (src[key] !== undefined) {
				(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
			}
		}
		if (deep) {
			jQuery.extend(true, target, deep);
		}

		return target;
	}

	/* Handles responses to an ajax request:
  * - finds the right dataType (mediates between content-type and expected dataType)
  * - returns the corresponding response
  */
	function ajaxHandleResponses(s, jqXHR, responses) {

		var ct,
		    type,
		    finalDataType,
		    firstDataType,
		    contents = s.contents,
		    dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while (dataTypes[0] === "*") {
			dataTypes.shift();
			if (ct === undefined) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}

		// Check if we're dealing with a known content-type
		if (ct) {
			for (type in contents) {
				if (contents[type] && contents[type].test(ct)) {
					dataTypes.unshift(type);
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if (dataTypes[0] in responses) {
			finalDataType = dataTypes[0];
		} else {

			// Try convertible dataTypes
			for (type in responses) {
				if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
					finalDataType = type;
					break;
				}
				if (!firstDataType) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if (finalDataType) {
			if (finalDataType !== dataTypes[0]) {
				dataTypes.unshift(finalDataType);
			}
			return responses[finalDataType];
		}
	}

	/* Chain conversions given the request and the original response
  * Also sets the responseXXX fields on the jqXHR instance
  */
	function ajaxConvert(s, response, jqXHR, isSuccess) {
		var conv2,
		    current,
		    conv,
		    tmp,
		    prev,
		    converters = {},


		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if (dataTypes[1]) {
			for (conv in s.converters) {
				converters[conv.toLowerCase()] = s.converters[conv];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while (current) {

			if (s.responseFields[current]) {
				jqXHR[s.responseFields[current]] = response;
			}

			// Apply the dataFilter if provided
			if (!prev && isSuccess && s.dataFilter) {
				response = s.dataFilter(response, s.dataType);
			}

			prev = current;
			current = dataTypes.shift();

			if (current) {

				// There's only work to do if current dataType is non-auto
				if (current === "*") {

					current = prev;

					// Convert response if prev dataType is non-auto and differs from current
				} else if (prev !== "*" && prev !== current) {

					// Seek a direct converter
					conv = converters[prev + " " + current] || converters["* " + current];

					// If none found, seek a pair
					if (!conv) {
						for (conv2 in converters) {

							// If conv2 outputs current
							tmp = conv2.split(" ");
							if (tmp[1] === current) {

								// If prev can be converted to accepted input
								conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
								if (conv) {

									// Condense equivalence converters
									if (conv === true) {
										conv = converters[conv2];

										// Otherwise, insert the intermediate dataType
									} else if (converters[conv2] !== true) {
										current = tmp[0];
										dataTypes.unshift(tmp[1]);
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if (conv !== true) {

						// Unless errors are allowed to bubble, catch and return them
						if (conv && s.throws) {
							response = conv(response);
						} else {
							try {
								response = conv(response);
							} catch (e) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend({

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test(location.protocol),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
   timeout: 0,
   data: null,
   dataType: null,
   username: null,
   password: null,
   cache: null,
   throws: false,
   traditional: false,
   headers: {},
   */

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function ajaxSetup(target, settings) {
			return settings ?

			// Building a settings object
			ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

			// Extending ajaxSettings
			ajaxExtend(jQuery.ajaxSettings, target);
		},

		ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
		ajaxTransport: addToPrefiltersOrTransports(transports),

		// Main method
		ajax: function ajax(url, options) {

			// If url is an object, simulate pre-1.5 signature
			if (typeof url === "object") {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,


			// URL without anti-cache param
			cacheURL,


			// Response headers
			responseHeadersString,
			    responseHeaders,


			// timeout handle
			timeoutTimer,


			// Url cleanup var
			urlAnchor,


			// Request state (becomes false upon send and true upon completion)
			completed,


			// To know if global events are to be dispatched
			fireGlobals,


			// Loop variable
			i,


			// uncached part of the url
			uncached,


			// Create the final options object
			s = jQuery.ajaxSetup({}, options),


			// Callbacks context
			callbackContext = s.context || s,


			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,


			// Deferreds
			deferred = jQuery.Deferred(),
			    completeDeferred = jQuery.Callbacks("once memory"),


			// Status-dependent callbacks
			_statusCode = s.statusCode || {},


			// Headers (they are sent all at once)
			requestHeaders = {},
			    requestHeadersNames = {},


			// Default abort message
			strAbort = "canceled",


			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function getResponseHeader(key) {
					var match;
					if (completed) {
						if (!responseHeaders) {
							responseHeaders = {};
							while (match = rheaders.exec(responseHeadersString)) {
								responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
							}
						}
						match = responseHeaders[key.toLowerCase() + " "];
					}
					return match == null ? null : match.join(", ");
				},

				// Raw string
				getAllResponseHeaders: function getAllResponseHeaders() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function setRequestHeader(name, value) {
					if (completed == null) {
						name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
						requestHeaders[name] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function overrideMimeType(type) {
					if (completed == null) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function statusCode(map) {
					var code;
					if (map) {
						if (completed) {

							// Execute the appropriate callbacks
							jqXHR.always(map[jqXHR.status]);
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for (code in map) {
								_statusCode[code] = [_statusCode[code], map[code]];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function abort(statusText) {
					var finalText = statusText || strAbort;
					if (transport) {
						transport.abort(finalText);
					}
					done(0, finalText);
					return this;
				}
			};

			// Attach deferreds
			deferred.promise(jqXHR);

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if (s.crossDomain == null) {
				urlAnchor = document.createElement("a");

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
				} catch (e) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if (s.data && s.processData && typeof s.data !== "string") {
				s.data = jQuery.param(s.data, s.traditional);
			}

			// Apply prefilters
			inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

			// If request was aborted inside a prefilter, stop there
			if (completed) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if (fireGlobals && jQuery.active++ === 0) {
				jQuery.event.trigger("ajaxStart");
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test(s.type);

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace(rhash, "");

			// More options handling for requests with no content
			if (!s.hasContent) {

				// Remember the hash so we can put it back
				uncached = s.url.slice(cacheURL.length);

				// If data is available and should be processed, append data to url
				if (s.data && (s.processData || typeof s.data === "string")) {
					cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if (s.cache === false) {
					cacheURL = cacheURL.replace(rantiCache, "$1");
					uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++ + uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

				// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
				s.data = s.data.replace(r20, "+");
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if (s.ifModified) {
				if (jQuery.lastModified[cacheURL]) {
					jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
				}
				if (jQuery.etag[cacheURL]) {
					jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
				}
			}

			// Set the correct header, if data is being sent
			if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
				jqXHR.setRequestHeader("Content-Type", s.contentType);
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

			// Check for headers option
			for (i in s.headers) {
				jqXHR.setRequestHeader(i, s.headers[i]);
			}

			// Allow custom headers/mimetypes and early abort
			if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add(s.complete);
			jqXHR.done(s.success);
			jqXHR.fail(s.error);

			// Get transport
			transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

			// If no transport, we auto-abort
			if (!transport) {
				done(-1, "No Transport");
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if (fireGlobals) {
					globalEventContext.trigger("ajaxSend", [jqXHR, s]);
				}

				// If request was aborted inside ajaxSend, stop there
				if (completed) {
					return jqXHR;
				}

				// Timeout
				if (s.async && s.timeout > 0) {
					timeoutTimer = window.setTimeout(function () {
						jqXHR.abort("timeout");
					}, s.timeout);
				}

				try {
					completed = false;
					transport.send(requestHeaders, done);
				} catch (e) {

					// Rethrow post-completion exceptions
					if (completed) {
						throw e;
					}

					// Propagate others as results
					done(-1, e);
				}
			}

			// Callback for when everything is done
			function done(status, nativeStatusText, responses, headers) {
				var isSuccess,
				    success,
				    error,
				    response,
				    modified,
				    statusText = nativeStatusText;

				// Ignore repeat invocations
				if (completed) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if (timeoutTimer) {
					window.clearTimeout(timeoutTimer);
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if (responses) {
					response = ajaxHandleResponses(s, jqXHR, responses);
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert(s, response, jqXHR, isSuccess);

				// If successful, handle type chaining
				if (isSuccess) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if (s.ifModified) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if (modified) {
							jQuery.lastModified[cacheURL] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if (modified) {
							jQuery.etag[cacheURL] = modified;
						}
					}

					// if no content
					if (status === 204 || s.type === "HEAD") {
						statusText = "nocontent";

						// if not modified
					} else if (status === 304) {
						statusText = "notmodified";

						// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if (status || !statusText) {
						statusText = "error";
						if (status < 0) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = (nativeStatusText || statusText) + "";

				// Success/Error
				if (isSuccess) {
					deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
				} else {
					deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
				}

				// Status-dependent callbacks
				jqXHR.statusCode(_statusCode);
				_statusCode = undefined;

				if (fireGlobals) {
					globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
				}

				// Complete
				completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

				if (fireGlobals) {
					globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

					// Handle the global AJAX counter
					if (! --jQuery.active) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}

			return jqXHR;
		},

		getJSON: function getJSON(url, data, callback) {
			return jQuery.get(url, data, callback, "json");
		},

		getScript: function getScript(url, callback) {
			return jQuery.get(url, undefined, callback, "script");
		}
	});

	jQuery.each(["get", "post"], function (i, method) {
		jQuery[method] = function (url, data, callback, type) {

			// Shift arguments if data argument was omitted
			if (isFunction(data)) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax(jQuery.extend({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject(url) && url));
		};
	});

	jQuery._evalUrl = function (url, options) {
		return jQuery.ajax({
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,

			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function textScript() {}
			},
			dataFilter: function dataFilter(response) {
				jQuery.globalEval(response, options);
			}
		});
	};

	jQuery.fn.extend({
		wrapAll: function wrapAll(html) {
			var wrap;

			if (this[0]) {
				if (isFunction(html)) {
					html = html.call(this[0]);
				}

				// The elements to wrap the target around
				wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

				if (this[0].parentNode) {
					wrap.insertBefore(this[0]);
				}

				wrap.map(function () {
					var elem = this;

					while (elem.firstElementChild) {
						elem = elem.firstElementChild;
					}

					return elem;
				}).append(this);
			}

			return this;
		},

		wrapInner: function wrapInner(html) {
			if (isFunction(html)) {
				return this.each(function (i) {
					jQuery(this).wrapInner(html.call(this, i));
				});
			}

			return this.each(function () {
				var self = jQuery(this),
				    contents = self.contents();

				if (contents.length) {
					contents.wrapAll(html);
				} else {
					self.append(html);
				}
			});
		},

		wrap: function wrap(html) {
			var htmlIsFunction = isFunction(html);

			return this.each(function (i) {
				jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
			});
		},

		unwrap: function unwrap(selector) {
			this.parent(selector).not("body").each(function () {
				jQuery(this).replaceWith(this.childNodes);
			});
			return this;
		}
	});

	jQuery.expr.pseudos.hidden = function (elem) {
		return !jQuery.expr.pseudos.visible(elem);
	};
	jQuery.expr.pseudos.visible = function (elem) {
		return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	};

	jQuery.ajaxSettings.xhr = function () {
		try {
			return new window.XMLHttpRequest();
		} catch (e) {}
	};

	var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	    xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport(function (options) {
		var _callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if (support.cors || xhrSupported && !options.crossDomain) {
			return {
				send: function send(headers, complete) {
					var i,
					    xhr = options.xhr();

					xhr.open(options.type, options.url, options.async, options.username, options.password);

					// Apply custom fields if provided
					if (options.xhrFields) {
						for (i in options.xhrFields) {
							xhr[i] = options.xhrFields[i];
						}
					}

					// Override mime type if needed
					if (options.mimeType && xhr.overrideMimeType) {
						xhr.overrideMimeType(options.mimeType);
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if (!options.crossDomain && !headers["X-Requested-With"]) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}

					// Set headers
					for (i in headers) {
						xhr.setRequestHeader(i, headers[i]);
					}

					// Callback
					_callback = function callback(type) {
						return function () {
							if (_callback) {
								_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;

								if (type === "abort") {
									xhr.abort();
								} else if (type === "error") {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if (typeof xhr.status !== "number") {
										complete(0, "error");
									} else {
										complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status, xhr.statusText);
									}
								} else {
									complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
								}
							}
						};
					};

					// Listen to events
					xhr.onload = _callback();
					errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if (xhr.onabort !== undefined) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function () {

							// Check readyState before timeout as it changes
							if (xhr.readyState === 4) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout(function () {
									if (_callback) {
										errorCallback();
									}
								});
							}
						};
					}

					// Create the abort callback
					_callback = _callback("abort");

					try {

						// Do send the request (this may raise an exception)
						xhr.send(options.hasContent && options.data || null);
					} catch (e) {

						// #14683: Only rethrow if this hasn't been notified as an error yet
						if (_callback) {
							throw e;
						}
					}
				},

				abort: function abort() {
					if (_callback) {
						_callback();
					}
				}
			};
		}
	});

	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter(function (s) {
		if (s.crossDomain) {
			s.contents.script = false;
		}
	});

	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function textScript(text) {
				jQuery.globalEval(text);
				return text;
			}
		}
	});

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter("script", function (s) {
		if (s.cache === undefined) {
			s.cache = false;
		}
		if (s.crossDomain) {
			s.type = "GET";
		}
	});

	// Bind script tag hack transport
	jQuery.ajaxTransport("script", function (s) {

		// This transport only deals with cross domain or forced-by-attrs requests
		if (s.crossDomain || s.scriptAttrs) {
			var script, _callback2;
			return {
				send: function send(_, complete) {
					script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", _callback2 = function callback(evt) {
						script.remove();
						_callback2 = null;
						if (evt) {
							complete(evt.type === "error" ? 404 : 200, evt.type);
						}
					});

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild(script[0]);
				},
				abort: function abort() {
					if (_callback2) {
						_callback2();
					}
				}
			};
		}
	});

	var oldCallbacks = [],
	    rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function jsonpCallback() {
			var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
			this[callback] = true;
			return callback;
		}
	});

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

		var callbackName,
		    overwritten,
		    responseContainer,
		    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if (jsonProp || s.dataTypes[0] === "jsonp") {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

			// Insert callback into url or form data
			if (jsonProp) {
				s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
			} else if (s.jsonp !== false) {
				s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function () {
				if (!responseContainer) {
					jQuery.error(callbackName + " was not called");
				}
				return responseContainer[0];
			};

			// Force json dataType
			s.dataTypes[0] = "json";

			// Install callback
			overwritten = window[callbackName];
			window[callbackName] = function () {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always(function () {

				// If previous value didn't exist - remove it
				if (overwritten === undefined) {
					jQuery(window).removeProp(callbackName);

					// Otherwise restore preexisting value
				} else {
					window[callbackName] = overwritten;
				}

				// Save back as free
				if (s[callbackName]) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push(callbackName);
				}

				// Call if it was a function and we have a response
				if (responseContainer && isFunction(overwritten)) {
					overwritten(responseContainer[0]);
				}

				responseContainer = overwritten = undefined;
			});

			// Delegate to script
			return "script";
		}
	});

	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = function () {
		var body = document.implementation.createHTMLDocument("").body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	}();

	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function (data, context, keepScripts) {
		if (typeof data !== "string") {
			return [];
		}
		if (typeof context === "boolean") {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if (!context) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if (support.createHTMLDocument) {
				context = document.implementation.createHTMLDocument("");

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement("base");
				base.href = document.location.href;
				context.head.appendChild(base);
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec(data);
		scripts = !keepScripts && [];

		// Single tag
		if (parsed) {
			return [context.createElement(parsed[1])];
		}

		parsed = buildFragment([data], context, scripts);

		if (scripts && scripts.length) {
			jQuery(scripts).remove();
		}

		return jQuery.merge([], parsed.childNodes);
	};

	/**
  * Load a url into a page
  */
	jQuery.fn.load = function (url, params, callback) {
		var selector,
		    type,
		    response,
		    self = this,
		    off = url.indexOf(" ");

		if (off > -1) {
			selector = stripAndCollapse(url.slice(off));
			url = url.slice(0, off);
		}

		// If it's a function
		if (isFunction(params)) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

			// Otherwise, build a param string
		} else if (params && typeof params === "object") {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if (self.length > 0) {
			jQuery.ajax({
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			}).done(function (responseText) {

				// Save response for use in complete callback
				response = arguments;

				self.html(selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

				// Otherwise use the full result
				responseText);

				// If the request succeeds, this function gets "data", "status", "jqXHR"
				// but they are ignored because response was set above.
				// If it fails, this function gets "jqXHR", "status", "error"
			}).always(callback && function (jqXHR, status) {
				self.each(function () {
					callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
				});
			});
		}

		return this;
	};

	// Attach a bunch of functions for handling common AJAX events
	jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
		jQuery.fn[type] = function (fn) {
			return this.on(type, fn);
		};
	});

	jQuery.expr.pseudos.animated = function (elem) {
		return jQuery.grep(jQuery.timers, function (fn) {
			return elem === fn.elem;
		}).length;
	};

	jQuery.offset = {
		setOffset: function setOffset(elem, options, i) {
			var curPosition,
			    curLeft,
			    curCSSTop,
			    curTop,
			    curOffset,
			    curCSSLeft,
			    calculatePosition,
			    position = jQuery.css(elem, "position"),
			    curElem = jQuery(elem),
			    props = {};

			// Set position first, in-case top/left are set even on static elem
			if (position === "static") {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css(elem, "top");
			curCSSLeft = jQuery.css(elem, "left");
			calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if (calculatePosition) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat(curCSSTop) || 0;
				curLeft = parseFloat(curCSSLeft) || 0;
			}

			if (isFunction(options)) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call(elem, i, jQuery.extend({}, curOffset));
			}

			if (options.top != null) {
				props.top = options.top - curOffset.top + curTop;
			}
			if (options.left != null) {
				props.left = options.left - curOffset.left + curLeft;
			}

			if ("using" in options) {
				options.using.call(elem, props);
			} else {
				curElem.css(props);
			}
		}
	};

	jQuery.fn.extend({

		// offset() relates an element's border box to the document origin
		offset: function offset(options) {

			// Preserve chaining for setter
			if (arguments.length) {
				return options === undefined ? this : this.each(function (i) {
					jQuery.offset.setOffset(this, options, i);
				});
			}

			var rect,
			    win,
			    elem = this[0];

			if (!elem) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if (!elem.getClientRects().length) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function position() {
			if (!this[0]) {
				return;
			}

			var offsetParent,
			    offset,
			    doc,
			    elem = this[0],
			    parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if (jQuery.css(elem, "position") === "fixed") {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {

					offsetParent = offsetParent.parentNode;
				}
				if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery(offsetParent).offset();
					parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
					parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
				left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function offsetParent() {
			return this.map(function () {
				var offsetParent = this.offsetParent;

				while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			});
		}
	});

	// Create scrollLeft and scrollTop methods
	jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
		var top = "pageYOffset" === prop;

		jQuery.fn[method] = function (val) {
			return access(this, function (elem, method, val) {

				// Coalesce documents and windows
				var win;
				if (isWindow(elem)) {
					win = elem;
				} else if (elem.nodeType === 9) {
					win = elem.defaultView;
				}

				if (val === undefined) {
					return win ? win[prop] : elem[method];
				}

				if (win) {
					win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
				} else {
					elem[method] = val;
				}
			}, method, val, arguments.length);
		};
	});

	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each(["top", "left"], function (i, prop) {
		jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
			if (computed) {
				computed = curCSS(elem, prop);

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
			}
		});
	});

	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
		jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[funcName] = function (margin, value) {
				var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
				    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

				return access(this, function (elem, type, value) {
					var doc;

					if (isWindow(elem)) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
					}

					// Get document width or height
					if (elem.nodeType === 9) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
					}

					return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css(elem, type, extra) :

					// Set width or height on the element
					jQuery.style(elem, type, value, extra);
				}, type, chainable ? margin : undefined, chainable);
			};
		});
	});

	jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (i, name) {

		// Handle event binding
		jQuery.fn[name] = function (data, fn) {
			return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
		};
	});

	jQuery.fn.extend({
		hover: function hover(fnOver, fnOut) {
			return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
		}
	});

	jQuery.fn.extend({

		bind: function bind(types, data, fn) {
			return this.on(types, null, data, fn);
		},
		unbind: function unbind(types, fn) {
			return this.off(types, null, fn);
		},

		delegate: function delegate(selector, types, data, fn) {
			return this.on(types, selector, data, fn);
		},
		undelegate: function undelegate(selector, types, fn) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
		}
	});

	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function (fn, context) {
		var tmp, args, proxy;

		if (typeof context === "string") {
			tmp = fn[context];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if (!isFunction(fn)) {
			return undefined;
		}

		// Simulated bind
		args = _slice.call(arguments, 2);
		proxy = function proxy() {
			return fn.apply(context || this, args.concat(_slice.call(arguments)));
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function (hold) {
		if (hold) {
			jQuery.readyWait++;
		} else {
			jQuery.ready(true);
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function (obj) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type(obj);
		return (type === "number" || type === "string") &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN(obj - parseFloat(obj));
	};

	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.

	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return jQuery;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,


	// Map over the $ in case of overwrite
	_$ = window.$;

	jQuery.noConflict = function (deep) {
		if (window.$ === jQuery) {
			window.$ = _$;
		}

		if (deep && window.jQuery === jQuery) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if (!noGlobal) {
		window.jQuery = window.$ = jQuery;
	}

	return jQuery;
});

/***/ }),

/***/ "pjHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_register__ = __webpack_require__("fbon");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_linkstate__ = __webpack_require__("CSCC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_utils_firebase__ = __webpack_require__("ZxPa");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'modal-backdrop fade show' });

var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'svg',
	{ 'class': 'icon bg-dark', width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M16.2426 6.34311L6.34309 16.2426C5.95257 16.6331 5.95257 17.2663 6.34309 17.6568C6.73362 18.0473 7.36678 18.0473 7.75731 17.6568L17.6568 7.75732C18.0473 7.36679 18.0473 6.73363 17.6568 6.34311C17.2663 5.95258 16.6331 5.95258 16.2426 6.34311Z', fill: '#212529' }),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M17.6568 16.2426L7.75734 6.34309C7.36681 5.95257 6.73365 5.95257 6.34313 6.34309C5.9526 6.73362 5.9526 7.36678 6.34313 7.75731L16.2426 17.6568C16.6331 18.0473 17.2663 18.0473 17.6568 17.6568C18.0474 17.2663 18.0474 16.6331 17.6568 16.2426Z', fill: '#212529' })
);

var _ref3 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'col-auto' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'h5',
		null,
		' Kirjaudu sis\xE4\xE4n'
	)
);

var _ref4 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref5 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref6 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'button',
	{ 'class': 'btn btn-primary btn-block btn-loading btn-loading-animate', disabled: true },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'svg',
		{ xmlns: 'http://www.w3.org/2000/svg', width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', 'class': 'injected-svg icon', 'data-src': 'assets/img/icons/theme/code/loading.svg' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'title',
			null,
			'Icon For Loading'
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'g',
			{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('polygon', { points: '0 0 24 0 24 24 0 24', opacity: '0' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z', fill: '#000000', 'fill-rule': 'nonzero', transform: 'translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, 12.000000)' })
		)
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'Ladataan'
	)
);

var _ref7 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'h5',
	null,
	'Salasanan alustamisohjeet on nyt l\xE4hetetty s\xE4hk\xF6postiisi!'
);

var _ref8 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'p',
	null,
	'Muistathan katsoa my\xF6s roskapostikansiosi.'
);

var _ref9 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'div',
	{ 'class': 'col-auto' },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'h5',
		null,
		'Unohdin salasanani'
	)
);

var _ref10 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref11 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('br', null);

var _ref12 = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
	'button',
	{ 'class': 'btn btn-primary btn-block btn-loading btn-loading-animate', disabled: true },
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'svg',
		{ xmlns: 'http://www.w3.org/2000/svg', width: '24px', height: '24px', viewBox: '0 0 24 24', version: '1.1', 'class': 'injected-svg icon', 'data-src': 'assets/img/icons/theme/code/loading.svg' },
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'title',
			null,
			'Icon For Loading'
		),
		Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'g',
			{ stroke: 'none', 'stroke-width': '1', fill: 'none', 'fill-rule': 'evenodd' },
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'g',
				null,
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('polygon', { points: '0 0 24 0 24 24 0 24', opacity: '0' })
			),
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('path', { d: 'M12,4 L12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,10.9603196 17.7360885,9.96126435 17.2402578,9.07513926 L18.9856052,8.09853149 C19.6473536,9.28117708 20,10.6161442 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z', fill: '#000000', 'fill-rule': 'nonzero', transform: 'translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, 12.000000)' })
		)
	),
	Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
		'span',
		null,
		'Ladataan'
	)
);

var Login = function (_Component) {
	_inherits(Login, _Component);

	function Login() {
		var _temp, _this, _ret;

		_classCallCheck(this, Login);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.validate = function () {
			var _this$state = _this.state,
			    email = _this$state.email,
			    password = _this$state.password;

			if (!email || !email.split('@')[1] || email.split('@')[1].indexOf('.') === -1 || !email.split('@')[1].split('.')[1]) {
				_this.setState({ error: 'email' });
				return false;
			}

			if (!password || password.length < 6) {
				_this.setState({ error: 'password' });
				return false;
			}

			return true;
		}, _this.submit = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			_this.setState({ loading: true, error: null });

			var _this$state2 = _this.state,
			    email = _this$state2.email,
			    password = _this$state2.password;


			if (_this.validate()) {
				_this.setState({ loading: true });
				__WEBPACK_IMPORTED_MODULE_3_utils_firebase__["a" /* default */].auth().signInWithEmailAndPassword(email, password).catch(function (error) {
					// Handle Errors here.
					_this.setState({ loading: false, error: error });
					console.error(error);
				});
			} else {
				_this.setState({ loading: false });
			}
		}, _this.reset = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			_this.setState({ loading: true, error: null });

			var email = _this.state.email;


			if (email) {
				_this.setState({ loading: true });
				__WEBPACK_IMPORTED_MODULE_3_utils_firebase__["a" /* default */].auth().sendPasswordResetEmail(email).then(function (res) {
					_this.setState({ loading: false, success: true });
				}).catch(function (error) {
					// Handle Errors here.
					_this.setState({ loading: false, error: error });
					console.error(error);
				});
			} else {
				_this.setState({ loading: false });
			}
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Login.prototype.render = function render(props, state) {
		var _h,
		    _h2,
		    _this2 = this;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
			'div',
			null,
			_ref,
			Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
				'div',
				{ 'class': 'modal fade show', id: 'contact-box-modal', tabindex: '-1', role: 'dialog', 'aria-modal': 'true', style: 'display: block;' },
				Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
					'div',
					{ 'class': 'modal-dialog modal-dialog-centered', role: 'document' },
					Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
						'div',
						{ 'class': 'modal-content' },
						Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
							'div',
							{ 'class': 'modal-body' },
							Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'button',
								{ type: 'button', 'class': 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: props.onClose },
								_ref2
							),
							!state.forgot ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'p-4' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'row text-left justify-content-between' },
									_ref3,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'col-auto' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ 'class': 'text-small text-600' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'a',
												{ href: '#', onClick: function onClick(e) {
														e.preventDefault();e.stopImmediatePropagation();props.onRegister();
													} },
												'Luo tunnus'
											)
										)
									)
								),
								state.error && typeof state.error !== 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'alert alert-primary', role: 'alert' },
									'Kirjautuminen ei onnistu, tarkistathan tietosi. Jos ongelma jatkuu, ota yhteytt\xE4 asiakaspalveluun.',
									_ref4,
									_ref5,
									'Virheviesti: "',
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'em',
										null,
										state.error.message
									),
									'"'
								) : null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'form',
									{ onSubmit: this.submit },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'form-group' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h = { type: 'email', 'class': 'form-control', autocomplete: 'email', id: 'email', placeholder: '', onInput: Object(__WEBPACK_IMPORTED_MODULE_2_linkstate__["a" /* default */])(this, 'email'), value: state.email, required: '' }, _h['placeholder'] = 'S\xE4hk\xF6postiosoite', _h)),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'invalid-feedback', style: state.error === 'email' ? 'display:block;' : null },
											'Tarkista s\xE4hk\xF6postiosoitteesi'
										)
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'form-group' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', (_h2 = { type: 'password', autocomplete: 'new-password', 'class': 'form-control', id: 'password', placeholder: '', onInput: Object(__WEBPACK_IMPORTED_MODULE_2_linkstate__["a" /* default */])(this, 'password'), value: state.password, required: '' }, _h2['placeholder'] = 'Salasana', _h2)),
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'invalid-feedback', style: state.error === 'password' ? 'display:block;' : null },
											'Salasana on pakollinen kentt\xE4. Salasanan tulee olla v\xE4hint\xE4\xE4n 6 merkki\xE4.'
										)
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'row justify-content-between  mb-3' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'div',
											{ 'class': 'col-auto' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'a',
												{ 'class': 'text-small', href: '#', onClick: function onClick(e) {
														e.preventDefault();e.stopImmediatePropagation();_this2.setState({ forgot: true, error: null });
													} },
												'Unohditko salasanasi?'
											)
										)
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'form-group' },
										state.loading ? _ref6 : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'button',
											{ 'class': 'btn btn-primary btn-block', type: 'submit', onClick: this.submit },
											'Kirjaudu sis\xE4\xE4n'
										)
									)
								)
							) : state.success ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'p-4' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'row text-left justify-content-between' },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'col-auto' },
										_ref7,
										_ref8,
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'button',
											{ 'class': 'btn btn-primary btn-block mt-4', type: 'submit', onClick: function onClick(e) {
													e.preventDefault();e.stopImmediatePropagation();_this2.setState({ forgot: false, error: null });
												} },
											'Takaisin kirjautumiseen'
										)
									)
								)
							) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
								'div',
								{ 'class': 'p-4' },
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'row text-left justify-content-between' },
									_ref9,
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'col-auto' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'p',
											{ 'class': 'text-small text-600' },
											Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
												'a',
												{ href: '#', onClick: function onClick(e) {
														e.preventDefault();e.stopImmediatePropagation();_this2.setState({ forgot: false, error: null });
													} },
												'Takaisin kirjautumiseen'
											)
										)
									)
								),
								state.error && typeof state.error !== 'string' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'div',
									{ 'class': 'alert alert-primary', role: 'alert' },
									'Salasanan nollaus ei onnistu, tarkistathan tietosi. Jos ongelma jatkuu, ota yhteytt\xE4 asiakaspalveluun.',
									_ref10,
									_ref11,
									'Virheviesti: "',
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'em',
										null,
										state.error.message
									),
									'"'
								) : null,
								Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
									'form',
									{ onSubmit: this.reset },
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'form-group' },
										Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', { 'class': 'form-control', type: 'email', required: true, autocomplete: 'email', placeholder: 'S\xE4hk\xF6postiosoite', onInput: Object(__WEBPACK_IMPORTED_MODULE_2_linkstate__["a" /* default */])(this, 'email'), value: state.email })
									),
									Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
										'div',
										{ 'class': 'form-group' },
										state.loading ? _ref12 : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
											'button',
											{ 'class': 'btn btn-primary btn-block', type: 'submit', onClick: this.reset },
											'L\xE4het\xE4 s\xE4hk\xF6posti'
										)
									)
								)
							)
						)
					)
				)
			)
		);
	};

	return Login;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (false) {
	navigator.serviceWorker.register(__webpack_public_path__ + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "u3et":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ueHA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorCode", function() { return tmp_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventType", function() { return tmp_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebChannel", function() { return tmp_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XhrIo", function() { return tmp_5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createWebChannelTransport", function() { return tmp_1; });
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var g,
    goog = goog || {},
    k = commonjsGlobal;function m(a) {
  return "string" == typeof a;
}function aa(a) {
  return "number" == typeof a;
}function n(a, b) {
  a = a.split(".");b = b || k;for (var c = 0; c < a.length; c++) {
    if (b = b[a[c]], null == b) return null;
  }return b;
}function ba() {}
function p(a) {
  var b = typeof a;if ("object" == b) {
    if (a) {
      if (a instanceof Array) return "array";if (a instanceof Object) return b;var c = Object.prototype.toString.call(a);if ("[object Window]" == c) return "object";if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
    } else return "null";
  } else if ("function" == b && "undefined" == typeof a.call) return "object";return b;
}function q(a) {
  return "array" == p(a);
}function ca(a) {
  var b = p(a);return "array" == b || "object" == b && "number" == typeof a.length;
}function r(a) {
  var b = typeof a;return "object" == b && null != a || "function" == b;
}var t = "closure_uid_" + (1E9 * Math.random() >>> 0),
    da = 0;function ea(a, b, c) {
  return a.call.apply(a.bind, arguments);
}
function fa(a, b, c) {
  if (!a) throw Error();if (2 < arguments.length) {
    var d = Array.prototype.slice.call(arguments, 2);return function () {
      var e = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e, d);return a.apply(b, e);
    };
  }return function () {
    return a.apply(b, arguments);
  };
}function u(a, b, c) {
  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? u = ea : u = fa;return u.apply(null, arguments);
}
function v(a, b) {
  var c = Array.prototype.slice.call(arguments, 1);return function () {
    var d = c.slice();d.push.apply(d, arguments);return a.apply(this, d);
  };
}var w = Date.now || function () {
  return +new Date();
};function x(a, b) {
  function c() {}c.prototype = b.prototype;a.N = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.yb = function (d, e, f) {
    for (var h = Array(arguments.length - 2), l = 2; l < arguments.length; l++) {
      h[l - 2] = arguments[l];
    }return b.prototype[e].apply(d, h);
  };
}function y() {
  this.j = this.j;this.i = this.i;
}var ha = 0;y.prototype.j = !1;y.prototype.la = function () {
  if (!this.j && (this.j = !0, this.G(), 0 != ha)) {
    var a = this[t] || (this[t] = ++da);
  }
};y.prototype.G = function () {
  if (this.i) for (; this.i.length;) {
    this.i.shift()();
  }
};var ja = Array.prototype.indexOf ? function (a, b) {
  return Array.prototype.indexOf.call(a, b, void 0);
} : function (a, b) {
  if (m(a)) return m(b) && 1 == b.length ? a.indexOf(b, 0) : -1;for (var c = 0; c < a.length; c++) {
    if (c in a && a[c] === b) return c;
  }return -1;
},
    la = Array.prototype.forEach ? function (a, b, c) {
  Array.prototype.forEach.call(a, b, c);
} : function (a, b, c) {
  for (var d = a.length, e = m(a) ? a.split("") : a, f = 0; f < d; f++) {
    f in e && b.call(c, e[f], f, a);
  }
};
function ma(a) {
  a: {
    var b = na;for (var c = a.length, d = m(a) ? a.split("") : a, e = 0; e < c; e++) {
      if (e in d && b.call(void 0, d[e], e, a)) {
        b = e;break a;
      }
    }b = -1;
  }return 0 > b ? null : m(a) ? a.charAt(b) : a[b];
}function oa(a) {
  return Array.prototype.concat.apply([], arguments);
}function pa(a) {
  var b = a.length;if (0 < b) {
    for (var c = Array(b), d = 0; d < b; d++) {
      c[d] = a[d];
    }return c;
  }return [];
}function qa(a) {
  return (/^[\s\xa0]*$/.test(a)
  );
}var ra = String.prototype.trim ? function (a) {
  return a.trim();
} : function (a) {
  return (/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]
  );
};function z(a, b) {
  return -1 != a.indexOf(b);
}function sa(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}var A;a: {
  var ta = k.navigator;if (ta) {
    var ua = ta.userAgent;if (ua) {
      A = ua;break a;
    }
  }A = "";
}function va(a, b, c) {
  for (var d in a) {
    b.call(c, a[d], d, a);
  }
}function wa(a) {
  var b = {},
      c;for (c in a) {
    b[c] = a[c];
  }return b;
}var xa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function ya(a, b) {
  for (var c, d, e = 1; e < arguments.length; e++) {
    d = arguments[e];for (c in d) {
      a[c] = d[c];
    }for (var f = 0; f < xa.length; f++) {
      c = xa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
  }
}function za(a) {
  za[" "](a);return a;
}za[" "] = ba;function Aa(a, b) {
  var c = Ba;return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}var Ca = z(A, "Opera"),
    B = z(A, "Trident") || z(A, "MSIE"),
    Da = z(A, "Edge"),
    Ea = Da || B,
    Fa = z(A, "Gecko") && !(z(A.toLowerCase(), "webkit") && !z(A, "Edge")) && !(z(A, "Trident") || z(A, "MSIE")) && !z(A, "Edge"),
    Ga = z(A.toLowerCase(), "webkit") && !z(A, "Edge");function Ha() {
  var a = k.document;return a ? a.documentMode : void 0;
}var Ia;
a: {
  var Ja = "",
      Ka = function () {
    var a = A;if (Fa) return (/rv:([^\);]+)(\)|;)/.exec(a)
    );if (Da) return (/Edge\/([\d\.]+)/.exec(a)
    );if (B) return (/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a)
    );if (Ga) return (/WebKit\/(\S+)/.exec(a)
    );if (Ca) return (/(?:Version)[ \/]?(\S+)/.exec(a)
    );
  }();Ka && (Ja = Ka ? Ka[1] : "");if (B) {
    var La = Ha();if (null != La && La > parseFloat(Ja)) {
      Ia = String(La);break a;
    }
  }Ia = Ja;
}var Ba = {};
function Ma(a) {
  return Aa(a, function () {
    for (var b = 0, c = ra(String(Ia)).split("."), d = ra(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++) {
      var h = c[f] || "",
          l = d[f] || "";do {
        h = /(\d*)(\D*)(.*)/.exec(h) || ["", "", "", ""];l = /(\d*)(\D*)(.*)/.exec(l) || ["", "", "", ""];if (0 == h[0].length && 0 == l[0].length) break;b = sa(0 == h[1].length ? 0 : parseInt(h[1], 10), 0 == l[1].length ? 0 : parseInt(l[1], 10)) || sa(0 == h[2].length, 0 == l[2].length) || sa(h[2], l[2]);h = h[3];l = l[3];
      } while (0 == b);
    }return 0 <= b;
  });
}var Na;var Oa = k.document;
Na = Oa && B ? Ha() || ("CSS1Compat" == Oa.compatMode ? parseInt(Ia, 10) : 5) : void 0;var Pa = !B || 9 <= Number(Na),
    Qa = B && !Ma("9"),
    Ra = function () {
  if (!k.addEventListener || !Object.defineProperty) return !1;var a = !1,
      b = Object.defineProperty({}, "passive", { get: function get() {
      a = !0;
    } });try {
    k.addEventListener("test", ba, b), k.removeEventListener("test", ba, b);
  } catch (c) {}return a;
}();function C(a, b) {
  this.type = a;this.a = this.target = b;this.Ja = !0;
}C.prototype.b = function () {
  this.Ja = !1;
};function D(a, b) {
  C.call(this, a ? a.type : "");this.relatedTarget = this.a = this.target = null;this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;this.key = "";this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;this.pointerId = 0;this.pointerType = "";this.c = null;if (a) {
    var c = this.type = a.type,
        d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;this.target = a.target || a.srcElement;this.a = b;if (b = a.relatedTarget) {
      if (Fa) {
        a: {
          try {
            za(b.nodeName);var e = !0;break a;
          } catch (f) {}e = !1;
        }e || (b = null);
      }
    } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);this.relatedTarget = b;d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);this.button = a.button;this.key = a.key || "";this.ctrlKey = a.ctrlKey;this.altKey = a.altKey;this.shiftKey = a.shiftKey;this.metaKey = a.metaKey;this.pointerId = a.pointerId || 0;this.pointerType = m(a.pointerType) ? a.pointerType : Sa[a.pointerType] || "";this.c = a;a.defaultPrevented && this.b();
  }
}x(D, C);var Sa = { 2: "touch", 3: "pen", 4: "mouse" };D.prototype.b = function () {
  D.N.b.call(this);var a = this.c;if (a.preventDefault) a.preventDefault();else if (a.returnValue = !1, Qa) try {
    if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1;
  } catch (b) {}
};var E = "closure_listenable_" + (1E6 * Math.random() | 0),
    Ta = 0;function Ua(a, b, c, d, e) {
  this.listener = a;this.proxy = null;this.src = b;this.type = c;this.capture = !!d;this.da = e;this.key = ++Ta;this.X = this.Z = !1;
}function Va(a) {
  a.X = !0;a.listener = null;a.proxy = null;a.src = null;a.da = null;
}function Wa(a) {
  this.src = a;this.a = {};this.b = 0;
}Wa.prototype.add = function (a, b, c, d, e) {
  var f = a.toString();a = this.a[f];a || (a = this.a[f] = [], this.b++);var h = Xa(a, b, d, e);-1 < h ? (b = a[h], c || (b.Z = !1)) : (b = new Ua(b, this.src, f, !!d, e), b.Z = c, a.push(b));return b;
};function Ya(a, b) {
  var c = b.type;if (c in a.a) {
    var d = a.a[c],
        e = ja(d, b),
        f;(f = 0 <= e) && Array.prototype.splice.call(d, e, 1);f && (Va(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
  }
}
function Xa(a, b, c, d) {
  for (var e = 0; e < a.length; ++e) {
    var f = a[e];if (!f.X && f.listener == b && f.capture == !!c && f.da == d) return e;
  }return -1;
}var Za = "closure_lm_" + (1E6 * Math.random() | 0),
    $a = {};function bb(a, b, c, d, e) {
  if (d && d.once) return cb(a, b, c, d, e);if (q(b)) {
    for (var f = 0; f < b.length; f++) {
      bb(a, b[f], c, d, e);
    }return null;
  }c = db(c);return a && a[E] ? a.Aa(b, c, r(d) ? !!d.capture : !!d, e) : eb(a, b, c, !1, d, e);
}
function eb(a, b, c, d, e, f) {
  if (!b) throw Error("Invalid event type");var h = r(e) ? !!e.capture : !!e;if (h && !Pa) return null;var l = fb(a);l || (a[Za] = l = new Wa(a));c = l.add(b, c, d, h, f);if (c.proxy) return c;d = gb();c.proxy = d;d.src = a;d.listener = c;if (a.addEventListener) Ra || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);else if (a.attachEvent) a.attachEvent(hb(b.toString()), d);else if (a.addListener && a.removeListener) a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");return c;
}function gb() {
  var a = ib,
      b = Pa ? function (c) {
    return a.call(b.src, b.listener, c);
  } : function (c) {
    c = a.call(b.src, b.listener, c);if (!c) return c;
  };return b;
}function cb(a, b, c, d, e) {
  if (q(b)) {
    for (var f = 0; f < b.length; f++) {
      cb(a, b[f], c, d, e);
    }return null;
  }c = db(c);return a && a[E] ? a.Ba(b, c, r(d) ? !!d.capture : !!d, e) : eb(a, b, c, !0, d, e);
}
function jb(a, b, c, d, e) {
  if (q(b)) for (var f = 0; f < b.length; f++) {
    jb(a, b[f], c, d, e);
  } else (d = r(d) ? !!d.capture : !!d, c = db(c), a && a[E]) ? (a = a.c, b = String(b).toString(), b in a.a && (f = a.a[b], c = Xa(f, c, d, e), -1 < c && (Va(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = fb(a)) && (b = a.a[b.toString()], a = -1, b && (a = Xa(b, c, d, e)), (c = -1 < a ? b[a] : null) && kb(c));
}
function kb(a) {
  if (!aa(a) && a && !a.X) {
    var b = a.src;if (b && b[E]) Ya(b.c, a);else {
      var c = a.type,
          d = a.proxy;b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(hb(c), d) : b.addListener && b.removeListener && b.removeListener(d);(c = fb(b)) ? (Ya(c, a), 0 == c.b && (c.src = null, b[Za] = null)) : Va(a);
    }
  }
}function hb(a) {
  return a in $a ? $a[a] : $a[a] = "on" + a;
}function lb(a, b) {
  var c = a.listener,
      d = a.da || a.src;a.Z && kb(a);return c.call(d, b);
}
function ib(a, b) {
  return a.X ? !0 : Pa ? lb(a, new D(b, this)) : (b = new D(b || n("window.event"), this), lb(a, b));
}function fb(a) {
  a = a[Za];return a instanceof Wa ? a : null;
}var mb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);function db(a) {
  if ("function" == p(a)) return a;a[mb] || (a[mb] = function (b) {
    return a.handleEvent(b);
  });return a[mb];
}function G() {
  y.call(this);this.c = new Wa(this);this.J = this;this.B = null;
}x(G, y);G.prototype[E] = !0;g = G.prototype;g.addEventListener = function (a, b, c, d) {
  bb(this, a, b, c, d);
};g.removeEventListener = function (a, b, c, d) {
  jb(this, a, b, c, d);
};
g.dispatchEvent = function (a) {
  var b,
      c = this.B;if (c) for (b = []; c; c = c.B) {
    b.push(c);
  }c = this.J;var d = a.type || a;if (m(a)) a = new C(a, c);else if (a instanceof C) a.target = a.target || c;else {
    var e = a;a = new C(d, c);ya(a, e);
  }e = !0;if (b) for (var f = b.length - 1; 0 <= f; f--) {
    var h = a.a = b[f];e = nb(h, d, !0, a) && e;
  }h = a.a = c;e = nb(h, d, !0, a) && e;e = nb(h, d, !1, a) && e;if (b) for (f = 0; f < b.length; f++) {
    h = a.a = b[f], e = nb(h, d, !1, a) && e;
  }return e;
};
g.G = function () {
  G.N.G.call(this);if (this.c) {
    var a = this.c,
        c;for (c in a.a) {
      for (var d = a.a[c], e = 0; e < d.length; e++) {
        Va(d[e]);
      }delete a.a[c];a.b--;
    }
  }this.B = null;
};g.Aa = function (a, b, c, d) {
  return this.c.add(String(a), b, !1, c, d);
};g.Ba = function (a, b, c, d) {
  return this.c.add(String(a), b, !0, c, d);
};
function nb(a, b, c, d) {
  b = a.c.a[String(b)];if (!b) return !0;b = b.concat();for (var e = !0, f = 0; f < b.length; ++f) {
    var h = b[f];if (h && !h.X && h.capture == c) {
      var l = h.listener,
          F = h.da || h.src;h.Z && Ya(a.c, h);e = !1 !== l.call(F, d) && e;
    }
  }return e && 0 != d.Ja;
}var ob = k.JSON.stringify;function pb(a, b) {
  this.c = a;this.f = b;this.b = 0;this.a = null;
}pb.prototype.get = function () {
  if (0 < this.b) {
    this.b--;var a = this.a;this.a = a.next;a.next = null;
  } else a = this.c();return a;
};function qb() {
  this.b = this.a = null;
}var sb = new pb(function () {
  return new rb();
}, function (a) {
  a.reset();
});qb.prototype.add = function (a, b) {
  var c = sb.get();c.set(a, b);this.b ? this.b.next = c : this.a = c;this.b = c;
};function tb() {
  var a = ub,
      b = null;a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null);return b;
}function rb() {
  this.next = this.b = this.a = null;
}rb.prototype.set = function (a, b) {
  this.a = a;this.b = b;this.next = null;
};rb.prototype.reset = function () {
  this.next = this.b = this.a = null;
};function vb(a) {
  k.setTimeout(function () {
    throw a;
  }, 0);
}function wb(a, b) {
  xb || yb();zb || (xb(), zb = !0);ub.add(a, b);
}var xb;function yb() {
  var a = k.Promise.resolve(void 0);xb = function xb() {
    a.then(Ab);
  };
}var zb = !1,
    ub = new qb();function Ab() {
  for (var a; a = tb();) {
    try {
      a.a.call(a.b);
    } catch (c) {
      vb(c);
    }var b = sb;b.f(a);100 > b.b && (b.b++, a.next = b.a, b.a = a);
  }zb = !1;
}function Cb(a, b) {
  G.call(this);this.b = a || 1;this.a = b || k;this.f = u(this.gb, this);this.g = w();
}x(Cb, G);g = Cb.prototype;g.ba = !1;g.L = null;g.gb = function () {
  if (this.ba) {
    var a = w() - this.g;0 < a && a < .8 * this.b ? this.L = this.a.setTimeout(this.f, this.b - a) : (this.L && (this.a.clearTimeout(this.L), this.L = null), this.dispatchEvent("tick"), this.ba && (Db(this), this.start()));
  }
};g.start = function () {
  this.ba = !0;this.L || (this.L = this.a.setTimeout(this.f, this.b), this.g = w());
};function Db(a) {
  a.ba = !1;a.L && (a.a.clearTimeout(a.L), a.L = null);
}
g.G = function () {
  Cb.N.G.call(this);Db(this);delete this.a;
};function Eb(a, b, c) {
  if ("function" == p(a)) c && (a = u(a, c));else if (a && "function" == typeof a.handleEvent) a = u(a.handleEvent, a);else throw Error("Invalid listener argument");return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0);
}function Fb(a, b, c) {
  y.call(this);this.f = null != c ? u(a, c) : a;this.c = b;this.b = u(this.ab, this);this.a = [];
}x(Fb, y);g = Fb.prototype;g.ea = !1;g.U = null;g.Ua = function (a) {
  this.a = arguments;this.U ? this.ea = !0 : Gb(this);
};g.G = function () {
  Fb.N.G.call(this);this.U && (k.clearTimeout(this.U), this.U = null, this.ea = !1, this.a = []);
};g.ab = function () {
  this.U = null;this.ea && (this.ea = !1, Gb(this));
};function Gb(a) {
  a.U = Eb(a.b, a.c);a.f.apply(null, a.a);
}function H(a) {
  y.call(this);this.b = a;this.a = {};
}x(H, y);var Hb = [];function Ib(a, b, c, d) {
  q(c) || (c && (Hb[0] = c.toString()), c = Hb);for (var e = 0; e < c.length; e++) {
    var f = bb(b, c[e], d || a.handleEvent, !1, a.b || a);if (!f) break;a.a[f.key] = f;
  }
}function Jb(a) {
  va(a.a, function (b, c) {
    this.a.hasOwnProperty(c) && kb(b);
  }, a);a.a = {};
}H.prototype.G = function () {
  H.N.G.call(this);Jb(this);
};H.prototype.handleEvent = function () {
  throw Error("EventHandler.handleEvent not implemented");
};function Kb() {}var I = new G();function Lb(a) {
  C.call(this, "serverreachability", a);
}x(Lb, C);function J(a) {
  I.dispatchEvent(new Lb(I, a));
}function Mb(a) {
  C.call(this, "statevent", a);
}x(Mb, C);function K(a) {
  I.dispatchEvent(new Mb(I, a));
}function Nb(a) {
  C.call(this, "timingevent", a);
}x(Nb, C);function Ob(a, b) {
  if ("function" != p(a)) throw Error("Fn must not be null and must be a function");return k.setTimeout(function () {
    a();
  }, b);
}var Pb = { NO_ERROR: 0, hb: 1, ob: 2, nb: 3, kb: 4, mb: 5, pb: 6, Ma: 7, TIMEOUT: 8, sb: 9 };var Qb = { jb: "complete", wb: "success", Na: "error", Ma: "abort", ub: "ready", vb: "readystatechange", TIMEOUT: "timeout", qb: "incrementaldata", tb: "progress", lb: "downloadprogress", xb: "uploadprogress" };function Rb() {}Rb.prototype.a = null;function Sb(a) {
  var b;(b = a.a) || (b = a.a = {});return b;
}function Tb() {}var L = { OPEN: "a", ib: "b", Na: "c", rb: "d" };function Ub() {
  C.call(this, "d");
}x(Ub, C);function Vb() {
  C.call(this, "c");
}x(Vb, C);var Wb;function Xb() {}x(Xb, Rb);Wb = new Xb();function M(a, b, c) {
  this.g = a;this.W = b;this.V = c || 1;this.I = new H(this);this.O = Yb;a = Ea ? 125 : void 0;this.P = new Cb(a);this.h = null;this.b = !1;this.l = this.D = this.f = this.F = this.v = this.R = this.i = null;this.j = [];this.a = null;this.A = 0;this.c = this.w = null;this.o = -1;this.m = !1;this.J = 0;this.B = null;this.s = this.S = this.H = !1;
}var Yb = 45E3,
    Zb = {},
    $b = {};g = M.prototype;g.setTimeout = function (a) {
  this.O = a;
};function ac(a, b, c) {
  a.F = 1;a.f = bc(N(b));a.l = c;a.H = !0;cc(a, null);
}function dc(a, b, c, d) {
  a.F = 1;a.f = bc(N(b));a.l = null;a.H = c;cc(a, d);
}
function cc(a, b) {
  a.v = w();ec(a);a.D = N(a.f);fc(a.D, "t", a.V);a.A = 0;a.a = a.g.$(a.g.Y() ? b : null);0 < a.J && (a.B = new Fb(u(a.Ka, a, a.a), a.J));Ib(a.I, a.a, "readystatechange", a.eb);b = a.h ? wa(a.h) : {};a.l ? (a.w || (a.w = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.ca(a.D, a.w, a.l, b)) : (a.w = "GET", a.a.ca(a.D, a.w, null, b));J(1);
}g.eb = function (a) {
  a = a.target;var b = this.B;b && 3 == O(a) ? b.Ua() : this.Ka(a);
};
g.Ka = function (a) {
  try {
    if (a == this.a) a: {
      var b = O(this.a),
          c = this.a.ya(),
          d = this.a.T();if (!(3 > b || 3 == b && !Ea && !this.a.aa())) {
        this.m || 4 != b || 7 == c || (8 == c || 0 >= d ? J(3) : J(2));gc(this);var e = this.a.T();this.o = e;var f = this.a.aa();if (this.b = 200 == e) {
          if (this.S && !this.s) {
            b: {
              if (this.a) {
                var h = hc(this.a, "X-HTTP-Initial-Response");if (h && !qa(h)) {
                  var l = h;break b;
                }
              }l = null;
            }if (l) this.s = !0, ic(this, l);else {
              this.b = !1;this.c = 3;K(12);P(this);jc(this);break a;
            }
          }this.H ? (kc(this, b, f), Ea && this.b && 3 == b && (Ib(this.I, this.P, "tick", this.cb), this.P.start())) : ic(this, f);4 == b && P(this);this.b && !this.m && (4 == b ? this.g.na(this) : (this.b = !1, ec(this)));
        } else 400 == e && 0 < f.indexOf("Unknown SID") ? (this.c = 3, K(12)) : (this.c = 0, K(13)), P(this), jc(this);
      }
    }
  } catch (F) {} finally {}
};function kc(a, b, c) {
  for (var d = !0; !a.m && a.A < c.length;) {
    var e = lc(a, c);if (e == $b) {
      4 == b && (a.c = 4, K(14), d = !1);break;
    } else if (e == Zb) {
      a.c = 4;K(15);d = !1;break;
    } else ic(a, e);
  }4 == b && 0 == c.length && (a.c = 1, K(16), d = !1);a.b = a.b && d;d || (P(a), jc(a));
}
g.cb = function () {
  if (this.a) {
    var a = O(this.a),
        b = this.a.aa();this.A < b.length && (gc(this), kc(this, a, b), this.b && 4 != a && ec(this));
  }
};function lc(a, b) {
  var c = a.A,
      d = b.indexOf("\n", c);if (-1 == d) return $b;c = Number(b.substring(c, d));if (isNaN(c)) return Zb;d += 1;if (d + c > b.length) return $b;b = b.substr(d, c);a.A = d + c;return b;
}g.cancel = function () {
  this.m = !0;P(this);
};function ec(a) {
  a.R = w() + a.O;mc(a, a.O);
}function mc(a, b) {
  if (null != a.i) throw Error("WatchDog timer not null");a.i = Ob(u(a.bb, a), b);
}
function gc(a) {
  a.i && (k.clearTimeout(a.i), a.i = null);
}g.bb = function () {
  this.i = null;var a = w();0 <= a - this.R ? (2 != this.F && (J(3), K(17)), P(this), this.c = 2, jc(this)) : mc(this, this.R - a);
};function jc(a) {
  a.g.Da() || a.m || a.g.na(a);
}function P(a) {
  gc(a);var b = a.B;b && "function" == typeof b.la && b.la();a.B = null;Db(a.P);Jb(a.I);a.a && (b = a.a, a.a = null, b.abort(), b.la());
}function ic(a, b) {
  try {
    a.g.Ga(a, b), J(4);
  } catch (c) {}
}function nc(a) {
  if (a.C && "function" == typeof a.C) return a.C();if (m(a)) return a.split("");if (ca(a)) {
    for (var b = [], c = a.length, d = 0; d < c; d++) {
      b.push(a[d]);
    }return b;
  }b = [];c = 0;for (d in a) {
    b[c++] = a[d];
  }return b;
}
function oc(a, b) {
  if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);else if (ca(a) || m(a)) la(a, b, void 0);else {
    if (a.K && "function" == typeof a.K) var c = a.K();else if (a.C && "function" == typeof a.C) c = void 0;else if (ca(a) || m(a)) {
      c = [];for (var d = a.length, e = 0; e < d; e++) {
        c.push(e);
      }
    } else for (e in c = [], d = 0, a) {
      c[d++] = e;
    }d = nc(a);e = d.length;for (var f = 0; f < e; f++) {
      b.call(void 0, d[f], c && c[f], a);
    }
  }
}function Q(a, b) {
  this.b = {};this.a = [];this.c = 0;var c = arguments.length;if (1 < c) {
    if (c % 2) throw Error("Uneven number of arguments");for (var d = 0; d < c; d += 2) {
      this.set(arguments[d], arguments[d + 1]);
    }
  } else if (a) if (a instanceof Q) for (c = a.K(), d = 0; d < c.length; d++) {
    this.set(c[d], a.get(c[d]));
  } else for (d in a) {
    this.set(d, a[d]);
  }
}g = Q.prototype;g.C = function () {
  pc(this);for (var a = [], b = 0; b < this.a.length; b++) {
    a.push(this.b[this.a[b]]);
  }return a;
};g.K = function () {
  pc(this);return this.a.concat();
};
function qc(a) {
  a.b = {};a.a.length = 0;a.c = 0;
}function rc(a, b) {
  R(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && pc(a));
}function pc(a) {
  if (a.c != a.a.length) {
    for (var b = 0, c = 0; b < a.a.length;) {
      var d = a.a[b];R(a.b, d) && (a.a[c++] = d);b++;
    }a.a.length = c;
  }if (a.c != a.a.length) {
    var e = {};for (c = b = 0; b < a.a.length;) {
      d = a.a[b], R(e, d) || (a.a[c++] = d, e[d] = 1), b++;
    }a.a.length = c;
  }
}g.get = function (a, b) {
  return R(this.b, a) ? this.b[a] : b;
};g.set = function (a, b) {
  R(this.b, a) || (this.c++, this.a.push(a));this.b[a] = b;
};
g.forEach = function (a, b) {
  for (var c = this.K(), d = 0; d < c.length; d++) {
    var e = c[d],
        f = this.get(e);a.call(b, f, e, this);
  }
};function R(a, b) {
  return Object.prototype.hasOwnProperty.call(a, b);
}var sc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function tc(a, b) {
  if (a) {
    a = a.split("&");for (var c = 0; c < a.length; c++) {
      var d = a[c].indexOf("="),
          e = null;if (0 <= d) {
        var f = a[c].substring(0, d);e = a[c].substring(d + 1);
      } else f = a[c];b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
    }
  }
}function S(a, b) {
  this.b = this.j = this.f = "";this.i = null;this.g = this.a = "";this.h = !1;var c;a instanceof S ? (this.h = void 0 !== b ? b : a.h, uc(this, a.f), this.j = a.j, vc(this, a.b), wc(this, a.i), this.a = a.a, xc(this, yc(a.c)), this.g = a.g) : a && (c = String(a).match(sc)) ? (this.h = !!b, uc(this, c[1] || "", !0), this.j = zc(c[2] || ""), vc(this, c[3] || "", !0), wc(this, c[4]), this.a = zc(c[5] || "", !0), xc(this, c[6] || "", !0), this.g = zc(c[7] || "")) : (this.h = !!b, this.c = new Ac(null, this.h));
}
S.prototype.toString = function () {
  var a = [],
      b = this.f;b && a.push(Bc(b, Cc, !0), ":");var c = this.b;if (c || "file" == b) a.push("//"), (b = this.j) && a.push(Bc(b, Cc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.i, null != c && a.push(":", String(c));if (c = this.a) this.b && "/" != c.charAt(0) && a.push("/"), a.push(Bc(c, "/" == c.charAt(0) ? Dc : Ec, !0));(c = this.c.toString()) && a.push("?", c);(c = this.g) && a.push("#", Bc(c, Fc));return a.join("");
};
S.prototype.resolve = function (a) {
  var b = N(this),
      c = !!a.f;c ? uc(b, a.f) : c = !!a.j;c ? b.j = a.j : c = !!a.b;c ? vc(b, a.b) : c = null != a.i;var d = a.a;if (c) wc(b, a.i);else if (c = !!a.a) {
    if ("/" != d.charAt(0)) if (this.b && !this.a) d = "/" + d;else {
      var e = b.a.lastIndexOf("/");-1 != e && (d = b.a.substr(0, e + 1) + d);
    }e = d;if (".." == e || "." == e) d = "";else if (z(e, "./") || z(e, "/.")) {
      d = 0 == e.lastIndexOf("/", 0);e = e.split("/");for (var f = [], h = 0; h < e.length;) {
        var l = e[h++];"." == l ? d && h == e.length && f.push("") : ".." == l ? ((1 < f.length || 1 == f.length && "" != f[0]) && f.pop(), d && h == e.length && f.push("")) : (f.push(l), d = !0);
      }d = f.join("/");
    } else d = e;
  }c ? b.a = d : c = "" !== a.c.toString();c ? xc(b, yc(a.c)) : c = !!a.g;c && (b.g = a.g);return b;
};function N(a) {
  return new S(a);
}function uc(a, b, c) {
  a.f = c ? zc(b, !0) : b;a.f && (a.f = a.f.replace(/:$/, ""));
}function vc(a, b, c) {
  a.b = c ? zc(b, !0) : b;
}function wc(a, b) {
  if (b) {
    b = Number(b);if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);a.i = b;
  } else a.i = null;
}function xc(a, b, c) {
  b instanceof Ac ? (a.c = b, Gc(a.c, a.h)) : (c || (b = Bc(b, Hc)), a.c = new Ac(b, a.h));
}
function T(a, b, c) {
  a.c.set(b, c);
}function fc(a, b, c) {
  q(c) || (c = [String(c)]);Ic(a.c, b, c);
}function bc(a) {
  T(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ w()).toString(36));return a;
}function Jc(a) {
  return a instanceof S ? N(a) : new S(a, void 0);
}function Kc(a, b, c, d) {
  var e = new S(null, void 0);a && uc(e, a);b && vc(e, b);c && wc(e, c);d && (e.a = d);return e;
}function zc(a, b) {
  return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function Bc(a, b, c) {
  return m(a) ? (a = encodeURI(a).replace(b, Lc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}function Lc(a) {
  a = a.charCodeAt(0);return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}var Cc = /[#\/\?@]/g,
    Ec = /[#\?:]/g,
    Dc = /[#\?]/g,
    Hc = /[#\?@]/g,
    Fc = /#/g;function Ac(a, b) {
  this.b = this.a = null;this.c = a || null;this.f = !!b;
}function U(a) {
  a.a || (a.a = new Q(), a.b = 0, a.c && tc(a.c, function (b, c) {
    a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
  }));
}g = Ac.prototype;
g.add = function (a, b) {
  U(this);this.c = null;a = V(this, a);var c = this.a.get(a);c || this.a.set(a, c = []);c.push(b);this.b += 1;return this;
};function Mc(a, b) {
  U(a);b = V(a, b);R(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, rc(a.a, b));
}function Nc(a, b) {
  U(a);b = V(a, b);return R(a.a.b, b);
}g.forEach = function (a, b) {
  U(this);this.a.forEach(function (c, d) {
    la(c, function (e) {
      a.call(b, e, d, this);
    }, this);
  }, this);
};
g.K = function () {
  U(this);for (var a = this.a.C(), b = this.a.K(), c = [], d = 0; d < b.length; d++) {
    for (var e = a[d], f = 0; f < e.length; f++) {
      c.push(b[d]);
    }
  }return c;
};g.C = function (a) {
  U(this);var b = [];if (m(a)) Nc(this, a) && (b = oa(b, this.a.get(V(this, a))));else {
    a = this.a.C();for (var c = 0; c < a.length; c++) {
      b = oa(b, a[c]);
    }
  }return b;
};g.set = function (a, b) {
  U(this);this.c = null;a = V(this, a);Nc(this, a) && (this.b -= this.a.get(a).length);this.a.set(a, [b]);this.b += 1;return this;
};
g.get = function (a, b) {
  if (!a) return b;a = this.C(a);return 0 < a.length ? String(a[0]) : b;
};function Ic(a, b, c) {
  Mc(a, b);0 < c.length && (a.c = null, a.a.set(V(a, b), pa(c)), a.b += c.length);
}g.toString = function () {
  if (this.c) return this.c;if (!this.a) return "";for (var a = [], b = this.a.K(), c = 0; c < b.length; c++) {
    var d = b[c],
        e = encodeURIComponent(String(d));d = this.C(d);for (var f = 0; f < d.length; f++) {
      var h = e;"" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));a.push(h);
    }
  }return this.c = a.join("&");
};
function yc(a) {
  var b = new Ac();b.c = a.c;a.a && (b.a = new Q(a.a), b.b = a.b);return b;
}function V(a, b) {
  b = String(b);a.f && (b = b.toLowerCase());return b;
}function Gc(a, b) {
  b && !a.f && (U(a), a.c = null, a.a.forEach(function (c, d) {
    var e = d.toLowerCase();d != e && (Mc(this, d), Ic(this, e, c));
  }, a));a.f = b;
}function Qc() {}function Rc() {}x(Rc, Qc);function Sc(a) {
  this.a = a;this.b = this.h = null;this.g = !1;this.i = null;this.c = -1;this.l = this.f = null;
}g = Sc.prototype;g.M = null;function Uc(a) {
  var b = a.a.F.a;if (null != b) K(4), b ? (K(10), Vc(a.a, a, !1)) : (K(11), Vc(a.a, a, !0));else {
    a.b = new M(a, void 0, void 0);a.b.h = a.h;b = a.a;b = Wc(b, b.Y() ? a.f : null, a.i);K(4);fc(b, "TYPE", "xmlhttp");var c = a.a.j,
        d = a.a.I;c && d && T(b, c, d);dc(a.b, b, !1, a.f);
  }
}g.$ = function (a) {
  return this.a.$(a);
};g.abort = function () {
  this.b && (this.b.cancel(), this.b = null);this.c = -1;
};g.Da = function () {
  return !1;
};
g.Ga = function (a, b) {
  this.c = a.o;if (0 == this.M) {
    if (!this.a.o && (a = a.a)) {
      var c = hc(a, "X-Client-Wire-Protocol");this.l = c ? c : null;this.a.j && (a = hc(a, "X-HTTP-Session-Id")) && (this.a.I = a);
    }if (b) {
      try {
        var d = this.a.ja.a.parse(b);
      } catch (e) {
        b = this.a;b.m = this.c;W(b, 2);return;
      }this.f = d[0];
    } else b = this.a, b.m = this.c, W(b, 2);
  } else if (1 == this.M) if (this.g) K(6);else if ("11111" == b) {
    if (K(5), this.g = !0, !B || 10 <= Number(Na)) this.c = 200, this.b.cancel(), K(11), Vc(this.a, this, !0);
  } else K(7), this.g = !1;
};
g.na = function () {
  this.c = this.b.o;if (this.b.b) 0 == this.M ? (this.M = 1, Uc(this)) : 1 == this.M && (this.g ? (K(11), Vc(this.a, this, !0)) : (K(10), Vc(this.a, this, !1)));else {
    0 == this.M ? K(8) : 1 == this.M && K(9);var a = this.a;a.m = this.c;W(a, 2);
  }
};g.Y = function () {
  return this.a.Y();
};g.ma = function () {
  return this.a.ma();
};function Xc() {
  this.a = this.b = null;
}function Yc() {
  this.a = new Q();
}function Zc(a) {
  var b = typeof a;return "object" == b && a || "function" == b ? "o" + (a[t] || (a[t] = ++da)) : b.charAt(0) + a;
}Yc.prototype.add = function (a) {
  this.a.set(Zc(a), a);
};Yc.prototype.C = function () {
  return this.a.C();
};function $c(a, b) {
  this.b = a;this.a = b;
}function ad(a) {
  this.g = a || bd;k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.ka && k.ka.Ea && k.ka.Ea() && k.ka.Ea().zb);this.f = a ? this.g : 1;this.a = null;1 < this.f && (this.a = new Yc());this.b = null;this.c = [];
}var bd = 10;function cd(a, b) {
  !a.a && (z(b, "spdy") || z(b, "quic") || z(b, "h2")) && (a.f = a.g, a.a = new Yc(), a.b && (dd(a, a.b), a.b = null));
}function ed(a) {
  return a.b ? !0 : a.a ? a.a.a.c >= a.f : !1;
}
function fd(a) {
  return a.b ? 1 : a.a ? a.a.a.c : 0;
}function gd(a, b) {
  a.b ? a = a.b == b : a.a ? (b = Zc(b), a = R(a.a.a.b, b)) : a = !1;return a;
}function dd(a, b) {
  a.a ? a.a.add(b) : a.b = b;
}function hd(a, b) {
  if (a.b && a.b == b) a.b = null;else {
    var c;if (c = a.a) c = Zc(b), c = R(a.a.a.b, c);c && rc(a.a.a, Zc(b));
  }
}ad.prototype.cancel = function () {
  this.c = id(this);this.b ? (this.b.cancel(), this.b = null) : this.a && 0 != this.a.a.c && (la(this.a.C(), function (a) {
    a.cancel();
  }), qc(this.a.a));
};
function id(a) {
  if (null != a.b) return a.c.concat(a.b.j);if (null != a.a && 0 != a.a.a.c) {
    var b = a.c;la(a.a.C(), function (c) {
      b = b.concat(c.j);
    });return b;
  }return pa(a.c);
}function jd() {}jd.prototype.stringify = function (a) {
  return k.JSON.stringify(a, void 0);
};jd.prototype.parse = function (a) {
  return k.JSON.parse(a, void 0);
};function kd() {
  this.a = new jd();
}function ld(a, b, c) {
  var d = c || "";try {
    oc(a, function (e, f) {
      var h = e;r(e) && (h = ob(e));b.push(d + f + "=" + encodeURIComponent(h));
    });
  } catch (e) {
    throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
  }
}function md(a, b) {
  var c = new Kb();if (k.Image) {
    var d = new Image();d.onload = v(nd, c, d, "TestLoadImage: loaded", !0, b);d.onerror = v(nd, c, d, "TestLoadImage: error", !1, b);d.onabort = v(nd, c, d, "TestLoadImage: abort", !1, b);d.ontimeout = v(nd, c, d, "TestLoadImage: timeout", !1, b);k.setTimeout(function () {
      if (d.ontimeout) d.ontimeout();
    }, 1E4);d.src = a;
  } else b(!1);
}function nd(a, b, c, d, e) {
  try {
    b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
  } catch (f) {}
}var od = k.JSON.parse;function X(a) {
  G.call(this);this.headers = new Q();this.H = a || null;this.b = !1;this.s = this.a = null;this.A = "";this.h = 0;this.f = "";this.g = this.w = this.l = this.v = !1;this.o = 0;this.m = null;this.I = pd;this.D = this.F = !1;
}x(X, G);var pd = "",
    qd = /^https?$/i,
    rd = ["POST", "PUT"];g = X.prototype;
g.ca = function (a, b, c, d) {
  if (this.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.A + "; newUri=" + a);b = b ? b.toUpperCase() : "GET";this.A = a;this.f = "";this.h = 0;this.v = !1;this.b = !0;this.a = new XMLHttpRequest();this.s = this.H ? Sb(this.H) : Sb(Wb);this.a.onreadystatechange = u(this.Fa, this);try {
    this.w = !0, this.a.open(b, String(a), !0), this.w = !1;
  } catch (f) {
    sd(this, f);return;
  }a = c || "";var e = new Q(this.headers);d && oc(d, function (f, h) {
    e.set(h, f);
  });d = ma(e.K());c = k.FormData && a instanceof k.FormData;!(0 <= ja(rd, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");e.forEach(function (f, h) {
    this.a.setRequestHeader(h, f);
  }, this);this.I && (this.a.responseType = this.I);"withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);try {
    td(this), 0 < this.o && ((this.D = ud(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = u(this.Ca, this)) : this.m = Eb(this.Ca, this.o, this)), this.l = !0, this.a.send(a), this.l = !1;
  } catch (f) {
    sd(this, f);
  }
};
function ud(a) {
  return B && Ma(9) && aa(a.timeout) && void 0 !== a.ontimeout;
}function na(a) {
  return "content-type" == a.toLowerCase();
}g.Ca = function () {
  "undefined" != typeof goog && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, this.dispatchEvent("timeout"), this.abort(8));
};function sd(a, b) {
  a.b = !1;a.a && (a.g = !0, a.a.abort(), a.g = !1);a.f = b;a.h = 5;vd(a);wd(a);
}function vd(a) {
  a.v || (a.v = !0, a.dispatchEvent("complete"), a.dispatchEvent("error"));
}
g.abort = function (a) {
  this.a && this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1, this.h = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), wd(this));
};g.G = function () {
  this.a && (this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1), wd(this, !0));X.N.G.call(this);
};g.Fa = function () {
  this.j || (this.w || this.l || this.g ? xd(this) : this.$a());
};g.$a = function () {
  xd(this);
};
function xd(a) {
  if (a.b && "undefined" != typeof goog && (!a.s[1] || 4 != O(a) || 2 != a.T())) if (a.l && 4 == O(a)) Eb(a.Fa, 0, a);else if (a.dispatchEvent("readystatechange"), 4 == O(a)) {
    a.b = !1;try {
      var b = a.T();a: switch (b) {case 200:case 201:case 202:case 204:case 206:case 304:case 1223:
          var c = !0;break a;default:
          c = !1;}var d;if (!(d = c)) {
        var e;if (e = 0 === b) {
          var f = String(a.A).match(sc)[1] || null;if (!f && k.self && k.self.location) {
            var h = k.self.location.protocol;f = h.substr(0, h.length - 1);
          }e = !qd.test(f ? f.toLowerCase() : "");
        }d = e;
      }d ? (a.dispatchEvent("complete"), a.dispatchEvent("success")) : (a.h = 6, a.f = a.za() + " [" + a.T() + "]", vd(a));
    } finally {
      wd(a);
    }
  }
}function wd(a, b) {
  if (a.a) {
    td(a);var c = a.a,
        d = a.s[0] ? ba : null;a.a = null;a.s = null;b || a.dispatchEvent("ready");try {
      c.onreadystatechange = d;
    } catch (e) {}
  }
}function td(a) {
  a.a && a.D && (a.a.ontimeout = null);a.m && (k.clearTimeout(a.m), a.m = null);
}function O(a) {
  return a.a ? a.a.readyState : 0;
}g.T = function () {
  try {
    return 2 < O(this) ? this.a.status : -1;
  } catch (a) {
    return -1;
  }
};g.za = function () {
  try {
    return 2 < O(this) ? this.a.statusText : "";
  } catch (a) {
    return "";
  }
};
g.aa = function () {
  try {
    return this.a ? this.a.responseText : "";
  } catch (a) {
    return "";
  }
};g.Va = function (a) {
  if (this.a) {
    var b = this.a.responseText;a && 0 == b.indexOf(a) && (b = b.substring(a.length));return od(b);
  }
};function hc(a, b) {
  return a.a ? a.a.getResponseHeader(b) : null;
}g.ya = function () {
  return this.h;
};g.Ya = function () {
  return m(this.f) ? this.f : String(this.f);
};function yd(a) {
  var b = "";va(a, function (c, d) {
    b += d;b += ":";b += c;b += "\r\n";
  });return b;
}function zd(a, b, c) {
  a: {
    for (d in c) {
      var d = !1;break a;
    }d = !0;
  }if (d) return a;c = yd(c);if (m(a)) {
    b = encodeURIComponent(String(b));c = null != c ? "=" + encodeURIComponent(String(c)) : "";if (b += c) {
      c = a.indexOf("#");0 > c && (c = a.length);d = a.indexOf("?");if (0 > d || d > c) {
        d = c;var e = "";
      } else e = a.substring(d + 1, c);a = [a.substr(0, d), e, a.substr(c)];c = a[1];a[1] = b ? c ? c + "&" + b : b : c;a = a[0] + (a[1] ? "?" + a[1] : "") + a[2];
    }return a;
  }T(a, b, c);return a;
}function Ad(a) {
  this.f = [];this.F = new Xc();this.ga = this.pa = this.B = this.ha = this.a = this.I = this.j = this.V = this.g = this.J = this.i = null;this.Ra = this.P = 0;this.Pa = !!n("internalChannelParams.failFast", a);this.ia = this.w = this.s = this.l = this.h = this.c = null;this.oa = !0;this.m = this.ra = this.O = -1;this.S = this.v = this.A = 0;this.Oa = n("internalChannelParams.baseRetryDelayMs", a) || 5E3;this.Sa = n("internalChannelParams.retryDelaySeedMs", a) || 1E4;this.Qa = n("internalChannelParams.forwardChannelMaxRetries", a) || 2;this.qa = n("internalChannelParams.forwardChannelRequestTimeoutMs", a) || 2E4;this.La = a && a.Ab || void 0;this.D = void 0;this.R = a && a.supportsCrossDomainXhr || !1;this.H = "";this.b = new ad(a && a.concurrentRequestLimit);this.ja = new kd();this.o = a && void 0 !== a.backgroundChannelTest ? a.backgroundChannelTest : !0;(this.W = a && a.fastHandshake || !1) && !this.o && (this.o = !0);a && a.forceLongPolling && (this.oa = !1);this.fa = void 0;
}g = Ad.prototype;g.wa = 8;g.u = 1;
function Bd(a) {
  Cd(a);if (3 == a.u) {
    var b = a.P++,
        c = N(a.B);T(c, "SID", a.H);T(c, "RID", b);T(c, "TYPE", "terminate");Dd(a, c);b = new M(a, b, void 0);b.F = 2;b.f = bc(N(c));c = !1;k.navigator && k.navigator.sendBeacon && (c = k.navigator.sendBeacon(b.f.toString(), ""));!c && k.Image && (new Image().src = b.f, c = !0);c || (b.a = b.g.$(null), b.a.ca(b.f));b.v = w();ec(b);
  }Ed(a);
}
function Cd(a) {
  a.w && (a.w.abort(), a.w = null);a.a && (a.a.cancel(), a.a = null);a.l && (k.clearTimeout(a.l), a.l = null);Fd(a);a.b.cancel();a.h && (aa(a.h) && k.clearTimeout(a.h), a.h = null);
}function Gd(a, b) {
  a.f.push(new $c(a.Ra++, b));3 == a.u && Hd(a);
}g.Da = function () {
  return 0 == this.u;
};function Hd(a) {
  ed(a.b) || a.h || (a.h = !0, wb(a.Ia, a), a.A = 0);
}
function Id(a, b) {
  if (fd(a.b) >= a.b.f - (a.h ? 1 : 0)) return !1;if (a.h) return a.f = b.j.concat(a.f), !0;if (1 == a.u || 2 == a.u || a.A >= (a.Pa ? 0 : a.Qa)) return !1;a.h = Ob(u(a.Ia, a, b), Jd(a, a.A));a.A++;return !0;
}
g.Ia = function (a) {
  if (this.h) if (this.h = null, 1 == this.u) {
    if (!a) {
      this.P = Math.floor(1E5 * Math.random());a = this.P++;var b = new M(this, a, void 0),
          c = this.i;this.J && (c ? (c = wa(c), ya(c, this.J)) : c = this.J);null === this.g && (b.h = c);var d;if (this.W) a: {
        for (var e = d = 0; e < this.f.length; e++) {
          b: {
            var f = this.f[e];if ("__data__" in f.a && (f = f.a.__data__, m(f))) {
              f = f.length;break b;
            }f = void 0;
          }if (void 0 === f) break;d += f;if (4096 < d) {
            d = e;break a;
          }if (4096 === d || e === this.f.length - 1) {
            d = e + 1;break a;
          }
        }d = 1E3;
      } else d = 1E3;d = Kd(this, b, d);e = N(this.B);T(e, "RID", a);T(e, "CVER", 22);this.o && this.j && T(e, "X-HTTP-Session-Id", this.j);Dd(this, e);this.g && c && zd(e, this.g, c);dd(this.b, b);this.W ? (T(e, "$req", d), T(e, "SID", "null"), b.S = !0, ac(b, e, null)) : ac(b, e, d);this.u = 2;
    }
  } else 3 == this.u && (a ? Ld(this, a) : 0 == this.f.length || ed(this.b) || Ld(this));
};
function Ld(a, b) {
  var c;b ? c = b.W : c = a.P++;var d = N(a.B);T(d, "SID", a.H);T(d, "RID", c);T(d, "AID", a.O);Dd(a, d);a.g && a.i && zd(d, a.g, a.i);c = new M(a, c, a.A + 1);null === a.g && (c.h = a.i);b && (a.f = b.j.concat(a.f));b = Kd(a, c, 1E3);c.setTimeout(Math.round(.5 * a.qa) + Math.round(.5 * a.qa * Math.random()));dd(a.b, c);ac(c, d, b);
}function Dd(a, b) {
  a.c && oc({}, function (c, d) {
    T(b, d, c);
  });
}
function Kd(a, b, c) {
  c = Math.min(a.f.length, c);var d = a.c ? u(a.c.Ta, a.c, a) : null;a: for (var e = a.f, f = -1;;) {
    var h = ["count=" + c];-1 == f ? 0 < c ? (f = e[0].b, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);for (var l = !0, F = 0; F < c; F++) {
      var Bb = e[F].b,
          Tc = e[F].a;Bb -= f;if (0 > Bb) f = Math.max(0, e[F].b - 100), l = !1;else try {
        ld(Tc, h, "req" + Bb + "_");
      } catch (Ud) {
        d && d(Tc);
      }
    }if (l) {
      d = h.join("&");break a;
    }
  }a = a.f.splice(0, c);b.j = a;return d;
}function Md(a) {
  a.a || a.l || (a.S = 1, wb(a.Ha, a), a.v = 0);
}
function Nd(a) {
  if (a.a || a.l || 3 <= a.v) return !1;a.S++;a.l = Ob(u(a.Ha, a), Jd(a, a.v));a.v++;return !0;
}g.Ha = function () {
  this.l = null;this.a = new M(this, "rpc", this.S);null === this.g && (this.a.h = this.i);this.a.J = 0;var a = N(this.pa);T(a, "RID", "rpc");T(a, "SID", this.H);T(a, "CI", this.ia ? "0" : "1");T(a, "AID", this.O);Dd(this, a);T(a, "TYPE", "xmlhttp");this.g && this.i && zd(a, this.g, this.i);this.D && this.a.setTimeout(this.D);dc(this.a, a, !0, this.ga);
};
function Vc(a, b, c) {
  var d = b.l;d && cd(a.b, d);a.ia = a.oa && c;a.m = b.c;a.B = Wc(a, null, a.ha);Hd(a);
}
g.Ga = function (a, b) {
  if (0 != this.u && (this.a == a || gd(this.b, a))) if (this.m = a.o, !a.s && gd(this.b, a) && 3 == this.u) {
    try {
      var c = this.ja.a.parse(b);
    } catch (f) {
      c = null;
    }if (q(c) && 3 == c.length) {
      b = c;if (0 == b[0]) a: {
        if (!this.l) {
          if (this.a) if (this.a.v + 3E3 < a.v) Fd(this), this.a.cancel(), this.a = null;else break a;Nd(this);K(18);
        }
      } else this.ra = b[1], 0 < this.ra - this.O && 37500 > b[2] && this.ia && 0 == this.v && !this.s && (this.s = Ob(u(this.Za, this), 6E3));if (1 >= fd(this.b) && this.fa) {
        try {
          this.fa();
        } catch (f) {}this.fa = void 0;
      }
    } else W(this, 11);
  } else if ((a.s || this.a == a) && Fd(this), !qa(b)) for (b = c = this.ja.a.parse(b), c = 0; c < b.length; c++) {
    var d = b[c];this.O = d[0];d = d[1];if (2 == this.u) {
      if ("c" == d[0]) {
        this.H = d[1];this.ga = d[2];var e = d[3];null != e && (this.wa = e);d = d[5];null != d && aa(d) && 0 < d && (this.D = 1.5 * d);this.o && (d = a.a) && ((e = hc(d, "X-Client-Wire-Protocol")) && cd(this.b, e), this.j && (d = hc(d, "X-HTTP-Session-Id"))) && (this.I = d, T(this.B, this.j, d));this.u = 3;this.c && this.c.va();d = a;this.pa = Wc(this, this.Y() ? this.ga : null, this.ha);d.s ? (hd(this.b, d), (e = this.D) && d.setTimeout(e), d.i && (gc(d), ec(d)), this.a = d) : Md(this);0 < this.f.length && Hd(this);
      } else "stop" != d[0] && "close" != d[0] || W(this, 7);
    } else 3 == this.u && ("stop" == d[0] || "close" == d[0] ? "stop" == d[0] ? W(this, 7) : Bd(this) : "noop" != d[0] && this.c && this.c.ua(d), this.v = 0);
  }
};g.Za = function () {
  null != this.s && (this.s = null, this.a.cancel(), this.a = null, Nd(this), K(19));
};function Fd(a) {
  null != a.s && (k.clearTimeout(a.s), a.s = null);
}
g.na = function (a) {
  var b = null;if (this.a == a) {
    Fd(this);this.a = null;var c = 2;
  } else if (gd(this.b, a)) b = a.j, hd(this.b, a), c = 1;else return;this.m = a.o;if (0 != this.u) if (a.b) 1 == c ? (b = w() - a.v, I.dispatchEvent(new Nb(I, a.l ? a.l.length : 0, b, this.A)), Hd(this)) : Md(this);else {
    var d = a.c;if (3 == d || 0 == d && 0 < this.m || !(1 == c && Id(this, a) || 2 == c && Nd(this))) switch (b && 0 < b.length && (a = this.b, a.c = a.c.concat(b)), d) {case 1:
        W(this, 5);break;case 4:
        W(this, 10);break;case 3:
        W(this, 6);break;default:
        W(this, 2);}
  }
};
function Jd(a, b) {
  var c = a.Oa + Math.floor(Math.random() * a.Sa);a.ma() || (c *= 2);return c * b;
}function W(a, b) {
  if (2 == b) {
    var c = null;a.c && (c = null);var d = u(a.fb, a);c || (c = new S("//www.google.com/images/cleardot.gif"), k.location && "http" == k.location.protocol || uc(c, "https"), bc(c));md(c.toString(), d);
  } else K(2);a.u = 0;a.c && a.c.ta(b);Ed(a);Cd(a);
}g.fb = function (a) {
  a ? K(2) : K(1);
};function Ed(a) {
  a.u = 0;a.m = -1;if (a.c) {
    if (0 != id(a.b).length || 0 != a.f.length) a.b.c.length = 0, pa(a.f), a.f.length = 0;a.c.sa();
  }
}
function Wc(a, b, c) {
  var d = Jc(c);if ("" != d.b) b && vc(d, b + "." + d.b), wc(d, d.i);else {
    var e = k.location,
        f;b ? f = b + "." + e.hostname : f = e.hostname;d = Kc(e.protocol, f, +e.port, c);
  }a.V && va(a.V, function (h, l) {
    T(d, l, h);
  });b = a.j;c = a.I;b && c && T(d, b, c);T(d, "VER", a.wa);Dd(a, d);return d;
}g.$ = function (a) {
  if (a && !this.R) throw Error("Can't create secondary domain capable XhrIo object.");a = new X(this.La);a.F = this.R;return a;
};g.ma = function () {
  return !!this.c && !0;
};g.Y = function () {
  return this.R;
};function Od() {}g = Od.prototype;g.va = function () {};
g.ua = function () {};g.ta = function () {};g.sa = function () {};g.Ta = function () {};function Pd(a) {
  for (var b = arguments[0], c = 1; c < arguments.length; c++) {
    var d = arguments[c];if (0 == d.lastIndexOf("/", 0)) b = d;else {
      var e;(e = "" == b) || (e = b.length - 1, e = 0 <= e && b.indexOf("/", e) == e);e ? b += d : b += "/" + d;
    }
  }return b;
}function Qd() {
  if (B && !(10 <= Number(Na))) throw Error("Environmental error: no available transport.");
}Qd.prototype.a = function (a, b) {
  return new Y(a, b);
};
function Y(a, b) {
  G.call(this);this.a = new Ad(b);this.g = a;this.m = b && b.testUrl ? b.testUrl : Pd(this.g, "test");this.b = b && b.messageUrlParams || null;a = b && b.messageHeaders || null;b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = { "X-Client-Protocol": "webchannel" });this.a.i = a;a = b && b.initMessageHeaders || null;b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = { "X-WebChannel-Content-Type": b.messageContentType });b && b.xa && (a ? a["X-WebChannel-Client-Profile"] = b.xa : a = { "X-WebChannel-Client-Profile": b.xa });this.a.J = a;(a = b && b.httpHeadersOverwriteParam) && !qa(a) && (this.a.g = a);this.l = b && b.supportsCrossDomainXhr || !1;this.h = b && b.sendRawJson || !1;(b = b && b.httpSessionIdParam) && !qa(b) && (this.a.j = b, a = this.b, null !== a && b in a && (a = this.b, b in a && delete a[b]));this.f = new Z(this);
}x(Y, G);g = Y.prototype;g.addEventListener = function (a, b, c, d) {
  Y.N.addEventListener.call(this, a, b, c, d);
};g.removeEventListener = function (a, b, c, d) {
  Y.N.removeEventListener.call(this, a, b, c, d);
};
g.Wa = function () {
  this.a.c = this.f;this.l && (this.a.R = !0);var a = this.a,
      b = this.m,
      c = this.g,
      d = this.b || void 0;K(0);a.ha = c;a.V = d || {};a.o && (a.F.b = [], a.F.a = !1);a.w = new Sc(a);null === a.g && (a.w.h = a.i);c = b;a.g && a.i && (c = zd(b, a.g, a.i));a = a.w;a.i = c;b = Wc(a.a, null, a.i);K(3);c = a.a.F.b;null != c ? (a.f = c[0], a.M = 1, Uc(a)) : (fc(b, "MODE", "init"), !a.a.o && a.a.j && fc(b, "X-HTTP-Session-Id", a.a.j), a.b = new M(a, void 0, void 0), a.b.h = a.h, dc(a.b, b, !1, null), a.M = 0);
};g.close = function () {
  Bd(this.a);
};
g.Xa = function (a) {
  if (m(a)) {
    var b = {};b.__data__ = a;Gd(this.a, b);
  } else this.h ? (b = {}, b.__data__ = ob(a), Gd(this.a, b)) : Gd(this.a, a);
};g.G = function () {
  this.a.c = null;delete this.f;Bd(this.a);delete this.a;Y.N.G.call(this);
};function Rd(a) {
  Ub.call(this);var b = a.__sm__;if (b) {
    a: {
      for (var c in b) {
        a = c;break a;
      }a = void 0;
    }(this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
  } else this.data = a;
}x(Rd, Ub);function Sd() {
  Vb.call(this);this.status = 1;
}x(Sd, Vb);function Z(a) {
  this.a = a;
}x(Z, Od);Z.prototype.va = function () {
  this.a.dispatchEvent("a");
};
Z.prototype.ua = function (a) {
  this.a.dispatchEvent(new Rd(a));
};Z.prototype.ta = function (a) {
  this.a.dispatchEvent(new Sd(a));
};Z.prototype.sa = function () {
  this.a.dispatchEvent("b");
};var Td = v(function (a, b) {
  function c() {}c.prototype = a.prototype;var d = new c();a.apply(d, Array.prototype.slice.call(arguments, 1));return d;
}, Qd); /*
        Copyright 2017 Google Inc.
        Licensed under the Apache License, Version 2.0 (the "License");
        you may not use this file except in compliance with the License.
        You may obtain a copy of the License at
        http://www.apache.org/licenses/LICENSE-2.0
        Unless required by applicable law or agreed to in writing, software
        distributed under the License is distributed on an "AS IS" BASIS,
        WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
        See the License for the specific language governing permissions and
        limitations under the License.
        */
Qd.prototype.createWebChannel = Qd.prototype.a;Y.prototype.send = Y.prototype.Xa;Y.prototype.open = Y.prototype.Wa;Y.prototype.close = Y.prototype.close;Pb.NO_ERROR = 0;Pb.TIMEOUT = 8;Pb.HTTP_ERROR = 6;Qb.COMPLETE = "complete";Tb.EventType = L;L.OPEN = "a";L.CLOSE = "b";L.ERROR = "c";L.MESSAGE = "d";G.prototype.listen = G.prototype.Aa;X.prototype.listenOnce = X.prototype.Ba;X.prototype.getLastError = X.prototype.Ya;X.prototype.getLastErrorCode = X.prototype.ya;X.prototype.getStatus = X.prototype.T;X.prototype.getStatusText = X.prototype.za;
X.prototype.getResponseJson = X.prototype.Va;X.prototype.getResponseText = X.prototype.aa;X.prototype.send = X.prototype.ca;var tmp = { createWebChannelTransport: Td, ErrorCode: Pb, EventType: Qb, WebChannel: Tb, XhrIo: X };
var tmp_1 = tmp.createWebChannelTransport;
var tmp_2 = tmp.ErrorCode;
var tmp_3 = tmp.EventType;
var tmp_4 = tmp.WebChannel;
var tmp_5 = tmp.XhrIo;

/* harmony default export */ __webpack_exports__["default"] = (tmp);

//# sourceMappingURL=index.esm.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("h6ac")))

/***/ }),

/***/ "vCxL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return _assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return _extendStatics(d, b);
};

function __extends(d, b) {
    _extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
    _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return _assign.apply(this, arguments);
};


function __rest(s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) {
        decorator(target, key, paramIndex);
    };
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator],
        i = 0;
    if (m) return m.call(o);
    return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o),
        r,
        ar = [],
        e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
            ar.push(r.value);
        }
    } catch (error) {
        e = { error: error };
    } finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
            if (e) throw e.error;
        }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++) {
        ar = ar.concat(__read(arguments[i]));
    }return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []),
        i,
        q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function (v) {
            return new Promise(function (a, b) {
                q.push([n, v, a, b]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function () {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function (v) {
            return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v;
        } : f;
    }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator],
        i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function (v) {
            return new Promise(function (resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function (v) {
            resolve({ value: v, done: d });
        }, reject);
    }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) {
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }result.default = mod;
    return result;
}

function __importDefault(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
}

/***/ }),

/***/ "yY49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zQXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
var API = 'https://us-central1-lippumaatti.cloudfunctions.net/api';

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.81993.js